var Et = Object.defineProperty;
var Mt = (p, s, h) => s in p ? Et(p, s, { enumerable: !0, configurable: !0, writable: !0, value: h }) : p[s] = h;
var Pe = (p, s, h) => Mt(p, typeof s != "symbol" ? s + "" : s, h);
class Echo {
  constructor(s) {
    Pe(this, "connector");
    this.connector = s, this.connector.connect();
  }
  disconnect() {
    this.connector.disconnect();
  }
  channel(s) {
    return this.connector.channel(s);
  }
  private(s) {
    return this.connector.privateChannel(s);
  }
  leaveAllChannels() {
    this.connector.channels.forEach((s) => {
      s.unsubscribe();
    });
  }
  leave(s) {
    this.connector.leave(s);
  }
}
class Channel {
  constructor(s) {
    Pe(this, "name");
    this.name = s;
  }
}
class Connector {
  constructor() {
    Pe(this, "channels", []);
  }
}
class NullChannel extends Channel {
  constructor(s) {
    super(s);
  }
  subscribe() {
  }
  subscribed() {
  }
  unsubscribe() {
  }
  listen(s, h) {
    return h(s), this;
  }
  stopListening(s, h) {
    return h(s), this;
  }
  error(s) {
    return s(), this;
  }
}
class NullConnector extends Connector {
  constructor() {
    super(...arguments);
    Pe(this, "channels", []);
  }
  connect() {
  }
  disconnect() {
  }
  leave() {
  }
  channel(h) {
    let c = this.channels.find((d) => d.name === h);
    return c || (c = new NullChannel(h), c.subscribe(), this.channels.push(c)), c;
  }
  privateChannel(h) {
    return this.channel(`private-${h}`);
  }
}
var commonjsGlobal = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function getAugmentedNamespace(p) {
  if (p.__esModule) return p;
  var s = p.default;
  if (typeof s == "function") {
    var h = function c() {
      return this instanceof c ? Reflect.construct(s, arguments, this.constructor) : s.apply(this, arguments);
    };
    h.prototype = s.prototype;
  } else h = {};
  return Object.defineProperty(h, "__esModule", { value: !0 }), Object.keys(p).forEach(function(c) {
    var d = Object.getOwnPropertyDescriptor(p, c);
    Object.defineProperty(h, c, d.get ? d : {
      enumerable: !0,
      get: function() {
        return p[c];
      }
    });
  }), h;
}
(function(p) {
  function s(k, z) {
    var $;
    return k instanceof Buffer ? $ = k : $ = Buffer.from(k.buffer, k.byteOffset, k.byteLength), $.toString(z);
  }
  var h = function(k) {
    return Buffer.from(k);
  };
  function c(k) {
    for (var z = 0, $ = Math.min(256 * 256, k.length + 1), re = new Uint16Array($), oe = [], le = 0; ; ) {
      var ue = z < k.length;
      if (!ue || le >= $ - 1) {
        var pe = re.subarray(0, le), he = pe;
        if (oe.push(String.fromCharCode.apply(null, he)), !ue) return oe.join("");
        k = k.subarray(z), z = 0, le = 0;
      }
      var fe = k[z++];
      if (!(fe & 128)) re[le++] = fe;
      else if ((fe & 224) === 192) {
        var ye = k[z++] & 63;
        re[le++] = (fe & 31) << 6 | ye;
      } else if ((fe & 240) === 224) {
        var ye = k[z++] & 63, Re = k[z++] & 63;
        re[le++] = (fe & 31) << 12 | ye << 6 | Re;
      } else if ((fe & 248) === 240) {
        var ye = k[z++] & 63, Re = k[z++] & 63, be = k[z++] & 63, Me = (fe & 7) << 18 | ye << 12 | Re << 6 | be;
        Me > 65535 && (Me -= 65536, re[le++] = Me >>> 10 & 1023 | 55296, Me = 56320 | Me & 1023), re[le++] = Me;
      }
    }
  }
  function d(k) {
    for (var z = 0, $ = k.length, re = 0, oe = Math.max(32, $ + ($ >>> 1) + 7), le = new Uint8Array(oe >>> 3 << 3); z < $; ) {
      var ue = k.charCodeAt(z++);
      if (ue >= 55296 && ue <= 56319) {
        if (z < $) {
          var pe = k.charCodeAt(z);
          (pe & 64512) === 56320 && (++z, ue = ((ue & 1023) << 10) + (pe & 1023) + 65536);
        }
        if (ue >= 55296 && ue <= 56319) continue;
      }
      if (re + 4 > le.length) {
        oe += 8, oe *= 1 + z / k.length * 2, oe = oe >>> 3 << 3;
        var he = new Uint8Array(oe);
        he.set(le), le = he;
      }
      if (ue & 4294967168)
        if (!(ue & 4294965248)) le[re++] = ue >>> 6 & 31 | 192;
        else if (!(ue & 4294901760)) le[re++] = ue >>> 12 & 15 | 224, le[re++] = ue >>> 6 & 63 | 128;
        else if (!(ue & 4292870144)) le[re++] = ue >>> 18 & 7 | 240, le[re++] = ue >>> 12 & 63 | 128, le[re++] = ue >>> 6 & 63 | 128;
        else continue;
      else {
        le[re++] = ue;
        continue;
      }
      le[re++] = ue & 63 | 128;
    }
    return le.slice ? le.slice(0, re) : le.subarray(0, re);
  }
  var l = "Failed to ", g = function(k, z, $) {
    if (k) throw new Error("".concat(l).concat(z, ": the '").concat($, "' option is unsupported."));
  }, f = typeof Buffer == "function" && Buffer.from, _ = f ? h : d;
  function te() {
    this.encoding = "utf-8";
  }
  te.prototype.encode = function(k, z) {
    return g(z && z.stream, "encode", "stream"), _(k);
  };
  function ae(k) {
    var z;
    try {
      var $ = new Blob([k], { type: "text/plain;charset=UTF-8" });
      z = URL.createObjectURL($);
      var re = new XMLHttpRequest();
      return re.open("GET", z, !1), re.send(), re.responseText;
    } finally {
      z && URL.revokeObjectURL(z);
    }
  }
  var ie = !f && typeof Blob == "function" && typeof URL == "function" && typeof URL.createObjectURL == "function", se = ["utf-8", "utf8", "unicode-1-1-utf-8"], m = c;
  f ? m = s : ie && (m = function(k) {
    try {
      return ae(k);
    } catch (z) {
      return c(k);
    }
  });
  var w = "construct 'TextDecoder'", q = "".concat(l, " ").concat(w, ": the ");
  function j(k, z) {
    g(z && z.fatal, w, "fatal"), k = k || "utf-8";
    var $;
    if (f ? $ = Buffer.isEncoding(k) : $ = se.indexOf(k.toLowerCase()) !== -1, !$) throw new RangeError("".concat(q, " encoding label provided ('").concat(k, "') is invalid."));
    this.encoding = k, this.fatal = !1, this.ignoreBOM = !1;
  }
  j.prototype.decode = function(k, z) {
    g(z && z.stream, "decode", "stream");
    var $;
    return k instanceof Uint8Array ? $ = k : k.buffer instanceof ArrayBuffer ? $ = new Uint8Array(k.buffer) : $ = new Uint8Array(k), m($, this.encoding);
  }, p.TextEncoder = p.TextEncoder || te, p.TextDecoder = p.TextDecoder || j;
})(typeof window != "undefined" ? window : commonjsGlobal);
var src$1 = {}, cacheClient = {}, cacheControlClient = {}, dist = {}, CacheclientServiceClientPb = {}, grpcWeb$a = {}, n$1;
function aa(p) {
  var s = 0;
  return function() {
    return s < p.length ? { done: !1, value: p[s++] } : { done: !0 };
  };
}
var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(p, s, h) {
  p != Array.prototype && p != Object.prototype && (p[s] = h.value);
};
function ca(p) {
  p = [typeof window == "object" && window, typeof self == "object" && self, typeof commonjsGlobal == "object" && commonjsGlobal, p];
  for (var s = 0; s < p.length; ++s) {
    var h = p[s];
    if (h && h.Math == Math) return h;
  }
  throw Error("Cannot find global object");
}
var r$1 = ca(commonjsGlobal);
function t$1() {
  t$1 = function() {
  }, r$1.Symbol || (r$1.Symbol = da);
}
function ea(p, s) {
  this.a = p, ba(this, "description", { configurable: !0, writable: !0, value: s });
}
ea.prototype.toString = function() {
  return this.a;
};
var da = /* @__PURE__ */ function() {
  function p(h) {
    if (this instanceof p) throw new TypeError("Symbol is not a constructor");
    return new ea("jscomp_symbol_" + (h || "") + "_" + s++, h);
  }
  var s = 0;
  return p;
}();
function u() {
  t$1();
  var p = r$1.Symbol.iterator;
  p || (p = r$1.Symbol.iterator = r$1.Symbol("Symbol.iterator")), typeof Array.prototype[p] != "function" && ba(Array.prototype, p, { configurable: !0, writable: !0, value: function() {
    return fa(aa(this));
  } }), u = function() {
  };
}
function fa(p) {
  return u(), p = { next: p }, p[r$1.Symbol.iterator] = function() {
    return this;
  }, p;
}
function ha(p) {
  var s = typeof Symbol != "undefined" && Symbol.iterator && p[Symbol.iterator];
  return s ? s.call(p) : { next: aa(p) };
}
var ia = typeof Object.create == "function" ? Object.create : function(p) {
  function s() {
  }
  return s.prototype = p, new s();
}, ja;
if (typeof Object.setPrototypeOf == "function") ja = Object.setPrototypeOf;
else {
  var ka;
  e: {
    var la = { V: !0 }, ma = {};
    try {
      ma.__proto__ = la, ka = ma.V;
      break e;
    } catch (p) {
    }
    ka = !1;
  }
  ja = ka ? function(p, s) {
    if (p.__proto__ = s, p.__proto__ !== s) throw new TypeError(p + " is not extensible");
    return p;
  } : null;
}
var na = ja;
function oa(p, s) {
  if (p.prototype = ia(s.prototype), p.prototype.constructor = p, na) na(p, s);
  else for (var h in s) if (h != "prototype") if (Object.defineProperties) {
    var c = Object.getOwnPropertyDescriptor(s, h);
    c && Object.defineProperty(p, h, c);
  } else p[h] = s[h];
  p.O = s.prototype;
}
function pa(p, s) {
  u(), p instanceof String && (p += "");
  var h = 0, c = { next: function() {
    if (h < p.length) {
      var d = h++;
      return { value: s(d, p[d]), done: !1 };
    }
    return c.next = function() {
      return { done: !0, value: void 0 };
    }, c.next();
  } };
  return c[Symbol.iterator] = function() {
    return c;
  }, c;
}
function v(p, s) {
  if (s) {
    var h = r$1;
    p = p.split(".");
    for (var c = 0; c < p.length - 1; c++) {
      var d = p[c];
      d in h || (h[d] = {}), h = h[d];
    }
    p = p[p.length - 1], c = h[p], s = s(c), s != c && s != null && ba(h, p, { configurable: !0, writable: !0, value: s });
  }
}
v("Array.prototype.keys", function(p) {
  return p || function() {
    return pa(this, function(s) {
      return s;
    });
  };
});
v("Array.prototype.find", function(p) {
  return p || function(s, h) {
    e: {
      var c = this;
      c instanceof String && (c = String(c));
      for (var d = c.length, l = 0; l < d; l++) {
        var g = c[l];
        if (s.call(h, g, l, c)) {
          s = g;
          break e;
        }
      }
      s = void 0;
    }
    return s;
  };
});
v("Object.is", function(p) {
  return p || function(s, h) {
    return s === h ? s !== 0 || 1 / s === 1 / h : s !== s && h !== h;
  };
});
v("Array.prototype.includes", function(p) {
  return p || function(s, h) {
    var c = this;
    c instanceof String && (c = String(c));
    var d = c.length;
    for (h = h || 0, 0 > h && (h = Math.max(h + d, 0)); h < d; h++) {
      var l = c[h];
      if (l === s || Object.is(l, s)) return !0;
    }
    return !1;
  };
});
v("Promise", function(p) {
  function s(g) {
    this.b = 0, this.c = void 0, this.a = [];
    var f = this.f();
    try {
      g(f.resolve, f.reject);
    } catch (_) {
      f.reject(_);
    }
  }
  function h() {
    this.a = null;
  }
  function c(g) {
    return g instanceof s ? g : new s(function(f) {
      f(g);
    });
  }
  if (p) return p;
  h.prototype.b = function(g) {
    if (this.a == null) {
      this.a = [];
      var f = this;
      this.c(function() {
        f.g();
      });
    }
    this.a.push(g);
  };
  var d = r$1.setTimeout;
  h.prototype.c = function(g) {
    d(g, 0);
  }, h.prototype.g = function() {
    for (; this.a && this.a.length; ) {
      var g = this.a;
      this.a = [];
      for (var f = 0; f < g.length; ++f) {
        var _ = g[f];
        g[f] = null;
        try {
          _();
        } catch (te) {
          this.f(te);
        }
      }
    }
    this.a = null;
  }, h.prototype.f = function(g) {
    this.c(function() {
      throw g;
    });
  }, s.prototype.f = function() {
    function g(te) {
      return function(ae) {
        _ || (_ = !0, te.call(f, ae));
      };
    }
    var f = this, _ = !1;
    return { resolve: g(this.s), reject: g(this.g) };
  }, s.prototype.s = function(g) {
    if (g === this) this.g(new TypeError("A Promise cannot resolve to itself"));
    else if (g instanceof s) this.v(g);
    else {
      e: switch (typeof g) {
        case "object":
          var f = g != null;
          break e;
        case "function":
          f = !0;
          break e;
        default:
          f = !1;
      }
      f ? this.m(g) : this.h(g);
    }
  }, s.prototype.m = function(g) {
    var f = void 0;
    try {
      f = g.then;
    } catch (_) {
      this.g(_);
      return;
    }
    typeof f == "function" ? this.w(f, g) : this.h(g);
  }, s.prototype.g = function(g) {
    this.i(2, g);
  }, s.prototype.h = function(g) {
    this.i(1, g);
  }, s.prototype.i = function(g, f) {
    if (this.b != 0) throw Error("Cannot settle(" + g + ", " + f + "): Promise already settled in state" + this.b);
    this.b = g, this.c = f, this.l();
  }, s.prototype.l = function() {
    if (this.a != null) {
      for (var g = 0; g < this.a.length; ++g) l.b(this.a[g]);
      this.a = null;
    }
  };
  var l = new h();
  return s.prototype.v = function(g) {
    var f = this.f();
    g.F(f.resolve, f.reject);
  }, s.prototype.w = function(g, f) {
    var _ = this.f();
    try {
      g.call(f, _.resolve, _.reject);
    } catch (te) {
      _.reject(te);
    }
  }, s.prototype.then = function(g, f) {
    function _(se, m) {
      return typeof se == "function" ? function(w) {
        try {
          te(se(w));
        } catch (q) {
          ae(q);
        }
      } : m;
    }
    var te, ae, ie = new s(function(se, m) {
      te = se, ae = m;
    });
    return this.F(_(g, te), _(f, ae)), ie;
  }, s.prototype.catch = function(g) {
    return this.then(void 0, g);
  }, s.prototype.F = function(g, f) {
    function _() {
      switch (te.b) {
        case 1:
          g(te.c);
          break;
        case 2:
          f(te.c);
          break;
        default:
          throw Error("Unexpected state: " + te.b);
      }
    }
    var te = this;
    this.a == null ? l.b(_) : this.a.push(_);
  }, s.resolve = c, s.reject = function(g) {
    return new s(function(f, _) {
      _(g);
    });
  }, s.race = function(g) {
    return new s(function(f, _) {
      for (var te = ha(g), ae = te.next(); !ae.done; ae = te.next()) c(ae.value).F(f, _);
    });
  }, s.all = function(g) {
    var f = ha(g), _ = f.next();
    return _.done ? c([]) : new s(function(te, ae) {
      function ie(w) {
        return function(q) {
          se[w] = q, m--, m == 0 && te(se);
        };
      }
      var se = [], m = 0;
      do
        se.push(void 0), m++, c(_.value).F(ie(se.length - 1), ae), _ = f.next();
      while (!_.done);
    });
  }, s;
});
var qa = qa || {}, x = commonjsGlobal || self;
function y(p, s) {
  p = p.split("."), s = s || x;
  for (var h = 0; h < p.length; h++) if (s = s[p[h]], s == null) return null;
  return s;
}
function ra() {
}
function sa(p) {
  var s = typeof p;
  return s == "object" && p != null || s == "function";
}
function va(p, s, h) {
  return p.call.apply(p.bind, arguments);
}
function wa(p, s, h) {
  if (!p) throw Error();
  if (2 < arguments.length) {
    var c = Array.prototype.slice.call(arguments, 2);
    return function() {
      var d = Array.prototype.slice.call(arguments);
      return Array.prototype.unshift.apply(d, c), p.apply(s, d);
    };
  }
  return function() {
    return p.apply(s, arguments);
  };
}
function A(p, s, h) {
  return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? A = va : A = wa, A.apply(null, arguments);
}
function B(p, s) {
  function h() {
  }
  h.prototype = s.prototype, p.O = s.prototype, p.prototype = new h(), p.prototype.constructor = p;
}
function xa(p) {
  this.a = p || {};
}
xa.prototype.get = function(p) {
  return this.a[p];
};
xa.prototype.G = function() {
  return Object.keys(this.a);
};
function C(p, s, h, c) {
  this.f = p, this.c = s, this.b = h, this.a = c;
}
C.prototype.getRequestMessage = function() {
  return this.f;
};
C.prototype.getMethodDescriptor = function() {
  return this.c;
};
C.prototype.getMetadata = function() {
  return this.b;
};
C.prototype.getCallOptions = function() {
  return this.a;
};
function D(p, s, h, c) {
  h = h === void 0 ? {} : h, this.c = p, this.a = h, this.b = s, this.f = c === void 0 ? null : c;
}
D.prototype.getResponseMessage = function() {
  return this.c;
};
D.prototype.getMetadata = function() {
  return this.a;
};
D.prototype.getMethodDescriptor = function() {
  return this.b;
};
D.prototype.getStatus = function() {
  return this.f;
};
function ya(p, s, h, c, d, l) {
  this.name = p, this.a = d, this.b = l;
}
function za(p, s, h) {
  h = h === void 0 ? {} : h;
  var c = c === void 0 ? new xa() : c;
  return new C(s, p, h, c);
}
ya.prototype.getName = function() {
  return this.name;
};
ya.prototype.getName = ya.prototype.getName;
function Aa(p) {
  switch (p) {
    case 200:
      return 0;
    case 400:
      return 3;
    case 401:
      return 16;
    case 403:
      return 7;
    case 404:
      return 5;
    case 409:
      return 10;
    case 412:
      return 9;
    case 429:
      return 8;
    case 499:
      return 1;
    case 500:
      return 2;
    case 501:
      return 12;
    case 503:
      return 14;
    case 504:
      return 4;
    default:
      return 2;
  }
}
function E(p, s, h) {
  h = h === void 0 ? {} : h, s = Error.call(this, s), this.message = s.message, "stack" in s && (this.stack = s.stack), this.code = p, this.metadata = h;
}
oa(E, Error);
E.prototype.name = "RpcError";
function Ba(p) {
  this.a = p;
}
Ba.prototype.on = function(p, s) {
  return p == "data" || p == "error" ? this : this.a.on(p, s);
};
Ba.prototype.removeListener = function(p, s) {
  return this.a.removeListener(p, s);
};
Ba.prototype.cancel = function() {
  this.a.cancel();
};
function Ca(p) {
  switch (p) {
    case 0:
      return "No Error";
    case 1:
      return "Access denied to content document";
    case 2:
      return "File not found";
    case 3:
      return "Firefox silently errored";
    case 4:
      return "Application custom error";
    case 5:
      return "An exception occurred";
    case 6:
      return "Http response at 400 or 500 level";
    case 7:
      return "Request was aborted";
    case 8:
      return "Request timed out";
    case 9:
      return "The resource is not available offline";
    default:
      return "Unrecognized error code";
  }
}
function F(p) {
  if (Error.captureStackTrace) Error.captureStackTrace(this, F);
  else {
    var s = Error().stack;
    s && (this.stack = s);
  }
  p && (this.message = String(p));
}
B(F, Error);
F.prototype.name = "CustomError";
function Da(p, s) {
  p = p.split("%s");
  for (var h = "", c = p.length - 1, d = 0; d < c; d++) h += p[d] + (d < s.length ? s[d] : "%s");
  F.call(this, h + p[c]);
}
B(Da, F);
Da.prototype.name = "AssertionError";
function Ea(p, s) {
  throw new Da("Failure" + (": " + p), Array.prototype.slice.call(arguments, 1));
}
function Fa() {
  this.l = null, this.i = [], this.m = 0, this.b = Ga, this.f = this.a = this.h = 0, this.c = null, this.g = 0;
}
function Ha(p, s) {
  function h(te) {
    te == Ia || te == G ? g.h = te : Ja(g, f, _, "invalid frame byte"), g.b = Ka, g.a = 0, g.f = 0;
  }
  function c(te) {
    g.f++, g.a = (g.a << 8) + te, g.f == 4 && (g.b = La, g.g = 0, typeof Uint8Array != "undefined" ? g.c = new Uint8Array(g.a) : g.c = Array(g.a), g.a == 0 && l());
  }
  function d(te) {
    g.c[g.g++] = te, g.g == g.a && l();
  }
  function l() {
    var te = {};
    te[g.h] = g.c, g.i.push(te), g.b = Ga;
  }
  var g = p, f, _ = 0;
  for (s instanceof Uint8Array || s instanceof Array ? f = s : f = new Uint8Array(s); _ < f.length; ) {
    switch (g.b) {
      case Ma:
        Ja(g, f, _, "stream already broken");
        break;
      case Ga:
        h(f[_]);
        break;
      case Ka:
        c(f[_]);
        break;
      case La:
        d(f[_]);
        break;
      default:
        throw Error("unexpected parser state: " + g.b);
    }
    g.m++, _++;
  }
  return p = g.i, g.i = [], 0 < p.length ? p : null;
}
var Ga = 0, Ka = 1, La = 2, Ma = 3, Ia = 0, G = 128;
function Ja(p, s, h, c) {
  throw p.b = Ma, p.l = "The stream is broken @" + p.m + "/" + h + ". Error: " + c + `. With input:
` + s, Error(p.l);
}
var Na = Array.prototype.indexOf ? function(p, s) {
  return Array.prototype.indexOf.call(p, s, void 0);
} : function(p, s) {
  if (typeof p == "string") return typeof s != "string" || s.length != 1 ? -1 : p.indexOf(s, 0);
  for (var h = 0; h < p.length; h++) if (h in p && p[h] === s) return h;
  return -1;
}, Oa = String.prototype.trim ? function(p) {
  return p.trim();
} : function(p) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(p)[1];
};
function H(p, s) {
  return p.indexOf(s) != -1;
}
function Pa(p, s) {
  return p < s ? -1 : p > s ? 1 : 0;
}
var I;
e: {
  var Qa = x.navigator;
  if (Qa) {
    var Ra = Qa.userAgent;
    if (Ra) {
      I = Ra;
      break e;
    }
  }
  I = "";
}
function Sa(p, s) {
  for (var h in p) s.call(void 0, p[h], h, p);
}
function Ta(p, s) {
  var h = {}, c;
  for (c in p) h[c] = s.call(void 0, p[c], c, p);
  return h;
}
var Ua = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Va(p, s) {
  for (var h, c, d = 1; d < arguments.length; d++) {
    c = arguments[d];
    for (h in c) p[h] = c[h];
    for (var l = 0; l < Ua.length; l++) h = Ua[l], Object.prototype.hasOwnProperty.call(c, h) && (p[h] = c[h]);
  }
}
function Wa(p) {
  var s = 1;
  p = p.split(":");
  for (var h = []; 0 < s && p.length; ) h.push(p.shift()), s--;
  return p.length && h.push(p.join(":")), h;
}
function Xa(p) {
  return Xa[" "](p), p;
}
Xa[" "] = ra;
function Ya(p) {
  var s = Za;
  return Object.prototype.hasOwnProperty.call(s, 9) ? s[9] : s[9] = p(9);
}
var $a = H(I, "Opera"), ab = H(I, "Trident") || H(I, "MSIE"), bb = H(I, "Edge"), cb = H(I, "Gecko") && !(H(I.toLowerCase(), "webkit") && !H(I, "Edge")) && !(H(I, "Trident") || H(I, "MSIE")) && !H(I, "Edge"), db = H(I.toLowerCase(), "webkit") && !H(I, "Edge"), eb;
e: {
  var fb = "", gb = function() {
    var p = I;
    if (cb) return /rv:([^\);]+)(\)|;)/.exec(p);
    if (bb) return /Edge\/([\d\.]+)/.exec(p);
    if (ab) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(p);
    if (db) return /WebKit\/(\S+)/.exec(p);
    if ($a) return /(?:Version)[ \/]?(\S+)/.exec(p);
  }();
  if (gb && (fb = gb ? gb[1] : ""), ab) {
    var hb, ib = x.document;
    if (hb = ib ? ib.documentMode : void 0, hb != null && hb > parseFloat(fb)) {
      eb = String(hb);
      break e;
    }
  }
  eb = fb;
}
var Za = {};
function jb() {
  return Ya(function() {
    for (var p = 0, s = Oa(String(eb)).split("."), h = Oa("9").split("."), c = Math.max(s.length, h.length), d = 0; p == 0 && d < c; d++) {
      var l = s[d] || "", g = h[d] || "";
      do {
        if (l = /(\d*)(\D*)(.*)/.exec(l) || ["", "", "", ""], g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""], l[0].length == 0 && g[0].length == 0) break;
        p = Pa(l[1].length == 0 ? 0 : parseInt(l[1], 10), g[1].length == 0 ? 0 : parseInt(g[1], 10)) || Pa(l[2].length == 0, g[2].length == 0) || Pa(l[2], g[2]), l = l[3], g = g[3];
      } while (p == 0);
    }
    return 0 <= p;
  });
}
function kb() {
  this.K = this.K;
}
kb.prototype.K = !1;
var mb = Object.freeze || function(p) {
  return p;
};
function J(p, s) {
  this.type = p, this.a = this.target = s, this.defaultPrevented = !1;
}
J.prototype.b = function() {
  this.defaultPrevented = !0;
};
var nb = function() {
  if (!x.addEventListener || !Object.defineProperty) return !1;
  var p = !1, s = Object.defineProperty({}, "passive", { get: function() {
    p = !0;
  } });
  try {
    x.addEventListener("test", ra, s), x.removeEventListener("test", ra, s);
  } catch (h) {
  }
  return p;
}();
function K(p, s) {
  if (J.call(this, p ? p.type : ""), this.relatedTarget = this.a = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.pointerId = 0, this.pointerType = "", this.c = null, p) {
    var h = this.type = p.type, c = p.changedTouches && p.changedTouches.length ? p.changedTouches[0] : null;
    if (this.target = p.target || p.srcElement, this.a = s, s = p.relatedTarget) {
      if (cb) {
        e: {
          try {
            Xa(s.nodeName);
            var d = !0;
            break e;
          } catch (l) {
          }
          d = !1;
        }
        d || (s = null);
      }
    } else h == "mouseover" ? s = p.fromElement : h == "mouseout" && (s = p.toElement);
    this.relatedTarget = s, c ? (this.clientX = c.clientX !== void 0 ? c.clientX : c.pageX, this.clientY = c.clientY !== void 0 ? c.clientY : c.pageY, this.screenX = c.screenX || 0, this.screenY = c.screenY || 0) : (this.clientX = p.clientX !== void 0 ? p.clientX : p.pageX, this.clientY = p.clientY !== void 0 ? p.clientY : p.pageY, this.screenX = p.screenX || 0, this.screenY = p.screenY || 0), this.button = p.button, this.key = p.key || "", this.ctrlKey = p.ctrlKey, this.altKey = p.altKey, this.shiftKey = p.shiftKey, this.metaKey = p.metaKey, this.pointerId = p.pointerId || 0, this.pointerType = typeof p.pointerType == "string" ? p.pointerType : ob[p.pointerType] || "", this.c = p, p.defaultPrevented && K.O.b.call(this);
  }
}
B(K, J);
var ob = mb({ 2: "touch", 3: "pen", 4: "mouse" });
K.prototype.b = function() {
  K.O.b.call(this);
  var p = this.c;
  p.preventDefault ? p.preventDefault() : p.returnValue = !1;
};
var L = "closure_listenable_" + (1e6 * Math.random() | 0), pb = 0;
function qb(p, s, h, c, d) {
  this.listener = p, this.proxy = null, this.src = s, this.type = h, this.capture = !!c, this.H = d, this.key = ++pb, this.A = this.D = !1;
}
function rb(p) {
  p.A = !0, p.listener = null, p.proxy = null, p.src = null, p.H = null;
}
function sb(p) {
  this.src = p, this.a = {}, this.b = 0;
}
sb.prototype.add = function(p, s, h, c, d) {
  var l = p.toString();
  p = this.a[l], p || (p = this.a[l] = [], this.b++);
  var g = tb(p, s, c, d);
  return -1 < g ? (s = p[g], h || (s.D = !1)) : (s = new qb(s, this.src, l, !!c, d), s.D = h, p.push(s)), s;
};
sb.prototype.remove = function(p, s, h, c) {
  if (p = p.toString(), !(p in this.a)) return !1;
  var d = this.a[p];
  return s = tb(d, s, h, c), -1 < s ? (rb(d[s]), Array.prototype.splice.call(d, s, 1), d.length == 0 && (delete this.a[p], this.b--), !0) : !1;
};
function ub(p, s) {
  var h = s.type;
  if (h in p.a) {
    var c = p.a[h], d = Na(c, s), l;
    (l = 0 <= d) && Array.prototype.splice.call(c, d, 1), l && (rb(s), p.a[h].length == 0 && (delete p.a[h], p.b--));
  }
}
function tb(p, s, h, c) {
  for (var d = 0; d < p.length; ++d) {
    var l = p[d];
    if (!l.A && l.listener == s && l.capture == !!h && l.H == c) return d;
  }
  return -1;
}
var vb = "closure_lm_" + (1e6 * Math.random() | 0), wb = {};
function yb(p, s, h, c, d) {
  if (c && c.once) zb(p, s, h, c, d);
  else if (Array.isArray(s)) for (var l = 0; l < s.length; l++) yb(p, s[l], h, c, d);
  else h = Ab(h), p && p[L] ? p.f.add(String(s), h, !1, sa(c) ? !!c.capture : !!c, d) : Bb(p, s, h, !1, c, d);
}
function Bb(p, s, h, c, d, l) {
  if (!s) throw Error("Invalid event type");
  var g = sa(d) ? !!d.capture : !!d, f = Cb(p);
  if (f || (p[vb] = f = new sb(p)), h = f.add(s, h, c, g, l), !h.proxy)
    if (c = Db(), h.proxy = c, c.src = p, c.listener = h, p.addEventListener) nb || (d = g), d === void 0 && (d = !1), p.addEventListener(s.toString(), c, d);
    else if (p.attachEvent) p.attachEvent(Eb(s.toString()), c);
    else if (p.addListener && p.removeListener) p.addListener(c);
    else throw Error("addEventListener and attachEvent are unavailable.");
}
function Db() {
  function p(h) {
    return s.call(p.src, p.listener, h);
  }
  var s = Fb;
  return p;
}
function zb(p, s, h, c, d) {
  if (Array.isArray(s)) for (var l = 0; l < s.length; l++) zb(p, s[l], h, c, d);
  else h = Ab(h), p && p[L] ? p.f.add(String(s), h, !0, sa(c) ? !!c.capture : !!c, d) : Bb(p, s, h, !0, c, d);
}
function Gb(p, s, h, c, d) {
  if (Array.isArray(s)) for (var l = 0; l < s.length; l++) Gb(p, s[l], h, c, d);
  else c = sa(c) ? !!c.capture : !!c, h = Ab(h), p && p[L] ? p.f.remove(String(s), h, c, d) : p && (p = Cb(p)) && (s = p.a[s.toString()], p = -1, s && (p = tb(s, h, c, d)), (h = -1 < p ? s[p] : null) && Hb(h));
}
function Hb(p) {
  if (typeof p != "number" && p && !p.A) {
    var s = p.src;
    if (s && s[L]) ub(s.f, p);
    else {
      var h = p.type, c = p.proxy;
      s.removeEventListener ? s.removeEventListener(h, c, p.capture) : s.detachEvent ? s.detachEvent(Eb(h), c) : s.addListener && s.removeListener && s.removeListener(c), (h = Cb(s)) ? (ub(h, p), h.b == 0 && (h.src = null, s[vb] = null)) : rb(p);
    }
  }
}
function Eb(p) {
  return p in wb ? wb[p] : wb[p] = "on" + p;
}
function Fb(p, s) {
  if (p.A) p = !0;
  else {
    s = new K(s, this);
    var h = p.listener, c = p.H || p.src;
    p.D && Hb(p), p = h.call(c, s);
  }
  return p;
}
function Cb(p) {
  return p = p[vb], p instanceof sb ? p : null;
}
var Ib = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
function Ab(p) {
  return typeof p == "function" ? p : (p[Ib] || (p[Ib] = function(s) {
    return p.handleEvent(s);
  }), p[Ib]);
}
function N() {
  kb.call(this), this.f = new sb(this), this.U = this;
}
B(N, kb);
N.prototype[L] = !0;
N.prototype.addEventListener = function(p, s, h, c) {
  yb(this, p, s, h, c);
};
N.prototype.removeEventListener = function(p, s, h, c) {
  Gb(this, p, s, h, c);
};
function O(p, s) {
  p = p.U;
  var h = s.type || s;
  if (typeof s == "string") s = new J(s, p);
  else if (s instanceof J) s.target = s.target || p;
  else {
    var c = s;
    s = new J(h, p), Va(s, c);
  }
  p = s.a = p, Jb(p, h, !0, s), Jb(p, h, !1, s);
}
function Jb(p, s, h, c) {
  if (s = p.f.a[String(s)]) {
    s = s.concat();
    for (var d = !0, l = 0; l < s.length; ++l) {
      var g = s[l];
      if (g && !g.A && g.capture == h) {
        var f = g.listener, _ = g.H || g.src;
        g.D && ub(p.f, g), d = f.call(_, c) !== !1 && d;
      }
    }
  }
}
var Kb = x;
function Lb(p, s, h) {
  if (typeof p == "function") h && (p = A(p, h));
  else if (p && typeof p.handleEvent == "function") p = A(p.handleEvent, p);
  else throw Error("Invalid listener argument");
  return 2147483647 < Number(s) ? -1 : Kb.setTimeout(p, s || 0);
}
function Mb(p, s) {
  this.name = p, this.value = s;
}
Mb.prototype.toString = function() {
  return this.name;
};
var Nb = new Mb("OFF", 1 / 0), Ob = new Mb("SEVERE", 1e3), Pb = new Mb("CONFIG", 700), Qb = new Mb("FINE", 500);
function Rb() {
  this.clear();
}
var Sb;
Rb.prototype.clear = function() {
};
function Ub(p, s, h) {
  this.reset(p || Nb, s, h, void 0, void 0);
}
Ub.prototype.reset = function() {
};
function Vb(p, s) {
  this.a = null, this.f = [], this.b = (s === void 0 ? null : s) || null, this.c = [], this.g = { getName: function() {
    return p;
  } };
}
function Wb(p) {
  return p.a ? p.a : p.b ? Wb(p.b) : (Ea("Root logger has no level set."), Nb);
}
function Xb(p, s) {
  for (; p; ) p.f.forEach(function(h) {
    h(s);
  }), p = p.b;
}
function Yb() {
  this.entries = {};
  var p = new Vb("");
  p.a = Pb, this.entries[""] = p;
}
var Zb;
function $b(p, s, h) {
  var c = p.entries[s];
  if (c) return c;
  c = $b(p, s.substr(0, s.lastIndexOf(".")));
  var d = new Vb(s, c);
  return p.entries[s] = d, c.c.push(d), d;
}
function ac() {
  return Zb || (Zb = new Yb()), Zb;
}
function bc(p, s, h) {
  var c;
  if ((c = p) && (c = p && s)) {
    c = s.value;
    var d = p ? Wb($b(ac(), p.getName())) : Nb;
    c = c >= d.value;
  }
  c && (s = s || Nb, c = $b(ac(), p.getName()), typeof h == "function" && (h = h()), Sb || (Sb = new Rb()), p = p.getName(), p = new Ub(s, h, p), Xb(c, p));
}
function P(p, s) {
  p && bc(p, Qb, s);
}
function cc() {
}
cc.prototype.a = null;
function dc(p) {
  var s;
  return (s = p.a) || (s = {}, ec(p) && (s[0] = !0, s[1] = !0), s = p.a = s), s;
}
var fc;
function gc() {
}
B(gc, cc);
function hc(p) {
  return (p = ec(p)) ? new ActiveXObject(p) : new XMLHttpRequest();
}
function ec(p) {
  if (!p.b && typeof XMLHttpRequest == "undefined" && typeof ActiveXObject != "undefined") {
    for (var s = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], h = 0; h < s.length; h++) {
      var c = s[h];
      try {
        return new ActiveXObject(c), p.b = c;
      } catch (d) {
      }
    }
    throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
  }
  return p.b;
}
fc = new gc();
t$1();
u();
function ic(p, s) {
  this.b = p[x.Symbol.iterator](), this.c = s, this.f = 0;
}
ic.prototype[Symbol.iterator] = function() {
  return this;
};
ic.prototype.next = function() {
  var p = this.b.next();
  return { value: p.done ? void 0 : this.c.call(void 0, p.value, this.f++), done: p.done };
};
function jc(p, s) {
  return new ic(p, s);
}
t$1();
u();
t$1();
u();
var kc = "StopIteration" in x ? x.StopIteration : { message: "StopIteration", stack: "" };
function Q() {
}
Q.prototype.next = function() {
  return Q.prototype.a.call(this);
};
Q.prototype.a = function() {
  throw kc;
};
Q.prototype.u = function() {
  return this;
};
function lc(p) {
  if (p instanceof R || p instanceof S || p instanceof T) return p;
  if (typeof p.next == "function") return new R(function() {
    return mc(p);
  });
  if (t$1(), u(), typeof p[Symbol.iterator] == "function") return t$1(), u(), new R(function() {
    return p[Symbol.iterator]();
  });
  if (typeof p.u == "function") return new R(function() {
    return mc(p.u());
  });
  throw Error("Not an iterator or iterable.");
}
function mc(p) {
  if (!(p instanceof Q)) return p;
  var s = !1;
  return { next: function() {
    for (var h; !s; ) try {
      h = p.a();
      break;
    } catch (c) {
      if (c !== kc) throw c;
      s = !0;
    }
    return { value: h, done: s };
  } };
}
t$1();
u();
function R(p) {
  this.b = p;
}
R.prototype.u = function() {
  return new S(this.b());
};
R.prototype[Symbol.iterator] = function() {
  return new T(this.b());
};
R.prototype.c = function() {
  return new T(this.b());
};
t$1();
u();
function S(p) {
  this.b = p;
}
oa(S, Q);
S.prototype.a = function() {
  var p = this.b.next();
  if (p.done) throw kc;
  return p.value;
};
S.prototype.next = function() {
  return S.prototype.a.call(this);
};
S.prototype[Symbol.iterator] = function() {
  return new T(this.b);
};
S.prototype.c = function() {
  return new T(this.b);
};
function T(p) {
  R.call(this, function() {
    return p;
  }), this.f = p;
}
oa(T, R);
T.prototype.next = function() {
  return this.f.next();
};
function nc(p, s) {
  this.o = {}, this.j = [], this.B = this.size = 0;
  var h = arguments.length;
  if (1 < h) {
    if (h % 2) throw Error("Uneven number of arguments");
    for (var c = 0; c < h; c += 2) this.set(arguments[c], arguments[c + 1]);
  } else p && this.addAll(p);
}
n$1 = nc.prototype;
n$1.G = function() {
  return oc(this), this.j.concat();
};
n$1.has = function(p) {
  return U(this.o, p);
};
n$1.clear = function() {
  this.o = {}, this.B = this.size = this.j.length = 0;
};
n$1.remove = function(p) {
  return this.delete(p);
};
n$1.delete = function(p) {
  return U(this.o, p) ? (delete this.o[p], --this.size, this.B++, this.j.length > 2 * this.size && oc(this), !0) : !1;
};
function oc(p) {
  if (p.size != p.j.length) {
    for (var s = 0, h = 0; s < p.j.length; ) {
      var c = p.j[s];
      U(p.o, c) && (p.j[h++] = c), s++;
    }
    p.j.length = h;
  }
  if (p.size != p.j.length) {
    var d = {};
    for (h = s = 0; s < p.j.length; ) c = p.j[s], U(d, c) || (p.j[h++] = c, d[c] = 1), s++;
    p.j.length = h;
  }
}
n$1.get = function(p, s) {
  return U(this.o, p) ? this.o[p] : s;
};
n$1.set = function(p, s) {
  U(this.o, p) || (this.size += 1, this.j.push(p), this.B++), this.o[p] = s;
};
n$1.addAll = function(p) {
  if (p instanceof nc) for (var s = p.G(), h = 0; h < s.length; h++) this.set(s[h], p.get(s[h]));
  else for (s in p) this.set(s, p[s]);
};
n$1.forEach = function(p, s) {
  for (var h = this.G(), c = 0; c < h.length; c++) {
    var d = h[c], l = this.get(d);
    p.call(s, l, d, this);
  }
};
n$1.clone = function() {
  return new nc(this);
};
n$1.keys = function() {
  return lc(this.u(!0)).c();
};
n$1.values = function() {
  return lc(this.u(!1)).c();
};
n$1.entries = function() {
  var p = this;
  return jc(this.keys(), function(s) {
    return [s, p.get(s)];
  });
};
n$1.u = function(p) {
  oc(this);
  var s = 0, h = this.B, c = this, d = new Q();
  return d.a = function() {
    if (h != c.B) throw Error("The map has changed since the iterator was created");
    if (s >= c.j.length) throw kc;
    var l = c.j[s++];
    return p ? l : c.o[l];
  }, d.next = d.a.bind(d), d;
};
function U(p, s) {
  return Object.prototype.hasOwnProperty.call(p, s);
}
var pc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function qc(p) {
  N.call(this), this.headers = new nc(), this.C = p || null, this.c = !1, this.J = this.a = null, this.P = this.v = "", this.g = 0, this.l = "", this.i = this.N = this.s = this.L = !1, this.h = 0, this.w = null, this.m = rc, this.I = this.M = !1;
}
B(qc, N);
var rc = "";
qc.prototype.b = $b(ac(), "goog.net.XhrIo").g;
var sc = /^https?$/i, tc = ["POST", "PUT"];
function uc(p, s, h) {
  if (p.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + p.v + "; newUri=" + s);
  p.v = s, p.l = "", p.g = 0, p.P = "POST", p.L = !1, p.c = !0, p.a = p.C ? hc(p.C) : hc(fc), p.J = p.C ? dc(p.C) : dc(fc), p.a.onreadystatechange = A(p.R, p);
  try {
    P(p.b, V(p, "Opening Xhr")), p.N = !0, p.a.open("POST", String(s), !0), p.N = !1;
  } catch (l) {
    P(p.b, V(p, "Error opening Xhr: " + l.message)), vc(p, l);
    return;
  }
  s = h || "", h = p.headers.clone();
  var c = h.G().find(function(l) {
    return l.toLowerCase() == "content-type";
  }), d = x.FormData && s instanceof x.FormData;
  !(0 <= Na(tc, "POST")) || c || d || h.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"), h.forEach(function(l, g) {
    this.a.setRequestHeader(g, l);
  }, p), p.m && (p.a.responseType = p.m), "withCredentials" in p.a && p.a.withCredentials !== p.M && (p.a.withCredentials = p.M);
  try {
    wc(p), 0 < p.h && (p.I = xc(p.a), P(p.b, V(p, "Will abort after " + p.h + "ms if incomplete, xhr2 " + p.I)), p.I ? (p.a.timeout = p.h, p.a.ontimeout = A(p.T, p)) : p.w = Lb(p.T, p.h, p)), P(p.b, V(p, "Sending request")), p.s = !0, p.a.send(s), p.s = !1;
  } catch (l) {
    P(
      p.b,
      V(p, "Send error: " + l.message)
    ), vc(p, l);
  }
}
function xc(p) {
  return ab && jb() && typeof p.timeout == "number" && p.ontimeout !== void 0;
}
n$1 = qc.prototype;
n$1.T = function() {
  typeof qa != "undefined" && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, P(this.b, V(this, this.l)), O(this, "timeout"), this.abort(8));
};
function vc(p, s) {
  p.c = !1, p.a && (p.i = !0, p.a.abort(), p.i = !1), p.l = s, p.g = 5, yc(p), zc(p);
}
function yc(p) {
  p.L || (p.L = !0, O(p, "complete"), O(p, "error"));
}
n$1.abort = function(p) {
  this.a && this.c && (P(this.b, V(this, "Aborting")), this.c = !1, this.i = !0, this.a.abort(), this.i = !1, this.g = p || 7, O(this, "complete"), O(this, "abort"), zc(this));
};
n$1.R = function() {
  this.K || (this.N || this.s || this.i ? Ac(this) : this.W());
};
n$1.W = function() {
  Ac(this);
};
function Ac(p) {
  if (p.c && typeof qa != "undefined") {
    if (p.J[1] && W(p) == 4 && p.getStatus() == 2) P(p.b, V(p, "Local request error detected and ignored"));
    else if (p.s && W(p) == 4) Lb(p.R, 0, p);
    else if (O(p, "readystatechange"), W(p) == 4) {
      P(p.b, V(p, "Request complete")), p.c = !1;
      try {
        var s = p.getStatus();
        e: switch (s) {
          case 200:
          case 201:
          case 202:
          case 204:
          case 206:
          case 304:
          case 1223:
            var h = !0;
            break e;
          default:
            h = !1;
        }
        var c;
        if (!(c = h)) {
          var d;
          if (d = s === 0) {
            var l = String(p.v).match(pc)[1] || null;
            if (!l && x.self && x.self.location) {
              var g = x.self.location.protocol;
              l = g.substr(0, g.length - 1);
            }
            d = !sc.test(l ? l.toLowerCase() : "");
          }
          c = d;
        }
        if (c) O(p, "complete"), O(p, "success");
        else {
          p.g = 6;
          try {
            var f = 2 < W(p) ? p.a.statusText : "";
          } catch (_) {
            P(p.b, "Can not get status: " + _.message), f = "";
          }
          p.l = f + " [" + p.getStatus() + "]", yc(p);
        }
      } finally {
        zc(p);
      }
    }
  }
}
function zc(p) {
  if (p.a) {
    wc(p);
    var s = p.a, h = p.J[0] ? ra : null;
    p.a = null, p.J = null, O(p, "ready");
    try {
      s.onreadystatechange = h;
    } catch (c) {
      (p = p.b) && bc(p, Ob, "Problem encountered resetting onreadystatechange: " + c.message);
    }
  }
}
function wc(p) {
  p.a && p.I && (p.a.ontimeout = null), p.w && (Kb.clearTimeout(p.w), p.w = null);
}
function W(p) {
  return p.a ? p.a.readyState : 0;
}
n$1.getStatus = function() {
  try {
    return 2 < W(this) ? this.a.status : -1;
  } catch (p) {
    return -1;
  }
};
function Bc(p) {
  try {
    if (!p.a) return null;
    if ("response" in p.a) return p.a.response;
    switch (p.m) {
      case rc:
      case "text":
        return p.a.responseText;
      case "arraybuffer":
        if ("mozResponseArrayBuffer" in p.a) return p.a.mozResponseArrayBuffer;
    }
    var s = p.b;
    return s && bc(s, Ob, "Response type " + p.m + " is not supported on this browser"), null;
  } catch (h) {
    return P(p.b, "Can not get response: " + h.message), null;
  }
}
function Cc(p, s) {
  if (p.a && W(p) == 4) return p = p.a.getResponseHeader(s), p === null ? void 0 : p;
}
function Dc(p) {
  var s = {};
  p = (p.a && W(p) == 4 && p.a.getAllResponseHeaders() || "").split(`\r
`);
  for (var h = 0; h < p.length; h++) if (!/^[\s\xa0]*$/.test(p[h])) {
    var c = Wa(p[h]), d = c[0];
    if (c = c[1], typeof c == "string") {
      c = c.trim();
      var l = s[d] || [];
      s[d] = l, l.push(c);
    }
  }
  return Ta(s, function(g) {
    return g.join(", ");
  });
}
function V(p, s) {
  return s + " [" + p.P + " " + p.v + " " + p.getStatus() + "]";
}
var Ec = {}, Fc = null;
function Gc(p) {
  var s = p.length, h = 3 * s / 4;
  h % 3 ? h = Math.floor(h) : H("=.", p[s - 1]) && (h = H("=.", p[s - 2]) ? h - 2 : h - 1);
  var c = new Uint8Array(h), d = 0;
  return Hc(p, function(l) {
    c[d++] = l;
  }), c.subarray(0, d);
}
function Hc(p, s) {
  function h(_) {
    for (; c < p.length; ) {
      var te = p.charAt(c++), ae = Fc[te];
      if (ae != null) return ae;
      if (!/^[\s\xa0]*$/.test(te)) throw Error("Unknown base64 encoding at char: " + te);
    }
    return _;
  }
  Ic();
  for (var c = 0; ; ) {
    var d = h(-1), l = h(0), g = h(64), f = h(64);
    if (f === 64 && d === -1) break;
    s(d << 2 | l >> 4), g != 64 && (s(l << 4 & 240 | g >> 2), f != 64 && s(g << 6 & 192 | f));
  }
}
function Ic() {
  if (!Fc) {
    Fc = {};
    for (var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), s = ["+/=", "+/", "-_=", "-_.", "-_"], h = 0; 5 > h; h++) {
      var c = p.concat(s[h].split(""));
      Ec[h] = c;
      for (var d = 0; d < c.length; d++) {
        var l = c[d];
        Fc[l] === void 0 && (Fc[l] = d);
      }
    }
  }
}
var Jc = ["content-type", "grpc-status", "grpc-message"];
function X(p) {
  this.a = p.Z, this.m = null, this.b = [], this.h = [], this.g = [], this.f = [], this.c = [], this.l = !1, this.i = 0, this.s = new Fa();
  var s = this;
  yb(this.a, "readystatechange", function() {
    var h = s.a;
    if (h = h.a ? h.a.getResponseHeader("Content-Type") : null) {
      if (h = h.toLowerCase(), h.lastIndexOf("application/grpc-web-text", 0) == 0) {
        h = s.a;
        try {
          var c = h.a ? h.a.responseText : "";
        } catch (_) {
          P(h.b, "Can not get responseText: " + _.message), c = "";
        }
        if (h = c || "", c = h.length - h.length % 4, h = h.substr(s.i, c - s.i), h.length == 0) return;
        s.i = c, h = Gc(h);
      } else if (h.lastIndexOf("application/grpc", 0) == 0) h = new Uint8Array(Bc(s.a));
      else {
        Y(s, new E(2, "Unknown Content-type received."));
        return;
      }
      c = null;
      try {
        c = Ha(s.s, h);
      } catch (_) {
        Y(s, new E(2, "Error in parsing response body"));
      }
      if (c) for (h = 0; h < c.length; h++) {
        if (Ia in c[h]) {
          var d = c[h][Ia];
          if (d) {
            var l = !1, g = void 0;
            try {
              g = s.m(d), l = !0;
            } catch (_) {
              Y(s, new E(13, "Error when deserializing response data; error: " + _ + (", response: " + g)));
            }
            if (l) for (d = g, l = 0; l < s.b.length; l++) s.b[l](d);
          }
        }
        if (G in c[h] && 0 < c[h][G].length) {
          for (d = "", l = 0; l < c[h][G].length; l++) d += String.fromCharCode(c[h][G][l]);
          for (d = d.trim().split(`\r
`), l = {}, g = 0; g < d.length; g++) {
            var f = d[g].indexOf(":");
            l[d[g].substring(0, f).trim()] = d[g].substring(f + 1).trim();
          }
          d = l, l = 0, g = "", "grpc-status" in d && (l = Number(d["grpc-status"]), delete d["grpc-status"]), "grpc-message" in d && (g = d["grpc-message"], delete d["grpc-message"]), Y(s, new E(l, g, d));
        }
      }
    }
  }), yb(this.a, "complete", function() {
    var h = s.a.g, c = 2, d = "", l = {}, g = Dc(s.a);
    Object.keys(g).forEach(function(_) {
      Jc.includes(_) || (l[_] = g[_]);
    }), Kc(s, l);
    var f = -1;
    if (h != 0) {
      switch (h) {
        case 7:
          c = 10;
          break;
        case 8:
          c = 4;
          break;
        case 6:
          f = s.a.getStatus(), c = Aa(f);
          break;
        default:
          c = 14;
      }
      c == 10 && s.l || (d = Ca(h), f != -1 && (d += ", http status code: " + f), Y(s, new E(c, d)));
    } else f = !1, "grpc-status" in g && (c = Number(Cc(s.a, "grpc-status")), "grpc-message" in g && (d = Cc(s.a, "grpc-message")), c != 0 && (Y(s, new E(c, d || "", g)), f = !0)), f || Lc(s);
  });
}
X.prototype.on = function(p, s) {
  return p == "data" ? this.b.push(s) : p == "status" ? this.h.push(s) : p == "metadata" ? this.g.push(s) : p == "end" ? this.c.push(s) : p == "error" && this.f.push(s), this;
};
function Mc(p, s) {
  s = p.indexOf(s), -1 < s && p.splice(s, 1);
}
X.prototype.removeListener = function(p, s) {
  return p == "data" ? Mc(this.b, s) : p == "status" ? Mc(this.h, s) : p == "metadata" ? Mc(this.g, s) : p == "end" ? Mc(this.c, s) : p == "error" && Mc(this.f, s), this;
};
X.prototype.cancel = function() {
  this.l = !0, this.a.abort();
};
function Y(p, s) {
  if (s.code != 0) for (var h = new E(s.code, decodeURIComponent(s.message || ""), s.metadata), c = 0; c < p.f.length; c++) p.f[c](h);
  for (s = { code: s.code, details: decodeURIComponent(s.message || ""), metadata: s.metadata }, h = 0; h < p.h.length; h++) p.h[h](s);
}
function Kc(p, s) {
  for (var h = 0; h < p.g.length; h++) p.g[h](s);
}
function Lc(p) {
  for (var s = 0; s < p.c.length; s++) p.c[s]();
}
X.prototype.cancel = X.prototype.cancel;
X.prototype.removeListener = X.prototype.removeListener;
X.prototype.on = X.prototype.on;
function Nc(p) {
  var s = "";
  return Sa(p, function(h, c) {
    s += c, s += ":", s += h, s += `\r
`;
  }), s;
}
function Z(p, s) {
  p = p === void 0 ? {} : p, this.a = p.format || y("format", p) || "text", this.g = p.aa || y("suppressCorsPreflight", p) || !1, this.f = p.withCredentials || y("withCredentials", p) || !1, this.b = p.$ || y("streamInterceptors", p) || [], this.h = p.ba || y("unaryInterceptors", p) || [], this.c = s || null;
}
Z.prototype.X = function(p, s, h, c, d) {
  var l = this, g = p.substr(0, p.length - c.name.length);
  return p = Oc(function(f) {
    return Pc(l, f, g);
  }, this.b).call(this, za(c, s, h)), Qc(p, d, !1), new Ba(p);
};
Z.prototype.S = function(p, s, h, c) {
  var d = this, l = p.substr(0, p.length - c.name.length);
  return Oc(function(g) {
    return new Promise(function(f, _) {
      var te = Pc(d, g, l), ae, ie, se;
      Qc(te, function(m, w, q, j, k) {
        m ? _(m) : k ? se = w : q ? ie = q : j ? ae = j : (m = g.getMethodDescriptor(), w = ae, w = w === void 0 ? {} : w, f(new D(se, m, w, ie === void 0 ? null : ie)));
      }, !0);
    });
  }, this.h).call(this, za(c, s, h)).then(function(g) {
    return g.getResponseMessage();
  });
};
Z.prototype.unaryCall = function(p, s, h, c) {
  return this.S(p, s, h, c);
};
Z.prototype.Y = function(p, s, h, c) {
  var d = this, l = p.substr(0, p.length - c.name.length);
  return Oc(function(g) {
    return Pc(d, g, l);
  }, this.b).call(this, za(c, s, h));
};
function Pc(p, s, h) {
  var c = s.getMethodDescriptor(), d = h + c.getName();
  h = p.c ? p.c : new qc(), h.M = p.f;
  var l = new X({ Z: h });
  l.m = c.b;
  var g = s.getMetadata();
  for (f in g) h.headers.set(f, g[f]);
  if (p.a == "text" ? (h.headers.set("Content-Type", "application/grpc-web-text"), h.headers.set("Accept", "application/grpc-web-text")) : h.headers.set("Content-Type", "application/grpc-web+proto"), h.headers.set("X-User-Agent", "grpc-web-javascript/0.1"), h.headers.set("X-Grpc-Web", "1"), h.headers.has("deadline")) {
    var f = Number(h.headers.get("deadline"));
    f = Math.ceil(f - (/* @__PURE__ */ new Date()).getTime()), h.headers.delete("deadline"), f === 1 / 0 && (f = 0), 0 < f && (h.headers.set("grpc-timeout", f + "m"), h.h = Math.max(0, Math.max(1e3, Math.ceil(1.1 * f))));
  }
  if (p.g) {
    g = h.headers, f = {};
    for (var _ = ha(g.keys()), te = _.next(); !te.done; te = _.next()) te = te.value, f[te] = g.get(te);
    h.headers.clear();
    e: {
      for (ae in f) {
        var ae = !1;
        break e;
      }
      ae = !0;
    }
    ae || (f = Nc(f), typeof d == "string" ? (ae = encodeURIComponent("$httpHeaders"), f = f != null ? "=" + encodeURIComponent(String(f)) : "", (ae += f) && (f = d.indexOf("#"), 0 > f && (f = d.length), g = d.indexOf("?"), 0 > g || g > f ? (g = f, _ = "") : _ = d.substring(g + 1, f), d = [d.substr(0, g), _, d.substr(f)], f = d[1], d[1] = ae ? f ? f + "&" + ae : ae : f, d = d[0] + (d[1] ? "?" + d[1] : "") + d[2])) : d.a("$httpHeaders", f));
  }
  for (s = (0, c.a)(s.getRequestMessage()), c = s.length, ae = [0, 0, 0, 0], f = new Uint8Array(5 + c), g = 3; 0 <= g; g--) ae[g] = c % 256, c >>>= 8;
  if (f.set(new Uint8Array(ae), 1), f.set(s, 5), s = f, p.a == "text") {
    p = s;
    var ie;
    for (ie === void 0 && (ie = 0), Ic(), ie = Ec[ie], s = Array(Math.floor(p.length / 3)), c = ie[64] || "", ae = f = 0; f < p.length - 2; f += 3) {
      te = p[f];
      var se = p[f + 1];
      _ = p[f + 2], g = ie[te >> 2], te = ie[(te & 3) << 4 | se >> 4], se = ie[(se & 15) << 2 | _ >> 6], _ = ie[_ & 63], s[ae++] = g + te + se + _;
    }
    switch (g = 0, _ = c, p.length - f) {
      case 2:
        g = p[f + 1], _ = ie[(g & 15) << 2] || c;
      case 1:
        p = p[f], s[ae] = ie[p >> 2] + ie[(p & 3) << 4 | g >> 4] + _ + c;
    }
    s = s.join("");
  } else p.a == "binary" && (h.m = "arraybuffer");
  return uc(h, d, s), l;
}
function Qc(p, s, h) {
  var c = !1, d = null, l = !1;
  p.on("data", function(g) {
    c = !0, d = g;
  }), p.on("error", function(g) {
    g.code == 0 || l || (l = !0, s(g, null));
  }), p.on("status", function(g) {
    g.code == 0 || l ? h && s(null, null, g) : (l = !0, s({ code: g.code, message: g.details, metadata: g.metadata }, null));
  }), h && p.on("metadata", function(g) {
    s(null, null, null, g);
  }), p.on("end", function() {
    l || (c ? h ? s(null, d, null, null, !0) : s(null, d) : s({ code: 2, message: "Incomplete response" })), h && s(null, null);
  });
}
function Oc(p, s) {
  var h = p;
  return s.forEach(function(c) {
    var d = h;
    h = function(l) {
      return c.intercept(l, d);
    };
  }), h;
}
Z.prototype.serverStreaming = Z.prototype.Y;
Z.prototype.unaryCall = Z.prototype.unaryCall;
Z.prototype.thenableCall = Z.prototype.S;
Z.prototype.rpcCall = Z.prototype.X;
grpcWeb$a.CallOptions = xa;
grpcWeb$a.MethodDescriptor = ya;
grpcWeb$a.GrpcWebClientBase = Z;
grpcWeb$a.RpcError = E;
grpcWeb$a.StatusCode = { OK: 0, CANCELLED: 1, UNKNOWN: 2, INVALID_ARGUMENT: 3, DEADLINE_EXCEEDED: 4, NOT_FOUND: 5, ALREADY_EXISTS: 6, PERMISSION_DENIED: 7, UNAUTHENTICATED: 16, RESOURCE_EXHAUSTED: 8, FAILED_PRECONDITION: 9, ABORTED: 10, OUT_OF_RANGE: 11, UNIMPLEMENTED: 12, INTERNAL: 13, UNAVAILABLE: 14, DATA_LOSS: 15 };
grpcWeb$a.MethodType = { UNARY: "unary", SERVER_STREAMING: "server_streaming", BIDI_STREAMING: "bidi_streaming" };
Kb = typeof globalThis != "undefined" && globalThis || self;
var cacheclient_pb$1 = {}, googleProtobuf = {};
(function(exports) {
  var $jscomp = $jscomp || {};
  $jscomp.scope = {}, $jscomp.findInternal = function(p, s, h) {
    p instanceof String && (p = String(p));
    for (var c = p.length, d = 0; d < c; d++) {
      var l = p[d];
      if (s.call(h, l, d, p)) return { i: d, v: l };
    }
    return { i: -1, v: void 0 };
  }, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(p, s, h) {
    p != Array.prototype && p != Object.prototype && (p[s] = h.value);
  }, $jscomp.getGlobal = function(p) {
    return typeof window != "undefined" && window === p ? p : typeof commonjsGlobal != "undefined" && commonjsGlobal != null ? commonjsGlobal : p;
  }, $jscomp.global = $jscomp.getGlobal(commonjsGlobal), $jscomp.polyfill = function(p, s, h, c) {
    if (s) {
      for (h = $jscomp.global, p = p.split("."), c = 0; c < p.length - 1; c++) {
        var d = p[c];
        d in h || (h[d] = {}), h = h[d];
      }
      p = p[p.length - 1], c = h[p], s = s(c), s != c && s != null && $jscomp.defineProperty(h, p, { configurable: !0, writable: !0, value: s });
    }
  }, $jscomp.polyfill("Array.prototype.findIndex", function(p) {
    return p || function(s, h) {
      return $jscomp.findInternal(this, s, h).i;
    };
  }, "es6", "es3"), $jscomp.checkStringArgs = function(p, s, h) {
    if (p == null) throw new TypeError("The 'this' value for String.prototype." + h + " must not be null or undefined");
    if (s instanceof RegExp) throw new TypeError("First argument to String.prototype." + h + " must not be a regular expression");
    return p + "";
  }, $jscomp.polyfill("String.prototype.endsWith", function(p) {
    return p || function(s, h) {
      var c = $jscomp.checkStringArgs(this, s, "endsWith");
      s += "", h === void 0 && (h = c.length), h = Math.max(0, Math.min(h | 0, c.length));
      for (var d = s.length; 0 < d && 0 < h; ) if (c[--h] != s[--d]) return !1;
      return 0 >= d;
    };
  }, "es6", "es3"), $jscomp.polyfill("Array.prototype.find", function(p) {
    return p || function(s, h) {
      return $jscomp.findInternal(this, s, h).v;
    };
  }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function(p) {
    return p || function(s, h) {
      var c = $jscomp.checkStringArgs(this, s, "startsWith");
      s += "";
      var d = c.length, l = s.length;
      h = Math.max(0, Math.min(h | 0, c.length));
      for (var g = 0; g < l && h < d; ) if (c[h++] != s[g++]) return !1;
      return g >= l;
    };
  }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function(p) {
    return p || function(s) {
      var h = $jscomp.checkStringArgs(this, null, "repeat");
      if (0 > s || 1342177279 < s) throw new RangeError("Invalid count value");
      s |= 0;
      for (var c = ""; s; ) s & 1 && (c += h), (s >>>= 1) && (h += h);
      return c;
    };
  }, "es6", "es3");
  var COMPILED = !0, goog = goog || {};
  goog.global = commonjsGlobal || self, goog.exportPath_ = function(p, s, h) {
    p = p.split("."), h = h || goog.global, p[0] in h || typeof h.execScript == "undefined" || h.execScript("var " + p[0]);
    for (var c; p.length && (c = p.shift()); ) p.length || s === void 0 ? h = h[c] && h[c] !== Object.prototype[c] ? h[c] : h[c] = {} : h[c] = s;
  }, goog.define = function(p, s) {
    return s;
  }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.STRICT_MODE_COMPATIBLE = !1, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function(p) {
    if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
    goog.constructNamespace_(p);
  }, goog.constructNamespace_ = function(p, s) {
    goog.exportPath_(p, s);
  }, goog.getScriptNonce = function(p) {
    return p && p != goog.global ? goog.getScriptNonce_(p.document) : (goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
  }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(p) {
    return (p = p.querySelector && p.querySelector("script[nonce]")) && (p = p.nonce || p.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(p) ? p : "";
  }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(p) {
    if (typeof p != "string" || !p || p.search(goog.VALID_MODULE_RE_) == -1) throw Error("Invalid module identifier");
    if (!goog.isInGoogModuleLoader_()) throw Error("Module " + p + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
    if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
    goog.moduleLoaderState_.moduleName = p;
  }, goog.module.get = function(p) {
    return goog.module.getInternal_(p);
  }, goog.module.getInternal_ = function(p) {
    return null;
  }, goog.ModuleType = { ES6: "es6", GOOG: "goog" }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
    return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
  }, goog.isInGoogModuleLoader_ = function() {
    return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
  }, goog.isInEs6ModuleLoader_ = function() {
    if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
    var p = goog.global.$jscomp;
    return p ? typeof p.getCurrentModulePath != "function" ? !1 : !!p.getCurrentModulePath() : !1;
  }, goog.module.declareLegacyNamespace = function() {
    goog.moduleLoaderState_.declareLegacyNamespace = !0;
  }, goog.declareModuleId = function(p) {
    if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = p;
    else {
      var s = goog.global.$jscomp;
      if (!s || typeof s.getCurrentModulePath != "function") throw Error('Module with namespace "' + p + '" has been loaded incorrectly.');
      s = s.require(s.getCurrentModulePath()), goog.loadedModules_[p] = { exports: s, type: goog.ModuleType.ES6, moduleId: p };
    }
  }, goog.setTestOnly = function(p) {
    if (goog.DISALLOW_TEST_ONLY_CODE) throw p = p || "", Error("Importing test-only code into non-debug environment" + (p ? ": " + p : "."));
  }, goog.forwardDeclare = function(p) {
  }, goog.getObjectByName = function(p, s) {
    p = p.split("."), s = s || goog.global;
    for (var h = 0; h < p.length; h++) if (s = s[p[h]], s == null) return null;
    return s;
  }, goog.globalize = function(p, s) {
    s = s || goog.global;
    for (var h in p) s[h] = p[h];
  }, goog.addDependency = function(p, s, h, c) {
  }, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function(p) {
    goog.global.console && goog.global.console.error(p);
  }, goog.require = function(p) {
  }, goog.requireType = function(p) {
    return {};
  }, goog.basePath = "", goog.nullFunction = function() {
  }, goog.abstractMethod = function() {
    throw Error("unimplemented abstract method");
  }, goog.addSingletonGetter = function(p) {
    p.instance_ = void 0, p.getInstance = function() {
      return p.instance_ ? p.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = p), p.instance_ = new p());
    };
  }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
    if (goog.hasBadLetScoping == null) {
      try {
        var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
      } catch (p) {
        a = !1;
      }
      goog.hasBadLetScoping = a;
    }
    return goog.hasBadLetScoping;
  }, goog.workaroundSafari10EvalBug = function(p) {
    return "(function(){" + p + `
;})();
`;
  }, goog.loadModule = function(p) {
    var s = goog.moduleLoaderState_;
    try {
      if (goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: !1, type: goog.ModuleType.GOOG }, goog.isFunction(p)) var h = p.call(void 0, {});
      else if (typeof p == "string") goog.useSafari10Workaround() && (p = goog.workaroundSafari10EvalBug(p)), h = goog.loadModuleFromSource_.call(void 0, p);
      else throw Error("Invalid module definition");
      var c = goog.moduleLoaderState_.moduleName;
      if (typeof c == "string" && c) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(
        c,
        h
      ) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof h == "object" && h != null && Object.seal(h), goog.loadedModules_[c] = { exports: h, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
      else throw Error('Invalid module name "' + c + '"');
    } finally {
      goog.moduleLoaderState_ = s;
    }
  }, goog.loadModuleFromSource_ = function(a) {
    return eval(a), {};
  }, goog.normalizePath_ = function(p) {
    p = p.split("/");
    for (var s = 0; s < p.length; ) p[s] == "." ? p.splice(s, 1) : s && p[s] == ".." && p[s - 1] && p[s - 1] != ".." ? p.splice(--s, 2) : s++;
    return p.join("/");
  }, goog.loadFileSync_ = function(p) {
    if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(p);
    try {
      var s = new goog.global.XMLHttpRequest();
      return s.open("get", p, !1), s.send(), s.status == 0 || s.status == 200 ? s.responseText : null;
    } catch (h) {
      return null;
    }
  }, goog.transpile_ = function(p, s, h) {
    var c = goog.global.$jscomp;
    c || (goog.global.$jscomp = c = {});
    var d = c.transpile;
    if (!d) {
      var l = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(l);
      if (g) {
        if (function() {
          (0, eval)(g + `
//# sourceURL=` + l);
        }.call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
        goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, c = goog.global.$jscomp, d = c.transpile;
      }
    }
    return d || (d = c.transpile = function(f, _) {
      return goog.logToConsole_(_ + " requires transpilation but no transpiler was found."), f;
    }), d(p, s, h);
  }, goog.typeOf = function(p) {
    var s = typeof p;
    if (s == "object") if (p) {
      if (p instanceof Array) return "array";
      if (p instanceof Object) return s;
      var h = Object.prototype.toString.call(p);
      if (h == "[object Window]") return "object";
      if (h == "[object Array]" || typeof p.length == "number" && typeof p.splice != "undefined" && typeof p.propertyIsEnumerable != "undefined" && !p.propertyIsEnumerable("splice")) return "array";
      if (h == "[object Function]" || typeof p.call != "undefined" && typeof p.propertyIsEnumerable != "undefined" && !p.propertyIsEnumerable("call")) return "function";
    } else return "null";
    else if (s == "function" && typeof p.call == "undefined") return "object";
    return s;
  }, goog.isArray = function(p) {
    return goog.typeOf(p) == "array";
  }, goog.isArrayLike = function(p) {
    var s = goog.typeOf(p);
    return s == "array" || s == "object" && typeof p.length == "number";
  }, goog.isDateLike = function(p) {
    return goog.isObject(p) && typeof p.getFullYear == "function";
  }, goog.isFunction = function(p) {
    return goog.typeOf(p) == "function";
  }, goog.isObject = function(p) {
    var s = typeof p;
    return s == "object" && p != null || s == "function";
  }, goog.getUid = function(p) {
    return Object.prototype.hasOwnProperty.call(p, goog.UID_PROPERTY_) && p[goog.UID_PROPERTY_] || (p[goog.UID_PROPERTY_] = ++goog.uidCounter_);
  }, goog.hasUid = function(p) {
    return !!p[goog.UID_PROPERTY_];
  }, goog.removeUid = function(p) {
    p !== null && "removeAttribute" in p && p.removeAttribute(goog.UID_PROPERTY_);
    try {
      delete p[goog.UID_PROPERTY_];
    } catch (s) {
    }
  }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function(p) {
    var s = goog.typeOf(p);
    if (s == "object" || s == "array") {
      if (typeof p.clone == "function") return p.clone();
      s = s == "array" ? [] : {};
      for (var h in p) s[h] = goog.cloneObject(p[h]);
      return s;
    }
    return p;
  }, goog.bindNative_ = function(p, s, h) {
    return p.call.apply(p.bind, arguments);
  }, goog.bindJs_ = function(p, s, h) {
    if (!p) throw Error();
    if (2 < arguments.length) {
      var c = Array.prototype.slice.call(arguments, 2);
      return function() {
        var d = Array.prototype.slice.call(arguments);
        return Array.prototype.unshift.apply(d, c), p.apply(s, d);
      };
    }
    return function() {
      return p.apply(s, arguments);
    };
  }, goog.bind = function(p, s, h) {
    return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
  }, goog.partial = function(p, s) {
    var h = Array.prototype.slice.call(arguments, 1);
    return function() {
      var c = h.slice();
      return c.push.apply(c, arguments), p.apply(this, c);
    };
  }, goog.mixin = function(p, s) {
    for (var h in s) p[h] = s[h];
  }, goog.now = goog.TRUSTED_SITE && Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, goog.globalEval = function(p) {
    if (goog.global.execScript) goog.global.execScript(p, "JavaScript");
    else if (goog.global.eval) {
      if (goog.evalWorksForGlobals_ == null) {
        try {
          goog.global.eval("var _evalTest_ = 1;");
        } catch (c) {
        }
        if (typeof goog.global._evalTest_ != "undefined") {
          try {
            delete goog.global._evalTest_;
          } catch (c) {
          }
          goog.evalWorksForGlobals_ = !0;
        } else goog.evalWorksForGlobals_ = !1;
      }
      if (goog.evalWorksForGlobals_) goog.global.eval(p);
      else {
        var s = goog.global.document, h = s.createElement("script");
        h.type = "text/javascript", h.defer = !1, h.appendChild(s.createTextNode(p)), s.head.appendChild(h), s.head.removeChild(h);
      }
    } else throw Error("goog.globalEval not available");
  }, goog.evalWorksForGlobals_ = null, goog.getCssName = function(p, s) {
    if (String(p).charAt(0) == ".") throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + p);
    var h = function(d) {
      return goog.cssNameMapping_[d] || d;
    }, c = function(d) {
      d = d.split("-");
      for (var l = [], g = 0; g < d.length; g++) l.push(h(d[g]));
      return l.join("-");
    };
    return c = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? h : c : function(d) {
      return d;
    }, p = s ? p + "-" + c(s) : c(p), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(p) : p;
  }, goog.setCssNameMapping = function(p, s) {
    goog.cssNameMapping_ = p, goog.cssNameMappingStyle_ = s;
  }, goog.getMsg = function(p, s, h) {
    return h && h.html && (p = p.replace(/</g, "&lt;")), s && (p = p.replace(/\{\$([^}]+)}/g, function(c, d) {
      return s != null && d in s ? s[d] : c;
    })), p;
  }, goog.getMsgWithFallback = function(p, s) {
    return p;
  }, goog.exportSymbol = function(p, s, h) {
    goog.exportPath_(p, s, h);
  }, goog.exportProperty = function(p, s, h) {
    p[s] = h;
  }, goog.inherits = function(p, s) {
    function h() {
    }
    h.prototype = s.prototype, p.superClass_ = s.prototype, p.prototype = new h(), p.prototype.constructor = p, p.base = function(c, d, l) {
      for (var g = Array(arguments.length - 2), f = 2; f < arguments.length; f++) g[f - 2] = arguments[f];
      return s.prototype[d].apply(c, g);
    };
  }, goog.scope = function(p) {
    if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
    p.call(goog.global);
  }, goog.defineClass = function(p, s) {
    var h = s.constructor, c = s.statics;
    return h && h != Object.prototype.constructor || (h = function() {
      throw Error("cannot instantiate an interface (no constructor defined).");
    }), h = goog.defineClass.createSealingConstructor_(h, p), p && goog.inherits(h, p), delete s.constructor, delete s.statics, goog.defineClass.applyProperties_(h.prototype, s), c != null && (c instanceof Function ? c(h) : goog.defineClass.applyProperties_(h, c)), h;
  }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(p, s) {
    if (!goog.defineClass.SEAL_CLASS_INSTANCES) return p;
    var h = !goog.defineClass.isUnsealable_(s), c = function() {
      var d = p.apply(this, arguments) || this;
      return d[goog.UID_PROPERTY_] = d[goog.UID_PROPERTY_], this.constructor === c && h && Object.seal instanceof Function && Object.seal(d), d;
    };
    return c;
  }, goog.defineClass.isUnsealable_ = function(p) {
    return p && p.prototype && p.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
  }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function(p, s) {
    for (var h in s) Object.prototype.hasOwnProperty.call(s, h) && (p[h] = s[h]);
    for (var c = 0; c < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; c++) h = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[c], Object.prototype.hasOwnProperty.call(s, h) && (p[h] = s[h]);
  }, goog.tagUnsealableClass = function(p) {
  }, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.TRUSTED_TYPES_POLICY_NAME = "", goog.identity_ = function(p) {
    return p;
  }, goog.createTrustedTypesPolicy = function(p) {
    var s = null, h = goog.global.trustedTypes || goog.global.TrustedTypes;
    if (!h || !h.createPolicy) return s;
    try {
      s = h.createPolicy(p, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_, createURL: goog.identity_ });
    } catch (c) {
      goog.logToConsole_(c.message);
    }
    return s;
  }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.object = {}, goog.object.is = function(p, s) {
    return p === s ? p !== 0 || 1 / p === 1 / s : p !== p && s !== s;
  }, goog.object.forEach = function(p, s, h) {
    for (var c in p) s.call(h, p[c], c, p);
  }, goog.object.filter = function(p, s, h) {
    var c = {}, d;
    for (d in p) s.call(h, p[d], d, p) && (c[d] = p[d]);
    return c;
  }, goog.object.map = function(p, s, h) {
    var c = {}, d;
    for (d in p) c[d] = s.call(h, p[d], d, p);
    return c;
  }, goog.object.some = function(p, s, h) {
    for (var c in p) if (s.call(h, p[c], c, p)) return !0;
    return !1;
  }, goog.object.every = function(p, s, h) {
    for (var c in p) if (!s.call(h, p[c], c, p)) return !1;
    return !0;
  }, goog.object.getCount = function(p) {
    var s = 0, h;
    for (h in p) s++;
    return s;
  }, goog.object.getAnyKey = function(p) {
    for (var s in p) return s;
  }, goog.object.getAnyValue = function(p) {
    for (var s in p) return p[s];
  }, goog.object.contains = function(p, s) {
    return goog.object.containsValue(p, s);
  }, goog.object.getValues = function(p) {
    var s = [], h = 0, c;
    for (c in p) s[h++] = p[c];
    return s;
  }, goog.object.getKeys = function(p) {
    var s = [], h = 0, c;
    for (c in p) s[h++] = c;
    return s;
  }, goog.object.getValueByKeys = function(p, s) {
    var h = goog.isArrayLike(s), c = h ? s : arguments;
    for (h = h ? 0 : 1; h < c.length; h++) {
      if (p == null) return;
      p = p[c[h]];
    }
    return p;
  }, goog.object.containsKey = function(p, s) {
    return p !== null && s in p;
  }, goog.object.containsValue = function(p, s) {
    for (var h in p) if (p[h] == s) return !0;
    return !1;
  }, goog.object.findKey = function(p, s, h) {
    for (var c in p) if (s.call(h, p[c], c, p)) return c;
  }, goog.object.findValue = function(p, s, h) {
    return (s = goog.object.findKey(p, s, h)) && p[s];
  }, goog.object.isEmpty = function(p) {
    for (var s in p) return !1;
    return !0;
  }, goog.object.clear = function(p) {
    for (var s in p) delete p[s];
  }, goog.object.remove = function(p, s) {
    var h;
    return (h = s in p) && delete p[s], h;
  }, goog.object.add = function(p, s, h) {
    if (p !== null && s in p) throw Error('The object already contains the key "' + s + '"');
    goog.object.set(p, s, h);
  }, goog.object.get = function(p, s, h) {
    return p !== null && s in p ? p[s] : h;
  }, goog.object.set = function(p, s, h) {
    p[s] = h;
  }, goog.object.setIfUndefined = function(p, s, h) {
    return s in p ? p[s] : p[s] = h;
  }, goog.object.setWithReturnValueIfNotSet = function(p, s, h) {
    return s in p ? p[s] : (h = h(), p[s] = h);
  }, goog.object.equals = function(p, s) {
    for (var h in p) if (!(h in s) || p[h] !== s[h]) return !1;
    for (var c in s) if (!(c in p)) return !1;
    return !0;
  }, goog.object.clone = function(p) {
    var s = {}, h;
    for (h in p) s[h] = p[h];
    return s;
  }, goog.object.unsafeClone = function(p) {
    var s = goog.typeOf(p);
    if (s == "object" || s == "array") {
      if (goog.isFunction(p.clone)) return p.clone();
      s = s == "array" ? [] : {};
      for (var h in p) s[h] = goog.object.unsafeClone(p[h]);
      return s;
    }
    return p;
  }, goog.object.transpose = function(p) {
    var s = {}, h;
    for (h in p) s[p[h]] = h;
    return s;
  }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function(p, s) {
    for (var h, c, d = 1; d < arguments.length; d++) {
      c = arguments[d];
      for (h in c) p[h] = c[h];
      for (var l = 0; l < goog.object.PROTOTYPE_FIELDS_.length; l++) h = goog.object.PROTOTYPE_FIELDS_[l], Object.prototype.hasOwnProperty.call(c, h) && (p[h] = c[h]);
    }
  }, goog.object.create = function(p) {
    var s = arguments.length;
    if (s == 1 && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
    if (s % 2) throw Error("Uneven number of arguments");
    for (var h = {}, c = 0; c < s; c += 2) h[arguments[c]] = arguments[c + 1];
    return h;
  }, goog.object.createSet = function(p) {
    var s = arguments.length;
    if (s == 1 && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
    for (var h = {}, c = 0; c < s; c++) h[arguments[c]] = !0;
    return h;
  }, goog.object.createImmutableView = function(p) {
    var s = p;
    return Object.isFrozen && !Object.isFrozen(p) && (s = Object.create(p), Object.freeze(s)), s;
  }, goog.object.isImmutableView = function(p) {
    return !!Object.isFrozen && Object.isFrozen(p);
  }, goog.object.getAllPropertyNames = function(p, s, h) {
    if (!p) return [];
    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(p);
    for (var c = {}; p && (p !== Object.prototype || s) && (p !== Function.prototype || h); ) {
      for (var d = Object.getOwnPropertyNames(p), l = 0; l < d.length; l++) c[d[l]] = !0;
      p = Object.getPrototypeOf(p);
    }
    return goog.object.getKeys(c);
  }, goog.object.getSuperClass = function(p) {
    return (p = Object.getPrototypeOf(p.prototype)) && p.constructor;
  };
  var jspb = { asserts: {} };
  jspb.asserts.doAssertFailure = function(p, s, h, c) {
    var d = "Assertion failed";
    if (h) {
      d += ": " + h;
      var l = c;
    } else p && (d += ": " + p, l = s);
    throw Error("" + d, l || []);
  }, jspb.asserts.assert = function(p, s, h) {
    for (var c = [], d = 2; d < arguments.length; ++d) c[d - 2] = arguments[d];
    return p || jspb.asserts.doAssertFailure("", null, s, c), p;
  }, jspb.asserts.assertString = function(p, s, h) {
    for (var c = [], d = 2; d < arguments.length; ++d) c[d - 2] = arguments[d];
    return typeof p != "string" && jspb.asserts.doAssertFailure("Expected string but got %s: %s.", [goog.typeOf(p), p], s, c), p;
  }, jspb.asserts.assertArray = function(p, s, h) {
    for (var c = [], d = 2; d < arguments.length; ++d) c[d - 2] = arguments[d];
    return Array.isArray(p) || jspb.asserts.doAssertFailure("Expected array but got %s: %s.", [goog.typeOf(p), p], s, c), p;
  }, jspb.asserts.fail = function(p, s) {
    for (var h = [], c = 1; c < arguments.length; ++c) h[c - 1] = arguments[c];
    throw Error("Failure" + (p ? ": " + p : ""), h);
  }, jspb.asserts.assertInstanceof = function(p, s, h, c) {
    for (var d = [], l = 3; l < arguments.length; ++l) d[l - 3] = arguments[l];
    return p instanceof s || jspb.asserts.doAssertFailure("Expected instanceof %s but got %s.", [jspb.asserts.getType(s), jspb.asserts.getType(p)], h, d), p;
  }, jspb.asserts.getType = function(p) {
    return p instanceof Function ? p.displayName || p.name || "unknown type name" : p instanceof Object ? p.constructor.displayName || p.constructor.name || Object.prototype.toString.call(p) : p === null ? "null" : typeof p;
  }, jspb.BinaryConstants = {}, jspb.ConstBinaryMessage = function() {
  }, jspb.BinaryMessage = function() {
  }, jspb.BinaryConstants.FieldType = { INVALID: -1, DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18, FHASH64: 30, VHASH64: 31 }, jspb.BinaryConstants.WireType = { INVALID: -1, VARINT: 0, FIXED64: 1, DELIMITED: 2, START_GROUP: 3, END_GROUP: 4, FIXED32: 5 }, jspb.BinaryConstants.FieldTypeToWireType = function(p) {
    var s = jspb.BinaryConstants.FieldType, h = jspb.BinaryConstants.WireType;
    switch (p) {
      case s.INT32:
      case s.INT64:
      case s.UINT32:
      case s.UINT64:
      case s.SINT32:
      case s.SINT64:
      case s.BOOL:
      case s.ENUM:
      case s.VHASH64:
        return h.VARINT;
      case s.DOUBLE:
      case s.FIXED64:
      case s.SFIXED64:
      case s.FHASH64:
        return h.FIXED64;
      case s.STRING:
      case s.MESSAGE:
      case s.BYTES:
        return h.DELIMITED;
      case s.FLOAT:
      case s.FIXED32:
      case s.SFIXED32:
        return h.FIXED32;
      default:
        return h.INVALID;
    }
  }, jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1, jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60, jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54, jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22, jspb.BinaryConstants.FLOAT64_EPS = 5e-324, jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324, jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292, jspb.BinaryConstants.TWO_TO_20 = 1048576, jspb.BinaryConstants.TWO_TO_23 = 8388608, jspb.BinaryConstants.TWO_TO_31 = 2147483648, jspb.BinaryConstants.TWO_TO_32 = 4294967296, jspb.BinaryConstants.TWO_TO_52 = 4503599627370496, jspb.BinaryConstants.TWO_TO_63 = 9223372036854776e3, jspb.BinaryConstants.TWO_TO_64 = 18446744073709552e3, jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0", goog.debug = {}, goog.debug.Error = function(p) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);
    else {
      var s = Error().stack;
      s && (this.stack = s);
    }
    p && (this.message = String(p)), this.reportErrorToServer = !0;
  }, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.dom = {}, goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(p, s) {
    goog.debug.Error.call(this, goog.asserts.subs_(p, s)), this.messagePattern = p;
  }, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function(p) {
    throw p;
  }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(p, s) {
    p = p.split("%s");
    for (var h = "", c = p.length - 1, d = 0; d < c; d++) h += p[d] + (d < s.length ? s[d] : "%s");
    return h + p[c];
  }, goog.asserts.doAssertFailure_ = function(p, s, h, c) {
    var d = "Assertion failed";
    if (h) {
      d += ": " + h;
      var l = c;
    } else p && (d += ": " + p, l = s);
    p = new goog.asserts.AssertionError("" + d, l || []), goog.asserts.errorHandler_(p);
  }, goog.asserts.setErrorHandler = function(p) {
    goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = p);
  }, goog.asserts.assert = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && !p && goog.asserts.doAssertFailure_("", null, s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertExists = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && p == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.fail = function(p, s) {
    goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (p ? ": " + p : ""), Array.prototype.slice.call(arguments, 1)));
  }, goog.asserts.assertNumber = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && typeof p != "number" && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertString = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && typeof p != "string" && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertFunction = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(p) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertObject = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && !goog.isObject(p) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertArray = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && !Array.isArray(p) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertBoolean = function(p, s, h) {
    return goog.asserts.ENABLE_ASSERTS && typeof p != "boolean" && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertElement = function(p, s, h) {
    return !goog.asserts.ENABLE_ASSERTS || goog.isObject(p) && p.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(p), p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertInstanceof = function(p, s, h, c) {
    return !goog.asserts.ENABLE_ASSERTS || p instanceof s || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(s), goog.asserts.getType_(p)], h, Array.prototype.slice.call(arguments, 3)), p;
  }, goog.asserts.assertFinite = function(p, s, h) {
    return !goog.asserts.ENABLE_ASSERTS || typeof p == "number" && isFinite(p) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [p], s, Array.prototype.slice.call(arguments, 2)), p;
  }, goog.asserts.assertObjectPrototypeIsIntact = function() {
    for (var p in Object.prototype) goog.asserts.fail(p + " should not be enumerable in Object.prototype.");
  }, goog.asserts.getType_ = function(p) {
    return p instanceof Function ? p.displayName || p.name || "unknown type name" : p instanceof Object ? p.constructor.displayName || p.constructor.name || Object.prototype.toString.call(p) : p === null ? "null" : typeof p;
  }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE, goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR, goog.array.peek = function(p) {
    return p[p.length - 1];
  }, goog.array.last = goog.array.peek, goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(p, s, h) {
    return goog.asserts.assert(p.length != null), Array.prototype.indexOf.call(p, s, h);
  } : function(p, s, h) {
    if (h = h == null ? 0 : 0 > h ? Math.max(0, p.length + h) : h, typeof p == "string") return typeof s != "string" || s.length != 1 ? -1 : p.indexOf(s, h);
    for (; h < p.length; h++) if (h in p && p[h] === s) return h;
    return -1;
  }, goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(p, s, h) {
    return goog.asserts.assert(p.length != null), Array.prototype.lastIndexOf.call(p, s, h == null ? p.length - 1 : h);
  } : function(p, s, h) {
    if (h = h == null ? p.length - 1 : h, 0 > h && (h = Math.max(0, p.length + h)), typeof p == "string") return typeof s != "string" || s.length != 1 ? -1 : p.lastIndexOf(s, h);
    for (; 0 <= h; h--) if (h in p && p[h] === s) return h;
    return -1;
  }, goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(p, s, h) {
    goog.asserts.assert(p.length != null), Array.prototype.forEach.call(p, s, h);
  } : function(p, s, h) {
    for (var c = p.length, d = typeof p == "string" ? p.split("") : p, l = 0; l < c; l++) l in d && s.call(h, d[l], l, p);
  }, goog.array.forEachRight = function(p, s, h) {
    var c = p.length, d = typeof p == "string" ? p.split("") : p;
    for (--c; 0 <= c; --c) c in d && s.call(h, d[c], c, p);
  }, goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(p, s, h) {
    return goog.asserts.assert(p.length != null), Array.prototype.filter.call(p, s, h);
  } : function(p, s, h) {
    for (var c = p.length, d = [], l = 0, g = typeof p == "string" ? p.split("") : p, f = 0; f < c; f++) if (f in g) {
      var _ = g[f];
      s.call(h, _, f, p) && (d[l++] = _);
    }
    return d;
  }, goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(p, s, h) {
    return goog.asserts.assert(p.length != null), Array.prototype.map.call(p, s, h);
  } : function(p, s, h) {
    for (var c = p.length, d = Array(c), l = typeof p == "string" ? p.split("") : p, g = 0; g < c; g++) g in l && (d[g] = s.call(h, l[g], g, p));
    return d;
  }, goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(p, s, h, c) {
    return goog.asserts.assert(p.length != null), c && (s = goog.bind(s, c)), Array.prototype.reduce.call(p, s, h);
  } : function(p, s, h, c) {
    var d = h;
    return goog.array.forEach(p, function(l, g) {
      d = s.call(c, d, l, g, p);
    }), d;
  }, goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(p, s, h, c) {
    return goog.asserts.assert(p.length != null), goog.asserts.assert(s != null), c && (s = goog.bind(s, c)), Array.prototype.reduceRight.call(p, s, h);
  } : function(p, s, h, c) {
    var d = h;
    return goog.array.forEachRight(p, function(l, g) {
      d = s.call(c, d, l, g, p);
    }), d;
  }, goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(p, s, h) {
    return goog.asserts.assert(p.length != null), Array.prototype.some.call(p, s, h);
  } : function(p, s, h) {
    for (var c = p.length, d = typeof p == "string" ? p.split("") : p, l = 0; l < c; l++) if (l in d && s.call(h, d[l], l, p)) return !0;
    return !1;
  }, goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(p, s, h) {
    return goog.asserts.assert(p.length != null), Array.prototype.every.call(p, s, h);
  } : function(p, s, h) {
    for (var c = p.length, d = typeof p == "string" ? p.split("") : p, l = 0; l < c; l++) if (l in d && !s.call(h, d[l], l, p)) return !1;
    return !0;
  }, goog.array.count = function(p, s, h) {
    var c = 0;
    return goog.array.forEach(p, function(d, l, g) {
      s.call(h, d, l, g) && ++c;
    }, h), c;
  }, goog.array.find = function(p, s, h) {
    return s = goog.array.findIndex(p, s, h), 0 > s ? null : typeof p == "string" ? p.charAt(s) : p[s];
  }, goog.array.findIndex = function(p, s, h) {
    for (var c = p.length, d = typeof p == "string" ? p.split("") : p, l = 0; l < c; l++) if (l in d && s.call(h, d[l], l, p)) return l;
    return -1;
  }, goog.array.findRight = function(p, s, h) {
    return s = goog.array.findIndexRight(p, s, h), 0 > s ? null : typeof p == "string" ? p.charAt(s) : p[s];
  }, goog.array.findIndexRight = function(p, s, h) {
    var c = p.length, d = typeof p == "string" ? p.split("") : p;
    for (--c; 0 <= c; c--) if (c in d && s.call(h, d[c], c, p)) return c;
    return -1;
  }, goog.array.contains = function(p, s) {
    return 0 <= goog.array.indexOf(p, s);
  }, goog.array.isEmpty = function(p) {
    return p.length == 0;
  }, goog.array.clear = function(p) {
    if (!Array.isArray(p)) for (var s = p.length - 1; 0 <= s; s--) delete p[s];
    p.length = 0;
  }, goog.array.insert = function(p, s) {
    goog.array.contains(p, s) || p.push(s);
  }, goog.array.insertAt = function(p, s, h) {
    goog.array.splice(p, h, 0, s);
  }, goog.array.insertArrayAt = function(p, s, h) {
    goog.partial(goog.array.splice, p, h, 0).apply(null, s);
  }, goog.array.insertBefore = function(p, s, h) {
    var c;
    arguments.length == 2 || 0 > (c = goog.array.indexOf(p, h)) ? p.push(s) : goog.array.insertAt(p, s, c);
  }, goog.array.remove = function(p, s) {
    s = goog.array.indexOf(p, s);
    var h;
    return (h = 0 <= s) && goog.array.removeAt(p, s), h;
  }, goog.array.removeLast = function(p, s) {
    return s = goog.array.lastIndexOf(p, s), 0 <= s ? (goog.array.removeAt(p, s), !0) : !1;
  }, goog.array.removeAt = function(p, s) {
    return goog.asserts.assert(p.length != null), Array.prototype.splice.call(p, s, 1).length == 1;
  }, goog.array.removeIf = function(p, s, h) {
    return s = goog.array.findIndex(p, s, h), 0 <= s ? (goog.array.removeAt(p, s), !0) : !1;
  }, goog.array.removeAllIf = function(p, s, h) {
    var c = 0;
    return goog.array.forEachRight(p, function(d, l) {
      s.call(h, d, l, p) && goog.array.removeAt(p, l) && c++;
    }), c;
  }, goog.array.concat = function(p) {
    return Array.prototype.concat.apply([], arguments);
  }, goog.array.join = function(p) {
    return Array.prototype.concat.apply([], arguments);
  }, goog.array.toArray = function(p) {
    var s = p.length;
    if (0 < s) {
      for (var h = Array(s), c = 0; c < s; c++) h[c] = p[c];
      return h;
    }
    return [];
  }, goog.array.clone = goog.array.toArray, goog.array.extend = function(p, s) {
    for (var h = 1; h < arguments.length; h++) {
      var c = arguments[h];
      if (goog.isArrayLike(c)) {
        var d = p.length || 0, l = c.length || 0;
        p.length = d + l;
        for (var g = 0; g < l; g++) p[d + g] = c[g];
      } else p.push(c);
    }
  }, goog.array.splice = function(p, s, h, c) {
    return goog.asserts.assert(p.length != null), Array.prototype.splice.apply(p, goog.array.slice(arguments, 1));
  }, goog.array.slice = function(p, s, h) {
    return goog.asserts.assert(p.length != null), 2 >= arguments.length ? Array.prototype.slice.call(p, s) : Array.prototype.slice.call(p, s, h);
  }, goog.array.removeDuplicates = function(p, s, h) {
    s = s || p;
    var c = function(_) {
      return goog.isObject(_) ? "o" + goog.getUid(_) : (typeof _).charAt(0) + _;
    };
    h = h || c, c = {};
    for (var d = 0, l = 0; l < p.length; ) {
      var g = p[l++], f = h(g);
      Object.prototype.hasOwnProperty.call(c, f) || (c[f] = !0, s[d++] = g);
    }
    s.length = d;
  }, goog.array.binarySearch = function(p, s, h) {
    return goog.array.binarySearch_(p, h || goog.array.defaultCompare, !1, s);
  }, goog.array.binarySelect = function(p, s, h) {
    return goog.array.binarySearch_(p, s, !0, void 0, h);
  }, goog.array.binarySearch_ = function(p, s, h, c, d) {
    for (var l = 0, g = p.length, f; l < g; ) {
      var _ = l + (g - l >>> 1), te = h ? s.call(d, p[_], _, p) : s(c, p[_]);
      0 < te ? l = _ + 1 : (g = _, f = !te);
    }
    return f ? l : -l - 1;
  }, goog.array.sort = function(p, s) {
    p.sort(s || goog.array.defaultCompare);
  }, goog.array.stableSort = function(p, s) {
    for (var h = Array(p.length), c = 0; c < p.length; c++) h[c] = { index: c, value: p[c] };
    var d = s || goog.array.defaultCompare;
    for (goog.array.sort(h, function(l, g) {
      return d(l.value, g.value) || l.index - g.index;
    }), c = 0; c < p.length; c++) p[c] = h[c].value;
  }, goog.array.sortByKey = function(p, s, h) {
    var c = h || goog.array.defaultCompare;
    goog.array.sort(p, function(d, l) {
      return c(s(d), s(l));
    });
  }, goog.array.sortObjectsByKey = function(p, s, h) {
    goog.array.sortByKey(p, function(c) {
      return c[s];
    }, h);
  }, goog.array.isSorted = function(p, s, h) {
    s = s || goog.array.defaultCompare;
    for (var c = 1; c < p.length; c++) {
      var d = s(p[c - 1], p[c]);
      if (0 < d || d == 0 && h) return !1;
    }
    return !0;
  }, goog.array.equals = function(p, s, h) {
    if (!goog.isArrayLike(p) || !goog.isArrayLike(s) || p.length != s.length) return !1;
    var c = p.length;
    h = h || goog.array.defaultCompareEquality;
    for (var d = 0; d < c; d++) if (!h(p[d], s[d])) return !1;
    return !0;
  }, goog.array.compare3 = function(p, s, h) {
    h = h || goog.array.defaultCompare;
    for (var c = Math.min(p.length, s.length), d = 0; d < c; d++) {
      var l = h(p[d], s[d]);
      if (l != 0) return l;
    }
    return goog.array.defaultCompare(p.length, s.length);
  }, goog.array.defaultCompare = function(p, s) {
    return p > s ? 1 : p < s ? -1 : 0;
  }, goog.array.inverseDefaultCompare = function(p, s) {
    return -goog.array.defaultCompare(p, s);
  }, goog.array.defaultCompareEquality = function(p, s) {
    return p === s;
  }, goog.array.binaryInsert = function(p, s, h) {
    return h = goog.array.binarySearch(p, s, h), 0 > h ? (goog.array.insertAt(p, s, -(h + 1)), !0) : !1;
  }, goog.array.binaryRemove = function(p, s, h) {
    return s = goog.array.binarySearch(p, s, h), 0 <= s ? goog.array.removeAt(p, s) : !1;
  }, goog.array.bucket = function(p, s, h) {
    for (var c = {}, d = 0; d < p.length; d++) {
      var l = p[d], g = s.call(h, l, d, p);
      g !== void 0 && (c[g] || (c[g] = [])).push(l);
    }
    return c;
  }, goog.array.toObject = function(p, s, h) {
    var c = {};
    return goog.array.forEach(p, function(d, l) {
      c[s.call(h, d, l, p)] = d;
    }), c;
  }, goog.array.range = function(p, s, h) {
    var c = [], d = 0, l = p;
    if (h = h || 1, s !== void 0 && (d = p, l = s), 0 > h * (l - d)) return [];
    if (0 < h) for (p = d; p < l; p += h) c.push(p);
    else for (p = d; p > l; p += h) c.push(p);
    return c;
  }, goog.array.repeat = function(p, s) {
    for (var h = [], c = 0; c < s; c++) h[c] = p;
    return h;
  }, goog.array.flatten = function(p) {
    for (var s = [], h = 0; h < arguments.length; h++) {
      var c = arguments[h];
      if (Array.isArray(c)) for (var d = 0; d < c.length; d += 8192) {
        var l = goog.array.slice(c, d, d + 8192);
        l = goog.array.flatten.apply(null, l);
        for (var g = 0; g < l.length; g++) s.push(l[g]);
      }
      else s.push(c);
    }
    return s;
  }, goog.array.rotate = function(p, s) {
    return goog.asserts.assert(p.length != null), p.length && (s %= p.length, 0 < s ? Array.prototype.unshift.apply(p, p.splice(-s, s)) : 0 > s && Array.prototype.push.apply(p, p.splice(0, -s))), p;
  }, goog.array.moveItem = function(p, s, h) {
    goog.asserts.assert(0 <= s && s < p.length), goog.asserts.assert(0 <= h && h < p.length), s = Array.prototype.splice.call(p, s, 1), Array.prototype.splice.call(p, h, 0, s[0]);
  }, goog.array.zip = function(p) {
    if (!arguments.length) return [];
    for (var s = [], h = arguments[0].length, c = 1; c < arguments.length; c++) arguments[c].length < h && (h = arguments[c].length);
    for (c = 0; c < h; c++) {
      for (var d = [], l = 0; l < arguments.length; l++) d.push(arguments[l][c]);
      s.push(d);
    }
    return s;
  }, goog.array.shuffle = function(p, s) {
    s = s || Math.random;
    for (var h = p.length - 1; 0 < h; h--) {
      var c = Math.floor(s() * (h + 1)), d = p[h];
      p[h] = p[c], p[c] = d;
    }
  }, goog.array.copyByIndex = function(p, s) {
    var h = [];
    return goog.array.forEach(s, function(c) {
      h.push(p[c]);
    }), h;
  }, goog.array.concatMap = function(p, s, h) {
    return goog.array.concat.apply([], goog.array.map(p, s, h));
  }, goog.crypt = {}, goog.crypt.stringToByteArray = function(p) {
    for (var s = [], h = 0, c = 0; c < p.length; c++) {
      var d = p.charCodeAt(c);
      255 < d && (s[h++] = d & 255, d >>= 8), s[h++] = d;
    }
    return s;
  }, goog.crypt.byteArrayToString = function(p) {
    if (8192 >= p.length) return String.fromCharCode.apply(null, p);
    for (var s = "", h = 0; h < p.length; h += 8192) {
      var c = goog.array.slice(p, h, h + 8192);
      s += String.fromCharCode.apply(null, c);
    }
    return s;
  }, goog.crypt.byteArrayToHex = function(p, s) {
    return goog.array.map(p, function(h) {
      return h = h.toString(16), 1 < h.length ? h : "0" + h;
    }).join(s || "");
  }, goog.crypt.hexToByteArray = function(p) {
    goog.asserts.assert(p.length % 2 == 0, "Key string length must be multiple of 2");
    for (var s = [], h = 0; h < p.length; h += 2) s.push(parseInt(p.substring(h, h + 2), 16));
    return s;
  }, goog.crypt.stringToUtf8ByteArray = function(p) {
    for (var s = [], h = 0, c = 0; c < p.length; c++) {
      var d = p.charCodeAt(c);
      128 > d ? s[h++] = d : (2048 > d ? s[h++] = d >> 6 | 192 : ((d & 64512) == 55296 && c + 1 < p.length && (p.charCodeAt(c + 1) & 64512) == 56320 ? (d = 65536 + ((d & 1023) << 10) + (p.charCodeAt(++c) & 1023), s[h++] = d >> 18 | 240, s[h++] = d >> 12 & 63 | 128) : s[h++] = d >> 12 | 224, s[h++] = d >> 6 & 63 | 128), s[h++] = d & 63 | 128);
    }
    return s;
  }, goog.crypt.utf8ByteArrayToString = function(p) {
    for (var s = [], h = 0, c = 0; h < p.length; ) {
      var d = p[h++];
      if (128 > d) s[c++] = String.fromCharCode(d);
      else if (191 < d && 224 > d) {
        var l = p[h++];
        s[c++] = String.fromCharCode((d & 31) << 6 | l & 63);
      } else if (239 < d && 365 > d) {
        l = p[h++];
        var g = p[h++], f = p[h++];
        d = ((d & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | f & 63) - 65536, s[c++] = String.fromCharCode(55296 + (d >> 10)), s[c++] = String.fromCharCode(56320 + (d & 1023));
      } else l = p[h++], g = p[h++], s[c++] = String.fromCharCode((d & 15) << 12 | (l & 63) << 6 | g & 63);
    }
    return s.join("");
  }, goog.crypt.xorByteArray = function(p, s) {
    goog.asserts.assert(p.length == s.length, "XOR array lengths must match");
    for (var h = [], c = 0; c < p.length; c++) h.push(p[c] ^ s[c]);
    return h;
  }, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(p) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var s = goog.dom.asserts.getWindow_(p);
      s && (!p || !(p instanceof s.Location) && p instanceof s.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(p));
    }
    return p;
  }, goog.dom.asserts.assertIsElementType_ = function(p, s) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var h = goog.dom.asserts.getWindow_(p);
      h && typeof h[s] != "undefined" && (p && (p instanceof h[s] || !(p instanceof h.Location || p instanceof h.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", s, goog.dom.asserts.debugStringForType_(p)));
    }
    return p;
  }, goog.dom.asserts.assertIsHTMLAnchorElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLAnchorElement");
  }, goog.dom.asserts.assertIsHTMLButtonElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLButtonElement");
  }, goog.dom.asserts.assertIsHTMLLinkElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLLinkElement");
  }, goog.dom.asserts.assertIsHTMLImageElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLImageElement");
  }, goog.dom.asserts.assertIsHTMLAudioElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLAudioElement");
  }, goog.dom.asserts.assertIsHTMLVideoElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLVideoElement");
  }, goog.dom.asserts.assertIsHTMLInputElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLInputElement");
  }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLTextAreaElement");
  }, goog.dom.asserts.assertIsHTMLCanvasElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLCanvasElement");
  }, goog.dom.asserts.assertIsHTMLEmbedElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLEmbedElement");
  }, goog.dom.asserts.assertIsHTMLFormElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLFormElement");
  }, goog.dom.asserts.assertIsHTMLFrameElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLFrameElement");
  }, goog.dom.asserts.assertIsHTMLIFrameElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLIFrameElement");
  }, goog.dom.asserts.assertIsHTMLObjectElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLObjectElement");
  }, goog.dom.asserts.assertIsHTMLScriptElement = function(p) {
    return goog.dom.asserts.assertIsElementType_(p, "HTMLScriptElement");
  }, goog.dom.asserts.debugStringForType_ = function(p) {
    if (goog.isObject(p)) try {
      return p.constructor.displayName || p.constructor.name || Object.prototype.toString.call(p);
    } catch (s) {
      return "<object could not be stringified>";
    }
    else return p === void 0 ? "undefined" : p === null ? "null" : typeof p;
  }, goog.dom.asserts.getWindow_ = function(p) {
    try {
      var s = p && p.ownerDocument, h = s && (s.defaultView || s.parentWindow);
      if (h = h || goog.global, h.Element && h.Location) return h;
    } catch (c) {
    }
    return null;
  }, goog.functions = {}, goog.functions.constant = function(p) {
    return function() {
      return p;
    };
  }, goog.functions.FALSE = function() {
    return !1;
  }, goog.functions.TRUE = function() {
    return !0;
  }, goog.functions.NULL = function() {
    return null;
  }, goog.functions.identity = function(p, s) {
    return p;
  }, goog.functions.error = function(p) {
    return function() {
      throw Error(p);
    };
  }, goog.functions.fail = function(p) {
    return function() {
      throw p;
    };
  }, goog.functions.lock = function(p, s) {
    return s = s || 0, function() {
      return p.apply(this, Array.prototype.slice.call(arguments, 0, s));
    };
  }, goog.functions.nth = function(p) {
    return function() {
      return arguments[p];
    };
  }, goog.functions.partialRight = function(p, s) {
    var h = Array.prototype.slice.call(arguments, 1);
    return function() {
      var c = Array.prototype.slice.call(arguments);
      return c.push.apply(c, h), p.apply(this, c);
    };
  }, goog.functions.withReturnValue = function(p, s) {
    return goog.functions.sequence(p, goog.functions.constant(s));
  }, goog.functions.equalTo = function(p, s) {
    return function(h) {
      return s ? p == h : p === h;
    };
  }, goog.functions.compose = function(p, s) {
    var h = arguments, c = h.length;
    return function() {
      var d;
      c && (d = h[c - 1].apply(this, arguments));
      for (var l = c - 2; 0 <= l; l--) d = h[l].call(this, d);
      return d;
    };
  }, goog.functions.sequence = function(p) {
    var s = arguments, h = s.length;
    return function() {
      for (var c, d = 0; d < h; d++) c = s[d].apply(this, arguments);
      return c;
    };
  }, goog.functions.and = function(p) {
    var s = arguments, h = s.length;
    return function() {
      for (var c = 0; c < h; c++) if (!s[c].apply(this, arguments)) return !1;
      return !0;
    };
  }, goog.functions.or = function(p) {
    var s = arguments, h = s.length;
    return function() {
      for (var c = 0; c < h; c++) if (s[c].apply(this, arguments)) return !0;
      return !1;
    };
  }, goog.functions.not = function(p) {
    return function() {
      return !p.apply(this, arguments);
    };
  }, goog.functions.create = function(p, s) {
    var h = function() {
    };
    return h.prototype = p.prototype, h = new h(), p.apply(h, Array.prototype.slice.call(arguments, 1)), h;
  }, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function(p) {
    var s = !1, h;
    return function() {
      return goog.functions.CACHE_RETURN_VALUE ? (s || (h = p(), s = !0), h) : p();
    };
  }, goog.functions.once = function(p) {
    var s = p;
    return function() {
      if (s) {
        var h = s;
        s = null, h();
      }
    };
  }, goog.functions.debounce = function(p, s, h) {
    var c = 0;
    return function(d) {
      goog.global.clearTimeout(c);
      var l = arguments;
      c = goog.global.setTimeout(function() {
        p.apply(h, l);
      }, s);
    };
  }, goog.functions.throttle = function(p, s, h) {
    var c = 0, d = !1, l = [], g = function() {
      c = 0, d && (d = !1, f());
    }, f = function() {
      c = goog.global.setTimeout(g, s), p.apply(h, l);
    };
    return function(_) {
      l = arguments, c ? d = !0 : f();
    };
  }, goog.functions.rateLimit = function(p, s, h) {
    var c = 0, d = function() {
      c = 0;
    };
    return function(l) {
      c || (c = goog.global.setTimeout(d, s), p.apply(h, arguments));
    };
  }, goog.dom.HtmlElement = function() {
  }, goog.dom.TagName = function(p) {
    this.tagName_ = p;
  }, goog.dom.TagName.prototype.toString = function() {
    return this.tagName_;
  }, goog.dom.TagName.A = new goog.dom.TagName("A"), goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR"), goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM"), goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS"), goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET"), goog.dom.TagName.AREA = new goog.dom.TagName("AREA"), goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE"), goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE"), goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO"), goog.dom.TagName.B = new goog.dom.TagName("B"), goog.dom.TagName.BASE = new goog.dom.TagName("BASE"), goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT"), goog.dom.TagName.BDI = new goog.dom.TagName("BDI"), goog.dom.TagName.BDO = new goog.dom.TagName("BDO"), goog.dom.TagName.BIG = new goog.dom.TagName("BIG"), goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE"), goog.dom.TagName.BODY = new goog.dom.TagName("BODY"), goog.dom.TagName.BR = new goog.dom.TagName("BR"), goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON"), goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS"), goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION"), goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER"), goog.dom.TagName.CITE = new goog.dom.TagName("CITE"), goog.dom.TagName.CODE = new goog.dom.TagName("CODE"), goog.dom.TagName.COL = new goog.dom.TagName("COL"), goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP"), goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND"), goog.dom.TagName.DATA = new goog.dom.TagName("DATA"), goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST"), goog.dom.TagName.DD = new goog.dom.TagName("DD"), goog.dom.TagName.DEL = new goog.dom.TagName("DEL"), goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS"), goog.dom.TagName.DFN = new goog.dom.TagName("DFN"), goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG"), goog.dom.TagName.DIR = new goog.dom.TagName("DIR"), goog.dom.TagName.DIV = new goog.dom.TagName("DIV"), goog.dom.TagName.DL = new goog.dom.TagName("DL"), goog.dom.TagName.DT = new goog.dom.TagName("DT"), goog.dom.TagName.EM = new goog.dom.TagName("EM"), goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED"), goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET"), goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION"), goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE"), goog.dom.TagName.FONT = new goog.dom.TagName("FONT"), goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER"), goog.dom.TagName.FORM = new goog.dom.TagName("FORM"), goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME"), goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET"), goog.dom.TagName.H1 = new goog.dom.TagName("H1"), goog.dom.TagName.H2 = new goog.dom.TagName("H2"), goog.dom.TagName.H3 = new goog.dom.TagName("H3"), goog.dom.TagName.H4 = new goog.dom.TagName("H4"), goog.dom.TagName.H5 = new goog.dom.TagName("H5"), goog.dom.TagName.H6 = new goog.dom.TagName("H6"), goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD"), goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER"), goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP"), goog.dom.TagName.HR = new goog.dom.TagName("HR"), goog.dom.TagName.HTML = new goog.dom.TagName("HTML"), goog.dom.TagName.I = new goog.dom.TagName("I"), goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME"), goog.dom.TagName.IMG = new goog.dom.TagName("IMG"), goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT"), goog.dom.TagName.INS = new goog.dom.TagName("INS"), goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX"), goog.dom.TagName.KBD = new goog.dom.TagName("KBD"), goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN"), goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL"), goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND"), goog.dom.TagName.LI = new goog.dom.TagName("LI"), goog.dom.TagName.LINK = new goog.dom.TagName("LINK"), goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN"), goog.dom.TagName.MAP = new goog.dom.TagName("MAP"), goog.dom.TagName.MARK = new goog.dom.TagName("MARK"), goog.dom.TagName.MATH = new goog.dom.TagName("MATH"), goog.dom.TagName.MENU = new goog.dom.TagName("MENU"), goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM"), goog.dom.TagName.META = new goog.dom.TagName("META"), goog.dom.TagName.METER = new goog.dom.TagName("METER"), goog.dom.TagName.NAV = new goog.dom.TagName("NAV"), goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES"), goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT"), goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT"), goog.dom.TagName.OL = new goog.dom.TagName("OL"), goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP"), goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION"), goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT"), goog.dom.TagName.P = new goog.dom.TagName("P"), goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM"), goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE"), goog.dom.TagName.PRE = new goog.dom.TagName("PRE"), goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS"), goog.dom.TagName.Q = new goog.dom.TagName("Q"), goog.dom.TagName.RP = new goog.dom.TagName("RP"), goog.dom.TagName.RT = new goog.dom.TagName("RT"), goog.dom.TagName.RTC = new goog.dom.TagName("RTC"), goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY"), goog.dom.TagName.S = new goog.dom.TagName("S"), goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP"), goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT"), goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION"), goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT"), goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL"), goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE"), goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN"), goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE"), goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG"), goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE"), goog.dom.TagName.SUB = new goog.dom.TagName("SUB"), goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY"), goog.dom.TagName.SUP = new goog.dom.TagName("SUP"), goog.dom.TagName.SVG = new goog.dom.TagName("SVG"), goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE"), goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY"), goog.dom.TagName.TD = new goog.dom.TagName("TD"), goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE"), goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA"), goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT"), goog.dom.TagName.TH = new goog.dom.TagName("TH"), goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD"), goog.dom.TagName.TIME = new goog.dom.TagName("TIME"), goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE"), goog.dom.TagName.TR = new goog.dom.TagName("TR"), goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK"), goog.dom.TagName.TT = new goog.dom.TagName("TT"), goog.dom.TagName.U = new goog.dom.TagName("U"), goog.dom.TagName.UL = new goog.dom.TagName("UL"), goog.dom.TagName.VAR = new goog.dom.TagName("VAR"), goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO"), goog.dom.TagName.WBR = new goog.dom.TagName("WBR"), goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = { area: !0, base: !0, br: !0, col: !0, command: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, goog.dom.tags.isVoidTag = function(p) {
    return goog.dom.tags.VOID_TAGS_[p] === !0;
  }, goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null, goog.string = {}, goog.string.TypedString = function() {
  }, goog.string.Const = function(p, s) {
    this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = p === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && s || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
  }, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function() {
    return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
  }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
    return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
  }), goog.string.Const.unwrap = function(p) {
    return p instanceof goog.string.Const && p.constructor === goog.string.Const && p.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? p.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + p + "'"), "type_error:Const");
  }, goog.string.Const.from = function(p) {
    return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, p);
  }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.html.SafeScript = function() {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "", this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0, goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeScript.fromConstant = function(p) {
    return p = goog.string.Const.unwrap(p), p.length === 0 ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeScript.fromConstantAndArgs = function(p, s) {
    for (var h = [], c = 1; c < arguments.length; c++) h.push(goog.html.SafeScript.stringify_(arguments[c]));
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(p) + ")(" + h.join(", ") + ");");
  }, goog.html.SafeScript.fromJson = function(p) {
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(p));
  }, goog.html.SafeScript.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
  }, goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
    return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
  }), goog.html.SafeScript.unwrap = function(p) {
    return goog.html.SafeScript.unwrapTrustedScript(p).toString();
  }, goog.html.SafeScript.unwrapTrustedScript = function(p) {
    return p instanceof goog.html.SafeScript && p.constructor === goog.html.SafeScript && p.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? p.privateDoNotAccessOrElseSafeScriptWrappedValue_ : (goog.asserts.fail("expected object of type SafeScript, got '" + p + "' of type " + goog.typeOf(p)), "type_error:SafeScript");
  }, goog.html.SafeScript.stringify_ = function(p) {
    return JSON.stringify(p).replace(/</g, "\\x3c");
  }, goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(p) {
    return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(p);
  }, goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(p) {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(p) : p, this;
  }, goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(""), goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(p) {
    return goog.fs.url.getUrlObject_().createObjectURL(p);
  }, goog.fs.url.revokeObjectUrl = function(p) {
    goog.fs.url.getUrlObject_().revokeObjectURL(p);
  }, goog.fs.url.UrlObject_ = function() {
  }, goog.fs.url.UrlObject_.prototype.createObjectURL = function(p) {
  }, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(p) {
  }, goog.fs.url.getUrlObject_ = function() {
    var p = goog.fs.url.findUrlObject_();
    if (p != null) return p;
    throw Error("This browser doesn't seem to support blob URLs");
  }, goog.fs.url.findUrlObject_ = function() {
    return goog.global.URL !== void 0 && goog.global.URL.createObjectURL !== void 0 ? goog.global.URL : goog.global.webkitURL !== void 0 && goog.global.webkitURL.createObjectURL !== void 0 ? goog.global.webkitURL : goog.global.createObjectURL !== void 0 ? goog.global : null;
  }, goog.fs.url.browserSupportsObjectUrls = function() {
    return goog.fs.url.findUrlObject_() != null;
  }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(p) {
    var s = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
    if (s !== void 0) {
      s = new s();
      for (var h = 0; h < arguments.length; h++) s.append(arguments[h]);
      return s.getBlob();
    }
    return goog.fs.blob.getBlobWithProperties(goog.array.toArray(arguments));
  }, goog.fs.blob.getBlobWithProperties = function(p, s, h) {
    var c = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
    if (c !== void 0) {
      c = new c();
      for (var d = 0; d < p.length; d++) c.append(p[d], h);
      return c.getBlob(s);
    }
    if (goog.global.Blob !== void 0) return c = {}, s && (c.type = s), h && (c.endings = h), new Blob(p, c);
    throw Error("This browser doesn't seem to support creating Blobs");
  }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(
    3,
    7
  ).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa"), goog.i18n.bidi.Format = { LRE: "‪", RLE: "‫", PDF: "‬", LRM: "‎", RLM: "‏" }, goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(p, s) {
    return typeof p == "number" ? 0 < p ? goog.i18n.bidi.Dir.LTR : 0 > p ? goog.i18n.bidi.Dir.RTL : s ? null : goog.i18n.bidi.Dir.NEUTRAL : p == null ? null : p ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  }, goog.i18n.bidi.ltrChars_ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-﬜︀-﹯﻽-￿", goog.i18n.bidi.rtlChars_ = "֑-ۯۺ-ࣿ‏\uD802-\uD803\uD83A-\uD83Bיִ-﷿ﹰ-ﻼ", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(p, s) {
    return s ? p.replace(goog.i18n.bidi.htmlSkipReg_, "") : p;
  }, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function(p, s) {
    return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(p, s));
  }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(p, s) {
    return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(p, s));
  }, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function(p) {
    return goog.i18n.bidi.rtlRe_.test(p);
  }, goog.i18n.bidi.isLtrChar = function(p) {
    return goog.i18n.bidi.ltrRe_.test(p);
  }, goog.i18n.bidi.isNeutralChar = function(p) {
    return !goog.i18n.bidi.isLtrChar(p) && !goog.i18n.bidi.isRtlChar(p);
  }, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function(p, s) {
    return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(p, s));
  }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(p, s) {
    return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(p, s));
  }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(p, s) {
    return p = goog.i18n.bidi.stripHtmlIfNeeded_(p, s), goog.i18n.bidi.isRequiredLtrRe_.test(p) || !goog.i18n.bidi.hasAnyLtr(p) && !goog.i18n.bidi.hasAnyRtl(p);
  }, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function(p, s) {
    return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(p, s));
  }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(p, s) {
    return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(p, s));
  }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(p) {
    return goog.i18n.bidi.rtlLocalesRe_.test(p);
  }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(p, s) {
    return s = (s === void 0 ? goog.i18n.bidi.hasAnyRtl(p) : s) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, p.replace(goog.i18n.bidi.bracketGuardTextRe_, s + "$&" + s);
  }, goog.i18n.bidi.enforceRtlInHtml = function(p) {
    return p.charAt(0) == "<" ? p.replace(/<\w+/, "$& dir=rtl") : `
<span dir=rtl>` + p + "</span>";
  }, goog.i18n.bidi.enforceRtlInText = function(p) {
    return goog.i18n.bidi.Format.RLE + p + goog.i18n.bidi.Format.PDF;
  }, goog.i18n.bidi.enforceLtrInHtml = function(p) {
    return p.charAt(0) == "<" ? p.replace(/<\w+/, "$& dir=ltr") : `
<span dir=ltr>` + p + "</span>";
  }, goog.i18n.bidi.enforceLtrInText = function(p) {
    return goog.i18n.bidi.Format.LRE + p + goog.i18n.bidi.Format.PDF;
  }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(p) {
    return p.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
  }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(p) {
    return p.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
  }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function(p, s) {
    var h = 0, c = 0, d = !1;
    for (p = goog.i18n.bidi.stripHtmlIfNeeded_(p, s).split(goog.i18n.bidi.wordSeparatorRe_), s = 0; s < p.length; s++) {
      var l = p[s];
      goog.i18n.bidi.startsWithRtl(l) ? (h++, c++) : goog.i18n.bidi.isRequiredLtrRe_.test(l) ? d = !0 : goog.i18n.bidi.hasAnyLtr(l) ? c++ : goog.i18n.bidi.hasNumeralsRe_.test(l) && (d = !0);
    }
    return c == 0 ? d ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : h / c > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  }, goog.i18n.bidi.detectRtlDirectionality = function(p, s) {
    return goog.i18n.bidi.estimateDirection(p, s) == goog.i18n.bidi.Dir.RTL;
  }, goog.i18n.bidi.setElementDirAndAlign = function(p, s) {
    p && (s = goog.i18n.bidi.toDir(s)) && (p.style.textAlign = s == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, p.dir = s == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
  }, goog.i18n.bidi.setElementDirByTextDirectionality = function(p, s) {
    switch (goog.i18n.bidi.estimateDirection(s)) {
      case goog.i18n.bidi.Dir.LTR:
        p.dir = "ltr";
        break;
      case goog.i18n.bidi.Dir.RTL:
        p.dir = "rtl";
        break;
      default:
        p.removeAttribute("dir");
    }
  }, goog.i18n.bidi.DirectionalString = function() {
  }, goog.html.TrustedResourceUrl = function(p, s) {
    this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = p === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && s || "", this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
  }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(p, s) {
    var h = goog.html.TrustedResourceUrl.unwrap(this);
    h = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(h);
    var c = h[3] || "";
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(h[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", h[2] || "", p) + goog.html.TrustedResourceUrl.stringifyParams_("#", c, s));
  }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
    return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
  }), goog.html.TrustedResourceUrl.unwrap = function(p) {
    return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(p).toString();
  }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(p) {
    return p instanceof goog.html.TrustedResourceUrl && p.constructor === goog.html.TrustedResourceUrl && p.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? p.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + p + "' of type " + goog.typeOf(p)), "type_error:TrustedResourceUrl");
  }, goog.html.TrustedResourceUrl.format = function(p, s) {
    var h = goog.string.Const.unwrap(p);
    if (!goog.html.TrustedResourceUrl.BASE_URL_.test(h)) throw Error("Invalid TrustedResourceUrl format: " + h);
    return p = h.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(c, d) {
      if (!Object.prototype.hasOwnProperty.call(s, d)) throw Error('Found marker, "' + d + '", in format string, "' + h + '", but no valid label mapping found in args: ' + JSON.stringify(s));
      return c = s[d], c instanceof goog.string.Const ? goog.string.Const.unwrap(c) : encodeURIComponent(String(c));
    }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(p, s, h, c) {
    return goog.html.TrustedResourceUrl.format(p, s).cloneWithParams(h, c);
  }, goog.html.TrustedResourceUrl.fromConstant = function(p) {
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(p));
  }, goog.html.TrustedResourceUrl.fromConstants = function(p) {
    for (var s = "", h = 0; h < p.length; h++) s += goog.string.Const.unwrap(p[h]);
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.TrustedResourceUrl.fromSafeScript = function(p) {
    return p = goog.fs.blob.getBlobWithProperties([goog.html.SafeScript.unwrap(p)], "text/javascript"), p = goog.fs.url.createObjectUrl(p), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(p) {
    return p = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(p) : p, new goog.html.TrustedResourceUrl(goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_, p);
  }, goog.html.TrustedResourceUrl.stringifyParams_ = function(p, s, h) {
    if (h == null) return s;
    if (typeof h == "string") return h ? p + encodeURIComponent(h) : "";
    for (var c in h) {
      var d = h[c];
      d = Array.isArray(d) ? d : [d];
      for (var l = 0; l < d.length; l++) {
        var g = d[l];
        g != null && (s || (s = p), s += (s.length > p.length ? "&" : "") + encodeURIComponent(c) + "=" + encodeURIComponent(String(g)));
      }
    }
    return s;
  }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.internal = {}, goog.string.internal.startsWith = function(p, s) {
    return p.lastIndexOf(s, 0) == 0;
  }, goog.string.internal.endsWith = function(p, s) {
    var h = p.length - s.length;
    return 0 <= h && p.indexOf(s, h) == h;
  }, goog.string.internal.caseInsensitiveStartsWith = function(p, s) {
    return goog.string.internal.caseInsensitiveCompare(s, p.substr(0, s.length)) == 0;
  }, goog.string.internal.caseInsensitiveEndsWith = function(p, s) {
    return goog.string.internal.caseInsensitiveCompare(s, p.substr(p.length - s.length, s.length)) == 0;
  }, goog.string.internal.caseInsensitiveEquals = function(p, s) {
    return p.toLowerCase() == s.toLowerCase();
  }, goog.string.internal.isEmptyOrWhitespace = function(p) {
    return /^[\s\xa0]*$/.test(p);
  }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(p) {
    return p.trim();
  } : function(p) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(p)[1];
  }, goog.string.internal.caseInsensitiveCompare = function(p, s) {
    return p = String(p).toLowerCase(), s = String(s).toLowerCase(), p < s ? -1 : p == s ? 0 : 1;
  }, goog.string.internal.newLineToBr = function(p, s) {
    return p.replace(/(\r\n|\r|\n)/g, s ? "<br />" : "<br>");
  }, goog.string.internal.htmlEscape = function(p, s) {
    if (s) p = p.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
    else {
      if (!goog.string.internal.ALL_RE_.test(p)) return p;
      p.indexOf("&") != -1 && (p = p.replace(goog.string.internal.AMP_RE_, "&amp;")), p.indexOf("<") != -1 && (p = p.replace(
        goog.string.internal.LT_RE_,
        "&lt;"
      )), p.indexOf(">") != -1 && (p = p.replace(goog.string.internal.GT_RE_, "&gt;")), p.indexOf('"') != -1 && (p = p.replace(goog.string.internal.QUOT_RE_, "&quot;")), p.indexOf("'") != -1 && (p = p.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), p.indexOf("\0") != -1 && (p = p.replace(goog.string.internal.NULL_RE_, "&#0;"));
    }
    return p;
  }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(p, s) {
    return goog.string.internal.newLineToBr(p.replace(/  /g, " &#160;"), s);
  }, goog.string.internal.contains = function(p, s) {
    return p.indexOf(s) != -1;
  }, goog.string.internal.caseInsensitiveContains = function(p, s) {
    return goog.string.internal.contains(p.toLowerCase(), s.toLowerCase());
  }, goog.string.internal.compareVersions = function(p, s) {
    var h = 0;
    p = goog.string.internal.trim(String(p)).split("."), s = goog.string.internal.trim(String(s)).split(".");
    for (var c = Math.max(p.length, s.length), d = 0; h == 0 && d < c; d++) {
      var l = p[d] || "", g = s[d] || "";
      do {
        if (l = /(\d*)(\D*)(.*)/.exec(l) || ["", "", "", ""], g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""], l[0].length == 0 && g[0].length == 0) break;
        h = l[1].length == 0 ? 0 : parseInt(l[1], 10);
        var f = g[1].length == 0 ? 0 : parseInt(g[1], 10);
        h = goog.string.internal.compareElements_(h, f) || goog.string.internal.compareElements_(l[2].length == 0, g[2].length == 0) || goog.string.internal.compareElements_(l[2], g[2]), l = l[3], g = g[3];
      } while (h == 0);
    }
    return h;
  }, goog.string.internal.compareElements_ = function(p, s) {
    return p < s ? -1 : p > s ? 1 : 0;
  }, goog.html.SafeUrl = function(p, s) {
    this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = p === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && s || "", this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
  }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
    return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
  }), goog.html.SafeUrl.unwrap = function(p) {
    return p instanceof goog.html.SafeUrl && p.constructor === goog.html.SafeUrl && p.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? p.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + p + "' of type " + goog.typeOf(p)), "type_error:SafeUrl");
  }, goog.html.SafeUrl.fromConstant = function(p) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(p));
  }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(p) {
    return goog.html.SAFE_MIME_TYPE_PATTERN_.test(p);
  }, goog.html.SafeUrl.fromBlob = function(p) {
    return p = goog.html.SafeUrl.isSafeMimeType(p.type) ? goog.fs.url.createObjectUrl(p) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeUrl.fromMediaSource = function(p) {
    return goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource"), p = p instanceof MediaSource ? goog.fs.url.createObjectUrl(p) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.fromDataUrl = function(p) {
    p = p.replace(/(%0A|%0D)/g, "");
    var s = p.match(goog.html.DATA_URL_PATTERN_);
    return s = s && goog.html.SafeUrl.isSafeMimeType(s[1]), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(s ? p : goog.html.SafeUrl.INNOCUOUS_STRING);
  }, goog.html.SafeUrl.fromTelUrl = function(p) {
    return goog.string.internal.caseInsensitiveStartsWith(p, "tel:") || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(p) {
    return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(p)) || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(p) {
    return goog.string.internal.caseInsensitiveStartsWith(p, "fb-messenger://share") || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeUrl.fromWhatsAppUrl = function(p) {
    return goog.string.internal.caseInsensitiveStartsWith(p, "whatsapp://send") || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeUrl.fromSmsUrl = function(p) {
    return goog.string.internal.caseInsensitiveStartsWith(p, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(p) || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(p) {
    var s = p.indexOf("#");
    if (0 < s && (p = p.substring(0, s)), s = p.match(/[?&]body=/gi), !s) return !0;
    if (1 < s.length) return !1;
    if (p = p.match(/[?&]body=([^&]*)/)[1], !p) return !0;
    try {
      decodeURIComponent(p);
    } catch (h) {
      return !1;
    }
    return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(p);
  }, goog.html.SafeUrl.fromSshUrl = function(p) {
    return goog.string.internal.caseInsensitiveStartsWith(p, "ssh://") || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(p, s) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, p, s);
  }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(p, s) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, p, s);
  }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(p, s) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, p, s);
  }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(p, s, h) {
    return (p = p.exec(s)) ? (p = p[1], (h instanceof goog.string.Const ? [goog.string.Const.unwrap(h)] : h.map(function(c) {
      return goog.string.Const.unwrap(c);
    })).indexOf(p) == -1 && (s = goog.html.SafeUrl.INNOCUOUS_STRING)) : s = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.SafeUrl.fromTrustedResourceUrl = function(p) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(p));
  }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.sanitize = function(p) {
    return p instanceof goog.html.SafeUrl ? p : (p = typeof p == "object" && p.implementsGoogStringTypedString ? p.getTypedStringValue() : String(p), goog.html.SAFE_URL_PATTERN_.test(p) || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p));
  }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(p, s) {
    return p instanceof goog.html.SafeUrl ? p : (p = typeof p == "object" && p.implementsGoogStringTypedString ? p.getTypedStringValue() : String(p), s && /^data:/i.test(p) && (s = goog.html.SafeUrl.fromDataUrl(p), s.getTypedStringValue() == p) ? s : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(p), "%s does not match the safe URL pattern", p) || (p = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(p)));
  }, goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(p) {
    return new goog.html.SafeUrl(goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_, p);
  }, goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle = function() {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "", this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyle.fromConstant = function(p) {
    return p = goog.string.Const.unwrap(p), p.length === 0 ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(p, ";"), "Last character of style string is not ';': " + p), goog.asserts.assert(goog.string.internal.contains(p, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + p), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(p));
  }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
  }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
    return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
  }), goog.html.SafeStyle.unwrap = function(p) {
    return p instanceof goog.html.SafeStyle && p.constructor === goog.html.SafeStyle && p.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? p.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + p + "' of type " + goog.typeOf(p)), "type_error:SafeStyle");
  }, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(p) {
    return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(p);
  }, goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(p) {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = p, this;
  }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function(p) {
    var s = "", h;
    for (h in p) {
      if (!/^[-_a-zA-Z0-9]+$/.test(h)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + h);
      var c = p[h];
      c != null && (c = Array.isArray(c) ? goog.array.map(c, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(c), s += h + ":" + c + ";");
    }
    return s ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(s) : goog.html.SafeStyle.EMPTY;
  }, goog.html.SafeStyle.sanitizePropertyValue_ = function(p) {
    if (p instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(p).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
    if (p = p instanceof goog.string.Const ? goog.string.Const.unwrap(p) : goog.html.SafeStyle.sanitizePropertyValueString_(String(p)), /[{;}]/.test(p)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [p]);
    return p;
  }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(p) {
    var s = p.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
    if (goog.html.SafeStyle.VALUE_RE_.test(s)) {
      if (goog.html.SafeStyle.COMMENT_RE_.test(p)) return goog.asserts.fail("String value disallows comments, got: " + p), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedQuotes_(p)) return goog.asserts.fail("String value requires balanced quotes, got: " + p), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(p)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + p), goog.html.SafeStyle.INNOCUOUS_STRING;
    } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + p), goog.html.SafeStyle.INNOCUOUS_STRING;
    return goog.html.SafeStyle.sanitizeUrl_(p);
  }, goog.html.SafeStyle.hasBalancedQuotes_ = function(p) {
    for (var s = !0, h = !0, c = 0; c < p.length; c++) {
      var d = p.charAt(c);
      d == "'" && h ? s = !s : d == '"' && s && (h = !h);
    }
    return s && h;
  }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(p) {
    for (var s = !0, h = /^[-_a-zA-Z0-9]$/, c = 0; c < p.length; c++) {
      var d = p.charAt(c);
      if (d == "]") {
        if (s) return !1;
        s = !0;
      } else if (d == "[") {
        if (!s) return !1;
        s = !1;
      } else if (!s && !h.test(d)) return !1;
    }
    return s;
  }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`, goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" "), goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g"), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(p) {
    return p.replace(goog.html.SafeStyle.URL_RE_, function(s, h, c, d) {
      var l = "";
      return c = c.replace(/^(['"])(.*)\1$/, function(g, f, _) {
        return l = f, _;
      }), s = goog.html.SafeUrl.sanitize(c).getTypedStringValue(), h + l + s + l + d;
    });
  }, goog.html.SafeStyle.concat = function(p) {
    var s = "", h = function(c) {
      Array.isArray(c) ? goog.array.forEach(c, h) : s += goog.html.SafeStyle.unwrap(c);
    };
    return goog.array.forEach(arguments, h), s ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(s) : goog.html.SafeStyle.EMPTY;
  }, goog.html.SafeStyleSheet = function() {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "", this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  }, goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyleSheet.createRule = function(p, s) {
    if (goog.string.internal.contains(p, "<")) throw Error("Selector does not allow '<', got: " + p);
    var h = p.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
    if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(h)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + p);
    if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(h)) throw Error("() and [] in selector must be balanced, got: " + p);
    return s instanceof goog.html.SafeStyle || (s = goog.html.SafeStyle.create(s)), p = p + "{" + goog.html.SafeStyle.unwrap(s).replace(/</g, "\\3C ") + "}", goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(p);
  }, goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(p) {
    for (var s = { "(": ")", "[": "]" }, h = [], c = 0; c < p.length; c++) {
      var d = p[c];
      if (s[d]) h.push(s[d]);
      else if (goog.object.contains(s, d) && h.pop() != d) return !1;
    }
    return h.length == 0;
  }, goog.html.SafeStyleSheet.concat = function(p) {
    var s = "", h = function(c) {
      Array.isArray(c) ? goog.array.forEach(c, h) : s += goog.html.SafeStyleSheet.unwrap(c);
    };
    return goog.array.forEach(arguments, h), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.SafeStyleSheet.fromConstant = function(p) {
    return p = goog.string.Const.unwrap(p), p.length === 0 ? goog.html.SafeStyleSheet.EMPTY : (goog.asserts.assert(!goog.string.internal.contains(p, "<"), "Forbidden '<' character in style sheet string: " + p), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(p));
  }, goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
  }, goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
    return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
  }), goog.html.SafeStyleSheet.unwrap = function(p) {
    return p instanceof goog.html.SafeStyleSheet && p.constructor === goog.html.SafeStyleSheet && p.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? p.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyleSheet, got '" + p + "' of type " + goog.typeOf(p)), "type_error:SafeStyleSheet");
  }, goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(p) {
    return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(p);
  }, goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(p) {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = p, this;
  }, goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
    var p = goog.labs.userAgent.util.getNavigator_();
    return p && (p = p.userAgent) ? p : "";
  }, goog.labs.userAgent.util.getNavigator_ = function() {
    return goog.global.navigator;
  }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(p) {
    goog.labs.userAgent.util.userAgent_ = p || goog.labs.userAgent.util.getNativeUserAgentString_();
  }, goog.labs.userAgent.util.getUserAgent = function() {
    return goog.labs.userAgent.util.userAgent_;
  }, goog.labs.userAgent.util.matchUserAgent = function(p) {
    var s = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.contains(s, p);
  }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(p) {
    var s = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.caseInsensitiveContains(s, p);
  }, goog.labs.userAgent.util.extractVersionTuples = function(p) {
    for (var s = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, h = [], c; c = s.exec(p); ) h.push([c[1], c[2], c[3] || void 0]);
    return h;
  }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Opera");
  }, goog.labs.userAgent.browser.matchIE_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edg/");
  }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("OPR");
  }, goog.labs.userAgent.browser.matchFirefox_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
  }, goog.labs.userAgent.browser.matchSafari_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
  }, goog.labs.userAgent.browser.matchCoast_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Coast");
  }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
  }, goog.labs.userAgent.browser.matchChrome_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
  }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
  }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
    return goog.labs.userAgent.util.matchUserAgent("Silk");
  }, goog.labs.userAgent.browser.getVersion = function() {
    function p(d) {
      return d = goog.array.find(d, c), h[d] || "";
    }
    var s = goog.labs.userAgent.util.getUserAgent();
    if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(s);
    s = goog.labs.userAgent.util.extractVersionTuples(s);
    var h = {};
    goog.array.forEach(s, function(d) {
      h[d[0]] = d[1];
    });
    var c = goog.partial(goog.object.containsKey, h);
    return goog.labs.userAgent.browser.isOpera() ? p(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? p(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? p(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? p(["Chrome", "CriOS", "HeadlessChrome"]) : (s = s[2]) && s[1] || "";
  }, goog.labs.userAgent.browser.isVersionOrHigher = function(p) {
    return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), p);
  }, goog.labs.userAgent.browser.getIEVersion_ = function(p) {
    var s = /rv: *([\d\.]*)/.exec(p);
    if (s && s[1]) return s[1];
    s = "";
    var h = /MSIE +([\d\.]+)/.exec(p);
    if (h && h[1]) if (p = /Trident\/(\d.\d)/.exec(p), h[1] == "7.0") if (p && p[1]) switch (p[1]) {
      case "4.0":
        s = "8.0";
        break;
      case "5.0":
        s = "9.0";
        break;
      case "6.0":
        s = "10.0";
        break;
      case "7.0":
        s = "11.0";
    }
    else s = "7.0";
    else s = h[1];
    return s;
  }, goog.html.SafeHtml = function() {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "", this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_, this.dir_ = null;
  }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function() {
    return this.dir_;
  }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
  }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
    return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
  }), goog.html.SafeHtml.unwrap = function(p) {
    return goog.html.SafeHtml.unwrapTrustedHTML(p).toString();
  }, goog.html.SafeHtml.unwrapTrustedHTML = function(p) {
    return p instanceof goog.html.SafeHtml && p.constructor === goog.html.SafeHtml && p.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? p.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + p + "' of type " + goog.typeOf(p)), "type_error:SafeHtml");
  }, goog.html.SafeHtml.htmlEscape = function(p) {
    if (p instanceof goog.html.SafeHtml) return p;
    var s = typeof p == "object", h = null;
    return s && p.implementsGoogI18nBidiDirectionalString && (h = p.getDirection()), p = s && p.implementsGoogStringTypedString ? p.getTypedStringValue() : String(p), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(p), h);
  }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(p) {
    return p instanceof goog.html.SafeHtml ? p : (p = goog.html.SafeHtml.htmlEscape(p), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(p)), p.getDirection()));
  }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(p) {
    return p instanceof goog.html.SafeHtml ? p : (p = goog.html.SafeHtml.htmlEscape(p), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(p)), p.getDirection()));
  }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(p) {
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(p) + "-->", null);
  }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: !0, cite: !0, data: !0, formaction: !0, href: !0, manifest: !0, poster: !0, src: !0 }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = { APPLET: !0, BASE: !0, EMBED: !0, IFRAME: !0, LINK: !0, MATH: !0, META: !0, OBJECT: !0, SCRIPT: !0, STYLE: !0, SVG: !0, TEMPLATE: !0 }, goog.html.SafeHtml.create = function(p, s, h) {
    return goog.html.SafeHtml.verifyTagName(String(p)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(p), s, h);
  }, goog.html.SafeHtml.verifyTagName = function(p) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(p)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + p + ">." : "");
    if (p.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + p + "> is not allowed for SafeHtml." : "");
  }, goog.html.SafeHtml.createIframe = function(p, s, h, c) {
    p && goog.html.TrustedResourceUrl.unwrap(p);
    var d = {};
    return d.src = p || null, d.srcdoc = s && goog.html.SafeHtml.unwrap(s), p = goog.html.SafeHtml.combineAttributes(d, { sandbox: "" }, h), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", p, c);
  }, goog.html.SafeHtml.createSandboxIframe = function(p, s, h, c) {
    if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
    var d = {};
    return d.src = p ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(p)) : null, d.srcdoc = s || null, d.sandbox = "", p = goog.html.SafeHtml.combineAttributes(d, {}, h), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", p, c);
  }, goog.html.SafeHtml.canUseSandboxIframe = function() {
    return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
  }, goog.html.SafeHtml.createScriptSrc = function(p, s) {
    return goog.html.TrustedResourceUrl.unwrap(p), p = goog.html.SafeHtml.combineAttributes({ src: p }, {}, s), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", p);
  }, goog.html.SafeHtml.createScript = function(p, s) {
    for (var h in s) {
      var c = h.toLowerCase();
      if (c == "language" || c == "src" || c == "text" || c == "type") throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + c + '" attribute' : "");
    }
    for (h = "", p = goog.array.concat(p), c = 0; c < p.length; c++) h += goog.html.SafeScript.unwrap(p[c]);
    return p = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(h, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", s, p);
  }, goog.html.SafeHtml.createStyle = function(p, s) {
    s = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, s);
    var h = "";
    p = goog.array.concat(p);
    for (var c = 0; c < p.length; c++) h += goog.html.SafeStyleSheet.unwrap(p[c]);
    return p = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(h, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", s, p);
  }, goog.html.SafeHtml.createMetaRefresh = function(p, s) {
    return p = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(p)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(p, ";") && (p = "'" + p.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", { "http-equiv": "refresh", content: (s || 0) + "; url=" + p });
  }, goog.html.SafeHtml.getAttrNameAndValue_ = function(p, s, h) {
    if (h instanceof goog.string.Const) h = goog.string.Const.unwrap(h);
    else if (s.toLowerCase() == "style") if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) h = goog.html.SafeHtml.getStyleValue_(h);
    else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
    else {
      if (/^on/i.test(s)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + s + '" requires goog.string.Const value, "' + h + '" given.' : "");
      if (s.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (h instanceof goog.html.TrustedResourceUrl) h = goog.html.TrustedResourceUrl.unwrap(h);
      else if (h instanceof goog.html.SafeUrl) h = goog.html.SafeUrl.unwrap(h);
      else if (typeof h == "string") h = goog.html.SafeUrl.sanitize(h).getTypedStringValue();
      else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + s + '" on tag "' + p + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + h + '" given.' : "");
    }
    return h.implementsGoogStringTypedString && (h = h.getTypedStringValue()), goog.asserts.assert(typeof h == "string" || typeof h == "number", "String or number value expected, got " + typeof h + " with value: " + h), s + '="' + goog.string.internal.htmlEscape(String(h)) + '"';
  }, goog.html.SafeHtml.getStyleValue_ = function(p) {
    if (!goog.isObject(p)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof p + " given: " + p : "");
    return p instanceof goog.html.SafeStyle || (p = goog.html.SafeStyle.create(p)), goog.html.SafeStyle.unwrap(p);
  }, goog.html.SafeHtml.createWithDir = function(p, s, h, c) {
    return s = goog.html.SafeHtml.create(s, h, c), s.dir_ = p, s;
  }, goog.html.SafeHtml.join = function(p, s) {
    p = goog.html.SafeHtml.htmlEscape(p);
    var h = p.getDirection(), c = [], d = function(l) {
      Array.isArray(l) ? goog.array.forEach(l, d) : (l = goog.html.SafeHtml.htmlEscape(l), c.push(goog.html.SafeHtml.unwrap(l)), l = l.getDirection(), h == goog.i18n.bidi.Dir.NEUTRAL ? h = l : l != goog.i18n.bidi.Dir.NEUTRAL && h != l && (h = null));
    };
    return goog.array.forEach(s, d), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c.join(goog.html.SafeHtml.unwrap(p)), h);
  }, goog.html.SafeHtml.concat = function(p) {
    return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
  }, goog.html.SafeHtml.concatWithDir = function(p, s) {
    var h = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
    return h.dir_ = p, h;
  }, goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(p, s) {
    return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(p, s);
  }, goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(p, s) {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(p) : p, this.dir_ = s, this;
  }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(p, s, h) {
    var c = null, d = "<" + p + goog.html.SafeHtml.stringifyAttributes(p, s);
    return h == null ? h = [] : Array.isArray(h) || (h = [h]), goog.dom.tags.isVoidTag(p.toLowerCase()) ? (goog.asserts.assert(!h.length, "Void tag <" + p + "> does not allow content."), d += ">") : (c = goog.html.SafeHtml.concat(h), d += ">" + goog.html.SafeHtml.unwrap(c) + "</" + p + ">", c = c.getDirection()), (p = s && s.dir) && (c = /^(ltr|rtl|auto)$/i.test(p) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(
      d,
      c
    );
  }, goog.html.SafeHtml.stringifyAttributes = function(p, s) {
    var h = "";
    if (s) for (var c in s) {
      if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(c)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + c + '".' : "");
      var d = s[c];
      d != null && (h += " " + goog.html.SafeHtml.getAttrNameAndValue_(p, c, d));
    }
    return h;
  }, goog.html.SafeHtml.combineAttributes = function(p, s, h) {
    var c = {}, d;
    for (d in p) goog.asserts.assert(d.toLowerCase() == d, "Must be lower case"), c[d] = p[d];
    for (d in s) goog.asserts.assert(d.toLowerCase() == d, "Must be lower case"), c[d] = s[d];
    if (h) for (d in h) {
      var l = d.toLowerCase();
      if (l in p) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + l + '" attribute, got "' + d + '" with value "' + h[d] + '"' : "");
      l in s && delete c[l], c[d] = h[d];
    }
    return c;
  }, goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(p, s, h) {
    return goog.asserts.assertString(goog.string.Const.unwrap(p), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(p)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(s, h || null);
  }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(p, s) {
    return goog.asserts.assertString(goog.string.Const.unwrap(p), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(p)), "must provide non-empty justification"), goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(p, s) {
    return goog.asserts.assertString(goog.string.Const.unwrap(p), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(p)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(p, s) {
    return goog.asserts.assertString(goog.string.Const.unwrap(p), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(p)), "must provide non-empty justification"), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(p, s) {
    return goog.asserts.assertString(goog.string.Const.unwrap(p), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(p)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(s);
  }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(p, s) {
    return goog.asserts.assertString(goog.string.Const.unwrap(p), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(p)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(s);
  }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: "afterbegin", AFTEREND: "afterend", BEFOREBEGIN: "beforebegin", BEFOREEND: "beforeend" }, goog.dom.safe.insertAdjacentHtml = function(p, s, h) {
    p.insertAdjacentHTML(s, goog.html.SafeHtml.unwrapTrustedHTML(h));
  }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: !0, SCRIPT: !0, STYLE: !0, SVG: !0, TEMPLATE: !0 }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
    if (goog.DEBUG && typeof document == "undefined") return !1;
    var p = document.createElement("div"), s = document.createElement("div");
    return s.appendChild(document.createElement("div")), p.appendChild(s), goog.DEBUG && !p.firstChild ? !1 : (s = p.firstChild.firstChild, p.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !s.parentElement);
  }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(p, s) {
    if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; p.lastChild; ) p.removeChild(p.lastChild);
    p.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(s);
  }, goog.dom.safe.setInnerHtml = function(p, s) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var h = p.tagName.toUpperCase();
      if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[h]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + p.tagName + ".");
    }
    goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(p, s);
  }, goog.dom.safe.setOuterHtml = function(p, s) {
    p.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(s);
  }, goog.dom.safe.setFormElementAction = function(p, s) {
    s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), goog.dom.asserts.assertIsHTMLFormElement(p).action = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setButtonFormAction = function(p, s) {
    s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), goog.dom.asserts.assertIsHTMLButtonElement(p).formAction = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setInputFormAction = function(p, s) {
    s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), goog.dom.asserts.assertIsHTMLInputElement(p).formAction = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setStyle = function(p, s) {
    p.style.cssText = goog.html.SafeStyle.unwrap(s);
  }, goog.dom.safe.documentWrite = function(p, s) {
    p.write(goog.html.SafeHtml.unwrapTrustedHTML(s));
  }, goog.dom.safe.setAnchorHref = function(p, s) {
    goog.dom.asserts.assertIsHTMLAnchorElement(p), s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), p.href = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setImageSrc = function(p, s) {
    if (goog.dom.asserts.assertIsHTMLImageElement(p), !(s instanceof goog.html.SafeUrl)) {
      var h = /^data:image\//i.test(s);
      s = goog.html.SafeUrl.sanitizeAssertUnchanged(s, h);
    }
    p.src = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setAudioSrc = function(p, s) {
    if (goog.dom.asserts.assertIsHTMLAudioElement(p), !(s instanceof goog.html.SafeUrl)) {
      var h = /^data:audio\//i.test(s);
      s = goog.html.SafeUrl.sanitizeAssertUnchanged(s, h);
    }
    p.src = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setVideoSrc = function(p, s) {
    if (goog.dom.asserts.assertIsHTMLVideoElement(p), !(s instanceof goog.html.SafeUrl)) {
      var h = /^data:video\//i.test(s);
      s = goog.html.SafeUrl.sanitizeAssertUnchanged(s, h);
    }
    p.src = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.setEmbedSrc = function(p, s) {
    goog.dom.asserts.assertIsHTMLEmbedElement(p), p.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(s);
  }, goog.dom.safe.setFrameSrc = function(p, s) {
    goog.dom.asserts.assertIsHTMLFrameElement(p), p.src = goog.html.TrustedResourceUrl.unwrap(s);
  }, goog.dom.safe.setIframeSrc = function(p, s) {
    goog.dom.asserts.assertIsHTMLIFrameElement(p), p.src = goog.html.TrustedResourceUrl.unwrap(s);
  }, goog.dom.safe.setIframeSrcdoc = function(p, s) {
    goog.dom.asserts.assertIsHTMLIFrameElement(p), p.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(s);
  }, goog.dom.safe.setLinkHrefAndRel = function(p, s, h) {
    goog.dom.asserts.assertIsHTMLLinkElement(p), p.rel = h, goog.string.internal.caseInsensitiveContains(h, "stylesheet") ? (goog.asserts.assert(s instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), p.href = goog.html.TrustedResourceUrl.unwrap(s)) : p.href = s instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(s) : s instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(s) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(s));
  }, goog.dom.safe.setObjectData = function(p, s) {
    goog.dom.asserts.assertIsHTMLObjectElement(p), p.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(s);
  }, goog.dom.safe.setScriptSrc = function(p, s) {
    goog.dom.asserts.assertIsHTMLScriptElement(p), p.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(s), (s = goog.getScriptNonce()) && p.setAttribute("nonce", s);
  }, goog.dom.safe.setScriptContent = function(p, s) {
    goog.dom.asserts.assertIsHTMLScriptElement(p), p.text = goog.html.SafeScript.unwrapTrustedScript(s), (s = goog.getScriptNonce()) && p.setAttribute("nonce", s);
  }, goog.dom.safe.setLocationHref = function(p, s) {
    goog.dom.asserts.assertIsLocation(p), s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), p.href = goog.html.SafeUrl.unwrap(s);
  }, goog.dom.safe.assignLocation = function(p, s) {
    goog.dom.asserts.assertIsLocation(p), s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), p.assign(goog.html.SafeUrl.unwrap(s));
  }, goog.dom.safe.replaceLocation = function(p, s) {
    s = s instanceof goog.html.SafeUrl ? s : goog.html.SafeUrl.sanitizeAssertUnchanged(s), p.replace(goog.html.SafeUrl.unwrap(s));
  }, goog.dom.safe.openInWindow = function(p, s, h, c, d) {
    return p = p instanceof goog.html.SafeUrl ? p : goog.html.SafeUrl.sanitizeAssertUnchanged(p), s = s || goog.global, h = h instanceof goog.string.Const ? goog.string.Const.unwrap(h) : h || "", s.open(goog.html.SafeUrl.unwrap(p), h, c, d);
  }, goog.dom.safe.parseFromStringHtml = function(p, s) {
    return goog.dom.safe.parseFromString(p, s, "text/html");
  }, goog.dom.safe.parseFromString = function(p, s, h) {
    return p.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(s), h);
  }, goog.dom.safe.createImageFromBlob = function(p) {
    if (!/^image\/.*/g.test(p.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
    var s = goog.global.URL.createObjectURL(p);
    return p = new goog.global.Image(), p.onload = function() {
      goog.global.URL.revokeObjectURL(s);
    }, goog.dom.safe.setImageSrc(p, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), s)), p;
  }, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = { NBSP: " " }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(p, s) {
    for (var h = p.split("%s"), c = "", d = Array.prototype.slice.call(arguments, 1); d.length && 1 < h.length; ) c += h.shift() + d.shift();
    return c + h.join("%s");
  }, goog.string.collapseWhitespace = function(p) {
    return p.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
  }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(p) {
    return p.length == 0;
  }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(p) {
    return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(p));
  }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(p) {
    return !/[^\t\n\r ]/.test(p);
  }, goog.string.isAlpha = function(p) {
    return !/[^a-zA-Z]/.test(p);
  }, goog.string.isNumeric = function(p) {
    return !/[^0-9]/.test(p);
  }, goog.string.isAlphaNumeric = function(p) {
    return !/[^a-zA-Z0-9]/.test(p);
  }, goog.string.isSpace = function(p) {
    return p == " ";
  }, goog.string.isUnicodeChar = function(p) {
    return p.length == 1 && " " <= p && "~" >= p || "" <= p && "�" >= p;
  }, goog.string.stripNewlines = function(p) {
    return p.replace(/(\r\n|\r|\n)+/g, " ");
  }, goog.string.canonicalizeNewlines = function(p) {
    return p.replace(/(\r\n|\r|\n)/g, `
`);
  }, goog.string.normalizeWhitespace = function(p) {
    return p.replace(/\xa0|\s/g, " ");
  }, goog.string.normalizeSpaces = function(p) {
    return p.replace(/\xa0|[ \t]+/g, " ");
  }, goog.string.collapseBreakingSpaces = function(p) {
    return p.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
  }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(p) {
    return p.replace(/^[\s\xa0]+/, "");
  }, goog.string.trimRight = function(p) {
    return p.replace(/[\s\xa0]+$/, "");
  }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(p, s, h) {
    if (p == s) return 0;
    if (!p) return -1;
    if (!s) return 1;
    for (var c = p.toLowerCase().match(h), d = s.toLowerCase().match(h), l = Math.min(c.length, d.length), g = 0; g < l; g++) {
      h = c[g];
      var f = d[g];
      if (h != f) return p = parseInt(h, 10), !isNaN(p) && (s = parseInt(f, 10), !isNaN(s) && p - s) ? p - s : h < f ? -1 : 1;
    }
    return c.length != d.length ? c.length - d.length : p < s ? -1 : 1;
  }, goog.string.intAwareCompare = function(p, s) {
    return goog.string.numberAwareCompare_(p, s, /\d+|\D+/g);
  }, goog.string.floatAwareCompare = function(p, s) {
    return goog.string.numberAwareCompare_(p, s, /\d+|\.\d+|\D+/g);
  }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(p) {
    return encodeURIComponent(String(p));
  }, goog.string.urlDecode = function(p) {
    return decodeURIComponent(p.replace(/\+/g, " "));
  }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(p, s) {
    return p = goog.string.internal.htmlEscape(p, s), goog.string.DETECT_DOUBLE_ESCAPING && (p = p.replace(goog.string.E_RE_, "&#101;")), p;
  }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(p) {
    return goog.string.contains(p, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(p) : goog.string.unescapePureXmlEntities_(p) : p;
  }, goog.string.unescapeEntitiesWithDocument = function(p, s) {
    return goog.string.contains(p, "&") ? goog.string.unescapeEntitiesUsingDom_(p, s) : p;
  }, goog.string.unescapeEntitiesUsingDom_ = function(p, s) {
    var h = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"' }, c = s ? s.createElement("div") : goog.global.document.createElement("div");
    return p.replace(goog.string.HTML_ENTITY_PATTERN_, function(d, l) {
      var g = h[d];
      return g || (l.charAt(0) == "#" && (l = +("0" + l.substr(1)), isNaN(l) || (g = String.fromCharCode(l))), g || (goog.dom.safe.setInnerHtml(c, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(
        goog.string.Const.from("Single HTML entity."),
        d + " "
      )), g = c.firstChild.nodeValue.slice(0, -1)), h[d] = g);
    });
  }, goog.string.unescapePureXmlEntities_ = function(p) {
    return p.replace(/&([^;]+);/g, function(s, h) {
      switch (h) {
        case "amp":
          return "&";
        case "lt":
          return "<";
        case "gt":
          return ">";
        case "quot":
          return '"';
        default:
          return h.charAt(0) != "#" || (h = +("0" + h.substr(1)), isNaN(h)) ? s : String.fromCharCode(h);
      }
    });
  }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(p, s) {
    return goog.string.newLineToBr(p.replace(/  /g, " &#160;"), s);
  }, goog.string.preserveSpaces = function(p) {
    return p.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
  }, goog.string.stripQuotes = function(p, s) {
    for (var h = s.length, c = 0; c < h; c++) {
      var d = h == 1 ? s : s.charAt(c);
      if (p.charAt(0) == d && p.charAt(p.length - 1) == d) return p.substring(1, p.length - 1);
    }
    return p;
  }, goog.string.truncate = function(p, s, h) {
    return h && (p = goog.string.unescapeEntities(p)), p.length > s && (p = p.substring(0, s - 3) + "..."), h && (p = goog.string.htmlEscape(p)), p;
  }, goog.string.truncateMiddle = function(p, s, h, c) {
    if (h && (p = goog.string.unescapeEntities(p)), c && p.length > s) {
      c > s && (c = s);
      var d = p.length - c;
      p = p.substring(0, s - c) + "..." + p.substring(d);
    } else p.length > s && (c = Math.floor(s / 2), d = p.length - c, p = p.substring(0, c + s % 2) + "..." + p.substring(d));
    return h && (p = goog.string.htmlEscape(p)), p;
  }, goog.string.specialEscapeChars_ = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" }, goog.string.jsEscapeCache_ = { "'": "\\'" }, goog.string.quote = function(p) {
    p = String(p);
    for (var s = ['"'], h = 0; h < p.length; h++) {
      var c = p.charAt(h), d = c.charCodeAt(0);
      s[h + 1] = goog.string.specialEscapeChars_[c] || (31 < d && 127 > d ? c : goog.string.escapeChar(c));
    }
    return s.push('"'), s.join("");
  }, goog.string.escapeString = function(p) {
    for (var s = [], h = 0; h < p.length; h++) s[h] = goog.string.escapeChar(p.charAt(h));
    return s.join("");
  }, goog.string.escapeChar = function(p) {
    if (p in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[p];
    if (p in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[p] = goog.string.specialEscapeChars_[p];
    var s = p.charCodeAt(0);
    if (31 < s && 127 > s) var h = p;
    else
      256 > s ? (h = "\\x", (16 > s || 256 < s) && (h += "0")) : (h = "\\u", 4096 > s && (h += "0")), h += s.toString(16).toUpperCase();
    return goog.string.jsEscapeCache_[p] = h;
  }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(p, s) {
    return p && s ? p.split(s).length - 1 : 0;
  }, goog.string.removeAt = function(p, s, h) {
    var c = p;
    return 0 <= s && s < p.length && 0 < h && (c = p.substr(0, s) + p.substr(s + h, p.length - s - h)), c;
  }, goog.string.remove = function(p, s) {
    return p.replace(s, "");
  }, goog.string.removeAll = function(p, s) {
    return s = new RegExp(goog.string.regExpEscape(s), "g"), p.replace(s, "");
  }, goog.string.replaceAll = function(p, s, h) {
    return s = new RegExp(goog.string.regExpEscape(s), "g"), p.replace(s, h.replace(/\$/g, "$$$$"));
  }, goog.string.regExpEscape = function(p) {
    return String(p).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
  }, goog.string.repeat = String.prototype.repeat ? function(p, s) {
    return p.repeat(s);
  } : function(p, s) {
    return Array(s + 1).join(p);
  }, goog.string.padNumber = function(p, s, h) {
    return p = h !== void 0 ? p.toFixed(h) : String(p), h = p.indexOf("."), h == -1 && (h = p.length), goog.string.repeat("0", Math.max(0, s - h)) + p;
  }, goog.string.makeSafe = function(p) {
    return p == null ? "" : String(p);
  }, goog.string.buildString = function(p) {
    return Array.prototype.join.call(arguments, "");
  }, goog.string.getRandomString = function() {
    return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
  }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(p) {
    for (var s = 0, h = 0; h < p.length; ++h) s = 31 * s + p.charCodeAt(h) >>> 0;
    return s;
  }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
    return "goog_" + goog.string.uniqueStringCounter_++;
  }, goog.string.toNumber = function(p) {
    var s = Number(p);
    return s == 0 && goog.string.isEmptyOrWhitespace(p) ? NaN : s;
  }, goog.string.isLowerCamelCase = function(p) {
    return /^[a-z]+([A-Z][a-z]*)*$/.test(p);
  }, goog.string.isUpperCamelCase = function(p) {
    return /^([A-Z][a-z]*)+$/.test(p);
  }, goog.string.toCamelCase = function(p) {
    return String(p).replace(/\-([a-z])/g, function(s, h) {
      return h.toUpperCase();
    });
  }, goog.string.toSelectorCase = function(p) {
    return String(p).replace(/([A-Z])/g, "-$1").toLowerCase();
  }, goog.string.toTitleCase = function(p, s) {
    return s = typeof s == "string" ? goog.string.regExpEscape(s) : "\\s", p.replace(new RegExp("(^" + (s ? "|[" + s + "]+" : "") + ")([a-z])", "g"), function(h, c, d) {
      return c + d.toUpperCase();
    });
  }, goog.string.capitalize = function(p) {
    return String(p.charAt(0)).toUpperCase() + String(p.substr(1)).toLowerCase();
  }, goog.string.parseInt = function(p) {
    return isFinite(p) && (p = String(p)), typeof p == "string" ? /^\s*-?0x/i.test(p) ? parseInt(p, 16) : parseInt(p, 10) : NaN;
  }, goog.string.splitLimit = function(p, s, h) {
    p = p.split(s);
    for (var c = []; 0 < h && p.length; ) c.push(p.shift()), h--;
    return p.length && c.push(p.join(s)), c;
  }, goog.string.lastComponent = function(p, s) {
    if (s) typeof s == "string" && (s = [s]);
    else return p;
    for (var h = -1, c = 0; c < s.length; c++) if (s[c] != "") {
      var d = p.lastIndexOf(s[c]);
      d > h && (h = d);
    }
    return h == -1 ? p : p.slice(h + 1);
  }, goog.string.editDistance = function(p, s) {
    var h = [], c = [];
    if (p == s) return 0;
    if (!p.length || !s.length) return Math.max(p.length, s.length);
    for (var d = 0; d < s.length + 1; d++) h[d] = d;
    for (d = 0; d < p.length; d++) {
      c[0] = d + 1;
      for (var l = 0; l < s.length; l++) c[l + 1] = Math.min(c[l] + 1, h[l + 1] + 1, h[l] + +(p[d] != s[l]));
      for (l = 0; l < h.length; l++) h[l] = c[l];
    }
    return c[s.length];
  }, goog.labs.userAgent.engine = {}, goog.labs.userAgent.engine.isPresto = function() {
    return goog.labs.userAgent.util.matchUserAgent("Presto");
  }, goog.labs.userAgent.engine.isTrident = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  }, goog.labs.userAgent.engine.isEdge = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  }, goog.labs.userAgent.engine.isWebKit = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
  }, goog.labs.userAgent.engine.isGecko = function() {
    return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
  }, goog.labs.userAgent.engine.getVersion = function() {
    var p = goog.labs.userAgent.util.getUserAgent();
    if (p) {
      p = goog.labs.userAgent.util.extractVersionTuples(p);
      var s = goog.labs.userAgent.engine.getEngineTuple_(p);
      if (s) return s[0] == "Gecko" ? goog.labs.userAgent.engine.getVersionForKey_(p, "Firefox") : s[1];
      p = p[0];
      var h;
      if (p && (h = p[2]) && (h = /Trident\/([^\s;]+)/.exec(h))) return h[1];
    }
    return "";
  }, goog.labs.userAgent.engine.getEngineTuple_ = function(p) {
    if (!goog.labs.userAgent.engine.isEdge()) return p[1];
    for (var s = 0; s < p.length; s++) {
      var h = p[s];
      if (h[0] == "Edge") return h;
    }
  }, goog.labs.userAgent.engine.isVersionOrHigher = function(p) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), p);
  }, goog.labs.userAgent.engine.getVersionForKey_ = function(p, s) {
    return (p = goog.array.find(p, function(h) {
      return s == h[0];
    })) && p[1] || "";
  }, goog.labs.userAgent.platform = {}, goog.labs.userAgent.platform.isAndroid = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android");
  }, goog.labs.userAgent.platform.isIpod = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPod");
  }, goog.labs.userAgent.platform.isIphone = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
  }, goog.labs.userAgent.platform.isIpad = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPad");
  }, goog.labs.userAgent.platform.isIos = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
  }, goog.labs.userAgent.platform.isMacintosh = function() {
    return goog.labs.userAgent.util.matchUserAgent("Macintosh");
  }, goog.labs.userAgent.platform.isLinux = function() {
    return goog.labs.userAgent.util.matchUserAgent("Linux");
  }, goog.labs.userAgent.platform.isWindows = function() {
    return goog.labs.userAgent.util.matchUserAgent("Windows");
  }, goog.labs.userAgent.platform.isChromeOS = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrOS");
  }, goog.labs.userAgent.platform.isChromecast = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrKey");
  }, goog.labs.userAgent.platform.isKaiOS = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
  }, goog.labs.userAgent.platform.getVersion = function() {
    var p = goog.labs.userAgent.util.getUserAgent(), s = "";
    return goog.labs.userAgent.platform.isWindows() ? (s = /Windows (?:NT|Phone) ([0-9.]+)/, s = (p = s.exec(p)) ? p[1] : "0.0") : goog.labs.userAgent.platform.isIos() ? (s = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, s = (p = s.exec(p)) && p[1].replace(/_/g, ".")) : goog.labs.userAgent.platform.isMacintosh() ? (s = /Mac OS X ([0-9_.]+)/, s = (p = s.exec(p)) ? p[1].replace(/_/g, ".") : "10") : goog.labs.userAgent.platform.isKaiOS() ? (s = /(?:KaiOS)\/(\S+)/i, s = (p = s.exec(p)) && p[1]) : goog.labs.userAgent.platform.isAndroid() ? (s = /Android\s+([^\);]+)(\)|;)/, s = (p = s.exec(p)) && p[1]) : goog.labs.userAgent.platform.isChromeOS() && (s = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, s = (p = s.exec(p)) && p[1]), s || "";
  }, goog.labs.userAgent.platform.isVersionOrHigher = function(p) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), p);
  }, goog.reflect = {}, goog.reflect.object = function(p, s) {
    return s;
  }, goog.reflect.objectProperty = function(p, s) {
    return p;
  }, goog.reflect.sinkValue = function(p) {
    return goog.reflect.sinkValue[" "](p), p;
  }, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function(p, s) {
    try {
      return goog.reflect.sinkValue(p[s]), !0;
    } catch (h) {
    }
    return !1;
  }, goog.reflect.cache = function(p, s, h, c) {
    return c = c ? c(s) : s, Object.prototype.hasOwnProperty.call(p, c) ? p[c] : p[c] = h(s);
  }, goog.userAgent = {}, goog.userAgent.ASSUME_IE = !1, goog.userAgent.ASSUME_EDGE = !1, goog.userAgent.ASSUME_GECKO = !1, goog.userAgent.ASSUME_WEBKIT = !1, goog.userAgent.ASSUME_MOBILE_WEBKIT = !1, goog.userAgent.ASSUME_OPERA = !1, goog.userAgent.ASSUME_ANY_VERSION = !1, goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA, goog.userAgent.getUserAgentString = function() {
    return goog.labs.userAgent.util.getUserAgent();
  }, goog.userAgent.getNavigatorTyped = function() {
    return goog.global.navigator || null;
  }, goog.userAgent.getNavigator = function() {
    return goog.userAgent.getNavigatorTyped();
  }, goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera(), goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE(), goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge(), goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE, goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko(), goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit(), goog.userAgent.isMobile_ = function() {
    return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
  }, goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_(), goog.userAgent.SAFARI = goog.userAgent.WEBKIT, goog.userAgent.determinePlatform_ = function() {
    var p = goog.userAgent.getNavigatorTyped();
    return p && p.platform || "";
  }, goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_(), goog.userAgent.ASSUME_MAC = !1, goog.userAgent.ASSUME_WINDOWS = !1, goog.userAgent.ASSUME_LINUX = !1, goog.userAgent.ASSUME_X11 = !1, goog.userAgent.ASSUME_ANDROID = !1, goog.userAgent.ASSUME_IPHONE = !1, goog.userAgent.ASSUME_IPAD = !1, goog.userAgent.ASSUME_IPOD = !1, goog.userAgent.ASSUME_KAIOS = !1, goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD, goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh(), goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows(), goog.userAgent.isLegacyLinux_ = function() {
    return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
  }, goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_(), goog.userAgent.isX11_ = function() {
    var p = goog.userAgent.getNavigatorTyped();
    return !!p && goog.string.contains(p.appVersion || "", "X11");
  }, goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_(), goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid(), goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone(), goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod(), goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos(), goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS(), goog.userAgent.determineVersion_ = function() {
    var p = "", s = goog.userAgent.getVersionRegexResult_();
    return s && (p = s ? s[1] : ""), goog.userAgent.IE && (s = goog.userAgent.getDocumentMode_(), s != null && s > parseFloat(p)) ? String(s) : p;
  }, goog.userAgent.getVersionRegexResult_ = function() {
    var p = goog.userAgent.getUserAgentString();
    if (goog.userAgent.GECKO) return /rv:([^\);]+)(\)|;)/.exec(p);
    if (goog.userAgent.EDGE) return /Edge\/([\d\.]+)/.exec(p);
    if (goog.userAgent.IE) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(p);
    if (goog.userAgent.WEBKIT) return /WebKit\/(\S+)/.exec(p);
    if (goog.userAgent.OPERA) return /(?:Version)[ \/]?(\S+)/.exec(p);
  }, goog.userAgent.getDocumentMode_ = function() {
    var p = goog.global.document;
    return p ? p.documentMode : void 0;
  }, goog.userAgent.VERSION = goog.userAgent.determineVersion_(), goog.userAgent.compare = function(p, s) {
    return goog.string.compareVersions(p, s);
  }, goog.userAgent.isVersionOrHigherCache_ = {}, goog.userAgent.isVersionOrHigher = function(p) {
    return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, p, function() {
      return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, p);
    });
  }, goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher, goog.userAgent.isDocumentModeOrHigher = function(p) {
    return Number(goog.userAgent.DOCUMENT_MODE) >= p;
  }, goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher, goog.userAgent.DOCUMENT_MODE = function() {
    if (goog.global.document && goog.userAgent.IE) {
      var p = goog.userAgent.getDocumentMode_();
      return p || parseInt(goog.userAgent.VERSION, 10) || void 0;
    }
  }(), goog.userAgent.product = {}, goog.userAgent.product.ASSUME_FIREFOX = !1, goog.userAgent.product.ASSUME_IPHONE = !1, goog.userAgent.product.ASSUME_IPAD = !1, goog.userAgent.product.ASSUME_ANDROID = !1, goog.userAgent.product.ASSUME_CHROME = !1, goog.userAgent.product.ASSUME_SAFARI = !1, goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI, goog.userAgent.product.OPERA = goog.userAgent.OPERA, goog.userAgent.product.IE = goog.userAgent.IE, goog.userAgent.product.EDGE = goog.userAgent.EDGE, goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox(), goog.userAgent.product.isIphoneOrIpod_ = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
  }, goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_(), goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser(), goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome(), goog.userAgent.product.isSafariDesktop_ = function() {
    return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
  }, goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_(), goog.crypt.base64 = {}, goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=", goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.", goog.crypt.base64.Alphabet = { DEFAULT: 0, NO_PADDING: 1, WEBSAFE: 2, WEBSAFE_DOT_PADDING: 3, WEBSAFE_NO_PADDING: 4 }, goog.crypt.base64.paddingChars_ = "=.", goog.crypt.base64.isPadding_ = function(p) {
    return goog.string.contains(goog.crypt.base64.paddingChars_, p);
  }, goog.crypt.base64.byteToCharMaps_ = {}, goog.crypt.base64.charToByteMap_ = null, goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA, goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || typeof goog.global.btoa == "function", goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && typeof goog.global.atob == "function", goog.crypt.base64.encodeByteArray = function(p, s) {
    goog.asserts.assert(goog.isArrayLike(p), "encodeByteArray takes an array as a parameter"), s === void 0 && (s = goog.crypt.base64.Alphabet.DEFAULT), goog.crypt.base64.init_(), s = goog.crypt.base64.byteToCharMaps_[s];
    for (var h = [], c = 0; c < p.length; c += 3) {
      var d = p[c], l = c + 1 < p.length, g = l ? p[c + 1] : 0, f = c + 2 < p.length, _ = f ? p[c + 2] : 0, te = d >> 2;
      d = (d & 3) << 4 | g >> 4, g = (g & 15) << 2 | _ >> 6, _ &= 63, f || (_ = 64, l || (g = 64)), h.push(s[te], s[d], s[g] || "", s[_] || "");
    }
    return h.join("");
  }, goog.crypt.base64.encodeString = function(p, s) {
    return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !s ? goog.global.btoa(p) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(p), s);
  }, goog.crypt.base64.decodeString = function(p, s) {
    if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !s) return goog.global.atob(p);
    var h = "";
    return goog.crypt.base64.decodeStringInternal_(p, function(c) {
      h += String.fromCharCode(c);
    }), h;
  }, goog.crypt.base64.decodeStringToByteArray = function(p, s) {
    var h = [];
    return goog.crypt.base64.decodeStringInternal_(p, function(c) {
      h.push(c);
    }), h;
  }, goog.crypt.base64.decodeStringToUint8Array = function(p) {
    goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
    var s = p.length, h = 3 * s / 4;
    h % 3 ? h = Math.floor(h) : goog.crypt.base64.isPadding_(p[s - 1]) && (h = goog.crypt.base64.isPadding_(p[s - 2]) ? h - 2 : h - 1);
    var c = new Uint8Array(h), d = 0;
    return goog.crypt.base64.decodeStringInternal_(p, function(l) {
      c[d++] = l;
    }), c.subarray(0, d);
  }, goog.crypt.base64.decodeStringInternal_ = function(p, s) {
    function h(_) {
      for (; c < p.length; ) {
        var te = p.charAt(c++), ae = goog.crypt.base64.charToByteMap_[te];
        if (ae != null) return ae;
        if (!goog.string.isEmptyOrWhitespace(te)) throw Error("Unknown base64 encoding at char: " + te);
      }
      return _;
    }
    goog.crypt.base64.init_();
    for (var c = 0; ; ) {
      var d = h(-1), l = h(0), g = h(64), f = h(64);
      if (f === 64 && d === -1) break;
      s(d << 2 | l >> 4), g != 64 && (s(l << 4 & 240 | g >> 2), f != 64 && s(g << 6 & 192 | f));
    }
  }, goog.crypt.base64.init_ = function() {
    if (!goog.crypt.base64.charToByteMap_) {
      goog.crypt.base64.charToByteMap_ = {};
      for (var p = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), s = ["+/=", "+/", "-_=", "-_.", "-_"], h = 0; 5 > h; h++) {
        var c = p.concat(s[h].split(""));
        goog.crypt.base64.byteToCharMaps_[h] = c;
        for (var d = 0; d < c.length; d++) {
          var l = c[d], g = goog.crypt.base64.charToByteMap_[l];
          g === void 0 ? goog.crypt.base64.charToByteMap_[l] = d : goog.asserts.assert(g === d);
        }
      }
    }
  }, jspb.utils = {}, jspb.utils.split64Low = 0, jspb.utils.split64High = 0, jspb.utils.splitUint64 = function(p) {
    var s = p >>> 0;
    p = Math.floor((p - s) / jspb.BinaryConstants.TWO_TO_32) >>> 0, jspb.utils.split64Low = s, jspb.utils.split64High = p;
  }, jspb.utils.splitInt64 = function(p) {
    var s = 0 > p;
    p = Math.abs(p);
    var h = p >>> 0;
    p = Math.floor((p - h) / jspb.BinaryConstants.TWO_TO_32), p >>>= 0, s && (p = ~p >>> 0, h = (~h >>> 0) + 1, 4294967295 < h && (h = 0, p++, 4294967295 < p && (p = 0))), jspb.utils.split64Low = h, jspb.utils.split64High = p;
  }, jspb.utils.splitZigzag64 = function(p) {
    var s = 0 > p;
    p = 2 * Math.abs(p), jspb.utils.splitUint64(p), p = jspb.utils.split64Low;
    var h = jspb.utils.split64High;
    s && (p == 0 ? h == 0 ? h = p = 4294967295 : (h--, p = 4294967295) : p--), jspb.utils.split64Low = p, jspb.utils.split64High = h;
  }, jspb.utils.splitFloat32 = function(p) {
    var s = 0 > p ? 1 : 0;
    if (p = s ? -p : p, p === 0) 0 < 1 / p ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);
    else if (isNaN(p)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;
    else if (p > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (s << 31 | 2139095040) >>> 0;
    else if (p < jspb.BinaryConstants.FLOAT32_MIN) p = Math.round(p / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (s << 31 | p) >>> 0;
    else {
      var h = Math.floor(Math.log(p) / Math.LN2);
      p *= Math.pow(2, -h), p = Math.round(p * jspb.BinaryConstants.TWO_TO_23), 16777216 <= p && ++h, jspb.utils.split64High = 0, jspb.utils.split64Low = (s << 31 | h + 127 << 23 | p & 8388607) >>> 0;
    }
  }, jspb.utils.splitFloat64 = function(p) {
    var s = 0 > p ? 1 : 0;
    if (p = s ? -p : p, p === 0) jspb.utils.split64High = 0 < 1 / p ? 0 : 2147483648, jspb.utils.split64Low = 0;
    else if (isNaN(p)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;
    else if (p > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (s << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;
    else if (p < jspb.BinaryConstants.FLOAT64_MIN) {
      var h = p / Math.pow(2, -1074);
      p = h / jspb.BinaryConstants.TWO_TO_32, jspb.utils.split64High = (s << 31 | p) >>> 0, jspb.utils.split64Low = h >>> 0;
    } else {
      h = p;
      var c = 0;
      if (2 <= h) for (; 2 <= h && 1023 > c; ) c++, h /= 2;
      else for (; 1 > h && -1022 < c; ) h *= 2, c--;
      h = p * Math.pow(2, -c), p = h * jspb.BinaryConstants.TWO_TO_20 & 1048575, h = h * jspb.BinaryConstants.TWO_TO_52 >>> 0, jspb.utils.split64High = (s << 31 | c + 1023 << 20 | p) >>> 0, jspb.utils.split64Low = h;
    }
  }, jspb.utils.splitHash64 = function(p) {
    var s = p.charCodeAt(0), h = p.charCodeAt(1), c = p.charCodeAt(2), d = p.charCodeAt(3), l = p.charCodeAt(4), g = p.charCodeAt(5), f = p.charCodeAt(6);
    p = p.charCodeAt(7), jspb.utils.split64Low = s + (h << 8) + (c << 16) + (d << 24) >>> 0, jspb.utils.split64High = l + (g << 8) + (f << 16) + (p << 24) >>> 0;
  }, jspb.utils.joinUint64 = function(p, s) {
    return s * jspb.BinaryConstants.TWO_TO_32 + (p >>> 0);
  }, jspb.utils.joinInt64 = function(p, s) {
    var h = s & 2147483648;
    return h && (p = ~p + 1 >>> 0, s = ~s >>> 0, p == 0 && (s = s + 1 >>> 0)), p = jspb.utils.joinUint64(p, s), h ? -p : p;
  }, jspb.utils.toZigzag64 = function(p, s, h) {
    var c = s >> 31;
    return h(p << 1 ^ c, (s << 1 | p >>> 31) ^ c);
  }, jspb.utils.joinZigzag64 = function(p, s) {
    return jspb.utils.fromZigzag64(p, s, jspb.utils.joinInt64);
  }, jspb.utils.fromZigzag64 = function(p, s, h) {
    var c = -(p & 1);
    return h((p >>> 1 | s << 31) ^ c, s >>> 1 ^ c);
  }, jspb.utils.joinFloat32 = function(p, s) {
    s = 2 * (p >> 31) + 1;
    var h = p >>> 23 & 255;
    return p &= 8388607, h == 255 ? p ? NaN : 1 / 0 * s : h == 0 ? s * Math.pow(2, -149) * p : s * Math.pow(2, h - 150) * (p + Math.pow(2, 23));
  }, jspb.utils.joinFloat64 = function(p, s) {
    var h = 2 * (s >> 31) + 1, c = s >>> 20 & 2047;
    return p = jspb.BinaryConstants.TWO_TO_32 * (s & 1048575) + p, c == 2047 ? p ? NaN : 1 / 0 * h : c == 0 ? h * Math.pow(2, -1074) * p : h * Math.pow(2, c - 1075) * (p + jspb.BinaryConstants.TWO_TO_52);
  }, jspb.utils.joinHash64 = function(p, s) {
    return String.fromCharCode(p >>> 0 & 255, p >>> 8 & 255, p >>> 16 & 255, p >>> 24 & 255, s >>> 0 & 255, s >>> 8 & 255, s >>> 16 & 255, s >>> 24 & 255);
  }, jspb.utils.DIGITS = "0123456789abcdef".split(""), jspb.utils.ZERO_CHAR_CODE_ = 48, jspb.utils.A_CHAR_CODE_ = 97, jspb.utils.joinUnsignedDecimalString = function(p, s) {
    function h(d, l) {
      return d = d ? String(d) : "", l ? "0000000".slice(d.length) + d : d;
    }
    if (2097151 >= s) return "" + jspb.utils.joinUint64(p, s);
    var c = (p >>> 24 | s << 8) >>> 0 & 16777215;
    return s = s >> 16 & 65535, p = (p & 16777215) + 6777216 * c + 6710656 * s, c += 8147497 * s, s *= 2, 1e7 <= p && (c += Math.floor(p / 1e7), p %= 1e7), 1e7 <= c && (s += Math.floor(c / 1e7), c %= 1e7), h(s, 0) + h(c, s) + h(p, 1);
  }, jspb.utils.joinSignedDecimalString = function(p, s) {
    var h = s & 2147483648;
    return h && (p = ~p + 1 >>> 0, s = ~s + (p == 0 ? 1 : 0) >>> 0), p = jspb.utils.joinUnsignedDecimalString(p, s), h ? "-" + p : p;
  }, jspb.utils.hash64ToDecimalString = function(p, s) {
    jspb.utils.splitHash64(p), p = jspb.utils.split64Low;
    var h = jspb.utils.split64High;
    return s ? jspb.utils.joinSignedDecimalString(p, h) : jspb.utils.joinUnsignedDecimalString(p, h);
  }, jspb.utils.hash64ArrayToDecimalStrings = function(p, s) {
    for (var h = Array(p.length), c = 0; c < p.length; c++) h[c] = jspb.utils.hash64ToDecimalString(p[c], s);
    return h;
  }, jspb.utils.decimalStringToHash64 = function(p) {
    function s(g, f) {
      for (var _ = 0; 8 > _ && (g !== 1 || 0 < f); _++) f = g * d[_] + f, d[_] = f & 255, f >>>= 8;
    }
    function h() {
      for (var g = 0; 8 > g; g++) d[g] = ~d[g] & 255;
    }
    jspb.asserts.assert(0 < p.length);
    var c = !1;
    p[0] === "-" && (c = !0, p = p.slice(1));
    for (var d = [0, 0, 0, 0, 0, 0, 0, 0], l = 0; l < p.length; l++) s(10, p.charCodeAt(l) - jspb.utils.ZERO_CHAR_CODE_);
    return c && (h(), s(1, 1)), goog.crypt.byteArrayToString(d);
  }, jspb.utils.splitDecimalString = function(p) {
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(p));
  }, jspb.utils.toHexDigit_ = function(p) {
    return String.fromCharCode(10 > p ? jspb.utils.ZERO_CHAR_CODE_ + p : jspb.utils.A_CHAR_CODE_ - 10 + p);
  }, jspb.utils.fromHexCharCode_ = function(p) {
    return p >= jspb.utils.A_CHAR_CODE_ ? p - jspb.utils.A_CHAR_CODE_ + 10 : p - jspb.utils.ZERO_CHAR_CODE_;
  }, jspb.utils.hash64ToHexString = function(p) {
    var s = Array(18);
    s[0] = "0", s[1] = "x";
    for (var h = 0; 8 > h; h++) {
      var c = p.charCodeAt(7 - h);
      s[2 * h + 2] = jspb.utils.toHexDigit_(c >> 4), s[2 * h + 3] = jspb.utils.toHexDigit_(c & 15);
    }
    return s.join("");
  }, jspb.utils.hexStringToHash64 = function(p) {
    p = p.toLowerCase(), jspb.asserts.assert(p.length == 18), jspb.asserts.assert(p[0] == "0"), jspb.asserts.assert(p[1] == "x");
    for (var s = "", h = 0; 8 > h; h++) {
      var c = jspb.utils.fromHexCharCode_(p.charCodeAt(2 * h + 2)), d = jspb.utils.fromHexCharCode_(p.charCodeAt(2 * h + 3));
      s = String.fromCharCode(16 * c + d) + s;
    }
    return s;
  }, jspb.utils.hash64ToNumber = function(p, s) {
    jspb.utils.splitHash64(p), p = jspb.utils.split64Low;
    var h = jspb.utils.split64High;
    return s ? jspb.utils.joinInt64(p, h) : jspb.utils.joinUint64(p, h);
  }, jspb.utils.numberToHash64 = function(p) {
    return jspb.utils.splitInt64(p), jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.utils.countVarints = function(p, s, h) {
    for (var c = 0, d = s; d < h; d++) c += p[d] >> 7;
    return h - s - c;
  }, jspb.utils.countVarintFields = function(p, s, h, c) {
    var d = 0;
    if (c = 8 * c + jspb.BinaryConstants.WireType.VARINT, 128 > c) for (; s < h && p[s++] == c; ) for (d++; ; ) {
      var l = p[s++];
      if (!(l & 128)) break;
    }
    else for (; s < h; ) {
      for (l = c; 128 < l; ) {
        if (p[s] != (l & 127 | 128)) return d;
        s++, l >>= 7;
      }
      if (p[s++] != l) break;
      for (d++; l = p[s++], (l & 128) != 0; ) ;
    }
    return d;
  }, jspb.utils.countFixedFields_ = function(p, s, h, c, d) {
    var l = 0;
    if (128 > c) for (; s < h && p[s++] == c; ) l++, s += d;
    else for (; s < h; ) {
      for (var g = c; 128 < g; ) {
        if (p[s++] != (g & 127 | 128)) return l;
        g >>= 7;
      }
      if (p[s++] != g) break;
      l++, s += d;
    }
    return l;
  }, jspb.utils.countFixed32Fields = function(p, s, h, c) {
    return jspb.utils.countFixedFields_(p, s, h, 8 * c + jspb.BinaryConstants.WireType.FIXED32, 4);
  }, jspb.utils.countFixed64Fields = function(p, s, h, c) {
    return jspb.utils.countFixedFields_(p, s, h, 8 * c + jspb.BinaryConstants.WireType.FIXED64, 8);
  }, jspb.utils.countDelimitedFields = function(p, s, h, c) {
    var d = 0;
    for (c = 8 * c + jspb.BinaryConstants.WireType.DELIMITED; s < h; ) {
      for (var l = c; 128 < l; ) {
        if (p[s++] != (l & 127 | 128)) return d;
        l >>= 7;
      }
      if (p[s++] != l) break;
      d++;
      for (var g = 0, f = 1; l = p[s++], g += (l & 127) * f, f *= 128, (l & 128) != 0; ) ;
      s += g;
    }
    return d;
  }, jspb.utils.debugBytesToTextFormat = function(p) {
    var s = '"';
    if (p) {
      p = jspb.utils.byteSourceToUint8Array(p);
      for (var h = 0; h < p.length; h++) s += "\\x", 16 > p[h] && (s += "0"), s += p[h].toString(16);
    }
    return s + '"';
  }, jspb.utils.debugScalarToTextFormat = function(p) {
    return typeof p == "string" ? goog.string.quote(p) : p.toString();
  }, jspb.utils.stringToByteArray = function(p) {
    for (var s = new Uint8Array(p.length), h = 0; h < p.length; h++) {
      var c = p.charCodeAt(h);
      if (255 < c) throw Error("Conversion error: string contains codepoint outside of byte range");
      s[h] = c;
    }
    return s;
  }, jspb.utils.byteSourceToUint8Array = function(p) {
    return p.constructor === Uint8Array ? p : p.constructor === ArrayBuffer || p.constructor === Array ? new Uint8Array(p) : p.constructor === String ? goog.crypt.base64.decodeStringToUint8Array(p) : p instanceof Uint8Array ? new Uint8Array(p.buffer, p.byteOffset, p.byteLength) : (jspb.asserts.fail("Type not convertible to Uint8Array."), new Uint8Array(0));
  }, jspb.BinaryDecoder = function(p, s, h) {
    this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1, p && this.setBlock(p, s, h);
  }, jspb.BinaryDecoder.instanceCache_ = [], jspb.BinaryDecoder.alloc = function(p, s, h) {
    if (jspb.BinaryDecoder.instanceCache_.length) {
      var c = jspb.BinaryDecoder.instanceCache_.pop();
      return p && c.setBlock(p, s, h), c;
    }
    return new jspb.BinaryDecoder(p, s, h);
  }, jspb.BinaryDecoder.prototype.free = function() {
    this.clear(), 100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
  }, jspb.BinaryDecoder.prototype.clone = function() {
    return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
  }, jspb.BinaryDecoder.prototype.clear = function() {
    this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1;
  }, jspb.BinaryDecoder.prototype.getBuffer = function() {
    return this.bytes_;
  }, jspb.BinaryDecoder.prototype.setBlock = function(p, s, h) {
    this.bytes_ = jspb.utils.byteSourceToUint8Array(p), this.start_ = s !== void 0 ? s : 0, this.end_ = h !== void 0 ? this.start_ + h : this.bytes_.length, this.cursor_ = this.start_;
  }, jspb.BinaryDecoder.prototype.getEnd = function() {
    return this.end_;
  }, jspb.BinaryDecoder.prototype.setEnd = function(p) {
    this.end_ = p;
  }, jspb.BinaryDecoder.prototype.reset = function() {
    this.cursor_ = this.start_;
  }, jspb.BinaryDecoder.prototype.getCursor = function() {
    return this.cursor_;
  }, jspb.BinaryDecoder.prototype.setCursor = function(p) {
    this.cursor_ = p;
  }, jspb.BinaryDecoder.prototype.advance = function(p) {
    this.cursor_ += p, jspb.asserts.assert(this.cursor_ <= this.end_);
  }, jspb.BinaryDecoder.prototype.atEnd = function() {
    return this.cursor_ == this.end_;
  }, jspb.BinaryDecoder.prototype.pastEnd = function() {
    return this.cursor_ > this.end_;
  }, jspb.BinaryDecoder.prototype.getError = function() {
    return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
  }, jspb.BinaryDecoder.prototype.readSplitVarint64 = function(p) {
    for (var s = 128, h = 0, c = 0, d = 0; 4 > d && 128 <= s; d++) s = this.bytes_[this.cursor_++], h |= (s & 127) << 7 * d;
    if (128 <= s && (s = this.bytes_[this.cursor_++], h |= (s & 127) << 28, c |= (s & 127) >> 4), 128 <= s) for (d = 0; 5 > d && 128 <= s; d++) s = this.bytes_[this.cursor_++], c |= (s & 127) << 7 * d + 3;
    if (128 > s) return p(h >>> 0, c >>> 0);
    jspb.asserts.fail("Failed to read varint, encoding is invalid."), this.error_ = !0;
  }, jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function(p) {
    return this.readSplitVarint64(function(s, h) {
      return jspb.utils.fromZigzag64(s, h, p);
    });
  }, jspb.BinaryDecoder.prototype.readSplitFixed64 = function(p) {
    var s = this.bytes_, h = this.cursor_;
    this.cursor_ += 8;
    for (var c = 0, d = 0, l = h + 7; l >= h; l--) c = c << 8 | s[l], d = d << 8 | s[l + 4];
    return p(c, d);
  }, jspb.BinaryDecoder.prototype.skipVarint = function() {
    for (; this.bytes_[this.cursor_] & 128; ) this.cursor_++;
    this.cursor_++;
  }, jspb.BinaryDecoder.prototype.unskipVarint = function(p) {
    for (; 128 < p; ) this.cursor_--, p >>>= 7;
    this.cursor_--;
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function() {
    var p = this.bytes_, s = p[this.cursor_ + 0], h = s & 127;
    return 128 > s ? (this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), h) : (s = p[this.cursor_ + 1], h |= (s & 127) << 7, 128 > s ? (this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), h) : (s = p[this.cursor_ + 2], h |= (s & 127) << 14, 128 > s ? (this.cursor_ += 3, jspb.asserts.assert(this.cursor_ <= this.end_), h) : (s = p[this.cursor_ + 3], h |= (s & 127) << 21, 128 > s ? (this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), h) : (s = p[this.cursor_ + 4], h |= (s & 15) << 28, 128 > s ? (this.cursor_ += 5, jspb.asserts.assert(this.cursor_ <= this.end_), h >>> 0) : (this.cursor_ += 5, 128 <= p[this.cursor_++] && 128 <= p[this.cursor_++] && 128 <= p[this.cursor_++] && 128 <= p[this.cursor_++] && 128 <= p[this.cursor_++] && jspb.asserts.assert(!1), jspb.asserts.assert(this.cursor_ <= this.end_), h)))));
  }, jspb.BinaryDecoder.prototype.readSignedVarint32 = function() {
    return ~~this.readUnsignedVarint32();
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function() {
    return this.readUnsignedVarint32().toString();
  }, jspb.BinaryDecoder.prototype.readSignedVarint32String = function() {
    return this.readSignedVarint32().toString();
  }, jspb.BinaryDecoder.prototype.readZigzagVarint32 = function() {
    var p = this.readUnsignedVarint32();
    return p >>> 1 ^ -(p & 1);
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinUint64);
  }, jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
  }, jspb.BinaryDecoder.prototype.readSignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinInt64);
  }, jspb.BinaryDecoder.prototype.readSignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
  }, jspb.BinaryDecoder.prototype.readZigzagVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinZigzag64);
  }, jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
  }, jspb.BinaryDecoder.prototype.readZigzagVarint64String = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
  }, jspb.BinaryDecoder.prototype.readUint8 = function() {
    var p = this.bytes_[this.cursor_ + 0];
    return this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), p;
  }, jspb.BinaryDecoder.prototype.readUint16 = function() {
    var p = this.bytes_[this.cursor_ + 0], s = this.bytes_[this.cursor_ + 1];
    return this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), p << 0 | s << 8;
  }, jspb.BinaryDecoder.prototype.readUint32 = function() {
    var p = this.bytes_[this.cursor_ + 0], s = this.bytes_[this.cursor_ + 1], h = this.bytes_[this.cursor_ + 2], c = this.bytes_[this.cursor_ + 3];
    return this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), (p << 0 | s << 8 | h << 16 | c << 24) >>> 0;
  }, jspb.BinaryDecoder.prototype.readUint64 = function() {
    var p = this.readUint32(), s = this.readUint32();
    return jspb.utils.joinUint64(p, s);
  }, jspb.BinaryDecoder.prototype.readUint64String = function() {
    var p = this.readUint32(), s = this.readUint32();
    return jspb.utils.joinUnsignedDecimalString(p, s);
  }, jspb.BinaryDecoder.prototype.readInt8 = function() {
    var p = this.bytes_[this.cursor_ + 0];
    return this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), p << 24 >> 24;
  }, jspb.BinaryDecoder.prototype.readInt16 = function() {
    var p = this.bytes_[this.cursor_ + 0], s = this.bytes_[this.cursor_ + 1];
    return this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), (p << 0 | s << 8) << 16 >> 16;
  }, jspb.BinaryDecoder.prototype.readInt32 = function() {
    var p = this.bytes_[this.cursor_ + 0], s = this.bytes_[this.cursor_ + 1], h = this.bytes_[this.cursor_ + 2], c = this.bytes_[this.cursor_ + 3];
    return this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), p << 0 | s << 8 | h << 16 | c << 24;
  }, jspb.BinaryDecoder.prototype.readInt64 = function() {
    var p = this.readUint32(), s = this.readUint32();
    return jspb.utils.joinInt64(p, s);
  }, jspb.BinaryDecoder.prototype.readInt64String = function() {
    var p = this.readUint32(), s = this.readUint32();
    return jspb.utils.joinSignedDecimalString(p, s);
  }, jspb.BinaryDecoder.prototype.readFloat = function() {
    var p = this.readUint32();
    return jspb.utils.joinFloat32(p, 0);
  }, jspb.BinaryDecoder.prototype.readDouble = function() {
    var p = this.readUint32(), s = this.readUint32();
    return jspb.utils.joinFloat64(p, s);
  }, jspb.BinaryDecoder.prototype.readBool = function() {
    return !!this.bytes_[this.cursor_++];
  }, jspb.BinaryDecoder.prototype.readEnum = function() {
    return this.readSignedVarint32();
  }, jspb.BinaryDecoder.prototype.readString = function(p) {
    var s = this.bytes_, h = this.cursor_;
    p = h + p;
    for (var c = [], d = ""; h < p; ) {
      var l = s[h++];
      if (128 > l) c.push(l);
      else {
        if (192 > l) continue;
        if (224 > l) {
          var g = s[h++];
          c.push((l & 31) << 6 | g & 63);
        } else if (240 > l) {
          g = s[h++];
          var f = s[h++];
          c.push((l & 15) << 12 | (g & 63) << 6 | f & 63);
        } else if (248 > l) {
          g = s[h++], f = s[h++];
          var _ = s[h++];
          l = (l & 7) << 18 | (g & 63) << 12 | (f & 63) << 6 | _ & 63, l -= 65536, c.push((l >> 10 & 1023) + 55296, (l & 1023) + 56320);
        }
      }
      8192 <= c.length && (d += String.fromCharCode.apply(null, c), c.length = 0);
    }
    return d += goog.crypt.byteArrayToString(c), this.cursor_ = h, d;
  }, jspb.BinaryDecoder.prototype.readStringWithLength = function() {
    var p = this.readUnsignedVarint32();
    return this.readString(p);
  }, jspb.BinaryDecoder.prototype.readBytes = function(p) {
    if (0 > p || this.cursor_ + p > this.bytes_.length) return this.error_ = !0, jspb.asserts.fail("Invalid byte length!"), new Uint8Array(0);
    var s = this.bytes_.subarray(this.cursor_, this.cursor_ + p);
    return this.cursor_ += p, jspb.asserts.assert(this.cursor_ <= this.end_), s;
  }, jspb.BinaryDecoder.prototype.readVarintHash64 = function() {
    return this.readSplitVarint64(jspb.utils.joinHash64);
  }, jspb.BinaryDecoder.prototype.readFixedHash64 = function() {
    var p = this.bytes_, s = this.cursor_, h = p[s + 0], c = p[s + 1], d = p[s + 2], l = p[s + 3], g = p[s + 4], f = p[s + 5], _ = p[s + 6];
    return p = p[s + 7], this.cursor_ += 8, String.fromCharCode(h, c, d, l, g, f, _, p);
  }, jspb.BinaryReader = function(p, s, h) {
    this.decoder_ = jspb.BinaryDecoder.alloc(p, s, h), this.fieldCursor_ = this.decoder_.getCursor(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null;
  }, jspb.BinaryReader.instanceCache_ = [], jspb.BinaryReader.alloc = function(p, s, h) {
    if (jspb.BinaryReader.instanceCache_.length) {
      var c = jspb.BinaryReader.instanceCache_.pop();
      return p && c.decoder_.setBlock(p, s, h), c;
    }
    return new jspb.BinaryReader(p, s, h);
  }, jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc, jspb.BinaryReader.prototype.free = function() {
    this.decoder_.clear(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null, 100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
  }, jspb.BinaryReader.prototype.getFieldCursor = function() {
    return this.fieldCursor_;
  }, jspb.BinaryReader.prototype.getCursor = function() {
    return this.decoder_.getCursor();
  }, jspb.BinaryReader.prototype.getBuffer = function() {
    return this.decoder_.getBuffer();
  }, jspb.BinaryReader.prototype.getFieldNumber = function() {
    return this.nextField_;
  }, goog.exportProperty(jspb.BinaryReader.prototype, "getFieldNumber", jspb.BinaryReader.prototype.getFieldNumber), jspb.BinaryReader.prototype.getWireType = function() {
    return this.nextWireType_;
  }, jspb.BinaryReader.prototype.isDelimited = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
  }, goog.exportProperty(jspb.BinaryReader.prototype, "isDelimited", jspb.BinaryReader.prototype.isDelimited), jspb.BinaryReader.prototype.isEndGroup = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
  }, goog.exportProperty(jspb.BinaryReader.prototype, "isEndGroup", jspb.BinaryReader.prototype.isEndGroup), jspb.BinaryReader.prototype.getError = function() {
    return this.error_ || this.decoder_.getError();
  }, jspb.BinaryReader.prototype.setBlock = function(p, s, h) {
    this.decoder_.setBlock(p, s, h), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  }, jspb.BinaryReader.prototype.reset = function() {
    this.decoder_.reset(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  }, jspb.BinaryReader.prototype.advance = function(p) {
    this.decoder_.advance(p);
  }, jspb.BinaryReader.prototype.nextField = function() {
    if (this.decoder_.atEnd()) return !1;
    if (this.getError()) return jspb.asserts.fail("Decoder hit an error"), !1;
    this.fieldCursor_ = this.decoder_.getCursor();
    var p = this.decoder_.readUnsignedVarint32(), s = p >>> 3;
    return p &= 7, p != jspb.BinaryConstants.WireType.VARINT && p != jspb.BinaryConstants.WireType.FIXED32 && p != jspb.BinaryConstants.WireType.FIXED64 && p != jspb.BinaryConstants.WireType.DELIMITED && p != jspb.BinaryConstants.WireType.START_GROUP && p != jspb.BinaryConstants.WireType.END_GROUP ? (jspb.asserts.fail(
      "Invalid wire type: %s (at position %s)",
      p,
      this.fieldCursor_
    ), this.error_ = !0, !1) : (this.nextField_ = s, this.nextWireType_ = p, !0);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "nextField", jspb.BinaryReader.prototype.nextField), jspb.BinaryReader.prototype.unskipHeader = function() {
    this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
  }, jspb.BinaryReader.prototype.skipMatchingFields = function() {
    var p = this.nextField_;
    for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == p; ) this.skipField();
    this.decoder_.atEnd() || this.unskipHeader();
  }, jspb.BinaryReader.prototype.skipVarintField = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (jspb.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
  }, jspb.BinaryReader.prototype.skipDelimitedField = function() {
    if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) jspb.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();
    else {
      var p = this.decoder_.readUnsignedVarint32();
      this.decoder_.advance(p);
    }
  }, jspb.BinaryReader.prototype.skipFixed32Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (jspb.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
  }, jspb.BinaryReader.prototype.skipFixed64Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (jspb.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
  }, jspb.BinaryReader.prototype.skipGroup = function() {
    var p = this.nextField_;
    do {
      if (!this.nextField()) {
        jspb.asserts.fail("Unmatched start-group tag: stream EOF"), this.error_ = !0;
        break;
      }
      if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
        this.nextField_ != p && (jspb.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
        break;
      }
      this.skipField();
    } while (!0);
  }, jspb.BinaryReader.prototype.skipField = function() {
    switch (this.nextWireType_) {
      case jspb.BinaryConstants.WireType.VARINT:
        this.skipVarintField();
        break;
      case jspb.BinaryConstants.WireType.FIXED64:
        this.skipFixed64Field();
        break;
      case jspb.BinaryConstants.WireType.DELIMITED:
        this.skipDelimitedField();
        break;
      case jspb.BinaryConstants.WireType.FIXED32:
        this.skipFixed32Field();
        break;
      case jspb.BinaryConstants.WireType.START_GROUP:
        this.skipGroup();
        break;
      default:
        jspb.asserts.fail("Invalid wire encoding for field.");
    }
  }, jspb.BinaryReader.prototype.registerReadCallback = function(p, s) {
    this.readCallbacks_ === null && (this.readCallbacks_ = {}), jspb.asserts.assert(!this.readCallbacks_[p]), this.readCallbacks_[p] = s;
  }, jspb.BinaryReader.prototype.runReadCallback = function(p) {
    return jspb.asserts.assert(this.readCallbacks_ !== null), p = this.readCallbacks_[p], jspb.asserts.assert(p), p(this);
  }, jspb.BinaryReader.prototype.readAny = function(p) {
    this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(p);
    var s = jspb.BinaryConstants.FieldType;
    switch (p) {
      case s.DOUBLE:
        return this.readDouble();
      case s.FLOAT:
        return this.readFloat();
      case s.INT64:
        return this.readInt64();
      case s.UINT64:
        return this.readUint64();
      case s.INT32:
        return this.readInt32();
      case s.FIXED64:
        return this.readFixed64();
      case s.FIXED32:
        return this.readFixed32();
      case s.BOOL:
        return this.readBool();
      case s.STRING:
        return this.readString();
      case s.GROUP:
        jspb.asserts.fail("Group field type not supported in readAny()");
      case s.MESSAGE:
        jspb.asserts.fail("Message field type not supported in readAny()");
      case s.BYTES:
        return this.readBytes();
      case s.UINT32:
        return this.readUint32();
      case s.ENUM:
        return this.readEnum();
      case s.SFIXED32:
        return this.readSfixed32();
      case s.SFIXED64:
        return this.readSfixed64();
      case s.SINT32:
        return this.readSint32();
      case s.SINT64:
        return this.readSint64();
      case s.FHASH64:
        return this.readFixedHash64();
      case s.VHASH64:
        return this.readVarintHash64();
      default:
        jspb.asserts.fail("Invalid field type in readAny()");
    }
    return 0;
  }, jspb.BinaryReader.prototype.readMessage = function(p, s) {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var h = this.decoder_.getEnd(), c = this.decoder_.readUnsignedVarint32();
    c = this.decoder_.getCursor() + c, this.decoder_.setEnd(c), s(p, this), this.decoder_.setCursor(c), this.decoder_.setEnd(h);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readMessage", jspb.BinaryReader.prototype.readMessage), jspb.BinaryReader.prototype.readGroup = function(p, s, h) {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP), jspb.asserts.assert(this.nextField_ == p), h(s, this), this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (jspb.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readGroup", jspb.BinaryReader.prototype.readGroup), jspb.BinaryReader.prototype.getFieldDecoder = function() {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var p = this.decoder_.readUnsignedVarint32(), s = this.decoder_.getCursor(), h = s + p;
    return p = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), s, p), this.decoder_.setCursor(h), p;
  }, jspb.BinaryReader.prototype.readInt32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readInt32", jspb.BinaryReader.prototype.readInt32), jspb.BinaryReader.prototype.readInt32String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32String();
  }, jspb.BinaryReader.prototype.readInt64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readInt64", jspb.BinaryReader.prototype.readInt64), jspb.BinaryReader.prototype.readInt64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64String();
  }, jspb.BinaryReader.prototype.readUint32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readUint32", jspb.BinaryReader.prototype.readUint32), jspb.BinaryReader.prototype.readUint32String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32String();
  }, jspb.BinaryReader.prototype.readUint64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readUint64", jspb.BinaryReader.prototype.readUint64), jspb.BinaryReader.prototype.readUint64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64String();
  }, jspb.BinaryReader.prototype.readSint32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSint32", jspb.BinaryReader.prototype.readSint32), jspb.BinaryReader.prototype.readSint64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSint64", jspb.BinaryReader.prototype.readSint64), jspb.BinaryReader.prototype.readSint64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64String();
  }, jspb.BinaryReader.prototype.readFixed32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readUint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readFixed32", jspb.BinaryReader.prototype.readFixed32), jspb.BinaryReader.prototype.readFixed64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readFixed64", jspb.BinaryReader.prototype.readFixed64), jspb.BinaryReader.prototype.readFixed64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64String();
  }, jspb.BinaryReader.prototype.readSfixed32 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSfixed32", jspb.BinaryReader.prototype.readSfixed32), jspb.BinaryReader.prototype.readSfixed32String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32().toString();
  }, jspb.BinaryReader.prototype.readSfixed64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readSfixed64", jspb.BinaryReader.prototype.readSfixed64), jspb.BinaryReader.prototype.readSfixed64String = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64String();
  }, jspb.BinaryReader.prototype.readFloat = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readFloat();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readFloat", jspb.BinaryReader.prototype.readFloat), jspb.BinaryReader.prototype.readDouble = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readDouble();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readDouble", jspb.BinaryReader.prototype.readDouble), jspb.BinaryReader.prototype.readBool = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), !!this.decoder_.readUnsignedVarint32();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readBool", jspb.BinaryReader.prototype.readBool), jspb.BinaryReader.prototype.readEnum = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readEnum", jspb.BinaryReader.prototype.readEnum), jspb.BinaryReader.prototype.readString = function() {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var p = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readString(p);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readString", jspb.BinaryReader.prototype.readString), jspb.BinaryReader.prototype.readBytes = function() {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var p = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readBytes(p);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readBytes", jspb.BinaryReader.prototype.readBytes), jspb.BinaryReader.prototype.readVarintHash64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readVarintHash64();
  }, jspb.BinaryReader.prototype.readSintHash64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarintHash64();
  }, jspb.BinaryReader.prototype.readSplitVarint64 = function(p) {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(p);
  }, jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function(p) {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(function(s, h) {
      return jspb.utils.fromZigzag64(s, h, p);
    });
  }, jspb.BinaryReader.prototype.readFixedHash64 = function() {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readFixedHash64();
  }, jspb.BinaryReader.prototype.readSplitFixed64 = function(p) {
    return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readSplitFixed64(p);
  }, jspb.BinaryReader.prototype.readPackedField_ = function(p) {
    jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var s = this.decoder_.readUnsignedVarint32();
    s = this.decoder_.getCursor() + s;
    for (var h = []; this.decoder_.getCursor() < s; ) h.push(p.call(this.decoder_));
    return h;
  }, jspb.BinaryReader.prototype.readPackedInt32 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedInt32", jspb.BinaryReader.prototype.readPackedInt32), jspb.BinaryReader.prototype.readPackedInt32String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32String);
  }, jspb.BinaryReader.prototype.readPackedInt64 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedInt64", jspb.BinaryReader.prototype.readPackedInt64), jspb.BinaryReader.prototype.readPackedInt64String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64String);
  }, jspb.BinaryReader.prototype.readPackedUint32 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedUint32", jspb.BinaryReader.prototype.readPackedUint32), jspb.BinaryReader.prototype.readPackedUint32String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
  }, jspb.BinaryReader.prototype.readPackedUint64 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedUint64", jspb.BinaryReader.prototype.readPackedUint64), jspb.BinaryReader.prototype.readPackedUint64String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
  }, jspb.BinaryReader.prototype.readPackedSint32 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSint32", jspb.BinaryReader.prototype.readPackedSint32), jspb.BinaryReader.prototype.readPackedSint64 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSint64", jspb.BinaryReader.prototype.readPackedSint64), jspb.BinaryReader.prototype.readPackedSint64String = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64String);
  }, jspb.BinaryReader.prototype.readPackedFixed32 = function() {
    return this.readPackedField_(this.decoder_.readUint32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFixed32", jspb.BinaryReader.prototype.readPackedFixed32), jspb.BinaryReader.prototype.readPackedFixed64 = function() {
    return this.readPackedField_(this.decoder_.readUint64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFixed64", jspb.BinaryReader.prototype.readPackedFixed64), jspb.BinaryReader.prototype.readPackedFixed64String = function() {
    return this.readPackedField_(this.decoder_.readUint64String);
  }, jspb.BinaryReader.prototype.readPackedSfixed32 = function() {
    return this.readPackedField_(this.decoder_.readInt32);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSfixed32", jspb.BinaryReader.prototype.readPackedSfixed32), jspb.BinaryReader.prototype.readPackedSfixed64 = function() {
    return this.readPackedField_(this.decoder_.readInt64);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSfixed64", jspb.BinaryReader.prototype.readPackedSfixed64), jspb.BinaryReader.prototype.readPackedSfixed64String = function() {
    return this.readPackedField_(this.decoder_.readInt64String);
  }, jspb.BinaryReader.prototype.readPackedFloat = function() {
    return this.readPackedField_(this.decoder_.readFloat);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFloat", jspb.BinaryReader.prototype.readPackedFloat), jspb.BinaryReader.prototype.readPackedDouble = function() {
    return this.readPackedField_(this.decoder_.readDouble);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedDouble", jspb.BinaryReader.prototype.readPackedDouble), jspb.BinaryReader.prototype.readPackedBool = function() {
    return this.readPackedField_(this.decoder_.readBool);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedBool", jspb.BinaryReader.prototype.readPackedBool), jspb.BinaryReader.prototype.readPackedEnum = function() {
    return this.readPackedField_(this.decoder_.readEnum);
  }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedEnum", jspb.BinaryReader.prototype.readPackedEnum), jspb.BinaryReader.prototype.readPackedVarintHash64 = function() {
    return this.readPackedField_(this.decoder_.readVarintHash64);
  }, jspb.BinaryReader.prototype.readPackedFixedHash64 = function() {
    return this.readPackedField_(this.decoder_.readFixedHash64);
  }, jspb.BinaryEncoder = function() {
    this.buffer_ = [];
  }, jspb.BinaryEncoder.prototype.length = function() {
    return this.buffer_.length;
  }, jspb.BinaryEncoder.prototype.end = function() {
    var p = this.buffer_;
    return this.buffer_ = [], p;
  }, jspb.BinaryEncoder.prototype.writeSplitVarint64 = function(p, s) {
    for (jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(s == Math.floor(s)), jspb.asserts.assert(0 <= p && p < jspb.BinaryConstants.TWO_TO_32), jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_32); 0 < s || 127 < p; ) this.buffer_.push(p & 127 | 128), p = (p >>> 7 | s << 25) >>> 0, s >>>= 7;
    this.buffer_.push(p);
  }, jspb.BinaryEncoder.prototype.writeSplitFixed64 = function(p, s) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(s == Math.floor(s)), jspb.asserts.assert(0 <= p && p < jspb.BinaryConstants.TWO_TO_32), jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_32), this.writeUint32(p), this.writeUint32(s);
  }, jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function(p) {
    for (jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(0 <= p && p < jspb.BinaryConstants.TWO_TO_32); 127 < p; ) this.buffer_.push(p & 127 | 128), p >>>= 7;
    this.buffer_.push(p);
  }, jspb.BinaryEncoder.prototype.writeSignedVarint32 = function(p) {
    if (jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_31 && p < jspb.BinaryConstants.TWO_TO_31), 0 <= p) this.writeUnsignedVarint32(p);
    else {
      for (var s = 0; 9 > s; s++) this.buffer_.push(p & 127 | 128), p >>= 7;
      this.buffer_.push(1);
    }
  }, jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(0 <= p && p < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitInt64(p), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeSignedVarint64 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_63 && p < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(p), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_31 && p < jspb.BinaryConstants.TWO_TO_31), this.writeUnsignedVarint32((p << 1 ^ p >> 31) >>> 0);
  }, jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_63 && p < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitZigzag64(p), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function(p) {
    this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(p));
  }, jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function(p) {
    var s = this;
    jspb.utils.splitHash64(p), jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function(h, c) {
      s.writeSplitVarint64(h >>> 0, c >>> 0);
    });
  }, jspb.BinaryEncoder.prototype.writeUint8 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(0 <= p && 256 > p), this.buffer_.push(p >>> 0 & 255);
  }, jspb.BinaryEncoder.prototype.writeUint16 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(0 <= p && 65536 > p), this.buffer_.push(p >>> 0 & 255), this.buffer_.push(p >>> 8 & 255);
  }, jspb.BinaryEncoder.prototype.writeUint32 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(0 <= p && p < jspb.BinaryConstants.TWO_TO_32), this.buffer_.push(p >>> 0 & 255), this.buffer_.push(p >>> 8 & 255), this.buffer_.push(p >>> 16 & 255), this.buffer_.push(p >>> 24 & 255);
  }, jspb.BinaryEncoder.prototype.writeUint64 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(0 <= p && p < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitUint64(p), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeInt8 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(-128 <= p && 128 > p), this.buffer_.push(p >>> 0 & 255);
  }, jspb.BinaryEncoder.prototype.writeInt16 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(-32768 <= p && 32768 > p), this.buffer_.push(p >>> 0 & 255), this.buffer_.push(p >>> 8 & 255);
  }, jspb.BinaryEncoder.prototype.writeInt32 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_31 && p < jspb.BinaryConstants.TWO_TO_31), this.buffer_.push(p >>> 0 & 255), this.buffer_.push(p >>> 8 & 255), this.buffer_.push(p >>> 16 & 255), this.buffer_.push(p >>> 24 & 255);
  }, jspb.BinaryEncoder.prototype.writeInt64 = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_63 && p < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(p), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeInt64String = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(+p >= -jspb.BinaryConstants.TWO_TO_63 && +p < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(p)), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeFloat = function(p) {
    jspb.asserts.assert(p === 1 / 0 || p === -1 / 0 || isNaN(p) || p >= -jspb.BinaryConstants.FLOAT32_MAX && p <= jspb.BinaryConstants.FLOAT32_MAX), jspb.utils.splitFloat32(p), this.writeUint32(jspb.utils.split64Low);
  }, jspb.BinaryEncoder.prototype.writeDouble = function(p) {
    jspb.asserts.assert(p === 1 / 0 || p === -1 / 0 || isNaN(p) || p >= -jspb.BinaryConstants.FLOAT64_MAX && p <= jspb.BinaryConstants.FLOAT64_MAX), jspb.utils.splitFloat64(p), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeBool = function(p) {
    jspb.asserts.assert(typeof p == "boolean" || typeof p == "number"), this.buffer_.push(p ? 1 : 0);
  }, jspb.BinaryEncoder.prototype.writeEnum = function(p) {
    jspb.asserts.assert(p == Math.floor(p)), jspb.asserts.assert(p >= -jspb.BinaryConstants.TWO_TO_31 && p < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32(p);
  }, jspb.BinaryEncoder.prototype.writeBytes = function(p) {
    this.buffer_.push.apply(this.buffer_, p);
  }, jspb.BinaryEncoder.prototype.writeVarintHash64 = function(p) {
    jspb.utils.splitHash64(p), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeFixedHash64 = function(p) {
    jspb.utils.splitHash64(p), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
  }, jspb.BinaryEncoder.prototype.writeString = function(p) {
    var s = this.buffer_.length;
    jspb.asserts.assertString(p);
    for (var h = 0; h < p.length; h++) {
      var c = p.charCodeAt(h);
      if (128 > c) this.buffer_.push(c);
      else if (2048 > c) this.buffer_.push(c >> 6 | 192), this.buffer_.push(c & 63 | 128);
      else if (65536 > c) if (55296 <= c && 56319 >= c && h + 1 < p.length) {
        var d = p.charCodeAt(h + 1);
        56320 <= d && 57343 >= d && (c = 1024 * (c - 55296) + d - 56320 + 65536, this.buffer_.push(c >> 18 | 240), this.buffer_.push(c >> 12 & 63 | 128), this.buffer_.push(c >> 6 & 63 | 128), this.buffer_.push(c & 63 | 128), h++);
      } else this.buffer_.push(c >> 12 | 224), this.buffer_.push(c >> 6 & 63 | 128), this.buffer_.push(c & 63 | 128);
    }
    return this.buffer_.length - s;
  }, jspb.arith = {}, jspb.arith.UInt64 = function(p, s) {
    this.lo = p, this.hi = s;
  }, jspb.arith.UInt64.prototype.cmp = function(p) {
    return this.hi < p.hi || this.hi == p.hi && this.lo < p.lo ? -1 : this.hi == p.hi && this.lo == p.lo ? 0 : 1;
  }, jspb.arith.UInt64.prototype.rightShift = function() {
    return new jspb.arith.UInt64((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
  }, jspb.arith.UInt64.prototype.leftShift = function() {
    return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
  }, jspb.arith.UInt64.prototype.msb = function() {
    return !!(this.hi & 2147483648);
  }, jspb.arith.UInt64.prototype.lsb = function() {
    return !!(this.lo & 1);
  }, jspb.arith.UInt64.prototype.zero = function() {
    return this.lo == 0 && this.hi == 0;
  }, jspb.arith.UInt64.prototype.add = function(p) {
    return new jspb.arith.UInt64((this.lo + p.lo & 4294967295) >>> 0 >>> 0, ((this.hi + p.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + p.lo ? 1 : 0) >>> 0);
  }, jspb.arith.UInt64.prototype.sub = function(p) {
    return new jspb.arith.UInt64((this.lo - p.lo & 4294967295) >>> 0 >>> 0, ((this.hi - p.hi & 4294967295) >>> 0) - (0 > this.lo - p.lo ? 1 : 0) >>> 0);
  }, jspb.arith.UInt64.mul32x32 = function(p, s) {
    var h = p & 65535;
    p >>>= 16;
    var c = s & 65535, d = s >>> 16;
    for (s = h * c + 65536 * (h * d & 65535) + 65536 * (p * c & 65535), h = p * d + (h * d >>> 16) + (p * c >>> 16); 4294967296 <= s; ) s -= 4294967296, h += 1;
    return new jspb.arith.UInt64(s >>> 0, h >>> 0);
  }, jspb.arith.UInt64.prototype.mul = function(p) {
    var s = jspb.arith.UInt64.mul32x32(this.lo, p);
    return p = jspb.arith.UInt64.mul32x32(this.hi, p), p.hi = p.lo, p.lo = 0, s.add(p);
  }, jspb.arith.UInt64.prototype.div = function(p) {
    if (p == 0) return [];
    var s = new jspb.arith.UInt64(0, 0), h = new jspb.arith.UInt64(this.lo, this.hi);
    p = new jspb.arith.UInt64(p, 0);
    for (var c = new jspb.arith.UInt64(1, 0); !p.msb(); ) p = p.leftShift(), c = c.leftShift();
    for (; !c.zero(); ) 0 >= p.cmp(h) && (s = s.add(c), h = h.sub(p)), p = p.rightShift(), c = c.rightShift();
    return [s, h];
  }, jspb.arith.UInt64.prototype.toString = function() {
    for (var p = "", s = this; !s.zero(); ) {
      s = s.div(10);
      var h = s[0];
      p = s[1].lo + p, s = h;
    }
    return p == "" && (p = "0"), p;
  }, jspb.arith.UInt64.fromString = function(p) {
    for (var s = new jspb.arith.UInt64(0, 0), h = new jspb.arith.UInt64(0, 0), c = 0; c < p.length; c++) {
      if ("0" > p[c] || "9" < p[c]) return null;
      var d = parseInt(p[c], 10);
      h.lo = d, s = s.mul(10).add(h);
    }
    return s;
  }, jspb.arith.UInt64.prototype.clone = function() {
    return new jspb.arith.UInt64(this.lo, this.hi);
  }, jspb.arith.Int64 = function(p, s) {
    this.lo = p, this.hi = s;
  }, jspb.arith.Int64.prototype.add = function(p) {
    return new jspb.arith.Int64((this.lo + p.lo & 4294967295) >>> 0 >>> 0, ((this.hi + p.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + p.lo ? 1 : 0) >>> 0);
  }, jspb.arith.Int64.prototype.sub = function(p) {
    return new jspb.arith.Int64((this.lo - p.lo & 4294967295) >>> 0 >>> 0, ((this.hi - p.hi & 4294967295) >>> 0) - (0 > this.lo - p.lo ? 1 : 0) >>> 0);
  }, jspb.arith.Int64.prototype.clone = function() {
    return new jspb.arith.Int64(this.lo, this.hi);
  }, jspb.arith.Int64.prototype.toString = function() {
    var p = (this.hi & 2147483648) != 0, s = new jspb.arith.UInt64(this.lo, this.hi);
    return p && (s = new jspb.arith.UInt64(0, 0).sub(s)), (p ? "-" : "") + s.toString();
  }, jspb.arith.Int64.fromString = function(p) {
    var s = 0 < p.length && p[0] == "-";
    return s && (p = p.substring(1)), p = jspb.arith.UInt64.fromString(p), p === null ? null : (s && (p = new jspb.arith.UInt64(0, 0).sub(p)), new jspb.arith.Int64(p.lo, p.hi));
  }, jspb.BinaryWriter = function() {
    this.blocks_ = [], this.totalLength_ = 0, this.encoder_ = new jspb.BinaryEncoder(), this.bookmarks_ = [];
  }, jspb.BinaryWriter.prototype.appendUint8Array_ = function(p) {
    var s = this.encoder_.end();
    this.blocks_.push(s), this.blocks_.push(p), this.totalLength_ += s.length + p.length;
  }, jspb.BinaryWriter.prototype.beginDelimited_ = function(p) {
    return this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), p = this.encoder_.end(), this.blocks_.push(p), this.totalLength_ += p.length, p.push(this.totalLength_), p;
  }, jspb.BinaryWriter.prototype.endDelimited_ = function(p) {
    var s = p.pop();
    for (s = this.totalLength_ + this.encoder_.length() - s, jspb.asserts.assert(0 <= s); 127 < s; ) p.push(s & 127 | 128), s >>>= 7, this.totalLength_++;
    p.push(s), this.totalLength_++;
  }, jspb.BinaryWriter.prototype.writeSerializedMessage = function(p, s, h) {
    this.appendUint8Array_(p.subarray(s, h));
  }, jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function(p, s, h) {
    p != null && s != null && h != null && this.writeSerializedMessage(p, s, h);
  }, jspb.BinaryWriter.prototype.reset = function() {
    this.blocks_ = [], this.encoder_.end(), this.totalLength_ = 0, this.bookmarks_ = [];
  }, jspb.BinaryWriter.prototype.getResultBuffer = function() {
    jspb.asserts.assert(this.bookmarks_.length == 0);
    for (var p = new Uint8Array(this.totalLength_ + this.encoder_.length()), s = this.blocks_, h = s.length, c = 0, d = 0; d < h; d++) {
      var l = s[d];
      p.set(l, c), c += l.length;
    }
    return s = this.encoder_.end(), p.set(s, c), c += s.length, jspb.asserts.assert(c == p.length), this.blocks_ = [p], p;
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "getResultBuffer", jspb.BinaryWriter.prototype.getResultBuffer), jspb.BinaryWriter.prototype.getResultBase64String = function(p) {
    return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), p);
  }, jspb.BinaryWriter.prototype.beginSubMessage = function(p) {
    this.bookmarks_.push(this.beginDelimited_(p));
  }, jspb.BinaryWriter.prototype.endSubMessage = function() {
    jspb.asserts.assert(0 <= this.bookmarks_.length), this.endDelimited_(this.bookmarks_.pop());
  }, jspb.BinaryWriter.prototype.writeFieldHeader_ = function(p, s) {
    jspb.asserts.assert(1 <= p && p == Math.floor(p)), this.encoder_.writeUnsignedVarint32(8 * p + s);
  }, jspb.BinaryWriter.prototype.writeAny = function(p, s, h) {
    var c = jspb.BinaryConstants.FieldType;
    switch (p) {
      case c.DOUBLE:
        this.writeDouble(s, h);
        break;
      case c.FLOAT:
        this.writeFloat(s, h);
        break;
      case c.INT64:
        this.writeInt64(s, h);
        break;
      case c.UINT64:
        this.writeUint64(s, h);
        break;
      case c.INT32:
        this.writeInt32(s, h);
        break;
      case c.FIXED64:
        this.writeFixed64(s, h);
        break;
      case c.FIXED32:
        this.writeFixed32(s, h);
        break;
      case c.BOOL:
        this.writeBool(s, h);
        break;
      case c.STRING:
        this.writeString(s, h);
        break;
      case c.GROUP:
        jspb.asserts.fail("Group field type not supported in writeAny()");
        break;
      case c.MESSAGE:
        jspb.asserts.fail("Message field type not supported in writeAny()");
        break;
      case c.BYTES:
        this.writeBytes(s, h);
        break;
      case c.UINT32:
        this.writeUint32(s, h);
        break;
      case c.ENUM:
        this.writeEnum(s, h);
        break;
      case c.SFIXED32:
        this.writeSfixed32(s, h);
        break;
      case c.SFIXED64:
        this.writeSfixed64(s, h);
        break;
      case c.SINT32:
        this.writeSint32(s, h);
        break;
      case c.SINT64:
        this.writeSint64(s, h);
        break;
      case c.FHASH64:
        this.writeFixedHash64(s, h);
        break;
      case c.VHASH64:
        this.writeVarintHash64(s, h);
        break;
      default:
        jspb.asserts.fail("Invalid field type in writeAny()");
    }
  }, jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(s));
  }, jspb.BinaryWriter.prototype.writeSignedVarint32_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(s));
  }, jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(s));
  }, jspb.BinaryWriter.prototype.writeSignedVarint64_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(s));
  }, jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(s));
  }, jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(s));
  }, jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(s));
  }, jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(s));
  }, jspb.BinaryWriter.prototype.writeInt32 = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_31 && s < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(p, s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeInt32", jspb.BinaryWriter.prototype.writeInt32), jspb.BinaryWriter.prototype.writeInt32String = function(p, s) {
    s != null && (s = parseInt(s, 10), jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_31 && s < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(p, s));
  }, jspb.BinaryWriter.prototype.writeInt64 = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_63 && s < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(p, s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeInt64", jspb.BinaryWriter.prototype.writeInt64), jspb.BinaryWriter.prototype.writeInt64String = function(p, s) {
    s != null && (s = jspb.arith.Int64.fromString(s), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(s.lo, s.hi));
  }, jspb.BinaryWriter.prototype.writeUint32 = function(p, s) {
    s != null && (jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(p, s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeUint32", jspb.BinaryWriter.prototype.writeUint32), jspb.BinaryWriter.prototype.writeUint32String = function(p, s) {
    s != null && (s = parseInt(s, 10), jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(p, s));
  }, jspb.BinaryWriter.prototype.writeUint64 = function(p, s) {
    s != null && (jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(p, s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeUint64", jspb.BinaryWriter.prototype.writeUint64), jspb.BinaryWriter.prototype.writeUint64String = function(p, s) {
    s != null && (s = jspb.arith.UInt64.fromString(s), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(s.lo, s.hi));
  }, jspb.BinaryWriter.prototype.writeSint32 = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_31 && s < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(p, s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSint32", jspb.BinaryWriter.prototype.writeSint32), jspb.BinaryWriter.prototype.writeSint64 = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_63 && s < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(p, s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSint64", jspb.BinaryWriter.prototype.writeSint64), jspb.BinaryWriter.prototype.writeSintHash64 = function(p, s) {
    s != null && this.writeZigzagVarintHash64_(p, s);
  }, jspb.BinaryWriter.prototype.writeSint64String = function(p, s) {
    s != null && this.writeZigzagVarint64String_(p, s);
  }, jspb.BinaryWriter.prototype.writeFixed32 = function(p, s) {
    s != null && (jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFixed32", jspb.BinaryWriter.prototype.writeFixed32), jspb.BinaryWriter.prototype.writeFixed64 = function(p, s) {
    s != null && (jspb.asserts.assert(0 <= s && s < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFixed64", jspb.BinaryWriter.prototype.writeFixed64), jspb.BinaryWriter.prototype.writeFixed64String = function(p, s) {
    s != null && (s = jspb.arith.UInt64.fromString(s), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(s.lo, s.hi));
  }, jspb.BinaryWriter.prototype.writeSfixed32 = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_31 && s < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSfixed32", jspb.BinaryWriter.prototype.writeSfixed32), jspb.BinaryWriter.prototype.writeSfixed64 = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_63 && s < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSfixed64", jspb.BinaryWriter.prototype.writeSfixed64), jspb.BinaryWriter.prototype.writeSfixed64String = function(p, s) {
    s != null && (s = jspb.arith.Int64.fromString(s), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(s.lo, s.hi));
  }, jspb.BinaryWriter.prototype.writeFloat = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFloat", jspb.BinaryWriter.prototype.writeFloat), jspb.BinaryWriter.prototype.writeDouble = function(p, s) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeDouble", jspb.BinaryWriter.prototype.writeDouble), jspb.BinaryWriter.prototype.writeBool = function(p, s) {
    s != null && (jspb.asserts.assert(typeof s == "boolean" || typeof s == "number"), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeBool", jspb.BinaryWriter.prototype.writeBool), jspb.BinaryWriter.prototype.writeEnum = function(p, s) {
    s != null && (jspb.asserts.assert(s >= -jspb.BinaryConstants.TWO_TO_31 && s < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeEnum", jspb.BinaryWriter.prototype.writeEnum), jspb.BinaryWriter.prototype.writeString = function(p, s) {
    s != null && (p = this.beginDelimited_(p), this.encoder_.writeString(s), this.endDelimited_(p));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeString", jspb.BinaryWriter.prototype.writeString), jspb.BinaryWriter.prototype.writeBytes = function(p, s) {
    s != null && (s = jspb.utils.byteSourceToUint8Array(s), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(s.length), this.appendUint8Array_(s));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeBytes", jspb.BinaryWriter.prototype.writeBytes), jspb.BinaryWriter.prototype.writeMessage = function(p, s, h) {
    s != null && (p = this.beginDelimited_(p), h(s, this), this.endDelimited_(p));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeMessage", jspb.BinaryWriter.prototype.writeMessage), jspb.BinaryWriter.prototype.writeMessageSet = function(p, s, h) {
    s != null && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(p), p = this.beginDelimited_(3), h(s, this), this.endDelimited_(p), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
  }, jspb.BinaryWriter.prototype.writeGroup = function(p, s, h) {
    s != null && (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.START_GROUP), h(s, this), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.END_GROUP));
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeGroup", jspb.BinaryWriter.prototype.writeGroup), jspb.BinaryWriter.prototype.writeFixedHash64 = function(p, s) {
    s != null && (jspb.asserts.assert(s.length == 8), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(s));
  }, jspb.BinaryWriter.prototype.writeVarintHash64 = function(p, s) {
    s != null && (jspb.asserts.assert(s.length == 8), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(s));
  }, jspb.BinaryWriter.prototype.writeSplitFixed64 = function(p, s, h) {
    this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(s, h);
  }, jspb.BinaryWriter.prototype.writeSplitVarint64 = function(p, s, h) {
    this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(s, h);
  }, jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function(p, s, h) {
    this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.VARINT);
    var c = this.encoder_;
    jspb.utils.toZigzag64(s, h, function(d, l) {
      c.writeSplitVarint64(d >>> 0, l >>> 0);
    });
  }, jspb.BinaryWriter.prototype.writeRepeatedInt32 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeSignedVarint32_(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedInt32", jspb.BinaryWriter.prototype.writeRepeatedInt32), jspb.BinaryWriter.prototype.writeRepeatedInt32String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeInt32String(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedInt64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeSignedVarint64_(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedInt64", jspb.BinaryWriter.prototype.writeRepeatedInt64), jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function(p, s, h, c) {
    if (s != null) for (var d = 0; d < s.length; d++) this.writeSplitFixed64(p, h(s[d]), c(s[d]));
  }, jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function(p, s, h, c) {
    if (s != null) for (var d = 0; d < s.length; d++) this.writeSplitVarint64(p, h(s[d]), c(s[d]));
  }, jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function(p, s, h, c) {
    if (s != null) for (var d = 0; d < s.length; d++) this.writeSplitZigzagVarint64(p, h(s[d]), c(s[d]));
  }, jspb.BinaryWriter.prototype.writeRepeatedInt64String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeInt64String(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedUint32 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeUnsignedVarint32_(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedUint32", jspb.BinaryWriter.prototype.writeRepeatedUint32), jspb.BinaryWriter.prototype.writeRepeatedUint32String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeUint32String(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedUint64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeUnsignedVarint64_(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedUint64", jspb.BinaryWriter.prototype.writeRepeatedUint64), jspb.BinaryWriter.prototype.writeRepeatedUint64String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeUint64String(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedSint32 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeZigzagVarint32_(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSint32", jspb.BinaryWriter.prototype.writeRepeatedSint32), jspb.BinaryWriter.prototype.writeRepeatedSint64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeZigzagVarint64_(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSint64", jspb.BinaryWriter.prototype.writeRepeatedSint64), jspb.BinaryWriter.prototype.writeRepeatedSint64String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeZigzagVarint64String_(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeZigzagVarintHash64_(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeFixed32(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed32", jspb.BinaryWriter.prototype.writeRepeatedFixed32), jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeFixed64(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed64", jspb.BinaryWriter.prototype.writeRepeatedFixed64), jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeFixed64String(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed64String", jspb.BinaryWriter.prototype.writeRepeatedFixed64String), jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeSfixed32(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSfixed32", jspb.BinaryWriter.prototype.writeRepeatedSfixed32), jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeSfixed64(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSfixed64", jspb.BinaryWriter.prototype.writeRepeatedSfixed64), jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeSfixed64String(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedFloat = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeFloat(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFloat", jspb.BinaryWriter.prototype.writeRepeatedFloat), jspb.BinaryWriter.prototype.writeRepeatedDouble = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeDouble(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedDouble", jspb.BinaryWriter.prototype.writeRepeatedDouble), jspb.BinaryWriter.prototype.writeRepeatedBool = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeBool(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedBool", jspb.BinaryWriter.prototype.writeRepeatedBool), jspb.BinaryWriter.prototype.writeRepeatedEnum = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeEnum(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedEnum", jspb.BinaryWriter.prototype.writeRepeatedEnum), jspb.BinaryWriter.prototype.writeRepeatedString = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeString(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedString", jspb.BinaryWriter.prototype.writeRepeatedString), jspb.BinaryWriter.prototype.writeRepeatedBytes = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeBytes(p, s[h]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedBytes", jspb.BinaryWriter.prototype.writeRepeatedBytes), jspb.BinaryWriter.prototype.writeRepeatedMessage = function(p, s, h) {
    if (s != null) for (var c = 0; c < s.length; c++) {
      var d = this.beginDelimited_(p);
      h(s[c], this), this.endDelimited_(d);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedMessage", jspb.BinaryWriter.prototype.writeRepeatedMessage), jspb.BinaryWriter.prototype.writeRepeatedGroup = function(p, s, h) {
    if (s != null) for (var c = 0; c < s.length; c++) this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.START_GROUP), h(s[c], this), this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.END_GROUP);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedGroup", jspb.BinaryWriter.prototype.writeRepeatedGroup), jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeFixedHash64(p, s[h]);
  }, jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function(p, s) {
    if (s != null) for (var h = 0; h < s.length; h++) this.writeVarintHash64(p, s[h]);
  }, jspb.BinaryWriter.prototype.writePackedInt32 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeSignedVarint32(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedInt32", jspb.BinaryWriter.prototype.writePackedInt32), jspb.BinaryWriter.prototype.writePackedInt32String = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeSignedVarint32(parseInt(s[h], 10));
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedInt64 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeSignedVarint64(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedInt64", jspb.BinaryWriter.prototype.writePackedInt64), jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function(p, s, h, c) {
    if (s != null) {
      p = this.beginDelimited_(p);
      for (var d = 0; d < s.length; d++) this.encoder_.writeSplitFixed64(h(s[d]), c(s[d]));
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function(p, s, h, c) {
    if (s != null) {
      p = this.beginDelimited_(p);
      for (var d = 0; d < s.length; d++) this.encoder_.writeSplitVarint64(h(s[d]), c(s[d]));
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function(p, s, h, c) {
    if (s != null) {
      p = this.beginDelimited_(p);
      for (var d = this.encoder_, l = 0; l < s.length; l++) jspb.utils.toZigzag64(h(s[l]), c(s[l]), function(g, f) {
        d.writeSplitVarint64(g >>> 0, f >>> 0);
      });
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedInt64String = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) {
        var c = jspb.arith.Int64.fromString(s[h]);
        this.encoder_.writeSplitVarint64(c.lo, c.hi);
      }
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedUint32 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeUnsignedVarint32(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedUint32", jspb.BinaryWriter.prototype.writePackedUint32), jspb.BinaryWriter.prototype.writePackedUint32String = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeUnsignedVarint32(parseInt(s[h], 10));
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedUint64 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeUnsignedVarint64(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedUint64", jspb.BinaryWriter.prototype.writePackedUint64), jspb.BinaryWriter.prototype.writePackedUint64String = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) {
        var c = jspb.arith.UInt64.fromString(s[h]);
        this.encoder_.writeSplitVarint64(c.lo, c.hi);
      }
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedSint32 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeZigzagVarint32(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSint32", jspb.BinaryWriter.prototype.writePackedSint32), jspb.BinaryWriter.prototype.writePackedSint64 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeZigzagVarint64(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSint64", jspb.BinaryWriter.prototype.writePackedSint64), jspb.BinaryWriter.prototype.writePackedSint64String = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(s[h]));
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedSintHash64 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeZigzagVarintHash64(s[h]);
      this.endDelimited_(p);
    }
  }, jspb.BinaryWriter.prototype.writePackedFixed32 = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * s.length), p = 0; p < s.length; p++) this.encoder_.writeUint32(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFixed32", jspb.BinaryWriter.prototype.writePackedFixed32), jspb.BinaryWriter.prototype.writePackedFixed64 = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * s.length), p = 0; p < s.length; p++) this.encoder_.writeUint64(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFixed64", jspb.BinaryWriter.prototype.writePackedFixed64), jspb.BinaryWriter.prototype.writePackedFixed64String = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * s.length), p = 0; p < s.length; p++) {
      var h = jspb.arith.UInt64.fromString(s[p]);
      this.encoder_.writeSplitFixed64(h.lo, h.hi);
    }
  }, jspb.BinaryWriter.prototype.writePackedSfixed32 = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * s.length), p = 0; p < s.length; p++) this.encoder_.writeInt32(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSfixed32", jspb.BinaryWriter.prototype.writePackedSfixed32), jspb.BinaryWriter.prototype.writePackedSfixed64 = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * s.length), p = 0; p < s.length; p++) this.encoder_.writeInt64(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSfixed64", jspb.BinaryWriter.prototype.writePackedSfixed64), jspb.BinaryWriter.prototype.writePackedSfixed64String = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * s.length), p = 0; p < s.length; p++) this.encoder_.writeInt64String(s[p]);
  }, jspb.BinaryWriter.prototype.writePackedFloat = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * s.length), p = 0; p < s.length; p++) this.encoder_.writeFloat(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFloat", jspb.BinaryWriter.prototype.writePackedFloat), jspb.BinaryWriter.prototype.writePackedDouble = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * s.length), p = 0; p < s.length; p++) this.encoder_.writeDouble(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedDouble", jspb.BinaryWriter.prototype.writePackedDouble), jspb.BinaryWriter.prototype.writePackedBool = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(s.length), p = 0; p < s.length; p++) this.encoder_.writeBool(s[p]);
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedBool", jspb.BinaryWriter.prototype.writePackedBool), jspb.BinaryWriter.prototype.writePackedEnum = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeEnum(s[h]);
      this.endDelimited_(p);
    }
  }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedEnum", jspb.BinaryWriter.prototype.writePackedEnum), jspb.BinaryWriter.prototype.writePackedFixedHash64 = function(p, s) {
    if (s != null && s.length) for (this.writeFieldHeader_(p, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * s.length), p = 0; p < s.length; p++) this.encoder_.writeFixedHash64(s[p]);
  }, jspb.BinaryWriter.prototype.writePackedVarintHash64 = function(p, s) {
    if (s != null && s.length) {
      p = this.beginDelimited_(p);
      for (var h = 0; h < s.length; h++) this.encoder_.writeVarintHash64(s[h]);
      this.endDelimited_(p);
    }
  }, jspb.Map = function(p, s) {
    this.arr_ = p, this.valueCtor_ = s, this.map_ = {}, this.arrClean = !0, 0 < this.arr_.length && this.loadFromArray_();
  }, goog.exportSymbol("jspb.Map", jspb.Map), jspb.Map.prototype.loadFromArray_ = function() {
    for (var p = 0; p < this.arr_.length; p++) {
      var s = this.arr_[p], h = s[0];
      this.map_[h.toString()] = new jspb.Map.Entry_(h, s[1]);
    }
    this.arrClean = !0;
  }, jspb.Map.prototype.toArray = function() {
    if (this.arrClean) {
      if (this.valueCtor_) {
        var p = this.map_, s;
        for (s in p) if (Object.prototype.hasOwnProperty.call(p, s)) {
          var h = p[s].valueWrapper;
          h && h.toArray();
        }
      }
    } else {
      for (this.arr_.length = 0, p = this.stringKeys_(), p.sort(), s = 0; s < p.length; s++) {
        var c = this.map_[p[s]];
        (h = c.valueWrapper) && h.toArray(), this.arr_.push([c.key, c.value]);
      }
      this.arrClean = !0;
    }
    return this.arr_;
  }, goog.exportProperty(jspb.Map.prototype, "toArray", jspb.Map.prototype.toArray), jspb.Map.prototype.toObject = function(p, s) {
    for (var h = this.toArray(), c = [], d = 0; d < h.length; d++) {
      var l = this.map_[h[d][0].toString()];
      this.wrapEntry_(l);
      var g = l.valueWrapper;
      g ? (jspb.asserts.assert(s), c.push([l.key, s(p, g)])) : c.push([l.key, l.value]);
    }
    return c;
  }, goog.exportProperty(jspb.Map.prototype, "toObject", jspb.Map.prototype.toObject), jspb.Map.fromObject = function(p, s, h) {
    s = new jspb.Map([], s);
    for (var c = 0; c < p.length; c++) {
      var d = p[c][0], l = h(p[c][1]);
      s.set(d, l);
    }
    return s;
  }, goog.exportProperty(jspb.Map, "fromObject", jspb.Map.fromObject), jspb.Map.ArrayIteratorIterable_ = function(p) {
    this.idx_ = 0, this.arr_ = p;
  }, jspb.Map.ArrayIteratorIterable_.prototype.next = function() {
    return this.idx_ < this.arr_.length ? { done: !1, value: this.arr_[this.idx_++] } : { done: !0, value: void 0 };
  }, typeof Symbol != "undefined" && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
    return this;
  }), jspb.Map.prototype.getLength = function() {
    return this.stringKeys_().length;
  }, goog.exportProperty(jspb.Map.prototype, "getLength", jspb.Map.prototype.getLength), jspb.Map.prototype.clear = function() {
    this.map_ = {}, this.arrClean = !1;
  }, goog.exportProperty(jspb.Map.prototype, "clear", jspb.Map.prototype.clear), jspb.Map.prototype.del = function(p) {
    p = p.toString();
    var s = this.map_.hasOwnProperty(p);
    return delete this.map_[p], this.arrClean = !1, s;
  }, goog.exportProperty(jspb.Map.prototype, "del", jspb.Map.prototype.del), jspb.Map.prototype.getEntryList = function() {
    var p = [], s = this.stringKeys_();
    s.sort();
    for (var h = 0; h < s.length; h++) {
      var c = this.map_[s[h]];
      p.push([c.key, c.value]);
    }
    return p;
  }, goog.exportProperty(jspb.Map.prototype, "getEntryList", jspb.Map.prototype.getEntryList), jspb.Map.prototype.entries = function() {
    var p = [], s = this.stringKeys_();
    s.sort();
    for (var h = 0; h < s.length; h++) {
      var c = this.map_[s[h]];
      p.push([c.key, this.wrapEntry_(c)]);
    }
    return new jspb.Map.ArrayIteratorIterable_(p);
  }, goog.exportProperty(jspb.Map.prototype, "entries", jspb.Map.prototype.entries), jspb.Map.prototype.keys = function() {
    var p = [], s = this.stringKeys_();
    s.sort();
    for (var h = 0; h < s.length; h++) p.push(this.map_[s[h]].key);
    return new jspb.Map.ArrayIteratorIterable_(p);
  }, goog.exportProperty(jspb.Map.prototype, "keys", jspb.Map.prototype.keys), jspb.Map.prototype.values = function() {
    var p = [], s = this.stringKeys_();
    s.sort();
    for (var h = 0; h < s.length; h++) p.push(this.wrapEntry_(this.map_[s[h]]));
    return new jspb.Map.ArrayIteratorIterable_(p);
  }, goog.exportProperty(jspb.Map.prototype, "values", jspb.Map.prototype.values), jspb.Map.prototype.forEach = function(p, s) {
    var h = this.stringKeys_();
    h.sort();
    for (var c = 0; c < h.length; c++) {
      var d = this.map_[h[c]];
      p.call(s, this.wrapEntry_(d), d.key, this);
    }
  }, goog.exportProperty(jspb.Map.prototype, "forEach", jspb.Map.prototype.forEach), jspb.Map.prototype.set = function(p, s) {
    var h = new jspb.Map.Entry_(p);
    return this.valueCtor_ ? (h.valueWrapper = s, h.value = s.toArray()) : h.value = s, this.map_[p.toString()] = h, this.arrClean = !1, this;
  }, goog.exportProperty(jspb.Map.prototype, "set", jspb.Map.prototype.set), jspb.Map.prototype.wrapEntry_ = function(p) {
    return this.valueCtor_ ? (p.valueWrapper || (p.valueWrapper = new this.valueCtor_(p.value)), p.valueWrapper) : p.value;
  }, jspb.Map.prototype.get = function(p) {
    if (p = this.map_[p.toString()]) return this.wrapEntry_(p);
  }, goog.exportProperty(jspb.Map.prototype, "get", jspb.Map.prototype.get), jspb.Map.prototype.has = function(p) {
    return p.toString() in this.map_;
  }, goog.exportProperty(jspb.Map.prototype, "has", jspb.Map.prototype.has), jspb.Map.prototype.serializeBinary = function(p, s, h, c, d) {
    var l = this.stringKeys_();
    l.sort();
    for (var g = 0; g < l.length; g++) {
      var f = this.map_[l[g]];
      s.beginSubMessage(p), h.call(s, 1, f.key), this.valueCtor_ ? c.call(s, 2, this.wrapEntry_(f), d) : c.call(s, 2, f.value), s.endSubMessage();
    }
  }, goog.exportProperty(jspb.Map.prototype, "serializeBinary", jspb.Map.prototype.serializeBinary), jspb.Map.deserializeBinary = function(p, s, h, c, d, l, g) {
    for (; s.nextField() && !s.isEndGroup(); ) {
      var f = s.getFieldNumber();
      f == 1 ? l = h.call(s) : f == 2 && (p.valueCtor_ ? (jspb.asserts.assert(d), g || (g = new p.valueCtor_()), c.call(s, g, d)) : g = c.call(s));
    }
    jspb.asserts.assert(l != null), jspb.asserts.assert(g != null), p.set(l, g);
  }, goog.exportProperty(jspb.Map, "deserializeBinary", jspb.Map.deserializeBinary), jspb.Map.prototype.stringKeys_ = function() {
    var p = this.map_, s = [], h;
    for (h in p) Object.prototype.hasOwnProperty.call(p, h) && s.push(h);
    return s;
  }, jspb.Map.Entry_ = function(p, s) {
    this.key = p, this.value = s, this.valueWrapper = void 0;
  }, jspb.ExtensionFieldInfo = function(p, s, h, c, d) {
    this.fieldIndex = p, this.fieldName = s, this.ctor = h, this.toObjectFn = c, this.isRepeated = d;
  }, goog.exportSymbol("jspb.ExtensionFieldInfo", jspb.ExtensionFieldInfo), jspb.ExtensionFieldBinaryInfo = function(p, s, h, c, d, l) {
    this.fieldInfo = p, this.binaryReaderFn = s, this.binaryWriterFn = h, this.binaryMessageSerializeFn = c, this.binaryMessageDeserializeFn = d, this.isPacked = l;
  }, goog.exportSymbol("jspb.ExtensionFieldBinaryInfo", jspb.ExtensionFieldBinaryInfo), jspb.ExtensionFieldInfo.prototype.isMessageType = function() {
    return !!this.ctor;
  }, goog.exportProperty(jspb.ExtensionFieldInfo.prototype, "isMessageType", jspb.ExtensionFieldInfo.prototype.isMessageType), jspb.Message = function() {
  }, goog.exportSymbol("jspb.Message", jspb.Message), jspb.Message.GENERATE_TO_OBJECT = !0, goog.exportProperty(jspb.Message, "GENERATE_TO_OBJECT", jspb.Message.GENERATE_TO_OBJECT), jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE, goog.exportProperty(jspb.Message, "GENERATE_FROM_OBJECT", jspb.Message.GENERATE_FROM_OBJECT), jspb.Message.GENERATE_TO_STRING = !0, jspb.Message.ASSUME_LOCAL_ARRAYS = !1, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0, jspb.Message.SUPPORTS_UINT8ARRAY_ = typeof Uint8Array == "function", jspb.Message.prototype.getJsPbMessageId = function() {
    return this.messageId_;
  }, goog.exportProperty(jspb.Message.prototype, "getJsPbMessageId", jspb.Message.prototype.getJsPbMessageId), jspb.Message.getIndex_ = function(p, s) {
    return s + p.arrayIndexOffset_;
  }, jspb.Message.hiddenES6Property_ = function() {
  }, jspb.Message.getFieldNumber_ = function(p, s) {
    return s - p.arrayIndexOffset_;
  }, jspb.Message.initialize = function(p, s, h, c, d, l) {
    if (p.wrappers_ = null, s || (s = h ? [h] : []), p.messageId_ = h ? String(h) : void 0, p.arrayIndexOffset_ = h === 0 ? -1 : 0, p.array = s, jspb.Message.initPivotAndExtensionObject_(p, c), p.convertedPrimitiveFields_ = {}, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (p.repeatedFields = d), d) for (s = 0; s < d.length; s++) h = d[s], h < p.pivot_ ? (h = jspb.Message.getIndex_(p, h), p.array[h] = p.array[h] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(p), p.extensionObject_[h] = p.extensionObject_[h] || jspb.Message.EMPTY_LIST_SENTINEL_);
    if (l && l.length) for (s = 0; s < l.length; s++) jspb.Message.computeOneofCase(p, l[s]);
  }, goog.exportProperty(jspb.Message, "initialize", jspb.Message.initialize), jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [], jspb.Message.isArray_ = function(p) {
    return jspb.Message.ASSUME_LOCAL_ARRAYS ? p instanceof Array : Array.isArray(p);
  }, jspb.Message.isExtensionObject_ = function(p) {
    return p !== null && typeof p == "object" && !jspb.Message.isArray_(p) && !(jspb.Message.SUPPORTS_UINT8ARRAY_ && p instanceof Uint8Array);
  }, jspb.Message.initPivotAndExtensionObject_ = function(p, s) {
    var h = p.array.length, c = -1;
    if (h && (c = h - 1, h = p.array[c], jspb.Message.isExtensionObject_(h))) {
      p.pivot_ = jspb.Message.getFieldNumber_(p, c), p.extensionObject_ = h;
      return;
    }
    -1 < s ? (p.pivot_ = Math.max(s, jspb.Message.getFieldNumber_(p, c + 1)), p.extensionObject_ = null) : p.pivot_ = Number.MAX_VALUE;
  }, jspb.Message.maybeInitEmptyExtensionObject_ = function(p) {
    var s = jspb.Message.getIndex_(p, p.pivot_);
    p.array[s] || (p.extensionObject_ = p.array[s] = {});
  }, jspb.Message.toObjectList = function(p, s, h) {
    for (var c = [], d = 0; d < p.length; d++) c[d] = s.call(p[d], h, p[d]);
    return c;
  }, goog.exportProperty(jspb.Message, "toObjectList", jspb.Message.toObjectList), jspb.Message.toObjectExtension = function(p, s, h, c, d) {
    for (var l in h) {
      var g = h[l], f = c.call(p, g);
      if (f != null) {
        for (var _ in g.fieldName) if (g.fieldName.hasOwnProperty(_)) break;
        s[_] = g.toObjectFn ? g.isRepeated ? jspb.Message.toObjectList(f, g.toObjectFn, d) : g.toObjectFn(d, f) : f;
      }
    }
  }, goog.exportProperty(jspb.Message, "toObjectExtension", jspb.Message.toObjectExtension), jspb.Message.serializeBinaryExtensions = function(p, s, h, c) {
    for (var d in h) {
      var l = h[d], g = l.fieldInfo;
      if (!l.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
      var f = c.call(p, g);
      if (f != null) if (g.isMessageType()) if (l.binaryMessageSerializeFn) l.binaryWriterFn.call(s, g.fieldIndex, f, l.binaryMessageSerializeFn);
      else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
      else l.binaryWriterFn.call(s, g.fieldIndex, f);
    }
  }, goog.exportProperty(jspb.Message, "serializeBinaryExtensions", jspb.Message.serializeBinaryExtensions), jspb.Message.readBinaryExtension = function(p, s, h, c, d) {
    var l = h[s.getFieldNumber()];
    if (l) {
      if (h = l.fieldInfo, !l.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");
      if (h.isMessageType()) {
        var g = new h.ctor();
        l.binaryReaderFn.call(s, g, l.binaryMessageDeserializeFn);
      } else g = l.binaryReaderFn.call(s);
      h.isRepeated && !l.isPacked ? (s = c.call(p, h)) ? s.push(g) : d.call(p, h, [g]) : d.call(p, h, g);
    } else s.skipField();
  }, goog.exportProperty(jspb.Message, "readBinaryExtension", jspb.Message.readBinaryExtension), jspb.Message.getField = function(p, s) {
    if (s < p.pivot_) {
      s = jspb.Message.getIndex_(p, s);
      var h = p.array[s];
      return h === jspb.Message.EMPTY_LIST_SENTINEL_ ? p.array[s] = [] : h;
    }
    if (p.extensionObject_) return h = p.extensionObject_[s], h === jspb.Message.EMPTY_LIST_SENTINEL_ ? p.extensionObject_[s] = [] : h;
  }, goog.exportProperty(jspb.Message, "getField", jspb.Message.getField), jspb.Message.getRepeatedField = function(p, s) {
    return jspb.Message.getField(p, s);
  }, goog.exportProperty(jspb.Message, "getRepeatedField", jspb.Message.getRepeatedField), jspb.Message.getOptionalFloatingPointField = function(p, s) {
    return p = jspb.Message.getField(p, s), p == null ? p : +p;
  }, goog.exportProperty(jspb.Message, "getOptionalFloatingPointField", jspb.Message.getOptionalFloatingPointField), jspb.Message.getBooleanField = function(p, s) {
    return p = jspb.Message.getField(p, s), p == null ? p : !!p;
  }, goog.exportProperty(jspb.Message, "getBooleanField", jspb.Message.getBooleanField), jspb.Message.getRepeatedFloatingPointField = function(p, s) {
    var h = jspb.Message.getRepeatedField(p, s);
    if (p.convertedPrimitiveFields_ || (p.convertedPrimitiveFields_ = {}), !p.convertedPrimitiveFields_[s]) {
      for (var c = 0; c < h.length; c++) h[c] = +h[c];
      p.convertedPrimitiveFields_[s] = !0;
    }
    return h;
  }, goog.exportProperty(jspb.Message, "getRepeatedFloatingPointField", jspb.Message.getRepeatedFloatingPointField), jspb.Message.getRepeatedBooleanField = function(p, s) {
    var h = jspb.Message.getRepeatedField(p, s);
    if (p.convertedPrimitiveFields_ || (p.convertedPrimitiveFields_ = {}), !p.convertedPrimitiveFields_[s]) {
      for (var c = 0; c < h.length; c++) h[c] = !!h[c];
      p.convertedPrimitiveFields_[s] = !0;
    }
    return h;
  }, goog.exportProperty(jspb.Message, "getRepeatedBooleanField", jspb.Message.getRepeatedBooleanField), jspb.Message.bytesAsB64 = function(p) {
    return p == null || typeof p == "string" ? p : jspb.Message.SUPPORTS_UINT8ARRAY_ && p instanceof Uint8Array ? goog.crypt.base64.encodeByteArray(p) : (jspb.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(p)), null);
  }, goog.exportProperty(jspb.Message, "bytesAsB64", jspb.Message.bytesAsB64), jspb.Message.bytesAsU8 = function(p) {
    return p == null || p instanceof Uint8Array ? p : typeof p == "string" ? goog.crypt.base64.decodeStringToUint8Array(p) : (jspb.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(p)), null);
  }, goog.exportProperty(jspb.Message, "bytesAsU8", jspb.Message.bytesAsU8), jspb.Message.bytesListAsB64 = function(p) {
    return jspb.Message.assertConsistentTypes_(p), p.length && typeof p[0] != "string" ? goog.array.map(p, jspb.Message.bytesAsB64) : p;
  }, goog.exportProperty(jspb.Message, "bytesListAsB64", jspb.Message.bytesListAsB64), jspb.Message.bytesListAsU8 = function(p) {
    return jspb.Message.assertConsistentTypes_(p), !p.length || p[0] instanceof Uint8Array ? p : goog.array.map(p, jspb.Message.bytesAsU8);
  }, goog.exportProperty(jspb.Message, "bytesListAsU8", jspb.Message.bytesListAsU8), jspb.Message.assertConsistentTypes_ = function(p) {
    if (goog.DEBUG && p && 1 < p.length) {
      var s = goog.typeOf(p[0]);
      goog.array.forEach(p, function(h) {
        goog.typeOf(h) != s && jspb.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(h) + " expected " + s);
      });
    }
  }, jspb.Message.getFieldWithDefault = function(p, s, h) {
    return p = jspb.Message.getField(p, s), p == null ? h : p;
  }, goog.exportProperty(jspb.Message, "getFieldWithDefault", jspb.Message.getFieldWithDefault), jspb.Message.getBooleanFieldWithDefault = function(p, s, h) {
    return p = jspb.Message.getBooleanField(p, s), p == null ? h : p;
  }, goog.exportProperty(jspb.Message, "getBooleanFieldWithDefault", jspb.Message.getBooleanFieldWithDefault), jspb.Message.getFloatingPointFieldWithDefault = function(p, s, h) {
    return p = jspb.Message.getOptionalFloatingPointField(p, s), p == null ? h : p;
  }, goog.exportProperty(jspb.Message, "getFloatingPointFieldWithDefault", jspb.Message.getFloatingPointFieldWithDefault), jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault, goog.exportProperty(jspb.Message, "getFieldProto3", jspb.Message.getFieldProto3), jspb.Message.getMapField = function(p, s, h, c) {
    if (p.wrappers_ || (p.wrappers_ = {}), s in p.wrappers_) return p.wrappers_[s];
    var d = jspb.Message.getField(p, s);
    if (!d) {
      if (h) return;
      d = [], jspb.Message.setField(p, s, d);
    }
    return p.wrappers_[s] = new jspb.Map(d, c);
  }, goog.exportProperty(jspb.Message, "getMapField", jspb.Message.getMapField), jspb.Message.setField = function(p, s, h) {
    return jspb.asserts.assertInstanceof(p, jspb.Message), s < p.pivot_ ? p.array[jspb.Message.getIndex_(p, s)] = h : (jspb.Message.maybeInitEmptyExtensionObject_(p), p.extensionObject_[s] = h), p;
  }, goog.exportProperty(jspb.Message, "setField", jspb.Message.setField), jspb.Message.setProto3IntField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, 0);
  }, goog.exportProperty(jspb.Message, "setProto3IntField", jspb.Message.setProto3IntField), jspb.Message.setProto3FloatField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, 0);
  }, goog.exportProperty(jspb.Message, "setProto3FloatField", jspb.Message.setProto3FloatField), jspb.Message.setProto3BooleanField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, !1);
  }, goog.exportProperty(jspb.Message, "setProto3BooleanField", jspb.Message.setProto3BooleanField), jspb.Message.setProto3StringField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, "");
  }, goog.exportProperty(jspb.Message, "setProto3StringField", jspb.Message.setProto3StringField), jspb.Message.setProto3BytesField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, "");
  }, goog.exportProperty(jspb.Message, "setProto3BytesField", jspb.Message.setProto3BytesField), jspb.Message.setProto3EnumField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, 0);
  }, goog.exportProperty(jspb.Message, "setProto3EnumField", jspb.Message.setProto3EnumField), jspb.Message.setProto3StringIntField = function(p, s, h) {
    return jspb.Message.setFieldIgnoringDefault_(p, s, h, "0");
  }, goog.exportProperty(jspb.Message, "setProto3StringIntField", jspb.Message.setProto3StringIntField), jspb.Message.setFieldIgnoringDefault_ = function(p, s, h, c) {
    return jspb.asserts.assertInstanceof(p, jspb.Message), h !== c ? jspb.Message.setField(p, s, h) : s < p.pivot_ ? p.array[jspb.Message.getIndex_(p, s)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(p), delete p.extensionObject_[s]), p;
  }, jspb.Message.addToRepeatedField = function(p, s, h, c) {
    return jspb.asserts.assertInstanceof(p, jspb.Message), s = jspb.Message.getRepeatedField(p, s), c != null ? s.splice(c, 0, h) : s.push(h), p;
  }, goog.exportProperty(jspb.Message, "addToRepeatedField", jspb.Message.addToRepeatedField), jspb.Message.setOneofField = function(p, s, h, c) {
    return jspb.asserts.assertInstanceof(p, jspb.Message), (h = jspb.Message.computeOneofCase(p, h)) && h !== s && c !== void 0 && (p.wrappers_ && h in p.wrappers_ && (p.wrappers_[h] = void 0), jspb.Message.setField(p, h, void 0)), jspb.Message.setField(p, s, c);
  }, goog.exportProperty(jspb.Message, "setOneofField", jspb.Message.setOneofField), jspb.Message.computeOneofCase = function(p, s) {
    for (var h, c, d = 0; d < s.length; d++) {
      var l = s[d], g = jspb.Message.getField(p, l);
      g != null && (h = l, c = g, jspb.Message.setField(p, l, void 0));
    }
    return h ? (jspb.Message.setField(p, h, c), h) : 0;
  }, goog.exportProperty(jspb.Message, "computeOneofCase", jspb.Message.computeOneofCase), jspb.Message.getWrapperField = function(p, s, h, c) {
    if (p.wrappers_ || (p.wrappers_ = {}), !p.wrappers_[h]) {
      var d = jspb.Message.getField(p, h);
      (c || d) && (p.wrappers_[h] = new s(d));
    }
    return p.wrappers_[h];
  }, goog.exportProperty(jspb.Message, "getWrapperField", jspb.Message.getWrapperField), jspb.Message.getRepeatedWrapperField = function(p, s, h) {
    return jspb.Message.wrapRepeatedField_(p, s, h), s = p.wrappers_[h], s == jspb.Message.EMPTY_LIST_SENTINEL_ && (s = p.wrappers_[h] = []), s;
  }, goog.exportProperty(jspb.Message, "getRepeatedWrapperField", jspb.Message.getRepeatedWrapperField), jspb.Message.wrapRepeatedField_ = function(p, s, h) {
    if (p.wrappers_ || (p.wrappers_ = {}), !p.wrappers_[h]) {
      for (var c = jspb.Message.getRepeatedField(p, h), d = [], l = 0; l < c.length; l++) d[l] = new s(c[l]);
      p.wrappers_[h] = d;
    }
  }, jspb.Message.setWrapperField = function(p, s, h) {
    jspb.asserts.assertInstanceof(p, jspb.Message), p.wrappers_ || (p.wrappers_ = {});
    var c = h && h.toArray();
    return p.wrappers_[s] = h, jspb.Message.setField(p, s, c);
  }, goog.exportProperty(jspb.Message, "setWrapperField", jspb.Message.setWrapperField), jspb.Message.setOneofWrapperField = function(p, s, h, c) {
    jspb.asserts.assertInstanceof(p, jspb.Message), p.wrappers_ || (p.wrappers_ = {});
    var d = c && c.toArray();
    return p.wrappers_[s] = c, jspb.Message.setOneofField(p, s, h, d);
  }, goog.exportProperty(jspb.Message, "setOneofWrapperField", jspb.Message.setOneofWrapperField), jspb.Message.setRepeatedWrapperField = function(p, s, h) {
    jspb.asserts.assertInstanceof(p, jspb.Message), p.wrappers_ || (p.wrappers_ = {}), h = h || [];
    for (var c = [], d = 0; d < h.length; d++) c[d] = h[d].toArray();
    return p.wrappers_[s] = h, jspb.Message.setField(p, s, c);
  }, goog.exportProperty(jspb.Message, "setRepeatedWrapperField", jspb.Message.setRepeatedWrapperField), jspb.Message.addToRepeatedWrapperField = function(p, s, h, c, d) {
    jspb.Message.wrapRepeatedField_(p, c, s);
    var l = p.wrappers_[s];
    return l || (l = p.wrappers_[s] = []), h = h || new c(), p = jspb.Message.getRepeatedField(p, s), d != null ? (l.splice(d, 0, h), p.splice(d, 0, h.toArray())) : (l.push(h), p.push(h.toArray())), h;
  }, goog.exportProperty(jspb.Message, "addToRepeatedWrapperField", jspb.Message.addToRepeatedWrapperField), jspb.Message.toMap = function(p, s, h, c) {
    for (var d = {}, l = 0; l < p.length; l++) d[s.call(p[l])] = h ? h.call(p[l], c, p[l]) : p[l];
    return d;
  }, goog.exportProperty(jspb.Message, "toMap", jspb.Message.toMap), jspb.Message.prototype.syncMapFields_ = function() {
    if (this.wrappers_) for (var p in this.wrappers_) {
      var s = this.wrappers_[p];
      if (Array.isArray(s)) for (var h = 0; h < s.length; h++) s[h] && s[h].toArray();
      else s && s.toArray();
    }
  }, jspb.Message.prototype.toArray = function() {
    return this.syncMapFields_(), this.array;
  }, goog.exportProperty(jspb.Message.prototype, "toArray", jspb.Message.prototype.toArray), jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function() {
    return this.syncMapFields_(), this.array.toString();
  }), jspb.Message.prototype.getExtension = function(p) {
    if (this.extensionObject_) {
      this.wrappers_ || (this.wrappers_ = {});
      var s = p.fieldIndex;
      if (p.isRepeated) {
        if (p.isMessageType()) return this.wrappers_[s] || (this.wrappers_[s] = goog.array.map(this.extensionObject_[s] || [], function(h) {
          return new p.ctor(h);
        })), this.wrappers_[s];
      } else if (p.isMessageType()) return !this.wrappers_[s] && this.extensionObject_[s] && (this.wrappers_[s] = new p.ctor(this.extensionObject_[s])), this.wrappers_[s];
      return this.extensionObject_[s];
    }
  }, goog.exportProperty(jspb.Message.prototype, "getExtension", jspb.Message.prototype.getExtension), jspb.Message.prototype.setExtension = function(p, s) {
    this.wrappers_ || (this.wrappers_ = {}), jspb.Message.maybeInitEmptyExtensionObject_(this);
    var h = p.fieldIndex;
    return p.isRepeated ? (s = s || [], p.isMessageType() ? (this.wrappers_[h] = s, this.extensionObject_[h] = goog.array.map(s, function(c) {
      return c.toArray();
    })) : this.extensionObject_[h] = s) : p.isMessageType() ? (this.wrappers_[h] = s, this.extensionObject_[h] = s && s.toArray()) : this.extensionObject_[h] = s, this;
  }, goog.exportProperty(jspb.Message.prototype, "setExtension", jspb.Message.prototype.setExtension), jspb.Message.difference = function(p, s) {
    if (!(p instanceof s.constructor)) throw Error("Messages have different types.");
    var h = p.toArray();
    s = s.toArray();
    var c = [], d = 0, l = h.length > s.length ? h.length : s.length;
    for (p.getJsPbMessageId() && (c[0] = p.getJsPbMessageId(), d = 1); d < l; d++) jspb.Message.compareFields(h[d], s[d]) || (c[d] = s[d]);
    return new p.constructor(c);
  }, goog.exportProperty(jspb.Message, "difference", jspb.Message.difference), jspb.Message.equals = function(p, s) {
    return p == s || !(!p || !s) && p instanceof s.constructor && jspb.Message.compareFields(p.toArray(), s.toArray());
  }, goog.exportProperty(jspb.Message, "equals", jspb.Message.equals), jspb.Message.compareExtensions = function(p, s) {
    p = p || {}, s = s || {};
    var h = {}, c;
    for (c in p) h[c] = 0;
    for (c in s) h[c] = 0;
    for (c in h) if (!jspb.Message.compareFields(p[c], s[c])) return !1;
    return !0;
  }, goog.exportProperty(jspb.Message, "compareExtensions", jspb.Message.compareExtensions), jspb.Message.compareFields = function(p, s) {
    if (p == s) return !0;
    if (!goog.isObject(p) || !goog.isObject(s)) return typeof p == "number" && isNaN(p) || typeof s == "number" && isNaN(s) ? String(p) == String(s) : !1;
    if (p.constructor != s.constructor) return !1;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && p.constructor === Uint8Array) {
      if (p.length != s.length) return !1;
      for (var h = 0; h < p.length; h++) if (p[h] != s[h]) return !1;
      return !0;
    }
    if (p.constructor === Array) {
      var c = void 0, d = void 0, l = Math.max(p.length, s.length);
      for (h = 0; h < l; h++) {
        var g = p[h], f = s[h];
        if (g && g.constructor == Object && (jspb.asserts.assert(c === void 0), jspb.asserts.assert(h === p.length - 1), c = g, g = void 0), f && f.constructor == Object && (jspb.asserts.assert(d === void 0), jspb.asserts.assert(h === s.length - 1), d = f, f = void 0), !jspb.Message.compareFields(g, f)) return !1;
      }
      return c || d ? (c = c || {}, d = d || {}, jspb.Message.compareExtensions(c, d)) : !0;
    }
    if (p.constructor === Object) return jspb.Message.compareExtensions(p, s);
    throw Error("Invalid type in JSPB array");
  }, goog.exportProperty(jspb.Message, "compareFields", jspb.Message.compareFields), jspb.Message.prototype.cloneMessage = function() {
    return jspb.Message.cloneMessage(this);
  }, goog.exportProperty(jspb.Message.prototype, "cloneMessage", jspb.Message.prototype.cloneMessage), jspb.Message.prototype.clone = function() {
    return jspb.Message.cloneMessage(this);
  }, goog.exportProperty(jspb.Message.prototype, "clone", jspb.Message.prototype.clone), jspb.Message.clone = function(p) {
    return jspb.Message.cloneMessage(p);
  }, goog.exportProperty(jspb.Message, "clone", jspb.Message.clone), jspb.Message.cloneMessage = function(p) {
    return new p.constructor(jspb.Message.clone_(p.toArray()));
  }, jspb.Message.copyInto = function(p, s) {
    jspb.asserts.assertInstanceof(p, jspb.Message), jspb.asserts.assertInstanceof(s, jspb.Message), jspb.asserts.assert(p.constructor == s.constructor, "Copy source and target message should have the same type."), p = jspb.Message.clone(p);
    for (var h = s.toArray(), c = p.toArray(), d = h.length = 0; d < c.length; d++) h[d] = c[d];
    s.wrappers_ = p.wrappers_, s.extensionObject_ = p.extensionObject_;
  }, goog.exportProperty(jspb.Message, "copyInto", jspb.Message.copyInto), jspb.Message.clone_ = function(p) {
    if (Array.isArray(p)) {
      for (var s = Array(p.length), h = 0; h < p.length; h++) {
        var c = p[h];
        c != null && (s[h] = typeof c == "object" ? jspb.Message.clone_(jspb.asserts.assert(c)) : c);
      }
      return s;
    }
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && p instanceof Uint8Array) return new Uint8Array(p);
    s = {};
    for (h in p) c = p[h], c != null && (s[h] = typeof c == "object" ? jspb.Message.clone_(jspb.asserts.assert(c)) : c);
    return s;
  }, jspb.Message.registerMessageType = function(p, s) {
    s.messageId = p;
  }, goog.exportProperty(jspb.Message, "registerMessageType", jspb.Message.registerMessageType), jspb.Message.messageSetExtensions = {}, jspb.Message.messageSetExtensionsBinary = {}, jspb.Export = {}, exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = { extend: goog.object.extend }, exports.typeOf = goog.typeOf;
})(googleProtobuf);
var common_pb$2 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("Absent", null, c), h.exportSymbol("AbsentOrEqual", null, c), h.exportSymbol("Equal", null, c), h.exportSymbol("NotEqual", null, c), h.exportSymbol("Present", null, c), h.exportSymbol("PresentAndNotEqual", null, c), h.exportSymbol("_Empty", null, c), h.exportSymbol("_Unbounded", null, c), c.Present = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.Present, s.Message), h.DEBUG && !COMPILED && (c.Present.displayName = "proto.Present"), c.PresentAndNotEqual = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.PresentAndNotEqual, s.Message), h.DEBUG && !COMPILED && (c.PresentAndNotEqual.displayName = "proto.PresentAndNotEqual"), c.Absent = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.Absent, s.Message), h.DEBUG && !COMPILED && (c.Absent.displayName = "proto.Absent"), c.Equal = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.Equal, s.Message), h.DEBUG && !COMPILED && (c.Equal.displayName = "proto.Equal"), c.AbsentOrEqual = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.AbsentOrEqual, s.Message), h.DEBUG && !COMPILED && (c.AbsentOrEqual.displayName = "proto.AbsentOrEqual"), c.NotEqual = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.NotEqual, s.Message), h.DEBUG && !COMPILED && (c.NotEqual.displayName = "proto.NotEqual"), c._Unbounded = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._Unbounded, s.Message), h.DEBUG && !COMPILED && (c._Unbounded.displayName = "proto._Unbounded"), c._Empty = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._Empty, s.Message), h.DEBUG && !COMPILED && (c._Empty.displayName = "proto._Empty"), s.Message.GENERATE_TO_OBJECT && (c.Present.prototype.toObject = function(d) {
    return c.Present.toObject(d, this);
  }, c.Present.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c.Present.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.Present();
    return c.Present.deserializeBinaryFromReader(g, l);
  }, c.Present.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.Present.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.Present.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.Present.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c.PresentAndNotEqual.prototype.toObject = function(d) {
    return c.PresentAndNotEqual.toObject(d, this);
  }, c.PresentAndNotEqual.toObject = function(d, l) {
    var g = {
      valueToCheck: l.getValueToCheck_asB64()
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.PresentAndNotEqual.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PresentAndNotEqual();
    return c.PresentAndNotEqual.deserializeBinaryFromReader(g, l);
  }, c.PresentAndNotEqual.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setValueToCheck(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PresentAndNotEqual.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PresentAndNotEqual.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PresentAndNotEqual.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getValueToCheck_asU8(), g.length > 0 && l.writeBytes(
      1,
      g
    );
  }, c.PresentAndNotEqual.prototype.getValueToCheck = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.PresentAndNotEqual.prototype.getValueToCheck_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValueToCheck()
      )
    );
  }, c.PresentAndNotEqual.prototype.getValueToCheck_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValueToCheck()
      )
    );
  }, c.PresentAndNotEqual.prototype.setValueToCheck = function(d) {
    return s.Message.setProto3BytesField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c.Absent.prototype.toObject = function(d) {
    return c.Absent.toObject(d, this);
  }, c.Absent.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c.Absent.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.Absent();
    return c.Absent.deserializeBinaryFromReader(g, l);
  }, c.Absent.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.Absent.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.Absent.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.Absent.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c.Equal.prototype.toObject = function(d) {
    return c.Equal.toObject(d, this);
  }, c.Equal.toObject = function(d, l) {
    var g = {
      valueToCheck: l.getValueToCheck_asB64()
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.Equal.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.Equal();
    return c.Equal.deserializeBinaryFromReader(g, l);
  }, c.Equal.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setValueToCheck(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.Equal.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.Equal.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.Equal.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getValueToCheck_asU8(), g.length > 0 && l.writeBytes(
      1,
      g
    );
  }, c.Equal.prototype.getValueToCheck = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.Equal.prototype.getValueToCheck_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValueToCheck()
      )
    );
  }, c.Equal.prototype.getValueToCheck_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValueToCheck()
      )
    );
  }, c.Equal.prototype.setValueToCheck = function(d) {
    return s.Message.setProto3BytesField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c.AbsentOrEqual.prototype.toObject = function(d) {
    return c.AbsentOrEqual.toObject(d, this);
  }, c.AbsentOrEqual.toObject = function(d, l) {
    var g = {
      valueToCheck: l.getValueToCheck_asB64()
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.AbsentOrEqual.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.AbsentOrEqual();
    return c.AbsentOrEqual.deserializeBinaryFromReader(g, l);
  }, c.AbsentOrEqual.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setValueToCheck(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.AbsentOrEqual.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.AbsentOrEqual.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.AbsentOrEqual.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getValueToCheck_asU8(), g.length > 0 && l.writeBytes(
      1,
      g
    );
  }, c.AbsentOrEqual.prototype.getValueToCheck = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.AbsentOrEqual.prototype.getValueToCheck_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValueToCheck()
      )
    );
  }, c.AbsentOrEqual.prototype.getValueToCheck_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValueToCheck()
      )
    );
  }, c.AbsentOrEqual.prototype.setValueToCheck = function(d) {
    return s.Message.setProto3BytesField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c.NotEqual.prototype.toObject = function(d) {
    return c.NotEqual.toObject(d, this);
  }, c.NotEqual.toObject = function(d, l) {
    var g = {
      valueToCheck: l.getValueToCheck_asB64()
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.NotEqual.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.NotEqual();
    return c.NotEqual.deserializeBinaryFromReader(g, l);
  }, c.NotEqual.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setValueToCheck(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.NotEqual.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.NotEqual.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.NotEqual.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getValueToCheck_asU8(), g.length > 0 && l.writeBytes(
      1,
      g
    );
  }, c.NotEqual.prototype.getValueToCheck = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.NotEqual.prototype.getValueToCheck_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValueToCheck()
      )
    );
  }, c.NotEqual.prototype.getValueToCheck_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValueToCheck()
      )
    );
  }, c.NotEqual.prototype.setValueToCheck = function(d) {
    return s.Message.setProto3BytesField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._Unbounded.prototype.toObject = function(d) {
    return c._Unbounded.toObject(d, this);
  }, c._Unbounded.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._Unbounded.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._Unbounded();
    return c._Unbounded.deserializeBinaryFromReader(g, l);
  }, c._Unbounded.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._Unbounded.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._Unbounded.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._Unbounded.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._Empty.prototype.toObject = function(d) {
    return c._Empty.toObject(d, this);
  }, c._Empty.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._Empty.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._Empty();
    return c._Empty.deserializeBinaryFromReader(g, l);
  }, c._Empty.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._Empty.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._Empty.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._Empty.serializeBinaryToWriter = function(d, l) {
  }, h.object.extend(p, c);
})(common_pb$2);
(function(p) {
  var s = googleProtobuf, h = s, c = {}, d = common_pb$2;
  h.object.extend(c, d), h.exportSymbol("ECacheResult", null, c), h.exportSymbol("_DeleteRequest", null, c), h.exportSymbol("_DeleteResponse", null, c), h.exportSymbol("_DictionaryDeleteRequest", null, c), h.exportSymbol("_DictionaryDeleteRequest.All", null, c), h.exportSymbol("_DictionaryDeleteRequest.DeleteCase", null, c), h.exportSymbol("_DictionaryDeleteRequest.Some", null, c), h.exportSymbol("_DictionaryDeleteResponse", null, c), h.exportSymbol("_DictionaryFetchRequest", null, c), h.exportSymbol("_DictionaryFetchResponse", null, c), h.exportSymbol("_DictionaryFetchResponse.DictionaryCase", null, c), h.exportSymbol("_DictionaryFetchResponse._Found", null, c), h.exportSymbol("_DictionaryFetchResponse._Missing", null, c), h.exportSymbol("_DictionaryFieldValuePair", null, c), h.exportSymbol("_DictionaryGetRequest", null, c), h.exportSymbol("_DictionaryGetResponse", null, c), h.exportSymbol("_DictionaryGetResponse.DictionaryCase", null, c), h.exportSymbol("_DictionaryGetResponse._DictionaryGetResponsePart", null, c), h.exportSymbol("_DictionaryGetResponse._Found", null, c), h.exportSymbol("_DictionaryGetResponse._Missing", null, c), h.exportSymbol("_DictionaryIncrementRequest", null, c), h.exportSymbol("_DictionaryIncrementResponse", null, c), h.exportSymbol("_DictionaryLengthRequest", null, c), h.exportSymbol("_DictionaryLengthResponse", null, c), h.exportSymbol("_DictionaryLengthResponse.DictionaryCase", null, c), h.exportSymbol("_DictionaryLengthResponse._Found", null, c), h.exportSymbol("_DictionaryLengthResponse._Missing", null, c), h.exportSymbol("_DictionarySetRequest", null, c), h.exportSymbol("_DictionarySetResponse", null, c), h.exportSymbol("_GetBatchRequest", null, c), h.exportSymbol("_GetRequest", null, c), h.exportSymbol("_GetResponse", null, c), h.exportSymbol("_IncrementRequest", null, c), h.exportSymbol("_IncrementResponse", null, c), h.exportSymbol("_ItemGetTtlRequest", null, c), h.exportSymbol("_ItemGetTtlResponse", null, c), h.exportSymbol("_ItemGetTtlResponse.ResultCase", null, c), h.exportSymbol("_ItemGetTtlResponse._Found", null, c), h.exportSymbol("_ItemGetTtlResponse._Missing", null, c), h.exportSymbol("_ItemGetTypeRequest", null, c), h.exportSymbol("_ItemGetTypeResponse", null, c), h.exportSymbol("_ItemGetTypeResponse.ItemType", null, c), h.exportSymbol("_ItemGetTypeResponse.ResultCase", null, c), h.exportSymbol("_ItemGetTypeResponse._Found", null, c), h.exportSymbol("_ItemGetTypeResponse._Missing", null, c), h.exportSymbol("_KeysExistRequest", null, c), h.exportSymbol("_KeysExistResponse", null, c), h.exportSymbol("_ListConcatenateBackRequest", null, c), h.exportSymbol("_ListConcatenateBackResponse", null, c), h.exportSymbol("_ListConcatenateFrontRequest", null, c), h.exportSymbol("_ListConcatenateFrontResponse", null, c), h.exportSymbol("_ListEraseRequest", null, c), h.exportSymbol("_ListEraseRequest.EraseCase", null, c), h.exportSymbol("_ListEraseRequest._All", null, c), h.exportSymbol("_ListEraseRequest._ListRanges", null, c), h.exportSymbol("_ListEraseResponse", null, c), h.exportSymbol("_ListEraseResponse.ListCase", null, c), h.exportSymbol("_ListEraseResponse._Found", null, c), h.exportSymbol("_ListEraseResponse._Missing", null, c), h.exportSymbol("_ListFetchRequest", null, c), h.exportSymbol("_ListFetchRequest.EndIndexCase", null, c), h.exportSymbol("_ListFetchRequest.StartIndexCase", null, c), h.exportSymbol("_ListFetchResponse", null, c), h.exportSymbol("_ListFetchResponse.ListCase", null, c), h.exportSymbol("_ListFetchResponse._Found", null, c), h.exportSymbol("_ListFetchResponse._Missing", null, c), h.exportSymbol("_ListLengthRequest", null, c), h.exportSymbol("_ListLengthResponse", null, c), h.exportSymbol("_ListLengthResponse.ListCase", null, c), h.exportSymbol("_ListLengthResponse._Found", null, c), h.exportSymbol("_ListLengthResponse._Missing", null, c), h.exportSymbol("_ListPopBackRequest", null, c), h.exportSymbol("_ListPopBackResponse", null, c), h.exportSymbol("_ListPopBackResponse.ListCase", null, c), h.exportSymbol("_ListPopBackResponse._Found", null, c), h.exportSymbol("_ListPopBackResponse._Missing", null, c), h.exportSymbol("_ListPopFrontRequest", null, c), h.exportSymbol("_ListPopFrontResponse", null, c), h.exportSymbol("_ListPopFrontResponse.ListCase", null, c), h.exportSymbol("_ListPopFrontResponse._Found", null, c), h.exportSymbol("_ListPopFrontResponse._Missing", null, c), h.exportSymbol("_ListPushBackRequest", null, c), h.exportSymbol("_ListPushBackResponse", null, c), h.exportSymbol("_ListPushFrontRequest", null, c), h.exportSymbol("_ListPushFrontResponse", null, c), h.exportSymbol("_ListRange", null, c), h.exportSymbol("_ListRemoveRequest", null, c), h.exportSymbol("_ListRemoveRequest.RemoveCase", null, c), h.exportSymbol("_ListRemoveResponse", null, c), h.exportSymbol("_ListRemoveResponse.ListCase", null, c), h.exportSymbol("_ListRemoveResponse._Found", null, c), h.exportSymbol("_ListRemoveResponse._Missing", null, c), h.exportSymbol("_ListRetainRequest", null, c), h.exportSymbol("_ListRetainRequest.EndIndexCase", null, c), h.exportSymbol("_ListRetainRequest.StartIndexCase", null, c), h.exportSymbol("_ListRetainResponse", null, c), h.exportSymbol("_ListRetainResponse.ListCase", null, c), h.exportSymbol("_ListRetainResponse._Found", null, c), h.exportSymbol("_ListRetainResponse._Missing", null, c), h.exportSymbol("_SetBatchRequest", null, c), h.exportSymbol("_SetContainsRequest", null, c), h.exportSymbol("_SetContainsResponse", null, c), h.exportSymbol("_SetContainsResponse.SetCase", null, c), h.exportSymbol("_SetContainsResponse._Found", null, c), h.exportSymbol("_SetContainsResponse._Missing", null, c), h.exportSymbol("_SetDifferenceRequest", null, c), h.exportSymbol("_SetDifferenceRequest.DifferenceCase", null, c), h.exportSymbol("_SetDifferenceRequest._Minuend", null, c), h.exportSymbol("_SetDifferenceRequest._Subtrahend", null, c), h.exportSymbol("_SetDifferenceRequest._Subtrahend.SubtrahendSetCase", null, c), h.exportSymbol("_SetDifferenceRequest._Subtrahend._Identity", null, c), h.exportSymbol("_SetDifferenceRequest._Subtrahend._Set", null, c), h.exportSymbol("_SetDifferenceResponse", null, c), h.exportSymbol("_SetDifferenceResponse.SetCase", null, c), h.exportSymbol("_SetDifferenceResponse._Found", null, c), h.exportSymbol("_SetDifferenceResponse._Missing", null, c), h.exportSymbol("_SetFetchRequest", null, c), h.exportSymbol("_SetFetchResponse", null, c), h.exportSymbol("_SetFetchResponse.SetCase", null, c), h.exportSymbol("_SetFetchResponse._Found", null, c), h.exportSymbol("_SetFetchResponse._Missing", null, c), h.exportSymbol("_SetIfNotExistsRequest", null, c), h.exportSymbol("_SetIfNotExistsResponse", null, c), h.exportSymbol("_SetIfNotExistsResponse.ResultCase", null, c), h.exportSymbol("_SetIfNotExistsResponse._NotStored", null, c), h.exportSymbol("_SetIfNotExistsResponse._Stored", null, c), h.exportSymbol("_SetIfRequest", null, c), h.exportSymbol("_SetIfRequest.ConditionCase", null, c), h.exportSymbol("_SetIfResponse", null, c), h.exportSymbol("_SetIfResponse.ResultCase", null, c), h.exportSymbol("_SetIfResponse._NotStored", null, c), h.exportSymbol("_SetIfResponse._Stored", null, c), h.exportSymbol("_SetLengthRequest", null, c), h.exportSymbol("_SetLengthResponse", null, c), h.exportSymbol("_SetLengthResponse.SetCase", null, c), h.exportSymbol("_SetLengthResponse._Found", null, c), h.exportSymbol("_SetLengthResponse._Missing", null, c), h.exportSymbol("_SetPopRequest", null, c), h.exportSymbol("_SetPopResponse", null, c), h.exportSymbol("_SetPopResponse.SetCase", null, c), h.exportSymbol("_SetPopResponse._Found", null, c), h.exportSymbol("_SetPopResponse._Missing", null, c), h.exportSymbol("_SetRequest", null, c), h.exportSymbol("_SetResponse", null, c), h.exportSymbol("_SetSampleRequest", null, c), h.exportSymbol("_SetSampleResponse", null, c), h.exportSymbol("_SetSampleResponse.SetCase", null, c), h.exportSymbol("_SetSampleResponse._Found", null, c), h.exportSymbol("_SetSampleResponse._Missing", null, c), h.exportSymbol("_SetUnionRequest", null, c), h.exportSymbol("_SetUnionResponse", null, c), h.exportSymbol("_SortedSetElement", null, c), h.exportSymbol("_SortedSetFetchRequest", null, c), h.exportSymbol("_SortedSetFetchRequest.Order", null, c), h.exportSymbol("_SortedSetFetchRequest.RangeCase", null, c), h.exportSymbol("_SortedSetFetchRequest._ByIndex", null, c), h.exportSymbol("_SortedSetFetchRequest._ByIndex.EndCase", null, c), h.exportSymbol("_SortedSetFetchRequest._ByIndex.StartCase", null, c), h.exportSymbol("_SortedSetFetchRequest._ByScore", null, c), h.exportSymbol("_SortedSetFetchRequest._ByScore.MaxCase", null, c), h.exportSymbol("_SortedSetFetchRequest._ByScore.MinCase", null, c), h.exportSymbol("_SortedSetFetchRequest._ByScore._Score", null, c), h.exportSymbol("_SortedSetFetchResponse", null, c), h.exportSymbol("_SortedSetFetchResponse.SortedSetCase", null, c), h.exportSymbol("_SortedSetFetchResponse._Found", null, c), h.exportSymbol("_SortedSetFetchResponse._Found.ElementsCase", null, c), h.exportSymbol("_SortedSetFetchResponse._Found._Values", null, c), h.exportSymbol("_SortedSetFetchResponse._Found._ValuesWithScores", null, c), h.exportSymbol("_SortedSetFetchResponse._Missing", null, c), h.exportSymbol("_SortedSetGetRankRequest", null, c), h.exportSymbol("_SortedSetGetRankRequest.Order", null, c), h.exportSymbol("_SortedSetGetRankResponse", null, c), h.exportSymbol("_SortedSetGetRankResponse.RankCase", null, c), h.exportSymbol("_SortedSetGetRankResponse._RankResponsePart", null, c), h.exportSymbol("_SortedSetGetRankResponse._SortedSetMissing", null, c), h.exportSymbol("_SortedSetGetScoreRequest", null, c), h.exportSymbol("_SortedSetGetScoreResponse", null, c), h.exportSymbol("_SortedSetGetScoreResponse.SortedSetCase", null, c), h.exportSymbol("_SortedSetGetScoreResponse._SortedSetFound", null, c), h.exportSymbol("_SortedSetGetScoreResponse._SortedSetGetScoreResponsePart", null, c), h.exportSymbol("_SortedSetGetScoreResponse._SortedSetMissing", null, c), h.exportSymbol("_SortedSetIncrementRequest", null, c), h.exportSymbol("_SortedSetIncrementResponse", null, c), h.exportSymbol("_SortedSetLengthByScoreRequest", null, c), h.exportSymbol("_SortedSetLengthByScoreRequest.MaxCase", null, c), h.exportSymbol("_SortedSetLengthByScoreRequest.MinCase", null, c), h.exportSymbol("_SortedSetLengthByScoreResponse", null, c), h.exportSymbol("_SortedSetLengthByScoreResponse.SortedSetCase", null, c), h.exportSymbol("_SortedSetLengthByScoreResponse._Found", null, c), h.exportSymbol("_SortedSetLengthByScoreResponse._Missing", null, c), h.exportSymbol("_SortedSetLengthRequest", null, c), h.exportSymbol("_SortedSetLengthResponse", null, c), h.exportSymbol("_SortedSetLengthResponse.SortedSetCase", null, c), h.exportSymbol("_SortedSetLengthResponse._Found", null, c), h.exportSymbol("_SortedSetLengthResponse._Missing", null, c), h.exportSymbol("_SortedSetPutRequest", null, c), h.exportSymbol("_SortedSetPutResponse", null, c), h.exportSymbol("_SortedSetRemoveRequest", null, c), h.exportSymbol("_SortedSetRemoveRequest.RemoveElementsCase", null, c), h.exportSymbol("_SortedSetRemoveRequest._All", null, c), h.exportSymbol("_SortedSetRemoveRequest._Some", null, c), h.exportSymbol("_SortedSetRemoveResponse", null, c), h.exportSymbol("_UpdateTtlRequest", null, c), h.exportSymbol("_UpdateTtlRequest.UpdateTtlCase", null, c), h.exportSymbol("_UpdateTtlResponse", null, c), h.exportSymbol("_UpdateTtlResponse.ResultCase", null, c), h.exportSymbol("_UpdateTtlResponse._Missing", null, c), h.exportSymbol("_UpdateTtlResponse._NotSet", null, c), h.exportSymbol("_UpdateTtlResponse._Set", null, c), c._GetRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GetRequest, s.Message), h.DEBUG && !COMPILED && (c._GetRequest.displayName = "proto._GetRequest"), c._GetResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GetResponse, s.Message), h.DEBUG && !COMPILED && (c._GetResponse.displayName = "proto._GetResponse"), c._GetBatchRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._GetBatchRequest.repeatedFields_, null);
  }, h.inherits(c._GetBatchRequest, s.Message), h.DEBUG && !COMPILED && (c._GetBatchRequest.displayName = "proto._GetBatchRequest"), c._DeleteRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DeleteRequest, s.Message), h.DEBUG && !COMPILED && (c._DeleteRequest.displayName = "proto._DeleteRequest"), c._DeleteResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DeleteResponse, s.Message), h.DEBUG && !COMPILED && (c._DeleteResponse.displayName = "proto._DeleteResponse"), c._SetRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetRequest, s.Message), h.DEBUG && !COMPILED && (c._SetRequest.displayName = "proto._SetRequest"), c._SetResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetResponse, s.Message), h.DEBUG && !COMPILED && (c._SetResponse.displayName = "proto._SetResponse"), c._SetBatchRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetBatchRequest.repeatedFields_, null);
  }, h.inherits(c._SetBatchRequest, s.Message), h.DEBUG && !COMPILED && (c._SetBatchRequest.displayName = "proto._SetBatchRequest"), c._SetIfRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetIfRequest.oneofGroups_);
  }, h.inherits(c._SetIfRequest, s.Message), h.DEBUG && !COMPILED && (c._SetIfRequest.displayName = "proto._SetIfRequest"), c._SetIfResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetIfResponse.oneofGroups_);
  }, h.inherits(c._SetIfResponse, s.Message), h.DEBUG && !COMPILED && (c._SetIfResponse.displayName = "proto._SetIfResponse"), c._SetIfResponse._Stored = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetIfResponse._Stored, s.Message), h.DEBUG && !COMPILED && (c._SetIfResponse._Stored.displayName = "proto._SetIfResponse._Stored"), c._SetIfResponse._NotStored = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetIfResponse._NotStored, s.Message), h.DEBUG && !COMPILED && (c._SetIfResponse._NotStored.displayName = "proto._SetIfResponse._NotStored"), c._SetIfNotExistsRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetIfNotExistsRequest, s.Message), h.DEBUG && !COMPILED && (c._SetIfNotExistsRequest.displayName = "proto._SetIfNotExistsRequest"), c._SetIfNotExistsResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetIfNotExistsResponse.oneofGroups_);
  }, h.inherits(c._SetIfNotExistsResponse, s.Message), h.DEBUG && !COMPILED && (c._SetIfNotExistsResponse.displayName = "proto._SetIfNotExistsResponse"), c._SetIfNotExistsResponse._Stored = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetIfNotExistsResponse._Stored, s.Message), h.DEBUG && !COMPILED && (c._SetIfNotExistsResponse._Stored.displayName = "proto._SetIfNotExistsResponse._Stored"), c._SetIfNotExistsResponse._NotStored = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetIfNotExistsResponse._NotStored, s.Message), h.DEBUG && !COMPILED && (c._SetIfNotExistsResponse._NotStored.displayName = "proto._SetIfNotExistsResponse._NotStored"), c._KeysExistRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._KeysExistRequest.repeatedFields_, null);
  }, h.inherits(c._KeysExistRequest, s.Message), h.DEBUG && !COMPILED && (c._KeysExistRequest.displayName = "proto._KeysExistRequest"), c._KeysExistResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, c._KeysExistResponse.repeatedFields_, null);
  }, h.inherits(c._KeysExistResponse, s.Message), h.DEBUG && !COMPILED && (c._KeysExistResponse.displayName = "proto._KeysExistResponse"), c._IncrementRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._IncrementRequest, s.Message), h.DEBUG && !COMPILED && (c._IncrementRequest.displayName = "proto._IncrementRequest"), c._IncrementResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._IncrementResponse, s.Message), h.DEBUG && !COMPILED && (c._IncrementResponse.displayName = "proto._IncrementResponse"), c._UpdateTtlRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._UpdateTtlRequest.oneofGroups_);
  }, h.inherits(c._UpdateTtlRequest, s.Message), h.DEBUG && !COMPILED && (c._UpdateTtlRequest.displayName = "proto._UpdateTtlRequest"), c._UpdateTtlResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._UpdateTtlResponse.oneofGroups_);
  }, h.inherits(c._UpdateTtlResponse, s.Message), h.DEBUG && !COMPILED && (c._UpdateTtlResponse.displayName = "proto._UpdateTtlResponse"), c._UpdateTtlResponse._Set = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._UpdateTtlResponse._Set, s.Message), h.DEBUG && !COMPILED && (c._UpdateTtlResponse._Set.displayName = "proto._UpdateTtlResponse._Set"), c._UpdateTtlResponse._NotSet = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._UpdateTtlResponse._NotSet, s.Message), h.DEBUG && !COMPILED && (c._UpdateTtlResponse._NotSet.displayName = "proto._UpdateTtlResponse._NotSet"), c._UpdateTtlResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._UpdateTtlResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._UpdateTtlResponse._Missing.displayName = "proto._UpdateTtlResponse._Missing"), c._ItemGetTtlRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ItemGetTtlRequest, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTtlRequest.displayName = "proto._ItemGetTtlRequest"), c._ItemGetTtlResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ItemGetTtlResponse.oneofGroups_);
  }, h.inherits(c._ItemGetTtlResponse, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTtlResponse.displayName = "proto._ItemGetTtlResponse"), c._ItemGetTtlResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ItemGetTtlResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTtlResponse._Found.displayName = "proto._ItemGetTtlResponse._Found"), c._ItemGetTtlResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ItemGetTtlResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTtlResponse._Missing.displayName = "proto._ItemGetTtlResponse._Missing"), c._ItemGetTypeRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ItemGetTypeRequest, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTypeRequest.displayName = "proto._ItemGetTypeRequest"), c._ItemGetTypeResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ItemGetTypeResponse.oneofGroups_);
  }, h.inherits(c._ItemGetTypeResponse, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTypeResponse.displayName = "proto._ItemGetTypeResponse"), c._ItemGetTypeResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ItemGetTypeResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTypeResponse._Found.displayName = "proto._ItemGetTypeResponse._Found"), c._ItemGetTypeResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ItemGetTypeResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ItemGetTypeResponse._Missing.displayName = "proto._ItemGetTypeResponse._Missing"), c._DictionaryGetRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._DictionaryGetRequest.repeatedFields_, null);
  }, h.inherits(c._DictionaryGetRequest, s.Message), h.DEBUG && !COMPILED && (c._DictionaryGetRequest.displayName = "proto._DictionaryGetRequest"), c._DictionaryGetResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._DictionaryGetResponse.oneofGroups_);
  }, h.inherits(c._DictionaryGetResponse, s.Message), h.DEBUG && !COMPILED && (c._DictionaryGetResponse.displayName = "proto._DictionaryGetResponse"), c._DictionaryGetResponse._DictionaryGetResponsePart = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryGetResponse._DictionaryGetResponsePart, s.Message), h.DEBUG && !COMPILED && (c._DictionaryGetResponse._DictionaryGetResponsePart.displayName = "proto._DictionaryGetResponse._DictionaryGetResponsePart"), c._DictionaryGetResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._DictionaryGetResponse._Found.repeatedFields_, null);
  }, h.inherits(c._DictionaryGetResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._DictionaryGetResponse._Found.displayName = "proto._DictionaryGetResponse._Found"), c._DictionaryGetResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryGetResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._DictionaryGetResponse._Missing.displayName = "proto._DictionaryGetResponse._Missing"), c._DictionaryFetchRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryFetchRequest, s.Message), h.DEBUG && !COMPILED && (c._DictionaryFetchRequest.displayName = "proto._DictionaryFetchRequest"), c._DictionaryFieldValuePair = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryFieldValuePair, s.Message), h.DEBUG && !COMPILED && (c._DictionaryFieldValuePair.displayName = "proto._DictionaryFieldValuePair"), c._DictionaryFetchResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._DictionaryFetchResponse.oneofGroups_);
  }, h.inherits(c._DictionaryFetchResponse, s.Message), h.DEBUG && !COMPILED && (c._DictionaryFetchResponse.displayName = "proto._DictionaryFetchResponse"), c._DictionaryFetchResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._DictionaryFetchResponse._Found.repeatedFields_, null);
  }, h.inherits(c._DictionaryFetchResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._DictionaryFetchResponse._Found.displayName = "proto._DictionaryFetchResponse._Found"), c._DictionaryFetchResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryFetchResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._DictionaryFetchResponse._Missing.displayName = "proto._DictionaryFetchResponse._Missing"), c._DictionarySetRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._DictionarySetRequest.repeatedFields_, null);
  }, h.inherits(c._DictionarySetRequest, s.Message), h.DEBUG && !COMPILED && (c._DictionarySetRequest.displayName = "proto._DictionarySetRequest"), c._DictionarySetResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionarySetResponse, s.Message), h.DEBUG && !COMPILED && (c._DictionarySetResponse.displayName = "proto._DictionarySetResponse"), c._DictionaryIncrementRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryIncrementRequest, s.Message), h.DEBUG && !COMPILED && (c._DictionaryIncrementRequest.displayName = "proto._DictionaryIncrementRequest"), c._DictionaryIncrementResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryIncrementResponse, s.Message), h.DEBUG && !COMPILED && (c._DictionaryIncrementResponse.displayName = "proto._DictionaryIncrementResponse"), c._DictionaryDeleteRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._DictionaryDeleteRequest.oneofGroups_);
  }, h.inherits(c._DictionaryDeleteRequest, s.Message), h.DEBUG && !COMPILED && (c._DictionaryDeleteRequest.displayName = "proto._DictionaryDeleteRequest"), c._DictionaryDeleteRequest.Some = function(l) {
    s.Message.initialize(this, l, 0, -1, c._DictionaryDeleteRequest.Some.repeatedFields_, null);
  }, h.inherits(c._DictionaryDeleteRequest.Some, s.Message), h.DEBUG && !COMPILED && (c._DictionaryDeleteRequest.Some.displayName = "proto._DictionaryDeleteRequest.Some"), c._DictionaryDeleteRequest.All = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryDeleteRequest.All, s.Message), h.DEBUG && !COMPILED && (c._DictionaryDeleteRequest.All.displayName = "proto._DictionaryDeleteRequest.All"), c._DictionaryDeleteResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryDeleteResponse, s.Message), h.DEBUG && !COMPILED && (c._DictionaryDeleteResponse.displayName = "proto._DictionaryDeleteResponse"), c._DictionaryLengthRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryLengthRequest, s.Message), h.DEBUG && !COMPILED && (c._DictionaryLengthRequest.displayName = "proto._DictionaryLengthRequest"), c._DictionaryLengthResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._DictionaryLengthResponse.oneofGroups_);
  }, h.inherits(c._DictionaryLengthResponse, s.Message), h.DEBUG && !COMPILED && (c._DictionaryLengthResponse.displayName = "proto._DictionaryLengthResponse"), c._DictionaryLengthResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryLengthResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._DictionaryLengthResponse._Found.displayName = "proto._DictionaryLengthResponse._Found"), c._DictionaryLengthResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DictionaryLengthResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._DictionaryLengthResponse._Missing.displayName = "proto._DictionaryLengthResponse._Missing"), c._SetFetchRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetFetchRequest, s.Message), h.DEBUG && !COMPILED && (c._SetFetchRequest.displayName = "proto._SetFetchRequest"), c._SetFetchResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetFetchResponse.oneofGroups_);
  }, h.inherits(c._SetFetchResponse, s.Message), h.DEBUG && !COMPILED && (c._SetFetchResponse.displayName = "proto._SetFetchResponse"), c._SetFetchResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetFetchResponse._Found.repeatedFields_, null);
  }, h.inherits(c._SetFetchResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SetFetchResponse._Found.displayName = "proto._SetFetchResponse._Found"), c._SetFetchResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetFetchResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SetFetchResponse._Missing.displayName = "proto._SetFetchResponse._Missing"), c._SetSampleRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetSampleRequest, s.Message), h.DEBUG && !COMPILED && (c._SetSampleRequest.displayName = "proto._SetSampleRequest"), c._SetSampleResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetSampleResponse.oneofGroups_);
  }, h.inherits(c._SetSampleResponse, s.Message), h.DEBUG && !COMPILED && (c._SetSampleResponse.displayName = "proto._SetSampleResponse"), c._SetSampleResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetSampleResponse._Found.repeatedFields_, null);
  }, h.inherits(c._SetSampleResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SetSampleResponse._Found.displayName = "proto._SetSampleResponse._Found"), c._SetSampleResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetSampleResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SetSampleResponse._Missing.displayName = "proto._SetSampleResponse._Missing"), c._SetUnionRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetUnionRequest.repeatedFields_, null);
  }, h.inherits(c._SetUnionRequest, s.Message), h.DEBUG && !COMPILED && (c._SetUnionRequest.displayName = "proto._SetUnionRequest"), c._SetUnionResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetUnionResponse, s.Message), h.DEBUG && !COMPILED && (c._SetUnionResponse.displayName = "proto._SetUnionResponse"), c._SetDifferenceRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetDifferenceRequest.oneofGroups_);
  }, h.inherits(c._SetDifferenceRequest, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceRequest.displayName = "proto._SetDifferenceRequest"), c._SetDifferenceRequest._Minuend = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetDifferenceRequest._Minuend.repeatedFields_, null);
  }, h.inherits(c._SetDifferenceRequest._Minuend, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceRequest._Minuend.displayName = "proto._SetDifferenceRequest._Minuend"), c._SetDifferenceRequest._Subtrahend = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetDifferenceRequest._Subtrahend.oneofGroups_);
  }, h.inherits(c._SetDifferenceRequest._Subtrahend, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceRequest._Subtrahend.displayName = "proto._SetDifferenceRequest._Subtrahend"), c._SetDifferenceRequest._Subtrahend._Set = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetDifferenceRequest._Subtrahend._Set.repeatedFields_, null);
  }, h.inherits(c._SetDifferenceRequest._Subtrahend._Set, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceRequest._Subtrahend._Set.displayName = "proto._SetDifferenceRequest._Subtrahend._Set"), c._SetDifferenceRequest._Subtrahend._Identity = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetDifferenceRequest._Subtrahend._Identity, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceRequest._Subtrahend._Identity.displayName = "proto._SetDifferenceRequest._Subtrahend._Identity"), c._SetDifferenceResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetDifferenceResponse.oneofGroups_);
  }, h.inherits(c._SetDifferenceResponse, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceResponse.displayName = "proto._SetDifferenceResponse"), c._SetDifferenceResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetDifferenceResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceResponse._Found.displayName = "proto._SetDifferenceResponse._Found"), c._SetDifferenceResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetDifferenceResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SetDifferenceResponse._Missing.displayName = "proto._SetDifferenceResponse._Missing"), c._SetContainsRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetContainsRequest.repeatedFields_, null);
  }, h.inherits(c._SetContainsRequest, s.Message), h.DEBUG && !COMPILED && (c._SetContainsRequest.displayName = "proto._SetContainsRequest"), c._SetContainsResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetContainsResponse.oneofGroups_);
  }, h.inherits(c._SetContainsResponse, s.Message), h.DEBUG && !COMPILED && (c._SetContainsResponse.displayName = "proto._SetContainsResponse"), c._SetContainsResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetContainsResponse._Found.repeatedFields_, null);
  }, h.inherits(c._SetContainsResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SetContainsResponse._Found.displayName = "proto._SetContainsResponse._Found"), c._SetContainsResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetContainsResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SetContainsResponse._Missing.displayName = "proto._SetContainsResponse._Missing"), c._SetLengthRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetLengthRequest, s.Message), h.DEBUG && !COMPILED && (c._SetLengthRequest.displayName = "proto._SetLengthRequest"), c._SetLengthResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetLengthResponse.oneofGroups_);
  }, h.inherits(c._SetLengthResponse, s.Message), h.DEBUG && !COMPILED && (c._SetLengthResponse.displayName = "proto._SetLengthResponse"), c._SetLengthResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetLengthResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SetLengthResponse._Found.displayName = "proto._SetLengthResponse._Found"), c._SetLengthResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetLengthResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SetLengthResponse._Missing.displayName = "proto._SetLengthResponse._Missing"), c._SetPopRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetPopRequest, s.Message), h.DEBUG && !COMPILED && (c._SetPopRequest.displayName = "proto._SetPopRequest"), c._SetPopResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SetPopResponse.oneofGroups_);
  }, h.inherits(c._SetPopResponse, s.Message), h.DEBUG && !COMPILED && (c._SetPopResponse.displayName = "proto._SetPopResponse"), c._SetPopResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SetPopResponse._Found.repeatedFields_, null);
  }, h.inherits(c._SetPopResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SetPopResponse._Found.displayName = "proto._SetPopResponse._Found"), c._SetPopResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SetPopResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SetPopResponse._Missing.displayName = "proto._SetPopResponse._Missing"), c._ListConcatenateFrontRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._ListConcatenateFrontRequest.repeatedFields_, null);
  }, h.inherits(c._ListConcatenateFrontRequest, s.Message), h.DEBUG && !COMPILED && (c._ListConcatenateFrontRequest.displayName = "proto._ListConcatenateFrontRequest"), c._ListConcatenateFrontResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListConcatenateFrontResponse, s.Message), h.DEBUG && !COMPILED && (c._ListConcatenateFrontResponse.displayName = "proto._ListConcatenateFrontResponse"), c._ListConcatenateBackRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._ListConcatenateBackRequest.repeatedFields_, null);
  }, h.inherits(c._ListConcatenateBackRequest, s.Message), h.DEBUG && !COMPILED && (c._ListConcatenateBackRequest.displayName = "proto._ListConcatenateBackRequest"), c._ListConcatenateBackResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListConcatenateBackResponse, s.Message), h.DEBUG && !COMPILED && (c._ListConcatenateBackResponse.displayName = "proto._ListConcatenateBackResponse"), c._ListPushFrontRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPushFrontRequest, s.Message), h.DEBUG && !COMPILED && (c._ListPushFrontRequest.displayName = "proto._ListPushFrontRequest"), c._ListPushFrontResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPushFrontResponse, s.Message), h.DEBUG && !COMPILED && (c._ListPushFrontResponse.displayName = "proto._ListPushFrontResponse"), c._ListPushBackRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPushBackRequest, s.Message), h.DEBUG && !COMPILED && (c._ListPushBackRequest.displayName = "proto._ListPushBackRequest"), c._ListPushBackResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPushBackResponse, s.Message), h.DEBUG && !COMPILED && (c._ListPushBackResponse.displayName = "proto._ListPushBackResponse"), c._ListPopFrontRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPopFrontRequest, s.Message), h.DEBUG && !COMPILED && (c._ListPopFrontRequest.displayName = "proto._ListPopFrontRequest"), c._ListPopFrontResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListPopFrontResponse.oneofGroups_);
  }, h.inherits(c._ListPopFrontResponse, s.Message), h.DEBUG && !COMPILED && (c._ListPopFrontResponse.displayName = "proto._ListPopFrontResponse"), c._ListPopFrontResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPopFrontResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListPopFrontResponse._Found.displayName = "proto._ListPopFrontResponse._Found"), c._ListPopFrontResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPopFrontResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListPopFrontResponse._Missing.displayName = "proto._ListPopFrontResponse._Missing"), c._ListPopBackRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPopBackRequest, s.Message), h.DEBUG && !COMPILED && (c._ListPopBackRequest.displayName = "proto._ListPopBackRequest"), c._ListPopBackResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListPopBackResponse.oneofGroups_);
  }, h.inherits(c._ListPopBackResponse, s.Message), h.DEBUG && !COMPILED && (c._ListPopBackResponse.displayName = "proto._ListPopBackResponse"), c._ListPopBackResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPopBackResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListPopBackResponse._Found.displayName = "proto._ListPopBackResponse._Found"), c._ListPopBackResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListPopBackResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListPopBackResponse._Missing.displayName = "proto._ListPopBackResponse._Missing"), c._ListRange = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListRange, s.Message), h.DEBUG && !COMPILED && (c._ListRange.displayName = "proto._ListRange"), c._ListEraseRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListEraseRequest.oneofGroups_);
  }, h.inherits(c._ListEraseRequest, s.Message), h.DEBUG && !COMPILED && (c._ListEraseRequest.displayName = "proto._ListEraseRequest"), c._ListEraseRequest._All = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListEraseRequest._All, s.Message), h.DEBUG && !COMPILED && (c._ListEraseRequest._All.displayName = "proto._ListEraseRequest._All"), c._ListEraseRequest._ListRanges = function(l) {
    s.Message.initialize(this, l, 0, -1, c._ListEraseRequest._ListRanges.repeatedFields_, null);
  }, h.inherits(c._ListEraseRequest._ListRanges, s.Message), h.DEBUG && !COMPILED && (c._ListEraseRequest._ListRanges.displayName = "proto._ListEraseRequest._ListRanges"), c._ListEraseResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListEraseResponse.oneofGroups_);
  }, h.inherits(c._ListEraseResponse, s.Message), h.DEBUG && !COMPILED && (c._ListEraseResponse.displayName = "proto._ListEraseResponse"), c._ListEraseResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListEraseResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListEraseResponse._Found.displayName = "proto._ListEraseResponse._Found"), c._ListEraseResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListEraseResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListEraseResponse._Missing.displayName = "proto._ListEraseResponse._Missing"), c._ListRemoveRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListRemoveRequest.oneofGroups_);
  }, h.inherits(c._ListRemoveRequest, s.Message), h.DEBUG && !COMPILED && (c._ListRemoveRequest.displayName = "proto._ListRemoveRequest"), c._ListRemoveResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListRemoveResponse.oneofGroups_);
  }, h.inherits(c._ListRemoveResponse, s.Message), h.DEBUG && !COMPILED && (c._ListRemoveResponse.displayName = "proto._ListRemoveResponse"), c._ListRemoveResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListRemoveResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListRemoveResponse._Found.displayName = "proto._ListRemoveResponse._Found"), c._ListRemoveResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListRemoveResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListRemoveResponse._Missing.displayName = "proto._ListRemoveResponse._Missing"), c._ListFetchRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListFetchRequest.oneofGroups_);
  }, h.inherits(c._ListFetchRequest, s.Message), h.DEBUG && !COMPILED && (c._ListFetchRequest.displayName = "proto._ListFetchRequest"), c._ListRetainRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListRetainRequest.oneofGroups_);
  }, h.inherits(c._ListRetainRequest, s.Message), h.DEBUG && !COMPILED && (c._ListRetainRequest.displayName = "proto._ListRetainRequest"), c._ListRetainResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListRetainResponse.oneofGroups_);
  }, h.inherits(c._ListRetainResponse, s.Message), h.DEBUG && !COMPILED && (c._ListRetainResponse.displayName = "proto._ListRetainResponse"), c._ListRetainResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListRetainResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListRetainResponse._Found.displayName = "proto._ListRetainResponse._Found"), c._ListRetainResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListRetainResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListRetainResponse._Missing.displayName = "proto._ListRetainResponse._Missing"), c._ListFetchResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListFetchResponse.oneofGroups_);
  }, h.inherits(c._ListFetchResponse, s.Message), h.DEBUG && !COMPILED && (c._ListFetchResponse.displayName = "proto._ListFetchResponse"), c._ListFetchResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, c._ListFetchResponse._Found.repeatedFields_, null);
  }, h.inherits(c._ListFetchResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListFetchResponse._Found.displayName = "proto._ListFetchResponse._Found"), c._ListFetchResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListFetchResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListFetchResponse._Missing.displayName = "proto._ListFetchResponse._Missing"), c._ListLengthRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListLengthRequest, s.Message), h.DEBUG && !COMPILED && (c._ListLengthRequest.displayName = "proto._ListLengthRequest"), c._ListLengthResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ListLengthResponse.oneofGroups_);
  }, h.inherits(c._ListLengthResponse, s.Message), h.DEBUG && !COMPILED && (c._ListLengthResponse.displayName = "proto._ListLengthResponse"), c._ListLengthResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListLengthResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._ListLengthResponse._Found.displayName = "proto._ListLengthResponse._Found"), c._ListLengthResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._ListLengthResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._ListLengthResponse._Missing.displayName = "proto._ListLengthResponse._Missing"), c._SortedSetElement = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetElement, s.Message), h.DEBUG && !COMPILED && (c._SortedSetElement.displayName = "proto._SortedSetElement"), c._SortedSetPutRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SortedSetPutRequest.repeatedFields_, null);
  }, h.inherits(c._SortedSetPutRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetPutRequest.displayName = "proto._SortedSetPutRequest"), c._SortedSetPutResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetPutResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetPutResponse.displayName = "proto._SortedSetPutResponse"), c._SortedSetFetchRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetFetchRequest.oneofGroups_);
  }, h.inherits(c._SortedSetFetchRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchRequest.displayName = "proto._SortedSetFetchRequest"), c._SortedSetFetchRequest._ByIndex = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetFetchRequest._ByIndex.oneofGroups_);
  }, h.inherits(c._SortedSetFetchRequest._ByIndex, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchRequest._ByIndex.displayName = "proto._SortedSetFetchRequest._ByIndex"), c._SortedSetFetchRequest._ByScore = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetFetchRequest._ByScore.oneofGroups_);
  }, h.inherits(c._SortedSetFetchRequest._ByScore, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchRequest._ByScore.displayName = "proto._SortedSetFetchRequest._ByScore"), c._SortedSetFetchRequest._ByScore._Score = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetFetchRequest._ByScore._Score, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchRequest._ByScore._Score.displayName = "proto._SortedSetFetchRequest._ByScore._Score"), c._SortedSetFetchResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetFetchResponse.oneofGroups_);
  }, h.inherits(c._SortedSetFetchResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchResponse.displayName = "proto._SortedSetFetchResponse"), c._SortedSetFetchResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetFetchResponse._Found.oneofGroups_);
  }, h.inherits(c._SortedSetFetchResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchResponse._Found.displayName = "proto._SortedSetFetchResponse._Found"), c._SortedSetFetchResponse._Found._ValuesWithScores = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SortedSetFetchResponse._Found._ValuesWithScores.repeatedFields_, null);
  }, h.inherits(c._SortedSetFetchResponse._Found._ValuesWithScores, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchResponse._Found._ValuesWithScores.displayName = "proto._SortedSetFetchResponse._Found._ValuesWithScores"), c._SortedSetFetchResponse._Found._Values = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SortedSetFetchResponse._Found._Values.repeatedFields_, null);
  }, h.inherits(c._SortedSetFetchResponse._Found._Values, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchResponse._Found._Values.displayName = "proto._SortedSetFetchResponse._Found._Values"), c._SortedSetFetchResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetFetchResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SortedSetFetchResponse._Missing.displayName = "proto._SortedSetFetchResponse._Missing"), c._SortedSetGetScoreRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SortedSetGetScoreRequest.repeatedFields_, null);
  }, h.inherits(c._SortedSetGetScoreRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetScoreRequest.displayName = "proto._SortedSetGetScoreRequest"), c._SortedSetGetScoreResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetGetScoreResponse.oneofGroups_);
  }, h.inherits(c._SortedSetGetScoreResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetScoreResponse.displayName = "proto._SortedSetGetScoreResponse"), c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.displayName = "proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart"), c._SortedSetGetScoreResponse._SortedSetFound = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SortedSetGetScoreResponse._SortedSetFound.repeatedFields_, null);
  }, h.inherits(c._SortedSetGetScoreResponse._SortedSetFound, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetScoreResponse._SortedSetFound.displayName = "proto._SortedSetGetScoreResponse._SortedSetFound"), c._SortedSetGetScoreResponse._SortedSetMissing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetGetScoreResponse._SortedSetMissing, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetScoreResponse._SortedSetMissing.displayName = "proto._SortedSetGetScoreResponse._SortedSetMissing"), c._SortedSetRemoveRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetRemoveRequest.oneofGroups_);
  }, h.inherits(c._SortedSetRemoveRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetRemoveRequest.displayName = "proto._SortedSetRemoveRequest"), c._SortedSetRemoveRequest._All = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetRemoveRequest._All, s.Message), h.DEBUG && !COMPILED && (c._SortedSetRemoveRequest._All.displayName = "proto._SortedSetRemoveRequest._All"), c._SortedSetRemoveRequest._Some = function(l) {
    s.Message.initialize(this, l, 0, -1, c._SortedSetRemoveRequest._Some.repeatedFields_, null);
  }, h.inherits(c._SortedSetRemoveRequest._Some, s.Message), h.DEBUG && !COMPILED && (c._SortedSetRemoveRequest._Some.displayName = "proto._SortedSetRemoveRequest._Some"), c._SortedSetRemoveResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetRemoveResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetRemoveResponse.displayName = "proto._SortedSetRemoveResponse"), c._SortedSetIncrementRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetIncrementRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetIncrementRequest.displayName = "proto._SortedSetIncrementRequest"), c._SortedSetIncrementResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetIncrementResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetIncrementResponse.displayName = "proto._SortedSetIncrementResponse"), c._SortedSetGetRankRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetGetRankRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetRankRequest.displayName = "proto._SortedSetGetRankRequest"), c._SortedSetGetRankResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetGetRankResponse.oneofGroups_);
  }, h.inherits(c._SortedSetGetRankResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetRankResponse.displayName = "proto._SortedSetGetRankResponse"), c._SortedSetGetRankResponse._RankResponsePart = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetGetRankResponse._RankResponsePart, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetRankResponse._RankResponsePart.displayName = "proto._SortedSetGetRankResponse._RankResponsePart"), c._SortedSetGetRankResponse._SortedSetMissing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetGetRankResponse._SortedSetMissing, s.Message), h.DEBUG && !COMPILED && (c._SortedSetGetRankResponse._SortedSetMissing.displayName = "proto._SortedSetGetRankResponse._SortedSetMissing"), c._SortedSetLengthRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetLengthRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthRequest.displayName = "proto._SortedSetLengthRequest"), c._SortedSetLengthResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetLengthResponse.oneofGroups_);
  }, h.inherits(c._SortedSetLengthResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthResponse.displayName = "proto._SortedSetLengthResponse"), c._SortedSetLengthResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetLengthResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthResponse._Found.displayName = "proto._SortedSetLengthResponse._Found"), c._SortedSetLengthResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetLengthResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthResponse._Missing.displayName = "proto._SortedSetLengthResponse._Missing"), c._SortedSetLengthByScoreRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetLengthByScoreRequest.oneofGroups_);
  }, h.inherits(c._SortedSetLengthByScoreRequest, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthByScoreRequest.displayName = "proto._SortedSetLengthByScoreRequest"), c._SortedSetLengthByScoreResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._SortedSetLengthByScoreResponse.oneofGroups_);
  }, h.inherits(c._SortedSetLengthByScoreResponse, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthByScoreResponse.displayName = "proto._SortedSetLengthByScoreResponse"), c._SortedSetLengthByScoreResponse._Found = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetLengthByScoreResponse._Found, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthByScoreResponse._Found.displayName = "proto._SortedSetLengthByScoreResponse._Found"), c._SortedSetLengthByScoreResponse._Missing = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._SortedSetLengthByScoreResponse._Missing, s.Message), h.DEBUG && !COMPILED && (c._SortedSetLengthByScoreResponse._Missing.displayName = "proto._SortedSetLengthByScoreResponse._Missing"), s.Message.GENERATE_TO_OBJECT && (c._GetRequest.prototype.toObject = function(l) {
    return c._GetRequest.toObject(l, this);
  }, c._GetRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetRequest();
    return c._GetRequest.deserializeBinaryFromReader(f, g);
  }, c._GetRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._GetRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._GetRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._GetRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetResponse.prototype.toObject = function(l) {
    return c._GetResponse.toObject(l, this);
  }, c._GetResponse.toObject = function(l, g) {
    var f = {
      result: s.Message.getFieldWithDefault(g, 1, 0),
      cacheBody: g.getCacheBody_asB64(),
      message: s.Message.getFieldWithDefault(g, 3, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetResponse();
    return c._GetResponse.deserializeBinaryFromReader(f, g);
  }, c._GetResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!proto.ECacheResult} */
            g.readEnum()
          );
          l.setResult(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheBody(_);
          break;
        case 3:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setMessage(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getResult(), f !== 0 && g.writeEnum(
      1,
      f
    ), f = l.getCacheBody_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getMessage(), f.length > 0 && g.writeString(
      3,
      f
    );
  }, c._GetResponse.prototype.getResult = function() {
    return (
      /** @type {!proto.ECacheResult} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._GetResponse.prototype.setResult = function(l) {
    return s.Message.setProto3EnumField(this, 1, l);
  }, c._GetResponse.prototype.getCacheBody = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetResponse.prototype.getCacheBody_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheBody()
      )
    );
  }, c._GetResponse.prototype.getCacheBody_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheBody()
      )
    );
  }, c._GetResponse.prototype.setCacheBody = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._GetResponse.prototype.getMessage = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, c._GetResponse.prototype.setMessage = function(l) {
    return s.Message.setProto3StringField(this, 3, l);
  }, c._GetBatchRequest.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._GetBatchRequest.prototype.toObject = function(l) {
    return c._GetBatchRequest.toObject(l, this);
  }, c._GetBatchRequest.toObject = function(l, g) {
    var f = {
      itemsList: s.Message.toObjectList(
        g.getItemsList(),
        c._GetRequest.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetBatchRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetBatchRequest();
    return c._GetBatchRequest.deserializeBinaryFromReader(f, g);
  }, c._GetBatchRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._GetRequest();
          g.readMessage(_, c._GetRequest.deserializeBinaryFromReader), l.addItems(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetBatchRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetBatchRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetBatchRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getItemsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._GetRequest.serializeBinaryToWriter
    );
  }, c._GetBatchRequest.prototype.getItemsList = function() {
    return (
      /** @type{!Array<!proto._GetRequest>} */
      s.Message.getRepeatedWrapperField(this, c._GetRequest, 1)
    );
  }, c._GetBatchRequest.prototype.setItemsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._GetBatchRequest.prototype.addItems = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._GetRequest, g);
  }, c._GetBatchRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteRequest.prototype.toObject = function(l) {
    return c._DeleteRequest.toObject(l, this);
  }, c._DeleteRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DeleteRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DeleteRequest();
    return c._DeleteRequest.deserializeBinaryFromReader(f, g);
  }, c._DeleteRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DeleteRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DeleteRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DeleteRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._DeleteRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DeleteRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._DeleteRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._DeleteRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteResponse.prototype.toObject = function(l) {
    return c._DeleteResponse.toObject(l, this);
  }, c._DeleteResponse.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DeleteResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DeleteResponse();
    return c._DeleteResponse.deserializeBinaryFromReader(f, g);
  }, c._DeleteResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DeleteResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DeleteResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DeleteResponse.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SetRequest.prototype.toObject = function(l) {
    return c._SetRequest.toObject(l, this);
  }, c._SetRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64(),
      cacheBody: g.getCacheBody_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetRequest();
    return c._SetRequest.deserializeBinaryFromReader(f, g);
  }, c._SetRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheBody(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getCacheBody_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    );
  }, c._SetRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._SetRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._SetRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetRequest.prototype.getCacheBody = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SetRequest.prototype.getCacheBody_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheBody()
      )
    );
  }, c._SetRequest.prototype.getCacheBody_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheBody()
      )
    );
  }, c._SetRequest.prototype.setCacheBody = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._SetRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SetRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetResponse.prototype.toObject = function(l) {
    return c._SetResponse.toObject(l, this);
  }, c._SetResponse.toObject = function(l, g) {
    var f = {
      result: s.Message.getFieldWithDefault(g, 1, 0),
      message: s.Message.getFieldWithDefault(g, 2, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetResponse();
    return c._SetResponse.deserializeBinaryFromReader(f, g);
  }, c._SetResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!proto.ECacheResult} */
            g.readEnum()
          );
          l.setResult(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setMessage(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getResult(), f !== 0 && g.writeEnum(
      1,
      f
    ), f = l.getMessage(), f.length > 0 && g.writeString(
      2,
      f
    );
  }, c._SetResponse.prototype.getResult = function() {
    return (
      /** @type {!proto.ECacheResult} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._SetResponse.prototype.setResult = function(l) {
    return s.Message.setProto3EnumField(this, 1, l);
  }, c._SetResponse.prototype.getMessage = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SetResponse.prototype.setMessage = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._SetBatchRequest.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetBatchRequest.prototype.toObject = function(l) {
    return c._SetBatchRequest.toObject(l, this);
  }, c._SetBatchRequest.toObject = function(l, g) {
    var f = {
      itemsList: s.Message.toObjectList(
        g.getItemsList(),
        c._SetRequest.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetBatchRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetBatchRequest();
    return c._SetBatchRequest.deserializeBinaryFromReader(f, g);
  }, c._SetBatchRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetRequest();
          g.readMessage(_, c._SetRequest.deserializeBinaryFromReader), l.addItems(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetBatchRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetBatchRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetBatchRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getItemsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._SetRequest.serializeBinaryToWriter
    );
  }, c._SetBatchRequest.prototype.getItemsList = function() {
    return (
      /** @type{!Array<!proto._SetRequest>} */
      s.Message.getRepeatedWrapperField(this, c._SetRequest, 1)
    );
  }, c._SetBatchRequest.prototype.setItemsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._SetBatchRequest.prototype.addItems = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._SetRequest, g);
  }, c._SetBatchRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
  }, c._SetIfRequest.oneofGroups_ = [[4, 5, 6, 7, 8, 9]], c._SetIfRequest.ConditionCase = {
    CONDITION_NOT_SET: 0,
    PRESENT: 4,
    PRESENT_AND_NOT_EQUAL: 5,
    ABSENT: 6,
    EQUAL: 7,
    ABSENT_OR_EQUAL: 8,
    NOT_EQUAL: 9
  }, c._SetIfRequest.prototype.getConditionCase = function() {
    return (
      /** @type {proto._SetIfRequest.ConditionCase} */
      s.Message.computeOneofCase(this, c._SetIfRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfRequest.prototype.toObject = function(l) {
    return c._SetIfRequest.toObject(l, this);
  }, c._SetIfRequest.toObject = function(l, g) {
    var f, _ = {
      cacheKey: g.getCacheKey_asB64(),
      cacheBody: g.getCacheBody_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      present: (f = g.getPresent()) && d.Present.toObject(l, f),
      presentAndNotEqual: (f = g.getPresentAndNotEqual()) && d.PresentAndNotEqual.toObject(l, f),
      absent: (f = g.getAbsent()) && d.Absent.toObject(l, f),
      equal: (f = g.getEqual()) && d.Equal.toObject(l, f),
      absentOrEqual: (f = g.getAbsentOrEqual()) && d.AbsentOrEqual.toObject(l, f),
      notEqual: (f = g.getNotEqual()) && d.NotEqual.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetIfRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfRequest();
    return c._SetIfRequest.deserializeBinaryFromReader(f, g);
  }, c._SetIfRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheBody(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = new d.Present();
          g.readMessage(_, d.Present.deserializeBinaryFromReader), l.setPresent(_);
          break;
        case 5:
          var _ = new d.PresentAndNotEqual();
          g.readMessage(_, d.PresentAndNotEqual.deserializeBinaryFromReader), l.setPresentAndNotEqual(_);
          break;
        case 6:
          var _ = new d.Absent();
          g.readMessage(_, d.Absent.deserializeBinaryFromReader), l.setAbsent(_);
          break;
        case 7:
          var _ = new d.Equal();
          g.readMessage(_, d.Equal.deserializeBinaryFromReader), l.setEqual(_);
          break;
        case 8:
          var _ = new d.AbsentOrEqual();
          g.readMessage(_, d.AbsentOrEqual.deserializeBinaryFromReader), l.setAbsentOrEqual(_);
          break;
        case 9:
          var _ = new d.NotEqual();
          g.readMessage(_, d.NotEqual.deserializeBinaryFromReader), l.setNotEqual(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getCacheBody_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getPresent(), f != null && g.writeMessage(
      4,
      f,
      d.Present.serializeBinaryToWriter
    ), f = l.getPresentAndNotEqual(), f != null && g.writeMessage(
      5,
      f,
      d.PresentAndNotEqual.serializeBinaryToWriter
    ), f = l.getAbsent(), f != null && g.writeMessage(
      6,
      f,
      d.Absent.serializeBinaryToWriter
    ), f = l.getEqual(), f != null && g.writeMessage(
      7,
      f,
      d.Equal.serializeBinaryToWriter
    ), f = l.getAbsentOrEqual(), f != null && g.writeMessage(
      8,
      f,
      d.AbsentOrEqual.serializeBinaryToWriter
    ), f = l.getNotEqual(), f != null && g.writeMessage(
      9,
      f,
      d.NotEqual.serializeBinaryToWriter
    );
  }, c._SetIfRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetIfRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._SetIfRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._SetIfRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetIfRequest.prototype.getCacheBody = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SetIfRequest.prototype.getCacheBody_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheBody()
      )
    );
  }, c._SetIfRequest.prototype.getCacheBody_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheBody()
      )
    );
  }, c._SetIfRequest.prototype.setCacheBody = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._SetIfRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SetIfRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._SetIfRequest.prototype.getPresent = function() {
    return (
      /** @type{?proto.Present} */
      s.Message.getWrapperField(this, d.Present, 4)
    );
  }, c._SetIfRequest.prototype.setPresent = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._SetIfRequest.oneofGroups_[0], l);
  }, c._SetIfRequest.prototype.clearPresent = function() {
    return this.setPresent(void 0);
  }, c._SetIfRequest.prototype.hasPresent = function() {
    return s.Message.getField(this, 4) != null;
  }, c._SetIfRequest.prototype.getPresentAndNotEqual = function() {
    return (
      /** @type{?proto.PresentAndNotEqual} */
      s.Message.getWrapperField(this, d.PresentAndNotEqual, 5)
    );
  }, c._SetIfRequest.prototype.setPresentAndNotEqual = function(l) {
    return s.Message.setOneofWrapperField(this, 5, c._SetIfRequest.oneofGroups_[0], l);
  }, c._SetIfRequest.prototype.clearPresentAndNotEqual = function() {
    return this.setPresentAndNotEqual(void 0);
  }, c._SetIfRequest.prototype.hasPresentAndNotEqual = function() {
    return s.Message.getField(this, 5) != null;
  }, c._SetIfRequest.prototype.getAbsent = function() {
    return (
      /** @type{?proto.Absent} */
      s.Message.getWrapperField(this, d.Absent, 6)
    );
  }, c._SetIfRequest.prototype.setAbsent = function(l) {
    return s.Message.setOneofWrapperField(this, 6, c._SetIfRequest.oneofGroups_[0], l);
  }, c._SetIfRequest.prototype.clearAbsent = function() {
    return this.setAbsent(void 0);
  }, c._SetIfRequest.prototype.hasAbsent = function() {
    return s.Message.getField(this, 6) != null;
  }, c._SetIfRequest.prototype.getEqual = function() {
    return (
      /** @type{?proto.Equal} */
      s.Message.getWrapperField(this, d.Equal, 7)
    );
  }, c._SetIfRequest.prototype.setEqual = function(l) {
    return s.Message.setOneofWrapperField(this, 7, c._SetIfRequest.oneofGroups_[0], l);
  }, c._SetIfRequest.prototype.clearEqual = function() {
    return this.setEqual(void 0);
  }, c._SetIfRequest.prototype.hasEqual = function() {
    return s.Message.getField(this, 7) != null;
  }, c._SetIfRequest.prototype.getAbsentOrEqual = function() {
    return (
      /** @type{?proto.AbsentOrEqual} */
      s.Message.getWrapperField(this, d.AbsentOrEqual, 8)
    );
  }, c._SetIfRequest.prototype.setAbsentOrEqual = function(l) {
    return s.Message.setOneofWrapperField(this, 8, c._SetIfRequest.oneofGroups_[0], l);
  }, c._SetIfRequest.prototype.clearAbsentOrEqual = function() {
    return this.setAbsentOrEqual(void 0);
  }, c._SetIfRequest.prototype.hasAbsentOrEqual = function() {
    return s.Message.getField(this, 8) != null;
  }, c._SetIfRequest.prototype.getNotEqual = function() {
    return (
      /** @type{?proto.NotEqual} */
      s.Message.getWrapperField(this, d.NotEqual, 9)
    );
  }, c._SetIfRequest.prototype.setNotEqual = function(l) {
    return s.Message.setOneofWrapperField(this, 9, c._SetIfRequest.oneofGroups_[0], l);
  }, c._SetIfRequest.prototype.clearNotEqual = function() {
    return this.setNotEqual(void 0);
  }, c._SetIfRequest.prototype.hasNotEqual = function() {
    return s.Message.getField(this, 9) != null;
  }, c._SetIfResponse.oneofGroups_ = [[1, 2]], c._SetIfResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    STORED: 1,
    NOT_STORED: 2
  }, c._SetIfResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto._SetIfResponse.ResultCase} */
      s.Message.computeOneofCase(this, c._SetIfResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfResponse.prototype.toObject = function(l) {
    return c._SetIfResponse.toObject(l, this);
  }, c._SetIfResponse.toObject = function(l, g) {
    var f, _ = {
      stored: (f = g.getStored()) && c._SetIfResponse._Stored.toObject(l, f),
      notStored: (f = g.getNotStored()) && c._SetIfResponse._NotStored.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetIfResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfResponse();
    return c._SetIfResponse.deserializeBinaryFromReader(f, g);
  }, c._SetIfResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetIfResponse._Stored();
          g.readMessage(_, c._SetIfResponse._Stored.deserializeBinaryFromReader), l.setStored(_);
          break;
        case 2:
          var _ = new c._SetIfResponse._NotStored();
          g.readMessage(_, c._SetIfResponse._NotStored.deserializeBinaryFromReader), l.setNotStored(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getStored(), f != null && g.writeMessage(
      1,
      f,
      c._SetIfResponse._Stored.serializeBinaryToWriter
    ), f = l.getNotStored(), f != null && g.writeMessage(
      2,
      f,
      c._SetIfResponse._NotStored.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfResponse._Stored.prototype.toObject = function(l) {
    return c._SetIfResponse._Stored.toObject(l, this);
  }, c._SetIfResponse._Stored.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetIfResponse._Stored.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfResponse._Stored();
    return c._SetIfResponse._Stored.deserializeBinaryFromReader(f, g);
  }, c._SetIfResponse._Stored.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfResponse._Stored.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfResponse._Stored.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfResponse._Stored.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfResponse._NotStored.prototype.toObject = function(l) {
    return c._SetIfResponse._NotStored.toObject(l, this);
  }, c._SetIfResponse._NotStored.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetIfResponse._NotStored.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfResponse._NotStored();
    return c._SetIfResponse._NotStored.deserializeBinaryFromReader(f, g);
  }, c._SetIfResponse._NotStored.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfResponse._NotStored.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfResponse._NotStored.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfResponse._NotStored.serializeBinaryToWriter = function(l, g) {
  }, c._SetIfResponse.prototype.getStored = function() {
    return (
      /** @type{?proto._SetIfResponse._Stored} */
      s.Message.getWrapperField(this, c._SetIfResponse._Stored, 1)
    );
  }, c._SetIfResponse.prototype.setStored = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetIfResponse.oneofGroups_[0], l);
  }, c._SetIfResponse.prototype.clearStored = function() {
    return this.setStored(void 0);
  }, c._SetIfResponse.prototype.hasStored = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetIfResponse.prototype.getNotStored = function() {
    return (
      /** @type{?proto._SetIfResponse._NotStored} */
      s.Message.getWrapperField(this, c._SetIfResponse._NotStored, 2)
    );
  }, c._SetIfResponse.prototype.setNotStored = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetIfResponse.oneofGroups_[0], l);
  }, c._SetIfResponse.prototype.clearNotStored = function() {
    return this.setNotStored(void 0);
  }, c._SetIfResponse.prototype.hasNotStored = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfNotExistsRequest.prototype.toObject = function(l) {
    return c._SetIfNotExistsRequest.toObject(l, this);
  }, c._SetIfNotExistsRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64(),
      cacheBody: g.getCacheBody_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetIfNotExistsRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfNotExistsRequest();
    return c._SetIfNotExistsRequest.deserializeBinaryFromReader(f, g);
  }, c._SetIfNotExistsRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheBody(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfNotExistsRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfNotExistsRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfNotExistsRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getCacheBody_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    );
  }, c._SetIfNotExistsRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetIfNotExistsRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._SetIfNotExistsRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._SetIfNotExistsRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetIfNotExistsRequest.prototype.getCacheBody = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SetIfNotExistsRequest.prototype.getCacheBody_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheBody()
      )
    );
  }, c._SetIfNotExistsRequest.prototype.getCacheBody_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheBody()
      )
    );
  }, c._SetIfNotExistsRequest.prototype.setCacheBody = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._SetIfNotExistsRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SetIfNotExistsRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._SetIfNotExistsResponse.oneofGroups_ = [[1, 2]], c._SetIfNotExistsResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    STORED: 1,
    NOT_STORED: 2
  }, c._SetIfNotExistsResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto._SetIfNotExistsResponse.ResultCase} */
      s.Message.computeOneofCase(this, c._SetIfNotExistsResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfNotExistsResponse.prototype.toObject = function(l) {
    return c._SetIfNotExistsResponse.toObject(l, this);
  }, c._SetIfNotExistsResponse.toObject = function(l, g) {
    var f, _ = {
      stored: (f = g.getStored()) && c._SetIfNotExistsResponse._Stored.toObject(l, f),
      notStored: (f = g.getNotStored()) && c._SetIfNotExistsResponse._NotStored.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetIfNotExistsResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfNotExistsResponse();
    return c._SetIfNotExistsResponse.deserializeBinaryFromReader(f, g);
  }, c._SetIfNotExistsResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetIfNotExistsResponse._Stored();
          g.readMessage(_, c._SetIfNotExistsResponse._Stored.deserializeBinaryFromReader), l.setStored(_);
          break;
        case 2:
          var _ = new c._SetIfNotExistsResponse._NotStored();
          g.readMessage(_, c._SetIfNotExistsResponse._NotStored.deserializeBinaryFromReader), l.setNotStored(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfNotExistsResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfNotExistsResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfNotExistsResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getStored(), f != null && g.writeMessage(
      1,
      f,
      c._SetIfNotExistsResponse._Stored.serializeBinaryToWriter
    ), f = l.getNotStored(), f != null && g.writeMessage(
      2,
      f,
      c._SetIfNotExistsResponse._NotStored.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfNotExistsResponse._Stored.prototype.toObject = function(l) {
    return c._SetIfNotExistsResponse._Stored.toObject(l, this);
  }, c._SetIfNotExistsResponse._Stored.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetIfNotExistsResponse._Stored.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfNotExistsResponse._Stored();
    return c._SetIfNotExistsResponse._Stored.deserializeBinaryFromReader(f, g);
  }, c._SetIfNotExistsResponse._Stored.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfNotExistsResponse._Stored.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfNotExistsResponse._Stored.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfNotExistsResponse._Stored.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SetIfNotExistsResponse._NotStored.prototype.toObject = function(l) {
    return c._SetIfNotExistsResponse._NotStored.toObject(l, this);
  }, c._SetIfNotExistsResponse._NotStored.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetIfNotExistsResponse._NotStored.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetIfNotExistsResponse._NotStored();
    return c._SetIfNotExistsResponse._NotStored.deserializeBinaryFromReader(f, g);
  }, c._SetIfNotExistsResponse._NotStored.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetIfNotExistsResponse._NotStored.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetIfNotExistsResponse._NotStored.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetIfNotExistsResponse._NotStored.serializeBinaryToWriter = function(l, g) {
  }, c._SetIfNotExistsResponse.prototype.getStored = function() {
    return (
      /** @type{?proto._SetIfNotExistsResponse._Stored} */
      s.Message.getWrapperField(this, c._SetIfNotExistsResponse._Stored, 1)
    );
  }, c._SetIfNotExistsResponse.prototype.setStored = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetIfNotExistsResponse.oneofGroups_[0], l);
  }, c._SetIfNotExistsResponse.prototype.clearStored = function() {
    return this.setStored(void 0);
  }, c._SetIfNotExistsResponse.prototype.hasStored = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetIfNotExistsResponse.prototype.getNotStored = function() {
    return (
      /** @type{?proto._SetIfNotExistsResponse._NotStored} */
      s.Message.getWrapperField(this, c._SetIfNotExistsResponse._NotStored, 2)
    );
  }, c._SetIfNotExistsResponse.prototype.setNotStored = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetIfNotExistsResponse.oneofGroups_[0], l);
  }, c._SetIfNotExistsResponse.prototype.clearNotStored = function() {
    return this.setNotStored(void 0);
  }, c._SetIfNotExistsResponse.prototype.hasNotStored = function() {
    return s.Message.getField(this, 2) != null;
  }, c._KeysExistRequest.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._KeysExistRequest.prototype.toObject = function(l) {
    return c._KeysExistRequest.toObject(l, this);
  }, c._KeysExistRequest.toObject = function(l, g) {
    var f = {
      cacheKeysList: g.getCacheKeysList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._KeysExistRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._KeysExistRequest();
    return c._KeysExistRequest.deserializeBinaryFromReader(f, g);
  }, c._KeysExistRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addCacheKeys(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._KeysExistRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._KeysExistRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._KeysExistRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKeysList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._KeysExistRequest.prototype.getCacheKeysList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._KeysExistRequest.prototype.getCacheKeysList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getCacheKeysList()
      )
    );
  }, c._KeysExistRequest.prototype.getCacheKeysList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getCacheKeysList()
      )
    );
  }, c._KeysExistRequest.prototype.setCacheKeysList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._KeysExistRequest.prototype.addCacheKeys = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._KeysExistRequest.prototype.clearCacheKeysList = function() {
    return this.setCacheKeysList([]);
  }, c._KeysExistResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._KeysExistResponse.prototype.toObject = function(l) {
    return c._KeysExistResponse.toObject(l, this);
  }, c._KeysExistResponse.toObject = function(l, g) {
    var f, _ = {
      existsList: (f = s.Message.getRepeatedBooleanField(g, 1)) == null ? void 0 : f
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._KeysExistResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._KeysExistResponse();
    return c._KeysExistResponse.deserializeBinaryFromReader(f, g);
  }, c._KeysExistResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          for (var _ = (
            /** @type {!Array<boolean>} */
            g.isDelimited() ? g.readPackedBool() : [g.readBool()]
          ), te = 0; te < _.length; te++)
            l.addExists(_[te]);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._KeysExistResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._KeysExistResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._KeysExistResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getExistsList(), f.length > 0 && g.writePackedBool(
      1,
      f
    );
  }, c._KeysExistResponse.prototype.getExistsList = function() {
    return (
      /** @type {!Array<boolean>} */
      s.Message.getRepeatedBooleanField(this, 1)
    );
  }, c._KeysExistResponse.prototype.setExistsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._KeysExistResponse.prototype.addExists = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._KeysExistResponse.prototype.clearExistsList = function() {
    return this.setExistsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._IncrementRequest.prototype.toObject = function(l) {
    return c._IncrementRequest.toObject(l, this);
  }, c._IncrementRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64(),
      amount: s.Message.getFieldWithDefault(g, 2, 0),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._IncrementRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._IncrementRequest();
    return c._IncrementRequest.deserializeBinaryFromReader(f, g);
  }, c._IncrementRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readInt64()
          );
          l.setAmount(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._IncrementRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._IncrementRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._IncrementRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getAmount(), f !== 0 && g.writeInt64(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    );
  }, c._IncrementRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._IncrementRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._IncrementRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._IncrementRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._IncrementRequest.prototype.getAmount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._IncrementRequest.prototype.setAmount = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, c._IncrementRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._IncrementRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._IncrementResponse.prototype.toObject = function(l) {
    return c._IncrementResponse.toObject(l, this);
  }, c._IncrementResponse.toObject = function(l, g) {
    var f = {
      value: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._IncrementResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._IncrementResponse();
    return c._IncrementResponse.deserializeBinaryFromReader(f, g);
  }, c._IncrementResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readInt64()
          );
          l.setValue(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._IncrementResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._IncrementResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._IncrementResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValue(), f !== 0 && g.writeInt64(
      1,
      f
    );
  }, c._IncrementResponse.prototype.getValue = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._IncrementResponse.prototype.setValue = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._UpdateTtlRequest.oneofGroups_ = [[2, 3, 4]], c._UpdateTtlRequest.UpdateTtlCase = {
    UPDATE_TTL_NOT_SET: 0,
    INCREASE_TO_MILLISECONDS: 2,
    DECREASE_TO_MILLISECONDS: 3,
    OVERWRITE_TO_MILLISECONDS: 4
  }, c._UpdateTtlRequest.prototype.getUpdateTtlCase = function() {
    return (
      /** @type {proto._UpdateTtlRequest.UpdateTtlCase} */
      s.Message.computeOneofCase(this, c._UpdateTtlRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._UpdateTtlRequest.prototype.toObject = function(l) {
    return c._UpdateTtlRequest.toObject(l, this);
  }, c._UpdateTtlRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64(),
      increaseToMilliseconds: s.Message.getFieldWithDefault(g, 2, 0),
      decreaseToMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      overwriteToMilliseconds: s.Message.getFieldWithDefault(g, 4, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._UpdateTtlRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._UpdateTtlRequest();
    return c._UpdateTtlRequest.deserializeBinaryFromReader(f, g);
  }, c._UpdateTtlRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setIncreaseToMilliseconds(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setDecreaseToMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setOverwriteToMilliseconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._UpdateTtlRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._UpdateTtlRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._UpdateTtlRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = /** @type {number} */
    s.Message.getField(l, 2), f != null && g.writeUint64(
      2,
      f
    ), f = /** @type {number} */
    s.Message.getField(l, 3), f != null && g.writeUint64(
      3,
      f
    ), f = /** @type {number} */
    s.Message.getField(l, 4), f != null && g.writeUint64(
      4,
      f
    );
  }, c._UpdateTtlRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._UpdateTtlRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._UpdateTtlRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._UpdateTtlRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._UpdateTtlRequest.prototype.getIncreaseToMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._UpdateTtlRequest.prototype.setIncreaseToMilliseconds = function(l) {
    return s.Message.setOneofField(this, 2, c._UpdateTtlRequest.oneofGroups_[0], l);
  }, c._UpdateTtlRequest.prototype.clearIncreaseToMilliseconds = function() {
    return s.Message.setOneofField(this, 2, c._UpdateTtlRequest.oneofGroups_[0], void 0);
  }, c._UpdateTtlRequest.prototype.hasIncreaseToMilliseconds = function() {
    return s.Message.getField(this, 2) != null;
  }, c._UpdateTtlRequest.prototype.getDecreaseToMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._UpdateTtlRequest.prototype.setDecreaseToMilliseconds = function(l) {
    return s.Message.setOneofField(this, 3, c._UpdateTtlRequest.oneofGroups_[0], l);
  }, c._UpdateTtlRequest.prototype.clearDecreaseToMilliseconds = function() {
    return s.Message.setOneofField(this, 3, c._UpdateTtlRequest.oneofGroups_[0], void 0);
  }, c._UpdateTtlRequest.prototype.hasDecreaseToMilliseconds = function() {
    return s.Message.getField(this, 3) != null;
  }, c._UpdateTtlRequest.prototype.getOverwriteToMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._UpdateTtlRequest.prototype.setOverwriteToMilliseconds = function(l) {
    return s.Message.setOneofField(this, 4, c._UpdateTtlRequest.oneofGroups_[0], l);
  }, c._UpdateTtlRequest.prototype.clearOverwriteToMilliseconds = function() {
    return s.Message.setOneofField(this, 4, c._UpdateTtlRequest.oneofGroups_[0], void 0);
  }, c._UpdateTtlRequest.prototype.hasOverwriteToMilliseconds = function() {
    return s.Message.getField(this, 4) != null;
  }, c._UpdateTtlResponse.oneofGroups_ = [[1, 2, 3]], c._UpdateTtlResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    SET: 1,
    NOT_SET: 2,
    MISSING: 3
  }, c._UpdateTtlResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto._UpdateTtlResponse.ResultCase} */
      s.Message.computeOneofCase(this, c._UpdateTtlResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._UpdateTtlResponse.prototype.toObject = function(l) {
    return c._UpdateTtlResponse.toObject(l, this);
  }, c._UpdateTtlResponse.toObject = function(l, g) {
    var f, _ = {
      set: (f = g.getSet()) && c._UpdateTtlResponse._Set.toObject(l, f),
      notSet: (f = g.getNotSet()) && c._UpdateTtlResponse._NotSet.toObject(l, f),
      missing: (f = g.getMissing()) && c._UpdateTtlResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._UpdateTtlResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._UpdateTtlResponse();
    return c._UpdateTtlResponse.deserializeBinaryFromReader(f, g);
  }, c._UpdateTtlResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._UpdateTtlResponse._Set();
          g.readMessage(_, c._UpdateTtlResponse._Set.deserializeBinaryFromReader), l.setSet(_);
          break;
        case 2:
          var _ = new c._UpdateTtlResponse._NotSet();
          g.readMessage(_, c._UpdateTtlResponse._NotSet.deserializeBinaryFromReader), l.setNotSet(_);
          break;
        case 3:
          var _ = new c._UpdateTtlResponse._Missing();
          g.readMessage(_, c._UpdateTtlResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._UpdateTtlResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._UpdateTtlResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._UpdateTtlResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSet(), f != null && g.writeMessage(
      1,
      f,
      c._UpdateTtlResponse._Set.serializeBinaryToWriter
    ), f = l.getNotSet(), f != null && g.writeMessage(
      2,
      f,
      c._UpdateTtlResponse._NotSet.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      3,
      f,
      c._UpdateTtlResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._UpdateTtlResponse._Set.prototype.toObject = function(l) {
    return c._UpdateTtlResponse._Set.toObject(l, this);
  }, c._UpdateTtlResponse._Set.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._UpdateTtlResponse._Set.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._UpdateTtlResponse._Set();
    return c._UpdateTtlResponse._Set.deserializeBinaryFromReader(f, g);
  }, c._UpdateTtlResponse._Set.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._UpdateTtlResponse._Set.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._UpdateTtlResponse._Set.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._UpdateTtlResponse._Set.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._UpdateTtlResponse._NotSet.prototype.toObject = function(l) {
    return c._UpdateTtlResponse._NotSet.toObject(l, this);
  }, c._UpdateTtlResponse._NotSet.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._UpdateTtlResponse._NotSet.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._UpdateTtlResponse._NotSet();
    return c._UpdateTtlResponse._NotSet.deserializeBinaryFromReader(f, g);
  }, c._UpdateTtlResponse._NotSet.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._UpdateTtlResponse._NotSet.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._UpdateTtlResponse._NotSet.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._UpdateTtlResponse._NotSet.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._UpdateTtlResponse._Missing.prototype.toObject = function(l) {
    return c._UpdateTtlResponse._Missing.toObject(l, this);
  }, c._UpdateTtlResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._UpdateTtlResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._UpdateTtlResponse._Missing();
    return c._UpdateTtlResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._UpdateTtlResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._UpdateTtlResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._UpdateTtlResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._UpdateTtlResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._UpdateTtlResponse.prototype.getSet = function() {
    return (
      /** @type{?proto._UpdateTtlResponse._Set} */
      s.Message.getWrapperField(this, c._UpdateTtlResponse._Set, 1)
    );
  }, c._UpdateTtlResponse.prototype.setSet = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._UpdateTtlResponse.oneofGroups_[0], l);
  }, c._UpdateTtlResponse.prototype.clearSet = function() {
    return this.setSet(void 0);
  }, c._UpdateTtlResponse.prototype.hasSet = function() {
    return s.Message.getField(this, 1) != null;
  }, c._UpdateTtlResponse.prototype.getNotSet = function() {
    return (
      /** @type{?proto._UpdateTtlResponse._NotSet} */
      s.Message.getWrapperField(this, c._UpdateTtlResponse._NotSet, 2)
    );
  }, c._UpdateTtlResponse.prototype.setNotSet = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._UpdateTtlResponse.oneofGroups_[0], l);
  }, c._UpdateTtlResponse.prototype.clearNotSet = function() {
    return this.setNotSet(void 0);
  }, c._UpdateTtlResponse.prototype.hasNotSet = function() {
    return s.Message.getField(this, 2) != null;
  }, c._UpdateTtlResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._UpdateTtlResponse._Missing} */
      s.Message.getWrapperField(this, c._UpdateTtlResponse._Missing, 3)
    );
  }, c._UpdateTtlResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._UpdateTtlResponse.oneofGroups_[0], l);
  }, c._UpdateTtlResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._UpdateTtlResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTtlRequest.prototype.toObject = function(l) {
    return c._ItemGetTtlRequest.toObject(l, this);
  }, c._ItemGetTtlRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ItemGetTtlRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTtlRequest();
    return c._ItemGetTtlRequest.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTtlRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTtlRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTtlRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTtlRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._ItemGetTtlRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ItemGetTtlRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._ItemGetTtlRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._ItemGetTtlRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ItemGetTtlResponse.oneofGroups_ = [[1, 2]], c._ItemGetTtlResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ItemGetTtlResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto._ItemGetTtlResponse.ResultCase} */
      s.Message.computeOneofCase(this, c._ItemGetTtlResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTtlResponse.prototype.toObject = function(l) {
    return c._ItemGetTtlResponse.toObject(l, this);
  }, c._ItemGetTtlResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ItemGetTtlResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ItemGetTtlResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ItemGetTtlResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTtlResponse();
    return c._ItemGetTtlResponse.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTtlResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ItemGetTtlResponse._Found();
          g.readMessage(_, c._ItemGetTtlResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ItemGetTtlResponse._Missing();
          g.readMessage(_, c._ItemGetTtlResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTtlResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTtlResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTtlResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ItemGetTtlResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ItemGetTtlResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTtlResponse._Found.prototype.toObject = function(l) {
    return c._ItemGetTtlResponse._Found.toObject(l, this);
  }, c._ItemGetTtlResponse._Found.toObject = function(l, g) {
    var f = {
      remainingTtlMillis: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ItemGetTtlResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTtlResponse._Found();
    return c._ItemGetTtlResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTtlResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setRemainingTtlMillis(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTtlResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTtlResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTtlResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getRemainingTtlMillis(), f !== 0 && g.writeUint64(
      1,
      f
    );
  }, c._ItemGetTtlResponse._Found.prototype.getRemainingTtlMillis = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ItemGetTtlResponse._Found.prototype.setRemainingTtlMillis = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTtlResponse._Missing.prototype.toObject = function(l) {
    return c._ItemGetTtlResponse._Missing.toObject(l, this);
  }, c._ItemGetTtlResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ItemGetTtlResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTtlResponse._Missing();
    return c._ItemGetTtlResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTtlResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTtlResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTtlResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTtlResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ItemGetTtlResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ItemGetTtlResponse._Found} */
      s.Message.getWrapperField(this, c._ItemGetTtlResponse._Found, 1)
    );
  }, c._ItemGetTtlResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ItemGetTtlResponse.oneofGroups_[0], l);
  }, c._ItemGetTtlResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ItemGetTtlResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ItemGetTtlResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ItemGetTtlResponse._Missing} */
      s.Message.getWrapperField(this, c._ItemGetTtlResponse._Missing, 2)
    );
  }, c._ItemGetTtlResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ItemGetTtlResponse.oneofGroups_[0], l);
  }, c._ItemGetTtlResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ItemGetTtlResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTypeRequest.prototype.toObject = function(l) {
    return c._ItemGetTypeRequest.toObject(l, this);
  }, c._ItemGetTypeRequest.toObject = function(l, g) {
    var f = {
      cacheKey: g.getCacheKey_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ItemGetTypeRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTypeRequest();
    return c._ItemGetTypeRequest.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTypeRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheKey(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTypeRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTypeRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTypeRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheKey_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._ItemGetTypeRequest.prototype.getCacheKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ItemGetTypeRequest.prototype.getCacheKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheKey()
      )
    );
  }, c._ItemGetTypeRequest.prototype.getCacheKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheKey()
      )
    );
  }, c._ItemGetTypeRequest.prototype.setCacheKey = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ItemGetTypeResponse.oneofGroups_ = [[1, 2]], c._ItemGetTypeResponse.ResultCase = {
    RESULT_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ItemGetTypeResponse.prototype.getResultCase = function() {
    return (
      /** @type {proto._ItemGetTypeResponse.ResultCase} */
      s.Message.computeOneofCase(this, c._ItemGetTypeResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTypeResponse.prototype.toObject = function(l) {
    return c._ItemGetTypeResponse.toObject(l, this);
  }, c._ItemGetTypeResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ItemGetTypeResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ItemGetTypeResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ItemGetTypeResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTypeResponse();
    return c._ItemGetTypeResponse.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTypeResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ItemGetTypeResponse._Found();
          g.readMessage(_, c._ItemGetTypeResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ItemGetTypeResponse._Missing();
          g.readMessage(_, c._ItemGetTypeResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTypeResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTypeResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTypeResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ItemGetTypeResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ItemGetTypeResponse._Missing.serializeBinaryToWriter
    );
  }, c._ItemGetTypeResponse.ItemType = {
    SCALAR: 0,
    DICTIONARY: 1,
    SET: 2,
    LIST: 3,
    SORTED_SET: 4
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTypeResponse._Found.prototype.toObject = function(l) {
    return c._ItemGetTypeResponse._Found.toObject(l, this);
  }, c._ItemGetTypeResponse._Found.toObject = function(l, g) {
    var f = {
      itemType: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ItemGetTypeResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTypeResponse._Found();
    return c._ItemGetTypeResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTypeResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!proto._ItemGetTypeResponse.ItemType} */
            g.readEnum()
          );
          l.setItemType(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTypeResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTypeResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTypeResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getItemType(), f !== 0 && g.writeEnum(
      1,
      f
    );
  }, c._ItemGetTypeResponse._Found.prototype.getItemType = function() {
    return (
      /** @type {!proto._ItemGetTypeResponse.ItemType} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ItemGetTypeResponse._Found.prototype.setItemType = function(l) {
    return s.Message.setProto3EnumField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ItemGetTypeResponse._Missing.prototype.toObject = function(l) {
    return c._ItemGetTypeResponse._Missing.toObject(l, this);
  }, c._ItemGetTypeResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ItemGetTypeResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ItemGetTypeResponse._Missing();
    return c._ItemGetTypeResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ItemGetTypeResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ItemGetTypeResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ItemGetTypeResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ItemGetTypeResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ItemGetTypeResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ItemGetTypeResponse._Found} */
      s.Message.getWrapperField(this, c._ItemGetTypeResponse._Found, 1)
    );
  }, c._ItemGetTypeResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ItemGetTypeResponse.oneofGroups_[0], l);
  }, c._ItemGetTypeResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ItemGetTypeResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ItemGetTypeResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ItemGetTypeResponse._Missing} */
      s.Message.getWrapperField(this, c._ItemGetTypeResponse._Missing, 2)
    );
  }, c._ItemGetTypeResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ItemGetTypeResponse.oneofGroups_[0], l);
  }, c._ItemGetTypeResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ItemGetTypeResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._DictionaryGetRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._DictionaryGetRequest.prototype.toObject = function(l) {
    return c._DictionaryGetRequest.toObject(l, this);
  }, c._DictionaryGetRequest.toObject = function(l, g) {
    var f = {
      dictionaryName: g.getDictionaryName_asB64(),
      fieldsList: g.getFieldsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryGetRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryGetRequest();
    return c._DictionaryGetRequest.deserializeBinaryFromReader(f, g);
  }, c._DictionaryGetRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setDictionaryName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addFields(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryGetRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryGetRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryGetRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDictionaryName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getFieldsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      2,
      f
    );
  }, c._DictionaryGetRequest.prototype.getDictionaryName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionaryGetRequest.prototype.getDictionaryName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryGetRequest.prototype.getDictionaryName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryGetRequest.prototype.setDictionaryName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._DictionaryGetRequest.prototype.getFieldsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, c._DictionaryGetRequest.prototype.getFieldsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getFieldsList()
      )
    );
  }, c._DictionaryGetRequest.prototype.getFieldsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getFieldsList()
      )
    );
  }, c._DictionaryGetRequest.prototype.setFieldsList = function(l) {
    return s.Message.setField(this, 2, l || []);
  }, c._DictionaryGetRequest.prototype.addFields = function(l, g) {
    return s.Message.addToRepeatedField(this, 2, l, g);
  }, c._DictionaryGetRequest.prototype.clearFieldsList = function() {
    return this.setFieldsList([]);
  }, c._DictionaryGetResponse.oneofGroups_ = [[1, 2]], c._DictionaryGetResponse.DictionaryCase = {
    DICTIONARY_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._DictionaryGetResponse.prototype.getDictionaryCase = function() {
    return (
      /** @type {proto._DictionaryGetResponse.DictionaryCase} */
      s.Message.computeOneofCase(this, c._DictionaryGetResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryGetResponse.prototype.toObject = function(l) {
    return c._DictionaryGetResponse.toObject(l, this);
  }, c._DictionaryGetResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._DictionaryGetResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._DictionaryGetResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._DictionaryGetResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryGetResponse();
    return c._DictionaryGetResponse.deserializeBinaryFromReader(f, g);
  }, c._DictionaryGetResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._DictionaryGetResponse._Found();
          g.readMessage(_, c._DictionaryGetResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._DictionaryGetResponse._Missing();
          g.readMessage(_, c._DictionaryGetResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryGetResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryGetResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryGetResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._DictionaryGetResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._DictionaryGetResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.toObject = function(l) {
    return c._DictionaryGetResponse._DictionaryGetResponsePart.toObject(l, this);
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.toObject = function(l, g) {
    var f = {
      result: s.Message.getFieldWithDefault(g, 1, 0),
      cacheBody: g.getCacheBody_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryGetResponse._DictionaryGetResponsePart();
    return c._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinaryFromReader(f, g);
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!proto.ECacheResult} */
            g.readEnum()
          );
          l.setResult(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setCacheBody(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryGetResponse._DictionaryGetResponsePart.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getResult(), f !== 0 && g.writeEnum(
      1,
      f
    ), f = l.getCacheBody_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    );
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getResult = function() {
    return (
      /** @type {!proto.ECacheResult} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.setResult = function(l) {
    return s.Message.setProto3EnumField(this, 1, l);
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getCacheBody = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getCacheBody_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getCacheBody()
      )
    );
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.getCacheBody_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getCacheBody()
      )
    );
  }, c._DictionaryGetResponse._DictionaryGetResponsePart.prototype.setCacheBody = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._DictionaryGetResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._DictionaryGetResponse._Found.prototype.toObject = function(l) {
    return c._DictionaryGetResponse._Found.toObject(l, this);
  }, c._DictionaryGetResponse._Found.toObject = function(l, g) {
    var f = {
      itemsList: s.Message.toObjectList(
        g.getItemsList(),
        c._DictionaryGetResponse._DictionaryGetResponsePart.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryGetResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryGetResponse._Found();
    return c._DictionaryGetResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._DictionaryGetResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._DictionaryGetResponse._DictionaryGetResponsePart();
          g.readMessage(_, c._DictionaryGetResponse._DictionaryGetResponsePart.deserializeBinaryFromReader), l.addItems(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryGetResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryGetResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryGetResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getItemsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._DictionaryGetResponse._DictionaryGetResponsePart.serializeBinaryToWriter
    );
  }, c._DictionaryGetResponse._Found.prototype.getItemsList = function() {
    return (
      /** @type{!Array<!proto._DictionaryGetResponse._DictionaryGetResponsePart>} */
      s.Message.getRepeatedWrapperField(this, c._DictionaryGetResponse._DictionaryGetResponsePart, 1)
    );
  }, c._DictionaryGetResponse._Found.prototype.setItemsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._DictionaryGetResponse._Found.prototype.addItems = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._DictionaryGetResponse._DictionaryGetResponsePart, g);
  }, c._DictionaryGetResponse._Found.prototype.clearItemsList = function() {
    return this.setItemsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryGetResponse._Missing.prototype.toObject = function(l) {
    return c._DictionaryGetResponse._Missing.toObject(l, this);
  }, c._DictionaryGetResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryGetResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryGetResponse._Missing();
    return c._DictionaryGetResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._DictionaryGetResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryGetResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryGetResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryGetResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._DictionaryGetResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._DictionaryGetResponse._Found} */
      s.Message.getWrapperField(this, c._DictionaryGetResponse._Found, 1)
    );
  }, c._DictionaryGetResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._DictionaryGetResponse.oneofGroups_[0], l);
  }, c._DictionaryGetResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._DictionaryGetResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._DictionaryGetResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._DictionaryGetResponse._Missing} */
      s.Message.getWrapperField(this, c._DictionaryGetResponse._Missing, 2)
    );
  }, c._DictionaryGetResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._DictionaryGetResponse.oneofGroups_[0], l);
  }, c._DictionaryGetResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._DictionaryGetResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryFetchRequest.prototype.toObject = function(l) {
    return c._DictionaryFetchRequest.toObject(l, this);
  }, c._DictionaryFetchRequest.toObject = function(l, g) {
    var f = {
      dictionaryName: g.getDictionaryName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryFetchRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryFetchRequest();
    return c._DictionaryFetchRequest.deserializeBinaryFromReader(f, g);
  }, c._DictionaryFetchRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setDictionaryName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryFetchRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryFetchRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryFetchRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDictionaryName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._DictionaryFetchRequest.prototype.getDictionaryName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionaryFetchRequest.prototype.getDictionaryName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryFetchRequest.prototype.getDictionaryName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryFetchRequest.prototype.setDictionaryName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryFieldValuePair.prototype.toObject = function(l) {
    return c._DictionaryFieldValuePair.toObject(l, this);
  }, c._DictionaryFieldValuePair.toObject = function(l, g) {
    var f = {
      field: g.getField_asB64(),
      value: g.getValue_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryFieldValuePair.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryFieldValuePair();
    return c._DictionaryFieldValuePair.deserializeBinaryFromReader(f, g);
  }, c._DictionaryFieldValuePair.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setField(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setValue(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryFieldValuePair.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryFieldValuePair.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryFieldValuePair.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getField_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValue_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    );
  }, c._DictionaryFieldValuePair.prototype.getField = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionaryFieldValuePair.prototype.getField_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getField()
      )
    );
  }, c._DictionaryFieldValuePair.prototype.getField_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getField()
      )
    );
  }, c._DictionaryFieldValuePair.prototype.setField = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._DictionaryFieldValuePair.prototype.getValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._DictionaryFieldValuePair.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, c._DictionaryFieldValuePair.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, c._DictionaryFieldValuePair.prototype.setValue = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._DictionaryFetchResponse.oneofGroups_ = [[1, 2]], c._DictionaryFetchResponse.DictionaryCase = {
    DICTIONARY_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._DictionaryFetchResponse.prototype.getDictionaryCase = function() {
    return (
      /** @type {proto._DictionaryFetchResponse.DictionaryCase} */
      s.Message.computeOneofCase(this, c._DictionaryFetchResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryFetchResponse.prototype.toObject = function(l) {
    return c._DictionaryFetchResponse.toObject(l, this);
  }, c._DictionaryFetchResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._DictionaryFetchResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._DictionaryFetchResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._DictionaryFetchResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryFetchResponse();
    return c._DictionaryFetchResponse.deserializeBinaryFromReader(f, g);
  }, c._DictionaryFetchResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._DictionaryFetchResponse._Found();
          g.readMessage(_, c._DictionaryFetchResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._DictionaryFetchResponse._Missing();
          g.readMessage(_, c._DictionaryFetchResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryFetchResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryFetchResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryFetchResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._DictionaryFetchResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._DictionaryFetchResponse._Missing.serializeBinaryToWriter
    );
  }, c._DictionaryFetchResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._DictionaryFetchResponse._Found.prototype.toObject = function(l) {
    return c._DictionaryFetchResponse._Found.toObject(l, this);
  }, c._DictionaryFetchResponse._Found.toObject = function(l, g) {
    var f = {
      itemsList: s.Message.toObjectList(
        g.getItemsList(),
        c._DictionaryFieldValuePair.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryFetchResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryFetchResponse._Found();
    return c._DictionaryFetchResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._DictionaryFetchResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._DictionaryFieldValuePair();
          g.readMessage(_, c._DictionaryFieldValuePair.deserializeBinaryFromReader), l.addItems(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryFetchResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryFetchResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryFetchResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getItemsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._DictionaryFieldValuePair.serializeBinaryToWriter
    );
  }, c._DictionaryFetchResponse._Found.prototype.getItemsList = function() {
    return (
      /** @type{!Array<!proto._DictionaryFieldValuePair>} */
      s.Message.getRepeatedWrapperField(this, c._DictionaryFieldValuePair, 1)
    );
  }, c._DictionaryFetchResponse._Found.prototype.setItemsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._DictionaryFetchResponse._Found.prototype.addItems = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._DictionaryFieldValuePair, g);
  }, c._DictionaryFetchResponse._Found.prototype.clearItemsList = function() {
    return this.setItemsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryFetchResponse._Missing.prototype.toObject = function(l) {
    return c._DictionaryFetchResponse._Missing.toObject(l, this);
  }, c._DictionaryFetchResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryFetchResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryFetchResponse._Missing();
    return c._DictionaryFetchResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._DictionaryFetchResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryFetchResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryFetchResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryFetchResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._DictionaryFetchResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._DictionaryFetchResponse._Found} */
      s.Message.getWrapperField(this, c._DictionaryFetchResponse._Found, 1)
    );
  }, c._DictionaryFetchResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._DictionaryFetchResponse.oneofGroups_[0], l);
  }, c._DictionaryFetchResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._DictionaryFetchResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._DictionaryFetchResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._DictionaryFetchResponse._Missing} */
      s.Message.getWrapperField(this, c._DictionaryFetchResponse._Missing, 2)
    );
  }, c._DictionaryFetchResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._DictionaryFetchResponse.oneofGroups_[0], l);
  }, c._DictionaryFetchResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._DictionaryFetchResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._DictionarySetRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._DictionarySetRequest.prototype.toObject = function(l) {
    return c._DictionarySetRequest.toObject(l, this);
  }, c._DictionarySetRequest.toObject = function(l, g) {
    var f = {
      dictionaryName: g.getDictionaryName_asB64(),
      itemsList: s.Message.toObjectList(
        g.getItemsList(),
        c._DictionaryFieldValuePair.toObject,
        l
      ),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionarySetRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionarySetRequest();
    return c._DictionarySetRequest.deserializeBinaryFromReader(f, g);
  }, c._DictionarySetRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setDictionaryName(_);
          break;
        case 2:
          var _ = new c._DictionaryFieldValuePair();
          g.readMessage(_, c._DictionaryFieldValuePair.deserializeBinaryFromReader), l.addItems(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionarySetRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionarySetRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionarySetRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDictionaryName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getItemsList(), f.length > 0 && g.writeRepeatedMessage(
      2,
      f,
      c._DictionaryFieldValuePair.serializeBinaryToWriter
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    );
  }, c._DictionarySetRequest.prototype.getDictionaryName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionarySetRequest.prototype.getDictionaryName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getDictionaryName()
      )
    );
  }, c._DictionarySetRequest.prototype.getDictionaryName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getDictionaryName()
      )
    );
  }, c._DictionarySetRequest.prototype.setDictionaryName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._DictionarySetRequest.prototype.getItemsList = function() {
    return (
      /** @type{!Array<!proto._DictionaryFieldValuePair>} */
      s.Message.getRepeatedWrapperField(this, c._DictionaryFieldValuePair, 2)
    );
  }, c._DictionarySetRequest.prototype.setItemsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 2, l);
  }, c._DictionarySetRequest.prototype.addItems = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 2, l, c._DictionaryFieldValuePair, g);
  }, c._DictionarySetRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
  }, c._DictionarySetRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._DictionarySetRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._DictionarySetRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._DictionarySetRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionarySetResponse.prototype.toObject = function(l) {
    return c._DictionarySetResponse.toObject(l, this);
  }, c._DictionarySetResponse.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionarySetResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionarySetResponse();
    return c._DictionarySetResponse.deserializeBinaryFromReader(f, g);
  }, c._DictionarySetResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionarySetResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionarySetResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionarySetResponse.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryIncrementRequest.prototype.toObject = function(l) {
    return c._DictionaryIncrementRequest.toObject(l, this);
  }, c._DictionaryIncrementRequest.toObject = function(l, g) {
    var f = {
      dictionaryName: g.getDictionaryName_asB64(),
      field: g.getField_asB64(),
      amount: s.Message.getFieldWithDefault(g, 3, 0),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 4, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 5, !1)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryIncrementRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryIncrementRequest();
    return c._DictionaryIncrementRequest.deserializeBinaryFromReader(f, g);
  }, c._DictionaryIncrementRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setDictionaryName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setField(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readInt64()
          );
          l.setAmount(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 5:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryIncrementRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryIncrementRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryIncrementRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDictionaryName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getField_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getAmount(), f !== 0 && g.writeInt64(
      3,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      4,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      5,
      f
    );
  }, c._DictionaryIncrementRequest.prototype.getDictionaryName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionaryIncrementRequest.prototype.getDictionaryName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryIncrementRequest.prototype.getDictionaryName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryIncrementRequest.prototype.setDictionaryName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._DictionaryIncrementRequest.prototype.getField = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._DictionaryIncrementRequest.prototype.getField_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getField()
      )
    );
  }, c._DictionaryIncrementRequest.prototype.getField_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getField()
      )
    );
  }, c._DictionaryIncrementRequest.prototype.setField = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._DictionaryIncrementRequest.prototype.getAmount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._DictionaryIncrementRequest.prototype.setAmount = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._DictionaryIncrementRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._DictionaryIncrementRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 4, l);
  }, c._DictionaryIncrementRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, c._DictionaryIncrementRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 5, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryIncrementResponse.prototype.toObject = function(l) {
    return c._DictionaryIncrementResponse.toObject(l, this);
  }, c._DictionaryIncrementResponse.toObject = function(l, g) {
    var f = {
      value: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryIncrementResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryIncrementResponse();
    return c._DictionaryIncrementResponse.deserializeBinaryFromReader(f, g);
  }, c._DictionaryIncrementResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readInt64()
          );
          l.setValue(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryIncrementResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryIncrementResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryIncrementResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValue(), f !== 0 && g.writeInt64(
      1,
      f
    );
  }, c._DictionaryIncrementResponse.prototype.getValue = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._DictionaryIncrementResponse.prototype.setValue = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._DictionaryDeleteRequest.oneofGroups_ = [[2, 3]], c._DictionaryDeleteRequest.DeleteCase = {
    DELETE_NOT_SET: 0,
    SOME: 2,
    ALL: 3
  }, c._DictionaryDeleteRequest.prototype.getDeleteCase = function() {
    return (
      /** @type {proto._DictionaryDeleteRequest.DeleteCase} */
      s.Message.computeOneofCase(this, c._DictionaryDeleteRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryDeleteRequest.prototype.toObject = function(l) {
    return c._DictionaryDeleteRequest.toObject(l, this);
  }, c._DictionaryDeleteRequest.toObject = function(l, g) {
    var f, _ = {
      dictionaryName: g.getDictionaryName_asB64(),
      some: (f = g.getSome()) && c._DictionaryDeleteRequest.Some.toObject(l, f),
      all: (f = g.getAll()) && c._DictionaryDeleteRequest.All.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._DictionaryDeleteRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryDeleteRequest();
    return c._DictionaryDeleteRequest.deserializeBinaryFromReader(f, g);
  }, c._DictionaryDeleteRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setDictionaryName(_);
          break;
        case 2:
          var _ = new c._DictionaryDeleteRequest.Some();
          g.readMessage(_, c._DictionaryDeleteRequest.Some.deserializeBinaryFromReader), l.setSome(_);
          break;
        case 3:
          var _ = new c._DictionaryDeleteRequest.All();
          g.readMessage(_, c._DictionaryDeleteRequest.All.deserializeBinaryFromReader), l.setAll(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryDeleteRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryDeleteRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryDeleteRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDictionaryName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getSome(), f != null && g.writeMessage(
      2,
      f,
      c._DictionaryDeleteRequest.Some.serializeBinaryToWriter
    ), f = l.getAll(), f != null && g.writeMessage(
      3,
      f,
      c._DictionaryDeleteRequest.All.serializeBinaryToWriter
    );
  }, c._DictionaryDeleteRequest.Some.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._DictionaryDeleteRequest.Some.prototype.toObject = function(l) {
    return c._DictionaryDeleteRequest.Some.toObject(l, this);
  }, c._DictionaryDeleteRequest.Some.toObject = function(l, g) {
    var f = {
      fieldsList: g.getFieldsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryDeleteRequest.Some.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryDeleteRequest.Some();
    return c._DictionaryDeleteRequest.Some.deserializeBinaryFromReader(f, g);
  }, c._DictionaryDeleteRequest.Some.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addFields(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryDeleteRequest.Some.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryDeleteRequest.Some.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryDeleteRequest.Some.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFieldsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._DictionaryDeleteRequest.Some.prototype.getFieldsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._DictionaryDeleteRequest.Some.prototype.getFieldsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getFieldsList()
      )
    );
  }, c._DictionaryDeleteRequest.Some.prototype.getFieldsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getFieldsList()
      )
    );
  }, c._DictionaryDeleteRequest.Some.prototype.setFieldsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._DictionaryDeleteRequest.Some.prototype.addFields = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._DictionaryDeleteRequest.Some.prototype.clearFieldsList = function() {
    return this.setFieldsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryDeleteRequest.All.prototype.toObject = function(l) {
    return c._DictionaryDeleteRequest.All.toObject(l, this);
  }, c._DictionaryDeleteRequest.All.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryDeleteRequest.All.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryDeleteRequest.All();
    return c._DictionaryDeleteRequest.All.deserializeBinaryFromReader(f, g);
  }, c._DictionaryDeleteRequest.All.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryDeleteRequest.All.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryDeleteRequest.All.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryDeleteRequest.All.serializeBinaryToWriter = function(l, g) {
  }, c._DictionaryDeleteRequest.prototype.getDictionaryName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionaryDeleteRequest.prototype.getDictionaryName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryDeleteRequest.prototype.getDictionaryName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryDeleteRequest.prototype.setDictionaryName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._DictionaryDeleteRequest.prototype.getSome = function() {
    return (
      /** @type{?proto._DictionaryDeleteRequest.Some} */
      s.Message.getWrapperField(this, c._DictionaryDeleteRequest.Some, 2)
    );
  }, c._DictionaryDeleteRequest.prototype.setSome = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._DictionaryDeleteRequest.oneofGroups_[0], l);
  }, c._DictionaryDeleteRequest.prototype.clearSome = function() {
    return this.setSome(void 0);
  }, c._DictionaryDeleteRequest.prototype.hasSome = function() {
    return s.Message.getField(this, 2) != null;
  }, c._DictionaryDeleteRequest.prototype.getAll = function() {
    return (
      /** @type{?proto._DictionaryDeleteRequest.All} */
      s.Message.getWrapperField(this, c._DictionaryDeleteRequest.All, 3)
    );
  }, c._DictionaryDeleteRequest.prototype.setAll = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._DictionaryDeleteRequest.oneofGroups_[0], l);
  }, c._DictionaryDeleteRequest.prototype.clearAll = function() {
    return this.setAll(void 0);
  }, c._DictionaryDeleteRequest.prototype.hasAll = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryDeleteResponse.prototype.toObject = function(l) {
    return c._DictionaryDeleteResponse.toObject(l, this);
  }, c._DictionaryDeleteResponse.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryDeleteResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryDeleteResponse();
    return c._DictionaryDeleteResponse.deserializeBinaryFromReader(f, g);
  }, c._DictionaryDeleteResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryDeleteResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryDeleteResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryDeleteResponse.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryLengthRequest.prototype.toObject = function(l) {
    return c._DictionaryLengthRequest.toObject(l, this);
  }, c._DictionaryLengthRequest.toObject = function(l, g) {
    var f = {
      dictionaryName: g.getDictionaryName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryLengthRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryLengthRequest();
    return c._DictionaryLengthRequest.deserializeBinaryFromReader(f, g);
  }, c._DictionaryLengthRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setDictionaryName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryLengthRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryLengthRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryLengthRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDictionaryName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._DictionaryLengthRequest.prototype.getDictionaryName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DictionaryLengthRequest.prototype.getDictionaryName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryLengthRequest.prototype.getDictionaryName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getDictionaryName()
      )
    );
  }, c._DictionaryLengthRequest.prototype.setDictionaryName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._DictionaryLengthResponse.oneofGroups_ = [[1, 2]], c._DictionaryLengthResponse.DictionaryCase = {
    DICTIONARY_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._DictionaryLengthResponse.prototype.getDictionaryCase = function() {
    return (
      /** @type {proto._DictionaryLengthResponse.DictionaryCase} */
      s.Message.computeOneofCase(this, c._DictionaryLengthResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryLengthResponse.prototype.toObject = function(l) {
    return c._DictionaryLengthResponse.toObject(l, this);
  }, c._DictionaryLengthResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._DictionaryLengthResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._DictionaryLengthResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._DictionaryLengthResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryLengthResponse();
    return c._DictionaryLengthResponse.deserializeBinaryFromReader(f, g);
  }, c._DictionaryLengthResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._DictionaryLengthResponse._Found();
          g.readMessage(_, c._DictionaryLengthResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._DictionaryLengthResponse._Missing();
          g.readMessage(_, c._DictionaryLengthResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryLengthResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryLengthResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryLengthResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._DictionaryLengthResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._DictionaryLengthResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryLengthResponse._Found.prototype.toObject = function(l) {
    return c._DictionaryLengthResponse._Found.toObject(l, this);
  }, c._DictionaryLengthResponse._Found.toObject = function(l, g) {
    var f = {
      length: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryLengthResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryLengthResponse._Found();
    return c._DictionaryLengthResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._DictionaryLengthResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryLengthResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryLengthResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryLengthResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._DictionaryLengthResponse._Found.prototype.getLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._DictionaryLengthResponse._Found.prototype.setLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._DictionaryLengthResponse._Missing.prototype.toObject = function(l) {
    return c._DictionaryLengthResponse._Missing.toObject(l, this);
  }, c._DictionaryLengthResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DictionaryLengthResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DictionaryLengthResponse._Missing();
    return c._DictionaryLengthResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._DictionaryLengthResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DictionaryLengthResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DictionaryLengthResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DictionaryLengthResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._DictionaryLengthResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._DictionaryLengthResponse._Found} */
      s.Message.getWrapperField(this, c._DictionaryLengthResponse._Found, 1)
    );
  }, c._DictionaryLengthResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._DictionaryLengthResponse.oneofGroups_[0], l);
  }, c._DictionaryLengthResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._DictionaryLengthResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._DictionaryLengthResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._DictionaryLengthResponse._Missing} */
      s.Message.getWrapperField(this, c._DictionaryLengthResponse._Missing, 2)
    );
  }, c._DictionaryLengthResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._DictionaryLengthResponse.oneofGroups_[0], l);
  }, c._DictionaryLengthResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._DictionaryLengthResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SetFetchRequest.prototype.toObject = function(l) {
    return c._SetFetchRequest.toObject(l, this);
  }, c._SetFetchRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetFetchRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetFetchRequest();
    return c._SetFetchRequest.deserializeBinaryFromReader(f, g);
  }, c._SetFetchRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetFetchRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetFetchRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetFetchRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._SetFetchRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetFetchRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetFetchRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetFetchRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetFetchResponse.oneofGroups_ = [[1, 2]], c._SetFetchResponse.SetCase = {
    SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SetFetchResponse.prototype.getSetCase = function() {
    return (
      /** @type {proto._SetFetchResponse.SetCase} */
      s.Message.computeOneofCase(this, c._SetFetchResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetFetchResponse.prototype.toObject = function(l) {
    return c._SetFetchResponse.toObject(l, this);
  }, c._SetFetchResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SetFetchResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SetFetchResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetFetchResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetFetchResponse();
    return c._SetFetchResponse.deserializeBinaryFromReader(f, g);
  }, c._SetFetchResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetFetchResponse._Found();
          g.readMessage(_, c._SetFetchResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SetFetchResponse._Missing();
          g.readMessage(_, c._SetFetchResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetFetchResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetFetchResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetFetchResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SetFetchResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SetFetchResponse._Missing.serializeBinaryToWriter
    );
  }, c._SetFetchResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetFetchResponse._Found.prototype.toObject = function(l) {
    return c._SetFetchResponse._Found.toObject(l, this);
  }, c._SetFetchResponse._Found.toObject = function(l, g) {
    var f = {
      elementsList: g.getElementsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetFetchResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetFetchResponse._Found();
    return c._SetFetchResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SetFetchResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetFetchResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetFetchResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetFetchResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SetFetchResponse._Found.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SetFetchResponse._Found.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetFetchResponse._Found.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetFetchResponse._Found.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SetFetchResponse._Found.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SetFetchResponse._Found.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetFetchResponse._Missing.prototype.toObject = function(l) {
    return c._SetFetchResponse._Missing.toObject(l, this);
  }, c._SetFetchResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetFetchResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetFetchResponse._Missing();
    return c._SetFetchResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SetFetchResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetFetchResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetFetchResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetFetchResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SetFetchResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SetFetchResponse._Found} */
      s.Message.getWrapperField(this, c._SetFetchResponse._Found, 1)
    );
  }, c._SetFetchResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetFetchResponse.oneofGroups_[0], l);
  }, c._SetFetchResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SetFetchResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetFetchResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SetFetchResponse._Missing} */
      s.Message.getWrapperField(this, c._SetFetchResponse._Missing, 2)
    );
  }, c._SetFetchResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetFetchResponse.oneofGroups_[0], l);
  }, c._SetFetchResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SetFetchResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SetSampleRequest.prototype.toObject = function(l) {
    return c._SetSampleRequest.toObject(l, this);
  }, c._SetSampleRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      limit: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetSampleRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetSampleRequest();
    return c._SetSampleRequest.deserializeBinaryFromReader(f, g);
  }, c._SetSampleRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setLimit(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetSampleRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetSampleRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetSampleRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getLimit(), f !== 0 && g.writeUint64(
      2,
      f
    );
  }, c._SetSampleRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetSampleRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetSampleRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetSampleRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetSampleRequest.prototype.getLimit = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._SetSampleRequest.prototype.setLimit = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, c._SetSampleResponse.oneofGroups_ = [[1, 2]], c._SetSampleResponse.SetCase = {
    SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SetSampleResponse.prototype.getSetCase = function() {
    return (
      /** @type {proto._SetSampleResponse.SetCase} */
      s.Message.computeOneofCase(this, c._SetSampleResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetSampleResponse.prototype.toObject = function(l) {
    return c._SetSampleResponse.toObject(l, this);
  }, c._SetSampleResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SetSampleResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SetSampleResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetSampleResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetSampleResponse();
    return c._SetSampleResponse.deserializeBinaryFromReader(f, g);
  }, c._SetSampleResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetSampleResponse._Found();
          g.readMessage(_, c._SetSampleResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SetSampleResponse._Missing();
          g.readMessage(_, c._SetSampleResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetSampleResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetSampleResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetSampleResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SetSampleResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SetSampleResponse._Missing.serializeBinaryToWriter
    );
  }, c._SetSampleResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetSampleResponse._Found.prototype.toObject = function(l) {
    return c._SetSampleResponse._Found.toObject(l, this);
  }, c._SetSampleResponse._Found.toObject = function(l, g) {
    var f = {
      elementsList: g.getElementsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetSampleResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetSampleResponse._Found();
    return c._SetSampleResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SetSampleResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetSampleResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetSampleResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetSampleResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SetSampleResponse._Found.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SetSampleResponse._Found.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetSampleResponse._Found.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetSampleResponse._Found.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SetSampleResponse._Found.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SetSampleResponse._Found.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetSampleResponse._Missing.prototype.toObject = function(l) {
    return c._SetSampleResponse._Missing.toObject(l, this);
  }, c._SetSampleResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetSampleResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetSampleResponse._Missing();
    return c._SetSampleResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SetSampleResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetSampleResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetSampleResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetSampleResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SetSampleResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SetSampleResponse._Found} */
      s.Message.getWrapperField(this, c._SetSampleResponse._Found, 1)
    );
  }, c._SetSampleResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetSampleResponse.oneofGroups_[0], l);
  }, c._SetSampleResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SetSampleResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetSampleResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SetSampleResponse._Missing} */
      s.Message.getWrapperField(this, c._SetSampleResponse._Missing, 2)
    );
  }, c._SetSampleResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetSampleResponse.oneofGroups_[0], l);
  }, c._SetSampleResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SetSampleResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SetUnionRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._SetUnionRequest.prototype.toObject = function(l) {
    return c._SetUnionRequest.toObject(l, this);
  }, c._SetUnionRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      elementsList: g.getElementsList_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetUnionRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetUnionRequest();
    return c._SetUnionRequest.deserializeBinaryFromReader(f, g);
  }, c._SetUnionRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetUnionRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetUnionRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetUnionRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    );
  }, c._SetUnionRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetUnionRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetUnionRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetUnionRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetUnionRequest.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, c._SetUnionRequest.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetUnionRequest.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetUnionRequest.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 2, l || []);
  }, c._SetUnionRequest.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 2, l, g);
  }, c._SetUnionRequest.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._SetUnionRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SetUnionRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._SetUnionRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._SetUnionRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetUnionResponse.prototype.toObject = function(l) {
    return c._SetUnionResponse.toObject(l, this);
  }, c._SetUnionResponse.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetUnionResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetUnionResponse();
    return c._SetUnionResponse.deserializeBinaryFromReader(f, g);
  }, c._SetUnionResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetUnionResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetUnionResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetUnionResponse.serializeBinaryToWriter = function(l, g) {
  }, c._SetDifferenceRequest.oneofGroups_ = [[2, 3]], c._SetDifferenceRequest.DifferenceCase = {
    DIFFERENCE_NOT_SET: 0,
    MINUEND: 2,
    SUBTRAHEND: 3
  }, c._SetDifferenceRequest.prototype.getDifferenceCase = function() {
    return (
      /** @type {proto._SetDifferenceRequest.DifferenceCase} */
      s.Message.computeOneofCase(this, c._SetDifferenceRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceRequest.prototype.toObject = function(l) {
    return c._SetDifferenceRequest.toObject(l, this);
  }, c._SetDifferenceRequest.toObject = function(l, g) {
    var f, _ = {
      setName: g.getSetName_asB64(),
      minuend: (f = g.getMinuend()) && c._SetDifferenceRequest._Minuend.toObject(l, f),
      subtrahend: (f = g.getSubtrahend()) && c._SetDifferenceRequest._Subtrahend.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetDifferenceRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceRequest();
    return c._SetDifferenceRequest.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = new c._SetDifferenceRequest._Minuend();
          g.readMessage(_, c._SetDifferenceRequest._Minuend.deserializeBinaryFromReader), l.setMinuend(_);
          break;
        case 3:
          var _ = new c._SetDifferenceRequest._Subtrahend();
          g.readMessage(_, c._SetDifferenceRequest._Subtrahend.deserializeBinaryFromReader), l.setSubtrahend(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getMinuend(), f != null && g.writeMessage(
      2,
      f,
      c._SetDifferenceRequest._Minuend.serializeBinaryToWriter
    ), f = l.getSubtrahend(), f != null && g.writeMessage(
      3,
      f,
      c._SetDifferenceRequest._Subtrahend.serializeBinaryToWriter
    );
  }, c._SetDifferenceRequest._Minuend.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceRequest._Minuend.prototype.toObject = function(l) {
    return c._SetDifferenceRequest._Minuend.toObject(l, this);
  }, c._SetDifferenceRequest._Minuend.toObject = function(l, g) {
    var f = {
      elementsList: g.getElementsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetDifferenceRequest._Minuend.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceRequest._Minuend();
    return c._SetDifferenceRequest._Minuend.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceRequest._Minuend.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceRequest._Minuend.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceRequest._Minuend.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceRequest._Minuend.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SetDifferenceRequest._Minuend.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SetDifferenceRequest._Minuend.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetDifferenceRequest._Minuend.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetDifferenceRequest._Minuend.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SetDifferenceRequest._Minuend.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SetDifferenceRequest._Minuend.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._SetDifferenceRequest._Subtrahend.oneofGroups_ = [[1, 2]], c._SetDifferenceRequest._Subtrahend.SubtrahendSetCase = {
    SUBTRAHEND_SET_NOT_SET: 0,
    SET: 1,
    IDENTITY: 2
  }, c._SetDifferenceRequest._Subtrahend.prototype.getSubtrahendSetCase = function() {
    return (
      /** @type {proto._SetDifferenceRequest._Subtrahend.SubtrahendSetCase} */
      s.Message.computeOneofCase(this, c._SetDifferenceRequest._Subtrahend.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceRequest._Subtrahend.prototype.toObject = function(l) {
    return c._SetDifferenceRequest._Subtrahend.toObject(l, this);
  }, c._SetDifferenceRequest._Subtrahend.toObject = function(l, g) {
    var f, _ = {
      set: (f = g.getSet()) && c._SetDifferenceRequest._Subtrahend._Set.toObject(l, f),
      identity: (f = g.getIdentity()) && c._SetDifferenceRequest._Subtrahend._Identity.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetDifferenceRequest._Subtrahend.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceRequest._Subtrahend();
    return c._SetDifferenceRequest._Subtrahend.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceRequest._Subtrahend.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetDifferenceRequest._Subtrahend._Set();
          g.readMessage(_, c._SetDifferenceRequest._Subtrahend._Set.deserializeBinaryFromReader), l.setSet(_);
          break;
        case 2:
          var _ = new c._SetDifferenceRequest._Subtrahend._Identity();
          g.readMessage(_, c._SetDifferenceRequest._Subtrahend._Identity.deserializeBinaryFromReader), l.setIdentity(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceRequest._Subtrahend.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceRequest._Subtrahend.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceRequest._Subtrahend.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSet(), f != null && g.writeMessage(
      1,
      f,
      c._SetDifferenceRequest._Subtrahend._Set.serializeBinaryToWriter
    ), f = l.getIdentity(), f != null && g.writeMessage(
      2,
      f,
      c._SetDifferenceRequest._Subtrahend._Identity.serializeBinaryToWriter
    );
  }, c._SetDifferenceRequest._Subtrahend._Set.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceRequest._Subtrahend._Set.prototype.toObject = function(l) {
    return c._SetDifferenceRequest._Subtrahend._Set.toObject(l, this);
  }, c._SetDifferenceRequest._Subtrahend._Set.toObject = function(l, g) {
    var f = {
      elementsList: g.getElementsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetDifferenceRequest._Subtrahend._Set.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceRequest._Subtrahend._Set();
    return c._SetDifferenceRequest._Subtrahend._Set.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceRequest._Subtrahend._Set.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceRequest._Subtrahend._Set.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceRequest._Subtrahend._Set.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SetDifferenceRequest._Subtrahend._Set.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceRequest._Subtrahend._Identity.prototype.toObject = function(l) {
    return c._SetDifferenceRequest._Subtrahend._Identity.toObject(l, this);
  }, c._SetDifferenceRequest._Subtrahend._Identity.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetDifferenceRequest._Subtrahend._Identity.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceRequest._Subtrahend._Identity();
    return c._SetDifferenceRequest._Subtrahend._Identity.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceRequest._Subtrahend._Identity.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceRequest._Subtrahend._Identity.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceRequest._Subtrahend._Identity.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceRequest._Subtrahend._Identity.serializeBinaryToWriter = function(l, g) {
  }, c._SetDifferenceRequest._Subtrahend.prototype.getSet = function() {
    return (
      /** @type{?proto._SetDifferenceRequest._Subtrahend._Set} */
      s.Message.getWrapperField(this, c._SetDifferenceRequest._Subtrahend._Set, 1)
    );
  }, c._SetDifferenceRequest._Subtrahend.prototype.setSet = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetDifferenceRequest._Subtrahend.oneofGroups_[0], l);
  }, c._SetDifferenceRequest._Subtrahend.prototype.clearSet = function() {
    return this.setSet(void 0);
  }, c._SetDifferenceRequest._Subtrahend.prototype.hasSet = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetDifferenceRequest._Subtrahend.prototype.getIdentity = function() {
    return (
      /** @type{?proto._SetDifferenceRequest._Subtrahend._Identity} */
      s.Message.getWrapperField(this, c._SetDifferenceRequest._Subtrahend._Identity, 2)
    );
  }, c._SetDifferenceRequest._Subtrahend.prototype.setIdentity = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetDifferenceRequest._Subtrahend.oneofGroups_[0], l);
  }, c._SetDifferenceRequest._Subtrahend.prototype.clearIdentity = function() {
    return this.setIdentity(void 0);
  }, c._SetDifferenceRequest._Subtrahend.prototype.hasIdentity = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SetDifferenceRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetDifferenceRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetDifferenceRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetDifferenceRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetDifferenceRequest.prototype.getMinuend = function() {
    return (
      /** @type{?proto._SetDifferenceRequest._Minuend} */
      s.Message.getWrapperField(this, c._SetDifferenceRequest._Minuend, 2)
    );
  }, c._SetDifferenceRequest.prototype.setMinuend = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetDifferenceRequest.oneofGroups_[0], l);
  }, c._SetDifferenceRequest.prototype.clearMinuend = function() {
    return this.setMinuend(void 0);
  }, c._SetDifferenceRequest.prototype.hasMinuend = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SetDifferenceRequest.prototype.getSubtrahend = function() {
    return (
      /** @type{?proto._SetDifferenceRequest._Subtrahend} */
      s.Message.getWrapperField(this, c._SetDifferenceRequest._Subtrahend, 3)
    );
  }, c._SetDifferenceRequest.prototype.setSubtrahend = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._SetDifferenceRequest.oneofGroups_[0], l);
  }, c._SetDifferenceRequest.prototype.clearSubtrahend = function() {
    return this.setSubtrahend(void 0);
  }, c._SetDifferenceRequest.prototype.hasSubtrahend = function() {
    return s.Message.getField(this, 3) != null;
  }, c._SetDifferenceResponse.oneofGroups_ = [[1, 2]], c._SetDifferenceResponse.SetCase = {
    SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SetDifferenceResponse.prototype.getSetCase = function() {
    return (
      /** @type {proto._SetDifferenceResponse.SetCase} */
      s.Message.computeOneofCase(this, c._SetDifferenceResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceResponse.prototype.toObject = function(l) {
    return c._SetDifferenceResponse.toObject(l, this);
  }, c._SetDifferenceResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SetDifferenceResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SetDifferenceResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetDifferenceResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceResponse();
    return c._SetDifferenceResponse.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetDifferenceResponse._Found();
          g.readMessage(_, c._SetDifferenceResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SetDifferenceResponse._Missing();
          g.readMessage(_, c._SetDifferenceResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SetDifferenceResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SetDifferenceResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceResponse._Found.prototype.toObject = function(l) {
    return c._SetDifferenceResponse._Found.toObject(l, this);
  }, c._SetDifferenceResponse._Found.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetDifferenceResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceResponse._Found();
    return c._SetDifferenceResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceResponse._Found.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SetDifferenceResponse._Missing.prototype.toObject = function(l) {
    return c._SetDifferenceResponse._Missing.toObject(l, this);
  }, c._SetDifferenceResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetDifferenceResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetDifferenceResponse._Missing();
    return c._SetDifferenceResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SetDifferenceResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetDifferenceResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetDifferenceResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetDifferenceResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SetDifferenceResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SetDifferenceResponse._Found} */
      s.Message.getWrapperField(this, c._SetDifferenceResponse._Found, 1)
    );
  }, c._SetDifferenceResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetDifferenceResponse.oneofGroups_[0], l);
  }, c._SetDifferenceResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SetDifferenceResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetDifferenceResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SetDifferenceResponse._Missing} */
      s.Message.getWrapperField(this, c._SetDifferenceResponse._Missing, 2)
    );
  }, c._SetDifferenceResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetDifferenceResponse.oneofGroups_[0], l);
  }, c._SetDifferenceResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SetDifferenceResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SetContainsRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._SetContainsRequest.prototype.toObject = function(l) {
    return c._SetContainsRequest.toObject(l, this);
  }, c._SetContainsRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      elementsList: g.getElementsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetContainsRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetContainsRequest();
    return c._SetContainsRequest.deserializeBinaryFromReader(f, g);
  }, c._SetContainsRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetContainsRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetContainsRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetContainsRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      2,
      f
    );
  }, c._SetContainsRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetContainsRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetContainsRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetContainsRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetContainsRequest.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, c._SetContainsRequest.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetContainsRequest.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetContainsRequest.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 2, l || []);
  }, c._SetContainsRequest.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 2, l, g);
  }, c._SetContainsRequest.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._SetContainsResponse.oneofGroups_ = [[1, 2]], c._SetContainsResponse.SetCase = {
    SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SetContainsResponse.prototype.getSetCase = function() {
    return (
      /** @type {proto._SetContainsResponse.SetCase} */
      s.Message.computeOneofCase(this, c._SetContainsResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetContainsResponse.prototype.toObject = function(l) {
    return c._SetContainsResponse.toObject(l, this);
  }, c._SetContainsResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SetContainsResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SetContainsResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetContainsResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetContainsResponse();
    return c._SetContainsResponse.deserializeBinaryFromReader(f, g);
  }, c._SetContainsResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetContainsResponse._Found();
          g.readMessage(_, c._SetContainsResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SetContainsResponse._Missing();
          g.readMessage(_, c._SetContainsResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetContainsResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetContainsResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetContainsResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SetContainsResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SetContainsResponse._Missing.serializeBinaryToWriter
    );
  }, c._SetContainsResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetContainsResponse._Found.prototype.toObject = function(l) {
    return c._SetContainsResponse._Found.toObject(l, this);
  }, c._SetContainsResponse._Found.toObject = function(l, g) {
    var f, _ = {
      containsList: (f = s.Message.getRepeatedBooleanField(g, 1)) == null ? void 0 : f
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetContainsResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetContainsResponse._Found();
    return c._SetContainsResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SetContainsResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          for (var _ = (
            /** @type {!Array<boolean>} */
            g.isDelimited() ? g.readPackedBool() : [g.readBool()]
          ), te = 0; te < _.length; te++)
            l.addContains(_[te]);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetContainsResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetContainsResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetContainsResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getContainsList(), f.length > 0 && g.writePackedBool(
      1,
      f
    );
  }, c._SetContainsResponse._Found.prototype.getContainsList = function() {
    return (
      /** @type {!Array<boolean>} */
      s.Message.getRepeatedBooleanField(this, 1)
    );
  }, c._SetContainsResponse._Found.prototype.setContainsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SetContainsResponse._Found.prototype.addContains = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SetContainsResponse._Found.prototype.clearContainsList = function() {
    return this.setContainsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetContainsResponse._Missing.prototype.toObject = function(l) {
    return c._SetContainsResponse._Missing.toObject(l, this);
  }, c._SetContainsResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetContainsResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetContainsResponse._Missing();
    return c._SetContainsResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SetContainsResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetContainsResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetContainsResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetContainsResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SetContainsResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SetContainsResponse._Found} */
      s.Message.getWrapperField(this, c._SetContainsResponse._Found, 1)
    );
  }, c._SetContainsResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetContainsResponse.oneofGroups_[0], l);
  }, c._SetContainsResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SetContainsResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetContainsResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SetContainsResponse._Missing} */
      s.Message.getWrapperField(this, c._SetContainsResponse._Missing, 2)
    );
  }, c._SetContainsResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetContainsResponse.oneofGroups_[0], l);
  }, c._SetContainsResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SetContainsResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SetLengthRequest.prototype.toObject = function(l) {
    return c._SetLengthRequest.toObject(l, this);
  }, c._SetLengthRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetLengthRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetLengthRequest();
    return c._SetLengthRequest.deserializeBinaryFromReader(f, g);
  }, c._SetLengthRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetLengthRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetLengthRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetLengthRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._SetLengthRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetLengthRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetLengthRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetLengthRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetLengthResponse.oneofGroups_ = [[1, 2]], c._SetLengthResponse.SetCase = {
    SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SetLengthResponse.prototype.getSetCase = function() {
    return (
      /** @type {proto._SetLengthResponse.SetCase} */
      s.Message.computeOneofCase(this, c._SetLengthResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetLengthResponse.prototype.toObject = function(l) {
    return c._SetLengthResponse.toObject(l, this);
  }, c._SetLengthResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SetLengthResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SetLengthResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetLengthResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetLengthResponse();
    return c._SetLengthResponse.deserializeBinaryFromReader(f, g);
  }, c._SetLengthResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetLengthResponse._Found();
          g.readMessage(_, c._SetLengthResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SetLengthResponse._Missing();
          g.readMessage(_, c._SetLengthResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetLengthResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetLengthResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetLengthResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SetLengthResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SetLengthResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetLengthResponse._Found.prototype.toObject = function(l) {
    return c._SetLengthResponse._Found.toObject(l, this);
  }, c._SetLengthResponse._Found.toObject = function(l, g) {
    var f = {
      length: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetLengthResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetLengthResponse._Found();
    return c._SetLengthResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SetLengthResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetLengthResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetLengthResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetLengthResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._SetLengthResponse._Found.prototype.getLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._SetLengthResponse._Found.prototype.setLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetLengthResponse._Missing.prototype.toObject = function(l) {
    return c._SetLengthResponse._Missing.toObject(l, this);
  }, c._SetLengthResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetLengthResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetLengthResponse._Missing();
    return c._SetLengthResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SetLengthResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetLengthResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetLengthResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetLengthResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SetLengthResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SetLengthResponse._Found} */
      s.Message.getWrapperField(this, c._SetLengthResponse._Found, 1)
    );
  }, c._SetLengthResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetLengthResponse.oneofGroups_[0], l);
  }, c._SetLengthResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SetLengthResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetLengthResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SetLengthResponse._Missing} */
      s.Message.getWrapperField(this, c._SetLengthResponse._Missing, 2)
    );
  }, c._SetLengthResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetLengthResponse.oneofGroups_[0], l);
  }, c._SetLengthResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SetLengthResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SetPopRequest.prototype.toObject = function(l) {
    return c._SetPopRequest.toObject(l, this);
  }, c._SetPopRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      count: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetPopRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetPopRequest();
    return c._SetPopRequest.deserializeBinaryFromReader(f, g);
  }, c._SetPopRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setCount(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetPopRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetPopRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetPopRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getCount(), f !== 0 && g.writeUint32(
      2,
      f
    );
  }, c._SetPopRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SetPopRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SetPopRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SetPopRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SetPopRequest.prototype.getCount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._SetPopRequest.prototype.setCount = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, c._SetPopResponse.oneofGroups_ = [[1, 2]], c._SetPopResponse.SetCase = {
    SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SetPopResponse.prototype.getSetCase = function() {
    return (
      /** @type {proto._SetPopResponse.SetCase} */
      s.Message.computeOneofCase(this, c._SetPopResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SetPopResponse.prototype.toObject = function(l) {
    return c._SetPopResponse.toObject(l, this);
  }, c._SetPopResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SetPopResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SetPopResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SetPopResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetPopResponse();
    return c._SetPopResponse.deserializeBinaryFromReader(f, g);
  }, c._SetPopResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SetPopResponse._Found();
          g.readMessage(_, c._SetPopResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SetPopResponse._Missing();
          g.readMessage(_, c._SetPopResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetPopResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetPopResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetPopResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SetPopResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SetPopResponse._Missing.serializeBinaryToWriter
    );
  }, c._SetPopResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SetPopResponse._Found.prototype.toObject = function(l) {
    return c._SetPopResponse._Found.toObject(l, this);
  }, c._SetPopResponse._Found.toObject = function(l, g) {
    var f = {
      elementsList: g.getElementsList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetPopResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetPopResponse._Found();
    return c._SetPopResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SetPopResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetPopResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetPopResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetPopResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SetPopResponse._Found.prototype.getElementsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SetPopResponse._Found.prototype.getElementsList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getElementsList()
      )
    );
  }, c._SetPopResponse._Found.prototype.getElementsList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getElementsList()
      )
    );
  }, c._SetPopResponse._Found.prototype.setElementsList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SetPopResponse._Found.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SetPopResponse._Found.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._SetPopResponse._Missing.prototype.toObject = function(l) {
    return c._SetPopResponse._Missing.toObject(l, this);
  }, c._SetPopResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SetPopResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SetPopResponse._Missing();
    return c._SetPopResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SetPopResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SetPopResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SetPopResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SetPopResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SetPopResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SetPopResponse._Found} */
      s.Message.getWrapperField(this, c._SetPopResponse._Found, 1)
    );
  }, c._SetPopResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SetPopResponse.oneofGroups_[0], l);
  }, c._SetPopResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SetPopResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SetPopResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SetPopResponse._Missing} */
      s.Message.getWrapperField(this, c._SetPopResponse._Missing, 2)
    );
  }, c._SetPopResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SetPopResponse.oneofGroups_[0], l);
  }, c._SetPopResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SetPopResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListConcatenateFrontRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._ListConcatenateFrontRequest.prototype.toObject = function(l) {
    return c._ListConcatenateFrontRequest.toObject(l, this);
  }, c._ListConcatenateFrontRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64(),
      valuesList: g.getValuesList_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1),
      truncateBackToSize: s.Message.getFieldWithDefault(g, 5, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListConcatenateFrontRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListConcatenateFrontRequest();
    return c._ListConcatenateFrontRequest.deserializeBinaryFromReader(f, g);
  }, c._ListConcatenateFrontRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addValues(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setTruncateBackToSize(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListConcatenateFrontRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListConcatenateFrontRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListConcatenateFrontRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValuesList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    ), f = l.getTruncateBackToSize(), f !== 0 && g.writeUint32(
      5,
      f
    );
  }, c._ListConcatenateFrontRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListConcatenateFrontRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListConcatenateFrontRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListConcatenateFrontRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListConcatenateFrontRequest.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, c._ListConcatenateFrontRequest.prototype.getValuesList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getValuesList()
      )
    );
  }, c._ListConcatenateFrontRequest.prototype.getValuesList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getValuesList()
      )
    );
  }, c._ListConcatenateFrontRequest.prototype.setValuesList = function(l) {
    return s.Message.setField(this, 2, l || []);
  }, c._ListConcatenateFrontRequest.prototype.addValues = function(l, g) {
    return s.Message.addToRepeatedField(this, 2, l, g);
  }, c._ListConcatenateFrontRequest.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, c._ListConcatenateFrontRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._ListConcatenateFrontRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._ListConcatenateFrontRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._ListConcatenateFrontRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, c._ListConcatenateFrontRequest.prototype.getTruncateBackToSize = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._ListConcatenateFrontRequest.prototype.setTruncateBackToSize = function(l) {
    return s.Message.setProto3IntField(this, 5, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListConcatenateFrontResponse.prototype.toObject = function(l) {
    return c._ListConcatenateFrontResponse.toObject(l, this);
  }, c._ListConcatenateFrontResponse.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListConcatenateFrontResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListConcatenateFrontResponse();
    return c._ListConcatenateFrontResponse.deserializeBinaryFromReader(f, g);
  }, c._ListConcatenateFrontResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListConcatenateFrontResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListConcatenateFrontResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListConcatenateFrontResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListConcatenateFrontResponse.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListConcatenateFrontResponse.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._ListConcatenateBackRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._ListConcatenateBackRequest.prototype.toObject = function(l) {
    return c._ListConcatenateBackRequest.toObject(l, this);
  }, c._ListConcatenateBackRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64(),
      valuesList: g.getValuesList_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1),
      truncateFrontToSize: s.Message.getFieldWithDefault(g, 5, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListConcatenateBackRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListConcatenateBackRequest();
    return c._ListConcatenateBackRequest.deserializeBinaryFromReader(f, g);
  }, c._ListConcatenateBackRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addValues(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setTruncateFrontToSize(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListConcatenateBackRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListConcatenateBackRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListConcatenateBackRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValuesList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    ), f = l.getTruncateFrontToSize(), f !== 0 && g.writeUint32(
      5,
      f
    );
  }, c._ListConcatenateBackRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListConcatenateBackRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListConcatenateBackRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListConcatenateBackRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListConcatenateBackRequest.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, c._ListConcatenateBackRequest.prototype.getValuesList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getValuesList()
      )
    );
  }, c._ListConcatenateBackRequest.prototype.getValuesList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getValuesList()
      )
    );
  }, c._ListConcatenateBackRequest.prototype.setValuesList = function(l) {
    return s.Message.setField(this, 2, l || []);
  }, c._ListConcatenateBackRequest.prototype.addValues = function(l, g) {
    return s.Message.addToRepeatedField(this, 2, l, g);
  }, c._ListConcatenateBackRequest.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, c._ListConcatenateBackRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._ListConcatenateBackRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._ListConcatenateBackRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._ListConcatenateBackRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, c._ListConcatenateBackRequest.prototype.getTruncateFrontToSize = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._ListConcatenateBackRequest.prototype.setTruncateFrontToSize = function(l) {
    return s.Message.setProto3IntField(this, 5, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListConcatenateBackResponse.prototype.toObject = function(l) {
    return c._ListConcatenateBackResponse.toObject(l, this);
  }, c._ListConcatenateBackResponse.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListConcatenateBackResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListConcatenateBackResponse();
    return c._ListConcatenateBackResponse.deserializeBinaryFromReader(f, g);
  }, c._ListConcatenateBackResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListConcatenateBackResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListConcatenateBackResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListConcatenateBackResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListConcatenateBackResponse.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListConcatenateBackResponse.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPushFrontRequest.prototype.toObject = function(l) {
    return c._ListPushFrontRequest.toObject(l, this);
  }, c._ListPushFrontRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64(),
      value: g.getValue_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1),
      truncateBackToSize: s.Message.getFieldWithDefault(g, 5, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPushFrontRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPushFrontRequest();
    return c._ListPushFrontRequest.deserializeBinaryFromReader(f, g);
  }, c._ListPushFrontRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setValue(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setTruncateBackToSize(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPushFrontRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPushFrontRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPushFrontRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValue_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    ), f = l.getTruncateBackToSize(), f !== 0 && g.writeUint32(
      5,
      f
    );
  }, c._ListPushFrontRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListPushFrontRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListPushFrontRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListPushFrontRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListPushFrontRequest.prototype.getValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._ListPushFrontRequest.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, c._ListPushFrontRequest.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, c._ListPushFrontRequest.prototype.setValue = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._ListPushFrontRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._ListPushFrontRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._ListPushFrontRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._ListPushFrontRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, c._ListPushFrontRequest.prototype.getTruncateBackToSize = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._ListPushFrontRequest.prototype.setTruncateBackToSize = function(l) {
    return s.Message.setProto3IntField(this, 5, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPushFrontResponse.prototype.toObject = function(l) {
    return c._ListPushFrontResponse.toObject(l, this);
  }, c._ListPushFrontResponse.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPushFrontResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPushFrontResponse();
    return c._ListPushFrontResponse.deserializeBinaryFromReader(f, g);
  }, c._ListPushFrontResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPushFrontResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPushFrontResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPushFrontResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListPushFrontResponse.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListPushFrontResponse.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPushBackRequest.prototype.toObject = function(l) {
    return c._ListPushBackRequest.toObject(l, this);
  }, c._ListPushBackRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64(),
      value: g.getValue_asB64(),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1),
      truncateFrontToSize: s.Message.getFieldWithDefault(g, 5, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPushBackRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPushBackRequest();
    return c._ListPushBackRequest.deserializeBinaryFromReader(f, g);
  }, c._ListPushBackRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setValue(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setTruncateFrontToSize(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPushBackRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPushBackRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPushBackRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValue_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    ), f = l.getTruncateFrontToSize(), f !== 0 && g.writeUint32(
      5,
      f
    );
  }, c._ListPushBackRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListPushBackRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListPushBackRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListPushBackRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListPushBackRequest.prototype.getValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._ListPushBackRequest.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, c._ListPushBackRequest.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, c._ListPushBackRequest.prototype.setValue = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._ListPushBackRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._ListPushBackRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._ListPushBackRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._ListPushBackRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, c._ListPushBackRequest.prototype.getTruncateFrontToSize = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._ListPushBackRequest.prototype.setTruncateFrontToSize = function(l) {
    return s.Message.setProto3IntField(this, 5, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPushBackResponse.prototype.toObject = function(l) {
    return c._ListPushBackResponse.toObject(l, this);
  }, c._ListPushBackResponse.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPushBackResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPushBackResponse();
    return c._ListPushBackResponse.deserializeBinaryFromReader(f, g);
  }, c._ListPushBackResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPushBackResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPushBackResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPushBackResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListPushBackResponse.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListPushBackResponse.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopFrontRequest.prototype.toObject = function(l) {
    return c._ListPopFrontRequest.toObject(l, this);
  }, c._ListPopFrontRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPopFrontRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopFrontRequest();
    return c._ListPopFrontRequest.deserializeBinaryFromReader(f, g);
  }, c._ListPopFrontRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopFrontRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopFrontRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopFrontRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._ListPopFrontRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListPopFrontRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListPopFrontRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListPopFrontRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListPopFrontResponse.oneofGroups_ = [[1, 2]], c._ListPopFrontResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListPopFrontResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListPopFrontResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListPopFrontResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopFrontResponse.prototype.toObject = function(l) {
    return c._ListPopFrontResponse.toObject(l, this);
  }, c._ListPopFrontResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListPopFrontResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListPopFrontResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListPopFrontResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopFrontResponse();
    return c._ListPopFrontResponse.deserializeBinaryFromReader(f, g);
  }, c._ListPopFrontResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListPopFrontResponse._Found();
          g.readMessage(_, c._ListPopFrontResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListPopFrontResponse._Missing();
          g.readMessage(_, c._ListPopFrontResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopFrontResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopFrontResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopFrontResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListPopFrontResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListPopFrontResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopFrontResponse._Found.prototype.toObject = function(l) {
    return c._ListPopFrontResponse._Found.toObject(l, this);
  }, c._ListPopFrontResponse._Found.toObject = function(l, g) {
    var f = {
      front: g.getFront_asB64(),
      listLength: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPopFrontResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopFrontResponse._Found();
    return c._ListPopFrontResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListPopFrontResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setFront(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopFrontResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopFrontResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopFrontResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFront_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getListLength(), f !== 0 && g.writeUint32(
      2,
      f
    );
  }, c._ListPopFrontResponse._Found.prototype.getFront = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListPopFrontResponse._Found.prototype.getFront_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getFront()
      )
    );
  }, c._ListPopFrontResponse._Found.prototype.getFront_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getFront()
      )
    );
  }, c._ListPopFrontResponse._Found.prototype.setFront = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListPopFrontResponse._Found.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._ListPopFrontResponse._Found.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopFrontResponse._Missing.prototype.toObject = function(l) {
    return c._ListPopFrontResponse._Missing.toObject(l, this);
  }, c._ListPopFrontResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPopFrontResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopFrontResponse._Missing();
    return c._ListPopFrontResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListPopFrontResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopFrontResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopFrontResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopFrontResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListPopFrontResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListPopFrontResponse._Found} */
      s.Message.getWrapperField(this, c._ListPopFrontResponse._Found, 1)
    );
  }, c._ListPopFrontResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListPopFrontResponse.oneofGroups_[0], l);
  }, c._ListPopFrontResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListPopFrontResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListPopFrontResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListPopFrontResponse._Missing} */
      s.Message.getWrapperField(this, c._ListPopFrontResponse._Missing, 2)
    );
  }, c._ListPopFrontResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListPopFrontResponse.oneofGroups_[0], l);
  }, c._ListPopFrontResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListPopFrontResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopBackRequest.prototype.toObject = function(l) {
    return c._ListPopBackRequest.toObject(l, this);
  }, c._ListPopBackRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPopBackRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopBackRequest();
    return c._ListPopBackRequest.deserializeBinaryFromReader(f, g);
  }, c._ListPopBackRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopBackRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopBackRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopBackRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._ListPopBackRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListPopBackRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListPopBackRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListPopBackRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListPopBackResponse.oneofGroups_ = [[1, 2]], c._ListPopBackResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListPopBackResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListPopBackResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListPopBackResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopBackResponse.prototype.toObject = function(l) {
    return c._ListPopBackResponse.toObject(l, this);
  }, c._ListPopBackResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListPopBackResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListPopBackResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListPopBackResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopBackResponse();
    return c._ListPopBackResponse.deserializeBinaryFromReader(f, g);
  }, c._ListPopBackResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListPopBackResponse._Found();
          g.readMessage(_, c._ListPopBackResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListPopBackResponse._Missing();
          g.readMessage(_, c._ListPopBackResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopBackResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopBackResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopBackResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListPopBackResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListPopBackResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopBackResponse._Found.prototype.toObject = function(l) {
    return c._ListPopBackResponse._Found.toObject(l, this);
  }, c._ListPopBackResponse._Found.toObject = function(l, g) {
    var f = {
      back: g.getBack_asB64(),
      listLength: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPopBackResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopBackResponse._Found();
    return c._ListPopBackResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListPopBackResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setBack(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopBackResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopBackResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopBackResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getBack_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getListLength(), f !== 0 && g.writeUint32(
      2,
      f
    );
  }, c._ListPopBackResponse._Found.prototype.getBack = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListPopBackResponse._Found.prototype.getBack_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getBack()
      )
    );
  }, c._ListPopBackResponse._Found.prototype.getBack_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getBack()
      )
    );
  }, c._ListPopBackResponse._Found.prototype.setBack = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListPopBackResponse._Found.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._ListPopBackResponse._Found.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListPopBackResponse._Missing.prototype.toObject = function(l) {
    return c._ListPopBackResponse._Missing.toObject(l, this);
  }, c._ListPopBackResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListPopBackResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListPopBackResponse._Missing();
    return c._ListPopBackResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListPopBackResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListPopBackResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListPopBackResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListPopBackResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListPopBackResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListPopBackResponse._Found} */
      s.Message.getWrapperField(this, c._ListPopBackResponse._Found, 1)
    );
  }, c._ListPopBackResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListPopBackResponse.oneofGroups_[0], l);
  }, c._ListPopBackResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListPopBackResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListPopBackResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListPopBackResponse._Missing} */
      s.Message.getWrapperField(this, c._ListPopBackResponse._Missing, 2)
    );
  }, c._ListPopBackResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListPopBackResponse.oneofGroups_[0], l);
  }, c._ListPopBackResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListPopBackResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRange.prototype.toObject = function(l) {
    return c._ListRange.toObject(l, this);
  }, c._ListRange.toObject = function(l, g) {
    var f = {
      beginIndex: s.Message.getFieldWithDefault(g, 1, 0),
      count: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListRange.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRange();
    return c._ListRange.deserializeBinaryFromReader(f, g);
  }, c._ListRange.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setBeginIndex(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setCount(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRange.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRange.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRange.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getBeginIndex(), f !== 0 && g.writeUint32(
      1,
      f
    ), f = l.getCount(), f !== 0 && g.writeUint32(
      2,
      f
    );
  }, c._ListRange.prototype.getBeginIndex = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListRange.prototype.setBeginIndex = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._ListRange.prototype.getCount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._ListRange.prototype.setCount = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, c._ListEraseRequest.oneofGroups_ = [[2, 3]], c._ListEraseRequest.EraseCase = {
    ERASE_NOT_SET: 0,
    SOME: 2,
    ALL: 3
  }, c._ListEraseRequest.prototype.getEraseCase = function() {
    return (
      /** @type {proto._ListEraseRequest.EraseCase} */
      s.Message.computeOneofCase(this, c._ListEraseRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListEraseRequest.prototype.toObject = function(l) {
    return c._ListEraseRequest.toObject(l, this);
  }, c._ListEraseRequest.toObject = function(l, g) {
    var f, _ = {
      listName: g.getListName_asB64(),
      some: (f = g.getSome()) && c._ListEraseRequest._ListRanges.toObject(l, f),
      all: (f = g.getAll()) && c._ListEraseRequest._All.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListEraseRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListEraseRequest();
    return c._ListEraseRequest.deserializeBinaryFromReader(f, g);
  }, c._ListEraseRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = new c._ListEraseRequest._ListRanges();
          g.readMessage(_, c._ListEraseRequest._ListRanges.deserializeBinaryFromReader), l.setSome(_);
          break;
        case 3:
          var _ = new c._ListEraseRequest._All();
          g.readMessage(_, c._ListEraseRequest._All.deserializeBinaryFromReader), l.setAll(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListEraseRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListEraseRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListEraseRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getSome(), f != null && g.writeMessage(
      2,
      f,
      c._ListEraseRequest._ListRanges.serializeBinaryToWriter
    ), f = l.getAll(), f != null && g.writeMessage(
      3,
      f,
      c._ListEraseRequest._All.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListEraseRequest._All.prototype.toObject = function(l) {
    return c._ListEraseRequest._All.toObject(l, this);
  }, c._ListEraseRequest._All.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListEraseRequest._All.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListEraseRequest._All();
    return c._ListEraseRequest._All.deserializeBinaryFromReader(f, g);
  }, c._ListEraseRequest._All.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListEraseRequest._All.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListEraseRequest._All.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListEraseRequest._All.serializeBinaryToWriter = function(l, g) {
  }, c._ListEraseRequest._ListRanges.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListEraseRequest._ListRanges.prototype.toObject = function(l) {
    return c._ListEraseRequest._ListRanges.toObject(l, this);
  }, c._ListEraseRequest._ListRanges.toObject = function(l, g) {
    var f = {
      rangesList: s.Message.toObjectList(
        g.getRangesList(),
        c._ListRange.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListEraseRequest._ListRanges.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListEraseRequest._ListRanges();
    return c._ListEraseRequest._ListRanges.deserializeBinaryFromReader(f, g);
  }, c._ListEraseRequest._ListRanges.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListRange();
          g.readMessage(_, c._ListRange.deserializeBinaryFromReader), l.addRanges(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListEraseRequest._ListRanges.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListEraseRequest._ListRanges.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListEraseRequest._ListRanges.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getRangesList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._ListRange.serializeBinaryToWriter
    );
  }, c._ListEraseRequest._ListRanges.prototype.getRangesList = function() {
    return (
      /** @type{!Array<!proto._ListRange>} */
      s.Message.getRepeatedWrapperField(this, c._ListRange, 1)
    );
  }, c._ListEraseRequest._ListRanges.prototype.setRangesList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._ListEraseRequest._ListRanges.prototype.addRanges = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._ListRange, g);
  }, c._ListEraseRequest._ListRanges.prototype.clearRangesList = function() {
    return this.setRangesList([]);
  }, c._ListEraseRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListEraseRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListEraseRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListEraseRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListEraseRequest.prototype.getSome = function() {
    return (
      /** @type{?proto._ListEraseRequest._ListRanges} */
      s.Message.getWrapperField(this, c._ListEraseRequest._ListRanges, 2)
    );
  }, c._ListEraseRequest.prototype.setSome = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListEraseRequest.oneofGroups_[0], l);
  }, c._ListEraseRequest.prototype.clearSome = function() {
    return this.setSome(void 0);
  }, c._ListEraseRequest.prototype.hasSome = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListEraseRequest.prototype.getAll = function() {
    return (
      /** @type{?proto._ListEraseRequest._All} */
      s.Message.getWrapperField(this, c._ListEraseRequest._All, 3)
    );
  }, c._ListEraseRequest.prototype.setAll = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._ListEraseRequest.oneofGroups_[0], l);
  }, c._ListEraseRequest.prototype.clearAll = function() {
    return this.setAll(void 0);
  }, c._ListEraseRequest.prototype.hasAll = function() {
    return s.Message.getField(this, 3) != null;
  }, c._ListEraseResponse.oneofGroups_ = [[1, 2]], c._ListEraseResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListEraseResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListEraseResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListEraseResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListEraseResponse.prototype.toObject = function(l) {
    return c._ListEraseResponse.toObject(l, this);
  }, c._ListEraseResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListEraseResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListEraseResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListEraseResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListEraseResponse();
    return c._ListEraseResponse.deserializeBinaryFromReader(f, g);
  }, c._ListEraseResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListEraseResponse._Found();
          g.readMessage(_, c._ListEraseResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListEraseResponse._Missing();
          g.readMessage(_, c._ListEraseResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListEraseResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListEraseResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListEraseResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListEraseResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListEraseResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListEraseResponse._Found.prototype.toObject = function(l) {
    return c._ListEraseResponse._Found.toObject(l, this);
  }, c._ListEraseResponse._Found.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListEraseResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListEraseResponse._Found();
    return c._ListEraseResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListEraseResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListEraseResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListEraseResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListEraseResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListEraseResponse._Found.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListEraseResponse._Found.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListEraseResponse._Missing.prototype.toObject = function(l) {
    return c._ListEraseResponse._Missing.toObject(l, this);
  }, c._ListEraseResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListEraseResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListEraseResponse._Missing();
    return c._ListEraseResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListEraseResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListEraseResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListEraseResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListEraseResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListEraseResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListEraseResponse._Found} */
      s.Message.getWrapperField(this, c._ListEraseResponse._Found, 1)
    );
  }, c._ListEraseResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListEraseResponse.oneofGroups_[0], l);
  }, c._ListEraseResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListEraseResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListEraseResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListEraseResponse._Missing} */
      s.Message.getWrapperField(this, c._ListEraseResponse._Missing, 2)
    );
  }, c._ListEraseResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListEraseResponse.oneofGroups_[0], l);
  }, c._ListEraseResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListEraseResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListRemoveRequest.oneofGroups_ = [[2]], c._ListRemoveRequest.RemoveCase = {
    REMOVE_NOT_SET: 0,
    ALL_ELEMENTS_WITH_VALUE: 2
  }, c._ListRemoveRequest.prototype.getRemoveCase = function() {
    return (
      /** @type {proto._ListRemoveRequest.RemoveCase} */
      s.Message.computeOneofCase(this, c._ListRemoveRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRemoveRequest.prototype.toObject = function(l) {
    return c._ListRemoveRequest.toObject(l, this);
  }, c._ListRemoveRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64(),
      allElementsWithValue: g.getAllElementsWithValue_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListRemoveRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRemoveRequest();
    return c._ListRemoveRequest.deserializeBinaryFromReader(f, g);
  }, c._ListRemoveRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setAllElementsWithValue(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRemoveRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRemoveRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRemoveRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = /** @type {!(string|Uint8Array)} */
    s.Message.getField(l, 2), f != null && g.writeBytes(
      2,
      f
    );
  }, c._ListRemoveRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListRemoveRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListRemoveRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListRemoveRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListRemoveRequest.prototype.getAllElementsWithValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._ListRemoveRequest.prototype.getAllElementsWithValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getAllElementsWithValue()
      )
    );
  }, c._ListRemoveRequest.prototype.getAllElementsWithValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getAllElementsWithValue()
      )
    );
  }, c._ListRemoveRequest.prototype.setAllElementsWithValue = function(l) {
    return s.Message.setOneofField(this, 2, c._ListRemoveRequest.oneofGroups_[0], l);
  }, c._ListRemoveRequest.prototype.clearAllElementsWithValue = function() {
    return s.Message.setOneofField(this, 2, c._ListRemoveRequest.oneofGroups_[0], void 0);
  }, c._ListRemoveRequest.prototype.hasAllElementsWithValue = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListRemoveResponse.oneofGroups_ = [[1, 2]], c._ListRemoveResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListRemoveResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListRemoveResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListRemoveResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRemoveResponse.prototype.toObject = function(l) {
    return c._ListRemoveResponse.toObject(l, this);
  }, c._ListRemoveResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListRemoveResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListRemoveResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListRemoveResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRemoveResponse();
    return c._ListRemoveResponse.deserializeBinaryFromReader(f, g);
  }, c._ListRemoveResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListRemoveResponse._Found();
          g.readMessage(_, c._ListRemoveResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListRemoveResponse._Missing();
          g.readMessage(_, c._ListRemoveResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRemoveResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRemoveResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRemoveResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListRemoveResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListRemoveResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRemoveResponse._Found.prototype.toObject = function(l) {
    return c._ListRemoveResponse._Found.toObject(l, this);
  }, c._ListRemoveResponse._Found.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListRemoveResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRemoveResponse._Found();
    return c._ListRemoveResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListRemoveResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRemoveResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRemoveResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRemoveResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListRemoveResponse._Found.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListRemoveResponse._Found.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRemoveResponse._Missing.prototype.toObject = function(l) {
    return c._ListRemoveResponse._Missing.toObject(l, this);
  }, c._ListRemoveResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListRemoveResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRemoveResponse._Missing();
    return c._ListRemoveResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListRemoveResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRemoveResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRemoveResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRemoveResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListRemoveResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListRemoveResponse._Found} */
      s.Message.getWrapperField(this, c._ListRemoveResponse._Found, 1)
    );
  }, c._ListRemoveResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListRemoveResponse.oneofGroups_[0], l);
  }, c._ListRemoveResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListRemoveResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListRemoveResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListRemoveResponse._Missing} */
      s.Message.getWrapperField(this, c._ListRemoveResponse._Missing, 2)
    );
  }, c._ListRemoveResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListRemoveResponse.oneofGroups_[0], l);
  }, c._ListRemoveResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListRemoveResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListFetchRequest.oneofGroups_ = [[2, 3], [4, 5]], c._ListFetchRequest.StartIndexCase = {
    START_INDEX_NOT_SET: 0,
    UNBOUNDED_START: 2,
    INCLUSIVE_START: 3
  }, c._ListFetchRequest.prototype.getStartIndexCase = function() {
    return (
      /** @type {proto._ListFetchRequest.StartIndexCase} */
      s.Message.computeOneofCase(this, c._ListFetchRequest.oneofGroups_[0])
    );
  }, c._ListFetchRequest.EndIndexCase = {
    END_INDEX_NOT_SET: 0,
    UNBOUNDED_END: 4,
    EXCLUSIVE_END: 5
  }, c._ListFetchRequest.prototype.getEndIndexCase = function() {
    return (
      /** @type {proto._ListFetchRequest.EndIndexCase} */
      s.Message.computeOneofCase(this, c._ListFetchRequest.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListFetchRequest.prototype.toObject = function(l) {
    return c._ListFetchRequest.toObject(l, this);
  }, c._ListFetchRequest.toObject = function(l, g) {
    var f, _ = {
      listName: g.getListName_asB64(),
      unboundedStart: (f = g.getUnboundedStart()) && d._Unbounded.toObject(l, f),
      inclusiveStart: s.Message.getFieldWithDefault(g, 3, 0),
      unboundedEnd: (f = g.getUnboundedEnd()) && d._Unbounded.toObject(l, f),
      exclusiveEnd: s.Message.getFieldWithDefault(g, 5, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListFetchRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListFetchRequest();
    return c._ListFetchRequest.deserializeBinaryFromReader(f, g);
  }, c._ListFetchRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedStart(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setInclusiveStart(_);
          break;
        case 4:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedEnd(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setExclusiveEnd(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListFetchRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListFetchRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListFetchRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getUnboundedStart(), f != null && g.writeMessage(
      2,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 3), f != null && g.writeSint32(
      3,
      f
    ), f = l.getUnboundedEnd(), f != null && g.writeMessage(
      4,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 5), f != null && g.writeSint32(
      5,
      f
    );
  }, c._ListFetchRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListFetchRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListFetchRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListFetchRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListFetchRequest.prototype.getUnboundedStart = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 2)
    );
  }, c._ListFetchRequest.prototype.setUnboundedStart = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListFetchRequest.oneofGroups_[0], l);
  }, c._ListFetchRequest.prototype.clearUnboundedStart = function() {
    return this.setUnboundedStart(void 0);
  }, c._ListFetchRequest.prototype.hasUnboundedStart = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListFetchRequest.prototype.getInclusiveStart = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._ListFetchRequest.prototype.setInclusiveStart = function(l) {
    return s.Message.setOneofField(this, 3, c._ListFetchRequest.oneofGroups_[0], l);
  }, c._ListFetchRequest.prototype.clearInclusiveStart = function() {
    return s.Message.setOneofField(this, 3, c._ListFetchRequest.oneofGroups_[0], void 0);
  }, c._ListFetchRequest.prototype.hasInclusiveStart = function() {
    return s.Message.getField(this, 3) != null;
  }, c._ListFetchRequest.prototype.getUnboundedEnd = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 4)
    );
  }, c._ListFetchRequest.prototype.setUnboundedEnd = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._ListFetchRequest.oneofGroups_[1], l);
  }, c._ListFetchRequest.prototype.clearUnboundedEnd = function() {
    return this.setUnboundedEnd(void 0);
  }, c._ListFetchRequest.prototype.hasUnboundedEnd = function() {
    return s.Message.getField(this, 4) != null;
  }, c._ListFetchRequest.prototype.getExclusiveEnd = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._ListFetchRequest.prototype.setExclusiveEnd = function(l) {
    return s.Message.setOneofField(this, 5, c._ListFetchRequest.oneofGroups_[1], l);
  }, c._ListFetchRequest.prototype.clearExclusiveEnd = function() {
    return s.Message.setOneofField(this, 5, c._ListFetchRequest.oneofGroups_[1], void 0);
  }, c._ListFetchRequest.prototype.hasExclusiveEnd = function() {
    return s.Message.getField(this, 5) != null;
  }, c._ListRetainRequest.oneofGroups_ = [[2, 3], [4, 5]], c._ListRetainRequest.StartIndexCase = {
    START_INDEX_NOT_SET: 0,
    UNBOUNDED_START: 2,
    INCLUSIVE_START: 3
  }, c._ListRetainRequest.prototype.getStartIndexCase = function() {
    return (
      /** @type {proto._ListRetainRequest.StartIndexCase} */
      s.Message.computeOneofCase(this, c._ListRetainRequest.oneofGroups_[0])
    );
  }, c._ListRetainRequest.EndIndexCase = {
    END_INDEX_NOT_SET: 0,
    UNBOUNDED_END: 4,
    EXCLUSIVE_END: 5
  }, c._ListRetainRequest.prototype.getEndIndexCase = function() {
    return (
      /** @type {proto._ListRetainRequest.EndIndexCase} */
      s.Message.computeOneofCase(this, c._ListRetainRequest.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRetainRequest.prototype.toObject = function(l) {
    return c._ListRetainRequest.toObject(l, this);
  }, c._ListRetainRequest.toObject = function(l, g) {
    var f, _ = {
      listName: g.getListName_asB64(),
      unboundedStart: (f = g.getUnboundedStart()) && d._Unbounded.toObject(l, f),
      inclusiveStart: s.Message.getFieldWithDefault(g, 3, 0),
      unboundedEnd: (f = g.getUnboundedEnd()) && d._Unbounded.toObject(l, f),
      exclusiveEnd: s.Message.getFieldWithDefault(g, 5, 0),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 6, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 7, !1)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListRetainRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRetainRequest();
    return c._ListRetainRequest.deserializeBinaryFromReader(f, g);
  }, c._ListRetainRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        case 2:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedStart(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setInclusiveStart(_);
          break;
        case 4:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedEnd(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setExclusiveEnd(_);
          break;
        case 6:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 7:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRetainRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRetainRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRetainRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getUnboundedStart(), f != null && g.writeMessage(
      2,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 3), f != null && g.writeSint32(
      3,
      f
    ), f = l.getUnboundedEnd(), f != null && g.writeMessage(
      4,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 5), f != null && g.writeSint32(
      5,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      6,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      7,
      f
    );
  }, c._ListRetainRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListRetainRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListRetainRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListRetainRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListRetainRequest.prototype.getUnboundedStart = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 2)
    );
  }, c._ListRetainRequest.prototype.setUnboundedStart = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListRetainRequest.oneofGroups_[0], l);
  }, c._ListRetainRequest.prototype.clearUnboundedStart = function() {
    return this.setUnboundedStart(void 0);
  }, c._ListRetainRequest.prototype.hasUnboundedStart = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListRetainRequest.prototype.getInclusiveStart = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._ListRetainRequest.prototype.setInclusiveStart = function(l) {
    return s.Message.setOneofField(this, 3, c._ListRetainRequest.oneofGroups_[0], l);
  }, c._ListRetainRequest.prototype.clearInclusiveStart = function() {
    return s.Message.setOneofField(this, 3, c._ListRetainRequest.oneofGroups_[0], void 0);
  }, c._ListRetainRequest.prototype.hasInclusiveStart = function() {
    return s.Message.getField(this, 3) != null;
  }, c._ListRetainRequest.prototype.getUnboundedEnd = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 4)
    );
  }, c._ListRetainRequest.prototype.setUnboundedEnd = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._ListRetainRequest.oneofGroups_[1], l);
  }, c._ListRetainRequest.prototype.clearUnboundedEnd = function() {
    return this.setUnboundedEnd(void 0);
  }, c._ListRetainRequest.prototype.hasUnboundedEnd = function() {
    return s.Message.getField(this, 4) != null;
  }, c._ListRetainRequest.prototype.getExclusiveEnd = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._ListRetainRequest.prototype.setExclusiveEnd = function(l) {
    return s.Message.setOneofField(this, 5, c._ListRetainRequest.oneofGroups_[1], l);
  }, c._ListRetainRequest.prototype.clearExclusiveEnd = function() {
    return s.Message.setOneofField(this, 5, c._ListRetainRequest.oneofGroups_[1], void 0);
  }, c._ListRetainRequest.prototype.hasExclusiveEnd = function() {
    return s.Message.getField(this, 5) != null;
  }, c._ListRetainRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 6, 0)
    );
  }, c._ListRetainRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 6, l);
  }, c._ListRetainRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 7, !1)
    );
  }, c._ListRetainRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 7, l);
  }, c._ListRetainResponse.oneofGroups_ = [[1, 2]], c._ListRetainResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListRetainResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListRetainResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListRetainResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRetainResponse.prototype.toObject = function(l) {
    return c._ListRetainResponse.toObject(l, this);
  }, c._ListRetainResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListRetainResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListRetainResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListRetainResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRetainResponse();
    return c._ListRetainResponse.deserializeBinaryFromReader(f, g);
  }, c._ListRetainResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListRetainResponse._Found();
          g.readMessage(_, c._ListRetainResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListRetainResponse._Missing();
          g.readMessage(_, c._ListRetainResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRetainResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRetainResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRetainResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListRetainResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListRetainResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRetainResponse._Found.prototype.toObject = function(l) {
    return c._ListRetainResponse._Found.toObject(l, this);
  }, c._ListRetainResponse._Found.toObject = function(l, g) {
    var f = {
      listLength: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListRetainResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRetainResponse._Found();
    return c._ListRetainResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListRetainResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setListLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRetainResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRetainResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRetainResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListRetainResponse._Found.prototype.getListLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListRetainResponse._Found.prototype.setListLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListRetainResponse._Missing.prototype.toObject = function(l) {
    return c._ListRetainResponse._Missing.toObject(l, this);
  }, c._ListRetainResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListRetainResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListRetainResponse._Missing();
    return c._ListRetainResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListRetainResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListRetainResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListRetainResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListRetainResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListRetainResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListRetainResponse._Found} */
      s.Message.getWrapperField(this, c._ListRetainResponse._Found, 1)
    );
  }, c._ListRetainResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListRetainResponse.oneofGroups_[0], l);
  }, c._ListRetainResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListRetainResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListRetainResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListRetainResponse._Missing} */
      s.Message.getWrapperField(this, c._ListRetainResponse._Missing, 2)
    );
  }, c._ListRetainResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListRetainResponse.oneofGroups_[0], l);
  }, c._ListRetainResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListRetainResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._ListFetchResponse.oneofGroups_ = [[1, 2]], c._ListFetchResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListFetchResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListFetchResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListFetchResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListFetchResponse.prototype.toObject = function(l) {
    return c._ListFetchResponse.toObject(l, this);
  }, c._ListFetchResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListFetchResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListFetchResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListFetchResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListFetchResponse();
    return c._ListFetchResponse.deserializeBinaryFromReader(f, g);
  }, c._ListFetchResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListFetchResponse._Found();
          g.readMessage(_, c._ListFetchResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListFetchResponse._Missing();
          g.readMessage(_, c._ListFetchResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListFetchResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListFetchResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListFetchResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListFetchResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListFetchResponse._Missing.serializeBinaryToWriter
    );
  }, c._ListFetchResponse._Found.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListFetchResponse._Found.prototype.toObject = function(l) {
    return c._ListFetchResponse._Found.toObject(l, this);
  }, c._ListFetchResponse._Found.toObject = function(l, g) {
    var f = {
      valuesList: g.getValuesList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListFetchResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListFetchResponse._Found();
    return c._ListFetchResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListFetchResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addValues(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListFetchResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListFetchResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListFetchResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValuesList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._ListFetchResponse._Found.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._ListFetchResponse._Found.prototype.getValuesList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getValuesList()
      )
    );
  }, c._ListFetchResponse._Found.prototype.getValuesList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getValuesList()
      )
    );
  }, c._ListFetchResponse._Found.prototype.setValuesList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._ListFetchResponse._Found.prototype.addValues = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._ListFetchResponse._Found.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListFetchResponse._Missing.prototype.toObject = function(l) {
    return c._ListFetchResponse._Missing.toObject(l, this);
  }, c._ListFetchResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListFetchResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListFetchResponse._Missing();
    return c._ListFetchResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListFetchResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListFetchResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListFetchResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListFetchResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListFetchResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListFetchResponse._Found} */
      s.Message.getWrapperField(this, c._ListFetchResponse._Found, 1)
    );
  }, c._ListFetchResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListFetchResponse.oneofGroups_[0], l);
  }, c._ListFetchResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListFetchResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListFetchResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListFetchResponse._Missing} */
      s.Message.getWrapperField(this, c._ListFetchResponse._Missing, 2)
    );
  }, c._ListFetchResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListFetchResponse.oneofGroups_[0], l);
  }, c._ListFetchResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListFetchResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._ListLengthRequest.prototype.toObject = function(l) {
    return c._ListLengthRequest.toObject(l, this);
  }, c._ListLengthRequest.toObject = function(l, g) {
    var f = {
      listName: g.getListName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListLengthRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListLengthRequest();
    return c._ListLengthRequest.deserializeBinaryFromReader(f, g);
  }, c._ListLengthRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setListName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListLengthRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListLengthRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListLengthRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getListName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._ListLengthRequest.prototype.getListName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListLengthRequest.prototype.getListName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getListName()
      )
    );
  }, c._ListLengthRequest.prototype.getListName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getListName()
      )
    );
  }, c._ListLengthRequest.prototype.setListName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._ListLengthResponse.oneofGroups_ = [[1, 2]], c._ListLengthResponse.ListCase = {
    LIST_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._ListLengthResponse.prototype.getListCase = function() {
    return (
      /** @type {proto._ListLengthResponse.ListCase} */
      s.Message.computeOneofCase(this, c._ListLengthResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListLengthResponse.prototype.toObject = function(l) {
    return c._ListLengthResponse.toObject(l, this);
  }, c._ListLengthResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._ListLengthResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._ListLengthResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ListLengthResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListLengthResponse();
    return c._ListLengthResponse.deserializeBinaryFromReader(f, g);
  }, c._ListLengthResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._ListLengthResponse._Found();
          g.readMessage(_, c._ListLengthResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._ListLengthResponse._Missing();
          g.readMessage(_, c._ListLengthResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListLengthResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListLengthResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListLengthResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._ListLengthResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._ListLengthResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListLengthResponse._Found.prototype.toObject = function(l) {
    return c._ListLengthResponse._Found.toObject(l, this);
  }, c._ListLengthResponse._Found.toObject = function(l, g) {
    var f = {
      length: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListLengthResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListLengthResponse._Found();
    return c._ListLengthResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._ListLengthResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListLengthResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListLengthResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListLengthResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._ListLengthResponse._Found.prototype.getLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._ListLengthResponse._Found.prototype.setLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListLengthResponse._Missing.prototype.toObject = function(l) {
    return c._ListLengthResponse._Missing.toObject(l, this);
  }, c._ListLengthResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._ListLengthResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ListLengthResponse._Missing();
    return c._ListLengthResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._ListLengthResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ListLengthResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ListLengthResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ListLengthResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._ListLengthResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._ListLengthResponse._Found} */
      s.Message.getWrapperField(this, c._ListLengthResponse._Found, 1)
    );
  }, c._ListLengthResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ListLengthResponse.oneofGroups_[0], l);
  }, c._ListLengthResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._ListLengthResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ListLengthResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._ListLengthResponse._Missing} */
      s.Message.getWrapperField(this, c._ListLengthResponse._Missing, 2)
    );
  }, c._ListLengthResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._ListLengthResponse.oneofGroups_[0], l);
  }, c._ListLengthResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._ListLengthResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetElement.prototype.toObject = function(l) {
    return c._SortedSetElement.toObject(l, this);
  }, c._SortedSetElement.toObject = function(l, g) {
    var f = {
      value: g.getValue_asB64(),
      score: s.Message.getFloatingPointFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetElement.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetElement();
    return c._SortedSetElement.deserializeBinaryFromReader(f, g);
  }, c._SortedSetElement.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setValue(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setScore(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetElement.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetElement.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetElement.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValue_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getScore(), f !== 0 && g.writeDouble(
      2,
      f
    );
  }, c._SortedSetElement.prototype.getValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetElement.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, c._SortedSetElement.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, c._SortedSetElement.prototype.setValue = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetElement.prototype.getScore = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, c._SortedSetElement.prototype.setScore = function(l) {
    return s.Message.setProto3FloatField(this, 2, l);
  }, c._SortedSetPutRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._SortedSetPutRequest.prototype.toObject = function(l) {
    return c._SortedSetPutRequest.toObject(l, this);
  }, c._SortedSetPutRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._SortedSetElement.toObject,
        l
      ),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 3, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 4, !1)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetPutRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetPutRequest();
    return c._SortedSetPutRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetPutRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = new c._SortedSetElement();
          g.readMessage(_, c._SortedSetElement.deserializeBinaryFromReader), l.addElements(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 4:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetPutRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetPutRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetPutRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      2,
      f,
      c._SortedSetElement.serializeBinaryToWriter
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      3,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      4,
      f
    );
  }, c._SortedSetPutRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetPutRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetPutRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetPutRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetPutRequest.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._SortedSetElement>} */
      s.Message.getRepeatedWrapperField(this, c._SortedSetElement, 2)
    );
  }, c._SortedSetPutRequest.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 2, l);
  }, c._SortedSetPutRequest.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 2, l, c._SortedSetElement, g);
  }, c._SortedSetPutRequest.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._SortedSetPutRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SortedSetPutRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._SortedSetPutRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 4, !1)
    );
  }, c._SortedSetPutRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 4, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetPutResponse.prototype.toObject = function(l) {
    return c._SortedSetPutResponse.toObject(l, this);
  }, c._SortedSetPutResponse.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetPutResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetPutResponse();
    return c._SortedSetPutResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetPutResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetPutResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetPutResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetPutResponse.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetFetchRequest.oneofGroups_ = [[4, 5]], c._SortedSetFetchRequest.RangeCase = {
    RANGE_NOT_SET: 0,
    BY_INDEX: 4,
    BY_SCORE: 5
  }, c._SortedSetFetchRequest.prototype.getRangeCase = function() {
    return (
      /** @type {proto._SortedSetFetchRequest.RangeCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchRequest.prototype.toObject = function(l) {
    return c._SortedSetFetchRequest.toObject(l, this);
  }, c._SortedSetFetchRequest.toObject = function(l, g) {
    var f, _ = {
      setName: g.getSetName_asB64(),
      order: s.Message.getFieldWithDefault(g, 2, 0),
      withScores: s.Message.getBooleanFieldWithDefault(g, 3, !1),
      byIndex: (f = g.getByIndex()) && c._SortedSetFetchRequest._ByIndex.toObject(l, f),
      byScore: (f = g.getByScore()) && c._SortedSetFetchRequest._ByScore.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetFetchRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchRequest();
    return c._SortedSetFetchRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {!proto._SortedSetFetchRequest.Order} */
            g.readEnum()
          );
          l.setOrder(_);
          break;
        case 3:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setWithScores(_);
          break;
        case 4:
          var _ = new c._SortedSetFetchRequest._ByIndex();
          g.readMessage(_, c._SortedSetFetchRequest._ByIndex.deserializeBinaryFromReader), l.setByIndex(_);
          break;
        case 5:
          var _ = new c._SortedSetFetchRequest._ByScore();
          g.readMessage(_, c._SortedSetFetchRequest._ByScore.deserializeBinaryFromReader), l.setByScore(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getOrder(), f !== 0 && g.writeEnum(
      2,
      f
    ), f = l.getWithScores(), f && g.writeBool(
      3,
      f
    ), f = l.getByIndex(), f != null && g.writeMessage(
      4,
      f,
      c._SortedSetFetchRequest._ByIndex.serializeBinaryToWriter
    ), f = l.getByScore(), f != null && g.writeMessage(
      5,
      f,
      c._SortedSetFetchRequest._ByScore.serializeBinaryToWriter
    );
  }, c._SortedSetFetchRequest.Order = {
    ASCENDING: 0,
    DESCENDING: 1
  }, c._SortedSetFetchRequest._ByIndex.oneofGroups_ = [[1, 2], [3, 4]], c._SortedSetFetchRequest._ByIndex.StartCase = {
    START_NOT_SET: 0,
    UNBOUNDED_START: 1,
    INCLUSIVE_START_INDEX: 2
  }, c._SortedSetFetchRequest._ByIndex.prototype.getStartCase = function() {
    return (
      /** @type {proto._SortedSetFetchRequest._ByIndex.StartCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchRequest._ByIndex.oneofGroups_[0])
    );
  }, c._SortedSetFetchRequest._ByIndex.EndCase = {
    END_NOT_SET: 0,
    UNBOUNDED_END: 3,
    EXCLUSIVE_END_INDEX: 4
  }, c._SortedSetFetchRequest._ByIndex.prototype.getEndCase = function() {
    return (
      /** @type {proto._SortedSetFetchRequest._ByIndex.EndCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchRequest._ByIndex.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchRequest._ByIndex.prototype.toObject = function(l) {
    return c._SortedSetFetchRequest._ByIndex.toObject(l, this);
  }, c._SortedSetFetchRequest._ByIndex.toObject = function(l, g) {
    var f, _ = {
      unboundedStart: (f = g.getUnboundedStart()) && d._Unbounded.toObject(l, f),
      inclusiveStartIndex: s.Message.getFieldWithDefault(g, 2, 0),
      unboundedEnd: (f = g.getUnboundedEnd()) && d._Unbounded.toObject(l, f),
      exclusiveEndIndex: s.Message.getFieldWithDefault(g, 4, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetFetchRequest._ByIndex.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchRequest._ByIndex();
    return c._SortedSetFetchRequest._ByIndex.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchRequest._ByIndex.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedStart(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setInclusiveStartIndex(_);
          break;
        case 3:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedEnd(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setExclusiveEndIndex(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchRequest._ByIndex.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchRequest._ByIndex.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchRequest._ByIndex.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getUnboundedStart(), f != null && g.writeMessage(
      1,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 2), f != null && g.writeSint32(
      2,
      f
    ), f = l.getUnboundedEnd(), f != null && g.writeMessage(
      3,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 4), f != null && g.writeSint32(
      4,
      f
    );
  }, c._SortedSetFetchRequest._ByIndex.prototype.getUnboundedStart = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 1)
    );
  }, c._SortedSetFetchRequest._ByIndex.prototype.setUnboundedStart = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetFetchRequest._ByIndex.oneofGroups_[0], l);
  }, c._SortedSetFetchRequest._ByIndex.prototype.clearUnboundedStart = function() {
    return this.setUnboundedStart(void 0);
  }, c._SortedSetFetchRequest._ByIndex.prototype.hasUnboundedStart = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetFetchRequest._ByIndex.prototype.getInclusiveStartIndex = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._SortedSetFetchRequest._ByIndex.prototype.setInclusiveStartIndex = function(l) {
    return s.Message.setOneofField(this, 2, c._SortedSetFetchRequest._ByIndex.oneofGroups_[0], l);
  }, c._SortedSetFetchRequest._ByIndex.prototype.clearInclusiveStartIndex = function() {
    return s.Message.setOneofField(this, 2, c._SortedSetFetchRequest._ByIndex.oneofGroups_[0], void 0);
  }, c._SortedSetFetchRequest._ByIndex.prototype.hasInclusiveStartIndex = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetFetchRequest._ByIndex.prototype.getUnboundedEnd = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 3)
    );
  }, c._SortedSetFetchRequest._ByIndex.prototype.setUnboundedEnd = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._SortedSetFetchRequest._ByIndex.oneofGroups_[1], l);
  }, c._SortedSetFetchRequest._ByIndex.prototype.clearUnboundedEnd = function() {
    return this.setUnboundedEnd(void 0);
  }, c._SortedSetFetchRequest._ByIndex.prototype.hasUnboundedEnd = function() {
    return s.Message.getField(this, 3) != null;
  }, c._SortedSetFetchRequest._ByIndex.prototype.getExclusiveEndIndex = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._SortedSetFetchRequest._ByIndex.prototype.setExclusiveEndIndex = function(l) {
    return s.Message.setOneofField(this, 4, c._SortedSetFetchRequest._ByIndex.oneofGroups_[1], l);
  }, c._SortedSetFetchRequest._ByIndex.prototype.clearExclusiveEndIndex = function() {
    return s.Message.setOneofField(this, 4, c._SortedSetFetchRequest._ByIndex.oneofGroups_[1], void 0);
  }, c._SortedSetFetchRequest._ByIndex.prototype.hasExclusiveEndIndex = function() {
    return s.Message.getField(this, 4) != null;
  }, c._SortedSetFetchRequest._ByScore.oneofGroups_ = [[1, 2], [3, 4]], c._SortedSetFetchRequest._ByScore.MinCase = {
    MIN_NOT_SET: 0,
    UNBOUNDED_MIN: 1,
    MIN_SCORE: 2
  }, c._SortedSetFetchRequest._ByScore.prototype.getMinCase = function() {
    return (
      /** @type {proto._SortedSetFetchRequest._ByScore.MinCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchRequest._ByScore.oneofGroups_[0])
    );
  }, c._SortedSetFetchRequest._ByScore.MaxCase = {
    MAX_NOT_SET: 0,
    UNBOUNDED_MAX: 3,
    MAX_SCORE: 4
  }, c._SortedSetFetchRequest._ByScore.prototype.getMaxCase = function() {
    return (
      /** @type {proto._SortedSetFetchRequest._ByScore.MaxCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchRequest._ByScore.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchRequest._ByScore.prototype.toObject = function(l) {
    return c._SortedSetFetchRequest._ByScore.toObject(l, this);
  }, c._SortedSetFetchRequest._ByScore.toObject = function(l, g) {
    var f, _ = {
      unboundedMin: (f = g.getUnboundedMin()) && d._Unbounded.toObject(l, f),
      minScore: (f = g.getMinScore()) && c._SortedSetFetchRequest._ByScore._Score.toObject(l, f),
      unboundedMax: (f = g.getUnboundedMax()) && d._Unbounded.toObject(l, f),
      maxScore: (f = g.getMaxScore()) && c._SortedSetFetchRequest._ByScore._Score.toObject(l, f),
      offset: s.Message.getFieldWithDefault(g, 5, 0),
      count: s.Message.getFieldWithDefault(g, 6, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetFetchRequest._ByScore.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchRequest._ByScore();
    return c._SortedSetFetchRequest._ByScore.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchRequest._ByScore.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedMin(_);
          break;
        case 2:
          var _ = new c._SortedSetFetchRequest._ByScore._Score();
          g.readMessage(_, c._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader), l.setMinScore(_);
          break;
        case 3:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedMax(_);
          break;
        case 4:
          var _ = new c._SortedSetFetchRequest._ByScore._Score();
          g.readMessage(_, c._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader), l.setMaxScore(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setOffset(_);
          break;
        case 6:
          var _ = (
            /** @type {number} */
            g.readSint32()
          );
          l.setCount(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchRequest._ByScore.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchRequest._ByScore.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchRequest._ByScore.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getUnboundedMin(), f != null && g.writeMessage(
      1,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = l.getMinScore(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter
    ), f = l.getUnboundedMax(), f != null && g.writeMessage(
      3,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = l.getMaxScore(), f != null && g.writeMessage(
      4,
      f,
      c._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter
    ), f = l.getOffset(), f !== 0 && g.writeUint32(
      5,
      f
    ), f = l.getCount(), f !== 0 && g.writeSint32(
      6,
      f
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchRequest._ByScore._Score.prototype.toObject = function(l) {
    return c._SortedSetFetchRequest._ByScore._Score.toObject(l, this);
  }, c._SortedSetFetchRequest._ByScore._Score.toObject = function(l, g) {
    var f = {
      score: s.Message.getFloatingPointFieldWithDefault(g, 1, 0),
      exclusive: s.Message.getBooleanFieldWithDefault(g, 2, !1)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetFetchRequest._ByScore._Score.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchRequest._ByScore._Score();
    return c._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchRequest._ByScore._Score.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setScore(_);
          break;
        case 2:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setExclusive(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchRequest._ByScore._Score.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchRequest._ByScore._Score.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getScore(), f !== 0 && g.writeDouble(
      1,
      f
    ), f = l.getExclusive(), f && g.writeBool(
      2,
      f
    );
  }, c._SortedSetFetchRequest._ByScore._Score.prototype.getScore = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, c._SortedSetFetchRequest._ByScore._Score.prototype.setScore = function(l) {
    return s.Message.setProto3FloatField(this, 1, l);
  }, c._SortedSetFetchRequest._ByScore._Score.prototype.getExclusive = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, c._SortedSetFetchRequest._ByScore._Score.prototype.setExclusive = function(l) {
    return s.Message.setProto3BooleanField(this, 2, l);
  }, c._SortedSetFetchRequest._ByScore.prototype.getUnboundedMin = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 1)
    );
  }, c._SortedSetFetchRequest._ByScore.prototype.setUnboundedMin = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetFetchRequest._ByScore.oneofGroups_[0], l);
  }, c._SortedSetFetchRequest._ByScore.prototype.clearUnboundedMin = function() {
    return this.setUnboundedMin(void 0);
  }, c._SortedSetFetchRequest._ByScore.prototype.hasUnboundedMin = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetFetchRequest._ByScore.prototype.getMinScore = function() {
    return (
      /** @type{?proto._SortedSetFetchRequest._ByScore._Score} */
      s.Message.getWrapperField(this, c._SortedSetFetchRequest._ByScore._Score, 2)
    );
  }, c._SortedSetFetchRequest._ByScore.prototype.setMinScore = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetFetchRequest._ByScore.oneofGroups_[0], l);
  }, c._SortedSetFetchRequest._ByScore.prototype.clearMinScore = function() {
    return this.setMinScore(void 0);
  }, c._SortedSetFetchRequest._ByScore.prototype.hasMinScore = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetFetchRequest._ByScore.prototype.getUnboundedMax = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 3)
    );
  }, c._SortedSetFetchRequest._ByScore.prototype.setUnboundedMax = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._SortedSetFetchRequest._ByScore.oneofGroups_[1], l);
  }, c._SortedSetFetchRequest._ByScore.prototype.clearUnboundedMax = function() {
    return this.setUnboundedMax(void 0);
  }, c._SortedSetFetchRequest._ByScore.prototype.hasUnboundedMax = function() {
    return s.Message.getField(this, 3) != null;
  }, c._SortedSetFetchRequest._ByScore.prototype.getMaxScore = function() {
    return (
      /** @type{?proto._SortedSetFetchRequest._ByScore._Score} */
      s.Message.getWrapperField(this, c._SortedSetFetchRequest._ByScore._Score, 4)
    );
  }, c._SortedSetFetchRequest._ByScore.prototype.setMaxScore = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._SortedSetFetchRequest._ByScore.oneofGroups_[1], l);
  }, c._SortedSetFetchRequest._ByScore.prototype.clearMaxScore = function() {
    return this.setMaxScore(void 0);
  }, c._SortedSetFetchRequest._ByScore.prototype.hasMaxScore = function() {
    return s.Message.getField(this, 4) != null;
  }, c._SortedSetFetchRequest._ByScore.prototype.getOffset = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._SortedSetFetchRequest._ByScore.prototype.setOffset = function(l) {
    return s.Message.setProto3IntField(this, 5, l);
  }, c._SortedSetFetchRequest._ByScore.prototype.getCount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 6, 0)
    );
  }, c._SortedSetFetchRequest._ByScore.prototype.setCount = function(l) {
    return s.Message.setProto3IntField(this, 6, l);
  }, c._SortedSetFetchRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetFetchRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetFetchRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetFetchRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetFetchRequest.prototype.getOrder = function() {
    return (
      /** @type {!proto._SortedSetFetchRequest.Order} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._SortedSetFetchRequest.prototype.setOrder = function(l) {
    return s.Message.setProto3EnumField(this, 2, l);
  }, c._SortedSetFetchRequest.prototype.getWithScores = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, c._SortedSetFetchRequest.prototype.setWithScores = function(l) {
    return s.Message.setProto3BooleanField(this, 3, l);
  }, c._SortedSetFetchRequest.prototype.getByIndex = function() {
    return (
      /** @type{?proto._SortedSetFetchRequest._ByIndex} */
      s.Message.getWrapperField(this, c._SortedSetFetchRequest._ByIndex, 4)
    );
  }, c._SortedSetFetchRequest.prototype.setByIndex = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._SortedSetFetchRequest.oneofGroups_[0], l);
  }, c._SortedSetFetchRequest.prototype.clearByIndex = function() {
    return this.setByIndex(void 0);
  }, c._SortedSetFetchRequest.prototype.hasByIndex = function() {
    return s.Message.getField(this, 4) != null;
  }, c._SortedSetFetchRequest.prototype.getByScore = function() {
    return (
      /** @type{?proto._SortedSetFetchRequest._ByScore} */
      s.Message.getWrapperField(this, c._SortedSetFetchRequest._ByScore, 5)
    );
  }, c._SortedSetFetchRequest.prototype.setByScore = function(l) {
    return s.Message.setOneofWrapperField(this, 5, c._SortedSetFetchRequest.oneofGroups_[0], l);
  }, c._SortedSetFetchRequest.prototype.clearByScore = function() {
    return this.setByScore(void 0);
  }, c._SortedSetFetchRequest.prototype.hasByScore = function() {
    return s.Message.getField(this, 5) != null;
  }, c._SortedSetFetchResponse.oneofGroups_ = [[1, 2]], c._SortedSetFetchResponse.SortedSetCase = {
    SORTED_SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SortedSetFetchResponse.prototype.getSortedSetCase = function() {
    return (
      /** @type {proto._SortedSetFetchResponse.SortedSetCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchResponse.prototype.toObject = function(l) {
    return c._SortedSetFetchResponse.toObject(l, this);
  }, c._SortedSetFetchResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SortedSetFetchResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SortedSetFetchResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetFetchResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchResponse();
    return c._SortedSetFetchResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetFetchResponse._Found();
          g.readMessage(_, c._SortedSetFetchResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SortedSetFetchResponse._Missing();
          g.readMessage(_, c._SortedSetFetchResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SortedSetFetchResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetFetchResponse._Missing.serializeBinaryToWriter
    );
  }, c._SortedSetFetchResponse._Found.oneofGroups_ = [[1, 2]], c._SortedSetFetchResponse._Found.ElementsCase = {
    ELEMENTS_NOT_SET: 0,
    VALUES_WITH_SCORES: 1,
    VALUES: 2
  }, c._SortedSetFetchResponse._Found.prototype.getElementsCase = function() {
    return (
      /** @type {proto._SortedSetFetchResponse._Found.ElementsCase} */
      s.Message.computeOneofCase(this, c._SortedSetFetchResponse._Found.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchResponse._Found.prototype.toObject = function(l) {
    return c._SortedSetFetchResponse._Found.toObject(l, this);
  }, c._SortedSetFetchResponse._Found.toObject = function(l, g) {
    var f, _ = {
      valuesWithScores: (f = g.getValuesWithScores()) && c._SortedSetFetchResponse._Found._ValuesWithScores.toObject(l, f),
      values: (f = g.getValues()) && c._SortedSetFetchResponse._Found._Values.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetFetchResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchResponse._Found();
    return c._SortedSetFetchResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetFetchResponse._Found._ValuesWithScores();
          g.readMessage(_, c._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinaryFromReader), l.setValuesWithScores(_);
          break;
        case 2:
          var _ = new c._SortedSetFetchResponse._Found._Values();
          g.readMessage(_, c._SortedSetFetchResponse._Found._Values.deserializeBinaryFromReader), l.setValues(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValuesWithScores(), f != null && g.writeMessage(
      1,
      f,
      c._SortedSetFetchResponse._Found._ValuesWithScores.serializeBinaryToWriter
    ), f = l.getValues(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetFetchResponse._Found._Values.serializeBinaryToWriter
    );
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchResponse._Found._ValuesWithScores.prototype.toObject = function(l) {
    return c._SortedSetFetchResponse._Found._ValuesWithScores.toObject(l, this);
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.toObject = function(l, g) {
    var f = {
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._SortedSetElement.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchResponse._Found._ValuesWithScores();
    return c._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetElement();
          g.readMessage(_, c._SortedSetElement.deserializeBinaryFromReader), l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchResponse._Found._ValuesWithScores.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._SortedSetElement.serializeBinaryToWriter
    );
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._SortedSetElement>} */
      s.Message.getRepeatedWrapperField(this, c._SortedSetElement, 1)
    );
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._SortedSetElement, g);
  }, c._SortedSetFetchResponse._Found._ValuesWithScores.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._SortedSetFetchResponse._Found._Values.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchResponse._Found._Values.prototype.toObject = function(l) {
    return c._SortedSetFetchResponse._Found._Values.toObject(l, this);
  }, c._SortedSetFetchResponse._Found._Values.toObject = function(l, g) {
    var f = {
      valuesList: g.getValuesList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetFetchResponse._Found._Values.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchResponse._Found._Values();
    return c._SortedSetFetchResponse._Found._Values.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchResponse._Found._Values.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addValues(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchResponse._Found._Values.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchResponse._Found._Values.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchResponse._Found._Values.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValuesList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SortedSetFetchResponse._Found._Values.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SortedSetFetchResponse._Found._Values.prototype.getValuesList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getValuesList()
      )
    );
  }, c._SortedSetFetchResponse._Found._Values.prototype.getValuesList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getValuesList()
      )
    );
  }, c._SortedSetFetchResponse._Found._Values.prototype.setValuesList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SortedSetFetchResponse._Found._Values.prototype.addValues = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SortedSetFetchResponse._Found._Values.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, c._SortedSetFetchResponse._Found.prototype.getValuesWithScores = function() {
    return (
      /** @type{?proto._SortedSetFetchResponse._Found._ValuesWithScores} */
      s.Message.getWrapperField(this, c._SortedSetFetchResponse._Found._ValuesWithScores, 1)
    );
  }, c._SortedSetFetchResponse._Found.prototype.setValuesWithScores = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetFetchResponse._Found.oneofGroups_[0], l);
  }, c._SortedSetFetchResponse._Found.prototype.clearValuesWithScores = function() {
    return this.setValuesWithScores(void 0);
  }, c._SortedSetFetchResponse._Found.prototype.hasValuesWithScores = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetFetchResponse._Found.prototype.getValues = function() {
    return (
      /** @type{?proto._SortedSetFetchResponse._Found._Values} */
      s.Message.getWrapperField(this, c._SortedSetFetchResponse._Found._Values, 2)
    );
  }, c._SortedSetFetchResponse._Found.prototype.setValues = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetFetchResponse._Found.oneofGroups_[0], l);
  }, c._SortedSetFetchResponse._Found.prototype.clearValues = function() {
    return this.setValues(void 0);
  }, c._SortedSetFetchResponse._Found.prototype.hasValues = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetFetchResponse._Missing.prototype.toObject = function(l) {
    return c._SortedSetFetchResponse._Missing.toObject(l, this);
  }, c._SortedSetFetchResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetFetchResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetFetchResponse._Missing();
    return c._SortedSetFetchResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SortedSetFetchResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetFetchResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetFetchResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetFetchResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetFetchResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SortedSetFetchResponse._Found} */
      s.Message.getWrapperField(this, c._SortedSetFetchResponse._Found, 1)
    );
  }, c._SortedSetFetchResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetFetchResponse.oneofGroups_[0], l);
  }, c._SortedSetFetchResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SortedSetFetchResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetFetchResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SortedSetFetchResponse._Missing} */
      s.Message.getWrapperField(this, c._SortedSetFetchResponse._Missing, 2)
    );
  }, c._SortedSetFetchResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetFetchResponse.oneofGroups_[0], l);
  }, c._SortedSetFetchResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SortedSetFetchResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetGetScoreRequest.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetScoreRequest.prototype.toObject = function(l) {
    return c._SortedSetGetScoreRequest.toObject(l, this);
  }, c._SortedSetGetScoreRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      valuesList: g.getValuesList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetScoreRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetScoreRequest();
    return c._SortedSetGetScoreRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetScoreRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addValues(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetScoreRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetScoreRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetScoreRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValuesList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      2,
      f
    );
  }, c._SortedSetGetScoreRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetGetScoreRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetGetScoreRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetGetScoreRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetGetScoreRequest.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, c._SortedSetGetScoreRequest.prototype.getValuesList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getValuesList()
      )
    );
  }, c._SortedSetGetScoreRequest.prototype.getValuesList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getValuesList()
      )
    );
  }, c._SortedSetGetScoreRequest.prototype.setValuesList = function(l) {
    return s.Message.setField(this, 2, l || []);
  }, c._SortedSetGetScoreRequest.prototype.addValues = function(l, g) {
    return s.Message.addToRepeatedField(this, 2, l, g);
  }, c._SortedSetGetScoreRequest.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, c._SortedSetGetScoreResponse.oneofGroups_ = [[1, 2]], c._SortedSetGetScoreResponse.SortedSetCase = {
    SORTED_SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SortedSetGetScoreResponse.prototype.getSortedSetCase = function() {
    return (
      /** @type {proto._SortedSetGetScoreResponse.SortedSetCase} */
      s.Message.computeOneofCase(this, c._SortedSetGetScoreResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetScoreResponse.prototype.toObject = function(l) {
    return c._SortedSetGetScoreResponse.toObject(l, this);
  }, c._SortedSetGetScoreResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SortedSetGetScoreResponse._SortedSetFound.toObject(l, f),
      missing: (f = g.getMissing()) && c._SortedSetGetScoreResponse._SortedSetMissing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetGetScoreResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetScoreResponse();
    return c._SortedSetGetScoreResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetScoreResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetGetScoreResponse._SortedSetFound();
          g.readMessage(_, c._SortedSetGetScoreResponse._SortedSetFound.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SortedSetGetScoreResponse._SortedSetMissing();
          g.readMessage(_, c._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetScoreResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetScoreResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetScoreResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SortedSetGetScoreResponse._SortedSetFound.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetGetScoreResponse._SortedSetMissing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.toObject = function(l) {
    return c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.toObject(l, this);
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.toObject = function(l, g) {
    var f = {
      result: s.Message.getFieldWithDefault(g, 1, 0),
      score: s.Message.getFloatingPointFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart();
    return c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!proto.ECacheResult} */
            g.readEnum()
          );
          l.setResult(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setScore(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getResult(), f !== 0 && g.writeEnum(
      1,
      f
    ), f = l.getScore(), f !== 0 && g.writeDouble(
      2,
      f
    );
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.getResult = function() {
    return (
      /** @type {!proto.ECacheResult} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.setResult = function(l) {
    return s.Message.setProto3EnumField(this, 1, l);
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.getScore = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.prototype.setScore = function(l) {
    return s.Message.setProto3FloatField(this, 2, l);
  }, c._SortedSetGetScoreResponse._SortedSetFound.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetScoreResponse._SortedSetFound.prototype.toObject = function(l) {
    return c._SortedSetGetScoreResponse._SortedSetFound.toObject(l, this);
  }, c._SortedSetGetScoreResponse._SortedSetFound.toObject = function(l, g) {
    var f = {
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetScoreResponse._SortedSetFound.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetScoreResponse._SortedSetFound();
    return c._SortedSetGetScoreResponse._SortedSetFound.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetScoreResponse._SortedSetFound.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart();
          g.readMessage(_, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.deserializeBinaryFromReader), l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetScoreResponse._SortedSetFound.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetScoreResponse._SortedSetFound.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetScoreResponse._SortedSetFound.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart.serializeBinaryToWriter
    );
  }, c._SortedSetGetScoreResponse._SortedSetFound.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart>} */
      s.Message.getRepeatedWrapperField(this, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart, 1)
    );
  }, c._SortedSetGetScoreResponse._SortedSetFound.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._SortedSetGetScoreResponse._SortedSetFound.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._SortedSetGetScoreResponse._SortedSetGetScoreResponsePart, g);
  }, c._SortedSetGetScoreResponse._SortedSetFound.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetScoreResponse._SortedSetMissing.prototype.toObject = function(l) {
    return c._SortedSetGetScoreResponse._SortedSetMissing.toObject(l, this);
  }, c._SortedSetGetScoreResponse._SortedSetMissing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetScoreResponse._SortedSetMissing();
    return c._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetScoreResponse._SortedSetMissing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetScoreResponse._SortedSetMissing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetScoreResponse._SortedSetMissing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetScoreResponse._SortedSetMissing.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetGetScoreResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SortedSetGetScoreResponse._SortedSetFound} */
      s.Message.getWrapperField(this, c._SortedSetGetScoreResponse._SortedSetFound, 1)
    );
  }, c._SortedSetGetScoreResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetGetScoreResponse.oneofGroups_[0], l);
  }, c._SortedSetGetScoreResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SortedSetGetScoreResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetGetScoreResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SortedSetGetScoreResponse._SortedSetMissing} */
      s.Message.getWrapperField(this, c._SortedSetGetScoreResponse._SortedSetMissing, 2)
    );
  }, c._SortedSetGetScoreResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetGetScoreResponse.oneofGroups_[0], l);
  }, c._SortedSetGetScoreResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SortedSetGetScoreResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetRemoveRequest.oneofGroups_ = [[2, 3]], c._SortedSetRemoveRequest.RemoveElementsCase = {
    REMOVE_ELEMENTS_NOT_SET: 0,
    ALL: 2,
    SOME: 3
  }, c._SortedSetRemoveRequest.prototype.getRemoveElementsCase = function() {
    return (
      /** @type {proto._SortedSetRemoveRequest.RemoveElementsCase} */
      s.Message.computeOneofCase(this, c._SortedSetRemoveRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetRemoveRequest.prototype.toObject = function(l) {
    return c._SortedSetRemoveRequest.toObject(l, this);
  }, c._SortedSetRemoveRequest.toObject = function(l, g) {
    var f, _ = {
      setName: g.getSetName_asB64(),
      all: (f = g.getAll()) && c._SortedSetRemoveRequest._All.toObject(l, f),
      some: (f = g.getSome()) && c._SortedSetRemoveRequest._Some.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetRemoveRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetRemoveRequest();
    return c._SortedSetRemoveRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetRemoveRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = new c._SortedSetRemoveRequest._All();
          g.readMessage(_, c._SortedSetRemoveRequest._All.deserializeBinaryFromReader), l.setAll(_);
          break;
        case 3:
          var _ = new c._SortedSetRemoveRequest._Some();
          g.readMessage(_, c._SortedSetRemoveRequest._Some.deserializeBinaryFromReader), l.setSome(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetRemoveRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetRemoveRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetRemoveRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getAll(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetRemoveRequest._All.serializeBinaryToWriter
    ), f = l.getSome(), f != null && g.writeMessage(
      3,
      f,
      c._SortedSetRemoveRequest._Some.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetRemoveRequest._All.prototype.toObject = function(l) {
    return c._SortedSetRemoveRequest._All.toObject(l, this);
  }, c._SortedSetRemoveRequest._All.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetRemoveRequest._All.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetRemoveRequest._All();
    return c._SortedSetRemoveRequest._All.deserializeBinaryFromReader(f, g);
  }, c._SortedSetRemoveRequest._All.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetRemoveRequest._All.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetRemoveRequest._All.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetRemoveRequest._All.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetRemoveRequest._Some.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._SortedSetRemoveRequest._Some.prototype.toObject = function(l) {
    return c._SortedSetRemoveRequest._Some.toObject(l, this);
  }, c._SortedSetRemoveRequest._Some.toObject = function(l, g) {
    var f = {
      valuesList: g.getValuesList_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetRemoveRequest._Some.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetRemoveRequest._Some();
    return c._SortedSetRemoveRequest._Some.deserializeBinaryFromReader(f, g);
  }, c._SortedSetRemoveRequest._Some.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.addValues(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetRemoveRequest._Some.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetRemoveRequest._Some.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetRemoveRequest._Some.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValuesList_asU8(), f.length > 0 && g.writeRepeatedBytes(
      1,
      f
    );
  }, c._SortedSetRemoveRequest._Some.prototype.getValuesList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, c._SortedSetRemoveRequest._Some.prototype.getValuesList_asB64 = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.bytesListAsB64(
        this.getValuesList()
      )
    );
  }, c._SortedSetRemoveRequest._Some.prototype.getValuesList_asU8 = function() {
    return (
      /** @type {!Array<!Uint8Array>} */
      s.Message.bytesListAsU8(
        this.getValuesList()
      )
    );
  }, c._SortedSetRemoveRequest._Some.prototype.setValuesList = function(l) {
    return s.Message.setField(this, 1, l || []);
  }, c._SortedSetRemoveRequest._Some.prototype.addValues = function(l, g) {
    return s.Message.addToRepeatedField(this, 1, l, g);
  }, c._SortedSetRemoveRequest._Some.prototype.clearValuesList = function() {
    return this.setValuesList([]);
  }, c._SortedSetRemoveRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetRemoveRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetRemoveRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetRemoveRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetRemoveRequest.prototype.getAll = function() {
    return (
      /** @type{?proto._SortedSetRemoveRequest._All} */
      s.Message.getWrapperField(this, c._SortedSetRemoveRequest._All, 2)
    );
  }, c._SortedSetRemoveRequest.prototype.setAll = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetRemoveRequest.oneofGroups_[0], l);
  }, c._SortedSetRemoveRequest.prototype.clearAll = function() {
    return this.setAll(void 0);
  }, c._SortedSetRemoveRequest.prototype.hasAll = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetRemoveRequest.prototype.getSome = function() {
    return (
      /** @type{?proto._SortedSetRemoveRequest._Some} */
      s.Message.getWrapperField(this, c._SortedSetRemoveRequest._Some, 3)
    );
  }, c._SortedSetRemoveRequest.prototype.setSome = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._SortedSetRemoveRequest.oneofGroups_[0], l);
  }, c._SortedSetRemoveRequest.prototype.clearSome = function() {
    return this.setSome(void 0);
  }, c._SortedSetRemoveRequest.prototype.hasSome = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetRemoveResponse.prototype.toObject = function(l) {
    return c._SortedSetRemoveResponse.toObject(l, this);
  }, c._SortedSetRemoveResponse.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetRemoveResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetRemoveResponse();
    return c._SortedSetRemoveResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetRemoveResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetRemoveResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetRemoveResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetRemoveResponse.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetIncrementRequest.prototype.toObject = function(l) {
    return c._SortedSetIncrementRequest.toObject(l, this);
  }, c._SortedSetIncrementRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      value: g.getValue_asB64(),
      amount: s.Message.getFloatingPointFieldWithDefault(g, 3, 0),
      ttlMilliseconds: s.Message.getFieldWithDefault(g, 4, 0),
      refreshTtl: s.Message.getBooleanFieldWithDefault(g, 5, !1)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetIncrementRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetIncrementRequest();
    return c._SortedSetIncrementRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetIncrementRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setValue(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setAmount(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setTtlMilliseconds(_);
          break;
        case 5:
          var _ = (
            /** @type {boolean} */
            g.readBool()
          );
          l.setRefreshTtl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetIncrementRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetIncrementRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetIncrementRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValue_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getAmount(), f !== 0 && g.writeDouble(
      3,
      f
    ), f = l.getTtlMilliseconds(), f !== 0 && g.writeUint64(
      4,
      f
    ), f = l.getRefreshTtl(), f && g.writeBool(
      5,
      f
    );
  }, c._SortedSetIncrementRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetIncrementRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetIncrementRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetIncrementRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetIncrementRequest.prototype.getValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SortedSetIncrementRequest.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, c._SortedSetIncrementRequest.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, c._SortedSetIncrementRequest.prototype.setValue = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._SortedSetIncrementRequest.prototype.getAmount = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 3, 0)
    );
  }, c._SortedSetIncrementRequest.prototype.setAmount = function(l) {
    return s.Message.setProto3FloatField(this, 3, l);
  }, c._SortedSetIncrementRequest.prototype.getTtlMilliseconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._SortedSetIncrementRequest.prototype.setTtlMilliseconds = function(l) {
    return s.Message.setProto3IntField(this, 4, l);
  }, c._SortedSetIncrementRequest.prototype.getRefreshTtl = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, c._SortedSetIncrementRequest.prototype.setRefreshTtl = function(l) {
    return s.Message.setProto3BooleanField(this, 5, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetIncrementResponse.prototype.toObject = function(l) {
    return c._SortedSetIncrementResponse.toObject(l, this);
  }, c._SortedSetIncrementResponse.toObject = function(l, g) {
    var f = {
      score: s.Message.getFloatingPointFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetIncrementResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetIncrementResponse();
    return c._SortedSetIncrementResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetIncrementResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setScore(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetIncrementResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetIncrementResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetIncrementResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getScore(), f !== 0 && g.writeDouble(
      1,
      f
    );
  }, c._SortedSetIncrementResponse.prototype.getScore = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 1, 0)
    );
  }, c._SortedSetIncrementResponse.prototype.setScore = function(l) {
    return s.Message.setProto3FloatField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetRankRequest.prototype.toObject = function(l) {
    return c._SortedSetGetRankRequest.toObject(l, this);
  }, c._SortedSetGetRankRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64(),
      value: g.getValue_asB64(),
      order: s.Message.getFieldWithDefault(g, 3, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetRankRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetRankRequest();
    return c._SortedSetGetRankRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetRankRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setValue(_);
          break;
        case 3:
          var _ = (
            /** @type {!proto._SortedSetGetRankRequest.Order} */
            g.readEnum()
          );
          l.setOrder(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetRankRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetRankRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetRankRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = l.getValue_asU8(), f.length > 0 && g.writeBytes(
      2,
      f
    ), f = l.getOrder(), f !== 0 && g.writeEnum(
      3,
      f
    );
  }, c._SortedSetGetRankRequest.Order = {
    ASCENDING: 0,
    DESCENDING: 1
  }, c._SortedSetGetRankRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetGetRankRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetGetRankRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetGetRankRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetGetRankRequest.prototype.getValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SortedSetGetRankRequest.prototype.getValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getValue()
      )
    );
  }, c._SortedSetGetRankRequest.prototype.getValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getValue()
      )
    );
  }, c._SortedSetGetRankRequest.prototype.setValue = function(l) {
    return s.Message.setProto3BytesField(this, 2, l);
  }, c._SortedSetGetRankRequest.prototype.getOrder = function() {
    return (
      /** @type {!proto._SortedSetGetRankRequest.Order} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SortedSetGetRankRequest.prototype.setOrder = function(l) {
    return s.Message.setProto3EnumField(this, 3, l);
  }, c._SortedSetGetRankResponse.oneofGroups_ = [[1, 2]], c._SortedSetGetRankResponse.RankCase = {
    RANK_NOT_SET: 0,
    ELEMENT_RANK: 1,
    MISSING: 2
  }, c._SortedSetGetRankResponse.prototype.getRankCase = function() {
    return (
      /** @type {proto._SortedSetGetRankResponse.RankCase} */
      s.Message.computeOneofCase(this, c._SortedSetGetRankResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetRankResponse.prototype.toObject = function(l) {
    return c._SortedSetGetRankResponse.toObject(l, this);
  }, c._SortedSetGetRankResponse.toObject = function(l, g) {
    var f, _ = {
      elementRank: (f = g.getElementRank()) && c._SortedSetGetRankResponse._RankResponsePart.toObject(l, f),
      missing: (f = g.getMissing()) && c._SortedSetGetRankResponse._SortedSetMissing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetGetRankResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetRankResponse();
    return c._SortedSetGetRankResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetRankResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetGetRankResponse._RankResponsePart();
          g.readMessage(_, c._SortedSetGetRankResponse._RankResponsePart.deserializeBinaryFromReader), l.setElementRank(_);
          break;
        case 2:
          var _ = new c._SortedSetGetRankResponse._SortedSetMissing();
          g.readMessage(_, c._SortedSetGetRankResponse._SortedSetMissing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetRankResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetRankResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetRankResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementRank(), f != null && g.writeMessage(
      1,
      f,
      c._SortedSetGetRankResponse._RankResponsePart.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetGetRankResponse._SortedSetMissing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetRankResponse._RankResponsePart.prototype.toObject = function(l) {
    return c._SortedSetGetRankResponse._RankResponsePart.toObject(l, this);
  }, c._SortedSetGetRankResponse._RankResponsePart.toObject = function(l, g) {
    var f = {
      result: s.Message.getFieldWithDefault(g, 1, 0),
      rank: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetRankResponse._RankResponsePart.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetRankResponse._RankResponsePart();
    return c._SortedSetGetRankResponse._RankResponsePart.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetRankResponse._RankResponsePart.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!proto.ECacheResult} */
            g.readEnum()
          );
          l.setResult(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setRank(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetRankResponse._RankResponsePart.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetRankResponse._RankResponsePart.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetRankResponse._RankResponsePart.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getResult(), f !== 0 && g.writeEnum(
      1,
      f
    ), f = l.getRank(), f !== 0 && g.writeUint64(
      2,
      f
    );
  }, c._SortedSetGetRankResponse._RankResponsePart.prototype.getResult = function() {
    return (
      /** @type {!proto.ECacheResult} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._SortedSetGetRankResponse._RankResponsePart.prototype.setResult = function(l) {
    return s.Message.setProto3EnumField(this, 1, l);
  }, c._SortedSetGetRankResponse._RankResponsePart.prototype.getRank = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._SortedSetGetRankResponse._RankResponsePart.prototype.setRank = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetGetRankResponse._SortedSetMissing.prototype.toObject = function(l) {
    return c._SortedSetGetRankResponse._SortedSetMissing.toObject(l, this);
  }, c._SortedSetGetRankResponse._SortedSetMissing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetGetRankResponse._SortedSetMissing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetGetRankResponse._SortedSetMissing();
    return c._SortedSetGetRankResponse._SortedSetMissing.deserializeBinaryFromReader(f, g);
  }, c._SortedSetGetRankResponse._SortedSetMissing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetGetRankResponse._SortedSetMissing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetGetRankResponse._SortedSetMissing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetGetRankResponse._SortedSetMissing.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetGetRankResponse.prototype.getElementRank = function() {
    return (
      /** @type{?proto._SortedSetGetRankResponse._RankResponsePart} */
      s.Message.getWrapperField(this, c._SortedSetGetRankResponse._RankResponsePart, 1)
    );
  }, c._SortedSetGetRankResponse.prototype.setElementRank = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetGetRankResponse.oneofGroups_[0], l);
  }, c._SortedSetGetRankResponse.prototype.clearElementRank = function() {
    return this.setElementRank(void 0);
  }, c._SortedSetGetRankResponse.prototype.hasElementRank = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetGetRankResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SortedSetGetRankResponse._SortedSetMissing} */
      s.Message.getWrapperField(this, c._SortedSetGetRankResponse._SortedSetMissing, 2)
    );
  }, c._SortedSetGetRankResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetGetRankResponse.oneofGroups_[0], l);
  }, c._SortedSetGetRankResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SortedSetGetRankResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthRequest.prototype.toObject = function(l) {
    return c._SortedSetLengthRequest.toObject(l, this);
  }, c._SortedSetLengthRequest.toObject = function(l, g) {
    var f = {
      setName: g.getSetName_asB64()
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetLengthRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthRequest();
    return c._SortedSetLengthRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    );
  }, c._SortedSetLengthRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetLengthRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetLengthRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetLengthRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetLengthResponse.oneofGroups_ = [[1, 2]], c._SortedSetLengthResponse.SortedSetCase = {
    SORTED_SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SortedSetLengthResponse.prototype.getSortedSetCase = function() {
    return (
      /** @type {proto._SortedSetLengthResponse.SortedSetCase} */
      s.Message.computeOneofCase(this, c._SortedSetLengthResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthResponse.prototype.toObject = function(l) {
    return c._SortedSetLengthResponse.toObject(l, this);
  }, c._SortedSetLengthResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SortedSetLengthResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SortedSetLengthResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetLengthResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthResponse();
    return c._SortedSetLengthResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetLengthResponse._Found();
          g.readMessage(_, c._SortedSetLengthResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SortedSetLengthResponse._Missing();
          g.readMessage(_, c._SortedSetLengthResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SortedSetLengthResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetLengthResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthResponse._Found.prototype.toObject = function(l) {
    return c._SortedSetLengthResponse._Found.toObject(l, this);
  }, c._SortedSetLengthResponse._Found.toObject = function(l, g) {
    var f = {
      length: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetLengthResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthResponse._Found();
    return c._SortedSetLengthResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._SortedSetLengthResponse._Found.prototype.getLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._SortedSetLengthResponse._Found.prototype.setLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthResponse._Missing.prototype.toObject = function(l) {
    return c._SortedSetLengthResponse._Missing.toObject(l, this);
  }, c._SortedSetLengthResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetLengthResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthResponse._Missing();
    return c._SortedSetLengthResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetLengthResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SortedSetLengthResponse._Found} */
      s.Message.getWrapperField(this, c._SortedSetLengthResponse._Found, 1)
    );
  }, c._SortedSetLengthResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetLengthResponse.oneofGroups_[0], l);
  }, c._SortedSetLengthResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SortedSetLengthResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetLengthResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SortedSetLengthResponse._Missing} */
      s.Message.getWrapperField(this, c._SortedSetLengthResponse._Missing, 2)
    );
  }, c._SortedSetLengthResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetLengthResponse.oneofGroups_[0], l);
  }, c._SortedSetLengthResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SortedSetLengthResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetLengthByScoreRequest.oneofGroups_ = [[2, 3, 4], [5, 6, 7]], c._SortedSetLengthByScoreRequest.MinCase = {
    MIN_NOT_SET: 0,
    INCLUSIVE_MIN: 2,
    EXCLUSIVE_MIN: 3,
    UNBOUNDED_MIN: 4
  }, c._SortedSetLengthByScoreRequest.prototype.getMinCase = function() {
    return (
      /** @type {proto._SortedSetLengthByScoreRequest.MinCase} */
      s.Message.computeOneofCase(this, c._SortedSetLengthByScoreRequest.oneofGroups_[0])
    );
  }, c._SortedSetLengthByScoreRequest.MaxCase = {
    MAX_NOT_SET: 0,
    INCLUSIVE_MAX: 5,
    EXCLUSIVE_MAX: 6,
    UNBOUNDED_MAX: 7
  }, c._SortedSetLengthByScoreRequest.prototype.getMaxCase = function() {
    return (
      /** @type {proto._SortedSetLengthByScoreRequest.MaxCase} */
      s.Message.computeOneofCase(this, c._SortedSetLengthByScoreRequest.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthByScoreRequest.prototype.toObject = function(l) {
    return c._SortedSetLengthByScoreRequest.toObject(l, this);
  }, c._SortedSetLengthByScoreRequest.toObject = function(l, g) {
    var f, _ = {
      setName: g.getSetName_asB64(),
      inclusiveMin: s.Message.getFloatingPointFieldWithDefault(g, 2, 0),
      exclusiveMin: s.Message.getFloatingPointFieldWithDefault(g, 3, 0),
      unboundedMin: (f = g.getUnboundedMin()) && d._Unbounded.toObject(l, f),
      inclusiveMax: s.Message.getFloatingPointFieldWithDefault(g, 5, 0),
      exclusiveMax: s.Message.getFloatingPointFieldWithDefault(g, 6, 0),
      unboundedMax: (f = g.getUnboundedMax()) && d._Unbounded.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetLengthByScoreRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthByScoreRequest();
    return c._SortedSetLengthByScoreRequest.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthByScoreRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {!Uint8Array} */
            g.readBytes()
          );
          l.setSetName(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setInclusiveMin(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setExclusiveMin(_);
          break;
        case 4:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedMin(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setInclusiveMax(_);
          break;
        case 6:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setExclusiveMax(_);
          break;
        case 7:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedMax(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthByScoreRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthByScoreRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthByScoreRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSetName_asU8(), f.length > 0 && g.writeBytes(
      1,
      f
    ), f = /** @type {number} */
    s.Message.getField(l, 2), f != null && g.writeDouble(
      2,
      f
    ), f = /** @type {number} */
    s.Message.getField(l, 3), f != null && g.writeDouble(
      3,
      f
    ), f = l.getUnboundedMin(), f != null && g.writeMessage(
      4,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 5), f != null && g.writeDouble(
      5,
      f
    ), f = /** @type {number} */
    s.Message.getField(l, 6), f != null && g.writeDouble(
      6,
      f
    ), f = l.getUnboundedMax(), f != null && g.writeMessage(
      7,
      f,
      d._Unbounded.serializeBinaryToWriter
    );
  }, c._SortedSetLengthByScoreRequest.prototype.getSetName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SortedSetLengthByScoreRequest.prototype.getSetName_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getSetName()
      )
    );
  }, c._SortedSetLengthByScoreRequest.prototype.getSetName_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getSetName()
      )
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setSetName = function(l) {
    return s.Message.setProto3BytesField(this, 1, l);
  }, c._SortedSetLengthByScoreRequest.prototype.getInclusiveMin = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 2, 0)
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setInclusiveMin = function(l) {
    return s.Message.setOneofField(this, 2, c._SortedSetLengthByScoreRequest.oneofGroups_[0], l);
  }, c._SortedSetLengthByScoreRequest.prototype.clearInclusiveMin = function() {
    return s.Message.setOneofField(this, 2, c._SortedSetLengthByScoreRequest.oneofGroups_[0], void 0);
  }, c._SortedSetLengthByScoreRequest.prototype.hasInclusiveMin = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SortedSetLengthByScoreRequest.prototype.getExclusiveMin = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 3, 0)
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setExclusiveMin = function(l) {
    return s.Message.setOneofField(this, 3, c._SortedSetLengthByScoreRequest.oneofGroups_[0], l);
  }, c._SortedSetLengthByScoreRequest.prototype.clearExclusiveMin = function() {
    return s.Message.setOneofField(this, 3, c._SortedSetLengthByScoreRequest.oneofGroups_[0], void 0);
  }, c._SortedSetLengthByScoreRequest.prototype.hasExclusiveMin = function() {
    return s.Message.getField(this, 3) != null;
  }, c._SortedSetLengthByScoreRequest.prototype.getUnboundedMin = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 4)
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setUnboundedMin = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._SortedSetLengthByScoreRequest.oneofGroups_[0], l);
  }, c._SortedSetLengthByScoreRequest.prototype.clearUnboundedMin = function() {
    return this.setUnboundedMin(void 0);
  }, c._SortedSetLengthByScoreRequest.prototype.hasUnboundedMin = function() {
    return s.Message.getField(this, 4) != null;
  }, c._SortedSetLengthByScoreRequest.prototype.getInclusiveMax = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 5, 0)
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setInclusiveMax = function(l) {
    return s.Message.setOneofField(this, 5, c._SortedSetLengthByScoreRequest.oneofGroups_[1], l);
  }, c._SortedSetLengthByScoreRequest.prototype.clearInclusiveMax = function() {
    return s.Message.setOneofField(this, 5, c._SortedSetLengthByScoreRequest.oneofGroups_[1], void 0);
  }, c._SortedSetLengthByScoreRequest.prototype.hasInclusiveMax = function() {
    return s.Message.getField(this, 5) != null;
  }, c._SortedSetLengthByScoreRequest.prototype.getExclusiveMax = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 6, 0)
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setExclusiveMax = function(l) {
    return s.Message.setOneofField(this, 6, c._SortedSetLengthByScoreRequest.oneofGroups_[1], l);
  }, c._SortedSetLengthByScoreRequest.prototype.clearExclusiveMax = function() {
    return s.Message.setOneofField(this, 6, c._SortedSetLengthByScoreRequest.oneofGroups_[1], void 0);
  }, c._SortedSetLengthByScoreRequest.prototype.hasExclusiveMax = function() {
    return s.Message.getField(this, 6) != null;
  }, c._SortedSetLengthByScoreRequest.prototype.getUnboundedMax = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 7)
    );
  }, c._SortedSetLengthByScoreRequest.prototype.setUnboundedMax = function(l) {
    return s.Message.setOneofWrapperField(this, 7, c._SortedSetLengthByScoreRequest.oneofGroups_[1], l);
  }, c._SortedSetLengthByScoreRequest.prototype.clearUnboundedMax = function() {
    return this.setUnboundedMax(void 0);
  }, c._SortedSetLengthByScoreRequest.prototype.hasUnboundedMax = function() {
    return s.Message.getField(this, 7) != null;
  }, c._SortedSetLengthByScoreResponse.oneofGroups_ = [[1, 2]], c._SortedSetLengthByScoreResponse.SortedSetCase = {
    SORTED_SET_NOT_SET: 0,
    FOUND: 1,
    MISSING: 2
  }, c._SortedSetLengthByScoreResponse.prototype.getSortedSetCase = function() {
    return (
      /** @type {proto._SortedSetLengthByScoreResponse.SortedSetCase} */
      s.Message.computeOneofCase(this, c._SortedSetLengthByScoreResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthByScoreResponse.prototype.toObject = function(l) {
    return c._SortedSetLengthByScoreResponse.toObject(l, this);
  }, c._SortedSetLengthByScoreResponse.toObject = function(l, g) {
    var f, _ = {
      found: (f = g.getFound()) && c._SortedSetLengthByScoreResponse._Found.toObject(l, f),
      missing: (f = g.getMissing()) && c._SortedSetLengthByScoreResponse._Missing.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._SortedSetLengthByScoreResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthByScoreResponse();
    return c._SortedSetLengthByScoreResponse.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthByScoreResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._SortedSetLengthByScoreResponse._Found();
          g.readMessage(_, c._SortedSetLengthByScoreResponse._Found.deserializeBinaryFromReader), l.setFound(_);
          break;
        case 2:
          var _ = new c._SortedSetLengthByScoreResponse._Missing();
          g.readMessage(_, c._SortedSetLengthByScoreResponse._Missing.deserializeBinaryFromReader), l.setMissing(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthByScoreResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthByScoreResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthByScoreResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getFound(), f != null && g.writeMessage(
      1,
      f,
      c._SortedSetLengthByScoreResponse._Found.serializeBinaryToWriter
    ), f = l.getMissing(), f != null && g.writeMessage(
      2,
      f,
      c._SortedSetLengthByScoreResponse._Missing.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthByScoreResponse._Found.prototype.toObject = function(l) {
    return c._SortedSetLengthByScoreResponse._Found.toObject(l, this);
  }, c._SortedSetLengthByScoreResponse._Found.toObject = function(l, g) {
    var f = {
      length: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetLengthByScoreResponse._Found.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthByScoreResponse._Found();
    return c._SortedSetLengthByScoreResponse._Found.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthByScoreResponse._Found.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setLength(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthByScoreResponse._Found.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthByScoreResponse._Found.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthByScoreResponse._Found.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getLength(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._SortedSetLengthByScoreResponse._Found.prototype.getLength = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._SortedSetLengthByScoreResponse._Found.prototype.setLength = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._SortedSetLengthByScoreResponse._Missing.prototype.toObject = function(l) {
    return c._SortedSetLengthByScoreResponse._Missing.toObject(l, this);
  }, c._SortedSetLengthByScoreResponse._Missing.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._SortedSetLengthByScoreResponse._Missing.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._SortedSetLengthByScoreResponse._Missing();
    return c._SortedSetLengthByScoreResponse._Missing.deserializeBinaryFromReader(f, g);
  }, c._SortedSetLengthByScoreResponse._Missing.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._SortedSetLengthByScoreResponse._Missing.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._SortedSetLengthByScoreResponse._Missing.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._SortedSetLengthByScoreResponse._Missing.serializeBinaryToWriter = function(l, g) {
  }, c._SortedSetLengthByScoreResponse.prototype.getFound = function() {
    return (
      /** @type{?proto._SortedSetLengthByScoreResponse._Found} */
      s.Message.getWrapperField(this, c._SortedSetLengthByScoreResponse._Found, 1)
    );
  }, c._SortedSetLengthByScoreResponse.prototype.setFound = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._SortedSetLengthByScoreResponse.oneofGroups_[0], l);
  }, c._SortedSetLengthByScoreResponse.prototype.clearFound = function() {
    return this.setFound(void 0);
  }, c._SortedSetLengthByScoreResponse.prototype.hasFound = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SortedSetLengthByScoreResponse.prototype.getMissing = function() {
    return (
      /** @type{?proto._SortedSetLengthByScoreResponse._Missing} */
      s.Message.getWrapperField(this, c._SortedSetLengthByScoreResponse._Missing, 2)
    );
  }, c._SortedSetLengthByScoreResponse.prototype.setMissing = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._SortedSetLengthByScoreResponse.oneofGroups_[0], l);
  }, c._SortedSetLengthByScoreResponse.prototype.clearMissing = function() {
    return this.setMissing(void 0);
  }, c._SortedSetLengthByScoreResponse.prototype.hasMissing = function() {
    return s.Message.getField(this, 2) != null;
  }, c.ECacheResult = {
    INVALID: 0,
    OK: 1,
    HIT: 2,
    MISS: 3
  }, h.object.extend(p, c);
})(cacheclient_pb$1);
var __createBinding$a = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$a = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$a = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$a(s, p, h);
  return __setModuleDefault$a(s, p), s;
};
Object.defineProperty(CacheclientServiceClientPb, "__esModule", { value: !0 });
CacheclientServiceClientPb.ScsClient = void 0;
const grpcWeb$9 = __importStar$a(grpcWeb$a), cacheclient_pb = __importStar$a(cacheclient_pb$1);
class ScsClient {
  constructor(s, h, c) {
    this.methodDescriptorGet = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/Get", grpcWeb$9.MethodType.UNARY, cacheclient_pb._GetRequest, cacheclient_pb._GetResponse, (d) => d.serializeBinary(), cacheclient_pb._GetResponse.deserializeBinary), this.methodDescriptorGetBatch = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/GetBatch", grpcWeb$9.MethodType.SERVER_STREAMING, cacheclient_pb._GetBatchRequest, cacheclient_pb._GetResponse, (d) => d.serializeBinary(), cacheclient_pb._GetResponse.deserializeBinary), this.methodDescriptorSet = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/Set", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetRequest, cacheclient_pb._SetResponse, (d) => d.serializeBinary(), cacheclient_pb._SetResponse.deserializeBinary), this.methodDescriptorSetBatch = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetBatch", grpcWeb$9.MethodType.SERVER_STREAMING, cacheclient_pb._SetBatchRequest, cacheclient_pb._SetResponse, (d) => d.serializeBinary(), cacheclient_pb._SetResponse.deserializeBinary), this.methodDescriptorSetIf = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetIf", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetIfRequest, cacheclient_pb._SetIfResponse, (d) => d.serializeBinary(), cacheclient_pb._SetIfResponse.deserializeBinary), this.methodDescriptorSetIfNotExists = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetIfNotExists", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetIfNotExistsRequest, cacheclient_pb._SetIfNotExistsResponse, (d) => d.serializeBinary(), cacheclient_pb._SetIfNotExistsResponse.deserializeBinary), this.methodDescriptorDelete = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/Delete", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DeleteRequest, cacheclient_pb._DeleteResponse, (d) => d.serializeBinary(), cacheclient_pb._DeleteResponse.deserializeBinary), this.methodDescriptorKeysExist = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/KeysExist", grpcWeb$9.MethodType.UNARY, cacheclient_pb._KeysExistRequest, cacheclient_pb._KeysExistResponse, (d) => d.serializeBinary(), cacheclient_pb._KeysExistResponse.deserializeBinary), this.methodDescriptorIncrement = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/Increment", grpcWeb$9.MethodType.UNARY, cacheclient_pb._IncrementRequest, cacheclient_pb._IncrementResponse, (d) => d.serializeBinary(), cacheclient_pb._IncrementResponse.deserializeBinary), this.methodDescriptorUpdateTtl = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/UpdateTtl", grpcWeb$9.MethodType.UNARY, cacheclient_pb._UpdateTtlRequest, cacheclient_pb._UpdateTtlResponse, (d) => d.serializeBinary(), cacheclient_pb._UpdateTtlResponse.deserializeBinary), this.methodDescriptorItemGetTtl = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ItemGetTtl", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ItemGetTtlRequest, cacheclient_pb._ItemGetTtlResponse, (d) => d.serializeBinary(), cacheclient_pb._ItemGetTtlResponse.deserializeBinary), this.methodDescriptorItemGetType = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ItemGetType", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ItemGetTypeRequest, cacheclient_pb._ItemGetTypeResponse, (d) => d.serializeBinary(), cacheclient_pb._ItemGetTypeResponse.deserializeBinary), this.methodDescriptorDictionaryGet = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/DictionaryGet", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DictionaryGetRequest, cacheclient_pb._DictionaryGetResponse, (d) => d.serializeBinary(), cacheclient_pb._DictionaryGetResponse.deserializeBinary), this.methodDescriptorDictionaryFetch = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/DictionaryFetch", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DictionaryFetchRequest, cacheclient_pb._DictionaryFetchResponse, (d) => d.serializeBinary(), cacheclient_pb._DictionaryFetchResponse.deserializeBinary), this.methodDescriptorDictionarySet = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/DictionarySet", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DictionarySetRequest, cacheclient_pb._DictionarySetResponse, (d) => d.serializeBinary(), cacheclient_pb._DictionarySetResponse.deserializeBinary), this.methodDescriptorDictionaryIncrement = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/DictionaryIncrement", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DictionaryIncrementRequest, cacheclient_pb._DictionaryIncrementResponse, (d) => d.serializeBinary(), cacheclient_pb._DictionaryIncrementResponse.deserializeBinary), this.methodDescriptorDictionaryDelete = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/DictionaryDelete", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DictionaryDeleteRequest, cacheclient_pb._DictionaryDeleteResponse, (d) => d.serializeBinary(), cacheclient_pb._DictionaryDeleteResponse.deserializeBinary), this.methodDescriptorDictionaryLength = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/DictionaryLength", grpcWeb$9.MethodType.UNARY, cacheclient_pb._DictionaryLengthRequest, cacheclient_pb._DictionaryLengthResponse, (d) => d.serializeBinary(), cacheclient_pb._DictionaryLengthResponse.deserializeBinary), this.methodDescriptorSetFetch = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetFetch", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetFetchRequest, cacheclient_pb._SetFetchResponse, (d) => d.serializeBinary(), cacheclient_pb._SetFetchResponse.deserializeBinary), this.methodDescriptorSetSample = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetSample", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetSampleRequest, cacheclient_pb._SetSampleResponse, (d) => d.serializeBinary(), cacheclient_pb._SetSampleResponse.deserializeBinary), this.methodDescriptorSetUnion = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetUnion", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetUnionRequest, cacheclient_pb._SetUnionResponse, (d) => d.serializeBinary(), cacheclient_pb._SetUnionResponse.deserializeBinary), this.methodDescriptorSetDifference = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetDifference", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetDifferenceRequest, cacheclient_pb._SetDifferenceResponse, (d) => d.serializeBinary(), cacheclient_pb._SetDifferenceResponse.deserializeBinary), this.methodDescriptorSetContains = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetContains", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetContainsRequest, cacheclient_pb._SetContainsResponse, (d) => d.serializeBinary(), cacheclient_pb._SetContainsResponse.deserializeBinary), this.methodDescriptorSetLength = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetLength", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetLengthRequest, cacheclient_pb._SetLengthResponse, (d) => d.serializeBinary(), cacheclient_pb._SetLengthResponse.deserializeBinary), this.methodDescriptorSetPop = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SetPop", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SetPopRequest, cacheclient_pb._SetPopResponse, (d) => d.serializeBinary(), cacheclient_pb._SetPopResponse.deserializeBinary), this.methodDescriptorListPushFront = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListPushFront", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListPushFrontRequest, cacheclient_pb._ListPushFrontResponse, (d) => d.serializeBinary(), cacheclient_pb._ListPushFrontResponse.deserializeBinary), this.methodDescriptorListPushBack = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListPushBack", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListPushBackRequest, cacheclient_pb._ListPushBackResponse, (d) => d.serializeBinary(), cacheclient_pb._ListPushBackResponse.deserializeBinary), this.methodDescriptorListPopFront = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListPopFront", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListPopFrontRequest, cacheclient_pb._ListPopFrontResponse, (d) => d.serializeBinary(), cacheclient_pb._ListPopFrontResponse.deserializeBinary), this.methodDescriptorListPopBack = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListPopBack", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListPopBackRequest, cacheclient_pb._ListPopBackResponse, (d) => d.serializeBinary(), cacheclient_pb._ListPopBackResponse.deserializeBinary), this.methodDescriptorListErase = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListErase", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListEraseRequest, cacheclient_pb._ListEraseResponse, (d) => d.serializeBinary(), cacheclient_pb._ListEraseResponse.deserializeBinary), this.methodDescriptorListRemove = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListRemove", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListRemoveRequest, cacheclient_pb._ListRemoveResponse, (d) => d.serializeBinary(), cacheclient_pb._ListRemoveResponse.deserializeBinary), this.methodDescriptorListFetch = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListFetch", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListFetchRequest, cacheclient_pb._ListFetchResponse, (d) => d.serializeBinary(), cacheclient_pb._ListFetchResponse.deserializeBinary), this.methodDescriptorListLength = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListLength", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListLengthRequest, cacheclient_pb._ListLengthResponse, (d) => d.serializeBinary(), cacheclient_pb._ListLengthResponse.deserializeBinary), this.methodDescriptorListConcatenateFront = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListConcatenateFront", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListConcatenateFrontRequest, cacheclient_pb._ListConcatenateFrontResponse, (d) => d.serializeBinary(), cacheclient_pb._ListConcatenateFrontResponse.deserializeBinary), this.methodDescriptorListConcatenateBack = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListConcatenateBack", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListConcatenateBackRequest, cacheclient_pb._ListConcatenateBackResponse, (d) => d.serializeBinary(), cacheclient_pb._ListConcatenateBackResponse.deserializeBinary), this.methodDescriptorListRetain = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/ListRetain", grpcWeb$9.MethodType.UNARY, cacheclient_pb._ListRetainRequest, cacheclient_pb._ListRetainResponse, (d) => d.serializeBinary(), cacheclient_pb._ListRetainResponse.deserializeBinary), this.methodDescriptorSortedSetPut = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetPut", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetPutRequest, cacheclient_pb._SortedSetPutResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetPutResponse.deserializeBinary), this.methodDescriptorSortedSetFetch = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetFetch", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetFetchRequest, cacheclient_pb._SortedSetFetchResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetFetchResponse.deserializeBinary), this.methodDescriptorSortedSetGetScore = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetGetScore", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetGetScoreRequest, cacheclient_pb._SortedSetGetScoreResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetGetScoreResponse.deserializeBinary), this.methodDescriptorSortedSetRemove = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetRemove", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetRemoveRequest, cacheclient_pb._SortedSetRemoveResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetRemoveResponse.deserializeBinary), this.methodDescriptorSortedSetIncrement = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetIncrement", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetIncrementRequest, cacheclient_pb._SortedSetIncrementResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetIncrementResponse.deserializeBinary), this.methodDescriptorSortedSetGetRank = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetGetRank", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetGetRankRequest, cacheclient_pb._SortedSetGetRankResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetGetRankResponse.deserializeBinary), this.methodDescriptorSortedSetLength = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetLength", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetLengthRequest, cacheclient_pb._SortedSetLengthResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetLengthResponse.deserializeBinary), this.methodDescriptorSortedSetLengthByScore = new grpcWeb$9.MethodDescriptor("/cache_client.Scs/SortedSetLengthByScore", grpcWeb$9.MethodType.UNARY, cacheclient_pb._SortedSetLengthByScoreRequest, cacheclient_pb._SortedSetLengthByScoreResponse, (d) => d.serializeBinary(), cacheclient_pb._SortedSetLengthByScoreResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$9.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  get(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/Get", s, h || {}, this.methodDescriptorGet, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/Get", s, h || {}, this.methodDescriptorGet);
  }
  getBatch(s, h) {
    return this.client_.serverStreaming(this.hostname_ + "/cache_client.Scs/GetBatch", s, h || {}, this.methodDescriptorGetBatch);
  }
  set(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/Set", s, h || {}, this.methodDescriptorSet, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/Set", s, h || {}, this.methodDescriptorSet);
  }
  setBatch(s, h) {
    return this.client_.serverStreaming(this.hostname_ + "/cache_client.Scs/SetBatch", s, h || {}, this.methodDescriptorSetBatch);
  }
  setIf(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetIf", s, h || {}, this.methodDescriptorSetIf, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetIf", s, h || {}, this.methodDescriptorSetIf);
  }
  setIfNotExists(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetIfNotExists", s, h || {}, this.methodDescriptorSetIfNotExists, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetIfNotExists", s, h || {}, this.methodDescriptorSetIfNotExists);
  }
  delete(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/Delete", s, h || {}, this.methodDescriptorDelete, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/Delete", s, h || {}, this.methodDescriptorDelete);
  }
  keysExist(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/KeysExist", s, h || {}, this.methodDescriptorKeysExist, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/KeysExist", s, h || {}, this.methodDescriptorKeysExist);
  }
  increment(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/Increment", s, h || {}, this.methodDescriptorIncrement, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/Increment", s, h || {}, this.methodDescriptorIncrement);
  }
  updateTtl(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/UpdateTtl", s, h || {}, this.methodDescriptorUpdateTtl, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/UpdateTtl", s, h || {}, this.methodDescriptorUpdateTtl);
  }
  itemGetTtl(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ItemGetTtl", s, h || {}, this.methodDescriptorItemGetTtl, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ItemGetTtl", s, h || {}, this.methodDescriptorItemGetTtl);
  }
  itemGetType(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ItemGetType", s, h || {}, this.methodDescriptorItemGetType, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ItemGetType", s, h || {}, this.methodDescriptorItemGetType);
  }
  dictionaryGet(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/DictionaryGet", s, h || {}, this.methodDescriptorDictionaryGet, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/DictionaryGet", s, h || {}, this.methodDescriptorDictionaryGet);
  }
  dictionaryFetch(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/DictionaryFetch", s, h || {}, this.methodDescriptorDictionaryFetch, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/DictionaryFetch", s, h || {}, this.methodDescriptorDictionaryFetch);
  }
  dictionarySet(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/DictionarySet", s, h || {}, this.methodDescriptorDictionarySet, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/DictionarySet", s, h || {}, this.methodDescriptorDictionarySet);
  }
  dictionaryIncrement(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/DictionaryIncrement", s, h || {}, this.methodDescriptorDictionaryIncrement, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/DictionaryIncrement", s, h || {}, this.methodDescriptorDictionaryIncrement);
  }
  dictionaryDelete(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/DictionaryDelete", s, h || {}, this.methodDescriptorDictionaryDelete, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/DictionaryDelete", s, h || {}, this.methodDescriptorDictionaryDelete);
  }
  dictionaryLength(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/DictionaryLength", s, h || {}, this.methodDescriptorDictionaryLength, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/DictionaryLength", s, h || {}, this.methodDescriptorDictionaryLength);
  }
  setFetch(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetFetch", s, h || {}, this.methodDescriptorSetFetch, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetFetch", s, h || {}, this.methodDescriptorSetFetch);
  }
  setSample(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetSample", s, h || {}, this.methodDescriptorSetSample, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetSample", s, h || {}, this.methodDescriptorSetSample);
  }
  setUnion(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetUnion", s, h || {}, this.methodDescriptorSetUnion, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetUnion", s, h || {}, this.methodDescriptorSetUnion);
  }
  setDifference(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetDifference", s, h || {}, this.methodDescriptorSetDifference, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetDifference", s, h || {}, this.methodDescriptorSetDifference);
  }
  setContains(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetContains", s, h || {}, this.methodDescriptorSetContains, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetContains", s, h || {}, this.methodDescriptorSetContains);
  }
  setLength(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetLength", s, h || {}, this.methodDescriptorSetLength, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetLength", s, h || {}, this.methodDescriptorSetLength);
  }
  setPop(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SetPop", s, h || {}, this.methodDescriptorSetPop, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SetPop", s, h || {}, this.methodDescriptorSetPop);
  }
  listPushFront(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListPushFront", s, h || {}, this.methodDescriptorListPushFront, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListPushFront", s, h || {}, this.methodDescriptorListPushFront);
  }
  listPushBack(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListPushBack", s, h || {}, this.methodDescriptorListPushBack, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListPushBack", s, h || {}, this.methodDescriptorListPushBack);
  }
  listPopFront(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListPopFront", s, h || {}, this.methodDescriptorListPopFront, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListPopFront", s, h || {}, this.methodDescriptorListPopFront);
  }
  listPopBack(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListPopBack", s, h || {}, this.methodDescriptorListPopBack, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListPopBack", s, h || {}, this.methodDescriptorListPopBack);
  }
  listErase(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListErase", s, h || {}, this.methodDescriptorListErase, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListErase", s, h || {}, this.methodDescriptorListErase);
  }
  listRemove(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListRemove", s, h || {}, this.methodDescriptorListRemove, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListRemove", s, h || {}, this.methodDescriptorListRemove);
  }
  listFetch(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListFetch", s, h || {}, this.methodDescriptorListFetch, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListFetch", s, h || {}, this.methodDescriptorListFetch);
  }
  listLength(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListLength", s, h || {}, this.methodDescriptorListLength, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListLength", s, h || {}, this.methodDescriptorListLength);
  }
  listConcatenateFront(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListConcatenateFront", s, h || {}, this.methodDescriptorListConcatenateFront, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListConcatenateFront", s, h || {}, this.methodDescriptorListConcatenateFront);
  }
  listConcatenateBack(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListConcatenateBack", s, h || {}, this.methodDescriptorListConcatenateBack, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListConcatenateBack", s, h || {}, this.methodDescriptorListConcatenateBack);
  }
  listRetain(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/ListRetain", s, h || {}, this.methodDescriptorListRetain, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/ListRetain", s, h || {}, this.methodDescriptorListRetain);
  }
  sortedSetPut(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetPut", s, h || {}, this.methodDescriptorSortedSetPut, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetPut", s, h || {}, this.methodDescriptorSortedSetPut);
  }
  sortedSetFetch(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetFetch", s, h || {}, this.methodDescriptorSortedSetFetch, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetFetch", s, h || {}, this.methodDescriptorSortedSetFetch);
  }
  sortedSetGetScore(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetGetScore", s, h || {}, this.methodDescriptorSortedSetGetScore, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetGetScore", s, h || {}, this.methodDescriptorSortedSetGetScore);
  }
  sortedSetRemove(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetRemove", s, h || {}, this.methodDescriptorSortedSetRemove, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetRemove", s, h || {}, this.methodDescriptorSortedSetRemove);
  }
  sortedSetIncrement(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetIncrement", s, h || {}, this.methodDescriptorSortedSetIncrement, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetIncrement", s, h || {}, this.methodDescriptorSortedSetIncrement);
  }
  sortedSetGetRank(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetGetRank", s, h || {}, this.methodDescriptorSortedSetGetRank, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetGetRank", s, h || {}, this.methodDescriptorSortedSetGetRank);
  }
  sortedSetLength(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetLength", s, h || {}, this.methodDescriptorSortedSetLength, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetLength", s, h || {}, this.methodDescriptorSortedSetLength);
  }
  sortedSetLengthByScore(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Scs/SortedSetLengthByScore", s, h || {}, this.methodDescriptorSortedSetLengthByScore, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Scs/SortedSetLengthByScore", s, h || {}, this.methodDescriptorSortedSetLengthByScore);
  }
}
CacheclientServiceClientPb.ScsClient = ScsClient;
var ControlclientServiceClientPb = {}, controlclient_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("_Cache", null, c), h.exportSymbol("_CacheLimits", null, c), h.exportSymbol("_CreateCacheRequest", null, c), h.exportSymbol("_CreateCacheResponse", null, c), h.exportSymbol("_CreateIndexRequest", null, c), h.exportSymbol("_CreateIndexResponse", null, c), h.exportSymbol("_CreateSigningKeyRequest", null, c), h.exportSymbol("_CreateSigningKeyResponse", null, c), h.exportSymbol("_CreateStoreRequest", null, c), h.exportSymbol("_CreateStoreResponse", null, c), h.exportSymbol("_DeleteCacheRequest", null, c), h.exportSymbol("_DeleteCacheResponse", null, c), h.exportSymbol("_DeleteIndexRequest", null, c), h.exportSymbol("_DeleteIndexResponse", null, c), h.exportSymbol("_DeleteStoreRequest", null, c), h.exportSymbol("_DeleteStoreResponse", null, c), h.exportSymbol("_FlushCacheRequest", null, c), h.exportSymbol("_FlushCacheResponse", null, c), h.exportSymbol("_ListCachesRequest", null, c), h.exportSymbol("_ListCachesResponse", null, c), h.exportSymbol("_ListIndexesRequest", null, c), h.exportSymbol("_ListIndexesResponse", null, c), h.exportSymbol("_ListIndexesResponse._Index", null, c), h.exportSymbol("_ListSigningKeysRequest", null, c), h.exportSymbol("_ListSigningKeysResponse", null, c), h.exportSymbol("_ListStoresRequest", null, c), h.exportSymbol("_ListStoresResponse", null, c), h.exportSymbol("_RevokeSigningKeyRequest", null, c), h.exportSymbol("_RevokeSigningKeyResponse", null, c), h.exportSymbol("_SigningKey", null, c), h.exportSymbol("_SimilarityMetric", null, c), h.exportSymbol("_SimilarityMetric.SimilarityMetricCase", null, c), h.exportSymbol("_SimilarityMetric._CosineSimilarity", null, c), h.exportSymbol("_SimilarityMetric._EuclideanSimilarity", null, c), h.exportSymbol("_SimilarityMetric._InnerProduct", null, c), h.exportSymbol("_Store", null, c), h.exportSymbol("_TopicLimits", null, c), c._CreateStoreRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateStoreRequest, s.Message), h.DEBUG && !COMPILED && (c._CreateStoreRequest.displayName = "proto._CreateStoreRequest"), c._CreateStoreResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateStoreResponse, s.Message), h.DEBUG && !COMPILED && (c._CreateStoreResponse.displayName = "proto._CreateStoreResponse"), c._DeleteStoreRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteStoreRequest, s.Message), h.DEBUG && !COMPILED && (c._DeleteStoreRequest.displayName = "proto._DeleteStoreRequest"), c._DeleteStoreResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteStoreResponse, s.Message), h.DEBUG && !COMPILED && (c._DeleteStoreResponse.displayName = "proto._DeleteStoreResponse"), c._ListStoresRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._ListStoresRequest, s.Message), h.DEBUG && !COMPILED && (c._ListStoresRequest.displayName = "proto._ListStoresRequest"), c._ListStoresResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, c._ListStoresResponse.repeatedFields_, null);
  }, h.inherits(c._ListStoresResponse, s.Message), h.DEBUG && !COMPILED && (c._ListStoresResponse.displayName = "proto._ListStoresResponse"), c._Store = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._Store, s.Message), h.DEBUG && !COMPILED && (c._Store.displayName = "proto._Store"), c._SimilarityMetric = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c._SimilarityMetric.oneofGroups_);
  }, h.inherits(c._SimilarityMetric, s.Message), h.DEBUG && !COMPILED && (c._SimilarityMetric.displayName = "proto._SimilarityMetric"), c._SimilarityMetric._EuclideanSimilarity = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._SimilarityMetric._EuclideanSimilarity, s.Message), h.DEBUG && !COMPILED && (c._SimilarityMetric._EuclideanSimilarity.displayName = "proto._SimilarityMetric._EuclideanSimilarity"), c._SimilarityMetric._InnerProduct = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._SimilarityMetric._InnerProduct, s.Message), h.DEBUG && !COMPILED && (c._SimilarityMetric._InnerProduct.displayName = "proto._SimilarityMetric._InnerProduct"), c._SimilarityMetric._CosineSimilarity = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._SimilarityMetric._CosineSimilarity, s.Message), h.DEBUG && !COMPILED && (c._SimilarityMetric._CosineSimilarity.displayName = "proto._SimilarityMetric._CosineSimilarity"), c._CreateIndexRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateIndexRequest, s.Message), h.DEBUG && !COMPILED && (c._CreateIndexRequest.displayName = "proto._CreateIndexRequest"), c._CreateIndexResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateIndexResponse, s.Message), h.DEBUG && !COMPILED && (c._CreateIndexResponse.displayName = "proto._CreateIndexResponse"), c._DeleteIndexRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteIndexRequest, s.Message), h.DEBUG && !COMPILED && (c._DeleteIndexRequest.displayName = "proto._DeleteIndexRequest"), c._DeleteIndexResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteIndexResponse, s.Message), h.DEBUG && !COMPILED && (c._DeleteIndexResponse.displayName = "proto._DeleteIndexResponse"), c._ListIndexesRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._ListIndexesRequest, s.Message), h.DEBUG && !COMPILED && (c._ListIndexesRequest.displayName = "proto._ListIndexesRequest"), c._ListIndexesResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, c._ListIndexesResponse.repeatedFields_, null);
  }, h.inherits(c._ListIndexesResponse, s.Message), h.DEBUG && !COMPILED && (c._ListIndexesResponse.displayName = "proto._ListIndexesResponse"), c._ListIndexesResponse._Index = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._ListIndexesResponse._Index, s.Message), h.DEBUG && !COMPILED && (c._ListIndexesResponse._Index.displayName = "proto._ListIndexesResponse._Index"), c._DeleteCacheRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteCacheRequest, s.Message), h.DEBUG && !COMPILED && (c._DeleteCacheRequest.displayName = "proto._DeleteCacheRequest"), c._DeleteCacheResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteCacheResponse, s.Message), h.DEBUG && !COMPILED && (c._DeleteCacheResponse.displayName = "proto._DeleteCacheResponse"), c._CreateCacheRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateCacheRequest, s.Message), h.DEBUG && !COMPILED && (c._CreateCacheRequest.displayName = "proto._CreateCacheRequest"), c._CreateCacheResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateCacheResponse, s.Message), h.DEBUG && !COMPILED && (c._CreateCacheResponse.displayName = "proto._CreateCacheResponse"), c._ListCachesRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._ListCachesRequest, s.Message), h.DEBUG && !COMPILED && (c._ListCachesRequest.displayName = "proto._ListCachesRequest"), c._CacheLimits = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CacheLimits, s.Message), h.DEBUG && !COMPILED && (c._CacheLimits.displayName = "proto._CacheLimits"), c._TopicLimits = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._TopicLimits, s.Message), h.DEBUG && !COMPILED && (c._TopicLimits.displayName = "proto._TopicLimits"), c._Cache = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._Cache, s.Message), h.DEBUG && !COMPILED && (c._Cache.displayName = "proto._Cache"), c._ListCachesResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, c._ListCachesResponse.repeatedFields_, null);
  }, h.inherits(c._ListCachesResponse, s.Message), h.DEBUG && !COMPILED && (c._ListCachesResponse.displayName = "proto._ListCachesResponse"), c._CreateSigningKeyRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateSigningKeyRequest, s.Message), h.DEBUG && !COMPILED && (c._CreateSigningKeyRequest.displayName = "proto._CreateSigningKeyRequest"), c._CreateSigningKeyResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._CreateSigningKeyResponse, s.Message), h.DEBUG && !COMPILED && (c._CreateSigningKeyResponse.displayName = "proto._CreateSigningKeyResponse"), c._RevokeSigningKeyRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._RevokeSigningKeyRequest, s.Message), h.DEBUG && !COMPILED && (c._RevokeSigningKeyRequest.displayName = "proto._RevokeSigningKeyRequest"), c._RevokeSigningKeyResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._RevokeSigningKeyResponse, s.Message), h.DEBUG && !COMPILED && (c._RevokeSigningKeyResponse.displayName = "proto._RevokeSigningKeyResponse"), c._SigningKey = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._SigningKey, s.Message), h.DEBUG && !COMPILED && (c._SigningKey.displayName = "proto._SigningKey"), c._ListSigningKeysRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._ListSigningKeysRequest, s.Message), h.DEBUG && !COMPILED && (c._ListSigningKeysRequest.displayName = "proto._ListSigningKeysRequest"), c._ListSigningKeysResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, c._ListSigningKeysResponse.repeatedFields_, null);
  }, h.inherits(c._ListSigningKeysResponse, s.Message), h.DEBUG && !COMPILED && (c._ListSigningKeysResponse.displayName = "proto._ListSigningKeysResponse"), c._FlushCacheRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._FlushCacheRequest, s.Message), h.DEBUG && !COMPILED && (c._FlushCacheRequest.displayName = "proto._FlushCacheRequest"), c._FlushCacheResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._FlushCacheResponse, s.Message), h.DEBUG && !COMPILED && (c._FlushCacheResponse.displayName = "proto._FlushCacheResponse"), s.Message.GENERATE_TO_OBJECT && (c._CreateStoreRequest.prototype.toObject = function(d) {
    return c._CreateStoreRequest.toObject(d, this);
  }, c._CreateStoreRequest.toObject = function(d, l) {
    var g = {
      storeName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateStoreRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateStoreRequest();
    return c._CreateStoreRequest.deserializeBinaryFromReader(g, l);
  }, c._CreateStoreRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setStoreName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateStoreRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateStoreRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateStoreRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getStoreName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._CreateStoreRequest.prototype.getStoreName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._CreateStoreRequest.prototype.setStoreName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateStoreResponse.prototype.toObject = function(d) {
    return c._CreateStoreResponse.toObject(d, this);
  }, c._CreateStoreResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateStoreResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateStoreResponse();
    return c._CreateStoreResponse.deserializeBinaryFromReader(g, l);
  }, c._CreateStoreResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateStoreResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateStoreResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateStoreResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteStoreRequest.prototype.toObject = function(d) {
    return c._DeleteStoreRequest.toObject(d, this);
  }, c._DeleteStoreRequest.toObject = function(d, l) {
    var g = {
      storeName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteStoreRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteStoreRequest();
    return c._DeleteStoreRequest.deserializeBinaryFromReader(g, l);
  }, c._DeleteStoreRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setStoreName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteStoreRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteStoreRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteStoreRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getStoreName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._DeleteStoreRequest.prototype.getStoreName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DeleteStoreRequest.prototype.setStoreName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteStoreResponse.prototype.toObject = function(d) {
    return c._DeleteStoreResponse.toObject(d, this);
  }, c._DeleteStoreResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteStoreResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteStoreResponse();
    return c._DeleteStoreResponse.deserializeBinaryFromReader(g, l);
  }, c._DeleteStoreResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteStoreResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteStoreResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteStoreResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._ListStoresRequest.prototype.toObject = function(d) {
    return c._ListStoresRequest.toObject(d, this);
  }, c._ListStoresRequest.toObject = function(d, l) {
    var g = {
      nextToken: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListStoresRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListStoresRequest();
    return c._ListStoresRequest.deserializeBinaryFromReader(g, l);
  }, c._ListStoresRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNextToken(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListStoresRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListStoresRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListStoresRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getNextToken(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._ListStoresRequest.prototype.getNextToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListStoresRequest.prototype.setNextToken = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._ListStoresResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListStoresResponse.prototype.toObject = function(d) {
    return c._ListStoresResponse.toObject(d, this);
  }, c._ListStoresResponse.toObject = function(d, l) {
    var g = {
      storeList: s.Message.toObjectList(
        l.getStoreList(),
        c._Store.toObject,
        d
      ),
      nextToken: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListStoresResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListStoresResponse();
    return c._ListStoresResponse.deserializeBinaryFromReader(g, l);
  }, c._ListStoresResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._Store();
          l.readMessage(f, c._Store.deserializeBinaryFromReader), d.addStore(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNextToken(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListStoresResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListStoresResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListStoresResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getStoreList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c._Store.serializeBinaryToWriter
    ), g = d.getNextToken(), g.length > 0 && l.writeString(
      2,
      g
    );
  }, c._ListStoresResponse.prototype.getStoreList = function() {
    return (
      /** @type{!Array<!proto._Store>} */
      s.Message.getRepeatedWrapperField(this, c._Store, 1)
    );
  }, c._ListStoresResponse.prototype.setStoreList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c._ListStoresResponse.prototype.addStore = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c._Store, l);
  }, c._ListStoresResponse.prototype.clearStoreList = function() {
    return this.setStoreList([]);
  }, c._ListStoresResponse.prototype.getNextToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._ListStoresResponse.prototype.setNextToken = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._Store.prototype.toObject = function(d) {
    return c._Store.toObject(d, this);
  }, c._Store.toObject = function(d, l) {
    var g = {
      storeName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._Store.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._Store();
    return c._Store.deserializeBinaryFromReader(g, l);
  }, c._Store.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setStoreName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._Store.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._Store.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._Store.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getStoreName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._Store.prototype.getStoreName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._Store.prototype.setStoreName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._SimilarityMetric.oneofGroups_ = [[1, 2, 3]], c._SimilarityMetric.SimilarityMetricCase = {
    SIMILARITY_METRIC_NOT_SET: 0,
    EUCLIDEAN_SIMILARITY: 1,
    INNER_PRODUCT: 2,
    COSINE_SIMILARITY: 3
  }, c._SimilarityMetric.prototype.getSimilarityMetricCase = function() {
    return (
      /** @type {proto._SimilarityMetric.SimilarityMetricCase} */
      s.Message.computeOneofCase(this, c._SimilarityMetric.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SimilarityMetric.prototype.toObject = function(d) {
    return c._SimilarityMetric.toObject(d, this);
  }, c._SimilarityMetric.toObject = function(d, l) {
    var g, f = {
      euclideanSimilarity: (g = l.getEuclideanSimilarity()) && c._SimilarityMetric._EuclideanSimilarity.toObject(d, g),
      innerProduct: (g = l.getInnerProduct()) && c._SimilarityMetric._InnerProduct.toObject(d, g),
      cosineSimilarity: (g = l.getCosineSimilarity()) && c._SimilarityMetric._CosineSimilarity.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._SimilarityMetric.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._SimilarityMetric();
    return c._SimilarityMetric.deserializeBinaryFromReader(g, l);
  }, c._SimilarityMetric.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._SimilarityMetric._EuclideanSimilarity();
          l.readMessage(f, c._SimilarityMetric._EuclideanSimilarity.deserializeBinaryFromReader), d.setEuclideanSimilarity(f);
          break;
        case 2:
          var f = new c._SimilarityMetric._InnerProduct();
          l.readMessage(f, c._SimilarityMetric._InnerProduct.deserializeBinaryFromReader), d.setInnerProduct(f);
          break;
        case 3:
          var f = new c._SimilarityMetric._CosineSimilarity();
          l.readMessage(f, c._SimilarityMetric._CosineSimilarity.deserializeBinaryFromReader), d.setCosineSimilarity(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._SimilarityMetric.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._SimilarityMetric.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._SimilarityMetric.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getEuclideanSimilarity(), g != null && l.writeMessage(
      1,
      g,
      c._SimilarityMetric._EuclideanSimilarity.serializeBinaryToWriter
    ), g = d.getInnerProduct(), g != null && l.writeMessage(
      2,
      g,
      c._SimilarityMetric._InnerProduct.serializeBinaryToWriter
    ), g = d.getCosineSimilarity(), g != null && l.writeMessage(
      3,
      g,
      c._SimilarityMetric._CosineSimilarity.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SimilarityMetric._EuclideanSimilarity.prototype.toObject = function(d) {
    return c._SimilarityMetric._EuclideanSimilarity.toObject(d, this);
  }, c._SimilarityMetric._EuclideanSimilarity.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._SimilarityMetric._EuclideanSimilarity.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._SimilarityMetric._EuclideanSimilarity();
    return c._SimilarityMetric._EuclideanSimilarity.deserializeBinaryFromReader(g, l);
  }, c._SimilarityMetric._EuclideanSimilarity.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._SimilarityMetric._EuclideanSimilarity.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._SimilarityMetric._EuclideanSimilarity.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._SimilarityMetric._EuclideanSimilarity.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SimilarityMetric._InnerProduct.prototype.toObject = function(d) {
    return c._SimilarityMetric._InnerProduct.toObject(d, this);
  }, c._SimilarityMetric._InnerProduct.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._SimilarityMetric._InnerProduct.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._SimilarityMetric._InnerProduct();
    return c._SimilarityMetric._InnerProduct.deserializeBinaryFromReader(g, l);
  }, c._SimilarityMetric._InnerProduct.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._SimilarityMetric._InnerProduct.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._SimilarityMetric._InnerProduct.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._SimilarityMetric._InnerProduct.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SimilarityMetric._CosineSimilarity.prototype.toObject = function(d) {
    return c._SimilarityMetric._CosineSimilarity.toObject(d, this);
  }, c._SimilarityMetric._CosineSimilarity.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._SimilarityMetric._CosineSimilarity.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._SimilarityMetric._CosineSimilarity();
    return c._SimilarityMetric._CosineSimilarity.deserializeBinaryFromReader(g, l);
  }, c._SimilarityMetric._CosineSimilarity.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._SimilarityMetric._CosineSimilarity.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._SimilarityMetric._CosineSimilarity.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._SimilarityMetric._CosineSimilarity.serializeBinaryToWriter = function(d, l) {
  }, c._SimilarityMetric.prototype.getEuclideanSimilarity = function() {
    return (
      /** @type{?proto._SimilarityMetric._EuclideanSimilarity} */
      s.Message.getWrapperField(this, c._SimilarityMetric._EuclideanSimilarity, 1)
    );
  }, c._SimilarityMetric.prototype.setEuclideanSimilarity = function(d) {
    return s.Message.setOneofWrapperField(this, 1, c._SimilarityMetric.oneofGroups_[0], d);
  }, c._SimilarityMetric.prototype.clearEuclideanSimilarity = function() {
    return this.setEuclideanSimilarity(void 0);
  }, c._SimilarityMetric.prototype.hasEuclideanSimilarity = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SimilarityMetric.prototype.getInnerProduct = function() {
    return (
      /** @type{?proto._SimilarityMetric._InnerProduct} */
      s.Message.getWrapperField(this, c._SimilarityMetric._InnerProduct, 2)
    );
  }, c._SimilarityMetric.prototype.setInnerProduct = function(d) {
    return s.Message.setOneofWrapperField(this, 2, c._SimilarityMetric.oneofGroups_[0], d);
  }, c._SimilarityMetric.prototype.clearInnerProduct = function() {
    return this.setInnerProduct(void 0);
  }, c._SimilarityMetric.prototype.hasInnerProduct = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SimilarityMetric.prototype.getCosineSimilarity = function() {
    return (
      /** @type{?proto._SimilarityMetric._CosineSimilarity} */
      s.Message.getWrapperField(this, c._SimilarityMetric._CosineSimilarity, 3)
    );
  }, c._SimilarityMetric.prototype.setCosineSimilarity = function(d) {
    return s.Message.setOneofWrapperField(this, 3, c._SimilarityMetric.oneofGroups_[0], d);
  }, c._SimilarityMetric.prototype.clearCosineSimilarity = function() {
    return this.setCosineSimilarity(void 0);
  }, c._SimilarityMetric.prototype.hasCosineSimilarity = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateIndexRequest.prototype.toObject = function(d) {
    return c._CreateIndexRequest.toObject(d, this);
  }, c._CreateIndexRequest.toObject = function(d, l) {
    var g, f = {
      indexName: s.Message.getFieldWithDefault(l, 1, ""),
      numDimensions: s.Message.getFieldWithDefault(l, 2, 0),
      similarityMetric: (g = l.getSimilarityMetric()) && c._SimilarityMetric.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._CreateIndexRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateIndexRequest();
    return c._CreateIndexRequest.deserializeBinaryFromReader(g, l);
  }, c._CreateIndexRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setIndexName(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readUint64()
          );
          d.setNumDimensions(f);
          break;
        case 3:
          var f = new c._SimilarityMetric();
          l.readMessage(f, c._SimilarityMetric.deserializeBinaryFromReader), d.setSimilarityMetric(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateIndexRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateIndexRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateIndexRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getIndexName(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getNumDimensions(), g !== 0 && l.writeUint64(
      2,
      g
    ), g = d.getSimilarityMetric(), g != null && l.writeMessage(
      3,
      g,
      c._SimilarityMetric.serializeBinaryToWriter
    );
  }, c._CreateIndexRequest.prototype.getIndexName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._CreateIndexRequest.prototype.setIndexName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._CreateIndexRequest.prototype.getNumDimensions = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._CreateIndexRequest.prototype.setNumDimensions = function(d) {
    return s.Message.setProto3IntField(this, 2, d);
  }, c._CreateIndexRequest.prototype.getSimilarityMetric = function() {
    return (
      /** @type{?proto._SimilarityMetric} */
      s.Message.getWrapperField(this, c._SimilarityMetric, 3)
    );
  }, c._CreateIndexRequest.prototype.setSimilarityMetric = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, c._CreateIndexRequest.prototype.clearSimilarityMetric = function() {
    return this.setSimilarityMetric(void 0);
  }, c._CreateIndexRequest.prototype.hasSimilarityMetric = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateIndexResponse.prototype.toObject = function(d) {
    return c._CreateIndexResponse.toObject(d, this);
  }, c._CreateIndexResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateIndexResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateIndexResponse();
    return c._CreateIndexResponse.deserializeBinaryFromReader(g, l);
  }, c._CreateIndexResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateIndexResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateIndexResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateIndexResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteIndexRequest.prototype.toObject = function(d) {
    return c._DeleteIndexRequest.toObject(d, this);
  }, c._DeleteIndexRequest.toObject = function(d, l) {
    var g = {
      indexName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteIndexRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteIndexRequest();
    return c._DeleteIndexRequest.deserializeBinaryFromReader(g, l);
  }, c._DeleteIndexRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setIndexName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteIndexRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteIndexRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteIndexRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getIndexName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._DeleteIndexRequest.prototype.getIndexName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DeleteIndexRequest.prototype.setIndexName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteIndexResponse.prototype.toObject = function(d) {
    return c._DeleteIndexResponse.toObject(d, this);
  }, c._DeleteIndexResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteIndexResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteIndexResponse();
    return c._DeleteIndexResponse.deserializeBinaryFromReader(g, l);
  }, c._DeleteIndexResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteIndexResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteIndexResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteIndexResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._ListIndexesRequest.prototype.toObject = function(d) {
    return c._ListIndexesRequest.toObject(d, this);
  }, c._ListIndexesRequest.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListIndexesRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListIndexesRequest();
    return c._ListIndexesRequest.deserializeBinaryFromReader(g, l);
  }, c._ListIndexesRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListIndexesRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListIndexesRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListIndexesRequest.serializeBinaryToWriter = function(d, l) {
  }, c._ListIndexesResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListIndexesResponse.prototype.toObject = function(d) {
    return c._ListIndexesResponse.toObject(d, this);
  }, c._ListIndexesResponse.toObject = function(d, l) {
    var g = {
      indexesList: s.Message.toObjectList(
        l.getIndexesList(),
        c._ListIndexesResponse._Index.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListIndexesResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListIndexesResponse();
    return c._ListIndexesResponse.deserializeBinaryFromReader(g, l);
  }, c._ListIndexesResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._ListIndexesResponse._Index();
          l.readMessage(f, c._ListIndexesResponse._Index.deserializeBinaryFromReader), d.addIndexes(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListIndexesResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListIndexesResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListIndexesResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getIndexesList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c._ListIndexesResponse._Index.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ListIndexesResponse._Index.prototype.toObject = function(d) {
    return c._ListIndexesResponse._Index.toObject(d, this);
  }, c._ListIndexesResponse._Index.toObject = function(d, l) {
    var g, f = {
      indexName: s.Message.getFieldWithDefault(l, 1, ""),
      numDimensions: s.Message.getFieldWithDefault(l, 2, 0),
      similarityMetric: (g = l.getSimilarityMetric()) && c._SimilarityMetric.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._ListIndexesResponse._Index.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListIndexesResponse._Index();
    return c._ListIndexesResponse._Index.deserializeBinaryFromReader(g, l);
  }, c._ListIndexesResponse._Index.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setIndexName(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readUint64()
          );
          d.setNumDimensions(f);
          break;
        case 3:
          var f = new c._SimilarityMetric();
          l.readMessage(f, c._SimilarityMetric.deserializeBinaryFromReader), d.setSimilarityMetric(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListIndexesResponse._Index.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListIndexesResponse._Index.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListIndexesResponse._Index.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getIndexName(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getNumDimensions(), g !== 0 && l.writeUint64(
      2,
      g
    ), g = d.getSimilarityMetric(), g != null && l.writeMessage(
      3,
      g,
      c._SimilarityMetric.serializeBinaryToWriter
    );
  }, c._ListIndexesResponse._Index.prototype.getIndexName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListIndexesResponse._Index.prototype.setIndexName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._ListIndexesResponse._Index.prototype.getNumDimensions = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._ListIndexesResponse._Index.prototype.setNumDimensions = function(d) {
    return s.Message.setProto3IntField(this, 2, d);
  }, c._ListIndexesResponse._Index.prototype.getSimilarityMetric = function() {
    return (
      /** @type{?proto._SimilarityMetric} */
      s.Message.getWrapperField(this, c._SimilarityMetric, 3)
    );
  }, c._ListIndexesResponse._Index.prototype.setSimilarityMetric = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, c._ListIndexesResponse._Index.prototype.clearSimilarityMetric = function() {
    return this.setSimilarityMetric(void 0);
  }, c._ListIndexesResponse._Index.prototype.hasSimilarityMetric = function() {
    return s.Message.getField(this, 3) != null;
  }, c._ListIndexesResponse.prototype.getIndexesList = function() {
    return (
      /** @type{!Array<!proto._ListIndexesResponse._Index>} */
      s.Message.getRepeatedWrapperField(this, c._ListIndexesResponse._Index, 1)
    );
  }, c._ListIndexesResponse.prototype.setIndexesList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c._ListIndexesResponse.prototype.addIndexes = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c._ListIndexesResponse._Index, l);
  }, c._ListIndexesResponse.prototype.clearIndexesList = function() {
    return this.setIndexesList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteCacheRequest.prototype.toObject = function(d) {
    return c._DeleteCacheRequest.toObject(d, this);
  }, c._DeleteCacheRequest.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteCacheRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteCacheRequest();
    return c._DeleteCacheRequest.deserializeBinaryFromReader(g, l);
  }, c._DeleteCacheRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteCacheRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteCacheRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteCacheRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._DeleteCacheRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DeleteCacheRequest.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteCacheResponse.prototype.toObject = function(d) {
    return c._DeleteCacheResponse.toObject(d, this);
  }, c._DeleteCacheResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteCacheResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteCacheResponse();
    return c._DeleteCacheResponse.deserializeBinaryFromReader(g, l);
  }, c._DeleteCacheResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteCacheResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteCacheResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteCacheResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateCacheRequest.prototype.toObject = function(d) {
    return c._CreateCacheRequest.toObject(d, this);
  }, c._CreateCacheRequest.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateCacheRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateCacheRequest();
    return c._CreateCacheRequest.deserializeBinaryFromReader(g, l);
  }, c._CreateCacheRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateCacheRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateCacheRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateCacheRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._CreateCacheRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._CreateCacheRequest.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateCacheResponse.prototype.toObject = function(d) {
    return c._CreateCacheResponse.toObject(d, this);
  }, c._CreateCacheResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateCacheResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateCacheResponse();
    return c._CreateCacheResponse.deserializeBinaryFromReader(g, l);
  }, c._CreateCacheResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateCacheResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateCacheResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateCacheResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._ListCachesRequest.prototype.toObject = function(d) {
    return c._ListCachesRequest.toObject(d, this);
  }, c._ListCachesRequest.toObject = function(d, l) {
    var g = {
      nextToken: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListCachesRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListCachesRequest();
    return c._ListCachesRequest.deserializeBinaryFromReader(g, l);
  }, c._ListCachesRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNextToken(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListCachesRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListCachesRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListCachesRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getNextToken(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._ListCachesRequest.prototype.getNextToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListCachesRequest.prototype.setNextToken = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._CacheLimits.prototype.toObject = function(d) {
    return c._CacheLimits.toObject(d, this);
  }, c._CacheLimits.toObject = function(d, l) {
    var g = {
      maxTrafficRate: s.Message.getFieldWithDefault(l, 1, 0),
      maxThroughputKbps: s.Message.getFieldWithDefault(l, 2, 0),
      maxItemSizeKb: s.Message.getFieldWithDefault(l, 3, 0),
      maxTtlSeconds: s.Message.getFieldWithDefault(l, 4, 0)
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CacheLimits.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CacheLimits();
    return c._CacheLimits.deserializeBinaryFromReader(g, l);
  }, c._CacheLimits.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setMaxTrafficRate(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setMaxThroughputKbps(f);
          break;
        case 3:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setMaxItemSizeKb(f);
          break;
        case 4:
          var f = (
            /** @type {number} */
            l.readUint64()
          );
          d.setMaxTtlSeconds(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CacheLimits.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CacheLimits.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CacheLimits.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getMaxTrafficRate(), g !== 0 && l.writeUint32(
      1,
      g
    ), g = d.getMaxThroughputKbps(), g !== 0 && l.writeUint32(
      2,
      g
    ), g = d.getMaxItemSizeKb(), g !== 0 && l.writeUint32(
      3,
      g
    ), g = d.getMaxTtlSeconds(), g !== 0 && l.writeUint64(
      4,
      g
    );
  }, c._CacheLimits.prototype.getMaxTrafficRate = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._CacheLimits.prototype.setMaxTrafficRate = function(d) {
    return s.Message.setProto3IntField(this, 1, d);
  }, c._CacheLimits.prototype.getMaxThroughputKbps = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._CacheLimits.prototype.setMaxThroughputKbps = function(d) {
    return s.Message.setProto3IntField(this, 2, d);
  }, c._CacheLimits.prototype.getMaxItemSizeKb = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._CacheLimits.prototype.setMaxItemSizeKb = function(d) {
    return s.Message.setProto3IntField(this, 3, d);
  }, c._CacheLimits.prototype.getMaxTtlSeconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._CacheLimits.prototype.setMaxTtlSeconds = function(d) {
    return s.Message.setProto3IntField(this, 4, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._TopicLimits.prototype.toObject = function(d) {
    return c._TopicLimits.toObject(d, this);
  }, c._TopicLimits.toObject = function(d, l) {
    var g = {
      maxPublishRate: s.Message.getFieldWithDefault(l, 1, 0),
      maxSubscriptionCount: s.Message.getFieldWithDefault(l, 2, 0),
      maxPublishMessageSizeKb: s.Message.getFieldWithDefault(l, 3, 0)
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._TopicLimits.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._TopicLimits();
    return c._TopicLimits.deserializeBinaryFromReader(g, l);
  }, c._TopicLimits.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setMaxPublishRate(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setMaxSubscriptionCount(f);
          break;
        case 3:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setMaxPublishMessageSizeKb(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._TopicLimits.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._TopicLimits.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._TopicLimits.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getMaxPublishRate(), g !== 0 && l.writeUint32(
      1,
      g
    ), g = d.getMaxSubscriptionCount(), g !== 0 && l.writeUint32(
      2,
      g
    ), g = d.getMaxPublishMessageSizeKb(), g !== 0 && l.writeUint32(
      3,
      g
    );
  }, c._TopicLimits.prototype.getMaxPublishRate = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._TopicLimits.prototype.setMaxPublishRate = function(d) {
    return s.Message.setProto3IntField(this, 1, d);
  }, c._TopicLimits.prototype.getMaxSubscriptionCount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._TopicLimits.prototype.setMaxSubscriptionCount = function(d) {
    return s.Message.setProto3IntField(this, 2, d);
  }, c._TopicLimits.prototype.getMaxPublishMessageSizeKb = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._TopicLimits.prototype.setMaxPublishMessageSizeKb = function(d) {
    return s.Message.setProto3IntField(this, 3, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._Cache.prototype.toObject = function(d) {
    return c._Cache.toObject(d, this);
  }, c._Cache.toObject = function(d, l) {
    var g, f = {
      cacheName: s.Message.getFieldWithDefault(l, 1, ""),
      cacheLimits: (g = l.getCacheLimits()) && c._CacheLimits.toObject(d, g),
      topicLimits: (g = l.getTopicLimits()) && c._TopicLimits.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._Cache.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._Cache();
    return c._Cache.deserializeBinaryFromReader(g, l);
  }, c._Cache.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        case 2:
          var f = new c._CacheLimits();
          l.readMessage(f, c._CacheLimits.deserializeBinaryFromReader), d.setCacheLimits(f);
          break;
        case 3:
          var f = new c._TopicLimits();
          l.readMessage(f, c._TopicLimits.deserializeBinaryFromReader), d.setTopicLimits(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._Cache.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._Cache.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._Cache.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getCacheLimits(), g != null && l.writeMessage(
      2,
      g,
      c._CacheLimits.serializeBinaryToWriter
    ), g = d.getTopicLimits(), g != null && l.writeMessage(
      3,
      g,
      c._TopicLimits.serializeBinaryToWriter
    );
  }, c._Cache.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._Cache.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._Cache.prototype.getCacheLimits = function() {
    return (
      /** @type{?proto._CacheLimits} */
      s.Message.getWrapperField(this, c._CacheLimits, 2)
    );
  }, c._Cache.prototype.setCacheLimits = function(d) {
    return s.Message.setWrapperField(this, 2, d);
  }, c._Cache.prototype.clearCacheLimits = function() {
    return this.setCacheLimits(void 0);
  }, c._Cache.prototype.hasCacheLimits = function() {
    return s.Message.getField(this, 2) != null;
  }, c._Cache.prototype.getTopicLimits = function() {
    return (
      /** @type{?proto._TopicLimits} */
      s.Message.getWrapperField(this, c._TopicLimits, 3)
    );
  }, c._Cache.prototype.setTopicLimits = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, c._Cache.prototype.clearTopicLimits = function() {
    return this.setTopicLimits(void 0);
  }, c._Cache.prototype.hasTopicLimits = function() {
    return s.Message.getField(this, 3) != null;
  }, c._ListCachesResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListCachesResponse.prototype.toObject = function(d) {
    return c._ListCachesResponse.toObject(d, this);
  }, c._ListCachesResponse.toObject = function(d, l) {
    var g = {
      cacheList: s.Message.toObjectList(
        l.getCacheList(),
        c._Cache.toObject,
        d
      ),
      nextToken: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListCachesResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListCachesResponse();
    return c._ListCachesResponse.deserializeBinaryFromReader(g, l);
  }, c._ListCachesResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._Cache();
          l.readMessage(f, c._Cache.deserializeBinaryFromReader), d.addCache(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNextToken(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListCachesResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListCachesResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListCachesResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c._Cache.serializeBinaryToWriter
    ), g = d.getNextToken(), g.length > 0 && l.writeString(
      2,
      g
    );
  }, c._ListCachesResponse.prototype.getCacheList = function() {
    return (
      /** @type{!Array<!proto._Cache>} */
      s.Message.getRepeatedWrapperField(this, c._Cache, 1)
    );
  }, c._ListCachesResponse.prototype.setCacheList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c._ListCachesResponse.prototype.addCache = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c._Cache, l);
  }, c._ListCachesResponse.prototype.clearCacheList = function() {
    return this.setCacheList([]);
  }, c._ListCachesResponse.prototype.getNextToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._ListCachesResponse.prototype.setNextToken = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateSigningKeyRequest.prototype.toObject = function(d) {
    return c._CreateSigningKeyRequest.toObject(d, this);
  }, c._CreateSigningKeyRequest.toObject = function(d, l) {
    var g = {
      ttlMinutes: s.Message.getFieldWithDefault(l, 1, 0)
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateSigningKeyRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateSigningKeyRequest();
    return c._CreateSigningKeyRequest.deserializeBinaryFromReader(g, l);
  }, c._CreateSigningKeyRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {number} */
            l.readUint32()
          );
          d.setTtlMinutes(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateSigningKeyRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateSigningKeyRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateSigningKeyRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getTtlMinutes(), g !== 0 && l.writeUint32(
      1,
      g
    );
  }, c._CreateSigningKeyRequest.prototype.getTtlMinutes = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._CreateSigningKeyRequest.prototype.setTtlMinutes = function(d) {
    return s.Message.setProto3IntField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._CreateSigningKeyResponse.prototype.toObject = function(d) {
    return c._CreateSigningKeyResponse.toObject(d, this);
  }, c._CreateSigningKeyResponse.toObject = function(d, l) {
    var g = {
      key: s.Message.getFieldWithDefault(l, 1, ""),
      expiresAt: s.Message.getFieldWithDefault(l, 2, 0)
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._CreateSigningKeyResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._CreateSigningKeyResponse();
    return c._CreateSigningKeyResponse.deserializeBinaryFromReader(g, l);
  }, c._CreateSigningKeyResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setKey(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readUint64()
          );
          d.setExpiresAt(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._CreateSigningKeyResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._CreateSigningKeyResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._CreateSigningKeyResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getKey(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getExpiresAt(), g !== 0 && l.writeUint64(
      2,
      g
    );
  }, c._CreateSigningKeyResponse.prototype.getKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._CreateSigningKeyResponse.prototype.setKey = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._CreateSigningKeyResponse.prototype.getExpiresAt = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._CreateSigningKeyResponse.prototype.setExpiresAt = function(d) {
    return s.Message.setProto3IntField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._RevokeSigningKeyRequest.prototype.toObject = function(d) {
    return c._RevokeSigningKeyRequest.toObject(d, this);
  }, c._RevokeSigningKeyRequest.toObject = function(d, l) {
    var g = {
      keyId: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._RevokeSigningKeyRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._RevokeSigningKeyRequest();
    return c._RevokeSigningKeyRequest.deserializeBinaryFromReader(g, l);
  }, c._RevokeSigningKeyRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setKeyId(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._RevokeSigningKeyRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._RevokeSigningKeyRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._RevokeSigningKeyRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getKeyId(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._RevokeSigningKeyRequest.prototype.getKeyId = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._RevokeSigningKeyRequest.prototype.setKeyId = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._RevokeSigningKeyResponse.prototype.toObject = function(d) {
    return c._RevokeSigningKeyResponse.toObject(d, this);
  }, c._RevokeSigningKeyResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._RevokeSigningKeyResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._RevokeSigningKeyResponse();
    return c._RevokeSigningKeyResponse.deserializeBinaryFromReader(g, l);
  }, c._RevokeSigningKeyResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._RevokeSigningKeyResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._RevokeSigningKeyResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._RevokeSigningKeyResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._SigningKey.prototype.toObject = function(d) {
    return c._SigningKey.toObject(d, this);
  }, c._SigningKey.toObject = function(d, l) {
    var g = {
      keyId: s.Message.getFieldWithDefault(l, 1, ""),
      expiresAt: s.Message.getFieldWithDefault(l, 2, 0)
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._SigningKey.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._SigningKey();
    return c._SigningKey.deserializeBinaryFromReader(g, l);
  }, c._SigningKey.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setKeyId(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readUint64()
          );
          d.setExpiresAt(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._SigningKey.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._SigningKey.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._SigningKey.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getKeyId(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getExpiresAt(), g !== 0 && l.writeUint64(
      2,
      g
    );
  }, c._SigningKey.prototype.getKeyId = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SigningKey.prototype.setKeyId = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._SigningKey.prototype.getExpiresAt = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._SigningKey.prototype.setExpiresAt = function(d) {
    return s.Message.setProto3IntField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._ListSigningKeysRequest.prototype.toObject = function(d) {
    return c._ListSigningKeysRequest.toObject(d, this);
  }, c._ListSigningKeysRequest.toObject = function(d, l) {
    var g = {
      nextToken: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListSigningKeysRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListSigningKeysRequest();
    return c._ListSigningKeysRequest.deserializeBinaryFromReader(g, l);
  }, c._ListSigningKeysRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNextToken(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListSigningKeysRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListSigningKeysRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListSigningKeysRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getNextToken(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._ListSigningKeysRequest.prototype.getNextToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListSigningKeysRequest.prototype.setNextToken = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._ListSigningKeysResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListSigningKeysResponse.prototype.toObject = function(d) {
    return c._ListSigningKeysResponse.toObject(d, this);
  }, c._ListSigningKeysResponse.toObject = function(d, l) {
    var g = {
      signingKeyList: s.Message.toObjectList(
        l.getSigningKeyList(),
        c._SigningKey.toObject,
        d
      ),
      nextToken: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListSigningKeysResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListSigningKeysResponse();
    return c._ListSigningKeysResponse.deserializeBinaryFromReader(g, l);
  }, c._ListSigningKeysResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._SigningKey();
          l.readMessage(f, c._SigningKey.deserializeBinaryFromReader), d.addSigningKey(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNextToken(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListSigningKeysResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListSigningKeysResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListSigningKeysResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getSigningKeyList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c._SigningKey.serializeBinaryToWriter
    ), g = d.getNextToken(), g.length > 0 && l.writeString(
      2,
      g
    );
  }, c._ListSigningKeysResponse.prototype.getSigningKeyList = function() {
    return (
      /** @type{!Array<!proto._SigningKey>} */
      s.Message.getRepeatedWrapperField(this, c._SigningKey, 1)
    );
  }, c._ListSigningKeysResponse.prototype.setSigningKeyList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c._ListSigningKeysResponse.prototype.addSigningKey = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c._SigningKey, l);
  }, c._ListSigningKeysResponse.prototype.clearSigningKeyList = function() {
    return this.setSigningKeyList([]);
  }, c._ListSigningKeysResponse.prototype.getNextToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._ListSigningKeysResponse.prototype.setNextToken = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._FlushCacheRequest.prototype.toObject = function(d) {
    return c._FlushCacheRequest.toObject(d, this);
  }, c._FlushCacheRequest.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._FlushCacheRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._FlushCacheRequest();
    return c._FlushCacheRequest.deserializeBinaryFromReader(g, l);
  }, c._FlushCacheRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._FlushCacheRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._FlushCacheRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._FlushCacheRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._FlushCacheRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._FlushCacheRequest.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._FlushCacheResponse.prototype.toObject = function(d) {
    return c._FlushCacheResponse.toObject(d, this);
  }, c._FlushCacheResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._FlushCacheResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._FlushCacheResponse();
    return c._FlushCacheResponse.deserializeBinaryFromReader(g, l);
  }, c._FlushCacheResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._FlushCacheResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._FlushCacheResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._FlushCacheResponse.serializeBinaryToWriter = function(d, l) {
  }, h.object.extend(p, c);
})(controlclient_pb$1);
var __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$9(s, p, h);
  return __setModuleDefault$9(s, p), s;
};
Object.defineProperty(ControlclientServiceClientPb, "__esModule", { value: !0 });
ControlclientServiceClientPb.ScsControlClient = void 0;
const grpcWeb$8 = __importStar$9(grpcWeb$a), controlclient_pb = __importStar$9(controlclient_pb$1);
class ScsControlClient {
  constructor(s, h, c) {
    this.methodDescriptorCreateCache = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/CreateCache", grpcWeb$8.MethodType.UNARY, controlclient_pb._CreateCacheRequest, controlclient_pb._CreateCacheResponse, (d) => d.serializeBinary(), controlclient_pb._CreateCacheResponse.deserializeBinary), this.methodDescriptorDeleteCache = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/DeleteCache", grpcWeb$8.MethodType.UNARY, controlclient_pb._DeleteCacheRequest, controlclient_pb._DeleteCacheResponse, (d) => d.serializeBinary(), controlclient_pb._DeleteCacheResponse.deserializeBinary), this.methodDescriptorListCaches = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/ListCaches", grpcWeb$8.MethodType.UNARY, controlclient_pb._ListCachesRequest, controlclient_pb._ListCachesResponse, (d) => d.serializeBinary(), controlclient_pb._ListCachesResponse.deserializeBinary), this.methodDescriptorFlushCache = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/FlushCache", grpcWeb$8.MethodType.UNARY, controlclient_pb._FlushCacheRequest, controlclient_pb._FlushCacheResponse, (d) => d.serializeBinary(), controlclient_pb._FlushCacheResponse.deserializeBinary), this.methodDescriptorCreateSigningKey = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/CreateSigningKey", grpcWeb$8.MethodType.UNARY, controlclient_pb._CreateSigningKeyRequest, controlclient_pb._CreateSigningKeyResponse, (d) => d.serializeBinary(), controlclient_pb._CreateSigningKeyResponse.deserializeBinary), this.methodDescriptorRevokeSigningKey = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/RevokeSigningKey", grpcWeb$8.MethodType.UNARY, controlclient_pb._RevokeSigningKeyRequest, controlclient_pb._RevokeSigningKeyResponse, (d) => d.serializeBinary(), controlclient_pb._RevokeSigningKeyResponse.deserializeBinary), this.methodDescriptorListSigningKeys = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/ListSigningKeys", grpcWeb$8.MethodType.UNARY, controlclient_pb._ListSigningKeysRequest, controlclient_pb._ListSigningKeysResponse, (d) => d.serializeBinary(), controlclient_pb._ListSigningKeysResponse.deserializeBinary), this.methodDescriptorCreateIndex = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/CreateIndex", grpcWeb$8.MethodType.UNARY, controlclient_pb._CreateIndexRequest, controlclient_pb._CreateIndexResponse, (d) => d.serializeBinary(), controlclient_pb._CreateIndexResponse.deserializeBinary), this.methodDescriptorDeleteIndex = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/DeleteIndex", grpcWeb$8.MethodType.UNARY, controlclient_pb._DeleteIndexRequest, controlclient_pb._DeleteIndexResponse, (d) => d.serializeBinary(), controlclient_pb._DeleteIndexResponse.deserializeBinary), this.methodDescriptorListIndexes = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/ListIndexes", grpcWeb$8.MethodType.UNARY, controlclient_pb._ListIndexesRequest, controlclient_pb._ListIndexesResponse, (d) => d.serializeBinary(), controlclient_pb._ListIndexesResponse.deserializeBinary), this.methodDescriptorCreateStore = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/CreateStore", grpcWeb$8.MethodType.UNARY, controlclient_pb._CreateStoreRequest, controlclient_pb._CreateStoreResponse, (d) => d.serializeBinary(), controlclient_pb._CreateStoreResponse.deserializeBinary), this.methodDescriptorDeleteStore = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/DeleteStore", grpcWeb$8.MethodType.UNARY, controlclient_pb._DeleteStoreRequest, controlclient_pb._DeleteStoreResponse, (d) => d.serializeBinary(), controlclient_pb._DeleteStoreResponse.deserializeBinary), this.methodDescriptorListStores = new grpcWeb$8.MethodDescriptor("/control_client.ScsControl/ListStores", grpcWeb$8.MethodType.UNARY, controlclient_pb._ListStoresRequest, controlclient_pb._ListStoresResponse, (d) => d.serializeBinary(), controlclient_pb._ListStoresResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$8.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  createCache(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/CreateCache", s, h || {}, this.methodDescriptorCreateCache, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/CreateCache", s, h || {}, this.methodDescriptorCreateCache);
  }
  deleteCache(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/DeleteCache", s, h || {}, this.methodDescriptorDeleteCache, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/DeleteCache", s, h || {}, this.methodDescriptorDeleteCache);
  }
  listCaches(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/ListCaches", s, h || {}, this.methodDescriptorListCaches, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/ListCaches", s, h || {}, this.methodDescriptorListCaches);
  }
  flushCache(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/FlushCache", s, h || {}, this.methodDescriptorFlushCache, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/FlushCache", s, h || {}, this.methodDescriptorFlushCache);
  }
  createSigningKey(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/CreateSigningKey", s, h || {}, this.methodDescriptorCreateSigningKey, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/CreateSigningKey", s, h || {}, this.methodDescriptorCreateSigningKey);
  }
  revokeSigningKey(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/RevokeSigningKey", s, h || {}, this.methodDescriptorRevokeSigningKey, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/RevokeSigningKey", s, h || {}, this.methodDescriptorRevokeSigningKey);
  }
  listSigningKeys(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/ListSigningKeys", s, h || {}, this.methodDescriptorListSigningKeys, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/ListSigningKeys", s, h || {}, this.methodDescriptorListSigningKeys);
  }
  createIndex(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/CreateIndex", s, h || {}, this.methodDescriptorCreateIndex, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/CreateIndex", s, h || {}, this.methodDescriptorCreateIndex);
  }
  deleteIndex(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/DeleteIndex", s, h || {}, this.methodDescriptorDeleteIndex, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/DeleteIndex", s, h || {}, this.methodDescriptorDeleteIndex);
  }
  listIndexes(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/ListIndexes", s, h || {}, this.methodDescriptorListIndexes, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/ListIndexes", s, h || {}, this.methodDescriptorListIndexes);
  }
  createStore(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/CreateStore", s, h || {}, this.methodDescriptorCreateStore, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/CreateStore", s, h || {}, this.methodDescriptorCreateStore);
  }
  deleteStore(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/DeleteStore", s, h || {}, this.methodDescriptorDeleteStore, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/DeleteStore", s, h || {}, this.methodDescriptorDeleteStore);
  }
  listStores(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/control_client.ScsControl/ListStores", s, h || {}, this.methodDescriptorListStores, c) : this.client_.unaryCall(this.hostname_ + "/control_client.ScsControl/ListStores", s, h || {}, this.methodDescriptorListStores);
  }
}
ControlclientServiceClientPb.ScsControlClient = ScsControlClient;
var AuthServiceClientPb = {}, auth_pb$1 = {}, permissionmessages_pb = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("CacheRole", null, c), h.exportSymbol("ExplicitPermissions", null, c), h.exportSymbol("Permissions", null, c), h.exportSymbol("Permissions.KindCase", null, c), h.exportSymbol("PermissionsType", null, c), h.exportSymbol("PermissionsType.All", null, c), h.exportSymbol("PermissionsType.CacheItemSelector", null, c), h.exportSymbol("PermissionsType.CacheItemSelector.KindCase", null, c), h.exportSymbol("PermissionsType.CachePermissions", null, c), h.exportSymbol("PermissionsType.CachePermissions.CacheCase", null, c), h.exportSymbol("PermissionsType.CachePermissions.CacheItemCase", null, c), h.exportSymbol("PermissionsType.CacheSelector", null, c), h.exportSymbol("PermissionsType.CacheSelector.KindCase", null, c), h.exportSymbol("PermissionsType.KindCase", null, c), h.exportSymbol("PermissionsType.TopicPermissions", null, c), h.exportSymbol("PermissionsType.TopicPermissions.CacheCase", null, c), h.exportSymbol("PermissionsType.TopicPermissions.TopicCase", null, c), h.exportSymbol("PermissionsType.TopicSelector", null, c), h.exportSymbol("PermissionsType.TopicSelector.KindCase", null, c), h.exportSymbol("SuperUserPermissions", null, c), h.exportSymbol("TopicRole", null, c), c.Permissions = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.Permissions.oneofGroups_);
  }, h.inherits(c.Permissions, s.Message), h.DEBUG && !COMPILED && (c.Permissions.displayName = "proto.Permissions"), c.ExplicitPermissions = function(d) {
    s.Message.initialize(this, d, 0, -1, c.ExplicitPermissions.repeatedFields_, null);
  }, h.inherits(c.ExplicitPermissions, s.Message), h.DEBUG && !COMPILED && (c.ExplicitPermissions.displayName = "proto.ExplicitPermissions"), c.PermissionsType = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.PermissionsType.oneofGroups_);
  }, h.inherits(c.PermissionsType, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.displayName = "proto.PermissionsType"), c.PermissionsType.All = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c.PermissionsType.All, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.All.displayName = "proto.PermissionsType.All"), c.PermissionsType.CacheSelector = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.PermissionsType.CacheSelector.oneofGroups_);
  }, h.inherits(c.PermissionsType.CacheSelector, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.CacheSelector.displayName = "proto.PermissionsType.CacheSelector"), c.PermissionsType.CacheItemSelector = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.PermissionsType.CacheItemSelector.oneofGroups_);
  }, h.inherits(c.PermissionsType.CacheItemSelector, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.CacheItemSelector.displayName = "proto.PermissionsType.CacheItemSelector"), c.PermissionsType.CachePermissions = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.PermissionsType.CachePermissions.oneofGroups_);
  }, h.inherits(c.PermissionsType.CachePermissions, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.CachePermissions.displayName = "proto.PermissionsType.CachePermissions"), c.PermissionsType.TopicSelector = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.PermissionsType.TopicSelector.oneofGroups_);
  }, h.inherits(c.PermissionsType.TopicSelector, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.TopicSelector.displayName = "proto.PermissionsType.TopicSelector"), c.PermissionsType.TopicPermissions = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c.PermissionsType.TopicPermissions.oneofGroups_);
  }, h.inherits(c.PermissionsType.TopicPermissions, s.Message), h.DEBUG && !COMPILED && (c.PermissionsType.TopicPermissions.displayName = "proto.PermissionsType.TopicPermissions"), c.Permissions.oneofGroups_ = [[1, 2]], c.Permissions.KindCase = {
    KIND_NOT_SET: 0,
    SUPER_USER: 1,
    EXPLICIT: 2
  }, c.Permissions.prototype.getKindCase = function() {
    return (
      /** @type {proto.Permissions.KindCase} */
      s.Message.computeOneofCase(this, c.Permissions.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.Permissions.prototype.toObject = function(d) {
    return c.Permissions.toObject(d, this);
  }, c.Permissions.toObject = function(d, l) {
    var g, f = {
      superUser: s.Message.getFieldWithDefault(l, 1, 0),
      explicit: (g = l.getExplicit()) && c.ExplicitPermissions.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c.Permissions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.Permissions();
    return c.Permissions.deserializeBinaryFromReader(g, l);
  }, c.Permissions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!proto.SuperUserPermissions} */
            l.readEnum()
          );
          d.setSuperUser(f);
          break;
        case 2:
          var f = new c.ExplicitPermissions();
          l.readMessage(f, c.ExplicitPermissions.deserializeBinaryFromReader), d.setExplicit(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.Permissions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.Permissions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.Permissions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {!proto.SuperUserPermissions} */
    s.Message.getField(d, 1), g != null && l.writeEnum(
      1,
      g
    ), g = d.getExplicit(), g != null && l.writeMessage(
      2,
      g,
      c.ExplicitPermissions.serializeBinaryToWriter
    );
  }, c.Permissions.prototype.getSuperUser = function() {
    return (
      /** @type {!proto.SuperUserPermissions} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c.Permissions.prototype.setSuperUser = function(d) {
    return s.Message.setOneofField(this, 1, c.Permissions.oneofGroups_[0], d);
  }, c.Permissions.prototype.clearSuperUser = function() {
    return s.Message.setOneofField(this, 1, c.Permissions.oneofGroups_[0], void 0);
  }, c.Permissions.prototype.hasSuperUser = function() {
    return s.Message.getField(this, 1) != null;
  }, c.Permissions.prototype.getExplicit = function() {
    return (
      /** @type{?proto.ExplicitPermissions} */
      s.Message.getWrapperField(this, c.ExplicitPermissions, 2)
    );
  }, c.Permissions.prototype.setExplicit = function(d) {
    return s.Message.setOneofWrapperField(this, 2, c.Permissions.oneofGroups_[0], d);
  }, c.Permissions.prototype.clearExplicit = function() {
    return this.setExplicit(void 0);
  }, c.Permissions.prototype.hasExplicit = function() {
    return s.Message.getField(this, 2) != null;
  }, c.ExplicitPermissions.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c.ExplicitPermissions.prototype.toObject = function(d) {
    return c.ExplicitPermissions.toObject(d, this);
  }, c.ExplicitPermissions.toObject = function(d, l) {
    var g = {
      permissionsList: s.Message.toObjectList(
        l.getPermissionsList(),
        c.PermissionsType.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.ExplicitPermissions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.ExplicitPermissions();
    return c.ExplicitPermissions.deserializeBinaryFromReader(g, l);
  }, c.ExplicitPermissions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c.PermissionsType();
          l.readMessage(f, c.PermissionsType.deserializeBinaryFromReader), d.addPermissions(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.ExplicitPermissions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.ExplicitPermissions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.ExplicitPermissions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getPermissionsList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c.PermissionsType.serializeBinaryToWriter
    );
  }, c.ExplicitPermissions.prototype.getPermissionsList = function() {
    return (
      /** @type{!Array<!proto.PermissionsType>} */
      s.Message.getRepeatedWrapperField(this, c.PermissionsType, 1)
    );
  }, c.ExplicitPermissions.prototype.setPermissionsList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c.ExplicitPermissions.prototype.addPermissions = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c.PermissionsType, l);
  }, c.ExplicitPermissions.prototype.clearPermissionsList = function() {
    return this.setPermissionsList([]);
  }, c.PermissionsType.oneofGroups_ = [[1, 2]], c.PermissionsType.KindCase = {
    KIND_NOT_SET: 0,
    CACHE_PERMISSIONS: 1,
    TOPIC_PERMISSIONS: 2
  }, c.PermissionsType.prototype.getKindCase = function() {
    return (
      /** @type {proto.PermissionsType.KindCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.prototype.toObject = function(d) {
    return c.PermissionsType.toObject(d, this);
  }, c.PermissionsType.toObject = function(d, l) {
    var g, f = {
      cachePermissions: (g = l.getCachePermissions()) && c.PermissionsType.CachePermissions.toObject(d, g),
      topicPermissions: (g = l.getTopicPermissions()) && c.PermissionsType.TopicPermissions.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c.PermissionsType.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType();
    return c.PermissionsType.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c.PermissionsType.CachePermissions();
          l.readMessage(f, c.PermissionsType.CachePermissions.deserializeBinaryFromReader), d.setCachePermissions(f);
          break;
        case 2:
          var f = new c.PermissionsType.TopicPermissions();
          l.readMessage(f, c.PermissionsType.TopicPermissions.deserializeBinaryFromReader), d.setTopicPermissions(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCachePermissions(), g != null && l.writeMessage(
      1,
      g,
      c.PermissionsType.CachePermissions.serializeBinaryToWriter
    ), g = d.getTopicPermissions(), g != null && l.writeMessage(
      2,
      g,
      c.PermissionsType.TopicPermissions.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.All.prototype.toObject = function(d) {
    return c.PermissionsType.All.toObject(d, this);
  }, c.PermissionsType.All.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c.PermissionsType.All.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType.All();
    return c.PermissionsType.All.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.All.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.All.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.All.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.All.serializeBinaryToWriter = function(d, l) {
  }, c.PermissionsType.CacheSelector.oneofGroups_ = [[1]], c.PermissionsType.CacheSelector.KindCase = {
    KIND_NOT_SET: 0,
    CACHE_NAME: 1
  }, c.PermissionsType.CacheSelector.prototype.getKindCase = function() {
    return (
      /** @type {proto.PermissionsType.CacheSelector.KindCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.CacheSelector.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.CacheSelector.prototype.toObject = function(d) {
    return c.PermissionsType.CacheSelector.toObject(d, this);
  }, c.PermissionsType.CacheSelector.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.PermissionsType.CacheSelector.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType.CacheSelector();
    return c.PermissionsType.CacheSelector.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.CacheSelector.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.CacheSelector.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.CacheSelector.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.CacheSelector.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    );
  }, c.PermissionsType.CacheSelector.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.PermissionsType.CacheSelector.prototype.setCacheName = function(d) {
    return s.Message.setOneofField(this, 1, c.PermissionsType.CacheSelector.oneofGroups_[0], d);
  }, c.PermissionsType.CacheSelector.prototype.clearCacheName = function() {
    return s.Message.setOneofField(this, 1, c.PermissionsType.CacheSelector.oneofGroups_[0], void 0);
  }, c.PermissionsType.CacheSelector.prototype.hasCacheName = function() {
    return s.Message.getField(this, 1) != null;
  }, c.PermissionsType.CacheItemSelector.oneofGroups_ = [[1, 2]], c.PermissionsType.CacheItemSelector.KindCase = {
    KIND_NOT_SET: 0,
    KEY: 1,
    KEY_PREFIX: 2
  }, c.PermissionsType.CacheItemSelector.prototype.getKindCase = function() {
    return (
      /** @type {proto.PermissionsType.CacheItemSelector.KindCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.CacheItemSelector.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.CacheItemSelector.prototype.toObject = function(d) {
    return c.PermissionsType.CacheItemSelector.toObject(d, this);
  }, c.PermissionsType.CacheItemSelector.toObject = function(d, l) {
    var g = {
      key: l.getKey_asB64(),
      keyPrefix: l.getKeyPrefix_asB64()
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.PermissionsType.CacheItemSelector.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType.CacheItemSelector();
    return c.PermissionsType.CacheItemSelector.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.CacheItemSelector.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setKey(f);
          break;
        case 2:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setKeyPrefix(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.CacheItemSelector.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.CacheItemSelector.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.CacheItemSelector.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {!(string|Uint8Array)} */
    s.Message.getField(d, 1), g != null && l.writeBytes(
      1,
      g
    ), g = /** @type {!(string|Uint8Array)} */
    s.Message.getField(d, 2), g != null && l.writeBytes(
      2,
      g
    );
  }, c.PermissionsType.CacheItemSelector.prototype.getKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.PermissionsType.CacheItemSelector.prototype.getKey_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getKey()
      )
    );
  }, c.PermissionsType.CacheItemSelector.prototype.getKey_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getKey()
      )
    );
  }, c.PermissionsType.CacheItemSelector.prototype.setKey = function(d) {
    return s.Message.setOneofField(this, 1, c.PermissionsType.CacheItemSelector.oneofGroups_[0], d);
  }, c.PermissionsType.CacheItemSelector.prototype.clearKey = function() {
    return s.Message.setOneofField(this, 1, c.PermissionsType.CacheItemSelector.oneofGroups_[0], void 0);
  }, c.PermissionsType.CacheItemSelector.prototype.hasKey = function() {
    return s.Message.getField(this, 1) != null;
  }, c.PermissionsType.CacheItemSelector.prototype.getKeyPrefix = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c.PermissionsType.CacheItemSelector.prototype.getKeyPrefix_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getKeyPrefix()
      )
    );
  }, c.PermissionsType.CacheItemSelector.prototype.getKeyPrefix_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getKeyPrefix()
      )
    );
  }, c.PermissionsType.CacheItemSelector.prototype.setKeyPrefix = function(d) {
    return s.Message.setOneofField(this, 2, c.PermissionsType.CacheItemSelector.oneofGroups_[0], d);
  }, c.PermissionsType.CacheItemSelector.prototype.clearKeyPrefix = function() {
    return s.Message.setOneofField(this, 2, c.PermissionsType.CacheItemSelector.oneofGroups_[0], void 0);
  }, c.PermissionsType.CacheItemSelector.prototype.hasKeyPrefix = function() {
    return s.Message.getField(this, 2) != null;
  }, c.PermissionsType.CachePermissions.oneofGroups_ = [[2, 3], [4, 5]], c.PermissionsType.CachePermissions.CacheCase = {
    CACHE_NOT_SET: 0,
    ALL_CACHES: 2,
    CACHE_SELECTOR: 3
  }, c.PermissionsType.CachePermissions.prototype.getCacheCase = function() {
    return (
      /** @type {proto.PermissionsType.CachePermissions.CacheCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.CachePermissions.oneofGroups_[0])
    );
  }, c.PermissionsType.CachePermissions.CacheItemCase = {
    CACHE_ITEM_NOT_SET: 0,
    ALL_ITEMS: 4,
    ITEM_SELECTOR: 5
  }, c.PermissionsType.CachePermissions.prototype.getCacheItemCase = function() {
    return (
      /** @type {proto.PermissionsType.CachePermissions.CacheItemCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.CachePermissions.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.CachePermissions.prototype.toObject = function(d) {
    return c.PermissionsType.CachePermissions.toObject(d, this);
  }, c.PermissionsType.CachePermissions.toObject = function(d, l) {
    var g, f = {
      role: s.Message.getFieldWithDefault(l, 1, 0),
      allCaches: (g = l.getAllCaches()) && c.PermissionsType.All.toObject(d, g),
      cacheSelector: (g = l.getCacheSelector()) && c.PermissionsType.CacheSelector.toObject(d, g),
      allItems: (g = l.getAllItems()) && c.PermissionsType.All.toObject(d, g),
      itemSelector: (g = l.getItemSelector()) && c.PermissionsType.CacheItemSelector.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c.PermissionsType.CachePermissions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType.CachePermissions();
    return c.PermissionsType.CachePermissions.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.CachePermissions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!proto.CacheRole} */
            l.readEnum()
          );
          d.setRole(f);
          break;
        case 2:
          var f = new c.PermissionsType.All();
          l.readMessage(f, c.PermissionsType.All.deserializeBinaryFromReader), d.setAllCaches(f);
          break;
        case 3:
          var f = new c.PermissionsType.CacheSelector();
          l.readMessage(f, c.PermissionsType.CacheSelector.deserializeBinaryFromReader), d.setCacheSelector(f);
          break;
        case 4:
          var f = new c.PermissionsType.All();
          l.readMessage(f, c.PermissionsType.All.deserializeBinaryFromReader), d.setAllItems(f);
          break;
        case 5:
          var f = new c.PermissionsType.CacheItemSelector();
          l.readMessage(f, c.PermissionsType.CacheItemSelector.deserializeBinaryFromReader), d.setItemSelector(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.CachePermissions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.CachePermissions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.CachePermissions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getRole(), g !== 0 && l.writeEnum(
      1,
      g
    ), g = d.getAllCaches(), g != null && l.writeMessage(
      2,
      g,
      c.PermissionsType.All.serializeBinaryToWriter
    ), g = d.getCacheSelector(), g != null && l.writeMessage(
      3,
      g,
      c.PermissionsType.CacheSelector.serializeBinaryToWriter
    ), g = d.getAllItems(), g != null && l.writeMessage(
      4,
      g,
      c.PermissionsType.All.serializeBinaryToWriter
    ), g = d.getItemSelector(), g != null && l.writeMessage(
      5,
      g,
      c.PermissionsType.CacheItemSelector.serializeBinaryToWriter
    );
  }, c.PermissionsType.CachePermissions.prototype.getRole = function() {
    return (
      /** @type {!proto.CacheRole} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c.PermissionsType.CachePermissions.prototype.setRole = function(d) {
    return s.Message.setProto3EnumField(this, 1, d);
  }, c.PermissionsType.CachePermissions.prototype.getAllCaches = function() {
    return (
      /** @type{?proto.PermissionsType.All} */
      s.Message.getWrapperField(this, c.PermissionsType.All, 2)
    );
  }, c.PermissionsType.CachePermissions.prototype.setAllCaches = function(d) {
    return s.Message.setOneofWrapperField(this, 2, c.PermissionsType.CachePermissions.oneofGroups_[0], d);
  }, c.PermissionsType.CachePermissions.prototype.clearAllCaches = function() {
    return this.setAllCaches(void 0);
  }, c.PermissionsType.CachePermissions.prototype.hasAllCaches = function() {
    return s.Message.getField(this, 2) != null;
  }, c.PermissionsType.CachePermissions.prototype.getCacheSelector = function() {
    return (
      /** @type{?proto.PermissionsType.CacheSelector} */
      s.Message.getWrapperField(this, c.PermissionsType.CacheSelector, 3)
    );
  }, c.PermissionsType.CachePermissions.prototype.setCacheSelector = function(d) {
    return s.Message.setOneofWrapperField(this, 3, c.PermissionsType.CachePermissions.oneofGroups_[0], d);
  }, c.PermissionsType.CachePermissions.prototype.clearCacheSelector = function() {
    return this.setCacheSelector(void 0);
  }, c.PermissionsType.CachePermissions.prototype.hasCacheSelector = function() {
    return s.Message.getField(this, 3) != null;
  }, c.PermissionsType.CachePermissions.prototype.getAllItems = function() {
    return (
      /** @type{?proto.PermissionsType.All} */
      s.Message.getWrapperField(this, c.PermissionsType.All, 4)
    );
  }, c.PermissionsType.CachePermissions.prototype.setAllItems = function(d) {
    return s.Message.setOneofWrapperField(this, 4, c.PermissionsType.CachePermissions.oneofGroups_[1], d);
  }, c.PermissionsType.CachePermissions.prototype.clearAllItems = function() {
    return this.setAllItems(void 0);
  }, c.PermissionsType.CachePermissions.prototype.hasAllItems = function() {
    return s.Message.getField(this, 4) != null;
  }, c.PermissionsType.CachePermissions.prototype.getItemSelector = function() {
    return (
      /** @type{?proto.PermissionsType.CacheItemSelector} */
      s.Message.getWrapperField(this, c.PermissionsType.CacheItemSelector, 5)
    );
  }, c.PermissionsType.CachePermissions.prototype.setItemSelector = function(d) {
    return s.Message.setOneofWrapperField(this, 5, c.PermissionsType.CachePermissions.oneofGroups_[1], d);
  }, c.PermissionsType.CachePermissions.prototype.clearItemSelector = function() {
    return this.setItemSelector(void 0);
  }, c.PermissionsType.CachePermissions.prototype.hasItemSelector = function() {
    return s.Message.getField(this, 5) != null;
  }, c.PermissionsType.TopicSelector.oneofGroups_ = [[1, 2]], c.PermissionsType.TopicSelector.KindCase = {
    KIND_NOT_SET: 0,
    TOPIC_NAME: 1,
    TOPIC_NAME_PREFIX: 2
  }, c.PermissionsType.TopicSelector.prototype.getKindCase = function() {
    return (
      /** @type {proto.PermissionsType.TopicSelector.KindCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.TopicSelector.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.TopicSelector.prototype.toObject = function(d) {
    return c.PermissionsType.TopicSelector.toObject(d, this);
  }, c.PermissionsType.TopicSelector.toObject = function(d, l) {
    var g = {
      topicName: s.Message.getFieldWithDefault(l, 1, ""),
      topicNamePrefix: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c.PermissionsType.TopicSelector.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType.TopicSelector();
    return c.PermissionsType.TopicSelector.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.TopicSelector.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setTopicName(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setTopicNamePrefix(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.TopicSelector.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.TopicSelector.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.TopicSelector.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 2), g != null && l.writeString(
      2,
      g
    );
  }, c.PermissionsType.TopicSelector.prototype.getTopicName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c.PermissionsType.TopicSelector.prototype.setTopicName = function(d) {
    return s.Message.setOneofField(this, 1, c.PermissionsType.TopicSelector.oneofGroups_[0], d);
  }, c.PermissionsType.TopicSelector.prototype.clearTopicName = function() {
    return s.Message.setOneofField(this, 1, c.PermissionsType.TopicSelector.oneofGroups_[0], void 0);
  }, c.PermissionsType.TopicSelector.prototype.hasTopicName = function() {
    return s.Message.getField(this, 1) != null;
  }, c.PermissionsType.TopicSelector.prototype.getTopicNamePrefix = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c.PermissionsType.TopicSelector.prototype.setTopicNamePrefix = function(d) {
    return s.Message.setOneofField(this, 2, c.PermissionsType.TopicSelector.oneofGroups_[0], d);
  }, c.PermissionsType.TopicSelector.prototype.clearTopicNamePrefix = function() {
    return s.Message.setOneofField(this, 2, c.PermissionsType.TopicSelector.oneofGroups_[0], void 0);
  }, c.PermissionsType.TopicSelector.prototype.hasTopicNamePrefix = function() {
    return s.Message.getField(this, 2) != null;
  }, c.PermissionsType.TopicPermissions.oneofGroups_ = [[2, 3], [4, 5]], c.PermissionsType.TopicPermissions.CacheCase = {
    CACHE_NOT_SET: 0,
    ALL_CACHES: 2,
    CACHE_SELECTOR: 3
  }, c.PermissionsType.TopicPermissions.prototype.getCacheCase = function() {
    return (
      /** @type {proto.PermissionsType.TopicPermissions.CacheCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.TopicPermissions.oneofGroups_[0])
    );
  }, c.PermissionsType.TopicPermissions.TopicCase = {
    TOPIC_NOT_SET: 0,
    ALL_TOPICS: 4,
    TOPIC_SELECTOR: 5
  }, c.PermissionsType.TopicPermissions.prototype.getTopicCase = function() {
    return (
      /** @type {proto.PermissionsType.TopicPermissions.TopicCase} */
      s.Message.computeOneofCase(this, c.PermissionsType.TopicPermissions.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c.PermissionsType.TopicPermissions.prototype.toObject = function(d) {
    return c.PermissionsType.TopicPermissions.toObject(d, this);
  }, c.PermissionsType.TopicPermissions.toObject = function(d, l) {
    var g, f = {
      role: s.Message.getFieldWithDefault(l, 1, 0),
      allCaches: (g = l.getAllCaches()) && c.PermissionsType.All.toObject(d, g),
      cacheSelector: (g = l.getCacheSelector()) && c.PermissionsType.CacheSelector.toObject(d, g),
      allTopics: (g = l.getAllTopics()) && c.PermissionsType.All.toObject(d, g),
      topicSelector: (g = l.getTopicSelector()) && c.PermissionsType.TopicSelector.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c.PermissionsType.TopicPermissions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c.PermissionsType.TopicPermissions();
    return c.PermissionsType.TopicPermissions.deserializeBinaryFromReader(g, l);
  }, c.PermissionsType.TopicPermissions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!proto.TopicRole} */
            l.readEnum()
          );
          d.setRole(f);
          break;
        case 2:
          var f = new c.PermissionsType.All();
          l.readMessage(f, c.PermissionsType.All.deserializeBinaryFromReader), d.setAllCaches(f);
          break;
        case 3:
          var f = new c.PermissionsType.CacheSelector();
          l.readMessage(f, c.PermissionsType.CacheSelector.deserializeBinaryFromReader), d.setCacheSelector(f);
          break;
        case 4:
          var f = new c.PermissionsType.All();
          l.readMessage(f, c.PermissionsType.All.deserializeBinaryFromReader), d.setAllTopics(f);
          break;
        case 5:
          var f = new c.PermissionsType.TopicSelector();
          l.readMessage(f, c.PermissionsType.TopicSelector.deserializeBinaryFromReader), d.setTopicSelector(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c.PermissionsType.TopicPermissions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c.PermissionsType.TopicPermissions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c.PermissionsType.TopicPermissions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getRole(), g !== 0 && l.writeEnum(
      1,
      g
    ), g = d.getAllCaches(), g != null && l.writeMessage(
      2,
      g,
      c.PermissionsType.All.serializeBinaryToWriter
    ), g = d.getCacheSelector(), g != null && l.writeMessage(
      3,
      g,
      c.PermissionsType.CacheSelector.serializeBinaryToWriter
    ), g = d.getAllTopics(), g != null && l.writeMessage(
      4,
      g,
      c.PermissionsType.All.serializeBinaryToWriter
    ), g = d.getTopicSelector(), g != null && l.writeMessage(
      5,
      g,
      c.PermissionsType.TopicSelector.serializeBinaryToWriter
    );
  }, c.PermissionsType.TopicPermissions.prototype.getRole = function() {
    return (
      /** @type {!proto.TopicRole} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c.PermissionsType.TopicPermissions.prototype.setRole = function(d) {
    return s.Message.setProto3EnumField(this, 1, d);
  }, c.PermissionsType.TopicPermissions.prototype.getAllCaches = function() {
    return (
      /** @type{?proto.PermissionsType.All} */
      s.Message.getWrapperField(this, c.PermissionsType.All, 2)
    );
  }, c.PermissionsType.TopicPermissions.prototype.setAllCaches = function(d) {
    return s.Message.setOneofWrapperField(this, 2, c.PermissionsType.TopicPermissions.oneofGroups_[0], d);
  }, c.PermissionsType.TopicPermissions.prototype.clearAllCaches = function() {
    return this.setAllCaches(void 0);
  }, c.PermissionsType.TopicPermissions.prototype.hasAllCaches = function() {
    return s.Message.getField(this, 2) != null;
  }, c.PermissionsType.TopicPermissions.prototype.getCacheSelector = function() {
    return (
      /** @type{?proto.PermissionsType.CacheSelector} */
      s.Message.getWrapperField(this, c.PermissionsType.CacheSelector, 3)
    );
  }, c.PermissionsType.TopicPermissions.prototype.setCacheSelector = function(d) {
    return s.Message.setOneofWrapperField(this, 3, c.PermissionsType.TopicPermissions.oneofGroups_[0], d);
  }, c.PermissionsType.TopicPermissions.prototype.clearCacheSelector = function() {
    return this.setCacheSelector(void 0);
  }, c.PermissionsType.TopicPermissions.prototype.hasCacheSelector = function() {
    return s.Message.getField(this, 3) != null;
  }, c.PermissionsType.TopicPermissions.prototype.getAllTopics = function() {
    return (
      /** @type{?proto.PermissionsType.All} */
      s.Message.getWrapperField(this, c.PermissionsType.All, 4)
    );
  }, c.PermissionsType.TopicPermissions.prototype.setAllTopics = function(d) {
    return s.Message.setOneofWrapperField(this, 4, c.PermissionsType.TopicPermissions.oneofGroups_[1], d);
  }, c.PermissionsType.TopicPermissions.prototype.clearAllTopics = function() {
    return this.setAllTopics(void 0);
  }, c.PermissionsType.TopicPermissions.prototype.hasAllTopics = function() {
    return s.Message.getField(this, 4) != null;
  }, c.PermissionsType.TopicPermissions.prototype.getTopicSelector = function() {
    return (
      /** @type{?proto.PermissionsType.TopicSelector} */
      s.Message.getWrapperField(this, c.PermissionsType.TopicSelector, 5)
    );
  }, c.PermissionsType.TopicPermissions.prototype.setTopicSelector = function(d) {
    return s.Message.setOneofWrapperField(this, 5, c.PermissionsType.TopicPermissions.oneofGroups_[1], d);
  }, c.PermissionsType.TopicPermissions.prototype.clearTopicSelector = function() {
    return this.setTopicSelector(void 0);
  }, c.PermissionsType.TopicPermissions.prototype.hasTopicSelector = function() {
    return s.Message.getField(this, 5) != null;
  }, c.PermissionsType.prototype.getCachePermissions = function() {
    return (
      /** @type{?proto.PermissionsType.CachePermissions} */
      s.Message.getWrapperField(this, c.PermissionsType.CachePermissions, 1)
    );
  }, c.PermissionsType.prototype.setCachePermissions = function(d) {
    return s.Message.setOneofWrapperField(this, 1, c.PermissionsType.oneofGroups_[0], d);
  }, c.PermissionsType.prototype.clearCachePermissions = function() {
    return this.setCachePermissions(void 0);
  }, c.PermissionsType.prototype.hasCachePermissions = function() {
    return s.Message.getField(this, 1) != null;
  }, c.PermissionsType.prototype.getTopicPermissions = function() {
    return (
      /** @type{?proto.PermissionsType.TopicPermissions} */
      s.Message.getWrapperField(this, c.PermissionsType.TopicPermissions, 2)
    );
  }, c.PermissionsType.prototype.setTopicPermissions = function(d) {
    return s.Message.setOneofWrapperField(this, 2, c.PermissionsType.oneofGroups_[0], d);
  }, c.PermissionsType.prototype.clearTopicPermissions = function() {
    return this.setTopicPermissions(void 0);
  }, c.PermissionsType.prototype.hasTopicPermissions = function() {
    return s.Message.getField(this, 2) != null;
  }, c.CacheRole = {
    CACHEPERMITNONE: 0,
    CACHEREADWRITE: 1,
    CACHEREADONLY: 2,
    CACHEWRITEONLY: 3
  }, c.TopicRole = {
    TOPICPERMITNONE: 0,
    TOPICREADWRITE: 1,
    TOPICREADONLY: 2,
    TOPICWRITEONLY: 3
  }, c.SuperUserPermissions = {
    SUPERUSER: 0
  }, h.object.extend(p, c);
})(permissionmessages_pb);
(function(p) {
  var s = googleProtobuf, h = s, c = {}, d = permissionmessages_pb;
  h.object.extend(c, d), h.exportSymbol("_GenerateApiTokenRequest", null, c), h.exportSymbol("_GenerateApiTokenRequest.Expires", null, c), h.exportSymbol("_GenerateApiTokenRequest.ExpiryCase", null, c), h.exportSymbol("_GenerateApiTokenRequest.Never", null, c), h.exportSymbol("_GenerateApiTokenResponse", null, c), h.exportSymbol("_LoginRequest", null, c), h.exportSymbol("_LoginResponse", null, c), h.exportSymbol("_LoginResponse.DirectBrowser", null, c), h.exportSymbol("_LoginResponse.Error", null, c), h.exportSymbol("_LoginResponse.LoggedIn", null, c), h.exportSymbol("_LoginResponse.Message", null, c), h.exportSymbol("_LoginResponse.StateCase", null, c), h.exportSymbol("_RefreshApiTokenRequest", null, c), h.exportSymbol("_RefreshApiTokenResponse", null, c), c._LoginRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._LoginRequest, s.Message), h.DEBUG && !COMPILED && (c._LoginRequest.displayName = "proto._LoginRequest"), c._LoginResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._LoginResponse.oneofGroups_);
  }, h.inherits(c._LoginResponse, s.Message), h.DEBUG && !COMPILED && (c._LoginResponse.displayName = "proto._LoginResponse"), c._LoginResponse.LoggedIn = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._LoginResponse.LoggedIn, s.Message), h.DEBUG && !COMPILED && (c._LoginResponse.LoggedIn.displayName = "proto._LoginResponse.LoggedIn"), c._LoginResponse.Error = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._LoginResponse.Error, s.Message), h.DEBUG && !COMPILED && (c._LoginResponse.Error.displayName = "proto._LoginResponse.Error"), c._LoginResponse.DirectBrowser = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._LoginResponse.DirectBrowser, s.Message), h.DEBUG && !COMPILED && (c._LoginResponse.DirectBrowser.displayName = "proto._LoginResponse.DirectBrowser"), c._LoginResponse.Message = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._LoginResponse.Message, s.Message), h.DEBUG && !COMPILED && (c._LoginResponse.Message.displayName = "proto._LoginResponse.Message"), c._GenerateApiTokenRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._GenerateApiTokenRequest.oneofGroups_);
  }, h.inherits(c._GenerateApiTokenRequest, s.Message), h.DEBUG && !COMPILED && (c._GenerateApiTokenRequest.displayName = "proto._GenerateApiTokenRequest"), c._GenerateApiTokenRequest.Never = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GenerateApiTokenRequest.Never, s.Message), h.DEBUG && !COMPILED && (c._GenerateApiTokenRequest.Never.displayName = "proto._GenerateApiTokenRequest.Never"), c._GenerateApiTokenRequest.Expires = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GenerateApiTokenRequest.Expires, s.Message), h.DEBUG && !COMPILED && (c._GenerateApiTokenRequest.Expires.displayName = "proto._GenerateApiTokenRequest.Expires"), c._GenerateApiTokenResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GenerateApiTokenResponse, s.Message), h.DEBUG && !COMPILED && (c._GenerateApiTokenResponse.displayName = "proto._GenerateApiTokenResponse"), c._RefreshApiTokenRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._RefreshApiTokenRequest, s.Message), h.DEBUG && !COMPILED && (c._RefreshApiTokenRequest.displayName = "proto._RefreshApiTokenRequest"), c._RefreshApiTokenResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._RefreshApiTokenResponse, s.Message), h.DEBUG && !COMPILED && (c._RefreshApiTokenResponse.displayName = "proto._RefreshApiTokenResponse"), s.Message.GENERATE_TO_OBJECT && (c._LoginRequest.prototype.toObject = function(l) {
    return c._LoginRequest.toObject(l, this);
  }, c._LoginRequest.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._LoginRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._LoginRequest();
    return c._LoginRequest.deserializeBinaryFromReader(f, g);
  }, c._LoginRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._LoginRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._LoginRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._LoginRequest.serializeBinaryToWriter = function(l, g) {
  }, c._LoginResponse.oneofGroups_ = [[1, 2, 3, 4]], c._LoginResponse.StateCase = {
    STATE_NOT_SET: 0,
    DIRECT_BROWSER: 1,
    LOGGED_IN: 2,
    MESSAGE: 3,
    ERROR: 4
  }, c._LoginResponse.prototype.getStateCase = function() {
    return (
      /** @type {proto._LoginResponse.StateCase} */
      s.Message.computeOneofCase(this, c._LoginResponse.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._LoginResponse.prototype.toObject = function(l) {
    return c._LoginResponse.toObject(l, this);
  }, c._LoginResponse.toObject = function(l, g) {
    var f, _ = {
      directBrowser: (f = g.getDirectBrowser()) && c._LoginResponse.DirectBrowser.toObject(l, f),
      loggedIn: (f = g.getLoggedIn()) && c._LoginResponse.LoggedIn.toObject(l, f),
      message: (f = g.getMessage()) && c._LoginResponse.Message.toObject(l, f),
      error: (f = g.getError()) && c._LoginResponse.Error.toObject(l, f)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._LoginResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._LoginResponse();
    return c._LoginResponse.deserializeBinaryFromReader(f, g);
  }, c._LoginResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._LoginResponse.DirectBrowser();
          g.readMessage(_, c._LoginResponse.DirectBrowser.deserializeBinaryFromReader), l.setDirectBrowser(_);
          break;
        case 2:
          var _ = new c._LoginResponse.LoggedIn();
          g.readMessage(_, c._LoginResponse.LoggedIn.deserializeBinaryFromReader), l.setLoggedIn(_);
          break;
        case 3:
          var _ = new c._LoginResponse.Message();
          g.readMessage(_, c._LoginResponse.Message.deserializeBinaryFromReader), l.setMessage(_);
          break;
        case 4:
          var _ = new c._LoginResponse.Error();
          g.readMessage(_, c._LoginResponse.Error.deserializeBinaryFromReader), l.setError(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._LoginResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._LoginResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._LoginResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDirectBrowser(), f != null && g.writeMessage(
      1,
      f,
      c._LoginResponse.DirectBrowser.serializeBinaryToWriter
    ), f = l.getLoggedIn(), f != null && g.writeMessage(
      2,
      f,
      c._LoginResponse.LoggedIn.serializeBinaryToWriter
    ), f = l.getMessage(), f != null && g.writeMessage(
      3,
      f,
      c._LoginResponse.Message.serializeBinaryToWriter
    ), f = l.getError(), f != null && g.writeMessage(
      4,
      f,
      c._LoginResponse.Error.serializeBinaryToWriter
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._LoginResponse.LoggedIn.prototype.toObject = function(l) {
    return c._LoginResponse.LoggedIn.toObject(l, this);
  }, c._LoginResponse.LoggedIn.toObject = function(l, g) {
    var f = {
      sessionToken: s.Message.getFieldWithDefault(g, 1, ""),
      validForSeconds: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._LoginResponse.LoggedIn.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._LoginResponse.LoggedIn();
    return c._LoginResponse.LoggedIn.deserializeBinaryFromReader(f, g);
  }, c._LoginResponse.LoggedIn.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setSessionToken(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setValidForSeconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._LoginResponse.LoggedIn.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._LoginResponse.LoggedIn.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._LoginResponse.LoggedIn.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getSessionToken(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getValidForSeconds(), f !== 0 && g.writeUint32(
      2,
      f
    );
  }, c._LoginResponse.LoggedIn.prototype.getSessionToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._LoginResponse.LoggedIn.prototype.setSessionToken = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._LoginResponse.LoggedIn.prototype.getValidForSeconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._LoginResponse.LoggedIn.prototype.setValidForSeconds = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._LoginResponse.Error.prototype.toObject = function(l) {
    return c._LoginResponse.Error.toObject(l, this);
  }, c._LoginResponse.Error.toObject = function(l, g) {
    var f = {
      description: s.Message.getFieldWithDefault(g, 1, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._LoginResponse.Error.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._LoginResponse.Error();
    return c._LoginResponse.Error.deserializeBinaryFromReader(f, g);
  }, c._LoginResponse.Error.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setDescription(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._LoginResponse.Error.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._LoginResponse.Error.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._LoginResponse.Error.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getDescription(), f.length > 0 && g.writeString(
      1,
      f
    );
  }, c._LoginResponse.Error.prototype.getDescription = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._LoginResponse.Error.prototype.setDescription = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._LoginResponse.DirectBrowser.prototype.toObject = function(l) {
    return c._LoginResponse.DirectBrowser.toObject(l, this);
  }, c._LoginResponse.DirectBrowser.toObject = function(l, g) {
    var f = {
      url: s.Message.getFieldWithDefault(g, 1, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._LoginResponse.DirectBrowser.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._LoginResponse.DirectBrowser();
    return c._LoginResponse.DirectBrowser.deserializeBinaryFromReader(f, g);
  }, c._LoginResponse.DirectBrowser.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setUrl(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._LoginResponse.DirectBrowser.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._LoginResponse.DirectBrowser.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._LoginResponse.DirectBrowser.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getUrl(), f.length > 0 && g.writeString(
      1,
      f
    );
  }, c._LoginResponse.DirectBrowser.prototype.getUrl = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._LoginResponse.DirectBrowser.prototype.setUrl = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._LoginResponse.Message.prototype.toObject = function(l) {
    return c._LoginResponse.Message.toObject(l, this);
  }, c._LoginResponse.Message.toObject = function(l, g) {
    var f = {
      text: s.Message.getFieldWithDefault(g, 1, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._LoginResponse.Message.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._LoginResponse.Message();
    return c._LoginResponse.Message.deserializeBinaryFromReader(f, g);
  }, c._LoginResponse.Message.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setText(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._LoginResponse.Message.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._LoginResponse.Message.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._LoginResponse.Message.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getText(), f.length > 0 && g.writeString(
      1,
      f
    );
  }, c._LoginResponse.Message.prototype.getText = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._LoginResponse.Message.prototype.setText = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._LoginResponse.prototype.getDirectBrowser = function() {
    return (
      /** @type{?proto._LoginResponse.DirectBrowser} */
      s.Message.getWrapperField(this, c._LoginResponse.DirectBrowser, 1)
    );
  }, c._LoginResponse.prototype.setDirectBrowser = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._LoginResponse.oneofGroups_[0], l);
  }, c._LoginResponse.prototype.clearDirectBrowser = function() {
    return this.setDirectBrowser(void 0);
  }, c._LoginResponse.prototype.hasDirectBrowser = function() {
    return s.Message.getField(this, 1) != null;
  }, c._LoginResponse.prototype.getLoggedIn = function() {
    return (
      /** @type{?proto._LoginResponse.LoggedIn} */
      s.Message.getWrapperField(this, c._LoginResponse.LoggedIn, 2)
    );
  }, c._LoginResponse.prototype.setLoggedIn = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._LoginResponse.oneofGroups_[0], l);
  }, c._LoginResponse.prototype.clearLoggedIn = function() {
    return this.setLoggedIn(void 0);
  }, c._LoginResponse.prototype.hasLoggedIn = function() {
    return s.Message.getField(this, 2) != null;
  }, c._LoginResponse.prototype.getMessage = function() {
    return (
      /** @type{?proto._LoginResponse.Message} */
      s.Message.getWrapperField(this, c._LoginResponse.Message, 3)
    );
  }, c._LoginResponse.prototype.setMessage = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._LoginResponse.oneofGroups_[0], l);
  }, c._LoginResponse.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  }, c._LoginResponse.prototype.hasMessage = function() {
    return s.Message.getField(this, 3) != null;
  }, c._LoginResponse.prototype.getError = function() {
    return (
      /** @type{?proto._LoginResponse.Error} */
      s.Message.getWrapperField(this, c._LoginResponse.Error, 4)
    );
  }, c._LoginResponse.prototype.setError = function(l) {
    return s.Message.setOneofWrapperField(this, 4, c._LoginResponse.oneofGroups_[0], l);
  }, c._LoginResponse.prototype.clearError = function() {
    return this.setError(void 0);
  }, c._LoginResponse.prototype.hasError = function() {
    return s.Message.getField(this, 4) != null;
  }, c._GenerateApiTokenRequest.oneofGroups_ = [[1, 2]], c._GenerateApiTokenRequest.ExpiryCase = {
    EXPIRY_NOT_SET: 0,
    NEVER: 1,
    EXPIRES: 2
  }, c._GenerateApiTokenRequest.prototype.getExpiryCase = function() {
    return (
      /** @type {proto._GenerateApiTokenRequest.ExpiryCase} */
      s.Message.computeOneofCase(this, c._GenerateApiTokenRequest.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._GenerateApiTokenRequest.prototype.toObject = function(l) {
    return c._GenerateApiTokenRequest.toObject(l, this);
  }, c._GenerateApiTokenRequest.toObject = function(l, g) {
    var f, _ = {
      never: (f = g.getNever()) && c._GenerateApiTokenRequest.Never.toObject(l, f),
      expires: (f = g.getExpires()) && c._GenerateApiTokenRequest.Expires.toObject(l, f),
      authToken: s.Message.getFieldWithDefault(g, 3, ""),
      permissions: (f = g.getPermissions()) && d.Permissions.toObject(l, f),
      tokenId: s.Message.getFieldWithDefault(g, 5, ""),
      description: s.Message.getFieldWithDefault(g, 6, "")
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._GenerateApiTokenRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateApiTokenRequest();
    return c._GenerateApiTokenRequest.deserializeBinaryFromReader(f, g);
  }, c._GenerateApiTokenRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._GenerateApiTokenRequest.Never();
          g.readMessage(_, c._GenerateApiTokenRequest.Never.deserializeBinaryFromReader), l.setNever(_);
          break;
        case 2:
          var _ = new c._GenerateApiTokenRequest.Expires();
          g.readMessage(_, c._GenerateApiTokenRequest.Expires.deserializeBinaryFromReader), l.setExpires(_);
          break;
        case 3:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setAuthToken(_);
          break;
        case 4:
          var _ = new d.Permissions();
          g.readMessage(_, d.Permissions.deserializeBinaryFromReader), l.setPermissions(_);
          break;
        case 5:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setTokenId(_);
          break;
        case 6:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setDescription(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateApiTokenRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateApiTokenRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateApiTokenRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getNever(), f != null && g.writeMessage(
      1,
      f,
      c._GenerateApiTokenRequest.Never.serializeBinaryToWriter
    ), f = l.getExpires(), f != null && g.writeMessage(
      2,
      f,
      c._GenerateApiTokenRequest.Expires.serializeBinaryToWriter
    ), f = l.getAuthToken(), f.length > 0 && g.writeString(
      3,
      f
    ), f = l.getPermissions(), f != null && g.writeMessage(
      4,
      f,
      d.Permissions.serializeBinaryToWriter
    ), f = l.getTokenId(), f.length > 0 && g.writeString(
      5,
      f
    ), f = l.getDescription(), f.length > 0 && g.writeString(
      6,
      f
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._GenerateApiTokenRequest.Never.prototype.toObject = function(l) {
    return c._GenerateApiTokenRequest.Never.toObject(l, this);
  }, c._GenerateApiTokenRequest.Never.toObject = function(l, g) {
    var f = {};
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GenerateApiTokenRequest.Never.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateApiTokenRequest.Never();
    return c._GenerateApiTokenRequest.Never.deserializeBinaryFromReader(f, g);
  }, c._GenerateApiTokenRequest.Never.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateApiTokenRequest.Never.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateApiTokenRequest.Never.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateApiTokenRequest.Never.serializeBinaryToWriter = function(l, g) {
  }, s.Message.GENERATE_TO_OBJECT && (c._GenerateApiTokenRequest.Expires.prototype.toObject = function(l) {
    return c._GenerateApiTokenRequest.Expires.toObject(l, this);
  }, c._GenerateApiTokenRequest.Expires.toObject = function(l, g) {
    var f = {
      validForSeconds: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GenerateApiTokenRequest.Expires.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateApiTokenRequest.Expires();
    return c._GenerateApiTokenRequest.Expires.deserializeBinaryFromReader(f, g);
  }, c._GenerateApiTokenRequest.Expires.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setValidForSeconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateApiTokenRequest.Expires.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateApiTokenRequest.Expires.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateApiTokenRequest.Expires.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValidForSeconds(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._GenerateApiTokenRequest.Expires.prototype.getValidForSeconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._GenerateApiTokenRequest.Expires.prototype.setValidForSeconds = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._GenerateApiTokenRequest.prototype.getNever = function() {
    return (
      /** @type{?proto._GenerateApiTokenRequest.Never} */
      s.Message.getWrapperField(this, c._GenerateApiTokenRequest.Never, 1)
    );
  }, c._GenerateApiTokenRequest.prototype.setNever = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._GenerateApiTokenRequest.oneofGroups_[0], l);
  }, c._GenerateApiTokenRequest.prototype.clearNever = function() {
    return this.setNever(void 0);
  }, c._GenerateApiTokenRequest.prototype.hasNever = function() {
    return s.Message.getField(this, 1) != null;
  }, c._GenerateApiTokenRequest.prototype.getExpires = function() {
    return (
      /** @type{?proto._GenerateApiTokenRequest.Expires} */
      s.Message.getWrapperField(this, c._GenerateApiTokenRequest.Expires, 2)
    );
  }, c._GenerateApiTokenRequest.prototype.setExpires = function(l) {
    return s.Message.setOneofWrapperField(this, 2, c._GenerateApiTokenRequest.oneofGroups_[0], l);
  }, c._GenerateApiTokenRequest.prototype.clearExpires = function() {
    return this.setExpires(void 0);
  }, c._GenerateApiTokenRequest.prototype.hasExpires = function() {
    return s.Message.getField(this, 2) != null;
  }, c._GenerateApiTokenRequest.prototype.getAuthToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, c._GenerateApiTokenRequest.prototype.setAuthToken = function(l) {
    return s.Message.setProto3StringField(this, 3, l);
  }, c._GenerateApiTokenRequest.prototype.getPermissions = function() {
    return (
      /** @type{?proto.Permissions} */
      s.Message.getWrapperField(this, d.Permissions, 4)
    );
  }, c._GenerateApiTokenRequest.prototype.setPermissions = function(l) {
    return s.Message.setWrapperField(this, 4, l);
  }, c._GenerateApiTokenRequest.prototype.clearPermissions = function() {
    return this.setPermissions(void 0);
  }, c._GenerateApiTokenRequest.prototype.hasPermissions = function() {
    return s.Message.getField(this, 4) != null;
  }, c._GenerateApiTokenRequest.prototype.getTokenId = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 5, "")
    );
  }, c._GenerateApiTokenRequest.prototype.setTokenId = function(l) {
    return s.Message.setProto3StringField(this, 5, l);
  }, c._GenerateApiTokenRequest.prototype.getDescription = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 6, "")
    );
  }, c._GenerateApiTokenRequest.prototype.setDescription = function(l) {
    return s.Message.setProto3StringField(this, 6, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._GenerateApiTokenResponse.prototype.toObject = function(l) {
    return c._GenerateApiTokenResponse.toObject(l, this);
  }, c._GenerateApiTokenResponse.toObject = function(l, g) {
    var f = {
      apiKey: s.Message.getFieldWithDefault(g, 1, ""),
      refreshToken: s.Message.getFieldWithDefault(g, 2, ""),
      endpoint: s.Message.getFieldWithDefault(g, 3, ""),
      validUntil: s.Message.getFieldWithDefault(g, 4, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GenerateApiTokenResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateApiTokenResponse();
    return c._GenerateApiTokenResponse.deserializeBinaryFromReader(f, g);
  }, c._GenerateApiTokenResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setApiKey(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setRefreshToken(_);
          break;
        case 3:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setEndpoint(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setValidUntil(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateApiTokenResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateApiTokenResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateApiTokenResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getApiKey(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getRefreshToken(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getEndpoint(), f.length > 0 && g.writeString(
      3,
      f
    ), f = l.getValidUntil(), f !== 0 && g.writeUint64(
      4,
      f
    );
  }, c._GenerateApiTokenResponse.prototype.getApiKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GenerateApiTokenResponse.prototype.setApiKey = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._GenerateApiTokenResponse.prototype.getRefreshToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GenerateApiTokenResponse.prototype.setRefreshToken = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._GenerateApiTokenResponse.prototype.getEndpoint = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, c._GenerateApiTokenResponse.prototype.setEndpoint = function(l) {
    return s.Message.setProto3StringField(this, 3, l);
  }, c._GenerateApiTokenResponse.prototype.getValidUntil = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._GenerateApiTokenResponse.prototype.setValidUntil = function(l) {
    return s.Message.setProto3IntField(this, 4, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._RefreshApiTokenRequest.prototype.toObject = function(l) {
    return c._RefreshApiTokenRequest.toObject(l, this);
  }, c._RefreshApiTokenRequest.toObject = function(l, g) {
    var f = {
      apiKey: s.Message.getFieldWithDefault(g, 1, ""),
      refreshToken: s.Message.getFieldWithDefault(g, 2, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._RefreshApiTokenRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._RefreshApiTokenRequest();
    return c._RefreshApiTokenRequest.deserializeBinaryFromReader(f, g);
  }, c._RefreshApiTokenRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setApiKey(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setRefreshToken(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._RefreshApiTokenRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._RefreshApiTokenRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._RefreshApiTokenRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getApiKey(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getRefreshToken(), f.length > 0 && g.writeString(
      2,
      f
    );
  }, c._RefreshApiTokenRequest.prototype.getApiKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._RefreshApiTokenRequest.prototype.setApiKey = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._RefreshApiTokenRequest.prototype.getRefreshToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._RefreshApiTokenRequest.prototype.setRefreshToken = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._RefreshApiTokenResponse.prototype.toObject = function(l) {
    return c._RefreshApiTokenResponse.toObject(l, this);
  }, c._RefreshApiTokenResponse.toObject = function(l, g) {
    var f = {
      apiKey: s.Message.getFieldWithDefault(g, 1, ""),
      refreshToken: s.Message.getFieldWithDefault(g, 2, ""),
      endpoint: s.Message.getFieldWithDefault(g, 3, ""),
      validUntil: s.Message.getFieldWithDefault(g, 4, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._RefreshApiTokenResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._RefreshApiTokenResponse();
    return c._RefreshApiTokenResponse.deserializeBinaryFromReader(f, g);
  }, c._RefreshApiTokenResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setApiKey(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setRefreshToken(_);
          break;
        case 3:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setEndpoint(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setValidUntil(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._RefreshApiTokenResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._RefreshApiTokenResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._RefreshApiTokenResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getApiKey(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getRefreshToken(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getEndpoint(), f.length > 0 && g.writeString(
      3,
      f
    ), f = l.getValidUntil(), f !== 0 && g.writeUint64(
      4,
      f
    );
  }, c._RefreshApiTokenResponse.prototype.getApiKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._RefreshApiTokenResponse.prototype.setApiKey = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._RefreshApiTokenResponse.prototype.getRefreshToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._RefreshApiTokenResponse.prototype.setRefreshToken = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._RefreshApiTokenResponse.prototype.getEndpoint = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, c._RefreshApiTokenResponse.prototype.setEndpoint = function(l) {
    return s.Message.setProto3StringField(this, 3, l);
  }, c._RefreshApiTokenResponse.prototype.getValidUntil = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._RefreshApiTokenResponse.prototype.setValidUntil = function(l) {
    return s.Message.setProto3IntField(this, 4, l);
  }, h.object.extend(p, c);
})(auth_pb$1);
var __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$8(s, p, h);
  return __setModuleDefault$8(s, p), s;
};
Object.defineProperty(AuthServiceClientPb, "__esModule", { value: !0 });
AuthServiceClientPb.AuthClient = void 0;
const grpcWeb$7 = __importStar$8(grpcWeb$a), auth_pb = __importStar$8(auth_pb$1);
class AuthClient {
  constructor(s, h, c) {
    this.methodDescriptorLogin = new grpcWeb$7.MethodDescriptor("/auth.Auth/Login", grpcWeb$7.MethodType.SERVER_STREAMING, auth_pb._LoginRequest, auth_pb._LoginResponse, (d) => d.serializeBinary(), auth_pb._LoginResponse.deserializeBinary), this.methodDescriptorGenerateApiToken = new grpcWeb$7.MethodDescriptor("/auth.Auth/GenerateApiToken", grpcWeb$7.MethodType.UNARY, auth_pb._GenerateApiTokenRequest, auth_pb._GenerateApiTokenResponse, (d) => d.serializeBinary(), auth_pb._GenerateApiTokenResponse.deserializeBinary), this.methodDescriptorRefreshApiToken = new grpcWeb$7.MethodDescriptor("/auth.Auth/RefreshApiToken", grpcWeb$7.MethodType.UNARY, auth_pb._RefreshApiTokenRequest, auth_pb._RefreshApiTokenResponse, (d) => d.serializeBinary(), auth_pb._RefreshApiTokenResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$7.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  login(s, h) {
    return this.client_.serverStreaming(this.hostname_ + "/auth.Auth/Login", s, h || {}, this.methodDescriptorLogin);
  }
  generateApiToken(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/auth.Auth/GenerateApiToken", s, h || {}, this.methodDescriptorGenerateApiToken, c) : this.client_.unaryCall(this.hostname_ + "/auth.Auth/GenerateApiToken", s, h || {}, this.methodDescriptorGenerateApiToken);
  }
  refreshApiToken(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/auth.Auth/RefreshApiToken", s, h || {}, this.methodDescriptorRefreshApiToken, c) : this.client_.unaryCall(this.hostname_ + "/auth.Auth/RefreshApiToken", s, h || {}, this.methodDescriptorRefreshApiToken);
  }
}
AuthServiceClientPb.AuthClient = AuthClient;
var TokenServiceClientPb = {}, token_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {}, d = permissionmessages_pb;
  h.object.extend(c, d), h.exportSymbol("_GenerateDisposableTokenRequest", null, c), h.exportSymbol("_GenerateDisposableTokenRequest.Expires", null, c), h.exportSymbol("_GenerateDisposableTokenResponse", null, c), c._GenerateDisposableTokenRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GenerateDisposableTokenRequest, s.Message), h.DEBUG && !COMPILED && (c._GenerateDisposableTokenRequest.displayName = "proto._GenerateDisposableTokenRequest"), c._GenerateDisposableTokenRequest.Expires = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GenerateDisposableTokenRequest.Expires, s.Message), h.DEBUG && !COMPILED && (c._GenerateDisposableTokenRequest.Expires.displayName = "proto._GenerateDisposableTokenRequest.Expires"), c._GenerateDisposableTokenResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GenerateDisposableTokenResponse, s.Message), h.DEBUG && !COMPILED && (c._GenerateDisposableTokenResponse.displayName = "proto._GenerateDisposableTokenResponse"), s.Message.GENERATE_TO_OBJECT && (c._GenerateDisposableTokenRequest.prototype.toObject = function(l) {
    return c._GenerateDisposableTokenRequest.toObject(l, this);
  }, c._GenerateDisposableTokenRequest.toObject = function(l, g) {
    var f, _ = {
      expires: (f = g.getExpires()) && c._GenerateDisposableTokenRequest.Expires.toObject(l, f),
      authToken: s.Message.getFieldWithDefault(g, 2, ""),
      permissions: (f = g.getPermissions()) && d.Permissions.toObject(l, f),
      tokenId: s.Message.getFieldWithDefault(g, 4, "")
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._GenerateDisposableTokenRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateDisposableTokenRequest();
    return c._GenerateDisposableTokenRequest.deserializeBinaryFromReader(f, g);
  }, c._GenerateDisposableTokenRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._GenerateDisposableTokenRequest.Expires();
          g.readMessage(_, c._GenerateDisposableTokenRequest.Expires.deserializeBinaryFromReader), l.setExpires(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setAuthToken(_);
          break;
        case 3:
          var _ = new d.Permissions();
          g.readMessage(_, d.Permissions.deserializeBinaryFromReader), l.setPermissions(_);
          break;
        case 4:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setTokenId(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateDisposableTokenRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateDisposableTokenRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateDisposableTokenRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getExpires(), f != null && g.writeMessage(
      1,
      f,
      c._GenerateDisposableTokenRequest.Expires.serializeBinaryToWriter
    ), f = l.getAuthToken(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getPermissions(), f != null && g.writeMessage(
      3,
      f,
      d.Permissions.serializeBinaryToWriter
    ), f = l.getTokenId(), f.length > 0 && g.writeString(
      4,
      f
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._GenerateDisposableTokenRequest.Expires.prototype.toObject = function(l) {
    return c._GenerateDisposableTokenRequest.Expires.toObject(l, this);
  }, c._GenerateDisposableTokenRequest.Expires.toObject = function(l, g) {
    var f = {
      validForSeconds: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GenerateDisposableTokenRequest.Expires.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateDisposableTokenRequest.Expires();
    return c._GenerateDisposableTokenRequest.Expires.deserializeBinaryFromReader(f, g);
  }, c._GenerateDisposableTokenRequest.Expires.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setValidForSeconds(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateDisposableTokenRequest.Expires.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateDisposableTokenRequest.Expires.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateDisposableTokenRequest.Expires.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getValidForSeconds(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._GenerateDisposableTokenRequest.Expires.prototype.getValidForSeconds = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._GenerateDisposableTokenRequest.Expires.prototype.setValidForSeconds = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._GenerateDisposableTokenRequest.prototype.getExpires = function() {
    return (
      /** @type{?proto._GenerateDisposableTokenRequest.Expires} */
      s.Message.getWrapperField(this, c._GenerateDisposableTokenRequest.Expires, 1)
    );
  }, c._GenerateDisposableTokenRequest.prototype.setExpires = function(l) {
    return s.Message.setWrapperField(this, 1, l);
  }, c._GenerateDisposableTokenRequest.prototype.clearExpires = function() {
    return this.setExpires(void 0);
  }, c._GenerateDisposableTokenRequest.prototype.hasExpires = function() {
    return s.Message.getField(this, 1) != null;
  }, c._GenerateDisposableTokenRequest.prototype.getAuthToken = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GenerateDisposableTokenRequest.prototype.setAuthToken = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._GenerateDisposableTokenRequest.prototype.getPermissions = function() {
    return (
      /** @type{?proto.Permissions} */
      s.Message.getWrapperField(this, d.Permissions, 3)
    );
  }, c._GenerateDisposableTokenRequest.prototype.setPermissions = function(l) {
    return s.Message.setWrapperField(this, 3, l);
  }, c._GenerateDisposableTokenRequest.prototype.clearPermissions = function() {
    return this.setPermissions(void 0);
  }, c._GenerateDisposableTokenRequest.prototype.hasPermissions = function() {
    return s.Message.getField(this, 3) != null;
  }, c._GenerateDisposableTokenRequest.prototype.getTokenId = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 4, "")
    );
  }, c._GenerateDisposableTokenRequest.prototype.setTokenId = function(l) {
    return s.Message.setProto3StringField(this, 4, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._GenerateDisposableTokenResponse.prototype.toObject = function(l) {
    return c._GenerateDisposableTokenResponse.toObject(l, this);
  }, c._GenerateDisposableTokenResponse.toObject = function(l, g) {
    var f = {
      apiKey: s.Message.getFieldWithDefault(g, 1, ""),
      endpoint: s.Message.getFieldWithDefault(g, 2, ""),
      validUntil: s.Message.getFieldWithDefault(g, 3, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GenerateDisposableTokenResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GenerateDisposableTokenResponse();
    return c._GenerateDisposableTokenResponse.deserializeBinaryFromReader(f, g);
  }, c._GenerateDisposableTokenResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setApiKey(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setEndpoint(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint64()
          );
          l.setValidUntil(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GenerateDisposableTokenResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GenerateDisposableTokenResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GenerateDisposableTokenResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getApiKey(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getEndpoint(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getValidUntil(), f !== 0 && g.writeUint64(
      3,
      f
    );
  }, c._GenerateDisposableTokenResponse.prototype.getApiKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GenerateDisposableTokenResponse.prototype.setApiKey = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._GenerateDisposableTokenResponse.prototype.getEndpoint = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GenerateDisposableTokenResponse.prototype.setEndpoint = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._GenerateDisposableTokenResponse.prototype.getValidUntil = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._GenerateDisposableTokenResponse.prototype.setValidUntil = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, h.object.extend(p, c);
})(token_pb$1);
var __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$7(s, p, h);
  return __setModuleDefault$7(s, p), s;
};
Object.defineProperty(TokenServiceClientPb, "__esModule", { value: !0 });
TokenServiceClientPb.TokenClient = void 0;
const grpcWeb$6 = __importStar$7(grpcWeb$a), token_pb = __importStar$7(token_pb$1);
class TokenClient {
  constructor(s, h, c) {
    this.methodDescriptorGenerateDisposableToken = new grpcWeb$6.MethodDescriptor("/token.Token/GenerateDisposableToken", grpcWeb$6.MethodType.UNARY, token_pb._GenerateDisposableTokenRequest, token_pb._GenerateDisposableTokenResponse, (d) => d.serializeBinary(), token_pb._GenerateDisposableTokenResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$6.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  generateDisposableToken(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/token.Token/GenerateDisposableToken", s, h || {}, this.methodDescriptorGenerateDisposableToken, c) : this.client_.unaryCall(this.hostname_ + "/token.Token/GenerateDisposableToken", s, h || {}, this.methodDescriptorGenerateDisposableToken);
  }
}
TokenServiceClientPb.TokenClient = TokenClient;
var CachepingServiceClientPb = {}, cacheping_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("_PingRequest", null, c), h.exportSymbol("_PingResponse", null, c), c._PingRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._PingRequest, s.Message), h.DEBUG && !COMPILED && (c._PingRequest.displayName = "proto._PingRequest"), c._PingResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._PingResponse, s.Message), h.DEBUG && !COMPILED && (c._PingResponse.displayName = "proto._PingResponse"), s.Message.GENERATE_TO_OBJECT && (c._PingRequest.prototype.toObject = function(d) {
    return c._PingRequest.toObject(d, this);
  }, c._PingRequest.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._PingRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._PingRequest();
    return c._PingRequest.deserializeBinaryFromReader(g, l);
  }, c._PingRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._PingRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._PingRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._PingRequest.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._PingResponse.prototype.toObject = function(d) {
    return c._PingResponse.toObject(d, this);
  }, c._PingResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._PingResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._PingResponse();
    return c._PingResponse.deserializeBinaryFromReader(g, l);
  }, c._PingResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._PingResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._PingResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._PingResponse.serializeBinaryToWriter = function(d, l) {
  }, h.object.extend(p, c);
})(cacheping_pb$1);
var __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$6(s, p, h);
  return __setModuleDefault$6(s, p), s;
};
Object.defineProperty(CachepingServiceClientPb, "__esModule", { value: !0 });
CachepingServiceClientPb.PingClient = void 0;
const grpcWeb$5 = __importStar$6(grpcWeb$a), cacheping_pb = __importStar$6(cacheping_pb$1);
let PingClient$1 = class {
  constructor(s, h, c) {
    this.methodDescriptorPing = new grpcWeb$5.MethodDescriptor("/cache_client.Ping/Ping", grpcWeb$5.MethodType.UNARY, cacheping_pb._PingRequest, cacheping_pb._PingResponse, (d) => d.serializeBinary(), cacheping_pb._PingResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$5.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  ping(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.Ping/Ping", s, h || {}, this.methodDescriptorPing, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.Ping/Ping", s, h || {}, this.methodDescriptorPing);
  }
};
CachepingServiceClientPb.PingClient = PingClient$1;
var LeaderboardServiceClientPb = {}, leaderboard_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {}, d = common_pb$2;
  h.object.extend(c, d), h.exportSymbol("_DeleteLeaderboardRequest", null, c), h.exportSymbol("_Element", null, c), h.exportSymbol("_GetByRankRequest", null, c), h.exportSymbol("_GetByRankResponse", null, c), h.exportSymbol("_GetByScoreRequest", null, c), h.exportSymbol("_GetByScoreResponse", null, c), h.exportSymbol("_GetLeaderboardLengthRequest", null, c), h.exportSymbol("_GetLeaderboardLengthResponse", null, c), h.exportSymbol("_GetRankRequest", null, c), h.exportSymbol("_GetRankResponse", null, c), h.exportSymbol("_Order", null, c), h.exportSymbol("_RankRange", null, c), h.exportSymbol("_RankedElement", null, c), h.exportSymbol("_RemoveElementsRequest", null, c), h.exportSymbol("_ScoreRange", null, c), h.exportSymbol("_ScoreRange.MaxCase", null, c), h.exportSymbol("_ScoreRange.MinCase", null, c), h.exportSymbol("_UpsertElementsRequest", null, c), c._Element = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._Element, s.Message), h.DEBUG && !COMPILED && (c._Element.displayName = "proto._Element"), c._RankedElement = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._RankedElement, s.Message), h.DEBUG && !COMPILED && (c._RankedElement.displayName = "proto._RankedElement"), c._RankRange = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._RankRange, s.Message), h.DEBUG && !COMPILED && (c._RankRange.displayName = "proto._RankRange"), c._ScoreRange = function(l) {
    s.Message.initialize(this, l, 0, -1, null, c._ScoreRange.oneofGroups_);
  }, h.inherits(c._ScoreRange, s.Message), h.DEBUG && !COMPILED && (c._ScoreRange.displayName = "proto._ScoreRange"), c._DeleteLeaderboardRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._DeleteLeaderboardRequest, s.Message), h.DEBUG && !COMPILED && (c._DeleteLeaderboardRequest.displayName = "proto._DeleteLeaderboardRequest"), c._GetLeaderboardLengthRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GetLeaderboardLengthRequest, s.Message), h.DEBUG && !COMPILED && (c._GetLeaderboardLengthRequest.displayName = "proto._GetLeaderboardLengthRequest"), c._GetLeaderboardLengthResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GetLeaderboardLengthResponse, s.Message), h.DEBUG && !COMPILED && (c._GetLeaderboardLengthResponse.displayName = "proto._GetLeaderboardLengthResponse"), c._UpsertElementsRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._UpsertElementsRequest.repeatedFields_, null);
  }, h.inherits(c._UpsertElementsRequest, s.Message), h.DEBUG && !COMPILED && (c._UpsertElementsRequest.displayName = "proto._UpsertElementsRequest"), c._GetByRankRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GetByRankRequest, s.Message), h.DEBUG && !COMPILED && (c._GetByRankRequest.displayName = "proto._GetByRankRequest"), c._GetByRankResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, c._GetByRankResponse.repeatedFields_, null);
  }, h.inherits(c._GetByRankResponse, s.Message), h.DEBUG && !COMPILED && (c._GetByRankResponse.displayName = "proto._GetByRankResponse"), c._GetRankRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._GetRankRequest.repeatedFields_, null);
  }, h.inherits(c._GetRankRequest, s.Message), h.DEBUG && !COMPILED && (c._GetRankRequest.displayName = "proto._GetRankRequest"), c._GetRankResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, c._GetRankResponse.repeatedFields_, null);
  }, h.inherits(c._GetRankResponse, s.Message), h.DEBUG && !COMPILED && (c._GetRankResponse.displayName = "proto._GetRankResponse"), c._RemoveElementsRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, c._RemoveElementsRequest.repeatedFields_, null);
  }, h.inherits(c._RemoveElementsRequest, s.Message), h.DEBUG && !COMPILED && (c._RemoveElementsRequest.displayName = "proto._RemoveElementsRequest"), c._GetByScoreRequest = function(l) {
    s.Message.initialize(this, l, 0, -1, null, null);
  }, h.inherits(c._GetByScoreRequest, s.Message), h.DEBUG && !COMPILED && (c._GetByScoreRequest.displayName = "proto._GetByScoreRequest"), c._GetByScoreResponse = function(l) {
    s.Message.initialize(this, l, 0, -1, c._GetByScoreResponse.repeatedFields_, null);
  }, h.inherits(c._GetByScoreResponse, s.Message), h.DEBUG && !COMPILED && (c._GetByScoreResponse.displayName = "proto._GetByScoreResponse"), s.Message.GENERATE_TO_OBJECT && (c._Element.prototype.toObject = function(l) {
    return c._Element.toObject(l, this);
  }, c._Element.toObject = function(l, g) {
    var f = {
      id: s.Message.getFieldWithDefault(g, 1, 0),
      score: s.Message.getFloatingPointFieldWithDefault(g, 3, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._Element.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._Element();
    return c._Element.deserializeBinaryFromReader(f, g);
  }, c._Element.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setId(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setScore(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._Element.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._Element.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._Element.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getId(), f !== 0 && g.writeUint32(
      1,
      f
    ), f = l.getScore(), f !== 0 && g.writeDouble(
      3,
      f
    );
  }, c._Element.prototype.getId = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._Element.prototype.setId = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._Element.prototype.getScore = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 3, 0)
    );
  }, c._Element.prototype.setScore = function(l) {
    return s.Message.setProto3FloatField(this, 3, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._RankedElement.prototype.toObject = function(l) {
    return c._RankedElement.toObject(l, this);
  }, c._RankedElement.toObject = function(l, g) {
    var f = {
      id: s.Message.getFieldWithDefault(g, 1, 0),
      rank: s.Message.getFieldWithDefault(g, 3, 0),
      score: s.Message.getFloatingPointFieldWithDefault(g, 4, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._RankedElement.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._RankedElement();
    return c._RankedElement.deserializeBinaryFromReader(f, g);
  }, c._RankedElement.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setId(_);
          break;
        case 3:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setRank(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setScore(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._RankedElement.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._RankedElement.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._RankedElement.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getId(), f !== 0 && g.writeUint32(
      1,
      f
    ), f = l.getRank(), f !== 0 && g.writeUint32(
      3,
      f
    ), f = l.getScore(), f !== 0 && g.writeDouble(
      4,
      f
    );
  }, c._RankedElement.prototype.getId = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._RankedElement.prototype.setId = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._RankedElement.prototype.getRank = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._RankedElement.prototype.setRank = function(l) {
    return s.Message.setProto3IntField(this, 3, l);
  }, c._RankedElement.prototype.getScore = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 4, 0)
    );
  }, c._RankedElement.prototype.setScore = function(l) {
    return s.Message.setProto3FloatField(this, 4, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._RankRange.prototype.toObject = function(l) {
    return c._RankRange.toObject(l, this);
  }, c._RankRange.toObject = function(l, g) {
    var f = {
      startInclusive: s.Message.getFieldWithDefault(g, 1, 0),
      endExclusive: s.Message.getFieldWithDefault(g, 2, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._RankRange.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._RankRange();
    return c._RankRange.deserializeBinaryFromReader(f, g);
  }, c._RankRange.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setStartInclusive(_);
          break;
        case 2:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setEndExclusive(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._RankRange.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._RankRange.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._RankRange.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getStartInclusive(), f !== 0 && g.writeUint32(
      1,
      f
    ), f = l.getEndExclusive(), f !== 0 && g.writeUint32(
      2,
      f
    );
  }, c._RankRange.prototype.getStartInclusive = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._RankRange.prototype.setStartInclusive = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._RankRange.prototype.getEndExclusive = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._RankRange.prototype.setEndExclusive = function(l) {
    return s.Message.setProto3IntField(this, 2, l);
  }, c._ScoreRange.oneofGroups_ = [[1, 5], [3, 6]], c._ScoreRange.MinCase = {
    MIN_NOT_SET: 0,
    UNBOUNDED_MIN: 1,
    MIN_INCLUSIVE: 5
  }, c._ScoreRange.prototype.getMinCase = function() {
    return (
      /** @type {proto._ScoreRange.MinCase} */
      s.Message.computeOneofCase(this, c._ScoreRange.oneofGroups_[0])
    );
  }, c._ScoreRange.MaxCase = {
    MAX_NOT_SET: 0,
    UNBOUNDED_MAX: 3,
    MAX_EXCLUSIVE: 6
  }, c._ScoreRange.prototype.getMaxCase = function() {
    return (
      /** @type {proto._ScoreRange.MaxCase} */
      s.Message.computeOneofCase(this, c._ScoreRange.oneofGroups_[1])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._ScoreRange.prototype.toObject = function(l) {
    return c._ScoreRange.toObject(l, this);
  }, c._ScoreRange.toObject = function(l, g) {
    var f, _ = {
      unboundedMin: (f = g.getUnboundedMin()) && d._Unbounded.toObject(l, f),
      minInclusive: s.Message.getFloatingPointFieldWithDefault(g, 5, 0),
      unboundedMax: (f = g.getUnboundedMax()) && d._Unbounded.toObject(l, f),
      maxExclusive: s.Message.getFloatingPointFieldWithDefault(g, 6, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._ScoreRange.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._ScoreRange();
    return c._ScoreRange.deserializeBinaryFromReader(f, g);
  }, c._ScoreRange.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedMin(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setMinInclusive(_);
          break;
        case 3:
          var _ = new d._Unbounded();
          g.readMessage(_, d._Unbounded.deserializeBinaryFromReader), l.setUnboundedMax(_);
          break;
        case 6:
          var _ = (
            /** @type {number} */
            g.readDouble()
          );
          l.setMaxExclusive(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._ScoreRange.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._ScoreRange.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._ScoreRange.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getUnboundedMin(), f != null && g.writeMessage(
      1,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 5), f != null && g.writeDouble(
      5,
      f
    ), f = l.getUnboundedMax(), f != null && g.writeMessage(
      3,
      f,
      d._Unbounded.serializeBinaryToWriter
    ), f = /** @type {number} */
    s.Message.getField(l, 6), f != null && g.writeDouble(
      6,
      f
    );
  }, c._ScoreRange.prototype.getUnboundedMin = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 1)
    );
  }, c._ScoreRange.prototype.setUnboundedMin = function(l) {
    return s.Message.setOneofWrapperField(this, 1, c._ScoreRange.oneofGroups_[0], l);
  }, c._ScoreRange.prototype.clearUnboundedMin = function() {
    return this.setUnboundedMin(void 0);
  }, c._ScoreRange.prototype.hasUnboundedMin = function() {
    return s.Message.getField(this, 1) != null;
  }, c._ScoreRange.prototype.getMinInclusive = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 5, 0)
    );
  }, c._ScoreRange.prototype.setMinInclusive = function(l) {
    return s.Message.setOneofField(this, 5, c._ScoreRange.oneofGroups_[0], l);
  }, c._ScoreRange.prototype.clearMinInclusive = function() {
    return s.Message.setOneofField(this, 5, c._ScoreRange.oneofGroups_[0], void 0);
  }, c._ScoreRange.prototype.hasMinInclusive = function() {
    return s.Message.getField(this, 5) != null;
  }, c._ScoreRange.prototype.getUnboundedMax = function() {
    return (
      /** @type{?proto._Unbounded} */
      s.Message.getWrapperField(this, d._Unbounded, 3)
    );
  }, c._ScoreRange.prototype.setUnboundedMax = function(l) {
    return s.Message.setOneofWrapperField(this, 3, c._ScoreRange.oneofGroups_[1], l);
  }, c._ScoreRange.prototype.clearUnboundedMax = function() {
    return this.setUnboundedMax(void 0);
  }, c._ScoreRange.prototype.hasUnboundedMax = function() {
    return s.Message.getField(this, 3) != null;
  }, c._ScoreRange.prototype.getMaxExclusive = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 6, 0)
    );
  }, c._ScoreRange.prototype.setMaxExclusive = function(l) {
    return s.Message.setOneofField(this, 6, c._ScoreRange.oneofGroups_[1], l);
  }, c._ScoreRange.prototype.clearMaxExclusive = function() {
    return s.Message.setOneofField(this, 6, c._ScoreRange.oneofGroups_[1], void 0);
  }, c._ScoreRange.prototype.hasMaxExclusive = function() {
    return s.Message.getField(this, 6) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteLeaderboardRequest.prototype.toObject = function(l) {
    return c._DeleteLeaderboardRequest.toObject(l, this);
  }, c._DeleteLeaderboardRequest.toObject = function(l, g) {
    var f = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._DeleteLeaderboardRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._DeleteLeaderboardRequest();
    return c._DeleteLeaderboardRequest.deserializeBinaryFromReader(f, g);
  }, c._DeleteLeaderboardRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._DeleteLeaderboardRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._DeleteLeaderboardRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._DeleteLeaderboardRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    );
  }, c._DeleteLeaderboardRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._DeleteLeaderboardRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._DeleteLeaderboardRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._DeleteLeaderboardRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetLeaderboardLengthRequest.prototype.toObject = function(l) {
    return c._GetLeaderboardLengthRequest.toObject(l, this);
  }, c._GetLeaderboardLengthRequest.toObject = function(l, g) {
    var f = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, "")
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetLeaderboardLengthRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetLeaderboardLengthRequest();
    return c._GetLeaderboardLengthRequest.deserializeBinaryFromReader(f, g);
  }, c._GetLeaderboardLengthRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetLeaderboardLengthRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetLeaderboardLengthRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetLeaderboardLengthRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    );
  }, c._GetLeaderboardLengthRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetLeaderboardLengthRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._GetLeaderboardLengthRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetLeaderboardLengthRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetLeaderboardLengthResponse.prototype.toObject = function(l) {
    return c._GetLeaderboardLengthResponse.toObject(l, this);
  }, c._GetLeaderboardLengthResponse.toObject = function(l, g) {
    var f = {
      count: s.Message.getFieldWithDefault(g, 1, 0)
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetLeaderboardLengthResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetLeaderboardLengthResponse();
    return c._GetLeaderboardLengthResponse.deserializeBinaryFromReader(f, g);
  }, c._GetLeaderboardLengthResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setCount(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetLeaderboardLengthResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetLeaderboardLengthResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetLeaderboardLengthResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCount(), f !== 0 && g.writeUint32(
      1,
      f
    );
  }, c._GetLeaderboardLengthResponse.prototype.getCount = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._GetLeaderboardLengthResponse.prototype.setCount = function(l) {
    return s.Message.setProto3IntField(this, 1, l);
  }, c._UpsertElementsRequest.repeatedFields_ = [3], s.Message.GENERATE_TO_OBJECT && (c._UpsertElementsRequest.prototype.toObject = function(l) {
    return c._UpsertElementsRequest.toObject(l, this);
  }, c._UpsertElementsRequest.toObject = function(l, g) {
    var f = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, ""),
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._Element.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._UpsertElementsRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._UpsertElementsRequest();
    return c._UpsertElementsRequest.deserializeBinaryFromReader(f, g);
  }, c._UpsertElementsRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(_);
          break;
        case 3:
          var _ = new c._Element();
          g.readMessage(_, c._Element.deserializeBinaryFromReader), l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._UpsertElementsRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._UpsertElementsRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._UpsertElementsRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      3,
      f,
      c._Element.serializeBinaryToWriter
    );
  }, c._UpsertElementsRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._UpsertElementsRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._UpsertElementsRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._UpsertElementsRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._UpsertElementsRequest.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._Element>} */
      s.Message.getRepeatedWrapperField(this, c._Element, 3)
    );
  }, c._UpsertElementsRequest.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 3, l);
  }, c._UpsertElementsRequest.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 3, l, c._Element, g);
  }, c._UpsertElementsRequest.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetByRankRequest.prototype.toObject = function(l) {
    return c._GetByRankRequest.toObject(l, this);
  }, c._GetByRankRequest.toObject = function(l, g) {
    var f, _ = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, ""),
      rankRange: (f = g.getRankRange()) && c._RankRange.toObject(l, f),
      order: s.Message.getFieldWithDefault(g, 4, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._GetByRankRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetByRankRequest();
    return c._GetByRankRequest.deserializeBinaryFromReader(f, g);
  }, c._GetByRankRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(_);
          break;
        case 3:
          var _ = new c._RankRange();
          g.readMessage(_, c._RankRange.deserializeBinaryFromReader), l.setRankRange(_);
          break;
        case 4:
          var _ = (
            /** @type {!proto._Order} */
            g.readEnum()
          );
          l.setOrder(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetByRankRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetByRankRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetByRankRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getRankRange(), f != null && g.writeMessage(
      3,
      f,
      c._RankRange.serializeBinaryToWriter
    ), f = l.getOrder(), f !== 0 && g.writeEnum(
      4,
      f
    );
  }, c._GetByRankRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetByRankRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._GetByRankRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetByRankRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._GetByRankRequest.prototype.getRankRange = function() {
    return (
      /** @type{?proto._RankRange} */
      s.Message.getWrapperField(this, c._RankRange, 3)
    );
  }, c._GetByRankRequest.prototype.setRankRange = function(l) {
    return s.Message.setWrapperField(this, 3, l);
  }, c._GetByRankRequest.prototype.clearRankRange = function() {
    return this.setRankRange(void 0);
  }, c._GetByRankRequest.prototype.hasRankRange = function() {
    return s.Message.getField(this, 3) != null;
  }, c._GetByRankRequest.prototype.getOrder = function() {
    return (
      /** @type {!proto._Order} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._GetByRankRequest.prototype.setOrder = function(l) {
    return s.Message.setProto3EnumField(this, 4, l);
  }, c._GetByRankResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._GetByRankResponse.prototype.toObject = function(l) {
    return c._GetByRankResponse.toObject(l, this);
  }, c._GetByRankResponse.toObject = function(l, g) {
    var f = {
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._RankedElement.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetByRankResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetByRankResponse();
    return c._GetByRankResponse.deserializeBinaryFromReader(f, g);
  }, c._GetByRankResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._RankedElement();
          g.readMessage(_, c._RankedElement.deserializeBinaryFromReader), l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetByRankResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetByRankResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetByRankResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._RankedElement.serializeBinaryToWriter
    );
  }, c._GetByRankResponse.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._RankedElement>} */
      s.Message.getRepeatedWrapperField(this, c._RankedElement, 1)
    );
  }, c._GetByRankResponse.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._GetByRankResponse.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._RankedElement, g);
  }, c._GetByRankResponse.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._GetRankRequest.repeatedFields_ = [3], s.Message.GENERATE_TO_OBJECT && (c._GetRankRequest.prototype.toObject = function(l) {
    return c._GetRankRequest.toObject(l, this);
  }, c._GetRankRequest.toObject = function(l, g) {
    var f, _ = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, ""),
      idsList: (f = s.Message.getRepeatedField(g, 3)) == null ? void 0 : f,
      order: s.Message.getFieldWithDefault(g, 4, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._GetRankRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetRankRequest();
    return c._GetRankRequest.deserializeBinaryFromReader(f, g);
  }, c._GetRankRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var ae = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(ae);
          break;
        case 2:
          var ae = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(ae);
          break;
        case 3:
          for (var _ = (
            /** @type {!Array<number>} */
            g.isDelimited() ? g.readPackedUint32() : [g.readUint32()]
          ), te = 0; te < _.length; te++)
            l.addIds(_[te]);
          break;
        case 4:
          var ae = (
            /** @type {!proto._Order} */
            g.readEnum()
          );
          l.setOrder(ae);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetRankRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetRankRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetRankRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getIdsList(), f.length > 0 && g.writePackedUint32(
      3,
      f
    ), f = l.getOrder(), f !== 0 && g.writeEnum(
      4,
      f
    );
  }, c._GetRankRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetRankRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._GetRankRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetRankRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._GetRankRequest.prototype.getIdsList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 3)
    );
  }, c._GetRankRequest.prototype.setIdsList = function(l) {
    return s.Message.setField(this, 3, l || []);
  }, c._GetRankRequest.prototype.addIds = function(l, g) {
    return s.Message.addToRepeatedField(this, 3, l, g);
  }, c._GetRankRequest.prototype.clearIdsList = function() {
    return this.setIdsList([]);
  }, c._GetRankRequest.prototype.getOrder = function() {
    return (
      /** @type {!proto._Order} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._GetRankRequest.prototype.setOrder = function(l) {
    return s.Message.setProto3EnumField(this, 4, l);
  }, c._GetRankResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._GetRankResponse.prototype.toObject = function(l) {
    return c._GetRankResponse.toObject(l, this);
  }, c._GetRankResponse.toObject = function(l, g) {
    var f = {
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._RankedElement.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetRankResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetRankResponse();
    return c._GetRankResponse.deserializeBinaryFromReader(f, g);
  }, c._GetRankResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._RankedElement();
          g.readMessage(_, c._RankedElement.deserializeBinaryFromReader), l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetRankResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetRankResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetRankResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._RankedElement.serializeBinaryToWriter
    );
  }, c._GetRankResponse.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._RankedElement>} */
      s.Message.getRepeatedWrapperField(this, c._RankedElement, 1)
    );
  }, c._GetRankResponse.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._GetRankResponse.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._RankedElement, g);
  }, c._GetRankResponse.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._RemoveElementsRequest.repeatedFields_ = [3], s.Message.GENERATE_TO_OBJECT && (c._RemoveElementsRequest.prototype.toObject = function(l) {
    return c._RemoveElementsRequest.toObject(l, this);
  }, c._RemoveElementsRequest.toObject = function(l, g) {
    var f, _ = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, ""),
      idsList: (f = s.Message.getRepeatedField(g, 3)) == null ? void 0 : f
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._RemoveElementsRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._RemoveElementsRequest();
    return c._RemoveElementsRequest.deserializeBinaryFromReader(f, g);
  }, c._RemoveElementsRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(_);
          break;
        case 3:
          for (var te = (
            /** @type {!Array<number>} */
            g.isDelimited() ? g.readPackedUint32() : [g.readUint32()]
          ), ae = 0; ae < te.length; ae++)
            l.addIds(te[ae]);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._RemoveElementsRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._RemoveElementsRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._RemoveElementsRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getIdsList(), f.length > 0 && g.writePackedUint32(
      3,
      f
    );
  }, c._RemoveElementsRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._RemoveElementsRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._RemoveElementsRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._RemoveElementsRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._RemoveElementsRequest.prototype.getIdsList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 3)
    );
  }, c._RemoveElementsRequest.prototype.setIdsList = function(l) {
    return s.Message.setField(this, 3, l || []);
  }, c._RemoveElementsRequest.prototype.addIds = function(l, g) {
    return s.Message.addToRepeatedField(this, 3, l, g);
  }, c._RemoveElementsRequest.prototype.clearIdsList = function() {
    return this.setIdsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetByScoreRequest.prototype.toObject = function(l) {
    return c._GetByScoreRequest.toObject(l, this);
  }, c._GetByScoreRequest.toObject = function(l, g) {
    var f, _ = {
      cacheName: s.Message.getFieldWithDefault(g, 1, ""),
      leaderboard: s.Message.getFieldWithDefault(g, 2, ""),
      scoreRange: (f = g.getScoreRange()) && c._ScoreRange.toObject(l, f),
      offset: s.Message.getFieldWithDefault(g, 4, 0),
      limitElements: s.Message.getFieldWithDefault(g, 5, 0),
      order: s.Message.getFieldWithDefault(g, 6, 0)
    };
    return l && (_.$jspbMessageInstance = g), _;
  }), c._GetByScoreRequest.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetByScoreRequest();
    return c._GetByScoreRequest.deserializeBinaryFromReader(f, g);
  }, c._GetByScoreRequest.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setCacheName(_);
          break;
        case 2:
          var _ = (
            /** @type {string} */
            g.readString()
          );
          l.setLeaderboard(_);
          break;
        case 3:
          var _ = new c._ScoreRange();
          g.readMessage(_, c._ScoreRange.deserializeBinaryFromReader), l.setScoreRange(_);
          break;
        case 4:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setOffset(_);
          break;
        case 5:
          var _ = (
            /** @type {number} */
            g.readUint32()
          );
          l.setLimitElements(_);
          break;
        case 6:
          var _ = (
            /** @type {!proto._Order} */
            g.readEnum()
          );
          l.setOrder(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetByScoreRequest.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetByScoreRequest.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetByScoreRequest.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getCacheName(), f.length > 0 && g.writeString(
      1,
      f
    ), f = l.getLeaderboard(), f.length > 0 && g.writeString(
      2,
      f
    ), f = l.getScoreRange(), f != null && g.writeMessage(
      3,
      f,
      c._ScoreRange.serializeBinaryToWriter
    ), f = l.getOffset(), f !== 0 && g.writeUint32(
      4,
      f
    ), f = l.getLimitElements(), f !== 0 && g.writeUint32(
      5,
      f
    ), f = l.getOrder(), f !== 0 && g.writeEnum(
      6,
      f
    );
  }, c._GetByScoreRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetByScoreRequest.prototype.setCacheName = function(l) {
    return s.Message.setProto3StringField(this, 1, l);
  }, c._GetByScoreRequest.prototype.getLeaderboard = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetByScoreRequest.prototype.setLeaderboard = function(l) {
    return s.Message.setProto3StringField(this, 2, l);
  }, c._GetByScoreRequest.prototype.getScoreRange = function() {
    return (
      /** @type{?proto._ScoreRange} */
      s.Message.getWrapperField(this, c._ScoreRange, 3)
    );
  }, c._GetByScoreRequest.prototype.setScoreRange = function(l) {
    return s.Message.setWrapperField(this, 3, l);
  }, c._GetByScoreRequest.prototype.clearScoreRange = function() {
    return this.setScoreRange(void 0);
  }, c._GetByScoreRequest.prototype.hasScoreRange = function() {
    return s.Message.getField(this, 3) != null;
  }, c._GetByScoreRequest.prototype.getOffset = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, c._GetByScoreRequest.prototype.setOffset = function(l) {
    return s.Message.setProto3IntField(this, 4, l);
  }, c._GetByScoreRequest.prototype.getLimitElements = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, c._GetByScoreRequest.prototype.setLimitElements = function(l) {
    return s.Message.setProto3IntField(this, 5, l);
  }, c._GetByScoreRequest.prototype.getOrder = function() {
    return (
      /** @type {!proto._Order} */
      s.Message.getFieldWithDefault(this, 6, 0)
    );
  }, c._GetByScoreRequest.prototype.setOrder = function(l) {
    return s.Message.setProto3EnumField(this, 6, l);
  }, c._GetByScoreResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._GetByScoreResponse.prototype.toObject = function(l) {
    return c._GetByScoreResponse.toObject(l, this);
  }, c._GetByScoreResponse.toObject = function(l, g) {
    var f = {
      elementsList: s.Message.toObjectList(
        g.getElementsList(),
        c._RankedElement.toObject,
        l
      )
    };
    return l && (f.$jspbMessageInstance = g), f;
  }), c._GetByScoreResponse.deserializeBinary = function(l) {
    var g = new s.BinaryReader(l), f = new c._GetByScoreResponse();
    return c._GetByScoreResponse.deserializeBinaryFromReader(f, g);
  }, c._GetByScoreResponse.deserializeBinaryFromReader = function(l, g) {
    for (; g.nextField() && !g.isEndGroup(); ) {
      var f = g.getFieldNumber();
      switch (f) {
        case 1:
          var _ = new c._RankedElement();
          g.readMessage(_, c._RankedElement.deserializeBinaryFromReader), l.addElements(_);
          break;
        default:
          g.skipField();
          break;
      }
    }
    return l;
  }, c._GetByScoreResponse.prototype.serializeBinary = function() {
    var l = new s.BinaryWriter();
    return c._GetByScoreResponse.serializeBinaryToWriter(this, l), l.getResultBuffer();
  }, c._GetByScoreResponse.serializeBinaryToWriter = function(l, g) {
    var f = void 0;
    f = l.getElementsList(), f.length > 0 && g.writeRepeatedMessage(
      1,
      f,
      c._RankedElement.serializeBinaryToWriter
    );
  }, c._GetByScoreResponse.prototype.getElementsList = function() {
    return (
      /** @type{!Array<!proto._RankedElement>} */
      s.Message.getRepeatedWrapperField(this, c._RankedElement, 1)
    );
  }, c._GetByScoreResponse.prototype.setElementsList = function(l) {
    return s.Message.setRepeatedWrapperField(this, 1, l);
  }, c._GetByScoreResponse.prototype.addElements = function(l, g) {
    return s.Message.addToRepeatedWrapperField(this, 1, l, c._RankedElement, g);
  }, c._GetByScoreResponse.prototype.clearElementsList = function() {
    return this.setElementsList([]);
  }, c._Order = {
    ASCENDING: 0,
    DESCENDING: 1
  }, h.object.extend(p, c);
})(leaderboard_pb$1);
var __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$5(s, p, h);
  return __setModuleDefault$5(s, p), s;
};
Object.defineProperty(LeaderboardServiceClientPb, "__esModule", { value: !0 });
LeaderboardServiceClientPb.LeaderboardClient = void 0;
const grpcWeb$4 = __importStar$5(grpcWeb$a), common_pb$1 = __importStar$5(common_pb$2), leaderboard_pb = __importStar$5(leaderboard_pb$1);
class LeaderboardClient {
  constructor(s, h, c) {
    this.methodDescriptorDeleteLeaderboard = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/DeleteLeaderboard", grpcWeb$4.MethodType.UNARY, leaderboard_pb._DeleteLeaderboardRequest, common_pb$1._Empty, (d) => d.serializeBinary(), common_pb$1._Empty.deserializeBinary), this.methodDescriptorUpsertElements = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/UpsertElements", grpcWeb$4.MethodType.UNARY, leaderboard_pb._UpsertElementsRequest, common_pb$1._Empty, (d) => d.serializeBinary(), common_pb$1._Empty.deserializeBinary), this.methodDescriptorRemoveElements = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/RemoveElements", grpcWeb$4.MethodType.UNARY, leaderboard_pb._RemoveElementsRequest, common_pb$1._Empty, (d) => d.serializeBinary(), common_pb$1._Empty.deserializeBinary), this.methodDescriptorGetLeaderboardLength = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/GetLeaderboardLength", grpcWeb$4.MethodType.UNARY, leaderboard_pb._GetLeaderboardLengthRequest, leaderboard_pb._GetLeaderboardLengthResponse, (d) => d.serializeBinary(), leaderboard_pb._GetLeaderboardLengthResponse.deserializeBinary), this.methodDescriptorGetByRank = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/GetByRank", grpcWeb$4.MethodType.UNARY, leaderboard_pb._GetByRankRequest, leaderboard_pb._GetByRankResponse, (d) => d.serializeBinary(), leaderboard_pb._GetByRankResponse.deserializeBinary), this.methodDescriptorGetRank = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/GetRank", grpcWeb$4.MethodType.UNARY, leaderboard_pb._GetRankRequest, leaderboard_pb._GetRankResponse, (d) => d.serializeBinary(), leaderboard_pb._GetRankResponse.deserializeBinary), this.methodDescriptorGetByScore = new grpcWeb$4.MethodDescriptor("/leaderboard.Leaderboard/GetByScore", grpcWeb$4.MethodType.UNARY, leaderboard_pb._GetByScoreRequest, leaderboard_pb._GetByScoreResponse, (d) => d.serializeBinary(), leaderboard_pb._GetByScoreResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$4.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  deleteLeaderboard(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/DeleteLeaderboard", s, h || {}, this.methodDescriptorDeleteLeaderboard, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/DeleteLeaderboard", s, h || {}, this.methodDescriptorDeleteLeaderboard);
  }
  upsertElements(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/UpsertElements", s, h || {}, this.methodDescriptorUpsertElements, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/UpsertElements", s, h || {}, this.methodDescriptorUpsertElements);
  }
  removeElements(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/RemoveElements", s, h || {}, this.methodDescriptorRemoveElements, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/RemoveElements", s, h || {}, this.methodDescriptorRemoveElements);
  }
  getLeaderboardLength(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/GetLeaderboardLength", s, h || {}, this.methodDescriptorGetLeaderboardLength, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/GetLeaderboardLength", s, h || {}, this.methodDescriptorGetLeaderboardLength);
  }
  getByRank(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/GetByRank", s, h || {}, this.methodDescriptorGetByRank, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/GetByRank", s, h || {}, this.methodDescriptorGetByRank);
  }
  getRank(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/GetRank", s, h || {}, this.methodDescriptorGetRank, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/GetRank", s, h || {}, this.methodDescriptorGetRank);
  }
  getByScore(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/leaderboard.Leaderboard/GetByScore", s, h || {}, this.methodDescriptorGetByScore, c) : this.client_.unaryCall(this.hostname_ + "/leaderboard.Leaderboard/GetByScore", s, h || {}, this.methodDescriptorGetByScore);
  }
}
LeaderboardServiceClientPb.LeaderboardClient = LeaderboardClient;
var WebhookServiceClientPb = {}, webhook_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("_DeleteWebhookRequest", null, c), h.exportSymbol("_DeleteWebhookResponse", null, c), h.exportSymbol("_GetWebhookSecretRequest", null, c), h.exportSymbol("_GetWebhookSecretResponse", null, c), h.exportSymbol("_ListWebhookRequest", null, c), h.exportSymbol("_ListWebhooksResponse", null, c), h.exportSymbol("_PutWebhookRequest", null, c), h.exportSymbol("_PutWebhookResponse", null, c), h.exportSymbol("_RotateWebhookSecretRequest", null, c), h.exportSymbol("_RotateWebhookSecretResponse", null, c), h.exportSymbol("_Webhook", null, c), h.exportSymbol("_WebhookDestination", null, c), h.exportSymbol("_WebhookDestination.KindCase", null, c), h.exportSymbol("_WebhookId", null, c), c._WebhookId = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._WebhookId, s.Message), h.DEBUG && !COMPILED && (c._WebhookId.displayName = "proto._WebhookId"), c._Webhook = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._Webhook, s.Message), h.DEBUG && !COMPILED && (c._Webhook.displayName = "proto._Webhook"), c._PutWebhookRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._PutWebhookRequest, s.Message), h.DEBUG && !COMPILED && (c._PutWebhookRequest.displayName = "proto._PutWebhookRequest"), c._PutWebhookResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._PutWebhookResponse, s.Message), h.DEBUG && !COMPILED && (c._PutWebhookResponse.displayName = "proto._PutWebhookResponse"), c._DeleteWebhookRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteWebhookRequest, s.Message), h.DEBUG && !COMPILED && (c._DeleteWebhookRequest.displayName = "proto._DeleteWebhookRequest"), c._DeleteWebhookResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._DeleteWebhookResponse, s.Message), h.DEBUG && !COMPILED && (c._DeleteWebhookResponse.displayName = "proto._DeleteWebhookResponse"), c._ListWebhookRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._ListWebhookRequest, s.Message), h.DEBUG && !COMPILED && (c._ListWebhookRequest.displayName = "proto._ListWebhookRequest"), c._ListWebhooksResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, c._ListWebhooksResponse.repeatedFields_, null);
  }, h.inherits(c._ListWebhooksResponse, s.Message), h.DEBUG && !COMPILED && (c._ListWebhooksResponse.displayName = "proto._ListWebhooksResponse"), c._GetWebhookSecretRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._GetWebhookSecretRequest, s.Message), h.DEBUG && !COMPILED && (c._GetWebhookSecretRequest.displayName = "proto._GetWebhookSecretRequest"), c._GetWebhookSecretResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._GetWebhookSecretResponse, s.Message), h.DEBUG && !COMPILED && (c._GetWebhookSecretResponse.displayName = "proto._GetWebhookSecretResponse"), c._WebhookDestination = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c._WebhookDestination.oneofGroups_);
  }, h.inherits(c._WebhookDestination, s.Message), h.DEBUG && !COMPILED && (c._WebhookDestination.displayName = "proto._WebhookDestination"), c._RotateWebhookSecretRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._RotateWebhookSecretRequest, s.Message), h.DEBUG && !COMPILED && (c._RotateWebhookSecretRequest.displayName = "proto._RotateWebhookSecretRequest"), c._RotateWebhookSecretResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._RotateWebhookSecretResponse, s.Message), h.DEBUG && !COMPILED && (c._RotateWebhookSecretResponse.displayName = "proto._RotateWebhookSecretResponse"), s.Message.GENERATE_TO_OBJECT && (c._WebhookId.prototype.toObject = function(d) {
    return c._WebhookId.toObject(d, this);
  }, c._WebhookId.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, ""),
      webhookName: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._WebhookId.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._WebhookId();
    return c._WebhookId.deserializeBinaryFromReader(g, l);
  }, c._WebhookId.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setWebhookName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._WebhookId.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._WebhookId.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._WebhookId.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getWebhookName(), g.length > 0 && l.writeString(
      2,
      g
    );
  }, c._WebhookId.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._WebhookId.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._WebhookId.prototype.getWebhookName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._WebhookId.prototype.setWebhookName = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._Webhook.prototype.toObject = function(d) {
    return c._Webhook.toObject(d, this);
  }, c._Webhook.toObject = function(d, l) {
    var g, f = {
      webhookId: (g = l.getWebhookId()) && c._WebhookId.toObject(d, g),
      topicName: s.Message.getFieldWithDefault(l, 2, ""),
      destination: (g = l.getDestination()) && c._WebhookDestination.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._Webhook.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._Webhook();
    return c._Webhook.deserializeBinaryFromReader(g, l);
  }, c._Webhook.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._WebhookId();
          l.readMessage(f, c._WebhookId.deserializeBinaryFromReader), d.setWebhookId(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setTopicName(f);
          break;
        case 3:
          var f = new c._WebhookDestination();
          l.readMessage(f, c._WebhookDestination.deserializeBinaryFromReader), d.setDestination(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._Webhook.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._Webhook.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._Webhook.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getWebhookId(), g != null && l.writeMessage(
      1,
      g,
      c._WebhookId.serializeBinaryToWriter
    ), g = d.getTopicName(), g.length > 0 && l.writeString(
      2,
      g
    ), g = d.getDestination(), g != null && l.writeMessage(
      3,
      g,
      c._WebhookDestination.serializeBinaryToWriter
    );
  }, c._Webhook.prototype.getWebhookId = function() {
    return (
      /** @type{?proto._WebhookId} */
      s.Message.getWrapperField(this, c._WebhookId, 1)
    );
  }, c._Webhook.prototype.setWebhookId = function(d) {
    return s.Message.setWrapperField(this, 1, d);
  }, c._Webhook.prototype.clearWebhookId = function() {
    return this.setWebhookId(void 0);
  }, c._Webhook.prototype.hasWebhookId = function() {
    return s.Message.getField(this, 1) != null;
  }, c._Webhook.prototype.getTopicName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._Webhook.prototype.setTopicName = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, c._Webhook.prototype.getDestination = function() {
    return (
      /** @type{?proto._WebhookDestination} */
      s.Message.getWrapperField(this, c._WebhookDestination, 3)
    );
  }, c._Webhook.prototype.setDestination = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, c._Webhook.prototype.clearDestination = function() {
    return this.setDestination(void 0);
  }, c._Webhook.prototype.hasDestination = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._PutWebhookRequest.prototype.toObject = function(d) {
    return c._PutWebhookRequest.toObject(d, this);
  }, c._PutWebhookRequest.toObject = function(d, l) {
    var g, f = {
      webhook: (g = l.getWebhook()) && c._Webhook.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._PutWebhookRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._PutWebhookRequest();
    return c._PutWebhookRequest.deserializeBinaryFromReader(g, l);
  }, c._PutWebhookRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._Webhook();
          l.readMessage(f, c._Webhook.deserializeBinaryFromReader), d.setWebhook(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._PutWebhookRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._PutWebhookRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._PutWebhookRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getWebhook(), g != null && l.writeMessage(
      1,
      g,
      c._Webhook.serializeBinaryToWriter
    );
  }, c._PutWebhookRequest.prototype.getWebhook = function() {
    return (
      /** @type{?proto._Webhook} */
      s.Message.getWrapperField(this, c._Webhook, 1)
    );
  }, c._PutWebhookRequest.prototype.setWebhook = function(d) {
    return s.Message.setWrapperField(this, 1, d);
  }, c._PutWebhookRequest.prototype.clearWebhook = function() {
    return this.setWebhook(void 0);
  }, c._PutWebhookRequest.prototype.hasWebhook = function() {
    return s.Message.getField(this, 1) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._PutWebhookResponse.prototype.toObject = function(d) {
    return c._PutWebhookResponse.toObject(d, this);
  }, c._PutWebhookResponse.toObject = function(d, l) {
    var g = {
      secretString: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._PutWebhookResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._PutWebhookResponse();
    return c._PutWebhookResponse.deserializeBinaryFromReader(g, l);
  }, c._PutWebhookResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setSecretString(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._PutWebhookResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._PutWebhookResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._PutWebhookResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getSecretString(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._PutWebhookResponse.prototype.getSecretString = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._PutWebhookResponse.prototype.setSecretString = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteWebhookRequest.prototype.toObject = function(d) {
    return c._DeleteWebhookRequest.toObject(d, this);
  }, c._DeleteWebhookRequest.toObject = function(d, l) {
    var g, f = {
      webhookId: (g = l.getWebhookId()) && c._WebhookId.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._DeleteWebhookRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteWebhookRequest();
    return c._DeleteWebhookRequest.deserializeBinaryFromReader(g, l);
  }, c._DeleteWebhookRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._WebhookId();
          l.readMessage(f, c._WebhookId.deserializeBinaryFromReader), d.setWebhookId(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteWebhookRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteWebhookRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteWebhookRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getWebhookId(), g != null && l.writeMessage(
      1,
      g,
      c._WebhookId.serializeBinaryToWriter
    );
  }, c._DeleteWebhookRequest.prototype.getWebhookId = function() {
    return (
      /** @type{?proto._WebhookId} */
      s.Message.getWrapperField(this, c._WebhookId, 1)
    );
  }, c._DeleteWebhookRequest.prototype.setWebhookId = function(d) {
    return s.Message.setWrapperField(this, 1, d);
  }, c._DeleteWebhookRequest.prototype.clearWebhookId = function() {
    return this.setWebhookId(void 0);
  }, c._DeleteWebhookRequest.prototype.hasWebhookId = function() {
    return s.Message.getField(this, 1) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._DeleteWebhookResponse.prototype.toObject = function(d) {
    return c._DeleteWebhookResponse.toObject(d, this);
  }, c._DeleteWebhookResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._DeleteWebhookResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._DeleteWebhookResponse();
    return c._DeleteWebhookResponse.deserializeBinaryFromReader(g, l);
  }, c._DeleteWebhookResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._DeleteWebhookResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._DeleteWebhookResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._DeleteWebhookResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._ListWebhookRequest.prototype.toObject = function(d) {
    return c._ListWebhookRequest.toObject(d, this);
  }, c._ListWebhookRequest.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListWebhookRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListWebhookRequest();
    return c._ListWebhookRequest.deserializeBinaryFromReader(g, l);
  }, c._ListWebhookRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListWebhookRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListWebhookRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListWebhookRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._ListWebhookRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._ListWebhookRequest.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._ListWebhooksResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._ListWebhooksResponse.prototype.toObject = function(d) {
    return c._ListWebhooksResponse.toObject(d, this);
  }, c._ListWebhooksResponse.toObject = function(d, l) {
    var g = {
      webhookList: s.Message.toObjectList(
        l.getWebhookList(),
        c._Webhook.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._ListWebhooksResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._ListWebhooksResponse();
    return c._ListWebhooksResponse.deserializeBinaryFromReader(g, l);
  }, c._ListWebhooksResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._Webhook();
          l.readMessage(f, c._Webhook.deserializeBinaryFromReader), d.addWebhook(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._ListWebhooksResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._ListWebhooksResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._ListWebhooksResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getWebhookList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c._Webhook.serializeBinaryToWriter
    );
  }, c._ListWebhooksResponse.prototype.getWebhookList = function() {
    return (
      /** @type{!Array<!proto._Webhook>} */
      s.Message.getRepeatedWrapperField(this, c._Webhook, 1)
    );
  }, c._ListWebhooksResponse.prototype.setWebhookList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c._ListWebhooksResponse.prototype.addWebhook = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c._Webhook, l);
  }, c._ListWebhooksResponse.prototype.clearWebhookList = function() {
    return this.setWebhookList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetWebhookSecretRequest.prototype.toObject = function(d) {
    return c._GetWebhookSecretRequest.toObject(d, this);
  }, c._GetWebhookSecretRequest.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, ""),
      webhookName: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._GetWebhookSecretRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._GetWebhookSecretRequest();
    return c._GetWebhookSecretRequest.deserializeBinaryFromReader(g, l);
  }, c._GetWebhookSecretRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setWebhookName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._GetWebhookSecretRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._GetWebhookSecretRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._GetWebhookSecretRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getWebhookName(), g.length > 0 && l.writeString(
      2,
      g
    );
  }, c._GetWebhookSecretRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetWebhookSecretRequest.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._GetWebhookSecretRequest.prototype.getWebhookName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetWebhookSecretRequest.prototype.setWebhookName = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._GetWebhookSecretResponse.prototype.toObject = function(d) {
    return c._GetWebhookSecretResponse.toObject(d, this);
  }, c._GetWebhookSecretResponse.toObject = function(d, l) {
    var g = {
      cacheName: s.Message.getFieldWithDefault(l, 1, ""),
      webhookName: s.Message.getFieldWithDefault(l, 2, ""),
      secretString: s.Message.getFieldWithDefault(l, 3, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._GetWebhookSecretResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._GetWebhookSecretResponse();
    return c._GetWebhookSecretResponse.deserializeBinaryFromReader(g, l);
  }, c._GetWebhookSecretResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCacheName(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setWebhookName(f);
          break;
        case 3:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setSecretString(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._GetWebhookSecretResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._GetWebhookSecretResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._GetWebhookSecretResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getCacheName(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getWebhookName(), g.length > 0 && l.writeString(
      2,
      g
    ), g = d.getSecretString(), g.length > 0 && l.writeString(
      3,
      g
    );
  }, c._GetWebhookSecretResponse.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._GetWebhookSecretResponse.prototype.setCacheName = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._GetWebhookSecretResponse.prototype.getWebhookName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._GetWebhookSecretResponse.prototype.setWebhookName = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, c._GetWebhookSecretResponse.prototype.getSecretString = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, c._GetWebhookSecretResponse.prototype.setSecretString = function(d) {
    return s.Message.setProto3StringField(this, 3, d);
  }, c._WebhookDestination.oneofGroups_ = [[1]], c._WebhookDestination.KindCase = {
    KIND_NOT_SET: 0,
    POST_URL: 1
  }, c._WebhookDestination.prototype.getKindCase = function() {
    return (
      /** @type {proto._WebhookDestination.KindCase} */
      s.Message.computeOneofCase(this, c._WebhookDestination.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._WebhookDestination.prototype.toObject = function(d) {
    return c._WebhookDestination.toObject(d, this);
  }, c._WebhookDestination.toObject = function(d, l) {
    var g = {
      postUrl: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._WebhookDestination.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._WebhookDestination();
    return c._WebhookDestination.deserializeBinaryFromReader(g, l);
  }, c._WebhookDestination.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setPostUrl(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._WebhookDestination.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._WebhookDestination.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._WebhookDestination.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    );
  }, c._WebhookDestination.prototype.getPostUrl = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._WebhookDestination.prototype.setPostUrl = function(d) {
    return s.Message.setOneofField(this, 1, c._WebhookDestination.oneofGroups_[0], d);
  }, c._WebhookDestination.prototype.clearPostUrl = function() {
    return s.Message.setOneofField(this, 1, c._WebhookDestination.oneofGroups_[0], void 0);
  }, c._WebhookDestination.prototype.hasPostUrl = function() {
    return s.Message.getField(this, 1) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._RotateWebhookSecretRequest.prototype.toObject = function(d) {
    return c._RotateWebhookSecretRequest.toObject(d, this);
  }, c._RotateWebhookSecretRequest.toObject = function(d, l) {
    var g, f = {
      webhookId: (g = l.getWebhookId()) && c._WebhookId.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._RotateWebhookSecretRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._RotateWebhookSecretRequest();
    return c._RotateWebhookSecretRequest.deserializeBinaryFromReader(g, l);
  }, c._RotateWebhookSecretRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._WebhookId();
          l.readMessage(f, c._WebhookId.deserializeBinaryFromReader), d.setWebhookId(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._RotateWebhookSecretRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._RotateWebhookSecretRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._RotateWebhookSecretRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getWebhookId(), g != null && l.writeMessage(
      1,
      g,
      c._WebhookId.serializeBinaryToWriter
    );
  }, c._RotateWebhookSecretRequest.prototype.getWebhookId = function() {
    return (
      /** @type{?proto._WebhookId} */
      s.Message.getWrapperField(this, c._WebhookId, 1)
    );
  }, c._RotateWebhookSecretRequest.prototype.setWebhookId = function(d) {
    return s.Message.setWrapperField(this, 1, d);
  }, c._RotateWebhookSecretRequest.prototype.clearWebhookId = function() {
    return this.setWebhookId(void 0);
  }, c._RotateWebhookSecretRequest.prototype.hasWebhookId = function() {
    return s.Message.getField(this, 1) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._RotateWebhookSecretResponse.prototype.toObject = function(d) {
    return c._RotateWebhookSecretResponse.toObject(d, this);
  }, c._RotateWebhookSecretResponse.toObject = function(d, l) {
    var g = {
      secretString: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._RotateWebhookSecretResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._RotateWebhookSecretResponse();
    return c._RotateWebhookSecretResponse.deserializeBinaryFromReader(g, l);
  }, c._RotateWebhookSecretResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setSecretString(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._RotateWebhookSecretResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._RotateWebhookSecretResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._RotateWebhookSecretResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getSecretString(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._RotateWebhookSecretResponse.prototype.getSecretString = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._RotateWebhookSecretResponse.prototype.setSecretString = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, h.object.extend(p, c);
})(webhook_pb$1);
var __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$4(s, p, h);
  return __setModuleDefault$4(s, p), s;
};
Object.defineProperty(WebhookServiceClientPb, "__esModule", { value: !0 });
WebhookServiceClientPb.WebhookClient = void 0;
const grpcWeb$3 = __importStar$4(grpcWeb$a), webhook_pb = __importStar$4(webhook_pb$1);
class WebhookClient {
  constructor(s, h, c) {
    this.methodDescriptorPutWebhook = new grpcWeb$3.MethodDescriptor("/webhook.Webhook/PutWebhook", grpcWeb$3.MethodType.UNARY, webhook_pb._PutWebhookRequest, webhook_pb._PutWebhookResponse, (d) => d.serializeBinary(), webhook_pb._PutWebhookResponse.deserializeBinary), this.methodDescriptorDeleteWebhook = new grpcWeb$3.MethodDescriptor("/webhook.Webhook/DeleteWebhook", grpcWeb$3.MethodType.UNARY, webhook_pb._DeleteWebhookRequest, webhook_pb._DeleteWebhookResponse, (d) => d.serializeBinary(), webhook_pb._DeleteWebhookResponse.deserializeBinary), this.methodDescriptorListWebhooks = new grpcWeb$3.MethodDescriptor("/webhook.Webhook/ListWebhooks", grpcWeb$3.MethodType.UNARY, webhook_pb._ListWebhookRequest, webhook_pb._ListWebhooksResponse, (d) => d.serializeBinary(), webhook_pb._ListWebhooksResponse.deserializeBinary), this.methodDescriptorGetWebhookSecret = new grpcWeb$3.MethodDescriptor("/webhook.Webhook/GetWebhookSecret", grpcWeb$3.MethodType.UNARY, webhook_pb._GetWebhookSecretRequest, webhook_pb._GetWebhookSecretResponse, (d) => d.serializeBinary(), webhook_pb._GetWebhookSecretResponse.deserializeBinary), this.methodDescriptorRotateWebhookSecret = new grpcWeb$3.MethodDescriptor("/webhook.Webhook/RotateWebhookSecret", grpcWeb$3.MethodType.UNARY, webhook_pb._RotateWebhookSecretRequest, webhook_pb._RotateWebhookSecretResponse, (d) => d.serializeBinary(), webhook_pb._RotateWebhookSecretResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$3.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  putWebhook(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/webhook.Webhook/PutWebhook", s, h || {}, this.methodDescriptorPutWebhook, c) : this.client_.unaryCall(this.hostname_ + "/webhook.Webhook/PutWebhook", s, h || {}, this.methodDescriptorPutWebhook);
  }
  deleteWebhook(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/webhook.Webhook/DeleteWebhook", s, h || {}, this.methodDescriptorDeleteWebhook, c) : this.client_.unaryCall(this.hostname_ + "/webhook.Webhook/DeleteWebhook", s, h || {}, this.methodDescriptorDeleteWebhook);
  }
  listWebhooks(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/webhook.Webhook/ListWebhooks", s, h || {}, this.methodDescriptorListWebhooks, c) : this.client_.unaryCall(this.hostname_ + "/webhook.Webhook/ListWebhooks", s, h || {}, this.methodDescriptorListWebhooks);
  }
  getWebhookSecret(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/webhook.Webhook/GetWebhookSecret", s, h || {}, this.methodDescriptorGetWebhookSecret, c) : this.client_.unaryCall(this.hostname_ + "/webhook.Webhook/GetWebhookSecret", s, h || {}, this.methodDescriptorGetWebhookSecret);
  }
  rotateWebhookSecret(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/webhook.Webhook/RotateWebhookSecret", s, h || {}, this.methodDescriptorRotateWebhookSecret, c) : this.client_.unaryCall(this.hostname_ + "/webhook.Webhook/RotateWebhookSecret", s, h || {}, this.methodDescriptorRotateWebhookSecret);
  }
}
WebhookServiceClientPb.WebhookClient = WebhookClient;
var Global_adminServiceClientPb = {}, global_admin_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("_Account", null, c), h.exportSymbol("_GetAccountsRequest", null, c), h.exportSymbol("_GetAccountsResponse", null, c), c._GetAccountsRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._GetAccountsRequest, s.Message), h.DEBUG && !COMPILED && (c._GetAccountsRequest.displayName = "proto._GetAccountsRequest"), c._GetAccountsResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, c._GetAccountsResponse.repeatedFields_, null);
  }, h.inherits(c._GetAccountsResponse, s.Message), h.DEBUG && !COMPILED && (c._GetAccountsResponse.displayName = "proto._GetAccountsResponse"), c._Account = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._Account, s.Message), h.DEBUG && !COMPILED && (c._Account.displayName = "proto._Account"), s.Message.GENERATE_TO_OBJECT && (c._GetAccountsRequest.prototype.toObject = function(d) {
    return c._GetAccountsRequest.toObject(d, this);
  }, c._GetAccountsRequest.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._GetAccountsRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._GetAccountsRequest();
    return c._GetAccountsRequest.deserializeBinaryFromReader(g, l);
  }, c._GetAccountsRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._GetAccountsRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._GetAccountsRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._GetAccountsRequest.serializeBinaryToWriter = function(d, l) {
  }, c._GetAccountsResponse.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (c._GetAccountsResponse.prototype.toObject = function(d) {
    return c._GetAccountsResponse.toObject(d, this);
  }, c._GetAccountsResponse.toObject = function(d, l) {
    var g = {
      accountsList: s.Message.toObjectList(
        l.getAccountsList(),
        c._Account.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._GetAccountsResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._GetAccountsResponse();
    return c._GetAccountsResponse.deserializeBinaryFromReader(g, l);
  }, c._GetAccountsResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._Account();
          l.readMessage(f, c._Account.deserializeBinaryFromReader), d.addAccounts(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._GetAccountsResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._GetAccountsResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._GetAccountsResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getAccountsList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      c._Account.serializeBinaryToWriter
    );
  }, c._GetAccountsResponse.prototype.getAccountsList = function() {
    return (
      /** @type{!Array<!proto._Account>} */
      s.Message.getRepeatedWrapperField(this, c._Account, 1)
    );
  }, c._GetAccountsResponse.prototype.setAccountsList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, c._GetAccountsResponse.prototype.addAccounts = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, c._Account, l);
  }, c._GetAccountsResponse.prototype.clearAccountsList = function() {
    return this.setAccountsList([]);
  }, s.Message.GENERATE_TO_OBJECT && (c._Account.prototype.toObject = function(d) {
    return c._Account.toObject(d, this);
  }, c._Account.toObject = function(d, l) {
    var g = {
      id: s.Message.getFieldWithDefault(l, 1, ""),
      accountName: s.Message.getFieldWithDefault(l, 2, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._Account.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._Account();
    return c._Account.deserializeBinaryFromReader(g, l);
  }, c._Account.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setId(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setAccountName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._Account.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._Account.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._Account.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getId(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getAccountName(), g.length > 0 && l.writeString(
      2,
      g
    );
  }, c._Account.prototype.getId = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._Account.prototype.setId = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._Account.prototype.getAccountName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._Account.prototype.setAccountName = function(d) {
    return s.Message.setProto3StringField(this, 2, d);
  }, h.object.extend(p, c);
})(global_admin_pb$1);
var __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$3(s, p, h);
  return __setModuleDefault$3(s, p), s;
};
Object.defineProperty(Global_adminServiceClientPb, "__esModule", { value: !0 });
Global_adminServiceClientPb.GlobalAdminClient = void 0;
const grpcWeb$2 = __importStar$3(grpcWeb$a), global_admin_pb = __importStar$3(global_admin_pb$1);
class GlobalAdminClient {
  constructor(s, h, c) {
    this.methodDescriptorGetAccounts = new grpcWeb$2.MethodDescriptor("/global_admin.GlobalAdmin/GetAccounts", grpcWeb$2.MethodType.UNARY, global_admin_pb._GetAccountsRequest, global_admin_pb._GetAccountsResponse, (d) => d.serializeBinary(), global_admin_pb._GetAccountsResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$2.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  getAccounts(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/global_admin.GlobalAdmin/GetAccounts", s, h || {}, this.methodDescriptorGetAccounts, c) : this.client_.unaryCall(this.hostname_ + "/global_admin.GlobalAdmin/GetAccounts", s, h || {}, this.methodDescriptorGetAccounts);
  }
}
Global_adminServiceClientPb.GlobalAdminClient = GlobalAdminClient;
var StoreServiceClientPb = {}, store_pb$1 = {};
(function(p) {
  var s = googleProtobuf, h = s, c = {};
  h.exportSymbol("_StoreDeleteRequest", null, c), h.exportSymbol("_StoreDeleteResponse", null, c), h.exportSymbol("_StoreGetRequest", null, c), h.exportSymbol("_StoreGetResponse", null, c), h.exportSymbol("_StorePutRequest", null, c), h.exportSymbol("_StorePutResponse", null, c), h.exportSymbol("_StoreValue", null, c), h.exportSymbol("_StoreValue.ValueCase", null, c), c._StoreValue = function(d) {
    s.Message.initialize(this, d, 0, -1, null, c._StoreValue.oneofGroups_);
  }, h.inherits(c._StoreValue, s.Message), h.DEBUG && !COMPILED && (c._StoreValue.displayName = "proto._StoreValue"), c._StoreGetRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._StoreGetRequest, s.Message), h.DEBUG && !COMPILED && (c._StoreGetRequest.displayName = "proto._StoreGetRequest"), c._StoreGetResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._StoreGetResponse, s.Message), h.DEBUG && !COMPILED && (c._StoreGetResponse.displayName = "proto._StoreGetResponse"), c._StorePutRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._StorePutRequest, s.Message), h.DEBUG && !COMPILED && (c._StorePutRequest.displayName = "proto._StorePutRequest"), c._StorePutResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._StorePutResponse, s.Message), h.DEBUG && !COMPILED && (c._StorePutResponse.displayName = "proto._StorePutResponse"), c._StoreDeleteRequest = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._StoreDeleteRequest, s.Message), h.DEBUG && !COMPILED && (c._StoreDeleteRequest.displayName = "proto._StoreDeleteRequest"), c._StoreDeleteResponse = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(c._StoreDeleteResponse, s.Message), h.DEBUG && !COMPILED && (c._StoreDeleteResponse.displayName = "proto._StoreDeleteResponse"), c._StoreValue.oneofGroups_ = [[1, 2, 3, 4]], c._StoreValue.ValueCase = {
    VALUE_NOT_SET: 0,
    BYTES_VALUE: 1,
    STRING_VALUE: 2,
    INTEGER_VALUE: 3,
    DOUBLE_VALUE: 4
  }, c._StoreValue.prototype.getValueCase = function() {
    return (
      /** @type {proto._StoreValue.ValueCase} */
      s.Message.computeOneofCase(this, c._StoreValue.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._StoreValue.prototype.toObject = function(d) {
    return c._StoreValue.toObject(d, this);
  }, c._StoreValue.toObject = function(d, l) {
    var g = {
      bytesValue: l.getBytesValue_asB64(),
      stringValue: s.Message.getFieldWithDefault(l, 2, ""),
      integerValue: s.Message.getFieldWithDefault(l, 3, 0),
      doubleValue: s.Message.getFloatingPointFieldWithDefault(l, 4, 0)
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._StoreValue.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StoreValue();
    return c._StoreValue.deserializeBinaryFromReader(g, l);
  }, c._StoreValue.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setBytesValue(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setStringValue(f);
          break;
        case 3:
          var f = (
            /** @type {number} */
            l.readInt64()
          );
          d.setIntegerValue(f);
          break;
        case 4:
          var f = (
            /** @type {number} */
            l.readDouble()
          );
          d.setDoubleValue(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StoreValue.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StoreValue.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StoreValue.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {!(string|Uint8Array)} */
    s.Message.getField(d, 1), g != null && l.writeBytes(
      1,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 2), g != null && l.writeString(
      2,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 3), g != null && l.writeInt64(
      3,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 4), g != null && l.writeDouble(
      4,
      g
    );
  }, c._StoreValue.prototype.getBytesValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._StoreValue.prototype.getBytesValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getBytesValue()
      )
    );
  }, c._StoreValue.prototype.getBytesValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getBytesValue()
      )
    );
  }, c._StoreValue.prototype.setBytesValue = function(d) {
    return s.Message.setOneofField(this, 1, c._StoreValue.oneofGroups_[0], d);
  }, c._StoreValue.prototype.clearBytesValue = function() {
    return s.Message.setOneofField(this, 1, c._StoreValue.oneofGroups_[0], void 0);
  }, c._StoreValue.prototype.hasBytesValue = function() {
    return s.Message.getField(this, 1) != null;
  }, c._StoreValue.prototype.getStringValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._StoreValue.prototype.setStringValue = function(d) {
    return s.Message.setOneofField(this, 2, c._StoreValue.oneofGroups_[0], d);
  }, c._StoreValue.prototype.clearStringValue = function() {
    return s.Message.setOneofField(this, 2, c._StoreValue.oneofGroups_[0], void 0);
  }, c._StoreValue.prototype.hasStringValue = function() {
    return s.Message.getField(this, 2) != null;
  }, c._StoreValue.prototype.getIntegerValue = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._StoreValue.prototype.setIntegerValue = function(d) {
    return s.Message.setOneofField(this, 3, c._StoreValue.oneofGroups_[0], d);
  }, c._StoreValue.prototype.clearIntegerValue = function() {
    return s.Message.setOneofField(this, 3, c._StoreValue.oneofGroups_[0], void 0);
  }, c._StoreValue.prototype.hasIntegerValue = function() {
    return s.Message.getField(this, 3) != null;
  }, c._StoreValue.prototype.getDoubleValue = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 4, 0)
    );
  }, c._StoreValue.prototype.setDoubleValue = function(d) {
    return s.Message.setOneofField(this, 4, c._StoreValue.oneofGroups_[0], d);
  }, c._StoreValue.prototype.clearDoubleValue = function() {
    return s.Message.setOneofField(this, 4, c._StoreValue.oneofGroups_[0], void 0);
  }, c._StoreValue.prototype.hasDoubleValue = function() {
    return s.Message.getField(this, 4) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._StoreGetRequest.prototype.toObject = function(d) {
    return c._StoreGetRequest.toObject(d, this);
  }, c._StoreGetRequest.toObject = function(d, l) {
    var g = {
      key: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._StoreGetRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StoreGetRequest();
    return c._StoreGetRequest.deserializeBinaryFromReader(g, l);
  }, c._StoreGetRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setKey(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StoreGetRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StoreGetRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StoreGetRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getKey(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._StoreGetRequest.prototype.getKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._StoreGetRequest.prototype.setKey = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._StoreGetResponse.prototype.toObject = function(d) {
    return c._StoreGetResponse.toObject(d, this);
  }, c._StoreGetResponse.toObject = function(d, l) {
    var g, f = {
      value: (g = l.getValue()) && c._StoreValue.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._StoreGetResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StoreGetResponse();
    return c._StoreGetResponse.deserializeBinaryFromReader(g, l);
  }, c._StoreGetResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new c._StoreValue();
          l.readMessage(f, c._StoreValue.deserializeBinaryFromReader), d.setValue(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StoreGetResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StoreGetResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StoreGetResponse.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getValue(), g != null && l.writeMessage(
      1,
      g,
      c._StoreValue.serializeBinaryToWriter
    );
  }, c._StoreGetResponse.prototype.getValue = function() {
    return (
      /** @type{?proto._StoreValue} */
      s.Message.getWrapperField(this, c._StoreValue, 1)
    );
  }, c._StoreGetResponse.prototype.setValue = function(d) {
    return s.Message.setWrapperField(this, 1, d);
  }, c._StoreGetResponse.prototype.clearValue = function() {
    return this.setValue(void 0);
  }, c._StoreGetResponse.prototype.hasValue = function() {
    return s.Message.getField(this, 1) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._StorePutRequest.prototype.toObject = function(d) {
    return c._StorePutRequest.toObject(d, this);
  }, c._StorePutRequest.toObject = function(d, l) {
    var g, f = {
      key: s.Message.getFieldWithDefault(l, 1, ""),
      value: (g = l.getValue()) && c._StoreValue.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), c._StorePutRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StorePutRequest();
    return c._StorePutRequest.deserializeBinaryFromReader(g, l);
  }, c._StorePutRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setKey(f);
          break;
        case 2:
          var f = new c._StoreValue();
          l.readMessage(f, c._StoreValue.deserializeBinaryFromReader), d.setValue(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StorePutRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StorePutRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StorePutRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getKey(), g.length > 0 && l.writeString(
      1,
      g
    ), g = d.getValue(), g != null && l.writeMessage(
      2,
      g,
      c._StoreValue.serializeBinaryToWriter
    );
  }, c._StorePutRequest.prototype.getKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._StorePutRequest.prototype.setKey = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, c._StorePutRequest.prototype.getValue = function() {
    return (
      /** @type{?proto._StoreValue} */
      s.Message.getWrapperField(this, c._StoreValue, 2)
    );
  }, c._StorePutRequest.prototype.setValue = function(d) {
    return s.Message.setWrapperField(this, 2, d);
  }, c._StorePutRequest.prototype.clearValue = function() {
    return this.setValue(void 0);
  }, c._StorePutRequest.prototype.hasValue = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._StorePutResponse.prototype.toObject = function(d) {
    return c._StorePutResponse.toObject(d, this);
  }, c._StorePutResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._StorePutResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StorePutResponse();
    return c._StorePutResponse.deserializeBinaryFromReader(g, l);
  }, c._StorePutResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StorePutResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StorePutResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StorePutResponse.serializeBinaryToWriter = function(d, l) {
  }, s.Message.GENERATE_TO_OBJECT && (c._StoreDeleteRequest.prototype.toObject = function(d) {
    return c._StoreDeleteRequest.toObject(d, this);
  }, c._StoreDeleteRequest.toObject = function(d, l) {
    var g = {
      key: s.Message.getFieldWithDefault(l, 1, "")
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), c._StoreDeleteRequest.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StoreDeleteRequest();
    return c._StoreDeleteRequest.deserializeBinaryFromReader(g, l);
  }, c._StoreDeleteRequest.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setKey(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StoreDeleteRequest.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StoreDeleteRequest.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StoreDeleteRequest.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getKey(), g.length > 0 && l.writeString(
      1,
      g
    );
  }, c._StoreDeleteRequest.prototype.getKey = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._StoreDeleteRequest.prototype.setKey = function(d) {
    return s.Message.setProto3StringField(this, 1, d);
  }, s.Message.GENERATE_TO_OBJECT && (c._StoreDeleteResponse.prototype.toObject = function(d) {
    return c._StoreDeleteResponse.toObject(d, this);
  }, c._StoreDeleteResponse.toObject = function(d, l) {
    var g = {};
    return d && (g.$jspbMessageInstance = l), g;
  }), c._StoreDeleteResponse.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new c._StoreDeleteResponse();
    return c._StoreDeleteResponse.deserializeBinaryFromReader(g, l);
  }, c._StoreDeleteResponse.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, c._StoreDeleteResponse.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return c._StoreDeleteResponse.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, c._StoreDeleteResponse.serializeBinaryToWriter = function(d, l) {
  }, h.object.extend(p, c);
})(store_pb$1);
var __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$2(s, p, h);
  return __setModuleDefault$2(s, p), s;
};
Object.defineProperty(StoreServiceClientPb, "__esModule", { value: !0 });
StoreServiceClientPb.StoreClient = void 0;
const grpcWeb$1 = __importStar$2(grpcWeb$a), store_pb = __importStar$2(store_pb$1);
class StoreClient {
  constructor(s, h, c) {
    this.methodDescriptorGet = new grpcWeb$1.MethodDescriptor("/store.Store/Get", grpcWeb$1.MethodType.UNARY, store_pb._StoreGetRequest, store_pb._StoreGetResponse, (d) => d.serializeBinary(), store_pb._StoreGetResponse.deserializeBinary), this.methodDescriptorPut = new grpcWeb$1.MethodDescriptor("/store.Store/Put", grpcWeb$1.MethodType.UNARY, store_pb._StorePutRequest, store_pb._StorePutResponse, (d) => d.serializeBinary(), store_pb._StorePutResponse.deserializeBinary), this.methodDescriptorDelete = new grpcWeb$1.MethodDescriptor("/store.Store/Delete", grpcWeb$1.MethodType.UNARY, store_pb._StoreDeleteRequest, store_pb._StoreDeleteResponse, (d) => d.serializeBinary(), store_pb._StoreDeleteResponse.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb$1.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  get(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/store.Store/Get", s, h || {}, this.methodDescriptorGet, c) : this.client_.unaryCall(this.hostname_ + "/store.Store/Get", s, h || {}, this.methodDescriptorGet);
  }
  put(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/store.Store/Put", s, h || {}, this.methodDescriptorPut, c) : this.client_.unaryCall(this.hostname_ + "/store.Store/Put", s, h || {}, this.methodDescriptorPut);
  }
  delete(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/store.Store/Delete", s, h || {}, this.methodDescriptorDelete, c) : this.client_.unaryCall(this.hostname_ + "/store.Store/Delete", s, h || {}, this.methodDescriptorDelete);
  }
}
StoreServiceClientPb.StoreClient = StoreClient;
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding$1(s, p, h);
  return __setModuleDefault$1(s, p), s;
};
Object.defineProperty(dist, "__esModule", { value: !0 });
dist.store = dist.globaladmin = dist.webhook = dist.leaderboard = dist.ping = dist.token = dist.auth = dist.control = dist.cache = void 0;
dist.cache = __importStar$1(CacheclientServiceClientPb);
dist.control = __importStar$1(ControlclientServiceClientPb);
dist.auth = __importStar$1(AuthServiceClientPb);
dist.token = __importStar$1(TokenServiceClientPb);
dist.ping = __importStar$1(CachepingServiceClientPb);
dist.leaderboard = __importStar$1(LeaderboardServiceClientPb);
dist.webhook = __importStar$1(WebhookServiceClientPb);
dist.globaladmin = __importStar$1(Global_adminServiceClientPb);
dist.store = __importStar$1(StoreServiceClientPb);
var cacheServiceErrorMapper = {}, src = {}, cacheGet = {}, responseBase = {};
Object.defineProperty(responseBase, "__esModule", { value: !0 });
responseBase.ResponseNotFound = responseBase.ResponseFound = responseBase.ResponseSuccess = responseBase.BaseResponseSubscription = responseBase.BaseResponseSuccess = responseBase.ResponseMiss = responseBase.BaseResponseMiss = responseBase.ResponseHit = responseBase.ResponseError = responseBase.BaseResponseError = responseBase.ResponseBase = void 0;
class ResponseBase {
  toString() {
    return this.constructor.name;
  }
}
responseBase.ResponseBase = ResponseBase;
class BaseResponseError extends ResponseBase {
  constructor(s) {
    super(), this._innerException = s;
  }
  message() {
    return this._innerException.wrappedErrorMessage();
  }
  innerException() {
    return this._innerException;
  }
  errorCode() {
    return this._innerException.errorCode();
  }
  toString() {
    return this.message();
  }
}
responseBase.BaseResponseError = BaseResponseError;
function ResponseError(p) {
  return class extends p {
    message() {
      return this._innerException.wrappedErrorMessage();
    }
    innerException() {
      return this._innerException;
    }
    errorCode() {
      return this._innerException.errorCode();
    }
    toString() {
      return this.message();
    }
  };
}
responseBase.ResponseError = ResponseError;
function ResponseHit(p) {
  return class extends p {
  };
}
responseBase.ResponseHit = ResponseHit;
class BaseResponseMiss extends ResponseBase {
  constructor() {
    super(...arguments), this.is_miss = !0;
  }
}
responseBase.BaseResponseMiss = BaseResponseMiss;
function ResponseMiss(p) {
  return class extends p {
    constructor() {
      super(...arguments), this.is_miss = !0;
    }
  };
}
responseBase.ResponseMiss = ResponseMiss;
class BaseResponseSuccess extends ResponseBase {
  constructor() {
    super(...arguments), this.is_success = !0;
  }
}
responseBase.BaseResponseSuccess = BaseResponseSuccess;
class BaseResponseSubscription extends ResponseBase {
  constructor() {
    super(...arguments), this.is_subscribed = !0;
  }
}
responseBase.BaseResponseSubscription = BaseResponseSubscription;
function ResponseSuccess(p) {
  return class extends p {
    constructor() {
      super(...arguments), this.is_success = !0;
    }
  };
}
responseBase.ResponseSuccess = ResponseSuccess;
function ResponseFound(p) {
  return class extends p {
  };
}
responseBase.ResponseFound = ResponseFound;
function ResponseNotFound(p) {
  return class extends p {
  };
}
responseBase.ResponseNotFound = ResponseNotFound;
var utils$1 = {}, auth$3 = {}, errors$1 = {}, errors = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.UnknownServiceError = p.UnknownError = p.TimeoutError = p.ServerUnavailableError = p.PermissionError = p.StoreItemNotFoundError = p.StoreNotFoundError = p.CacheNotFoundError = p.LimitExceededError = p.InvalidArgumentError = p.InternalServerError = p.FailedPreconditionError = p.ConnectionError = p.CancelledError = p.BadRequestError = p.AuthenticationError = p.StoreAlreadyExistsError = p.CacheAlreadyExistsError = p.SdkError = p.MomentoErrorTransportDetails = p.MomentoGrpcErrorDetails = p.MomentoErrorCode = void 0;
  var s;
  (function(pe) {
    pe.INVALID_ARGUMENT_ERROR = "INVALID_ARGUMENT_ERROR", pe.UNKNOWN_SERVICE_ERROR = "UNKNOWN_SERVICE_ERROR", pe.CACHE_ALREADY_EXISTS_ERROR = "ALREADY_EXISTS_ERROR", pe.ALREADY_EXISTS_ERROR = "ALREADY_EXISTS_ERROR", pe.STORE_ALREADY_EXISTS_ERROR = "ALREADY_EXISTS_ERROR", pe.CACHE_NOT_FOUND_ERROR = "NOT_FOUND_ERROR", pe.NOT_FOUND_ERROR = "NOT_FOUND_ERROR", pe.STORE_NOT_FOUND_ERROR = "STORE_NOT_FOUND_ERROR", pe.STORE_ITEM_NOT_FOUND_ERROR = "STORE_ITEM_NOT_FOUND_ERROR", pe.INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR", pe.PERMISSION_ERROR = "PERMISSION_ERROR", pe.AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR", pe.CANCELLED_ERROR = "CANCELLED_ERROR", pe.CONNECTION_ERROR = "CONNECTION_ERROR", pe.LIMIT_EXCEEDED_ERROR = "LIMIT_EXCEEDED_ERROR", pe.BAD_REQUEST_ERROR = "BAD_REQUEST_ERROR", pe.TIMEOUT_ERROR = "TIMEOUT_ERROR", pe.SERVER_UNAVAILABLE = "SERVER_UNAVAILABLE", pe.CLIENT_RESOURCE_EXHAUSTED = "CLIENT_RESOURCE_EXHAUSTED", pe.FAILED_PRECONDITION_ERROR = "FAILED_PRECONDITION_ERROR", pe.UNKNOWN_ERROR = "UNKNOWN_ERROR";
  })(s = p.MomentoErrorCode || (p.MomentoErrorCode = {}));
  class h {
    constructor(he, fe, ye) {
      this.code = he, this.details = fe, this.metadata = ye;
    }
  }
  p.MomentoGrpcErrorDetails = h;
  class c {
    constructor(he) {
      this.grpc = he;
    }
  }
  p.MomentoErrorTransportDetails = c;
  class d extends Error {
    constructor(he, fe = 0, ye = void 0, Re = void 0) {
      super(he);
      const be = new h(fe, he, ye);
      this._transportDetails = new c(be), this.stack = Re != null ? Re : void 0;
    }
    wrappedErrorMessage() {
      return `${this._messageWrapper}: ${this.message}`;
    }
    errorCode() {
      return this._errorCode;
    }
    transportDetails() {
      return this._transportDetails;
    }
  }
  p.SdkError = d;
  class l extends d {
    constructor() {
      super(...arguments), this._errorCode = s.CACHE_ALREADY_EXISTS_ERROR, this._messageWrapper = "A cache with the specified name already exists.  To resolve this error, either delete the existing cache and make a new one, or use a different name";
    }
  }
  p.CacheAlreadyExistsError = l;
  class g extends d {
    constructor() {
      super(...arguments), this._errorCode = s.STORE_ALREADY_EXISTS_ERROR, this._messageWrapper = "A store with the specified name already exists.  To resolve this error, either delete the existing store and make a new one, or use a different name";
    }
  }
  p.StoreAlreadyExistsError = g;
  class f extends d {
    constructor() {
      super(...arguments), this._errorCode = s.AUTHENTICATION_ERROR, this._messageWrapper = "Invalid authentication credentials to connect to cache service";
    }
  }
  p.AuthenticationError = f;
  class _ extends d {
    constructor() {
      super(...arguments), this._errorCode = s.BAD_REQUEST_ERROR, this._messageWrapper = "The request was invalid; please contact us at support@momentohq.com";
    }
  }
  p.BadRequestError = _;
  class te extends d {
    constructor() {
      super(...arguments), this._errorCode = s.CANCELLED_ERROR, this._messageWrapper = "The request was cancelled by the server; please contact us at support@momentohq.com";
    }
  }
  p.CancelledError = te;
  class ae extends d {
    constructor() {
      super(...arguments), this._errorCode = s.CONNECTION_ERROR;
    }
  }
  p.ConnectionError = ae;
  class ie extends d {
    constructor() {
      super(...arguments), this._errorCode = s.FAILED_PRECONDITION_ERROR, this._messageWrapper = "System is not in a state required for the operation's execution";
    }
  }
  p.FailedPreconditionError = ie;
  class se extends d {
    constructor() {
      super(...arguments), this._errorCode = s.INTERNAL_SERVER_ERROR, this._messageWrapper = "An unexpected error occurred while trying to fulfill the request; please contact us at support@momentohq.com";
    }
  }
  p.InternalServerError = se;
  class m extends d {
    constructor() {
      super(...arguments), this._errorCode = s.INVALID_ARGUMENT_ERROR, this._messageWrapper = "Invalid argument passed to Momento client";
    }
  }
  p.InvalidArgumentError = m;
  var w;
  (function(pe) {
    pe.TOPIC_SUBSCRIPTIONS_LIMIT_EXCEEDED = "Topic subscriptions limit exceeded for this account", pe.OPERATIONS_RATE_LIMIT_EXCEEDED = "Request rate limit exceeded for this account", pe.THROUGHPUT_RATE_LIMIT_EXCEEDED = "Bandwidth limit exceeded for this account", pe.REQUEST_SIZE_LIMIT_EXCEEDED = "Request size limit exceeded for this account", pe.ITEM_SIZE_LIMIT_EXCEEDED = "Item size limit exceeded for this account", pe.ELEMENT_SIZE_LIMIT_EXCEEDED = "Element size limit exceeded for this account", pe.UNKNOWN_LIMIT_EXCEEDED = "Limit exceeded for this account";
  })(w || (w = {}));
  class q extends d {
    constructor(he, fe = 0, ye = void 0, Re = void 0, be) {
      super(he, fe, ye, Re), this._errorCode = s.LIMIT_EXCEEDED_ERROR, this._messageWrapper = this.determineMessageWrapper(), this.errCause = be;
    }
    determineMessageWrapper() {
      if (this.errCause !== void 0)
        switch (this.errCause) {
          case "topic_subscriptions_limit_exceeded":
            return w.TOPIC_SUBSCRIPTIONS_LIMIT_EXCEEDED;
          case "operations_rate_limit_exceeded":
            return w.OPERATIONS_RATE_LIMIT_EXCEEDED;
          case "throughput_rate_limit_exceeded":
            return w.THROUGHPUT_RATE_LIMIT_EXCEEDED;
          case "request_size_limit_exceeded":
            return w.REQUEST_SIZE_LIMIT_EXCEEDED;
          case "item_size_limit_exceeded":
            return w.ITEM_SIZE_LIMIT_EXCEEDED;
          case "element_size_limit_exceeded":
            return w.ELEMENT_SIZE_LIMIT_EXCEEDED;
          default:
            return w.UNKNOWN_LIMIT_EXCEEDED;
        }
      if (this._transportDetails.grpc.details !== void 0) {
        const he = this._transportDetails.grpc.details.toLowerCase();
        if (he.includes("subscribers"))
          return w.TOPIC_SUBSCRIPTIONS_LIMIT_EXCEEDED;
        if (he.includes("operations"))
          return w.OPERATIONS_RATE_LIMIT_EXCEEDED;
        if (he.includes("throughput"))
          return w.THROUGHPUT_RATE_LIMIT_EXCEEDED;
        if (he.includes("request limit"))
          return w.REQUEST_SIZE_LIMIT_EXCEEDED;
        if (he.includes("item size"))
          return w.ITEM_SIZE_LIMIT_EXCEEDED;
        if (he.includes("element size"))
          return w.ELEMENT_SIZE_LIMIT_EXCEEDED;
      }
      return w.UNKNOWN_LIMIT_EXCEEDED;
    }
  }
  p.LimitExceededError = q;
  class j extends d {
    constructor() {
      super(...arguments), this._errorCode = s.CACHE_NOT_FOUND_ERROR, this._messageWrapper = "A cache with the specified name does not exist.  To resolve this error, make sure you have created the cache before attempting to use it";
    }
  }
  p.CacheNotFoundError = j;
  class k extends d {
    constructor() {
      super(...arguments), this._errorCode = s.STORE_NOT_FOUND_ERROR, this._messageWrapper = "A store with the specified name does not exist.  To resolve this error, make sure you have created the store before attempting to use it";
    }
  }
  p.StoreNotFoundError = k;
  class z extends d {
    constructor() {
      super(...arguments), this._errorCode = s.STORE_ITEM_NOT_FOUND_ERROR, this._messageWrapper = "An item with the specified key does not exist";
    }
  }
  p.StoreItemNotFoundError = z;
  class $ extends d {
    constructor() {
      super(...arguments), this._errorCode = s.PERMISSION_ERROR, this._messageWrapper = "Insufficient permissions to perform an operation on a cache";
    }
  }
  p.PermissionError = $;
  class re extends d {
    constructor() {
      super(...arguments), this._errorCode = s.SERVER_UNAVAILABLE, this._messageWrapper = "The server was unable to handle the request; consider retrying.  If the error persists, please contact us at support@momentohq.com";
    }
  }
  p.ServerUnavailableError = re;
  class oe extends d {
    constructor() {
      super(...arguments), this._errorCode = s.TIMEOUT_ERROR, this._messageWrapper = "The client's configured timeout was exceeded; you may need to use a Configuration with more lenient timeouts";
    }
  }
  p.TimeoutError = oe;
  class le extends d {
    constructor() {
      super(...arguments), this._errorCode = s.UNKNOWN_ERROR, this._messageWrapper = "Unknown error has occurred";
    }
  }
  p.UnknownError = le;
  class ue extends d {
    constructor() {
      super(...arguments), this._errorCode = s.UNKNOWN_SERVICE_ERROR, this._messageWrapper = "Service returned an unknown response; please contact us at support@momentohq.com";
    }
  }
  p.UnknownServiceError = ue;
})(errors);
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(errors, p);
})(errors$1);
function e(p) {
  this.message = p;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r = typeof window != "undefined" && window.atob && window.atob.bind(window) || function(p) {
  var s = String(p).replace(/=+$/, "");
  if (s.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var h, c, d = 0, l = 0, g = ""; c = s.charAt(l++); ~c && (h = d % 4 ? 64 * h + c : c, d++ % 4) ? g += String.fromCharCode(255 & h >> (-2 * d & 6)) : 0) c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(c);
  return g;
};
function t(p) {
  var s = p.replace(/-/g, "+").replace(/_/g, "/");
  switch (s.length % 4) {
    case 0:
      break;
    case 2:
      s += "==";
      break;
    case 3:
      s += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(h) {
      return decodeURIComponent(r(h).replace(/(.)/g, function(c, d) {
        var l = d.charCodeAt(0).toString(16).toUpperCase();
        return l.length < 2 && (l = "0" + l), "%" + l;
      }));
    }(s);
  } catch (h) {
    return r(s);
  }
}
function n(p) {
  this.message = p;
}
function o(p, s) {
  if (typeof p != "string") throw new n("Invalid token specified");
  var h = (s = s || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(t(p.split(".")[h]));
  } catch (c) {
    throw new n("Invalid token specified: " + c.message);
  }
}
n.prototype = new Error(), n.prototype.name = "InvalidTokenError";
const jwtDecode_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InvalidTokenError: n,
  default: o
}, Symbol.toStringTag, { value: "Module" })), require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(jwtDecode_esm);
var validators = {}, string = {}, buffer = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array != "undefined" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i)
  lookup[i] = code[i], revLookup[code.charCodeAt(i)] = i;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(p) {
  var s = p.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var h = p.indexOf("=");
  h === -1 && (h = s);
  var c = h === s ? 0 : 4 - h % 4;
  return [h, c];
}
function byteLength(p) {
  var s = getLens(p), h = s[0], c = s[1];
  return (h + c) * 3 / 4 - c;
}
function _byteLength(p, s, h) {
  return (s + h) * 3 / 4 - h;
}
function toByteArray(p) {
  var s, h = getLens(p), c = h[0], d = h[1], l = new Arr(_byteLength(p, c, d)), g = 0, f = d > 0 ? c - 4 : c, _;
  for (_ = 0; _ < f; _ += 4)
    s = revLookup[p.charCodeAt(_)] << 18 | revLookup[p.charCodeAt(_ + 1)] << 12 | revLookup[p.charCodeAt(_ + 2)] << 6 | revLookup[p.charCodeAt(_ + 3)], l[g++] = s >> 16 & 255, l[g++] = s >> 8 & 255, l[g++] = s & 255;
  return d === 2 && (s = revLookup[p.charCodeAt(_)] << 2 | revLookup[p.charCodeAt(_ + 1)] >> 4, l[g++] = s & 255), d === 1 && (s = revLookup[p.charCodeAt(_)] << 10 | revLookup[p.charCodeAt(_ + 1)] << 4 | revLookup[p.charCodeAt(_ + 2)] >> 2, l[g++] = s >> 8 & 255, l[g++] = s & 255), l;
}
function tripletToBase64(p) {
  return lookup[p >> 18 & 63] + lookup[p >> 12 & 63] + lookup[p >> 6 & 63] + lookup[p & 63];
}
function encodeChunk(p, s, h) {
  for (var c, d = [], l = s; l < h; l += 3)
    c = (p[l] << 16 & 16711680) + (p[l + 1] << 8 & 65280) + (p[l + 2] & 255), d.push(tripletToBase64(c));
  return d.join("");
}
function fromByteArray(p) {
  for (var s, h = p.length, c = h % 3, d = [], l = 16383, g = 0, f = h - c; g < f; g += l)
    d.push(encodeChunk(p, g, g + l > f ? f : g + l));
  return c === 1 ? (s = p[h - 1], d.push(
    lookup[s >> 2] + lookup[s << 4 & 63] + "=="
  )) : c === 2 && (s = (p[h - 2] << 8) + p[h - 1], d.push(
    lookup[s >> 10] + lookup[s >> 4 & 63] + lookup[s << 2 & 63] + "="
  )), d.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(p, s, h, c, d) {
  var l, g, f = d * 8 - c - 1, _ = (1 << f) - 1, te = _ >> 1, ae = -7, ie = h ? d - 1 : 0, se = h ? -1 : 1, m = p[s + ie];
  for (ie += se, l = m & (1 << -ae) - 1, m >>= -ae, ae += f; ae > 0; l = l * 256 + p[s + ie], ie += se, ae -= 8)
    ;
  for (g = l & (1 << -ae) - 1, l >>= -ae, ae += c; ae > 0; g = g * 256 + p[s + ie], ie += se, ae -= 8)
    ;
  if (l === 0)
    l = 1 - te;
  else {
    if (l === _)
      return g ? NaN : (m ? -1 : 1) * (1 / 0);
    g = g + Math.pow(2, c), l = l - te;
  }
  return (m ? -1 : 1) * g * Math.pow(2, l - c);
};
ieee754.write = function(p, s, h, c, d, l) {
  var g, f, _, te = l * 8 - d - 1, ae = (1 << te) - 1, ie = ae >> 1, se = d === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, m = c ? 0 : l - 1, w = c ? 1 : -1, q = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
  for (s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (f = isNaN(s) ? 1 : 0, g = ae) : (g = Math.floor(Math.log(s) / Math.LN2), s * (_ = Math.pow(2, -g)) < 1 && (g--, _ *= 2), g + ie >= 1 ? s += se / _ : s += se * Math.pow(2, 1 - ie), s * _ >= 2 && (g++, _ /= 2), g + ie >= ae ? (f = 0, g = ae) : g + ie >= 1 ? (f = (s * _ - 1) * Math.pow(2, d), g = g + ie) : (f = s * Math.pow(2, ie - 1) * Math.pow(2, d), g = 0)); d >= 8; p[h + m] = f & 255, m += w, f /= 256, d -= 8)
    ;
  for (g = g << d | f, te += d; te > 0; p[h + m] = g & 255, m += w, g /= 256, te -= 8)
    ;
  p[h + m - w] |= q * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(p) {
  const s = base64Js, h = ieee754, c = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  p.Buffer = f, p.SlowBuffer = z, p.INSPECT_MAX_BYTES = 50;
  const d = 2147483647;
  p.kMaxLength = d, f.TYPED_ARRAY_SUPPORT = l(), !f.TYPED_ARRAY_SUPPORT && typeof console != "undefined" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function l() {
    try {
      const ee = new Uint8Array(1), b = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(b, Uint8Array.prototype), Object.setPrototypeOf(ee, b), ee.foo() === 42;
    } catch (ee) {
      return !1;
    }
  }
  Object.defineProperty(f.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (f.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(f.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (f.isBuffer(this))
        return this.byteOffset;
    }
  });
  function g(ee) {
    if (ee > d)
      throw new RangeError('The value "' + ee + '" is invalid for option "size"');
    const b = new Uint8Array(ee);
    return Object.setPrototypeOf(b, f.prototype), b;
  }
  function f(ee, b, M) {
    if (typeof ee == "number") {
      if (typeof b == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return ie(ee);
    }
    return _(ee, b, M);
  }
  f.poolSize = 8192;
  function _(ee, b, M) {
    if (typeof ee == "string")
      return se(ee, b);
    if (ArrayBuffer.isView(ee))
      return w(ee);
    if (ee == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ee
      );
    if (je(ee, ArrayBuffer) || ee && je(ee.buffer, ArrayBuffer) || typeof SharedArrayBuffer != "undefined" && (je(ee, SharedArrayBuffer) || ee && je(ee.buffer, SharedArrayBuffer)))
      return q(ee, b, M);
    if (typeof ee == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const ne = ee.valueOf && ee.valueOf();
    if (ne != null && ne !== ee)
      return f.from(ne, b, M);
    const ce = j(ee);
    if (ce) return ce;
    if (typeof Symbol != "undefined" && Symbol.toPrimitive != null && typeof ee[Symbol.toPrimitive] == "function")
      return f.from(ee[Symbol.toPrimitive]("string"), b, M);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ee
    );
  }
  f.from = function(ee, b, M) {
    return _(ee, b, M);
  }, Object.setPrototypeOf(f.prototype, Uint8Array.prototype), Object.setPrototypeOf(f, Uint8Array);
  function te(ee) {
    if (typeof ee != "number")
      throw new TypeError('"size" argument must be of type number');
    if (ee < 0)
      throw new RangeError('The value "' + ee + '" is invalid for option "size"');
  }
  function ae(ee, b, M) {
    return te(ee), ee <= 0 ? g(ee) : b !== void 0 ? typeof M == "string" ? g(ee).fill(b, M) : g(ee).fill(b) : g(ee);
  }
  f.alloc = function(ee, b, M) {
    return ae(ee, b, M);
  };
  function ie(ee) {
    return te(ee), g(ee < 0 ? 0 : k(ee) | 0);
  }
  f.allocUnsafe = function(ee) {
    return ie(ee);
  }, f.allocUnsafeSlow = function(ee) {
    return ie(ee);
  };
  function se(ee, b) {
    if ((typeof b != "string" || b === "") && (b = "utf8"), !f.isEncoding(b))
      throw new TypeError("Unknown encoding: " + b);
    const M = $(ee, b) | 0;
    let ne = g(M);
    const ce = ne.write(ee, b);
    return ce !== M && (ne = ne.slice(0, ce)), ne;
  }
  function m(ee) {
    const b = ee.length < 0 ? 0 : k(ee.length) | 0, M = g(b);
    for (let ne = 0; ne < b; ne += 1)
      M[ne] = ee[ne] & 255;
    return M;
  }
  function w(ee) {
    if (je(ee, Uint8Array)) {
      const b = new Uint8Array(ee);
      return q(b.buffer, b.byteOffset, b.byteLength);
    }
    return m(ee);
  }
  function q(ee, b, M) {
    if (b < 0 || ee.byteLength < b)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (ee.byteLength < b + (M || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let ne;
    return b === void 0 && M === void 0 ? ne = new Uint8Array(ee) : M === void 0 ? ne = new Uint8Array(ee, b) : ne = new Uint8Array(ee, b, M), Object.setPrototypeOf(ne, f.prototype), ne;
  }
  function j(ee) {
    if (f.isBuffer(ee)) {
      const b = k(ee.length) | 0, M = g(b);
      return M.length === 0 || ee.copy(M, 0, 0, b), M;
    }
    if (ee.length !== void 0)
      return typeof ee.length != "number" || Ye(ee.length) ? g(0) : m(ee);
    if (ee.type === "Buffer" && Array.isArray(ee.data))
      return m(ee.data);
  }
  function k(ee) {
    if (ee >= d)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + d.toString(16) + " bytes");
    return ee | 0;
  }
  function z(ee) {
    return +ee != ee && (ee = 0), f.alloc(+ee);
  }
  f.isBuffer = function(b) {
    return b != null && b._isBuffer === !0 && b !== f.prototype;
  }, f.compare = function(b, M) {
    if (je(b, Uint8Array) && (b = f.from(b, b.offset, b.byteLength)), je(M, Uint8Array) && (M = f.from(M, M.offset, M.byteLength)), !f.isBuffer(b) || !f.isBuffer(M))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (b === M) return 0;
    let ne = b.length, ce = M.length;
    for (let ge = 0, de = Math.min(ne, ce); ge < de; ++ge)
      if (b[ge] !== M[ge]) {
        ne = b[ge], ce = M[ge];
        break;
      }
    return ne < ce ? -1 : ce < ne ? 1 : 0;
  }, f.isEncoding = function(b) {
    switch (String(b).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, f.concat = function(b, M) {
    if (!Array.isArray(b))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (b.length === 0)
      return f.alloc(0);
    let ne;
    if (M === void 0)
      for (M = 0, ne = 0; ne < b.length; ++ne)
        M += b[ne].length;
    const ce = f.allocUnsafe(M);
    let ge = 0;
    for (ne = 0; ne < b.length; ++ne) {
      let de = b[ne];
      if (je(de, Uint8Array))
        ge + de.length > ce.length ? (f.isBuffer(de) || (de = f.from(de)), de.copy(ce, ge)) : Uint8Array.prototype.set.call(
          ce,
          de,
          ge
        );
      else if (f.isBuffer(de))
        de.copy(ce, ge);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ge += de.length;
    }
    return ce;
  };
  function $(ee, b) {
    if (f.isBuffer(ee))
      return ee.length;
    if (ArrayBuffer.isView(ee) || je(ee, ArrayBuffer))
      return ee.byteLength;
    if (typeof ee != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ee
      );
    const M = ee.length, ne = arguments.length > 2 && arguments[2] === !0;
    if (!ne && M === 0) return 0;
    let ce = !1;
    for (; ; )
      switch (b) {
        case "ascii":
        case "latin1":
        case "binary":
          return M;
        case "utf8":
        case "utf-8":
          return Je(ee).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return M * 2;
        case "hex":
          return M >>> 1;
        case "base64":
          return st(ee).length;
        default:
          if (ce)
            return ne ? -1 : Je(ee).length;
          b = ("" + b).toLowerCase(), ce = !0;
      }
  }
  f.byteLength = $;
  function re(ee, b, M) {
    let ne = !1;
    if ((b === void 0 || b < 0) && (b = 0), b > this.length || ((M === void 0 || M > this.length) && (M = this.length), M <= 0) || (M >>>= 0, b >>>= 0, M <= b))
      return "";
    for (ee || (ee = "utf8"); ; )
      switch (ee) {
        case "hex":
          return He(this, b, M);
        case "utf8":
        case "utf-8":
          return Me(this, b, M);
        case "ascii":
          return xe(this, b, M);
        case "latin1":
        case "binary":
          return We(this, b, M);
        case "base64":
          return be(this, b, M);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return at(this, b, M);
        default:
          if (ne) throw new TypeError("Unknown encoding: " + ee);
          ee = (ee + "").toLowerCase(), ne = !0;
      }
  }
  f.prototype._isBuffer = !0;
  function oe(ee, b, M) {
    const ne = ee[b];
    ee[b] = ee[M], ee[M] = ne;
  }
  f.prototype.swap16 = function() {
    const b = this.length;
    if (b % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let M = 0; M < b; M += 2)
      oe(this, M, M + 1);
    return this;
  }, f.prototype.swap32 = function() {
    const b = this.length;
    if (b % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let M = 0; M < b; M += 4)
      oe(this, M, M + 3), oe(this, M + 1, M + 2);
    return this;
  }, f.prototype.swap64 = function() {
    const b = this.length;
    if (b % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let M = 0; M < b; M += 8)
      oe(this, M, M + 7), oe(this, M + 1, M + 6), oe(this, M + 2, M + 5), oe(this, M + 3, M + 4);
    return this;
  }, f.prototype.toString = function() {
    const b = this.length;
    return b === 0 ? "" : arguments.length === 0 ? Me(this, 0, b) : re.apply(this, arguments);
  }, f.prototype.toLocaleString = f.prototype.toString, f.prototype.equals = function(b) {
    if (!f.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    return this === b ? !0 : f.compare(this, b) === 0;
  }, f.prototype.inspect = function() {
    let b = "";
    const M = p.INSPECT_MAX_BYTES;
    return b = this.toString("hex", 0, M).replace(/(.{2})/g, "$1 ").trim(), this.length > M && (b += " ... "), "<Buffer " + b + ">";
  }, c && (f.prototype[c] = f.prototype.inspect), f.prototype.compare = function(b, M, ne, ce, ge) {
    if (je(b, Uint8Array) && (b = f.from(b, b.offset, b.byteLength)), !f.isBuffer(b))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof b
      );
    if (M === void 0 && (M = 0), ne === void 0 && (ne = b ? b.length : 0), ce === void 0 && (ce = 0), ge === void 0 && (ge = this.length), M < 0 || ne > b.length || ce < 0 || ge > this.length)
      throw new RangeError("out of range index");
    if (ce >= ge && M >= ne)
      return 0;
    if (ce >= ge)
      return -1;
    if (M >= ne)
      return 1;
    if (M >>>= 0, ne >>>= 0, ce >>>= 0, ge >>>= 0, this === b) return 0;
    let de = ge - ce, Se = ne - M;
    const Be = Math.min(de, Se), Ee = this.slice(ce, ge), Fe = b.slice(M, ne);
    for (let me = 0; me < Be; ++me)
      if (Ee[me] !== Fe[me]) {
        de = Ee[me], Se = Fe[me];
        break;
      }
    return de < Se ? -1 : Se < de ? 1 : 0;
  };
  function le(ee, b, M, ne, ce) {
    if (ee.length === 0) return -1;
    if (typeof M == "string" ? (ne = M, M = 0) : M > 2147483647 ? M = 2147483647 : M < -2147483648 && (M = -2147483648), M = +M, Ye(M) && (M = ce ? 0 : ee.length - 1), M < 0 && (M = ee.length + M), M >= ee.length) {
      if (ce) return -1;
      M = ee.length - 1;
    } else if (M < 0)
      if (ce) M = 0;
      else return -1;
    if (typeof b == "string" && (b = f.from(b, ne)), f.isBuffer(b))
      return b.length === 0 ? -1 : ue(ee, b, M, ne, ce);
    if (typeof b == "number")
      return b = b & 255, typeof Uint8Array.prototype.indexOf == "function" ? ce ? Uint8Array.prototype.indexOf.call(ee, b, M) : Uint8Array.prototype.lastIndexOf.call(ee, b, M) : ue(ee, [b], M, ne, ce);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ue(ee, b, M, ne, ce) {
    let ge = 1, de = ee.length, Se = b.length;
    if (ne !== void 0 && (ne = String(ne).toLowerCase(), ne === "ucs2" || ne === "ucs-2" || ne === "utf16le" || ne === "utf-16le")) {
      if (ee.length < 2 || b.length < 2)
        return -1;
      ge = 2, de /= 2, Se /= 2, M /= 2;
    }
    function Be(Fe, me) {
      return ge === 1 ? Fe[me] : Fe.readUInt16BE(me * ge);
    }
    let Ee;
    if (ce) {
      let Fe = -1;
      for (Ee = M; Ee < de; Ee++)
        if (Be(ee, Ee) === Be(b, Fe === -1 ? 0 : Ee - Fe)) {
          if (Fe === -1 && (Fe = Ee), Ee - Fe + 1 === Se) return Fe * ge;
        } else
          Fe !== -1 && (Ee -= Ee - Fe), Fe = -1;
    } else
      for (M + Se > de && (M = de - Se), Ee = M; Ee >= 0; Ee--) {
        let Fe = !0;
        for (let me = 0; me < Se; me++)
          if (Be(ee, Ee + me) !== Be(b, me)) {
            Fe = !1;
            break;
          }
        if (Fe) return Ee;
      }
    return -1;
  }
  f.prototype.includes = function(b, M, ne) {
    return this.indexOf(b, M, ne) !== -1;
  }, f.prototype.indexOf = function(b, M, ne) {
    return le(this, b, M, ne, !0);
  }, f.prototype.lastIndexOf = function(b, M, ne) {
    return le(this, b, M, ne, !1);
  };
  function pe(ee, b, M, ne) {
    M = Number(M) || 0;
    const ce = ee.length - M;
    ne ? (ne = Number(ne), ne > ce && (ne = ce)) : ne = ce;
    const ge = b.length;
    ne > ge / 2 && (ne = ge / 2);
    let de;
    for (de = 0; de < ne; ++de) {
      const Se = parseInt(b.substr(de * 2, 2), 16);
      if (Ye(Se)) return de;
      ee[M + de] = Se;
    }
    return de;
  }
  function he(ee, b, M, ne) {
    return $e(Je(b, ee.length - M), ee, M, ne);
  }
  function fe(ee, b, M, ne) {
    return $e(pt(b), ee, M, ne);
  }
  function ye(ee, b, M, ne) {
    return $e(st(b), ee, M, ne);
  }
  function Re(ee, b, M, ne) {
    return $e(gt(b, ee.length - M), ee, M, ne);
  }
  f.prototype.write = function(b, M, ne, ce) {
    if (M === void 0)
      ce = "utf8", ne = this.length, M = 0;
    else if (ne === void 0 && typeof M == "string")
      ce = M, ne = this.length, M = 0;
    else if (isFinite(M))
      M = M >>> 0, isFinite(ne) ? (ne = ne >>> 0, ce === void 0 && (ce = "utf8")) : (ce = ne, ne = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const ge = this.length - M;
    if ((ne === void 0 || ne > ge) && (ne = ge), b.length > 0 && (ne < 0 || M < 0) || M > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    ce || (ce = "utf8");
    let de = !1;
    for (; ; )
      switch (ce) {
        case "hex":
          return pe(this, b, M, ne);
        case "utf8":
        case "utf-8":
          return he(this, b, M, ne);
        case "ascii":
        case "latin1":
        case "binary":
          return fe(this, b, M, ne);
        case "base64":
          return ye(this, b, M, ne);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Re(this, b, M, ne);
        default:
          if (de) throw new TypeError("Unknown encoding: " + ce);
          ce = ("" + ce).toLowerCase(), de = !0;
      }
  }, f.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function be(ee, b, M) {
    return b === 0 && M === ee.length ? s.fromByteArray(ee) : s.fromByteArray(ee.slice(b, M));
  }
  function Me(ee, b, M) {
    M = Math.min(ee.length, M);
    const ne = [];
    let ce = b;
    for (; ce < M; ) {
      const ge = ee[ce];
      let de = null, Se = ge > 239 ? 4 : ge > 223 ? 3 : ge > 191 ? 2 : 1;
      if (ce + Se <= M) {
        let Be, Ee, Fe, me;
        switch (Se) {
          case 1:
            ge < 128 && (de = ge);
            break;
          case 2:
            Be = ee[ce + 1], (Be & 192) === 128 && (me = (ge & 31) << 6 | Be & 63, me > 127 && (de = me));
            break;
          case 3:
            Be = ee[ce + 1], Ee = ee[ce + 2], (Be & 192) === 128 && (Ee & 192) === 128 && (me = (ge & 15) << 12 | (Be & 63) << 6 | Ee & 63, me > 2047 && (me < 55296 || me > 57343) && (de = me));
            break;
          case 4:
            Be = ee[ce + 1], Ee = ee[ce + 2], Fe = ee[ce + 3], (Be & 192) === 128 && (Ee & 192) === 128 && (Fe & 192) === 128 && (me = (ge & 15) << 18 | (Be & 63) << 12 | (Ee & 63) << 6 | Fe & 63, me > 65535 && me < 1114112 && (de = me));
        }
      }
      de === null ? (de = 65533, Se = 1) : de > 65535 && (de -= 65536, ne.push(de >>> 10 & 1023 | 55296), de = 56320 | de & 1023), ne.push(de), ce += Se;
    }
    return we(ne);
  }
  const ve = 4096;
  function we(ee) {
    const b = ee.length;
    if (b <= ve)
      return String.fromCharCode.apply(String, ee);
    let M = "", ne = 0;
    for (; ne < b; )
      M += String.fromCharCode.apply(
        String,
        ee.slice(ne, ne += ve)
      );
    return M;
  }
  function xe(ee, b, M) {
    let ne = "";
    M = Math.min(ee.length, M);
    for (let ce = b; ce < M; ++ce)
      ne += String.fromCharCode(ee[ce] & 127);
    return ne;
  }
  function We(ee, b, M) {
    let ne = "";
    M = Math.min(ee.length, M);
    for (let ce = b; ce < M; ++ce)
      ne += String.fromCharCode(ee[ce]);
    return ne;
  }
  function He(ee, b, M) {
    const ne = ee.length;
    (!b || b < 0) && (b = 0), (!M || M < 0 || M > ne) && (M = ne);
    let ce = "";
    for (let ge = b; ge < M; ++ge)
      ce += dt[ee[ge]];
    return ce;
  }
  function at(ee, b, M) {
    const ne = ee.slice(b, M);
    let ce = "";
    for (let ge = 0; ge < ne.length - 1; ge += 2)
      ce += String.fromCharCode(ne[ge] + ne[ge + 1] * 256);
    return ce;
  }
  f.prototype.slice = function(b, M) {
    const ne = this.length;
    b = ~~b, M = M === void 0 ? ne : ~~M, b < 0 ? (b += ne, b < 0 && (b = 0)) : b > ne && (b = ne), M < 0 ? (M += ne, M < 0 && (M = 0)) : M > ne && (M = ne), M < b && (M = b);
    const ce = this.subarray(b, M);
    return Object.setPrototypeOf(ce, f.prototype), ce;
  };
  function Te(ee, b, M) {
    if (ee % 1 !== 0 || ee < 0) throw new RangeError("offset is not uint");
    if (ee + b > M) throw new RangeError("Trying to access beyond buffer length");
  }
  f.prototype.readUintLE = f.prototype.readUIntLE = function(b, M, ne) {
    b = b >>> 0, M = M >>> 0, ne || Te(b, M, this.length);
    let ce = this[b], ge = 1, de = 0;
    for (; ++de < M && (ge *= 256); )
      ce += this[b + de] * ge;
    return ce;
  }, f.prototype.readUintBE = f.prototype.readUIntBE = function(b, M, ne) {
    b = b >>> 0, M = M >>> 0, ne || Te(b, M, this.length);
    let ce = this[b + --M], ge = 1;
    for (; M > 0 && (ge *= 256); )
      ce += this[b + --M] * ge;
    return ce;
  }, f.prototype.readUint8 = f.prototype.readUInt8 = function(b, M) {
    return b = b >>> 0, M || Te(b, 1, this.length), this[b];
  }, f.prototype.readUint16LE = f.prototype.readUInt16LE = function(b, M) {
    return b = b >>> 0, M || Te(b, 2, this.length), this[b] | this[b + 1] << 8;
  }, f.prototype.readUint16BE = f.prototype.readUInt16BE = function(b, M) {
    return b = b >>> 0, M || Te(b, 2, this.length), this[b] << 8 | this[b + 1];
  }, f.prototype.readUint32LE = f.prototype.readUInt32LE = function(b, M) {
    return b = b >>> 0, M || Te(b, 4, this.length), (this[b] | this[b + 1] << 8 | this[b + 2] << 16) + this[b + 3] * 16777216;
  }, f.prototype.readUint32BE = f.prototype.readUInt32BE = function(b, M) {
    return b = b >>> 0, M || Te(b, 4, this.length), this[b] * 16777216 + (this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3]);
  }, f.prototype.readBigUInt64LE = ke(function(b) {
    b = b >>> 0, qe(b, "offset");
    const M = this[b], ne = this[b + 7];
    (M === void 0 || ne === void 0) && ze(b, this.length - 8);
    const ce = M + this[++b] * 2 ** 8 + this[++b] * 2 ** 16 + this[++b] * 2 ** 24, ge = this[++b] + this[++b] * 2 ** 8 + this[++b] * 2 ** 16 + ne * 2 ** 24;
    return BigInt(ce) + (BigInt(ge) << BigInt(32));
  }), f.prototype.readBigUInt64BE = ke(function(b) {
    b = b >>> 0, qe(b, "offset");
    const M = this[b], ne = this[b + 7];
    (M === void 0 || ne === void 0) && ze(b, this.length - 8);
    const ce = M * 2 ** 24 + this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + this[++b], ge = this[++b] * 2 ** 24 + this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + ne;
    return (BigInt(ce) << BigInt(32)) + BigInt(ge);
  }), f.prototype.readIntLE = function(b, M, ne) {
    b = b >>> 0, M = M >>> 0, ne || Te(b, M, this.length);
    let ce = this[b], ge = 1, de = 0;
    for (; ++de < M && (ge *= 256); )
      ce += this[b + de] * ge;
    return ge *= 128, ce >= ge && (ce -= Math.pow(2, 8 * M)), ce;
  }, f.prototype.readIntBE = function(b, M, ne) {
    b = b >>> 0, M = M >>> 0, ne || Te(b, M, this.length);
    let ce = M, ge = 1, de = this[b + --ce];
    for (; ce > 0 && (ge *= 256); )
      de += this[b + --ce] * ge;
    return ge *= 128, de >= ge && (de -= Math.pow(2, 8 * M)), de;
  }, f.prototype.readInt8 = function(b, M) {
    return b = b >>> 0, M || Te(b, 1, this.length), this[b] & 128 ? (255 - this[b] + 1) * -1 : this[b];
  }, f.prototype.readInt16LE = function(b, M) {
    b = b >>> 0, M || Te(b, 2, this.length);
    const ne = this[b] | this[b + 1] << 8;
    return ne & 32768 ? ne | 4294901760 : ne;
  }, f.prototype.readInt16BE = function(b, M) {
    b = b >>> 0, M || Te(b, 2, this.length);
    const ne = this[b + 1] | this[b] << 8;
    return ne & 32768 ? ne | 4294901760 : ne;
  }, f.prototype.readInt32LE = function(b, M) {
    return b = b >>> 0, M || Te(b, 4, this.length), this[b] | this[b + 1] << 8 | this[b + 2] << 16 | this[b + 3] << 24;
  }, f.prototype.readInt32BE = function(b, M) {
    return b = b >>> 0, M || Te(b, 4, this.length), this[b] << 24 | this[b + 1] << 16 | this[b + 2] << 8 | this[b + 3];
  }, f.prototype.readBigInt64LE = ke(function(b) {
    b = b >>> 0, qe(b, "offset");
    const M = this[b], ne = this[b + 7];
    (M === void 0 || ne === void 0) && ze(b, this.length - 8);
    const ce = this[b + 4] + this[b + 5] * 2 ** 8 + this[b + 6] * 2 ** 16 + (ne << 24);
    return (BigInt(ce) << BigInt(32)) + BigInt(M + this[++b] * 2 ** 8 + this[++b] * 2 ** 16 + this[++b] * 2 ** 24);
  }), f.prototype.readBigInt64BE = ke(function(b) {
    b = b >>> 0, qe(b, "offset");
    const M = this[b], ne = this[b + 7];
    (M === void 0 || ne === void 0) && ze(b, this.length - 8);
    const ce = (M << 24) + // Overflow
    this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + this[++b];
    return (BigInt(ce) << BigInt(32)) + BigInt(this[++b] * 2 ** 24 + this[++b] * 2 ** 16 + this[++b] * 2 ** 8 + ne);
  }), f.prototype.readFloatLE = function(b, M) {
    return b = b >>> 0, M || Te(b, 4, this.length), h.read(this, b, !0, 23, 4);
  }, f.prototype.readFloatBE = function(b, M) {
    return b = b >>> 0, M || Te(b, 4, this.length), h.read(this, b, !1, 23, 4);
  }, f.prototype.readDoubleLE = function(b, M) {
    return b = b >>> 0, M || Te(b, 8, this.length), h.read(this, b, !0, 52, 8);
  }, f.prototype.readDoubleBE = function(b, M) {
    return b = b >>> 0, M || Te(b, 8, this.length), h.read(this, b, !1, 52, 8);
  };
  function Le(ee, b, M, ne, ce, ge) {
    if (!f.isBuffer(ee)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (b > ce || b < ge) throw new RangeError('"value" argument is out of bounds');
    if (M + ne > ee.length) throw new RangeError("Index out of range");
  }
  f.prototype.writeUintLE = f.prototype.writeUIntLE = function(b, M, ne, ce) {
    if (b = +b, M = M >>> 0, ne = ne >>> 0, !ce) {
      const Se = Math.pow(2, 8 * ne) - 1;
      Le(this, b, M, ne, Se, 0);
    }
    let ge = 1, de = 0;
    for (this[M] = b & 255; ++de < ne && (ge *= 256); )
      this[M + de] = b / ge & 255;
    return M + ne;
  }, f.prototype.writeUintBE = f.prototype.writeUIntBE = function(b, M, ne, ce) {
    if (b = +b, M = M >>> 0, ne = ne >>> 0, !ce) {
      const Se = Math.pow(2, 8 * ne) - 1;
      Le(this, b, M, ne, Se, 0);
    }
    let ge = ne - 1, de = 1;
    for (this[M + ge] = b & 255; --ge >= 0 && (de *= 256); )
      this[M + ge] = b / de & 255;
    return M + ne;
  }, f.prototype.writeUint8 = f.prototype.writeUInt8 = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 1, 255, 0), this[M] = b & 255, M + 1;
  }, f.prototype.writeUint16LE = f.prototype.writeUInt16LE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 2, 65535, 0), this[M] = b & 255, this[M + 1] = b >>> 8, M + 2;
  }, f.prototype.writeUint16BE = f.prototype.writeUInt16BE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 2, 65535, 0), this[M] = b >>> 8, this[M + 1] = b & 255, M + 2;
  }, f.prototype.writeUint32LE = f.prototype.writeUInt32LE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 4, 4294967295, 0), this[M + 3] = b >>> 24, this[M + 2] = b >>> 16, this[M + 1] = b >>> 8, this[M] = b & 255, M + 4;
  }, f.prototype.writeUint32BE = f.prototype.writeUInt32BE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 4, 4294967295, 0), this[M] = b >>> 24, this[M + 1] = b >>> 16, this[M + 2] = b >>> 8, this[M + 3] = b & 255, M + 4;
  };
  function Ze(ee, b, M, ne, ce) {
    nt(b, ne, ce, ee, M, 7);
    let ge = Number(b & BigInt(4294967295));
    ee[M++] = ge, ge = ge >> 8, ee[M++] = ge, ge = ge >> 8, ee[M++] = ge, ge = ge >> 8, ee[M++] = ge;
    let de = Number(b >> BigInt(32) & BigInt(4294967295));
    return ee[M++] = de, de = de >> 8, ee[M++] = de, de = de >> 8, ee[M++] = de, de = de >> 8, ee[M++] = de, M;
  }
  function Qe(ee, b, M, ne, ce) {
    nt(b, ne, ce, ee, M, 7);
    let ge = Number(b & BigInt(4294967295));
    ee[M + 7] = ge, ge = ge >> 8, ee[M + 6] = ge, ge = ge >> 8, ee[M + 5] = ge, ge = ge >> 8, ee[M + 4] = ge;
    let de = Number(b >> BigInt(32) & BigInt(4294967295));
    return ee[M + 3] = de, de = de >> 8, ee[M + 2] = de, de = de >> 8, ee[M + 1] = de, de = de >> 8, ee[M] = de, M + 8;
  }
  f.prototype.writeBigUInt64LE = ke(function(b, M = 0) {
    return Ze(this, b, M, BigInt(0), BigInt("0xffffffffffffffff"));
  }), f.prototype.writeBigUInt64BE = ke(function(b, M = 0) {
    return Qe(this, b, M, BigInt(0), BigInt("0xffffffffffffffff"));
  }), f.prototype.writeIntLE = function(b, M, ne, ce) {
    if (b = +b, M = M >>> 0, !ce) {
      const Be = Math.pow(2, 8 * ne - 1);
      Le(this, b, M, ne, Be - 1, -Be);
    }
    let ge = 0, de = 1, Se = 0;
    for (this[M] = b & 255; ++ge < ne && (de *= 256); )
      b < 0 && Se === 0 && this[M + ge - 1] !== 0 && (Se = 1), this[M + ge] = (b / de >> 0) - Se & 255;
    return M + ne;
  }, f.prototype.writeIntBE = function(b, M, ne, ce) {
    if (b = +b, M = M >>> 0, !ce) {
      const Be = Math.pow(2, 8 * ne - 1);
      Le(this, b, M, ne, Be - 1, -Be);
    }
    let ge = ne - 1, de = 1, Se = 0;
    for (this[M + ge] = b & 255; --ge >= 0 && (de *= 256); )
      b < 0 && Se === 0 && this[M + ge + 1] !== 0 && (Se = 1), this[M + ge] = (b / de >> 0) - Se & 255;
    return M + ne;
  }, f.prototype.writeInt8 = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 1, 127, -128), b < 0 && (b = 255 + b + 1), this[M] = b & 255, M + 1;
  }, f.prototype.writeInt16LE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 2, 32767, -32768), this[M] = b & 255, this[M + 1] = b >>> 8, M + 2;
  }, f.prototype.writeInt16BE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 2, 32767, -32768), this[M] = b >>> 8, this[M + 1] = b & 255, M + 2;
  }, f.prototype.writeInt32LE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 4, 2147483647, -2147483648), this[M] = b & 255, this[M + 1] = b >>> 8, this[M + 2] = b >>> 16, this[M + 3] = b >>> 24, M + 4;
  }, f.prototype.writeInt32BE = function(b, M, ne) {
    return b = +b, M = M >>> 0, ne || Le(this, b, M, 4, 2147483647, -2147483648), b < 0 && (b = 4294967295 + b + 1), this[M] = b >>> 24, this[M + 1] = b >>> 16, this[M + 2] = b >>> 8, this[M + 3] = b & 255, M + 4;
  }, f.prototype.writeBigInt64LE = ke(function(b, M = 0) {
    return Ze(this, b, M, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), f.prototype.writeBigInt64BE = ke(function(b, M = 0) {
    return Qe(this, b, M, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function et(ee, b, M, ne, ce, ge) {
    if (M + ne > ee.length) throw new RangeError("Index out of range");
    if (M < 0) throw new RangeError("Index out of range");
  }
  function tt(ee, b, M, ne, ce) {
    return b = +b, M = M >>> 0, ce || et(ee, b, M, 4), h.write(ee, b, M, ne, 23, 4), M + 4;
  }
  f.prototype.writeFloatLE = function(b, M, ne) {
    return tt(this, b, M, !0, ne);
  }, f.prototype.writeFloatBE = function(b, M, ne) {
    return tt(this, b, M, !1, ne);
  };
  function rt(ee, b, M, ne, ce) {
    return b = +b, M = M >>> 0, ce || et(ee, b, M, 8), h.write(ee, b, M, ne, 52, 8), M + 8;
  }
  f.prototype.writeDoubleLE = function(b, M, ne) {
    return rt(this, b, M, !0, ne);
  }, f.prototype.writeDoubleBE = function(b, M, ne) {
    return rt(this, b, M, !1, ne);
  }, f.prototype.copy = function(b, M, ne, ce) {
    if (!f.isBuffer(b)) throw new TypeError("argument should be a Buffer");
    if (ne || (ne = 0), !ce && ce !== 0 && (ce = this.length), M >= b.length && (M = b.length), M || (M = 0), ce > 0 && ce < ne && (ce = ne), ce === ne || b.length === 0 || this.length === 0) return 0;
    if (M < 0)
      throw new RangeError("targetStart out of bounds");
    if (ne < 0 || ne >= this.length) throw new RangeError("Index out of range");
    if (ce < 0) throw new RangeError("sourceEnd out of bounds");
    ce > this.length && (ce = this.length), b.length - M < ce - ne && (ce = b.length - M + ne);
    const ge = ce - ne;
    return this === b && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(M, ne, ce) : Uint8Array.prototype.set.call(
      b,
      this.subarray(ne, ce),
      M
    ), ge;
  }, f.prototype.fill = function(b, M, ne, ce) {
    if (typeof b == "string") {
      if (typeof M == "string" ? (ce = M, M = 0, ne = this.length) : typeof ne == "string" && (ce = ne, ne = this.length), ce !== void 0 && typeof ce != "string")
        throw new TypeError("encoding must be a string");
      if (typeof ce == "string" && !f.isEncoding(ce))
        throw new TypeError("Unknown encoding: " + ce);
      if (b.length === 1) {
        const de = b.charCodeAt(0);
        (ce === "utf8" && de < 128 || ce === "latin1") && (b = de);
      }
    } else typeof b == "number" ? b = b & 255 : typeof b == "boolean" && (b = Number(b));
    if (M < 0 || this.length < M || this.length < ne)
      throw new RangeError("Out of range index");
    if (ne <= M)
      return this;
    M = M >>> 0, ne = ne === void 0 ? this.length : ne >>> 0, b || (b = 0);
    let ge;
    if (typeof b == "number")
      for (ge = M; ge < ne; ++ge)
        this[ge] = b;
    else {
      const de = f.isBuffer(b) ? b : f.from(b, ce), Se = de.length;
      if (Se === 0)
        throw new TypeError('The value "' + b + '" is invalid for argument "value"');
      for (ge = 0; ge < ne - M; ++ge)
        this[ge + M] = de[ge % Se];
    }
    return this;
  };
  const Ge = {};
  function Ke(ee, b, M) {
    Ge[ee] = class extends M {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: b.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${ee}]`, this.stack, delete this.name;
      }
      get code() {
        return ee;
      }
      set code(ce) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: ce,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${ee}]: ${this.message}`;
      }
    };
  }
  Ke(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(ee) {
      return ee ? `${ee} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Ke(
    "ERR_INVALID_ARG_TYPE",
    function(ee, b) {
      return `The "${ee}" argument must be of type number. Received type ${typeof b}`;
    },
    TypeError
  ), Ke(
    "ERR_OUT_OF_RANGE",
    function(ee, b, M) {
      let ne = `The value of "${ee}" is out of range.`, ce = M;
      return Number.isInteger(M) && Math.abs(M) > 2 ** 32 ? ce = ot(String(M)) : typeof M == "bigint" && (ce = String(M), (M > BigInt(2) ** BigInt(32) || M < -(BigInt(2) ** BigInt(32))) && (ce = ot(ce)), ce += "n"), ne += ` It must be ${b}. Received ${ce}`, ne;
    },
    RangeError
  );
  function ot(ee) {
    let b = "", M = ee.length;
    const ne = ee[0] === "-" ? 1 : 0;
    for (; M >= ne + 4; M -= 3)
      b = `_${ee.slice(M - 3, M)}${b}`;
    return `${ee.slice(0, M)}${b}`;
  }
  function ut(ee, b, M) {
    qe(b, "offset"), (ee[b] === void 0 || ee[b + M] === void 0) && ze(b, ee.length - (M + 1));
  }
  function nt(ee, b, M, ne, ce, ge) {
    if (ee > M || ee < b) {
      const de = typeof b == "bigint" ? "n" : "";
      let Se;
      throw b === 0 || b === BigInt(0) ? Se = `>= 0${de} and < 2${de} ** ${(ge + 1) * 8}${de}` : Se = `>= -(2${de} ** ${(ge + 1) * 8 - 1}${de}) and < 2 ** ${(ge + 1) * 8 - 1}${de}`, new Ge.ERR_OUT_OF_RANGE("value", Se, ee);
    }
    ut(ne, ce, ge);
  }
  function qe(ee, b) {
    if (typeof ee != "number")
      throw new Ge.ERR_INVALID_ARG_TYPE(b, "number", ee);
  }
  function ze(ee, b, M) {
    throw Math.floor(ee) !== ee ? (qe(ee, M), new Ge.ERR_OUT_OF_RANGE("offset", "an integer", ee)) : b < 0 ? new Ge.ERR_BUFFER_OUT_OF_BOUNDS() : new Ge.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${b}`,
      ee
    );
  }
  const ct = /[^+/0-9A-Za-z-_]/g;
  function lt(ee) {
    if (ee = ee.split("=")[0], ee = ee.trim().replace(ct, ""), ee.length < 2) return "";
    for (; ee.length % 4 !== 0; )
      ee = ee + "=";
    return ee;
  }
  function Je(ee, b) {
    b = b || 1 / 0;
    let M;
    const ne = ee.length;
    let ce = null;
    const ge = [];
    for (let de = 0; de < ne; ++de) {
      if (M = ee.charCodeAt(de), M > 55295 && M < 57344) {
        if (!ce) {
          if (M > 56319) {
            (b -= 3) > -1 && ge.push(239, 191, 189);
            continue;
          } else if (de + 1 === ne) {
            (b -= 3) > -1 && ge.push(239, 191, 189);
            continue;
          }
          ce = M;
          continue;
        }
        if (M < 56320) {
          (b -= 3) > -1 && ge.push(239, 191, 189), ce = M;
          continue;
        }
        M = (ce - 55296 << 10 | M - 56320) + 65536;
      } else ce && (b -= 3) > -1 && ge.push(239, 191, 189);
      if (ce = null, M < 128) {
        if ((b -= 1) < 0) break;
        ge.push(M);
      } else if (M < 2048) {
        if ((b -= 2) < 0) break;
        ge.push(
          M >> 6 | 192,
          M & 63 | 128
        );
      } else if (M < 65536) {
        if ((b -= 3) < 0) break;
        ge.push(
          M >> 12 | 224,
          M >> 6 & 63 | 128,
          M & 63 | 128
        );
      } else if (M < 1114112) {
        if ((b -= 4) < 0) break;
        ge.push(
          M >> 18 | 240,
          M >> 12 & 63 | 128,
          M >> 6 & 63 | 128,
          M & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ge;
  }
  function pt(ee) {
    const b = [];
    for (let M = 0; M < ee.length; ++M)
      b.push(ee.charCodeAt(M) & 255);
    return b;
  }
  function gt(ee, b) {
    let M, ne, ce;
    const ge = [];
    for (let de = 0; de < ee.length && !((b -= 2) < 0); ++de)
      M = ee.charCodeAt(de), ne = M >> 8, ce = M % 256, ge.push(ce), ge.push(ne);
    return ge;
  }
  function st(ee) {
    return s.toByteArray(lt(ee));
  }
  function $e(ee, b, M, ne) {
    let ce;
    for (ce = 0; ce < ne && !(ce + M >= b.length || ce >= ee.length); ++ce)
      b[ce + M] = ee[ce];
    return ce;
  }
  function je(ee, b) {
    return ee instanceof b || ee != null && ee.constructor != null && ee.constructor.name != null && ee.constructor.name === b.name;
  }
  function Ye(ee) {
    return ee !== ee;
  }
  const dt = function() {
    const ee = "0123456789abcdef", b = new Array(256);
    for (let M = 0; M < 16; ++M) {
      const ne = M * 16;
      for (let ce = 0; ce < 16; ++ce)
        b[ne + ce] = ee[M] + ee[ce];
    }
    return b;
  }();
  function ke(ee) {
    return typeof BigInt == "undefined" ? ht : ee;
  }
  function ht() {
    throw new Error("BigInt not supported");
  }
})(buffer);
Object.defineProperty(string, "__esModule", { value: !0 });
string.encodeToBase64 = string.decodeFromBase64 = void 0;
const buffer_1 = buffer, decodeFromBase64 = (p) => buffer_1.Buffer.from(p, "base64").toString("utf8");
string.decodeFromBase64 = decodeFromBase64;
const encodeToBase64 = (p) => buffer_1.Buffer.from(p, "utf-8").toString("base64");
string.encodeToBase64 = encodeToBase64;
Object.defineProperty(validators, "__esModule", { value: !0 });
validators.validateMaxConcurrentRequests = validators.validateLeaderboardNumberOfElements = validators.validateLeaderboardCount = validators.validateLeaderboardOffset = validators.validateLeaderboardRanks = validators.validateLeaderboardName = validators.isBase64 = validators.validateDisposableTokenTokenID = validators.validateDisposableTokenExpiry = validators.validateTimeout = validators.validateValidForSeconds = validators.validateTtlSeconds = validators.validateTtlMinutes = validators.validateTopK = validators.validateNumDimensions = validators.validateIndexName = validators.validateWebhookName = validators.validateTopicName = validators.validateListSliceStartEnd = validators.validateListName = validators.validateDictionaryName = validators.validateSortedSetCount = validators.validateSortedSetOffset = validators.validateSortedSetScores = validators.validateSortedSetRanks = validators.validateSortedSetName = validators.validateSetPopCount = validators.validateSetSampleLimit = validators.validateSetName = validators.validateCacheKeyOrPrefix = validators.validateCacheName = validators.validateStoreName = void 0;
const errors_1$3 = errors$1, string_1$1 = string;
function validateStoreName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("store name must not be empty");
}
validators.validateStoreName = validateStoreName;
function validateCacheName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("cache name must not be empty");
}
validators.validateCacheName = validateCacheName;
function validateCacheKeyOrPrefix(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("cache key or key prefix must not be empty");
}
validators.validateCacheKeyOrPrefix = validateCacheKeyOrPrefix;
function validateSetName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("set name must not be empty");
}
validators.validateSetName = validateSetName;
function validateSetSampleLimit(p) {
  if (p < 0)
    throw new errors_1$3.InvalidArgumentError("limit must be non-negative (>= 0)");
}
validators.validateSetSampleLimit = validateSetSampleLimit;
function validateSetPopCount(p) {
  if (p < 1)
    throw new errors_1$3.InvalidArgumentError("count must be positive (> 0)");
}
validators.validateSetPopCount = validateSetPopCount;
function validateSortedSetName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("sorted set name must not be empty");
}
validators.validateSortedSetName = validateSortedSetName;
function validateSortedSetRanks(p, s) {
  if (s !== void 0) {
    if (p > 0 && s > 0 && p > s)
      throw new errors_1$3.InvalidArgumentError("start rank must be less than end rank");
    if (p < 0 && s < 0 && p >= s)
      throw new errors_1$3.InvalidArgumentError("negative start rank must be less than negative end rank");
  }
}
validators.validateSortedSetRanks = validateSortedSetRanks;
function validateSortedSetScores(p, s) {
  if (p !== void 0 && s !== void 0 && p > s)
    throw new errors_1$3.InvalidArgumentError("minScore must be less than or equal to maxScore");
}
validators.validateSortedSetScores = validateSortedSetScores;
function validateSortedSetOffset(p) {
  if (p < 0)
    throw new errors_1$3.InvalidArgumentError("offset must be non-negative (>= 0)");
}
validators.validateSortedSetOffset = validateSortedSetOffset;
function validateSortedSetCount(p) {
  if (p < 1)
    throw new errors_1$3.InvalidArgumentError("count must be strictly positive (> 0)");
}
validators.validateSortedSetCount = validateSortedSetCount;
function validateDictionaryName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("dictionary name must not be empty");
}
validators.validateDictionaryName = validateDictionaryName;
function validateListName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("list name must not be empty");
}
validators.validateListName = validateListName;
function validateListSliceStartEnd(p, s) {
  if (!(p === void 0 || s === void 0) && !(p > 0 || s < 0) && s <= p)
    throw new errors_1$3.InvalidArgumentError("endIndex (exclusive) must be larger than startIndex (inclusive)");
}
validators.validateListSliceStartEnd = validateListSliceStartEnd;
function validateTopicName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("topic name must not be empty");
}
validators.validateTopicName = validateTopicName;
function validateWebhookName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("webhook name must not be empty");
}
validators.validateWebhookName = validateWebhookName;
function validateIndexName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("index name must not be empty");
}
validators.validateIndexName = validateIndexName;
function validateNumDimensions(p) {
  if (p <= 0)
    throw new errors_1$3.InvalidArgumentError("numDimensions must be greater than zero");
}
validators.validateNumDimensions = validateNumDimensions;
function validateTopK(p) {
  if (p <= 0)
    throw new errors_1$3.InvalidArgumentError("topK must be greater than zero");
}
validators.validateTopK = validateTopK;
function validateTtlMinutes(p) {
  if (p < 0 || !Number.isSafeInteger(p))
    throw new errors_1$3.InvalidArgumentError("ttlMinutes must be a positive integer");
}
validators.validateTtlMinutes = validateTtlMinutes;
function validateTtlSeconds(p) {
  if (p < 0 || !Number.isSafeInteger(p))
    throw new errors_1$3.InvalidArgumentError(`ttl must be a positive integer, received ${p}`);
}
validators.validateTtlSeconds = validateTtlSeconds;
function validateValidForSeconds(p) {
  if (p < 0)
    throw new errors_1$3.InvalidArgumentError("validForSeconds must be positive");
}
validators.validateValidForSeconds = validateValidForSeconds;
function validateTimeout(p) {
  if (p < 0)
    throw new errors_1$3.InvalidArgumentError("timeout must be positive");
}
validators.validateTimeout = validateTimeout;
function validateDisposableTokenExpiry(p) {
  if (!p.doesExpire())
    throw new errors_1$3.InvalidArgumentError("disposable tokens must have an expiry");
  if (p.seconds() < 0)
    throw new errors_1$3.InvalidArgumentError("disposable token expiry must be positive");
  if (p.seconds() > 60 * 60)
    throw new errors_1$3.InvalidArgumentError("disposable tokens must expire within 1 hour");
}
validators.validateDisposableTokenExpiry = validateDisposableTokenExpiry;
function validateDisposableTokenTokenID(p) {
  if (p.length > 64)
    throw new errors_1$3.InvalidArgumentError("TokenID must be less than or equal to 64 characters.");
}
validators.validateDisposableTokenTokenID = validateDisposableTokenTokenID;
function isEmpty(p) {
  return !p.trim();
}
function isBase64(p) {
  try {
    return (0, string_1$1.encodeToBase64)((0, string_1$1.decodeFromBase64)(p)) === p;
  } catch (s) {
    return !1;
  }
}
validators.isBase64 = isBase64;
function validateLeaderboardName(p) {
  if (isEmpty(p))
    throw new errors_1$3.InvalidArgumentError("leaderboard name must not be empty");
}
validators.validateLeaderboardName = validateLeaderboardName;
function validateLeaderboardRanks(p, s) {
  if (p > 0 && s > 0 && p >= s)
    throw new errors_1$3.InvalidArgumentError("start rank must be less than end rank");
  if (p < 0 || s < 0)
    throw new errors_1$3.InvalidArgumentError("ranks must be positive");
}
validators.validateLeaderboardRanks = validateLeaderboardRanks;
function validateLeaderboardOffset(p) {
  if (p < 0)
    throw new errors_1$3.InvalidArgumentError("offset must be non-negative (>= 0)");
}
validators.validateLeaderboardOffset = validateLeaderboardOffset;
function validateLeaderboardCount(p) {
  if (p < 1)
    throw new errors_1$3.InvalidArgumentError("count must be strictly positive (> 0)");
}
validators.validateLeaderboardCount = validateLeaderboardCount;
function validateLeaderboardNumberOfElements(p) {
  if (p < 1)
    throw new errors_1$3.InvalidArgumentError("must provide at least one element");
}
validators.validateLeaderboardNumberOfElements = validateLeaderboardNumberOfElements;
function validateMaxConcurrentRequests(p) {
  if (p < 1)
    throw new errors_1$3.InvalidArgumentError("concurrent requests limit must be strictly positive (> 0)");
}
validators.validateMaxConcurrentRequests = validateMaxConcurrentRequests;
var permissionScope = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.PredefinedScope = p.asPermissionsObject = p.isPermissionsObject = p.AllDataReadWrite = p.asTopicPermission = p.isTopicPermission = p.isTopicName = p.TopicRole = p.asCachePermission = p.isCachePermission = p.isCacheName = p.AllCacheItems = p.AllTopics = p.AllCaches = p.CacheRole = void 0;
  var s;
  (function(m) {
    m.ReadWrite = "readwrite", m.ReadOnly = "readonly", m.WriteOnly = "writeonly";
  })(s = p.CacheRole || (p.CacheRole = {})), p.AllCaches = Symbol(), p.AllTopics = Symbol(), p.AllCacheItems = Symbol();
  function h(m) {
    return m === p.AllCaches ? !1 : "name" in m;
  }
  p.isCacheName = h;
  function c(m) {
    return "role" in m && "cache" in m && !("topic" in m);
  }
  p.isCachePermission = c;
  function d(m) {
    if (!c(m))
      throw new Error(`permission is not a CachePermission object: ${JSON.stringify(m)}`);
    return m;
  }
  p.asCachePermission = d;
  var l;
  (function(m) {
    m.PublishSubscribe = "publishsubscribe", m.SubscribeOnly = "subscribeonly", m.PublishOnly = "publishonly";
  })(l = p.TopicRole || (p.TopicRole = {}));
  function g(m) {
    return m === p.AllTopics ? !1 : "name" in m;
  }
  p.isTopicName = g;
  function f(m) {
    return "role" in m && "cache" in m && "topic" in m;
  }
  p.isTopicPermission = f;
  function _(m) {
    if (!f(m))
      throw new Error(`permission is not a TopicPermission object: ${JSON.stringify(m)}`);
    return m;
  }
  p.asTopicPermission = _, p.AllDataReadWrite = {
    permissions: [
      { role: s.ReadWrite, cache: p.AllCaches },
      { role: l.PublishSubscribe, cache: p.AllCaches, topic: p.AllTopics }
    ]
  };
  function te(m) {
    return c(m) || f(m);
  }
  function ae(m) {
    return "permissions" in m ? m.permissions.every((q) => te(q)) : !1;
  }
  p.isPermissionsObject = ae;
  function ie(m) {
    if (!ae(m))
      throw new Error(`Token scope is not a Permissions object: ${JSON.stringify(m)}`);
    return m;
  }
  p.asPermissionsObject = ie;
  class se {
  }
  p.PredefinedScope = se;
})(permissionScope);
Object.defineProperty(auth$3, "__esModule", { value: !0 });
auth$3.InternalSuperUserPermissions = auth$3.decodeAuthToken = auth$3.populateAllEndpointsFromBaseEndpoint = void 0;
const errors_1$2 = errors$1, jwt_decode_1 = require$$1$1, validators_1 = validators, string_1 = string, permission_scope_1$2 = permissionScope;
function decodeAuthTokenClaims(p) {
  return (0, jwt_decode_1.default)(p);
}
function populateAllEndpointsFromBaseEndpoint(p) {
  let s = "";
  return p.endpointPrefix && (s = `${p.endpointPrefix}.`), {
    controlEndpoint: {
      endpoint: `${s}control.${p.baseEndpoint}`,
      secureConnection: p.secureConnection
    },
    cacheEndpoint: {
      endpoint: `${s}cache.${p.baseEndpoint}`,
      secureConnection: p.secureConnection
    },
    tokenEndpoint: {
      endpoint: `${s}token.${p.baseEndpoint}`,
      secureConnection: p.secureConnection
    },
    storageEndpoint: {
      endpoint: `${s}storage.${p.baseEndpoint}`,
      secureConnection: p.secureConnection
    }
  };
}
auth$3.populateAllEndpointsFromBaseEndpoint = populateAllEndpointsFromBaseEndpoint;
const decodeAuthToken = (p) => {
  if (!p)
    throw new errors_1$2.InvalidArgumentError("malformed auth token");
  try {
    if ((0, validators_1.isBase64)(p)) {
      const s = JSON.parse((0, string_1.decodeFromBase64)(p));
      if (!s.endpoint || !s.api_key)
        throw new errors_1$2.InvalidArgumentError("failed to parse token");
      const h = populateAllEndpointsFromBaseEndpoint({
        baseEndpoint: s.endpoint
      });
      return {
        controlEndpoint: h.controlEndpoint.endpoint,
        cacheEndpoint: h.cacheEndpoint.endpoint,
        tokenEndpoint: h.tokenEndpoint.endpoint,
        storageEndpoint: h.storageEndpoint.endpoint,
        authToken: s.api_key
      };
    } else {
      const s = decodeAuthTokenClaims(p);
      return {
        controlEndpoint: s.cp,
        cacheEndpoint: s.c,
        tokenEndpoint: s.c,
        storageEndpoint: s.c,
        authToken: p
      };
    }
  } catch (s) {
    throw new errors_1$2.InvalidArgumentError(`failed to parse token: ${s}`);
  }
};
auth$3.decodeAuthToken = decodeAuthToken;
class InternalSuperUserPermissions extends permission_scope_1$2.PredefinedScope {
}
auth$3.InternalSuperUserPermissions = InternalSuperUserPermissions;
var collections = {};
Object.defineProperty(collections, "__esModule", { value: !0 });
collections.range = void 0;
function range(p) {
  return [...Array(p).keys()];
}
collections.range = range;
var display = {};
Object.defineProperty(display, "__esModule", { value: !0 });
display.truncateStringArray = display.truncateString = void 0;
function truncateString(p, s = 32) {
  return p.length > s ? p.substring(0, s) + "..." : p;
}
display.truncateString = truncateString;
const DISPLAY_SIZE_LIMIT = 5;
function truncateStringArrayToSize(p, s) {
  return p.length <= s ? p : p.slice(0, s).concat(["..."]);
}
function truncateStringArray(p, s = DISPLAY_SIZE_LIMIT) {
  return truncateStringArrayToSize(p, s).map((c) => truncateString(c));
}
display.truncateStringArray = truncateStringArray;
var object = {};
Object.defineProperty(object, "__esModule", { value: !0 });
object.fromEntries = void 0;
function fromEntries(p) {
  return p.reduce((s, [h, c]) => ({ ...s, [h]: c }), {});
}
object.fromEntries = fromEntries;
var sleep$1 = {};
Object.defineProperty(sleep$1, "__esModule", { value: !0 });
sleep$1.sleep = void 0;
const sleep = (p) => new Promise((s) => setTimeout(s, p));
sleep$1.sleep = sleep;
var semaphore = {};
Object.defineProperty(semaphore, "__esModule", { value: !0 });
semaphore.Semaphore = void 0;
class Semaphore {
  constructor(s) {
    this.counter = 0, this.waiting = [], this.max = s;
  }
  take() {
    if (this.waiting.length > 0 && this.counter < this.max) {
      this.counter += 1;
      const s = this.waiting.shift();
      s && s.resolve();
    }
  }
  acquire() {
    return this.counter < this.max ? (this.counter += 1, new Promise((s) => {
      s(void 0);
    })) : new Promise((s, h) => {
      this.waiting.push({ resolve: s, err: h });
    });
  }
  release() {
    this.counter -= 1, this.take();
  }
  purge() {
    const s = this.waiting.length;
    for (let h = 0; h < s; h += 1)
      this.waiting[h].err("Task has been purged.");
    return this.counter = 0, this.waiting = [], s;
  }
}
semaphore.Semaphore = Semaphore;
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(auth$3, p), h(collections, p), h(display, p), h(object, p), h(sleep$1, p), h(string, p), h(validators, p), h(semaphore, p);
})(utils$1);
var enums = {}, auth$2 = {}, generateApiKey$1 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.GenerateApiKeyResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.GenerateApiKeyResponse || (p.GenerateApiKeyResponse = {}));
})(generateApiKey$1);
var generateDisposableToken$1 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.GenerateDisposableTokenResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.GenerateDisposableTokenResponse || (p.GenerateDisposableTokenResponse = {}));
})(generateDisposableToken$1);
var refreshApiKey$1 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.RefreshApiKeyResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.RefreshApiKeyResponse || (p.RefreshApiKeyResponse = {}));
})(refreshApiKey$1);
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.RefreshApiKeyResponse = p.GenerateDisposableTokenResponse = p.GenerateApiKeyResponse = void 0;
  var s = generateApiKey$1;
  Object.defineProperty(p, "GenerateApiKeyResponse", { enumerable: !0, get: function() {
    return s.GenerateApiKeyResponse;
  } });
  var h = generateDisposableToken$1;
  Object.defineProperty(p, "GenerateDisposableTokenResponse", { enumerable: !0, get: function() {
    return h.GenerateDisposableTokenResponse;
  } });
  var c = refreshApiKey$1;
  Object.defineProperty(p, "RefreshApiKeyResponse", { enumerable: !0, get: function() {
    return c.RefreshApiKeyResponse;
  } });
})(auth$2);
var cache$1 = {}, dictionary = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheDictionarySetFieldsResponse = p.CacheDictionarySetFieldResponse = p.CacheDictionaryRemoveFieldsResponse = p.CacheDictionaryRemoveFieldResponse = p.CacheDictionaryLengthResponse = p.CacheDictionaryIncrementResponse = p.CacheDictionaryFetchResponse = p.CacheDictionaryGetFieldResponse = p.CacheDictionaryGetFieldsResponse = void 0, function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheDictionaryGetFieldsResponse || (p.CacheDictionaryGetFieldsResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheDictionaryGetFieldResponse || (p.CacheDictionaryGetFieldResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheDictionaryFetchResponse || (p.CacheDictionaryFetchResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheDictionaryIncrementResponse || (p.CacheDictionaryIncrementResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheDictionaryLengthResponse || (p.CacheDictionaryLengthResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheDictionaryRemoveFieldResponse || (p.CacheDictionaryRemoveFieldResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheDictionaryRemoveFieldsResponse || (p.CacheDictionaryRemoveFieldsResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheDictionarySetFieldResponse || (p.CacheDictionarySetFieldResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheDictionarySetFieldsResponse || (p.CacheDictionarySetFieldsResponse = {}));
})(dictionary);
var scalar$2 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheDecreaseTtlResponse = p.CacheIncreaseTtlResponse = p.CacheUpdateTtlResponse = p.CacheItemGetTtlResponse = p.CacheItemGetTypeResponse = p.CacheKeysExistResponse = p.CacheKeyExistsResponse = p.CacheSetIfNotExistsResponse = p.CacheSetIfPresentAndNotEqualResponse = p.CacheSetIfAbsentOrEqualResponse = p.CacheSetIfNotEqualResponse = p.CacheSetIfEqualResponse = p.CacheSetIfPresentResponse = p.CacheSetIfAbsentResponse = p.CacheSetBatchResponse = p.CacheGetBatchResponse = p.CacheIncrementResponse = p.CacheDeleteResponse = p.CacheSetResponse = p.CacheGetResponse = void 0, function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheGetResponse || (p.CacheGetResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSetResponse || (p.CacheSetResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheDeleteResponse || (p.CacheDeleteResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheIncrementResponse || (p.CacheIncrementResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheGetBatchResponse || (p.CacheGetBatchResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSetBatchResponse || (p.CacheSetBatchResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfAbsentResponse || (p.CacheSetIfAbsentResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfPresentResponse || (p.CacheSetIfPresentResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfEqualResponse || (p.CacheSetIfEqualResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfNotEqualResponse || (p.CacheSetIfNotEqualResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfAbsentOrEqualResponse || (p.CacheSetIfAbsentOrEqualResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfPresentAndNotEqualResponse || (p.CacheSetIfPresentAndNotEqualResponse = {})), function(s) {
    s.Stored = "Stored", s.NotStored = "NotStored", s.Error = "Error";
  }(p.CacheSetIfNotExistsResponse || (p.CacheSetIfNotExistsResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheKeyExistsResponse || (p.CacheKeyExistsResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheKeysExistResponse || (p.CacheKeysExistResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheItemGetTypeResponse || (p.CacheItemGetTypeResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheItemGetTtlResponse || (p.CacheItemGetTtlResponse = {})), function(s) {
    s.Set = "Set", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheUpdateTtlResponse || (p.CacheUpdateTtlResponse = {})), function(s) {
    s.Set = "Set", s.NotSet = "NotSet", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheIncreaseTtlResponse || (p.CacheIncreaseTtlResponse = {})), function(s) {
    s.Set = "Set", s.NotSet = "NotSet", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheDecreaseTtlResponse || (p.CacheDecreaseTtlResponse = {}));
})(scalar$2);
var set = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheSetLengthResponse = p.CacheSetPopResponse = p.CacheSetSampleResponse = p.CacheSetRemoveElementsResponse = p.CacheSetRemoveElementResponse = p.CacheSetContainsElementsResponse = p.CacheSetContainsElementResponse = p.CacheSetFetchResponse = p.CacheSetAddElementsResponse = p.CacheSetAddElementResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSetAddElementResponse || (p.CacheSetAddElementResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSetAddElementsResponse || (p.CacheSetAddElementsResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSetFetchResponse || (p.CacheSetFetchResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSetContainsElementResponse || (p.CacheSetContainsElementResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSetContainsElementsResponse || (p.CacheSetContainsElementsResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSetRemoveElementResponse || (p.CacheSetRemoveElementResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSetRemoveElementsResponse || (p.CacheSetRemoveElementsResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSetSampleResponse || (p.CacheSetSampleResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSetPopResponse || (p.CacheSetPopResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSetLengthResponse || (p.CacheSetLengthResponse = {}));
})(set);
var list = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheListPopFrontResponse = p.CacheListPopBackResponse = p.CacheListLengthResponse = p.CacheListFetchResponse = p.CacheListRetainResponse = p.CacheListRemoveValueResponse = p.CacheListPushFrontResponse = p.CacheListPushBackResponse = p.CacheListConcatenateFrontResponse = p.CacheListConcatenateBackResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheListConcatenateBackResponse || (p.CacheListConcatenateBackResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheListConcatenateFrontResponse || (p.CacheListConcatenateFrontResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheListPushBackResponse || (p.CacheListPushBackResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheListPushFrontResponse || (p.CacheListPushFrontResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheListRemoveValueResponse || (p.CacheListRemoveValueResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheListRetainResponse || (p.CacheListRetainResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheListFetchResponse || (p.CacheListFetchResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheListLengthResponse || (p.CacheListLengthResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheListPopBackResponse || (p.CacheListPopBackResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheListPopFrontResponse || (p.CacheListPopFrontResponse = {}));
})(list);
var sortedSet = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheSortedSetRemoveElementsResponse = p.CacheSortedSetRemoveElementResponse = p.CacheSortedSetPutElementsResponse = p.CacheSortedSetPutElementResponse = p.CacheSortedSetLengthByScoreResponse = p.CacheSortedSetLengthResponse = p.CacheSortedSetIncrementScoreResponse = p.CacheSortedSetGetScoresResponse = p.CacheSortedSetGetScoreResponse = p.CacheSortedSetGetRankResponse = p.CacheSortedSetFetchResponse = void 0, function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSortedSetFetchResponse || (p.CacheSortedSetFetchResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSortedSetGetRankResponse || (p.CacheSortedSetGetRankResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSortedSetGetScoreResponse || (p.CacheSortedSetGetScoreResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSortedSetGetScoresResponse || (p.CacheSortedSetGetScoresResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSortedSetIncrementScoreResponse || (p.CacheSortedSetIncrementScoreResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSortedSetLengthResponse || (p.CacheSortedSetLengthResponse = {})), function(s) {
    s.Hit = "Hit", s.Miss = "Miss", s.Error = "Error";
  }(p.CacheSortedSetLengthByScoreResponse || (p.CacheSortedSetLengthByScoreResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSortedSetPutElementResponse || (p.CacheSortedSetPutElementResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSortedSetPutElementsResponse || (p.CacheSortedSetPutElementsResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSortedSetRemoveElementResponse || (p.CacheSortedSetRemoveElementResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.CacheSortedSetRemoveElementsResponse || (p.CacheSortedSetRemoveElementsResponse = {}));
})(sortedSet);
var control$2 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.ListCachesResponse = p.FlushCacheResponse = p.DeleteCacheResponse = p.CreateCacheResponse = void 0, function(s) {
    s.Success = "Success", s.AlreadyExists = "AlreadyExists", s.Error = "Error";
  }(p.CreateCacheResponse || (p.CreateCacheResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.DeleteCacheResponse || (p.DeleteCacheResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.FlushCacheResponse || (p.FlushCacheResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.ListCachesResponse || (p.ListCachesResponse = {}));
})(control$2);
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(dictionary, p), h(scalar$2, p), h(set, p), h(list, p), h(sortedSet, p), h(control$2, p);
})(cache$1);
var topics = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.TopicSubscribeResponse = p.TopicPublishResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.TopicPublishResponse || (p.TopicPublishResponse = {})), function(s) {
    s.Subscription = "Subscription", s.Error = "Error";
  }(p.TopicSubscribeResponse || (p.TopicSubscribeResponse = {}));
})(topics);
var leaderboard$3 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.LeaderboardUpsertResponse = p.LeaderboardRemoveElementsResponse = p.LeaderboardLengthResponse = p.LeaderboardFetchResponse = p.LeaderboardDeleteResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.LeaderboardDeleteResponse || (p.LeaderboardDeleteResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.LeaderboardFetchResponse || (p.LeaderboardFetchResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.LeaderboardLengthResponse || (p.LeaderboardLengthResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.LeaderboardRemoveElementsResponse || (p.LeaderboardRemoveElementsResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.LeaderboardUpsertResponse || (p.LeaderboardUpsertResponse = {}));
})(leaderboard$3);
var store = {}, control$1 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.DeleteStoreResponse = p.ListStoresResponse = p.CreateStoreResponse = void 0, function(s) {
    s.Success = "Success", s.AlreadyExists = "AlreadyExists", s.Error = "Error";
  }(p.CreateStoreResponse || (p.CreateStoreResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.ListStoresResponse || (p.ListStoresResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.DeleteStoreResponse || (p.DeleteStoreResponse = {}));
})(control$1);
var scalar$1 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.StorageDeleteResponse = p.StoragePutResponse = p.StorageGetResponse = void 0, function(s) {
    s.Found = "Found", s.NotFound = "NotFound", s.Error = "Error";
  }(p.StorageGetResponse || (p.StorageGetResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.StoragePutResponse || (p.StoragePutResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.StorageDeleteResponse || (p.StorageDeleteResponse = {}));
})(scalar$1);
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(control$1, p), h(scalar$1, p);
})(store);
var webhook$1 = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.ListWebhooksResponse = p.GetWebhookSecretResponse = p.RotateWebhookSecretResponse = p.DeleteWebhookResponse = p.PutWebhookResponse = void 0, function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.PutWebhookResponse || (p.PutWebhookResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.DeleteWebhookResponse || (p.DeleteWebhookResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.RotateWebhookSecretResponse || (p.RotateWebhookSecretResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.GetWebhookSecretResponse || (p.GetWebhookSecretResponse = {})), function(s) {
    s.Success = "Success", s.Error = "Error";
  }(p.ListWebhooksResponse || (p.ListWebhooksResponse = {}));
})(webhook$1);
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(auth$2, p), h(cache$1, p), h(topics, p), h(leaderboard$3, p), h(store, p), h(webhook$1, p);
})(enums);
Object.defineProperty(cacheGet, "__esModule", { value: !0 });
cacheGet.Error = cacheGet.Miss = cacheGet.Hit = void 0;
const response_base_1$1i = responseBase, utils_1$g = utils$1, enums_1$1i = enums, TEXT_DECODER$c = new TextDecoder();
let Hit$l = class extends response_base_1$1i.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$1i.CacheGetResponse.Hit, this.body = s;
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  value() {
    return TEXT_DECODER$c.decode(this.body);
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  valueString() {
    return TEXT_DECODER$c.decode(this.body);
  }
  /**
   * Returns the data as a byte array.
   * @returns {Uint8Array}
   */
  valueUint8Array() {
    return this.body;
  }
  toString() {
    const s = (0, utils_1$g.truncateString)(this.valueString());
    return `${super.toString()}: ${s}`;
  }
};
cacheGet.Hit = Hit$l;
let Miss$o = class extends response_base_1$1i.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$1i.CacheGetResponse.Miss;
  }
  value() {
  }
};
cacheGet.Miss = Miss$o;
let Error$1j = class extends response_base_1$1i.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1i.CacheGetResponse.Error;
  }
  value() {
  }
};
cacheGet.Error = Error$1j;
var cacheListConcatenateBack = {};
Object.defineProperty(cacheListConcatenateBack, "__esModule", { value: !0 });
cacheListConcatenateBack.Error = cacheListConcatenateBack.Success = void 0;
const response_base_1$1h = responseBase, enums_1$1h = enums;
let Success$M = class extends response_base_1$1h.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$1h.CacheListConcatenateBackResponse.Success, this._listLength = s;
  }
  /**
   * Returns the new length of the list after the concatenate operation.
   * @returns {number}
   */
  listLength() {
    return this._listLength;
  }
  toString() {
    return `${super.toString()}: listLength: ${this._listLength}`;
  }
};
cacheListConcatenateBack.Success = Success$M;
let Error$1i = class extends response_base_1$1h.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1h.CacheListConcatenateBackResponse.Error;
  }
};
cacheListConcatenateBack.Error = Error$1i;
var cacheListConcatenateFront = {};
Object.defineProperty(cacheListConcatenateFront, "__esModule", { value: !0 });
cacheListConcatenateFront.Error = cacheListConcatenateFront.Success = void 0;
const response_base_1$1g = responseBase, enums_1$1g = enums;
let Success$L = class extends response_base_1$1g.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$1g.CacheListConcatenateFrontResponse.Success, this._listLength = s;
  }
  /**
   * Returns the new length of the list after the concatenate operation.
   * @returns {number}
   */
  listLength() {
    return this._listLength;
  }
  toString() {
    return `${super.toString()}: listLength: ${this._listLength}`;
  }
};
cacheListConcatenateFront.Success = Success$L;
let Error$1h = class extends response_base_1$1g.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1g.CacheListConcatenateFrontResponse.Error;
  }
};
cacheListConcatenateFront.Error = Error$1h;
var cacheListFetch = {};
Object.defineProperty(cacheListFetch, "__esModule", { value: !0 });
cacheListFetch.Error = cacheListFetch.Miss = cacheListFetch.Hit = void 0;
const response_base_1$1f = responseBase, utils_1$f = utils$1, enums_1$1f = enums, TEXT_DECODER$b = new TextDecoder();
let Hit$k = class extends response_base_1$1f.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$1f.CacheListFetchResponse.Hit, this._values = s;
  }
  /**
   * Returns the data as an array of byte arrays.
   * @returns {Uint8Array[]}
   */
  valueListUint8Array() {
    return this._values;
  }
  /**
   * Returns the data as an array of strings, decoded from the underlying byte array.
   * @returns {string[]}
   */
  valueListString() {
    return this._values.map((s) => TEXT_DECODER$b.decode(s));
  }
  /**
   * Returns the data as an array of strings, decoded from the underlying byte array.  This is a convenience alias
   * for {valueListString}
   * @returns {string[]}
   */
  valueList() {
    return this.valueListString();
  }
  /**
   * Returns the data as an array of strings, decoded from the underlying byte array.
   * This is a convenience alias for {valueListString}
   * @returns {string[]}
   */
  value() {
    return this.valueListString();
  }
  toString() {
    const s = (0, utils_1$f.truncateStringArray)(this.valueListString());
    return `${super.toString()}: [${s.toString()}]`;
  }
};
cacheListFetch.Hit = Hit$k;
let Miss$n = class extends response_base_1$1f.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$1f.CacheListFetchResponse.Miss;
  }
  value() {
  }
};
cacheListFetch.Miss = Miss$n;
let Error$1g = class extends response_base_1$1f.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1f.CacheListFetchResponse.Error;
  }
  value() {
  }
};
cacheListFetch.Error = Error$1g;
var cacheListLength = {};
Object.defineProperty(cacheListLength, "__esModule", { value: !0 });
cacheListLength.Error = cacheListLength.Miss = cacheListLength.Hit = void 0;
const response_base_1$1e = responseBase, enums_1$1e = enums;
let Hit$j = class extends response_base_1$1e.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$1e.CacheListLengthResponse.Hit, this._length = s;
  }
  /**
   * Returns the length of the list.
   * @returns number
   */
  value() {
    return this._length;
  }
  /**
   * Returns the length of the list.
   * @returns number
   */
  length() {
    return this._length;
  }
  toString() {
    return `${super.toString()}: length ${this._length}`;
  }
};
cacheListLength.Hit = Hit$j;
let Miss$m = class extends response_base_1$1e.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$1e.CacheListLengthResponse.Miss;
  }
  value() {
  }
};
cacheListLength.Miss = Miss$m;
let Error$1f = class extends response_base_1$1e.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1e.CacheListLengthResponse.Error;
  }
  value() {
  }
};
cacheListLength.Error = Error$1f;
var cacheListPopBack = {};
Object.defineProperty(cacheListPopBack, "__esModule", { value: !0 });
cacheListPopBack.Error = cacheListPopBack.Miss = cacheListPopBack.Hit = void 0;
const response_base_1$1d = responseBase, utils_1$e = utils$1, enums_1$1d = enums, TEXT_DECODER$a = new TextDecoder();
let Hit$i = class extends response_base_1$1d.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$1d.CacheListPopBackResponse.Hit, this.body = s;
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  value() {
    return TEXT_DECODER$a.decode(this.body);
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  valueString() {
    return TEXT_DECODER$a.decode(this.body);
  }
  /**
   * Returns the data as a byte array.
   * @returns {Uint8Array}
   */
  valueUint8Array() {
    return this.body;
  }
  toString() {
    const s = (0, utils_1$e.truncateString)(this.valueString());
    return `${super.toString()}: ${s}`;
  }
};
cacheListPopBack.Hit = Hit$i;
let Miss$l = class extends response_base_1$1d.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$1d.CacheListPopBackResponse.Miss;
  }
  value() {
  }
};
cacheListPopBack.Miss = Miss$l;
let Error$1e = class extends response_base_1$1d.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1d.CacheListPopBackResponse.Error;
  }
  value() {
  }
};
cacheListPopBack.Error = Error$1e;
var cacheListPopFront = {};
Object.defineProperty(cacheListPopFront, "__esModule", { value: !0 });
cacheListPopFront.Error = cacheListPopFront.Miss = cacheListPopFront.Hit = void 0;
const response_base_1$1c = responseBase, utils_1$d = utils$1, enums_1$1c = enums, TEXT_DECODER$9 = new TextDecoder();
let Hit$h = class extends response_base_1$1c.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$1c.CacheListPopFrontResponse.Hit, this.body = s;
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  value() {
    return TEXT_DECODER$9.decode(this.body);
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  valueString() {
    return TEXT_DECODER$9.decode(this.body);
  }
  /**
   * Returns the data as a byte array.
   * @returns {Uint8Array}
   */
  valueUint8Array() {
    return this.body;
  }
  toString() {
    const s = (0, utils_1$d.truncateString)(this.valueString());
    return `${super.toString()}: ${s}`;
  }
};
cacheListPopFront.Hit = Hit$h;
let Miss$k = class extends response_base_1$1c.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$1c.CacheListPopFrontResponse.Miss;
  }
  value() {
  }
};
cacheListPopFront.Miss = Miss$k;
let Error$1d = class extends response_base_1$1c.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1c.CacheListPopFrontResponse.Error;
  }
  value() {
  }
};
cacheListPopFront.Error = Error$1d;
var cacheListPushBack = {};
Object.defineProperty(cacheListPushBack, "__esModule", { value: !0 });
cacheListPushBack.Error = cacheListPushBack.Success = void 0;
const response_base_1$1b = responseBase, enums_1$1b = enums;
let Success$K = class extends response_base_1$1b.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$1b.CacheListPushBackResponse.Success, this._listLength = s;
  }
  /**
   * Returns the new length of the list after the push operation.
   * @returns {number}
   */
  listLength() {
    return this._listLength;
  }
  toString() {
    return `${super.toString()}: listLength: ${this._listLength}`;
  }
};
cacheListPushBack.Success = Success$K;
let Error$1c = class extends response_base_1$1b.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1b.CacheListPushBackResponse.Error;
  }
};
cacheListPushBack.Error = Error$1c;
var cacheListPushFront = {};
Object.defineProperty(cacheListPushFront, "__esModule", { value: !0 });
cacheListPushFront.Error = cacheListPushFront.Success = void 0;
const response_base_1$1a = responseBase, enums_1$1a = enums;
let Success$J = class extends response_base_1$1a.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$1a.CacheListPushFrontResponse.Success, this._listLength = s;
  }
  /**
   * Returns the new length of the list after the push operation.
   * @returns {number}
   */
  listLength() {
    return this._listLength;
  }
  toString() {
    return `${super.toString()}: listLength: ${this._listLength}`;
  }
};
cacheListPushFront.Success = Success$J;
let Error$1b = class extends response_base_1$1a.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1a.CacheListPushFrontResponse.Error;
  }
};
cacheListPushFront.Error = Error$1b;
var cacheListRemoveValue = {};
Object.defineProperty(cacheListRemoveValue, "__esModule", { value: !0 });
cacheListRemoveValue.Error = cacheListRemoveValue.Success = void 0;
const response_base_1$19 = responseBase, enums_1$19 = enums;
let Success$I = class extends response_base_1$19.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$19.CacheListRemoveValueResponse.Success;
  }
};
cacheListRemoveValue.Success = Success$I;
let Error$1a = class extends response_base_1$19.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$19.CacheListRemoveValueResponse.Error;
  }
};
cacheListRemoveValue.Error = Error$1a;
var cacheListRetain = {};
Object.defineProperty(cacheListRetain, "__esModule", { value: !0 });
cacheListRetain.Error = cacheListRetain.Success = void 0;
const response_base_1$18 = responseBase, enums_1$18 = enums;
let Success$H = class extends response_base_1$18.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$18.CacheListRetainResponse.Success;
  }
};
cacheListRetain.Success = Success$H;
let Error$19 = class extends response_base_1$18.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$18.CacheListRetainResponse.Error;
  }
};
cacheListRetain.Error = Error$19;
var cacheSet = {};
Object.defineProperty(cacheSet, "__esModule", { value: !0 });
cacheSet.Error = cacheSet.Success = void 0;
const response_base_1$17 = responseBase, enums_1$17 = enums;
let Success$G = class extends response_base_1$17.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$17.CacheSetResponse.Success;
  }
};
cacheSet.Success = Success$G;
let Error$18 = class extends response_base_1$17.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$17.CacheSetResponse.Error;
  }
};
cacheSet.Error = Error$18;
var cacheDelete = {};
Object.defineProperty(cacheDelete, "__esModule", { value: !0 });
cacheDelete.Error = cacheDelete.Success = void 0;
const response_base_1$16 = responseBase, enums_1$16 = enums;
let Success$F = class extends response_base_1$16.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$16.CacheDeleteResponse.Success;
  }
};
cacheDelete.Success = Success$F;
let Error$17 = class extends response_base_1$16.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$16.CacheDeleteResponse.Error;
  }
};
cacheDelete.Error = Error$17;
var cacheFlush = {};
Object.defineProperty(cacheFlush, "__esModule", { value: !0 });
cacheFlush.Error = cacheFlush.Success = void 0;
const response_base_1$15 = responseBase, enums_1$15 = enums;
let Success$E = class extends response_base_1$15.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$15.FlushCacheResponse.Success;
  }
};
cacheFlush.Success = Success$E;
let Error$16 = class extends response_base_1$15.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$15.FlushCacheResponse.Error;
  }
};
cacheFlush.Error = Error$16;
var createCache = {};
Object.defineProperty(createCache, "__esModule", { value: !0 });
createCache.Error = createCache.AlreadyExists = createCache.Success = void 0;
const response_base_1$14 = responseBase, enums_1$14 = enums;
let Success$D = class extends response_base_1$14.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$14.CreateCacheResponse.Success;
  }
};
createCache.Success = Success$D;
let AlreadyExists$1 = class extends response_base_1$14.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$14.CreateCacheResponse.AlreadyExists;
  }
};
createCache.AlreadyExists = AlreadyExists$1;
let Error$15 = class extends response_base_1$14.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$14.CreateCacheResponse.Error;
  }
};
createCache.Error = Error$15;
var deleteCache = {};
Object.defineProperty(deleteCache, "__esModule", { value: !0 });
deleteCache.Error = deleteCache.Success = void 0;
const response_base_1$13 = responseBase, enums_1$13 = enums;
let Success$C = class extends response_base_1$13.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$13.DeleteCacheResponse.Success;
  }
};
deleteCache.Success = Success$C;
let Error$14 = class extends response_base_1$13.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$13.DeleteCacheResponse.Error;
  }
};
deleteCache.Error = Error$14;
var listCaches = {};
Object.defineProperty(listCaches, "__esModule", { value: !0 });
listCaches.Error = listCaches.Success = void 0;
const response_base_1$12 = responseBase, enums_1$12 = enums;
let Success$B = class extends response_base_1$12.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$12.ListCachesResponse.Success, this.caches = s;
  }
  /**
   * An array of CacheInfo, containing information about each cache.
   * @returns {CacheInfo[]}
   */
  getCaches() {
    return this.caches;
  }
  toString() {
    const s = this.caches.map((h) => h.getName());
    return super.toString() + ": " + s.join(", ");
  }
};
listCaches.Success = Success$B;
let Error$13 = class extends response_base_1$12.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$12.ListCachesResponse.Error;
  }
};
listCaches.Error = Error$13;
var cacheSetFetch = {};
Object.defineProperty(cacheSetFetch, "__esModule", { value: !0 });
cacheSetFetch.Error = cacheSetFetch.Miss = cacheSetFetch.Hit = void 0;
const response_base_1$11 = responseBase, utils_1$c = utils$1, enums_1$11 = enums, TEXT_DECODER$8 = new TextDecoder();
let Hit$g = class extends response_base_1$11.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$11.CacheSetFetchResponse.Hit, this.elements = s;
  }
  /**
   * Returns the data as a Set whose values are utf-8 strings, decoded from the underlying byte arrays.  This
   * is a convenience alias for {valueSetString}.
   * @returns {Set<string>}
   */
  valueSet() {
    return this.valueSetString();
  }
  /**
   * Returns the data as a Set whose values are utf-8 strings, decoded from the underlying byte arrays.
   * @returns {Set<string>}
   */
  valueSetString() {
    return new Set(this.elements.map((s) => TEXT_DECODER$8.decode(s)));
  }
  /**
   * Returns the data as a Set whose values are byte arrays.
   * @returns {Set<Uint8Array>}
   */
  valueSetUint8Array() {
    return new Set(this.elements);
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * This is a convenience alias for {valueArrayString}.
   * @returns {string[]}
   */
  value() {
    return this.valueArrayString();
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * This is a convenience alias for {valueArrayString}.
   * @returns {string[]}
   */
  valueArray() {
    return this.valueArrayString();
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * @returns {string[]}
   */
  valueArrayString() {
    return this.elements.map((s) => TEXT_DECODER$8.decode(s));
  }
  /**
   * Returns the data as an Array whose values are byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * @returns {Uint8Array[]}
   */
  valueArrayUint8Array() {
    return this.elements;
  }
  toString() {
    const s = (0, utils_1$c.truncateStringArray)(Array.from(this.valueSetString()));
    return `${super.toString()}: [${s.toString()}]`;
  }
};
cacheSetFetch.Hit = Hit$g;
let Miss$j = class extends response_base_1$11.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$11.CacheSetFetchResponse.Miss;
  }
  value() {
  }
};
cacheSetFetch.Miss = Miss$j;
let Error$12 = class extends response_base_1$11.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$11.CacheSetFetchResponse.Error;
  }
  value() {
  }
};
cacheSetFetch.Error = Error$12;
var cacheDictionaryFetch = {};
Object.defineProperty(cacheDictionaryFetch, "__esModule", { value: !0 });
cacheDictionaryFetch.Error = cacheDictionaryFetch.Miss = cacheDictionaryFetch.Hit = void 0;
const response_base_1$10 = responseBase, enums_1$10 = enums, TEXT_DECODER$7 = new TextDecoder();
let Hit$f = class extends response_base_1$10.ResponseBase {
  constructor(s) {
    super(), this._displayListSizeLimit = 5, this.type = enums_1$10.CacheDictionaryFetchResponse.Hit, this.items = s;
  }
  /**
   * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This is a convenience alias for {valueMapStringString}.
   * @returns {Map<string, string>}
   */
  valueMap() {
    return this.valueMapStringString();
  }
  /**
   * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * @returns {Map<string, string>}
   */
  valueMapStringString() {
    return this.items.reduce((s, h) => (s.set(TEXT_DECODER$7.decode(h.field), TEXT_DECODER$7.decode(h.value)), s), /* @__PURE__ */ new Map());
  }
  /**
   * Returns the data as a Map whose keys are utf-8 strings, decoded from the underlying byte array, and whose values
   * are byte arrays.
   * @returns {Map<string, Uint8Array>}
   */
  valueMapStringUint8Array() {
    return this.items.reduce((s, h) => (s.set(TEXT_DECODER$7.decode(h.field), h.value), s), /* @__PURE__ */ new Map());
  }
  /**
   * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This can be used in most places where an Object is desired.  This is a convenience alias for
   * {valueRecordStringString}.
   * @returns {Record<string, string>}
   */
  value() {
    return this.valueRecordStringString();
  }
  /**
   * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This can be used in most places where an Object is desired.  This is a convenience alias for
   * {valueRecordStringString}.
   * @returns {Record<string, string>}
   */
  valueRecord() {
    return this.valueRecordStringString();
  }
  /**
   * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This can be used in most places where an Object is desired.
   * @returns {Record<string, string>}
   */
  valueRecordStringString() {
    return this.items.reduce((s, h) => (s[TEXT_DECODER$7.decode(h.field)] = TEXT_DECODER$7.decode(h.value), s), {});
  }
  /**
   * Returns the data as a Record whose keys are utf-8 strings, decoded from the underlying byte array, and whose
   * values are byte arrays.  This can be used in most places where an Object is desired.
   * @returns {Record<string, Uint8Array>}
   */
  valueRecordStringUint8Array() {
    return this.items.reduce((s, h) => (s[TEXT_DECODER$7.decode(h.field)] = h.value, s), {});
  }
  truncateValueStrings() {
    const s = this.valueMapStringString().entries(), h = Array.from(s);
    if (h.length <= this._displayListSizeLimit) {
      const c = [];
      return h.forEach((d) => {
        c.push(`${d[0]}: ${d[1]}`);
      }), c.join(",");
    } else {
      const c = h.slice(0, this._displayListSizeLimit), d = [];
      return c.forEach((l) => {
        d.push(`${l[0]}: ${l[1]}`);
      }), d.join(",");
    }
  }
  toString() {
    return `${super.toString()}: valueDictionaryStringString: ${this.truncateValueStrings()}`;
  }
};
cacheDictionaryFetch.Hit = Hit$f;
let Miss$i = class extends response_base_1$10.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$10.CacheDictionaryFetchResponse.Miss;
  }
  value() {
  }
};
cacheDictionaryFetch.Miss = Miss$i;
let Error$11 = class extends response_base_1$10.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$10.CacheDictionaryFetchResponse.Error;
  }
  value() {
  }
};
cacheDictionaryFetch.Error = Error$11;
var cacheDictionarySetField = {};
Object.defineProperty(cacheDictionarySetField, "__esModule", { value: !0 });
cacheDictionarySetField.Error = cacheDictionarySetField.Success = void 0;
const response_base_1$$ = responseBase, enums_1$$ = enums;
let Success$A = class extends response_base_1$$.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$$.CacheDictionarySetFieldResponse.Success;
  }
};
cacheDictionarySetField.Success = Success$A;
let Error$10 = class extends response_base_1$$.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$$.CacheDictionarySetFieldResponse.Error;
  }
};
cacheDictionarySetField.Error = Error$10;
var cacheDictionarySetFields = {};
Object.defineProperty(cacheDictionarySetFields, "__esModule", { value: !0 });
cacheDictionarySetFields.Error = cacheDictionarySetFields.Success = void 0;
const response_base_1$_ = responseBase, enums_1$_ = enums;
let Success$z = class extends response_base_1$_.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$_.CacheDictionarySetFieldsResponse.Success;
  }
};
cacheDictionarySetFields.Success = Success$z;
let Error$$ = class extends response_base_1$_.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$_.CacheDictionarySetFieldsResponse.Error;
  }
};
cacheDictionarySetFields.Error = Error$$;
var cacheDictionaryGetField = {};
Object.defineProperty(cacheDictionaryGetField, "__esModule", { value: !0 });
cacheDictionaryGetField.Error = cacheDictionaryGetField.Miss = cacheDictionaryGetField.Hit = void 0;
const response_base_1$Z = responseBase, utils_1$b = utils$1, enums_1$Z = enums, TEXT_DECODER$6 = new TextDecoder();
let Hit$e = class extends response_base_1$Z.ResponseBase {
  constructor(s, h) {
    super(), this.type = enums_1$Z.CacheDictionaryGetFieldResponse.Hit, this.body = s, this.field = h;
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  value() {
    return this.valueString();
  }
  /**
   * Returns the data as a utf-8 string, decoded from the underlying byte array.
   * @returns string
   */
  valueString() {
    return TEXT_DECODER$6.decode(this.body);
  }
  /**
   * Returns the data as a byte array.
   * @returns {Uint8Array}
   */
  valueUint8Array() {
    return this.body;
  }
  toString() {
    const s = (0, utils_1$b.truncateString)(this.valueString());
    return `${super.toString()}: ${s}`;
  }
  /**
   * Returns the field name for the retrieved element, as a utf-8 string decoded from the underlying byte array.
   * @returns {string}
   */
  fieldString() {
    return TEXT_DECODER$6.decode(this.field);
  }
  /**
   * Returns the field name for the retrieved element, as a byte array.
   * @returns {Uint8Array}
   */
  fieldUint8Array() {
    return this.field;
  }
};
cacheDictionaryGetField.Hit = Hit$e;
let Miss$h = class extends response_base_1$Z.BaseResponseMiss {
  constructor(s) {
    super(), this.type = enums_1$Z.CacheDictionaryGetFieldResponse.Miss, this.field = s;
  }
  /**
   * Returns the field name for the retrieved element, as a utf-8 string decoded from the underlying byte array.
   * @returns {string}
   */
  fieldString() {
    return TEXT_DECODER$6.decode(this.field);
  }
  /**
   * Returns the field name for the retrieved element, as a byte array.
   * @returns {Uint8Array}
   */
  fieldUint8Array() {
    return this.field;
  }
  value() {
  }
};
cacheDictionaryGetField.Miss = Miss$h;
let Error$_ = class extends response_base_1$Z.BaseResponseError {
  constructor(s, h) {
    super(s), this.type = enums_1$Z.CacheDictionaryGetFieldResponse.Error, this.field = h;
  }
  /**
   * Returns the field name for the retrieved element, as a utf-8 string decoded from the underlying byte array.
   * @returns {string}
   */
  fieldString() {
    return TEXT_DECODER$6.decode(this.field);
  }
  /**
   * Returns the field name for the retrieved element, as a byte array.
   * @returns {Uint8Array}
   */
  fieldUint8Array() {
    return this.field;
  }
  value() {
  }
};
cacheDictionaryGetField.Error = Error$_;
var cacheDictionaryGetFields = {}, grpcResponseTypes = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p._RankedElement = p._SortedSetElement = p._SigningKey = p._SortedSetGetScoreResponsePart = p._DictionaryGetResponsePart = p._DictionaryFieldValuePair = p._ECacheResult = void 0, function(f) {
    f[f.Invalid = 0] = "Invalid", f[f.Ok = 1] = "Ok", f[f.Hit = 2] = "Hit", f[f.Miss = 3] = "Miss";
  }(p._ECacheResult || (p._ECacheResult = {}));
  class s {
    constructor({ field: _, value: te }) {
      this.field = _, this.value = te;
    }
  }
  p._DictionaryFieldValuePair = s;
  class h {
    constructor(_, te) {
      this.result = _, this.cacheBody = te;
    }
  }
  p._DictionaryGetResponsePart = h;
  class c {
    constructor(_, te) {
      this.result = _, this.score = te;
    }
  }
  p._SortedSetGetScoreResponsePart = c;
  class d {
    constructor(_, te) {
      this.key = _ != null ? _ : "", this.expiresAt = te != null ? te : 0;
    }
  }
  p._SigningKey = d;
  class l {
    constructor(_, te) {
      this.value = _, this.score = te;
    }
  }
  p._SortedSetElement = l;
  class g {
    constructor(_, te, ae) {
      this.id = _, this.score = te, this.rank = ae;
    }
  }
  p._RankedElement = g;
})(grpcResponseTypes);
Object.defineProperty(cacheDictionaryGetFields, "__esModule", { value: !0 });
cacheDictionaryGetFields.Error = cacheDictionaryGetFields.Miss = cacheDictionaryGetFields.Hit = void 0;
const errors_1$1 = errors$1, response_base_1$Y = responseBase, cache_dictionary_get_field_1 = cacheDictionaryGetField, grpc_response_types_1 = grpcResponseTypes, enums_1$Y = enums, TEXT_DECODER$5 = new TextDecoder();
let Hit$d = class extends response_base_1$Y.ResponseBase {
  constructor(s, h) {
    super(), this.type = enums_1$Y.CacheDictionaryGetFieldsResponse.Hit, this.responses = [], this.items = s, this.fields = h, s.forEach((c, d) => {
      c.result === grpc_response_types_1._ECacheResult.Hit ? this.responses.push(new cache_dictionary_get_field_1.Hit(c.cacheBody, h[d])) : c.result === grpc_response_types_1._ECacheResult.Miss ? this.responses.push(new cache_dictionary_get_field_1.Miss(h[d])) : this.responses.push(new cache_dictionary_get_field_1.Error(new errors_1$1.UnknownError(c.result.toString()), h[d]));
    });
  }
  /**
   * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * @returns {Map<string, string>}
   */
  valueMapStringString() {
    return this.items.reduce((s, h, c) => (h.result === grpc_response_types_1._ECacheResult.Hit && s.set(TEXT_DECODER$5.decode(this.fields[c]), TEXT_DECODER$5.decode(h.cacheBody)), s), /* @__PURE__ */ new Map());
  }
  /**
   * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This is a convenience alias for {valueMapStringString}.
   * @returns {Map<string, string>}
   */
  valueMap() {
    return this.valueMapStringString();
  }
  /**
   * Returns the data as a Map whose keys are utf-8 strings, decoded from the underlying byte array, and whose values
   * are byte arrays.
   * @returns {Map<string, Uint8Array>}
   */
  valueMapStringUint8Array() {
    return this.items.reduce((s, h, c) => (h.result === grpc_response_types_1._ECacheResult.Hit && s.set(TEXT_DECODER$5.decode(this.fields[c]), h.cacheBody), s), /* @__PURE__ */ new Map());
  }
  /**
   * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This can be used in most places where an Object is desired.
   * @returns {Record<string, string>}
   */
  valueRecordStringString() {
    return this.items.reduce((s, h, c) => (h.result === grpc_response_types_1._ECacheResult.Hit && (s[TEXT_DECODER$5.decode(this.fields[c])] = TEXT_DECODER$5.decode(h.cacheBody)), s), {});
  }
  /**
   * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This can be used in most places where an Object is desired.  This is a convenience alias for
   * {valueRecordStringString}.
   * @returns {Record<string, string>}
   */
  valueRecord() {
    return this.valueRecordStringString();
  }
  /**
   * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
   * This can be used in most places where an Object is desired.  This is a convenience alias for
   * {valueRecordStringString}.
   * @returns {Record<string, string>}
   */
  value() {
    return this.valueRecordStringString();
  }
  /**
   * Returns the data as a Record whose keys are utf-8 strings, decoded from the underlying byte array, and whose
   * values are byte arrays.  This can be used in most places where an Object is desired.
   * @returns {Record<string, Uint8Array>}
   */
  valueRecordStringUint8Array() {
    return this.items.reduce((s, h, c) => (h.result === grpc_response_types_1._ECacheResult.Hit && (s[TEXT_DECODER$5.decode(this.fields[c])] = h.cacheBody), s), {});
  }
  toString() {
    let s = "";
    return this.valueMapStringString().forEach((h, c) => {
      const d = `${c}: ${h}, `;
      s = s + d;
    }), `${super.toString()}: valueDictionaryStringString: ${s.slice(0, -2)}`;
  }
};
cacheDictionaryGetFields.Hit = Hit$d;
let Miss$g = class extends response_base_1$Y.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$Y.CacheDictionaryGetFieldsResponse.Miss;
  }
  value() {
  }
};
cacheDictionaryGetFields.Miss = Miss$g;
let Error$Z = class extends response_base_1$Y.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$Y.CacheDictionaryGetFieldsResponse.Error;
  }
  value() {
  }
};
cacheDictionaryGetFields.Error = Error$Z;
var cacheDictionaryRemoveField = {};
Object.defineProperty(cacheDictionaryRemoveField, "__esModule", { value: !0 });
cacheDictionaryRemoveField.Error = cacheDictionaryRemoveField.Success = void 0;
const response_base_1$X = responseBase, enums_1$X = enums;
let Success$y = class extends response_base_1$X.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$X.CacheDictionaryRemoveFieldResponse.Success;
  }
};
cacheDictionaryRemoveField.Success = Success$y;
let Error$Y = class extends response_base_1$X.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$X.CacheDictionaryRemoveFieldResponse.Error;
  }
};
cacheDictionaryRemoveField.Error = Error$Y;
var cacheDictionaryRemoveFields = {};
Object.defineProperty(cacheDictionaryRemoveFields, "__esModule", { value: !0 });
cacheDictionaryRemoveFields.Error = cacheDictionaryRemoveFields.Success = void 0;
const response_base_1$W = responseBase, enums_1$W = enums;
let Success$x = class extends response_base_1$W.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$W.CacheDictionaryRemoveFieldsResponse.Success;
  }
};
cacheDictionaryRemoveFields.Success = Success$x;
let Error$X = class extends response_base_1$W.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$W.CacheDictionaryRemoveFieldsResponse.Error;
  }
};
cacheDictionaryRemoveFields.Error = Error$X;
var cacheDictionaryIncrement = {};
Object.defineProperty(cacheDictionaryIncrement, "__esModule", { value: !0 });
cacheDictionaryIncrement.Error = cacheDictionaryIncrement.Success = void 0;
const response_base_1$V = responseBase, enums_1$V = enums;
let Success$w = class extends response_base_1$V.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$V.CacheDictionaryIncrementResponse.Success, this._value = s;
  }
  /**
   * The new value of the element after incrementing.
   * @returns {number}
   */
  value() {
    return this._value;
  }
  valueNumber() {
    return this._value;
  }
  toString() {
    return `${super.toString()}: value: ${this.valueNumber()}`;
  }
};
cacheDictionaryIncrement.Success = Success$w;
let Error$W = class extends response_base_1$V.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$V.CacheDictionaryIncrementResponse.Error;
  }
  value() {
  }
};
cacheDictionaryIncrement.Error = Error$W;
var cacheDictionaryLength = {};
Object.defineProperty(cacheDictionaryLength, "__esModule", { value: !0 });
cacheDictionaryLength.Error = cacheDictionaryLength.Miss = cacheDictionaryLength.Hit = void 0;
const response_base_1$U = responseBase, enums_1$U = enums;
let Hit$c = class extends response_base_1$U.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$U.CacheDictionaryLengthResponse.Hit, this._length = s;
  }
  /**
   * Returns the length of the dictionary
   * @returns {number}
   */
  length() {
    return this._length;
  }
  toString() {
    return `${super.toString()}: length ${this._length}`;
  }
  value() {
    return this._length;
  }
};
cacheDictionaryLength.Hit = Hit$c;
let Miss$f = class extends response_base_1$U.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$U.CacheDictionaryLengthResponse.Miss;
  }
  value() {
  }
};
cacheDictionaryLength.Miss = Miss$f;
let Error$V = class extends response_base_1$U.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$U.CacheDictionaryLengthResponse.Error;
  }
  value() {
  }
};
cacheDictionaryLength.Error = Error$V;
var cacheSetAddElements = {}, cacheSetAddElement = {};
Object.defineProperty(cacheSetAddElement, "__esModule", { value: !0 });
cacheSetAddElement.Error = cacheSetAddElement.Success = void 0;
const response_base_1$T = responseBase, enums_1$T = enums;
let Success$v = class extends response_base_1$T.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$T.CacheSetAddElementResponse.Success;
  }
};
cacheSetAddElement.Success = Success$v;
let Error$U = class extends response_base_1$T.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$T.CacheSetAddElementResponse.Error;
  }
};
cacheSetAddElement.Error = Error$U;
Object.defineProperty(cacheSetAddElements, "__esModule", { value: !0 });
cacheSetAddElements.Error = cacheSetAddElements.Success = void 0;
const response_base_1$S = responseBase, CacheSetAddElement = cacheSetAddElement, enums_1$S = enums;
let Success$u = class extends response_base_1$S.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$S.CacheSetAddElementsResponse.Success;
  }
  toSingularResponse() {
    return new CacheSetAddElement.Success();
  }
};
cacheSetAddElements.Success = Success$u;
let Error$T = class extends response_base_1$S.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$S.CacheSetAddElementsResponse.Error;
  }
  toSingularResponse() {
    return new CacheSetAddElement.Error(this._innerException);
  }
};
cacheSetAddElements.Error = Error$T;
var cacheSetContainsElement = {};
Object.defineProperty(cacheSetContainsElement, "__esModule", { value: !0 });
cacheSetContainsElement.Error = cacheSetContainsElement.Miss = cacheSetContainsElement.Hit = void 0;
const response_base_1$R = responseBase, enums_1$R = enums;
let Hit$b = class extends response_base_1$R.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$R.CacheSetContainsElementResponse.Hit, this._containsElement = s;
  }
  /**
   * Returns a boolean indicating whether the element was found in the cache.
   * @returns {boolean}
   */
  containsElement() {
    return this._containsElement;
  }
  toString() {
    return `${super.toString()}: Hit - ${this._containsElement ? "true" : "false"}`;
  }
};
cacheSetContainsElement.Hit = Hit$b;
let Miss$e = class extends response_base_1$R.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$R.CacheSetContainsElementResponse.Miss;
  }
  containsElement() {
  }
};
cacheSetContainsElement.Miss = Miss$e;
let Error$S = class extends response_base_1$R.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$R.CacheSetContainsElementResponse.Error;
  }
  containsElement() {
  }
};
cacheSetContainsElement.Error = Error$S;
var cacheSetContainsElements = {};
Object.defineProperty(cacheSetContainsElements, "__esModule", { value: !0 });
cacheSetContainsElements.Error = cacheSetContainsElements.Miss = cacheSetContainsElements.Hit = void 0;
const response_base_1$Q = responseBase, utils_1$a = utils$1, enums_1$Q = enums, TEXT_DECODER$4 = new TextDecoder();
let Hit$a = class extends response_base_1$Q.ResponseBase {
  constructor(s, h) {
    super(), this.type = enums_1$Q.CacheSetContainsElementsResponse.Hit, this._contains = s.reduce((c, d, l) => (c[TEXT_DECODER$4.decode(d)] = h[l], c), {});
  }
  /**
   * Returns a mapping of the elements to their presence in the cache.
   * @returns {Record<string, boolean>}
   */
  containsElements() {
    return this._contains;
  }
  toString() {
    const s = (0, utils_1$a.truncateString)(Object.entries(this._contains).map(([h, c]) => `${h}: ${c ? "true" : "false"}`).join(", "));
    return `${super.toString()}: ${s}`;
  }
};
cacheSetContainsElements.Hit = Hit$a;
let Miss$d = class extends response_base_1$Q.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$Q.CacheSetContainsElementsResponse.Miss;
  }
  containsElements() {
  }
};
cacheSetContainsElements.Miss = Miss$d;
let Error$R = class extends response_base_1$Q.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$Q.CacheSetContainsElementsResponse.Error;
  }
  containsElements() {
  }
};
cacheSetContainsElements.Error = Error$R;
var cacheSetRemoveElements = {}, cacheSetRemoveElement = {};
Object.defineProperty(cacheSetRemoveElement, "__esModule", { value: !0 });
cacheSetRemoveElement.Error = cacheSetRemoveElement.Success = void 0;
const response_base_1$P = responseBase, enums_1$P = enums;
let Success$t = class extends response_base_1$P.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$P.CacheSetRemoveElementResponse.Success;
  }
};
cacheSetRemoveElement.Success = Success$t;
let Error$Q = class extends response_base_1$P.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$P.CacheSetRemoveElementResponse.Error;
  }
};
cacheSetRemoveElement.Error = Error$Q;
Object.defineProperty(cacheSetRemoveElements, "__esModule", { value: !0 });
cacheSetRemoveElements.Error = cacheSetRemoveElements.Success = void 0;
const CacheSetRemoveElement = cacheSetRemoveElement, response_base_1$O = responseBase, enums_1$O = enums;
let Success$s = class extends response_base_1$O.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$O.CacheSetRemoveElementsResponse.Success;
  }
  toSingularResponse() {
    return new CacheSetRemoveElement.Success();
  }
};
cacheSetRemoveElements.Success = Success$s;
let Error$P = class extends response_base_1$O.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$O.CacheSetRemoveElementsResponse.Error;
  }
  toSingularResponse() {
    return new CacheSetRemoveElement.Error(this._innerException);
  }
};
cacheSetRemoveElements.Error = Error$P;
var cacheSetSample = {};
Object.defineProperty(cacheSetSample, "__esModule", { value: !0 });
cacheSetSample.Error = cacheSetSample.Miss = cacheSetSample.Hit = void 0;
const response_base_1$N = responseBase, utils_1$9 = utils$1, enums_1$N = enums, TEXT_DECODER$3 = new TextDecoder();
let Hit$9 = class extends response_base_1$N.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$N.CacheSetSampleResponse.Hit, this.elements = s;
  }
  /**
   * Returns the data as a Set whose values are utf-8 strings, decoded from the underlying byte arrays.  This
   * is a convenience alias for {valueSetString}.
   * @returns {Set<string>}
   */
  valueSet() {
    return this.valueSetString();
  }
  /**
   * Returns the data as a Set whose values are utf-8 strings, decoded from the underlying byte arrays.
   * @returns {Set<string>}
   */
  valueSetString() {
    return new Set(this.elements.map((s) => TEXT_DECODER$3.decode(s)));
  }
  /**
   * Returns the data as a Set whose values are byte arrays.
   * @returns {Set<Uint8Array>}
   */
  valueSetUint8Array() {
    return new Set(this.elements);
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * This is a convenience alias for {valueArrayString}.
   * @returns {string[]}
   */
  value() {
    return this.valueArrayString();
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * This is a convenience alias for {valueArrayString}.
   * @returns {string[]}
   */
  valueArray() {
    return this.valueArrayString();
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * @returns {string[]}
   */
  valueArrayString() {
    return this.elements.map((s) => TEXT_DECODER$3.decode(s));
  }
  /**
   * Returns the data as an Array whose values are byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * @returns {Uint8Array[]}
   */
  valueArrayUint8Array() {
    return this.elements;
  }
  toString() {
    const s = (0, utils_1$9.truncateStringArray)(Array.from(this.valueSetString()));
    return `${super.toString()}: [${s.toString()}]`;
  }
};
cacheSetSample.Hit = Hit$9;
let Miss$c = class extends response_base_1$N.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$N.CacheSetSampleResponse.Miss;
  }
  value() {
  }
};
cacheSetSample.Miss = Miss$c;
let Error$O = class extends response_base_1$N.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$N.CacheSetSampleResponse.Error;
  }
  value() {
  }
};
cacheSetSample.Error = Error$O;
var cacheSetPop = {};
Object.defineProperty(cacheSetPop, "__esModule", { value: !0 });
cacheSetPop.Error = cacheSetPop.Miss = cacheSetPop.Hit = void 0;
const response_base_1$M = responseBase, utils_1$8 = utils$1, enums_1$M = enums, TEXT_DECODER$2 = new TextDecoder();
let Hit$8 = class extends response_base_1$M.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$M.CacheSetPopResponse.Hit, this.elements = s;
  }
  /**
   * Returns the data as a Set whose values are utf-8 strings, decoded from the underlying byte arrays.  This
   * is a convenience alias for {valueSetString}.
   * @returns {Set<string>}
   */
  valueSet() {
    return this.valueSetString();
  }
  /**
   * Returns the data as a Set whose values are utf-8 strings, decoded from the underlying byte arrays.
   * @returns {Set<string>}
   */
  valueSetString() {
    return new Set(this.elements.map((s) => TEXT_DECODER$2.decode(s)));
  }
  /**
   * Returns the data as a Set whose values are byte arrays.
   * @returns {Set<Uint8Array>}
   */
  valueSetUint8Array() {
    return new Set(this.elements);
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * This is a convenience alias for {valueArrayString}.
   * @returns {string[]}
   */
  value() {
    return this.valueArrayString();
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * This is a convenience alias for {valueArrayString}.
   * @returns {string[]}
   */
  valueArray() {
    return this.valueArrayString();
  }
  /**
   * Returns the data as an Array whose values are utf-8 strings, decoded from the underlying byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * @returns {string[]}
   */
  valueArrayString() {
    return this.elements.map((s) => TEXT_DECODER$2.decode(s));
  }
  /**
   * Returns the data as an Array whose values are byte arrays.
   * This accessor is provided because Arrays are sometimes easier to work with in TypeScript/JavaScript than Sets are.
   * @returns {Uint8Array[]}
   */
  valueArrayUint8Array() {
    return this.elements;
  }
  toString() {
    const s = (0, utils_1$8.truncateStringArray)(Array.from(this.valueSetString()));
    return `${super.toString()}: [${s.toString()}]`;
  }
};
cacheSetPop.Hit = Hit$8;
let Miss$b = class extends response_base_1$M.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$M.CacheSetPopResponse.Miss;
  }
  value() {
  }
};
cacheSetPop.Miss = Miss$b;
let Error$N = class extends response_base_1$M.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$M.CacheSetPopResponse.Error;
  }
  value() {
  }
};
cacheSetPop.Error = Error$N;
var cacheSetLength = {};
Object.defineProperty(cacheSetLength, "__esModule", { value: !0 });
cacheSetLength.Error = cacheSetLength.Miss = cacheSetLength.Hit = void 0;
const response_base_1$L = responseBase, enums_1$L = enums;
let Hit$7 = class extends response_base_1$L.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$L.CacheSetLengthResponse.Hit, this._length = s;
  }
  /**
   * Returns the length of the set
   * @returns {number}
   */
  length() {
    return this._length;
  }
  toString() {
    return `${super.toString()}: length ${this._length}`;
  }
};
cacheSetLength.Hit = Hit$7;
let Miss$a = class extends response_base_1$L.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$L.CacheSetLengthResponse.Miss;
  }
  length() {
  }
};
cacheSetLength.Miss = Miss$a;
let Error$M = class extends response_base_1$L.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$L.CacheSetLengthResponse.Error;
  }
  length() {
  }
};
cacheSetLength.Error = Error$M;
var cacheIncrement = {};
Object.defineProperty(cacheIncrement, "__esModule", { value: !0 });
cacheIncrement.Error = cacheIncrement.Success = void 0;
const response_base_1$K = responseBase, enums_1$K = enums;
let Success$r = class extends response_base_1$K.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$K.CacheIncrementResponse.Success, this.body = s;
  }
  /**
   * Returns the updated value as a number.
   * @returns number
   */
  value() {
    return this.body;
  }
  /**
   * Returns the updated value as a number.
   * @returns number
   */
  valueNumber() {
    return this.body;
  }
  toString() {
    return `${super.toString()}: value: ${this.value()}`;
  }
};
cacheIncrement.Success = Success$r;
let Error$L = class extends response_base_1$K.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$K.CacheIncrementResponse.Error;
  }
  value() {
  }
};
cacheIncrement.Error = Error$L;
var cacheSetIfNotExists = {};
Object.defineProperty(cacheSetIfNotExists, "__esModule", { value: !0 });
cacheSetIfNotExists.Error = cacheSetIfNotExists.NotStored = cacheSetIfNotExists.Stored = void 0;
const response_base_1$J = responseBase, enums_1$J = enums;
let Stored$6 = class extends response_base_1$J.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$J.CacheSetIfNotExistsResponse.Stored;
  }
};
cacheSetIfNotExists.Stored = Stored$6;
let NotStored$6 = class extends response_base_1$J.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$J.CacheSetIfNotExistsResponse.NotStored;
  }
};
cacheSetIfNotExists.NotStored = NotStored$6;
let Error$K = class extends response_base_1$J.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$J.CacheSetIfNotExistsResponse.Error;
  }
};
cacheSetIfNotExists.Error = Error$K;
var cacheSetIfAbsent = {};
Object.defineProperty(cacheSetIfAbsent, "__esModule", { value: !0 });
cacheSetIfAbsent.Error = cacheSetIfAbsent.NotStored = cacheSetIfAbsent.Stored = void 0;
const response_base_1$I = responseBase, enums_1$I = enums;
let Stored$5 = class extends response_base_1$I.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$I.CacheSetIfAbsentResponse.Stored;
  }
};
cacheSetIfAbsent.Stored = Stored$5;
let NotStored$5 = class extends response_base_1$I.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$I.CacheSetIfAbsentResponse.NotStored;
  }
};
cacheSetIfAbsent.NotStored = NotStored$5;
let Error$J = class extends response_base_1$I.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$I.CacheSetIfAbsentResponse.Error;
  }
};
cacheSetIfAbsent.Error = Error$J;
var cacheSetIfPresent = {};
Object.defineProperty(cacheSetIfPresent, "__esModule", { value: !0 });
cacheSetIfPresent.Error = cacheSetIfPresent.NotStored = cacheSetIfPresent.Stored = void 0;
const response_base_1$H = responseBase, enums_1$H = enums;
let Stored$4 = class extends response_base_1$H.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$H.CacheSetIfPresentResponse.Stored;
  }
};
cacheSetIfPresent.Stored = Stored$4;
let NotStored$4 = class extends response_base_1$H.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$H.CacheSetIfPresentResponse.NotStored;
  }
};
cacheSetIfPresent.NotStored = NotStored$4;
let Error$I = class extends response_base_1$H.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$H.CacheSetIfPresentResponse.Error;
  }
};
cacheSetIfPresent.Error = Error$I;
var cacheSetIfEqual = {};
Object.defineProperty(cacheSetIfEqual, "__esModule", { value: !0 });
cacheSetIfEqual.Error = cacheSetIfEqual.NotStored = cacheSetIfEqual.Stored = void 0;
const response_base_1$G = responseBase, enums_1$G = enums;
let Stored$3 = class extends response_base_1$G.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$G.CacheSetIfEqualResponse.Stored;
  }
};
cacheSetIfEqual.Stored = Stored$3;
let NotStored$3 = class extends response_base_1$G.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$G.CacheSetIfEqualResponse.NotStored;
  }
};
cacheSetIfEqual.NotStored = NotStored$3;
let Error$H = class extends response_base_1$G.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$G.CacheSetIfEqualResponse.Error;
  }
};
cacheSetIfEqual.Error = Error$H;
var cacheSetIfNotEqual = {};
Object.defineProperty(cacheSetIfNotEqual, "__esModule", { value: !0 });
cacheSetIfNotEqual.Error = cacheSetIfNotEqual.NotStored = cacheSetIfNotEqual.Stored = void 0;
const response_base_1$F = responseBase, enums_1$F = enums;
let Stored$2 = class extends response_base_1$F.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$F.CacheSetIfNotEqualResponse.Stored;
  }
};
cacheSetIfNotEqual.Stored = Stored$2;
let NotStored$2 = class extends response_base_1$F.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$F.CacheSetIfNotEqualResponse.NotStored;
  }
};
cacheSetIfNotEqual.NotStored = NotStored$2;
let Error$G = class extends response_base_1$F.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$F.CacheSetIfNotEqualResponse.Error;
  }
};
cacheSetIfNotEqual.Error = Error$G;
var cacheSetIfPresentAndNotEqual = {};
Object.defineProperty(cacheSetIfPresentAndNotEqual, "__esModule", { value: !0 });
cacheSetIfPresentAndNotEqual.Error = cacheSetIfPresentAndNotEqual.NotStored = cacheSetIfPresentAndNotEqual.Stored = void 0;
const response_base_1$E = responseBase, enums_1$E = enums;
let Stored$1 = class extends response_base_1$E.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$E.CacheSetIfPresentAndNotEqualResponse.Stored;
  }
};
cacheSetIfPresentAndNotEqual.Stored = Stored$1;
let NotStored$1 = class extends response_base_1$E.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$E.CacheSetIfPresentAndNotEqualResponse.NotStored;
  }
};
cacheSetIfPresentAndNotEqual.NotStored = NotStored$1;
let Error$F = class extends response_base_1$E.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$E.CacheSetIfPresentAndNotEqualResponse.Error;
  }
};
cacheSetIfPresentAndNotEqual.Error = Error$F;
var cacheSetIfAbsentOrEqual = {};
Object.defineProperty(cacheSetIfAbsentOrEqual, "__esModule", { value: !0 });
cacheSetIfAbsentOrEqual.Error = cacheSetIfAbsentOrEqual.NotStored = cacheSetIfAbsentOrEqual.Stored = void 0;
const response_base_1$D = responseBase, enums_1$D = enums;
class Stored extends response_base_1$D.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$D.CacheSetIfAbsentOrEqualResponse.Stored;
  }
}
cacheSetIfAbsentOrEqual.Stored = Stored;
class NotStored extends response_base_1$D.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$D.CacheSetIfAbsentOrEqualResponse.NotStored;
  }
}
cacheSetIfAbsentOrEqual.NotStored = NotStored;
let Error$E = class extends response_base_1$D.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$D.CacheSetIfAbsentOrEqualResponse.Error;
  }
};
cacheSetIfAbsentOrEqual.Error = Error$E;
var cacheSortedSetPutElement = {};
Object.defineProperty(cacheSortedSetPutElement, "__esModule", { value: !0 });
cacheSortedSetPutElement.Error = cacheSortedSetPutElement.Success = void 0;
const response_base_1$C = responseBase, enums_1$C = enums;
let Success$q = class extends response_base_1$C.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$C.CacheSortedSetPutElementResponse.Success;
  }
};
cacheSortedSetPutElement.Success = Success$q;
let Error$D = class extends response_base_1$C.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$C.CacheSortedSetPutElementResponse.Error;
  }
};
cacheSortedSetPutElement.Error = Error$D;
var cacheSortedSetPutElements = {};
Object.defineProperty(cacheSortedSetPutElements, "__esModule", { value: !0 });
cacheSortedSetPutElements.Error = cacheSortedSetPutElements.Success = void 0;
const response_base_1$B = responseBase, enums_1$B = enums;
let Success$p = class extends response_base_1$B.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$B.CacheSortedSetPutElementsResponse.Success;
  }
};
cacheSortedSetPutElements.Success = Success$p;
let Error$C = class extends response_base_1$B.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$B.CacheSortedSetPutElementsResponse.Error;
  }
};
cacheSortedSetPutElements.Error = Error$C;
var cacheSortedSetFetch = {};
Object.defineProperty(cacheSortedSetFetch, "__esModule", { value: !0 });
cacheSortedSetFetch.Error = cacheSortedSetFetch.Miss = cacheSortedSetFetch.Hit = void 0;
const response_base_1$A = responseBase, enums_1$A = enums, TEXT_DECODER$1 = new TextDecoder();
let Hit$6 = class extends response_base_1$A.ResponseBase {
  constructor(s) {
    super(), this._displayListSizeLimit = 5, this.type = enums_1$A.CacheSortedSetFetchResponse.Hit, this.elements = s;
  }
  /**
   * Returns the elements as an array of objects, each containing a `value` and `score` field.
   * The value is a byte array, and the score is a number.
   * @returns {{value: Uint8Array; score: number}[]}
   */
  valueArrayUint8Elements() {
    return this.elements.map((s) => ({
      value: s.value,
      score: s.score
    }));
  }
  /**
   * Returns the elements as an array of objects, each containing a `value` and `score` field.
   * The value is a utf-8 string, decoded from the underlying byte array, and the score is a number.
   * @returns {{value: string; score: number}[]}
   */
  valueArrayStringElements() {
    return this.elements.map((s) => ({
      value: TEXT_DECODER$1.decode(s.value),
      score: s.score
    }));
  }
  /**
   * Returns the elements as an array of objects, each containing a `value` and `score` field.
   * The value is a utf-8 string, decoded from the underlying byte array, and the score is a number.
   * This is a convenience alias for {valueArrayStringNumber}.
   * @returns {value: string; score: number}[]
   */
  valueArray() {
    return this.valueArrayStringElements();
  }
  /**
   * Returns the elements as an array of objects, each containing a `value` and `score` field.
   * The value is a utf-8 string, decoded from the underlying byte array, and the score is a number.
   * This is a convenience alias for {valueArrayStringNumber}.
   * @returns {value: string; score: number}[]
   */
  value() {
    return this.valueArrayStringElements();
  }
  truncateValueStrings() {
    const s = this.valueArrayStringElements(), h = [];
    return s.length <= this._displayListSizeLimit ? s.forEach((c) => {
      h.push(`${c.value}: ${c.score}`);
    }) : s.slice(0, this._displayListSizeLimit).forEach((d) => {
      h.push(`${d.value}: ${d.score}`);
    }), h.join(", ");
  }
  toString() {
    return `${super.toString()}: valueArrayStringElements: ${this.truncateValueStrings()}`;
  }
};
cacheSortedSetFetch.Hit = Hit$6;
let Miss$9 = class extends response_base_1$A.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$A.CacheSortedSetFetchResponse.Miss;
  }
  value() {
  }
};
cacheSortedSetFetch.Miss = Miss$9;
let Error$B = class extends response_base_1$A.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$A.CacheSortedSetFetchResponse.Error;
  }
  value() {
  }
};
cacheSortedSetFetch.Error = Error$B;
var cacheSortedSetGetRank = {};
Object.defineProperty(cacheSortedSetGetRank, "__esModule", { value: !0 });
cacheSortedSetGetRank.Error = cacheSortedSetGetRank.Miss = cacheSortedSetGetRank.Hit = void 0;
const response_base_1$z = responseBase, enums_1$z = enums;
let Hit$5 = class extends response_base_1$z.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$z.CacheSortedSetGetRankResponse.Hit, this._rank = s;
  }
  /**
   * Returns the rank of the element in the sorted set.  Ranks start at 0.
   * @returns {number}
   */
  rank() {
    return this._rank;
  }
  toString() {
    return `${super.toString()}: rank: ${this.rank()}`;
  }
};
cacheSortedSetGetRank.Hit = Hit$5;
let Miss$8 = class extends response_base_1$z.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$z.CacheSortedSetGetRankResponse.Miss;
  }
  rank() {
  }
};
cacheSortedSetGetRank.Miss = Miss$8;
let Error$A = class extends response_base_1$z.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$z.CacheSortedSetGetRankResponse.Error;
  }
  rank() {
  }
};
cacheSortedSetGetRank.Error = Error$A;
var cacheSortedSetGetScore = {};
Object.defineProperty(cacheSortedSetGetScore, "__esModule", { value: !0 });
cacheSortedSetGetScore.Error = cacheSortedSetGetScore.Miss = cacheSortedSetGetScore.Hit = void 0;
const response_base_1$y = responseBase, enums_1$y = enums;
let Hit$4 = class extends response_base_1$y.ResponseBase {
  constructor(s, h) {
    super(), this.type = enums_1$y.CacheSortedSetGetScoreResponse.Hit, this._value = h, this._score = s;
  }
  /**
   * Returns the value of the element in the sorted set as a Uint8Array.
   * @returns {number}
   */
  valueUint8Array() {
    return this._value;
  }
  /**
   * Returns the value of the element in the sorted set as a string.
   * @returns {string}
   */
  valueString() {
    return new TextDecoder().decode(this._value);
  }
  /**
   * Returns the score of the element in the sorted set.
   * @return {*}  {number}
   */
  score() {
    return this._score;
  }
  toString() {
    return `${super.toString()}: value: ${this.valueString()}`;
  }
};
cacheSortedSetGetScore.Hit = Hit$4;
let Miss$7 = class extends response_base_1$y.BaseResponseMiss {
  constructor(s) {
    super(), this.type = enums_1$y.CacheSortedSetGetScoreResponse.Miss, this._value = s;
  }
  /**
   * Returns the value of the element in the sorted set as a Uint8Array.
   * @returns {number}
   */
  valueUint8Array() {
    return this._value;
  }
  /**
   * Returns the score of the element in the sorted set as a string.
   * @returns {string}
   */
  valueString() {
    return new TextDecoder().decode(this._value);
  }
  score() {
  }
  toString() {
    return `${super.toString()}: value: ${this.valueString()}`;
  }
};
cacheSortedSetGetScore.Miss = Miss$7;
let Error$z = class extends response_base_1$y.BaseResponseError {
  constructor(s, h) {
    super(s), this.type = enums_1$y.CacheSortedSetGetScoreResponse.Error, this._value = h;
  }
  /**
   * Returns the value of the element in the sorted set as a Uint8Array.
   * @returns {number}
   */
  valueUint8Array() {
    return this._value;
  }
  /**
   * Returns the score of the element in the sorted set as a string.
   * @returns {string}
   */
  valueString() {
    return new TextDecoder().decode(this._value);
  }
  score() {
  }
};
cacheSortedSetGetScore.Error = Error$z;
var cacheSortedSetGetScores = {}, hasRequiredCacheSortedSetGetScores;
function requireCacheSortedSetGetScores() {
  if (hasRequiredCacheSortedSetGetScores) return cacheSortedSetGetScores;
  hasRequiredCacheSortedSetGetScores = 1, Object.defineProperty(cacheSortedSetGetScores, "__esModule", { value: !0 }), cacheSortedSetGetScores.Error = cacheSortedSetGetScores.Miss = cacheSortedSetGetScores.Hit = void 0;
  const p = errors$1, s = responseBase, h = grpcResponseTypes, c = enums, d = requireSrc$1();
  class l extends s.ResponseBase {
    constructor(te, ae) {
      super(), this._responses = [], this.type = c.CacheSortedSetGetScoresResponse.Hit, te.forEach((ie, se) => {
        ie.result === h._ECacheResult.Hit ? this._responses.push(new d.CacheSortedSetGetScore.Hit(ie.score, ae[se])) : ie.result === h._ECacheResult.Miss ? this._responses.push(new d.CacheSortedSetGetScore.Miss(ae[se])) : this._responses.push(new d.CacheSortedSetGetScore.Error(new p.UnknownError(ie.result.toString()), ae[se]));
      });
    }
    responses() {
      return this._responses;
    }
    /**
     * Returns the data as a Map whose keys are utf-8 strings, decoded from the underlying byte arrays and values are numbers.
     * @returns {Map<string, number>}
     */
    valueMapString() {
      return this._responses.reduce((te, ae) => (ae instanceof d.CacheSortedSetGetScore.Hit && te.set(ae.valueString(), ae.score()), te), /* @__PURE__ */ new Map());
    }
    /**
     * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This is a convenience alias for {valueMapStringString}.
     * @returns {Map<string, number>}
     */
    valueMap() {
      return this.valueMapString();
    }
    /**
     * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This can be used in most places where an Object is desired.
     * @returns {Record<string, number>}
     */
    valueRecordString() {
      return this._responses.reduce((te, ae) => (ae instanceof d.CacheSortedSetGetScore.Hit && (te[ae.valueString()] = ae.score()), te), {});
    }
    /**
     * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This can be used in most places where an Object is desired.  This is a convenience alias for
     * {valueRecordStringString}.
     * @returns {Record<string, number>}
     */
    valueRecord() {
      return this.valueRecordString();
    }
    /**
     * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This can be used in most places where an Object is desired.  This is a convenience alias for
     * {valueRecordStringString}.
     * @returns {Record<string, number>}
     */
    value() {
      return this.valueRecord();
    }
    toString() {
      let te = "";
      return this.valueMapString().forEach((ae, ie) => {
        const se = `${ie}: ${ae}, `;
        te = te + se;
      }), `${super.toString()}: valueMapString: ${te.slice(0, -2)}`;
    }
  }
  cacheSortedSetGetScores.Hit = l;
  class g extends s.BaseResponseMiss {
    constructor() {
      super(...arguments), this.type = c.CacheSortedSetGetScoresResponse.Miss;
    }
    value() {
    }
  }
  cacheSortedSetGetScores.Miss = g;
  class f extends s.BaseResponseError {
    constructor(te) {
      super(te), this.type = c.CacheSortedSetGetScoresResponse.Error;
    }
    value() {
    }
  }
  return cacheSortedSetGetScores.Error = f, cacheSortedSetGetScores;
}
var cacheSortedSetIncrementScore = {};
Object.defineProperty(cacheSortedSetIncrementScore, "__esModule", { value: !0 });
cacheSortedSetIncrementScore.Error = cacheSortedSetIncrementScore.Success = void 0;
const response_base_1$x = responseBase, enums_1$x = enums;
let Success$o = class extends response_base_1$x.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$x.CacheSortedSetIncrementScoreResponse.Success, this._score = s;
  }
  /**
   * The new score of the element after incrementing.
   * @returns {number}
   */
  score() {
    return this._score;
  }
  toString() {
    return `${super.toString()}: value: ${this.score()}`;
  }
};
cacheSortedSetIncrementScore.Success = Success$o;
let Error$y = class extends response_base_1$x.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$x.CacheSortedSetIncrementScoreResponse.Error;
  }
  score() {
  }
};
cacheSortedSetIncrementScore.Error = Error$y;
var cacheSortedSetRemoveElement = {};
Object.defineProperty(cacheSortedSetRemoveElement, "__esModule", { value: !0 });
cacheSortedSetRemoveElement.Error = cacheSortedSetRemoveElement.Success = void 0;
const response_base_1$w = responseBase, enums_1$w = enums;
let Success$n = class extends response_base_1$w.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$w.CacheSortedSetRemoveElementResponse.Success;
  }
};
cacheSortedSetRemoveElement.Success = Success$n;
let Error$x = class extends response_base_1$w.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$w.CacheSortedSetRemoveElementResponse.Error;
  }
};
cacheSortedSetRemoveElement.Error = Error$x;
var cacheSortedSetRemoveElements = {};
Object.defineProperty(cacheSortedSetRemoveElements, "__esModule", { value: !0 });
cacheSortedSetRemoveElements.Error = cacheSortedSetRemoveElements.Success = void 0;
const response_base_1$v = responseBase, enums_1$v = enums;
let Success$m = class extends response_base_1$v.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$v.CacheSortedSetRemoveElementsResponse.Success;
  }
};
cacheSortedSetRemoveElements.Success = Success$m;
let Error$w = class extends response_base_1$v.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$v.CacheSortedSetRemoveElementsResponse.Error;
  }
};
cacheSortedSetRemoveElements.Error = Error$w;
var cacheSortedSetLength = {};
Object.defineProperty(cacheSortedSetLength, "__esModule", { value: !0 });
cacheSortedSetLength.Error = cacheSortedSetLength.Miss = cacheSortedSetLength.Hit = void 0;
const response_base_1$u = responseBase, enums_1$u = enums;
let Hit$3 = class extends response_base_1$u.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$u.CacheSortedSetLengthResponse.Hit, this._length = s;
  }
  /**
   * Returns the length of the sorted set
   * @returns {number}
   */
  length() {
    return this._length;
  }
  toString() {
    return `${super.toString()}: length ${this._length}`;
  }
};
cacheSortedSetLength.Hit = Hit$3;
let Miss$6 = class extends response_base_1$u.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$u.CacheSortedSetLengthResponse.Miss;
  }
  length() {
  }
};
cacheSortedSetLength.Miss = Miss$6;
let Error$v = class extends response_base_1$u.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$u.CacheSortedSetLengthResponse.Error;
  }
  length() {
  }
};
cacheSortedSetLength.Error = Error$v;
var cacheSortedSetLengthByScore = {};
Object.defineProperty(cacheSortedSetLengthByScore, "__esModule", { value: !0 });
cacheSortedSetLengthByScore.Error = cacheSortedSetLengthByScore.Miss = cacheSortedSetLengthByScore.Hit = void 0;
const response_base_1$t = responseBase, enums_1$t = enums;
let Hit$2 = class extends response_base_1$t.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$t.CacheSortedSetLengthByScoreResponse.Hit, this._length = s;
  }
  /**
   * Returns the length of the sorted set
   * @returns {number}
   */
  length() {
    return this._length;
  }
  toString() {
    return `${super.toString()}: length ${this._length}`;
  }
};
cacheSortedSetLengthByScore.Hit = Hit$2;
let Miss$5 = class extends response_base_1$t.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$t.CacheSortedSetLengthByScoreResponse.Miss;
  }
  length() {
  }
};
cacheSortedSetLengthByScore.Miss = Miss$5;
let Error$u = class extends response_base_1$t.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$t.CacheSortedSetLengthByScoreResponse.Error;
  }
  length() {
  }
};
cacheSortedSetLengthByScore.Error = Error$u;
var cacheItemGetType = {};
Object.defineProperty(cacheItemGetType, "__esModule", { value: !0 });
cacheItemGetType.Error = cacheItemGetType.Miss = cacheItemGetType.Hit = void 0;
const response_base_1$s = responseBase, enums_1$s = enums;
let Hit$1 = class extends response_base_1$s.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$s.CacheItemGetTypeResponse.Hit, this.keyType = s;
  }
  /**
   * Returns the type of key.
   * @returns {ItemType}
   */
  itemType() {
    return this.keyType;
  }
  toString() {
    return `${super.toString()}: item type: ${this.keyType}`;
  }
};
cacheItemGetType.Hit = Hit$1;
let Miss$4 = class extends response_base_1$s.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$s.CacheItemGetTypeResponse.Miss;
  }
  itemType() {
  }
};
cacheItemGetType.Miss = Miss$4;
let Error$t = class extends response_base_1$s.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$s.CacheItemGetTypeResponse.Error;
  }
  itemType() {
  }
};
cacheItemGetType.Error = Error$t;
var cacheItemGetTtl = {};
Object.defineProperty(cacheItemGetTtl, "__esModule", { value: !0 });
cacheItemGetTtl.Error = cacheItemGetTtl.Miss = cacheItemGetTtl.Hit = void 0;
const response_base_1$r = responseBase, enums_1$r = enums;
class Hit extends response_base_1$r.ResponseBase {
  constructor(s) {
    super(), this.type = enums_1$r.CacheItemGetTtlResponse.Hit, this.ttlMillis = s;
  }
  /**
   * Returns the remaining ttl in milliseconds for object stored at passed key.
   * @returns number
   */
  remainingTtlMillis() {
    return this.ttlMillis;
  }
  toString() {
    return `${super.toString()}: remaining ttl: ${this.ttlMillis}`;
  }
}
cacheItemGetTtl.Hit = Hit;
let Miss$3 = class extends response_base_1$r.BaseResponseMiss {
  constructor() {
    super(), this.type = enums_1$r.CacheItemGetTtlResponse.Miss;
  }
  remainingTtlMillis() {
  }
};
cacheItemGetTtl.Miss = Miss$3;
let Error$s = class extends response_base_1$r.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$r.CacheItemGetTtlResponse.Error;
  }
  remainingTtlMillis() {
  }
};
cacheItemGetTtl.Error = Error$s;
var cacheKeyExists = {};
Object.defineProperty(cacheKeyExists, "__esModule", { value: !0 });
cacheKeyExists.Error = cacheKeyExists.Success = void 0;
const response_base_1$q = responseBase, enums_1$q = enums;
let Success$l = class extends response_base_1$q.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$q.CacheKeyExistsResponse.Success, this._exists = s[0];
  }
  /**
   * Returns the boolean indicating whether the given key was found in the cache.
   * @returns {boolean}
   */
  exists() {
    return this._exists;
  }
  toString() {
    return `${super.toString()}: exists: ${String(this._exists)}`;
  }
};
cacheKeyExists.Success = Success$l;
let Error$r = class extends response_base_1$q.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$q.CacheKeyExistsResponse.Error;
  }
  exists() {
  }
};
cacheKeyExists.Error = Error$r;
var cacheKeysExist = {};
Object.defineProperty(cacheKeysExist, "__esModule", { value: !0 });
cacheKeysExist.Error = cacheKeysExist.Success = void 0;
const response_base_1$p = responseBase, enums_1$p = enums, TEXT_DECODER = new TextDecoder();
let Success$k = class extends response_base_1$p.BaseResponseSuccess {
  constructor(s, h) {
    super(), this.type = enums_1$p.CacheKeysExistResponse.Success, this._keys = s, this._exists = h;
  }
  /**
   * A list of booleans indicating whether each given key was found in the cache.
   * @returns {boolean[]}
   */
  exists() {
    return this._exists;
  }
  /**
   * A record of key-exists pairs indicating whether each given key was found in the cache.
   * @returns {Record<string, boolean>}
   */
  valueRecord() {
    return this._keys.reduce((s, h, c) => (s[TEXT_DECODER.decode(h)] = this._exists[c], s), {});
  }
  toString() {
    const s = this._exists.map((h) => h);
    return super.toString() + ": exists: " + s.join(", ");
  }
};
cacheKeysExist.Success = Success$k;
let Error$q = class extends response_base_1$p.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$p.CacheKeysExistResponse.Error;
  }
  exists() {
  }
};
cacheKeysExist.Error = Error$q;
var cacheTtlUpdate = {};
Object.defineProperty(cacheTtlUpdate, "__esModule", { value: !0 });
cacheTtlUpdate.Error = cacheTtlUpdate.Miss = cacheTtlUpdate.Set = void 0;
const response_base_1$o = responseBase, enums_1$o = enums;
let Set$3 = class extends response_base_1$o.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$o.CacheUpdateTtlResponse.Set;
  }
};
cacheTtlUpdate.Set = Set$3;
let Miss$2 = class extends response_base_1$o.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$o.CacheUpdateTtlResponse.Miss;
  }
};
cacheTtlUpdate.Miss = Miss$2;
let Error$p = class extends response_base_1$o.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$o.CacheUpdateTtlResponse.Error;
  }
};
cacheTtlUpdate.Error = Error$p;
var cacheTtlIncrease = {};
Object.defineProperty(cacheTtlIncrease, "__esModule", { value: !0 });
cacheTtlIncrease.Error = cacheTtlIncrease.Miss = cacheTtlIncrease.NotSet = cacheTtlIncrease.Set = void 0;
const response_base_1$n = responseBase, enums_1$n = enums;
let Set$2 = class extends response_base_1$n.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$n.CacheIncreaseTtlResponse.Set;
  }
};
cacheTtlIncrease.Set = Set$2;
let NotSet$1 = class extends response_base_1$n.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$n.CacheIncreaseTtlResponse.NotSet;
  }
};
cacheTtlIncrease.NotSet = NotSet$1;
let Miss$1 = class extends response_base_1$n.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$n.CacheIncreaseTtlResponse.Miss;
  }
};
cacheTtlIncrease.Miss = Miss$1;
let Error$o = class extends response_base_1$n.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$n.CacheIncreaseTtlResponse.Error;
  }
};
cacheTtlIncrease.Error = Error$o;
var cacheTtlDecrease = {};
Object.defineProperty(cacheTtlDecrease, "__esModule", { value: !0 });
cacheTtlDecrease.Error = cacheTtlDecrease.Miss = cacheTtlDecrease.NotSet = cacheTtlDecrease.Set = void 0;
const response_base_1$m = responseBase, enums_1$m = enums;
let Set$1 = class extends response_base_1$m.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$m.CacheDecreaseTtlResponse.Set;
  }
};
cacheTtlDecrease.Set = Set$1;
class NotSet extends response_base_1$m.ResponseBase {
  constructor() {
    super(...arguments), this.type = enums_1$m.CacheDecreaseTtlResponse.NotSet;
  }
}
cacheTtlDecrease.NotSet = NotSet;
class Miss extends response_base_1$m.BaseResponseMiss {
  constructor() {
    super(...arguments), this.type = enums_1$m.CacheDecreaseTtlResponse.Miss;
  }
}
cacheTtlDecrease.Miss = Miss;
let Error$n = class extends response_base_1$m.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$m.CacheDecreaseTtlResponse.Error;
  }
};
cacheTtlDecrease.Error = Error$n;
var cacheBatchSet = {};
Object.defineProperty(cacheBatchSet, "__esModule", { value: !0 });
cacheBatchSet.Error = cacheBatchSet.Success = void 0;
const response_base_1$l = responseBase, enums_1$l = enums;
let Success$j = class extends response_base_1$l.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$l.CacheSetBatchResponse.Success, this.body = s;
  }
  /**
   * Returns the status for each request in the batch as a list of CacheGet.Response objects.
   * @returns {CacheSet.Response[]}
   */
  results() {
    return this.body;
  }
};
cacheBatchSet.Success = Success$j;
let Error$m = class extends response_base_1$l.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$l.CacheSetBatchResponse.Error;
  }
};
cacheBatchSet.Error = Error$m;
var cacheBatchGet = {}, hasRequiredCacheBatchGet;
function requireCacheBatchGet() {
  if (hasRequiredCacheBatchGet) return cacheBatchGet;
  hasRequiredCacheBatchGet = 1, Object.defineProperty(cacheBatchGet, "__esModule", { value: !0 }), cacheBatchGet.Error = cacheBatchGet.Success = void 0;
  const p = responseBase, s = enums, h = requireSrc$1(), c = new TextDecoder();
  class d extends p.BaseResponseSuccess {
    constructor(f, _) {
      super(), this.type = s.CacheGetBatchResponse.Success, this.body = f, this.keys = _;
    }
    /**
     * Returns the status for each request in the batch as a list of CacheGet.Response objects.
     * @returns {CacheGet.Response[]}
     */
    results() {
      return this.body;
    }
    /**
     * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This can be used in most places where an Object is desired.  This is a convenience alias for
     * {valueRecordStringString}.
     * @returns {Record<string, string>}
     */
    values() {
      return this.valuesRecordStringString();
    }
    /**
     * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This can be used in most places where an Object is desired.  This is a convenience alias for
     * {valueRecordStringString}.
     * @returns {Record<string, string>}
     */
    valuesRecord() {
      return this.valuesRecordStringString();
    }
    /**
     * Returns the data as a Record whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This can be used in most places where an Object is desired.
     * @returns {Record<string, string>}
     */
    valuesRecordStringString() {
      return this.body.reduce((f, _, te) => (_ instanceof h.CacheGet.Hit && (f[c.decode(this.keys[te])] = _.valueString()), f), {});
    }
    /**
     * Returns the data as a Record whose keys are utf-8 strings, decoded from the underlying byte array, and whose
     * values are byte arrays.  This can be used in most places where an Object is desired.
     * @returns {Record<string, Uint8Array>}
     */
    valuesRecordStringUint8Array() {
      return this.body.reduce((f, _, te) => (_ instanceof h.CacheGet.Hit && (f[c.decode(this.keys[te])] = _.valueUint8Array()), f), {});
    }
    /**
     * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * This is a convenience alias for {valueMapStringString}.
     * @returns {Map<string, string>}
     */
    valuesMap() {
      return this.valuesMapStringString();
    }
    /**
     * Returns the data as a Map whose keys and values are utf-8 strings, decoded from the underlying byte arrays.
     * @returns {Map<string, string>}
     */
    valuesMapStringString() {
      return this.body.reduce((f, _, te) => (_ instanceof h.CacheGet.Hit && f.set(c.decode(this.keys[te]), _.valueString()), f), /* @__PURE__ */ new Map());
    }
    /**
     * Returns the data as a Map whose keys are strings and whose values are byte arrays.
     * @returns {Map<string, Uint8Array>}
     */
    valuesMapStringUint8Array() {
      return this.body.reduce((f, _, te) => (_ instanceof h.CacheGet.Hit && f.set(c.decode(this.keys[te]), _.valueUint8Array()), f), /* @__PURE__ */ new Map());
    }
    toString() {
      const f = this.results().map((_) => _.toString()).toString();
      return `${super.toString()}: ${f}`;
    }
  }
  cacheBatchGet.Success = d;
  class l extends p.BaseResponseError {
    constructor(f) {
      super(f), this.type = s.CacheGetBatchResponse.Error;
    }
    values() {
    }
  }
  return cacheBatchGet.Error = l, cacheBatchGet;
}
var topicPublish = {};
Object.defineProperty(topicPublish, "__esModule", { value: !0 });
topicPublish.Error = topicPublish.Success = void 0;
const response_base_1$k = responseBase, enums_1$k = enums;
let Success$i = class extends response_base_1$k.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$k.TopicPublishResponse.Success;
  }
};
topicPublish.Success = Success$i;
let Error$l = class extends response_base_1$k.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$k.TopicPublishResponse.Error;
  }
};
topicPublish.Error = Error$l;
var topicSubscribe = {};
Object.defineProperty(topicSubscribe, "__esModule", { value: !0 });
topicSubscribe.Error = topicSubscribe.Subscription = void 0;
const response_base_1$j = responseBase, enums_1$j = enums;
class Subscription extends response_base_1$j.BaseResponseSubscription {
  constructor(s, h) {
    super(), this.type = enums_1$j.TopicSubscribeResponse.Subscription, this.logger = s.getLogger(this), this.subscriptionState = h;
  }
  /**
   * Unsubscribes from the topic.
   *
   * @returns void
   */
  unsubscribe() {
    this.logger.trace(`Unsubscribing from subscription: ${this.subscriptionState.toString()}`), this.subscriptionState.unsubscribe();
  }
  get isSubscribed() {
    return this.subscriptionState.isSubscribed;
  }
}
topicSubscribe.Subscription = Subscription;
let Error$k = class extends response_base_1$j.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$j.TopicSubscribeResponse.Error;
  }
};
topicSubscribe.Error = Error$k;
var topicItem = {};
Object.defineProperty(topicItem, "__esModule", { value: !0 });
topicItem.TopicItem = void 0;
const utils_1$7 = utils$1;
class TopicItem {
  constructor(s, h, c) {
    this._value = s, this._tokenId = c == null ? void 0 : c.tokenId, this._sequenceNumber = h;
  }
  /**
   * Returns the data read from the stream.
   * @returns string | Uint8Array
   */
  value() {
    return this._value;
  }
  /**
   * Returns the data read from the stream as a {@link string}.
   * @returns string
   */
  valueString() {
    return this.value().toString();
  }
  /**
   * Returns the data read from the stream as a {@link Uint8Array}.
   * @returns Uint8Array
   */
  valueUint8Array() {
    return this.value();
  }
  /**
   * Optionally returns the publisher ID from the steam if it exists.
   * @returns string | undefined
   */
  tokenId() {
    return this._tokenId;
  }
  /**
   * Returns the sequence number of the item.
   * @returns number
   */
  sequenceNumber() {
    return this._sequenceNumber;
  }
  toString() {
    const s = (0, utils_1$7.truncateString)(this.value().toString());
    let h = `${this.constructor.name}: ${s}`;
    return this._tokenId !== void 0 && (h += `; Token Id: ${this._tokenId}`), h;
  }
}
topicItem.TopicItem = TopicItem;
var topicDiscontinuity = {};
Object.defineProperty(topicDiscontinuity, "__esModule", { value: !0 });
topicDiscontinuity.TopicDiscontinuity = void 0;
class TopicDiscontinuity {
  constructor(s, h) {
    this._lastSequenceNumber = s, this._newSequenceNumber = h;
  }
  /**
   * Returns the last sequence number before the discontinuity.
   * @returns number
   */
  lastSequenceNumber() {
    return this._lastSequenceNumber;
  }
  /**
   * Returns the new sequence number after the discontinuity.
   * @returns number
   */
  newSequenceNumber() {
    return this._newSequenceNumber;
  }
  toString() {
    const s = `Last Sequence Number: ${this._lastSequenceNumber}; New Sequence Number: ${this._newSequenceNumber}`;
    return `${this.constructor.name}: ${s}`;
  }
}
topicDiscontinuity.TopicDiscontinuity = TopicDiscontinuity;
var topicHeartbeat = {};
Object.defineProperty(topicHeartbeat, "__esModule", { value: !0 });
topicHeartbeat.TopicHeartbeat = void 0;
class TopicHeartbeat {
  toString() {
    return `${this.constructor.name}`;
  }
}
topicHeartbeat.TopicHeartbeat = TopicHeartbeat;
var generateApiKey = {};
Object.defineProperty(generateApiKey, "__esModule", { value: !0 });
generateApiKey.Error = generateApiKey.Success = void 0;
const response_base_1$i = responseBase, enums_1$i = enums, utils_1$6 = utils$1;
let Success$h = class extends response_base_1$i.BaseResponseSuccess {
  /**
   * @deprecated Use `apiKey` instead.
   */
  get authToken() {
    return this.apiKey;
  }
  constructor(s, h, c, d) {
    super(), this.type = enums_1$i.GenerateApiKeyResponse.Success, this.apiKey = (0, utils_1$6.encodeToBase64)(JSON.stringify({ endpoint: c, api_key: s })), this.refreshToken = h, this.endpoint = c, this.expiresAt = d;
  }
};
generateApiKey.Success = Success$h;
let Error$j = class extends response_base_1$i.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$i.GenerateApiKeyResponse.Error;
  }
};
generateApiKey.Error = Error$j;
var refreshApiKey = {};
Object.defineProperty(refreshApiKey, "__esModule", { value: !0 });
refreshApiKey.Error = refreshApiKey.Success = void 0;
const response_base_1$h = responseBase, enums_1$h = enums, utils_1$5 = utils$1;
let Success$g = class extends response_base_1$h.BaseResponseSuccess {
  /**
   * @deprecated Use `apiKey` instead.
   * @returns {string}
   */
  get authToken() {
    return this.apiKey;
  }
  constructor(s, h, c, d) {
    super(), this.type = enums_1$h.RefreshApiKeyResponse.Success, this.apiKey = (0, utils_1$5.encodeToBase64)(JSON.stringify({ endpoint: c, api_key: s })), this.refreshToken = h, this.endpoint = c, this.expiresAt = d;
  }
};
refreshApiKey.Success = Success$g;
let Error$i = class extends response_base_1$h.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$h.RefreshApiKeyResponse.Error;
  }
};
refreshApiKey.Error = Error$i;
var generateDisposableToken = {};
Object.defineProperty(generateDisposableToken, "__esModule", { value: !0 });
generateDisposableToken.Error = generateDisposableToken.Success = void 0;
const response_base_1$g = responseBase, enums_1$g = enums, utils_1$4 = utils$1;
let Success$f = class extends response_base_1$g.BaseResponseSuccess {
  constructor(s, h, c) {
    super(), this.type = enums_1$g.GenerateDisposableTokenResponse.Success, this.authToken = (0, utils_1$4.encodeToBase64)(JSON.stringify({ endpoint: h, api_key: s })), this.endpoint = h, this.expiresAt = c;
  }
};
generateDisposableToken.Success = Success$f;
let Error$h = class extends response_base_1$g.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$g.GenerateDisposableTokenResponse.Error;
  }
};
generateDisposableToken.Error = Error$h;
var leaderboard$2 = {}, leaderboardDelete = {};
Object.defineProperty(leaderboardDelete, "__esModule", { value: !0 });
leaderboardDelete.Error = leaderboardDelete.Success = void 0;
const response_base_1$f = responseBase, enums_1$f = enums;
let Success$e = class extends response_base_1$f.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$f.LeaderboardDeleteResponse.Success;
  }
};
leaderboardDelete.Success = Success$e;
let Error$g = class extends response_base_1$f.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$f.LeaderboardDeleteResponse.Error;
  }
};
leaderboardDelete.Error = Error$g;
var leaderboardFetch = {};
Object.defineProperty(leaderboardFetch, "__esModule", { value: !0 });
leaderboardFetch.Error = leaderboardFetch.Success = void 0;
const response_base_1$e = responseBase, enums_1$e = enums;
let Success$d = class extends response_base_1$e.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$e.LeaderboardFetchResponse.Success, this._elements = s;
  }
  /**
   * Returns the elements as an array of objects, each containing an `id`, `score`, and `rank` field.
   * @returns {{id: number, score: number, rank: number}[]}
   */
  values() {
    return this._elements.map((s) => ({
      id: s.id,
      score: s.score,
      rank: s.rank
    }));
  }
};
leaderboardFetch.Success = Success$d;
let Error$f = class extends response_base_1$e.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$e.LeaderboardFetchResponse.Error;
  }
};
leaderboardFetch.Error = Error$f;
var leaderboardLength = {};
Object.defineProperty(leaderboardLength, "__esModule", { value: !0 });
leaderboardLength.Error = leaderboardLength.Success = void 0;
const response_base_1$d = responseBase, enums_1$d = enums;
let Success$c = class extends response_base_1$d.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$d.LeaderboardLengthResponse.Success, this._length = s;
  }
  /**
   * Returns the length of the leaderboard
   * @returns {number}
   */
  length() {
    return this._length;
  }
  toString() {
    return `${super.toString()}: length ${this._length}`;
  }
};
leaderboardLength.Success = Success$c;
let Error$e = class extends response_base_1$d.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$d.LeaderboardLengthResponse.Error;
  }
};
leaderboardLength.Error = Error$e;
var leaderboardRemoveElements = {};
Object.defineProperty(leaderboardRemoveElements, "__esModule", { value: !0 });
leaderboardRemoveElements.Error = leaderboardRemoveElements.Success = void 0;
const response_base_1$c = responseBase, enums_1$c = enums;
let Success$b = class extends response_base_1$c.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$c.LeaderboardRemoveElementsResponse.Success;
  }
};
leaderboardRemoveElements.Success = Success$b;
let Error$d = class extends response_base_1$c.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$c.LeaderboardRemoveElementsResponse.Error;
  }
};
leaderboardRemoveElements.Error = Error$d;
var leaderboardUpsert = {};
Object.defineProperty(leaderboardUpsert, "__esModule", { value: !0 });
leaderboardUpsert.Error = leaderboardUpsert.Success = void 0;
const response_base_1$b = responseBase, enums_1$b = enums;
let Success$a = class extends response_base_1$b.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$b.LeaderboardUpsertResponse.Success;
  }
};
leaderboardUpsert.Success = Success$a;
let Error$c = class extends response_base_1$b.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$b.LeaderboardUpsertResponse.Error;
  }
};
leaderboardUpsert.Error = Error$c;
Object.defineProperty(leaderboard$2, "__esModule", { value: !0 });
leaderboard$2.LeaderboardUpsert = leaderboard$2.LeaderboardRemoveElements = leaderboard$2.LeaderboardLength = leaderboard$2.LeaderboardFetch = leaderboard$2.LeaderboardDelete = void 0;
leaderboard$2.LeaderboardDelete = leaderboardDelete;
leaderboard$2.LeaderboardFetch = leaderboardFetch;
leaderboard$2.LeaderboardLength = leaderboardLength;
leaderboard$2.LeaderboardRemoveElements = leaderboardRemoveElements;
leaderboard$2.LeaderboardUpsert = leaderboardUpsert;
var webhook = {}, deleteWebhook = {};
Object.defineProperty(deleteWebhook, "__esModule", { value: !0 });
deleteWebhook.Error = deleteWebhook.Success = void 0;
const response_base_1$a = responseBase, enums_1$a = enums;
let Success$9 = class extends response_base_1$a.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$a.DeleteWebhookResponse.Success;
  }
};
deleteWebhook.Success = Success$9;
let Error$b = class extends response_base_1$a.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$a.DeleteWebhookResponse.Error;
  }
};
deleteWebhook.Error = Error$b;
var listWebhooks = {};
Object.defineProperty(listWebhooks, "__esModule", { value: !0 });
listWebhooks.Error = listWebhooks.Success = void 0;
const response_base_1$9 = responseBase, enums_1$9 = enums;
let Success$8 = class extends response_base_1$9.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$9.ListWebhooksResponse.Success, this.webhooks = s;
  }
  /**
   * An array of webhooks.
   * @returns {Webhook[]}
   */
  getWebhooks() {
    return this.webhooks;
  }
  toString() {
    return super.toString() + ": " + this.webhooks.map((s) => s.id.webhookName).join(", ");
  }
};
listWebhooks.Success = Success$8;
let Error$a = class extends response_base_1$9.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$9.ListWebhooksResponse.Error;
  }
};
listWebhooks.Error = Error$a;
var putWebhook = {};
Object.defineProperty(putWebhook, "__esModule", { value: !0 });
putWebhook.Error = putWebhook.Success = void 0;
const response_base_1$8 = responseBase, enums_1$8 = enums;
let Success$7 = class extends response_base_1$8.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$8.PutWebhookResponse.Success, this._secretString = s;
  }
  secretString() {
    return this._secretString;
  }
};
putWebhook.Success = Success$7;
let Error$9 = class extends response_base_1$8.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$8.PutWebhookResponse.Error;
  }
};
putWebhook.Error = Error$9;
var getWebhookSecret = {};
Object.defineProperty(getWebhookSecret, "__esModule", { value: !0 });
getWebhookSecret.Error = getWebhookSecret.Success = void 0;
const response_base_1$7 = responseBase, enums_1$7 = enums;
let Success$6 = class extends response_base_1$7.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$7.GetWebhookSecretResponse.Success, this._secret = s.secret, this._cacheName = s.cacheName, this._webhookName = s.webhookName;
  }
  secret() {
    return this._secret;
  }
  webhookName() {
    return this._webhookName;
  }
  cacheName() {
    return this._cacheName;
  }
  toString() {
    return super.toString() + ": " + this._webhookName;
  }
};
getWebhookSecret.Success = Success$6;
let Error$8 = class extends response_base_1$7.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$7.GetWebhookSecretResponse.Error;
  }
};
getWebhookSecret.Error = Error$8;
var rotateWebhookSecret = {};
Object.defineProperty(rotateWebhookSecret, "__esModule", { value: !0 });
rotateWebhookSecret.Error = rotateWebhookSecret.Success = void 0;
const response_base_1$6 = responseBase, enums_1$6 = enums;
let Success$5 = class extends response_base_1$6.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$6.RotateWebhookSecretResponse.Success, this._secret = s.secret, this._cacheName = s.cacheName, this._webhookName = s.webhookName;
  }
  secret() {
    return this._secret;
  }
  webhookName() {
    return this._webhookName;
  }
  cacheName() {
    return this._cacheName;
  }
  toString() {
    return super.toString() + ": " + this._webhookName;
  }
};
rotateWebhookSecret.Success = Success$5;
let Error$7 = class extends response_base_1$6.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$6.RotateWebhookSecretResponse.Error;
  }
};
rotateWebhookSecret.Error = Error$7;
Object.defineProperty(webhook, "__esModule", { value: !0 });
webhook.RotateWebhookSecret = webhook.GetWebhookSecret = webhook.PutWebhook = webhook.ListWebhooks = webhook.DeleteWebhook = void 0;
webhook.DeleteWebhook = deleteWebhook;
webhook.ListWebhooks = listWebhooks;
webhook.PutWebhook = putWebhook;
webhook.GetWebhookSecret = getWebhookSecret;
webhook.RotateWebhookSecret = rotateWebhookSecret;
var storage$1 = {}, control = {}, deleteStore = {};
Object.defineProperty(deleteStore, "__esModule", { value: !0 });
deleteStore.Error = deleteStore.Success = void 0;
const enums_1$5 = enums, response_base_1$5 = responseBase;
let Success$4 = class extends response_base_1$5.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$5.DeleteStoreResponse.Success;
  }
};
deleteStore.Success = Success$4;
let Error$6 = class extends response_base_1$5.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$5.DeleteStoreResponse.Error;
  }
};
deleteStore.Error = Error$6;
var createStore = {};
Object.defineProperty(createStore, "__esModule", { value: !0 });
createStore.Error = createStore.AlreadyExists = createStore.Success = void 0;
const enums_1$4 = enums, response_base_1$4 = responseBase;
let Success$3 = class extends response_base_1$4.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$4.CreateStoreResponse.Success;
  }
};
createStore.Success = Success$3;
class AlreadyExists extends response_base_1$4.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$4.CreateStoreResponse.AlreadyExists;
  }
}
createStore.AlreadyExists = AlreadyExists;
let Error$5 = class extends response_base_1$4.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$4.CreateStoreResponse.Error;
  }
};
createStore.Error = Error$5;
var listStores = {};
Object.defineProperty(listStores, "__esModule", { value: !0 });
listStores.Error = listStores.Success = void 0;
const enums_1$3 = enums, response_base_1$3 = responseBase;
let Success$2 = class extends response_base_1$3.BaseResponseSuccess {
  constructor(s) {
    super(), this.type = enums_1$3.ListStoresResponse.Success, this._stores = s;
  }
  /**
   * An array of StoreInfo, containing information about each store.
   * @returns {StoreInfo[]}
   */
  stores() {
    return this._stores;
  }
  toString() {
    const s = this._stores.map((h) => h.getName());
    return super.toString() + ": " + s.join(", ");
  }
};
listStores.Success = Success$2;
let Error$4 = class extends response_base_1$3.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$3.ListStoresResponse.Error;
  }
};
listStores.Error = Error$4;
Object.defineProperty(control, "__esModule", { value: !0 });
control.ListStores = control.CreateStore = control.DeleteStore = void 0;
control.DeleteStore = deleteStore;
control.CreateStore = createStore;
control.ListStores = listStores;
var scalar = {}, storageDelete = {};
Object.defineProperty(storageDelete, "__esModule", { value: !0 });
storageDelete.Error = storageDelete.Success = void 0;
const enums_1$2 = enums, response_base_1$2 = responseBase;
let Success$1 = class extends response_base_1$2.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1$2.StorageDeleteResponse.Success;
  }
};
storageDelete.Success = Success$1;
let Error$3 = class extends response_base_1$2.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$2.StorageDeleteResponse.Error;
  }
};
storageDelete.Error = Error$3;
var storageGet = {}, storageValue = {};
Object.defineProperty(storageValue, "__esModule", { value: !0 });
storageValue.StorageValue = void 0;
class StorageValue {
  /**
   * Creates an instance of the StorageValue class.
   * @param {number | undefined} valueInt - The integer value to be stored.
   * @param {number | undefined} valueDouble - The double value to be stored.
   * @param {string | undefined} valueString - The string value to be stored.
   * @param {Uint8Array | undefined} valueBytes - The byte array value to be stored.
   */
  constructor(s, h, c, d) {
    this._valueInt = void 0, this._valueDouble = void 0, this._valueString = void 0, this._valueBytes = void 0, this._valueInt = s, this._valueDouble = h, this._valueString = c, this._valueBytes = d;
  }
  /**
   * Creates a StorageValue instance with an integer value.
   * @param {number} value - The integer value to be stored.
   * @returns {StorageValue} - A StorageValue instance containing the integer value.
   */
  static ofInt(s) {
    return new StorageValue(s, void 0, void 0, void 0);
  }
  /**
   * Creates a StorageValue instance with a double value.
   * @param {number} value - The double value to be stored.
   * @returns {StorageValue} - A StorageValue instance containing the double value.
   */
  static ofDouble(s) {
    return new StorageValue(void 0, s, void 0, void 0);
  }
  /**
   * Creates a StorageValue instance with a string value.
   * @param {string} value - The string value to be stored.
   * @returns {StorageValue} - A StorageValue instance containing the string value.
   */
  static ofString(s) {
    return new StorageValue(void 0, void 0, s, void 0);
  }
  /**
   * Creates a StorageValue instance with a byte array value.
   * @param {Uint8Array} value - The byte array value to be stored.
   * @returns {StorageValue} - A StorageValue instance containing the byte array value.
   */
  static ofBytes(s) {
    return new StorageValue(void 0, void 0, void 0, s);
  }
  /**
   * Retrieves the integer value stored in this instance.
   * @returns {number | undefined} - The integer value, or undefined if no integer value is present.
   */
  int() {
    return this._valueInt;
  }
  /**
   * Retrieves the double value stored in this instance.
   * @returns {number | undefined} - The double value, or undefined if no double value is present.
   */
  double() {
    return this._valueDouble;
  }
  /**
   * Retrieves the string value stored in this instance.
   * @returns {string | undefined} - The string value, or undefined if no string value is present.
   */
  string() {
    return this._valueString;
  }
  /**
   * Retrieves the byte array value stored in this instance.
   * @returns {Uint8Array | undefined} - The byte array value, or undefined if no byte array value is present.
   */
  bytes() {
    return this._valueBytes;
  }
}
storageValue.StorageValue = StorageValue;
Object.defineProperty(storageGet, "__esModule", { value: !0 });
storageGet.Error = storageGet.NotFound = storageGet.Found = void 0;
const enums_1$1 = enums, response_base_1$1 = responseBase, storage_value_1 = storageValue;
class Found extends response_base_1$1.ResponseBase {
  /**
   * Creates an instance of the Found response.
   * @param {StorageValue} value - The value associated with the key that was retrieved from the cache.
   */
  constructor(s) {
    super(), this.type = enums_1$1.StorageGetResponse.Found, this._value = s;
  }
  /**
   * Creates a Found response with an integer value.
   * @param {number} value - The integer value to be stored.
   * @returns {Found} - A Found response object containing the integer value.
   */
  static ofInt(s) {
    return new Found(storage_value_1.StorageValue.ofInt(s));
  }
  /**
   * Creates a Found response with a double value.
   * @param {number} value - The double value to be stored.
   * @returns {Found} - A Found response object containing the double value.
   */
  static ofDouble(s) {
    return new Found(storage_value_1.StorageValue.ofDouble(s));
  }
  /**
   * Creates a Found response with a string value.
   * @param {string} value - The string value to be stored.
   * @returns {Found} - A Found response object containing the string value.
   */
  static ofString(s) {
    return new Found(storage_value_1.StorageValue.ofString(s));
  }
  /**
   * Creates a Found response with a byte array value.
   * @param {Uint8Array} value - The byte array value to be stored.
   * @returns {Found} - A Found response object containing the byte array value.
   */
  static ofBytes(s) {
    return new Found(storage_value_1.StorageValue.ofBytes(s));
  }
  /**
   * Retrieves the value associated with the key that was retrieved from the cache.
   * @returns {StorageValue} - The value associated with the key, or undefined if no value is present.
   */
  value() {
    return this._value;
  }
}
storageGet.Found = Found;
class NotFound extends response_base_1$1.ResponseBase {
  constructor() {
    super(), this.type = enums_1$1.StorageGetResponse.NotFound;
  }
  value() {
  }
}
storageGet.NotFound = NotFound;
let Error$2 = class extends response_base_1$1.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1$1.StorageGetResponse.Error;
  }
  value() {
  }
};
storageGet.Error = Error$2;
var storagePut = {};
Object.defineProperty(storagePut, "__esModule", { value: !0 });
storagePut.Error = storagePut.Success = void 0;
const enums_1 = enums, response_base_1 = responseBase;
class Success extends response_base_1.BaseResponseSuccess {
  constructor() {
    super(...arguments), this.type = enums_1.StoragePutResponse.Success;
  }
}
storagePut.Success = Success;
let Error$1 = class extends response_base_1.BaseResponseError {
  constructor(s) {
    super(s), this.type = enums_1.StoragePutResponse.Error;
  }
};
storagePut.Error = Error$1;
Object.defineProperty(scalar, "__esModule", { value: !0 });
scalar.StoragePut = scalar.StorageGet = scalar.StorageDelete = void 0;
scalar.StorageDelete = storageDelete;
scalar.StorageGet = storageGet;
scalar.StoragePut = storagePut;
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(control, p), h(scalar, p);
})(storage$1);
var storeInfo = {};
Object.defineProperty(storeInfo, "__esModule", { value: !0 });
storeInfo.StoreInfo = void 0;
class StoreInfo {
  /**
   * Creates an instance of the StoreInfo class.
   * @param {string} name - The name of the store.
   */
  constructor(s) {
    this.name = s;
  }
  /**
   * Retrieves the name of the store.
   * @returns {string} - The name of the store.
   */
  getName() {
    return this.name;
  }
}
storeInfo.StoreInfo = StoreInfo;
var cacheInfo = {};
Object.defineProperty(cacheInfo, "__esModule", { value: !0 });
cacheInfo.CacheInfo = void 0;
class CacheInfo {
  constructor(s, h, c) {
    this.name = s, this.topicLimits = h, this.cacheLimits = c;
  }
  getName() {
    return this.name;
  }
  getTopicLimits() {
    return this.topicLimits;
  }
  getCacheLimits() {
    return this.cacheLimits;
  }
}
cacheInfo.CacheInfo = CacheInfo;
var utils = {}, cacheCallOptions = {}, collectionTtl = {};
Object.defineProperty(collectionTtl, "__esModule", { value: !0 });
collectionTtl.CollectionTtl = void 0;
const utils_1$3 = utils$1;
class CollectionTtl {
  /**
   * If refreshTtl is true, the client must update the collection's TTL
   * when it modifies a collection.
   * A null ttl means to use the client's TTL.
   * @param {number | null} [ttlSeconds=null]
   * @param {boolean} [refreshTtl=true]
   */
  constructor(s = null, h = !0) {
    s !== null && (0, utils_1$3.validateTtlSeconds)(s), this._refreshTtl = h, this._ttlSeconds = s;
  }
  /** Time-to-live, in seconds.
   * @returns {number | null}
   */
  ttlSeconds() {
    return this._ttlSeconds;
  }
  /** Time-to-live, in milliseconds.
   * @returns {number | null}
   */
  ttlMilliseconds() {
    return this._ttlSeconds === null ? null : this._ttlSeconds * 1e3;
  }
  /** Whether or not to refresh a collection's TTL when it's modified.
   * @returns {boolean}
   */
  refreshTtl() {
    return this._refreshTtl;
  }
  /** The default way to handle TTLs for collections. The client's default TTL
   *  will be used, and the TTL for the collection will be refreshed any
   *  time the collection is modified.
   * @constructor
   * @returns {CollectionTtl}
   */
  static fromCacheTtl() {
    return new CollectionTtl(null, !0);
  }
  /** Constructs a CollectionTtl with the specified TTL. The TTL
   *  for the collection will be refreshed any time the collection is
   *  modified.
   * @constructor
   * @param {number} [ttlSeconds]
   * @returns {CollectionTtl}
   */
  static of(s) {
    return new CollectionTtl(s, !0);
  }
  /** Constructs a CollectionTtl with the specified TTL.
   *  Will only refresh if the TTL is provided.
   * @constructor
   * @param {number | null} [ttlSeconds=null]
   * @returns {CollectionTtl}
   */
  static refreshTtlIfProvided(s = null) {
    return new CollectionTtl(s, s !== null);
  }
  /** Copies the CollectionTtl, but it will refresh the TTL when
   *  the collection is modified.
   * @returns {CollectionTtl}
   */
  withRefreshTtlOnUpdates() {
    return new CollectionTtl(this._ttlSeconds, !0);
  }
  /** Copies the CollectionTTL, but the TTL will not be refreshed
   *  when the collection is modified. Use this if you want to ensure
   *  that your collection expires at the originally specified time, even
   *  if you make modifications to the value of the collection.
   * @returns {CollectionTtl}
   */
  withNoRefreshTtlOnUpdates() {
    return new CollectionTtl(this._ttlSeconds, !1);
  }
  /** A string represenation of the CollectionTtl for debugging purposes.
   * @return {CollectionTtl}
   */
  toString() {
    return `ttl: ${this._ttlSeconds || "null"}, refreshTtl: ${this._refreshTtl ? "true" : "false"}`;
  }
}
collectionTtl.CollectionTtl = CollectionTtl;
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.LeaderboardOrder = p.SortedSetOrder = p.ttlOrFromCacheTtl = void 0;
  const s = collectionTtl;
  function h(c) {
    var d;
    return (d = c == null ? void 0 : c.ttl) !== null && d !== void 0 ? d : s.CollectionTtl.fromCacheTtl();
  }
  p.ttlOrFromCacheTtl = h, function(c) {
    c.Ascending = "ASC", c.Descending = "DESC";
  }(p.SortedSetOrder || (p.SortedSetOrder = {})), function(c) {
    c.Ascending = "ASC", c.Descending = "DESC";
  }(p.LeaderboardOrder || (p.LeaderboardOrder = {}));
})(cacheCallOptions);
var topicCallOptions = {};
Object.defineProperty(topicCallOptions, "__esModule", { value: !0 });
var expiration = {};
Object.defineProperty(expiration, "__esModule", { value: !0 });
expiration.ExpiresAt = expiration.ExpiresIn = void 0;
class Expiration {
  constructor(s) {
    this._doesExpire = s;
  }
  /**
   * Whether the token expires or not.
   * @returns {boolean}
   */
  doesExpire() {
    return this._doesExpire;
  }
}
class ExpiresIn extends Expiration {
  /**
   * If doesExpire is false, the refresh token will not have a expiration time, instead validForSeconds will be 'Infinity'.
   * @param {number} [validForSeconds]
   */
  constructor(s) {
    super(s !== 1 / 0), this._validForSeconds = s === null ? 1 / 0 : s;
  }
  /**
   * Time token is valid for in seconds.
   * @returns {number} Infinity, if token doesn't expire.
   */
  seconds() {
    return this._validForSeconds;
  }
  /**
   * Constructs a ExpiresIn which never expires.
   * @returns {ExpiresIn}
   */
  static never() {
    return new ExpiresIn(1 / 0);
  }
  /**
   * Constructs a ExpiresIn with a specified validFor period in seconds.
   * If seconds are undefined, or null, then token never expires.
   * @param validForSeconds
   * @returns {ExpiresIn}
   */
  static seconds(s) {
    return new ExpiresIn(s);
  }
  /**
   * Constructs a ExpiresIn with a specified validFor period in minutes.
   * @param validForMinutes
   * @returns {ExpiresIn}
   */
  static minutes(s) {
    return new ExpiresIn(s * 60);
  }
  /**
   * Constructs a ExpiresIn with a specified validFor period in hours.
   * @param validForHours
   * @returns {ExpiresIn}
   */
  static hours(s) {
    return new ExpiresIn(s * 3600);
  }
  /**
   * Constructs an ExpiresIn with a specified validFor period in days.
   * @param validForDays
   * @returns {ExpiresIn}
   */
  static days(s) {
    return new ExpiresIn(s * 86400);
  }
  /**
   * Constructs an ExpiresIn with a specified expiresBy period in epoch format.
   * @param expiresBy
   * @returns {ExpiresIn}
   */
  static epoch(s) {
    const h = (/* @__PURE__ */ new Date()).getTime() / 1e3, c = Math.round(s - h);
    return new ExpiresIn(c);
  }
}
expiration.ExpiresIn = ExpiresIn;
class ExpiresAt extends Expiration {
  constructor(s) {
    super(s !== void 0 && s !== 0), this.doesExpire() ? this.validUntil = s : this.validUntil = 1 / 0;
  }
  /**
   * Returns epoch timestamp of when api token expires.
   * @returns {number}
   */
  epoch() {
    return this.validUntil;
  }
  /**
   * Constructs an ExpiresAt with the specified epoch timestamp,
   * if timestamp is undefined, then epoch timestamp will instead be Infinity.
   * @param epoch
   * @returns {ExpiresAt}
   */
  static fromEpoch(s) {
    return new ExpiresAt(s);
  }
}
expiration.ExpiresAt = ExpiresAt;
var itemType = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.ItemType = void 0, function(s) {
    s[s.SCALAR = 0] = "SCALAR", s[s.DICTIONARY = 1] = "DICTIONARY", s[s.LIST = 2] = "LIST", s[s.SET = 3] = "SET", s[s.SORTED_SET = 4] = "SORTED_SET";
  }(p.ItemType || (p.ItemType = {}));
})(itemType);
var webhookDestination = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.PostUrlWebhookDestination = p.WebhookDestinationType = void 0;
  var s;
  (function(c) {
    c.PostUrl = "post_url";
  })(s = p.WebhookDestinationType || (p.WebhookDestinationType = {}));
  class h {
    constructor(d) {
      this._url = d;
    }
    url() {
      return this._url;
    }
    getType() {
      return s.PostUrl;
    }
  }
  p.PostUrlWebhookDestination = h;
})(webhookDestination);
var setBatchItem = {};
Object.defineProperty(setBatchItem, "__esModule", { value: !0 });
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(cacheCallOptions, p), h(collectionTtl, p), h(topicCallOptions, p), h(expiration, p), h(itemType, p), h(webhookDestination, p), h(setBatchItem, p);
})(utils);
var auth$1 = {}, credentialProvider = {};
Object.defineProperty(credentialProvider, "__esModule", { value: !0 });
credentialProvider.getDefaultCredentialProvider = credentialProvider.EnvMomentoTokenProvider = credentialProvider.StringMomentoTokenProvider = credentialProvider.CredentialProvider = void 0;
const utils_1$2 = utils$1;
function isBaseEndpointOverride(p) {
  return p.baseEndpoint !== void 0;
}
function isAllEndpoints(p) {
  const s = p;
  return s.cacheEndpoint !== void 0 && s.controlEndpoint !== void 0 && s.tokenEndpoint !== void 0;
}
class CredentialProvider {
  static fromEnvironmentVariable(s) {
    return new EnvMomentoTokenProvider(s);
  }
  static fromEnvVar(s) {
    return new EnvMomentoTokenProvider(s);
  }
  static fromString(s) {
    return new StringMomentoTokenProvider(s);
  }
}
credentialProvider.CredentialProvider = CredentialProvider;
class CredentialProviderBase {
  valueOf() {
    const s = Object.entries(this).filter(([c]) => c !== "authToken");
    return (0, utils_1$2.fromEntries)(s).valueOf();
  }
}
class StringMomentoTokenProvider extends CredentialProviderBase {
  /**
   * @param {StringMomentoTokenProviderProps} props configuration options for the token provider
   */
  constructor(s) {
    typeof s == "string" && (s = { apiKey: s }), super();
    let h;
    if ("authToken" in s)
      h = s.authToken;
    else if ("apiKey" in s)
      h = s.apiKey;
    else
      throw new Error("Missing required property: authToken or apiKey");
    const c = (0, utils_1$2.decodeAuthToken)(h);
    if (this.apiKey = c.authToken, s.endpointOverrides === void 0) {
      if (this.endpointsOverridden = !1, c.controlEndpoint === void 0)
        throw new Error("Malformed token; unable to determine control endpoint.  Depending on the type of token you are using, you may need to specify the controlEndpoint explicitly.");
      if (c.cacheEndpoint === void 0)
        throw new Error("Malformed token; unable to determine cache endpoint.  Depending on the type of token you are using, you may need to specify the cacheEndpoint explicitly.");
      if (c.tokenEndpoint === void 0)
        throw new Error("Malformed token; unable to determine token endpoint.  Depending on the type of token you are using, you may need to specify the tokenEndpoint explicitly.");
      if (c.storageEndpoint === void 0)
        throw new Error("Malformed token; unable to determine storage endpoint.  Depending on the type of token you are using, you may need to specify the storageEndpoint explicitly.");
      this.allEndpoints = {
        controlEndpoint: {
          endpoint: c.controlEndpoint
        },
        cacheEndpoint: {
          endpoint: c.cacheEndpoint
        },
        tokenEndpoint: {
          endpoint: c.tokenEndpoint
        },
        storageEndpoint: {
          endpoint: c.storageEndpoint
        }
      };
    } else if (isAllEndpoints(s.endpointOverrides))
      this.endpointsOverridden = !0, this.allEndpoints = s.endpointOverrides;
    else if (isBaseEndpointOverride(s.endpointOverrides))
      this.endpointsOverridden = !0, this.allEndpoints = (0, utils_1$2.populateAllEndpointsFromBaseEndpoint)(s.endpointOverrides);
    else
      throw new Error(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Unsupported endpointOverrides: ${s.endpointOverrides}`
      );
  }
  getAuthToken() {
    return this.apiKey;
  }
  getCacheEndpoint() {
    return this.allEndpoints.cacheEndpoint.endpoint;
  }
  isCacheEndpointSecure() {
    return this.allEndpoints.cacheEndpoint.secureConnection === void 0 ? !0 : this.allEndpoints.cacheEndpoint.secureConnection;
  }
  getControlEndpoint() {
    return this.allEndpoints.controlEndpoint.endpoint;
  }
  isControlEndpointSecure() {
    return this.allEndpoints.controlEndpoint.secureConnection === void 0 ? !0 : this.allEndpoints.controlEndpoint.secureConnection;
  }
  getTokenEndpoint() {
    return this.allEndpoints.tokenEndpoint.endpoint;
  }
  isTokenEndpointSecure() {
    return this.allEndpoints.tokenEndpoint.secureConnection === void 0 ? !0 : this.allEndpoints.tokenEndpoint.secureConnection;
  }
  getStorageEndpoint() {
    return this.allEndpoints.storageEndpoint.endpoint;
  }
  isStorageEndpointSecure() {
    return this.allEndpoints.storageEndpoint.secureConnection === void 0 ? !0 : this.allEndpoints.storageEndpoint.secureConnection;
  }
  areEndpointsOverridden() {
    return this.endpointsOverridden;
  }
  withMomentoLocal() {
    const s = {
      endpoint: "127.0.0.1:8080",
      secureConnection: !1
    };
    return new StringMomentoTokenProvider({
      authToken: this.apiKey,
      endpointOverrides: {
        cacheEndpoint: s,
        controlEndpoint: s,
        tokenEndpoint: s,
        storageEndpoint: s
      }
    });
  }
}
credentialProvider.StringMomentoTokenProvider = StringMomentoTokenProvider;
class EnvMomentoTokenProvider extends StringMomentoTokenProvider {
  /**
   * @param {EnvMomentoTokenProviderProps} props configuration options for the token provider
   */
  constructor(s) {
    typeof s == "string" && (s = { environmentVariableName: s });
    const h = process.env[s.environmentVariableName];
    if (!h)
      throw new Error(`Missing required environment variable ${s.environmentVariableName}`);
    super({
      authToken: h,
      endpointOverrides: s.endpointOverrides
    }), this.environmentVariableName = s.environmentVariableName;
  }
}
credentialProvider.EnvMomentoTokenProvider = EnvMomentoTokenProvider;
function getDefaultCredentialProvider() {
  return CredentialProvider.fromEnvVar("MOMENTO_API_KEY");
}
credentialProvider.getDefaultCredentialProvider = getDefaultCredentialProvider;
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(credentialProvider, p);
})(auth$1);
var noopMomentoLogger = {};
Object.defineProperty(noopMomentoLogger, "__esModule", { value: !0 });
noopMomentoLogger.NoopMomentoLoggerFactory = noopMomentoLogger.NoopMomentoLogger = void 0;
class NoopMomentoLogger {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  debug(s, ...h) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error(s, ...h) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  info(s, ...h) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trace(s, ...h) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  warn(s, ...h) {
  }
}
noopMomentoLogger.NoopMomentoLogger = NoopMomentoLogger;
class NoopMomentoLoggerFactory {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  getLogger(s) {
    return new NoopMomentoLogger();
  }
}
noopMomentoLogger.NoopMomentoLoggerFactory = NoopMomentoLoggerFactory;
var disposableTokenScope = {};
Object.defineProperty(disposableTokenScope, "__esModule", { value: !0 });
disposableTokenScope.asDisposableTokenPermissionsObject = disposableTokenScope.isDisposableTokenPermissionsObject = disposableTokenScope.asDisposableTokenCachePermission = disposableTokenScope.isDisposableTokenCachePermission = disposableTokenScope.isCacheItemKeyPrefix = disposableTokenScope.isCacheItemKey = void 0;
const permission_scope_1$1 = permissionScope;
function isCacheItemKey(p) {
  return p === permission_scope_1$1.AllCacheItems ? !1 : typeof p == "string" ? !0 : "key" in p;
}
disposableTokenScope.isCacheItemKey = isCacheItemKey;
function isCacheItemKeyPrefix(p) {
  return p === permission_scope_1$1.AllCacheItems || typeof p == "string" ? !1 : "keyPrefix" in p;
}
disposableTokenScope.isCacheItemKeyPrefix = isCacheItemKeyPrefix;
function isDisposableTokenCachePermission(p) {
  return "role" in p && "cache" in p && "item" in p && !("topic" in p);
}
disposableTokenScope.isDisposableTokenCachePermission = isDisposableTokenCachePermission;
function asDisposableTokenCachePermission(p) {
  if (!isDisposableTokenCachePermission(p))
    throw new Error(`permission is not a DisposableTokenCachePermission object: ${JSON.stringify(p)}`);
  return p;
}
disposableTokenScope.asDisposableTokenCachePermission = asDisposableTokenCachePermission;
function isDisposableTokenPermissionObject(p) {
  return isDisposableTokenCachePermission(p);
}
function isDisposableTokenPermissionsObject(p) {
  return "permissions" in p ? p.permissions.every((h) => isDisposableTokenPermissionObject(h)) : !1;
}
disposableTokenScope.isDisposableTokenPermissionsObject = isDisposableTokenPermissionsObject;
function asDisposableTokenPermissionsObject(p) {
  if (!isDisposableTokenPermissionsObject(p))
    throw new Error(`Token scope is not a DisposableTokenCachePermissions object: ${JSON.stringify(p)}`);
  return p;
}
disposableTokenScope.asDisposableTokenPermissionsObject = asDisposableTokenPermissionsObject;
var permissionScopes = {};
Object.defineProperty(permissionScopes, "__esModule", { value: !0 });
permissionScopes.topicPublishOnly = permissionScopes.topicPublishSubscribe = permissionScopes.topicSubscribeOnly = permissionScopes.cacheWriteOnly = permissionScopes.cacheReadOnly = permissionScopes.cacheReadWrite = void 0;
const permission_scope_1 = permissionScope;
function cacheReadWrite(p) {
  return {
    permissions: [{ role: permission_scope_1.CacheRole.ReadWrite, cache: p }]
  };
}
permissionScopes.cacheReadWrite = cacheReadWrite;
function cacheReadOnly(p) {
  return {
    permissions: [{ role: permission_scope_1.CacheRole.ReadOnly, cache: p }]
  };
}
permissionScopes.cacheReadOnly = cacheReadOnly;
function cacheWriteOnly(p) {
  return {
    permissions: [{ role: permission_scope_1.CacheRole.WriteOnly, cache: p }]
  };
}
permissionScopes.cacheWriteOnly = cacheWriteOnly;
function topicSubscribeOnly(p, s) {
  return {
    permissions: [
      {
        role: permission_scope_1.TopicRole.SubscribeOnly,
        cache: p,
        topic: s
      }
    ]
  };
}
permissionScopes.topicSubscribeOnly = topicSubscribeOnly;
function topicPublishSubscribe(p, s) {
  return {
    permissions: [
      {
        role: permission_scope_1.TopicRole.PublishSubscribe,
        cache: p,
        topic: s
      }
    ]
  };
}
permissionScopes.topicPublishSubscribe = topicPublishSubscribe;
function topicPublishOnly(p, s) {
  return {
    permissions: [
      {
        role: permission_scope_1.TopicRole.PublishOnly,
        cache: p,
        topic: s
      }
    ]
  };
}
permissionScopes.topicPublishOnly = topicPublishOnly;
var disposableTokenScopes = {};
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(ae, ie, se, m) {
    m === void 0 && (m = se);
    var w = Object.getOwnPropertyDescriptor(ie, se);
    (!w || ("get" in w ? !ie.__esModule : w.writable || w.configurable)) && (w = { enumerable: !0, get: function() {
      return ie[se];
    } }), Object.defineProperty(ae, m, w);
  } : function(ae, ie, se, m) {
    m === void 0 && (m = se), ae[m] = ie[se];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(ae, ie) {
    for (var se in ae) se !== "default" && !Object.prototype.hasOwnProperty.call(ie, se) && s(ie, ae, se);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), p.cacheKeyPrefixWriteOnly = p.cacheKeyWriteOnly = p.cacheKeyPrefixReadOnly = p.cacheKeyReadOnly = p.cacheKeyPrefixReadWrite = p.cacheKeyReadWrite = void 0;
  const c = permissionScope;
  h(permissionScopes, p);
  function d(ae, ie) {
    return {
      permissions: [{ role: c.CacheRole.ReadWrite, cache: ae, item: ie }]
    };
  }
  p.cacheKeyReadWrite = d;
  function l(ae, ie) {
    return {
      permissions: [
        {
          role: c.CacheRole.ReadWrite,
          cache: ae,
          item: { keyPrefix: ie }
        }
      ]
    };
  }
  p.cacheKeyPrefixReadWrite = l;
  function g(ae, ie) {
    return {
      permissions: [{ role: c.CacheRole.ReadOnly, cache: ae, item: ie }]
    };
  }
  p.cacheKeyReadOnly = g;
  function f(ae, ie) {
    return {
      permissions: [
        {
          role: c.CacheRole.ReadOnly,
          cache: ae,
          item: { keyPrefix: ie }
        }
      ]
    };
  }
  p.cacheKeyPrefixReadOnly = f;
  function _(ae, ie) {
    return {
      permissions: [{ role: c.CacheRole.WriteOnly, cache: ae, item: ie }]
    };
  }
  p.cacheKeyWriteOnly = _;
  function te(ae, ie) {
    return {
      permissions: [
        {
          role: c.CacheRole.WriteOnly,
          cache: ae,
          item: { keyPrefix: ie }
        }
      ]
    };
  }
  p.cacheKeyPrefixWriteOnly = te;
})(disposableTokenScopes);
var readConcern = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.ReadConcern = void 0, function(s) {
    s.BALANCED = "balanced", s.CONSISTENT = "consistent";
  }(p.ReadConcern || (p.ReadConcern = {}));
})(readConcern);
var compressionLevel = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.CompressionLevel = void 0, function(s) {
    s.Balanced = "Balanced", s.Fastest = "Fastest", s.SmallestSize = "SmallestSize";
  }(p.CompressionLevel || (p.CompressionLevel = {}));
})(compressionLevel);
var hasRequiredSrc$1;
function requireSrc$1() {
  return hasRequiredSrc$1 || (hasRequiredSrc$1 = 1, function(p) {
    var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Ie, Oe, De, Ne) {
      Ne === void 0 && (Ne = De);
      var it = Object.getOwnPropertyDescriptor(Oe, De);
      (!it || ("get" in it ? !Oe.__esModule : it.writable || it.configurable)) && (it = { enumerable: !0, get: function() {
        return Oe[De];
      } }), Object.defineProperty(Ie, Ne, it);
    } : function(Ie, Oe, De, Ne) {
      Ne === void 0 && (Ne = De), Ie[Ne] = Oe[De];
    }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(Ie, Oe) {
      for (var De in Ie) De !== "default" && !Object.prototype.hasOwnProperty.call(Oe, De) && s(Oe, Ie, De);
    };
    Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheSetIfPresentAndNotEqual = p.CacheSetIfNotEqual = p.CacheSetIfEqual = p.CacheSetIfAbsent = p.CacheSetIfPresent = p.CacheSetIfNotExists = p.CacheSet = p.CacheListRetain = p.CacheListRemoveValue = p.CacheListPushFront = p.CacheListPushBack = p.CacheListPopFront = p.CacheListPopBack = p.CacheListLength = p.CacheListFetch = p.CacheListConcatenateFront = p.CacheListConcatenateBack = p.CacheGet = p.getDefaultCredentialProvider = p.EnvMomentoTokenProvider = p.StringMomentoTokenProvider = p.CredentialProvider = p.LeaderboardOrder = p.SortedSetOrder = p.WebhookDestinationType = p.PostUrlWebhookDestination = p.ItemType = p.CollectionTtl = p.ExpiresAt = p.ExpiresIn = p.CompressionLevel = p.ReadConcern = p.DisposableTokenScopes = p.TokenScopes = p.PermissionScopes = p.isCacheItemKeyPrefix = p.isCacheItemKey = p.AllCacheItems = p.AllTopics = p.AllCaches = p.isTopicName = p.isCacheName = p.AllDataReadWrite = p.TopicRole = p.CacheRole = p.NoopMomentoLoggerFactory = p.NoopMomentoLogger = p.StoreInfo = p.webhook = p.leaderboard = void 0, p.TopicItem = p.TopicSubscribe = p.TopicPublish = p.CacheGetBatch = p.CacheSetBatch = p.CacheInfo = p.CacheDecreaseTtl = p.CacheIncreaseTtl = p.CacheUpdateTtl = p.CacheKeysExist = p.CacheKeyExists = p.CacheItemGetTtl = p.CacheItemGetType = p.CacheSortedSetLengthByScore = p.CacheSortedSetLength = p.CacheSortedSetRemoveElements = p.CacheSortedSetRemoveElement = p.CacheSortedSetIncrementScore = p.CacheSortedSetGetScores = p.CacheSortedSetGetScore = p.CacheSortedSetGetRank = p.CacheSortedSetFetch = p.CacheSortedSetPutElements = p.CacheSortedSetPutElement = p.CacheSetLength = p.CacheSetPop = p.CacheSetSample = p.CacheSetRemoveElement = p.CacheSetRemoveElements = p.CacheSetContainsElements = p.CacheSetContainsElement = p.CacheSetAddElement = p.CacheSetAddElements = p.CacheDictionaryLength = p.CacheDictionaryIncrement = p.CacheDictionaryRemoveFields = p.CacheDictionaryRemoveField = p.CacheDictionaryGetFields = p.CacheDictionaryGetField = p.CacheDictionarySetFields = p.CacheDictionarySetField = p.CacheDictionaryFetch = p.CacheSetFetch = p.CacheIncrement = p.ListCaches = p.DeleteCache = p.CreateCache = p.CacheFlush = p.CacheDelete = p.CacheSetIfAbsentOrEqual = void 0, p.UnknownError = p.StoreNotFoundError = p.StoreItemNotFoundError = p.CacheNotFoundError = p.PermissionError = p.BadRequestError = p.TimeoutError = p.ServerUnavailableError = p.UnknownServiceError = p.InvalidArgumentError = p.InternalServerError = p.LimitExceededError = p.FailedPreconditionError = p.ConnectionError = p.CancelledError = p.AuthenticationError = p.StoreAlreadyExistsError = p.CacheAlreadyExistsError = p.SdkError = p.MomentoErrorCode = p.GenerateDisposableToken = p.RefreshAuthToken = p.RefreshApiKey = p.GenerateAuthToken = p.GenerateApiKey = p.TopicHeartbeat = p.TopicDiscontinuity = void 0;
    const c = cacheGet;
    p.CacheGet = c;
    const d = cacheListConcatenateBack;
    p.CacheListConcatenateBack = d;
    const l = cacheListConcatenateFront;
    p.CacheListConcatenateFront = l;
    const g = cacheListFetch;
    p.CacheListFetch = g;
    const f = cacheListLength;
    p.CacheListLength = f;
    const _ = cacheListPopBack;
    p.CacheListPopBack = _;
    const te = cacheListPopFront;
    p.CacheListPopFront = te;
    const ae = cacheListPushBack;
    p.CacheListPushBack = ae;
    const ie = cacheListPushFront;
    p.CacheListPushFront = ie;
    const se = cacheListRemoveValue;
    p.CacheListRemoveValue = se;
    const m = cacheListRetain;
    p.CacheListRetain = m;
    const w = cacheSet;
    p.CacheSet = w;
    const q = cacheDelete;
    p.CacheDelete = q;
    const j = cacheFlush;
    p.CacheFlush = j;
    const k = createCache;
    p.CreateCache = k;
    const z = deleteCache;
    p.DeleteCache = z;
    const $ = listCaches;
    p.ListCaches = $;
    const re = cacheSetFetch;
    p.CacheSetFetch = re;
    const oe = cacheDictionaryFetch;
    p.CacheDictionaryFetch = oe;
    const le = cacheDictionarySetField;
    p.CacheDictionarySetField = le;
    const ue = cacheDictionarySetFields;
    p.CacheDictionarySetFields = ue;
    const pe = cacheDictionaryGetField;
    p.CacheDictionaryGetField = pe;
    const he = cacheDictionaryGetFields;
    p.CacheDictionaryGetFields = he;
    const fe = cacheDictionaryRemoveField;
    p.CacheDictionaryRemoveField = fe;
    const ye = cacheDictionaryRemoveFields;
    p.CacheDictionaryRemoveFields = ye;
    const Re = cacheDictionaryIncrement;
    p.CacheDictionaryIncrement = Re;
    const be = cacheDictionaryLength;
    p.CacheDictionaryLength = be;
    const Me = cacheSetAddElements;
    p.CacheSetAddElements = Me;
    const ve = cacheSetAddElement;
    p.CacheSetAddElement = ve;
    const we = cacheSetContainsElement;
    p.CacheSetContainsElement = we;
    const xe = cacheSetContainsElements;
    p.CacheSetContainsElements = xe;
    const We = cacheSetRemoveElements;
    p.CacheSetRemoveElements = We;
    const He = cacheSetRemoveElement;
    p.CacheSetRemoveElement = He;
    const at = cacheSetSample;
    p.CacheSetSample = at;
    const Te = cacheSetPop;
    p.CacheSetPop = Te;
    const Le = cacheSetLength;
    p.CacheSetLength = Le;
    const Ze = cacheIncrement;
    p.CacheIncrement = Ze;
    const Qe = cacheSetIfNotExists;
    p.CacheSetIfNotExists = Qe;
    const et = cacheSetIfAbsent;
    p.CacheSetIfAbsent = et;
    const tt = cacheSetIfPresent;
    p.CacheSetIfPresent = tt;
    const rt = cacheSetIfEqual;
    p.CacheSetIfEqual = rt;
    const Ge = cacheSetIfNotEqual;
    p.CacheSetIfNotEqual = Ge;
    const Ke = cacheSetIfPresentAndNotEqual;
    p.CacheSetIfPresentAndNotEqual = Ke;
    const ot = cacheSetIfAbsentOrEqual;
    p.CacheSetIfAbsentOrEqual = ot;
    const ut = cacheSortedSetPutElement;
    p.CacheSortedSetPutElement = ut;
    const nt = cacheSortedSetPutElements;
    p.CacheSortedSetPutElements = nt;
    const qe = cacheSortedSetFetch;
    p.CacheSortedSetFetch = qe;
    const ze = cacheSortedSetGetRank;
    p.CacheSortedSetGetRank = ze;
    const ct = cacheSortedSetGetScore;
    p.CacheSortedSetGetScore = ct;
    const lt = requireCacheSortedSetGetScores();
    p.CacheSortedSetGetScores = lt;
    const Je = cacheSortedSetIncrementScore;
    p.CacheSortedSetIncrementScore = Je;
    const pt = cacheSortedSetRemoveElement;
    p.CacheSortedSetRemoveElement = pt;
    const gt = cacheSortedSetRemoveElements;
    p.CacheSortedSetRemoveElements = gt;
    const st = cacheSortedSetLength;
    p.CacheSortedSetLength = st;
    const $e = cacheSortedSetLengthByScore;
    p.CacheSortedSetLengthByScore = $e;
    const je = cacheItemGetType;
    p.CacheItemGetType = je;
    const Ye = cacheItemGetTtl;
    p.CacheItemGetTtl = Ye;
    const dt = cacheKeyExists;
    p.CacheKeyExists = dt;
    const ke = cacheKeysExist;
    p.CacheKeysExist = ke;
    const ht = cacheTtlUpdate;
    p.CacheUpdateTtl = ht;
    const ee = cacheTtlIncrease;
    p.CacheIncreaseTtl = ee;
    const b = cacheTtlDecrease;
    p.CacheDecreaseTtl = b;
    const M = cacheBatchSet;
    p.CacheSetBatch = M;
    const ne = requireCacheBatchGet();
    p.CacheGetBatch = ne;
    const ce = topicPublish;
    p.TopicPublish = ce;
    const ge = topicSubscribe;
    p.TopicSubscribe = ge;
    const de = topicItem;
    Object.defineProperty(p, "TopicItem", { enumerable: !0, get: function() {
      return de.TopicItem;
    } });
    const Se = topicDiscontinuity;
    Object.defineProperty(p, "TopicDiscontinuity", { enumerable: !0, get: function() {
      return Se.TopicDiscontinuity;
    } });
    const Be = topicHeartbeat;
    Object.defineProperty(p, "TopicHeartbeat", { enumerable: !0, get: function() {
      return Be.TopicHeartbeat;
    } });
    const Ee = generateApiKey;
    p.GenerateApiKey = Ee, p.GenerateAuthToken = Ee;
    const Fe = refreshApiKey;
    p.RefreshApiKey = Fe, p.RefreshAuthToken = Fe;
    const me = generateDisposableToken;
    p.GenerateDisposableToken = me, p.leaderboard = leaderboard$2, h(leaderboard$2, p), p.webhook = webhook, h(webhook, p), h(storage$1, p);
    var yt = storeInfo;
    Object.defineProperty(p, "StoreInfo", { enumerable: !0, get: function() {
      return yt.StoreInfo;
    } });
    const St = cacheInfo;
    Object.defineProperty(p, "CacheInfo", { enumerable: !0, get: function() {
      return St.CacheInfo;
    } });
    const Ae = utils;
    Object.defineProperty(p, "CollectionTtl", { enumerable: !0, get: function() {
      return Ae.CollectionTtl;
    } }), Object.defineProperty(p, "SortedSetOrder", { enumerable: !0, get: function() {
      return Ae.SortedSetOrder;
    } }), Object.defineProperty(p, "LeaderboardOrder", { enumerable: !0, get: function() {
      return Ae.LeaderboardOrder;
    } }), Object.defineProperty(p, "ExpiresIn", { enumerable: !0, get: function() {
      return Ae.ExpiresIn;
    } }), Object.defineProperty(p, "ExpiresAt", { enumerable: !0, get: function() {
      return Ae.ExpiresAt;
    } }), Object.defineProperty(p, "ItemType", { enumerable: !0, get: function() {
      return Ae.ItemType;
    } }), Object.defineProperty(p, "PostUrlWebhookDestination", { enumerable: !0, get: function() {
      return Ae.PostUrlWebhookDestination;
    } }), Object.defineProperty(p, "WebhookDestinationType", { enumerable: !0, get: function() {
      return Ae.WebhookDestinationType;
    } });
    const Xe = auth$1;
    Object.defineProperty(p, "CredentialProvider", { enumerable: !0, get: function() {
      return Xe.CredentialProvider;
    } }), Object.defineProperty(p, "StringMomentoTokenProvider", { enumerable: !0, get: function() {
      return Xe.StringMomentoTokenProvider;
    } }), Object.defineProperty(p, "EnvMomentoTokenProvider", { enumerable: !0, get: function() {
      return Xe.EnvMomentoTokenProvider;
    } }), Object.defineProperty(p, "getDefaultCredentialProvider", { enumerable: !0, get: function() {
      return Xe.getDefaultCredentialProvider;
    } });
    const Ce = errors$1;
    Object.defineProperty(p, "MomentoErrorCode", { enumerable: !0, get: function() {
      return Ce.MomentoErrorCode;
    } }), Object.defineProperty(p, "SdkError", { enumerable: !0, get: function() {
      return Ce.SdkError;
    } }), Object.defineProperty(p, "CacheAlreadyExistsError", { enumerable: !0, get: function() {
      return Ce.CacheAlreadyExistsError;
    } }), Object.defineProperty(p, "StoreAlreadyExistsError", { enumerable: !0, get: function() {
      return Ce.StoreAlreadyExistsError;
    } }), Object.defineProperty(p, "AuthenticationError", { enumerable: !0, get: function() {
      return Ce.AuthenticationError;
    } }), Object.defineProperty(p, "CancelledError", { enumerable: !0, get: function() {
      return Ce.CancelledError;
    } }), Object.defineProperty(p, "ConnectionError", { enumerable: !0, get: function() {
      return Ce.ConnectionError;
    } }), Object.defineProperty(p, "FailedPreconditionError", { enumerable: !0, get: function() {
      return Ce.FailedPreconditionError;
    } }), Object.defineProperty(p, "LimitExceededError", { enumerable: !0, get: function() {
      return Ce.LimitExceededError;
    } }), Object.defineProperty(p, "InternalServerError", { enumerable: !0, get: function() {
      return Ce.InternalServerError;
    } }), Object.defineProperty(p, "InvalidArgumentError", { enumerable: !0, get: function() {
      return Ce.InvalidArgumentError;
    } }), Object.defineProperty(p, "UnknownServiceError", { enumerable: !0, get: function() {
      return Ce.UnknownServiceError;
    } }), Object.defineProperty(p, "ServerUnavailableError", { enumerable: !0, get: function() {
      return Ce.ServerUnavailableError;
    } }), Object.defineProperty(p, "TimeoutError", { enumerable: !0, get: function() {
      return Ce.TimeoutError;
    } }), Object.defineProperty(p, "BadRequestError", { enumerable: !0, get: function() {
      return Ce.BadRequestError;
    } }), Object.defineProperty(p, "PermissionError", { enumerable: !0, get: function() {
      return Ce.PermissionError;
    } }), Object.defineProperty(p, "CacheNotFoundError", { enumerable: !0, get: function() {
      return Ce.CacheNotFoundError;
    } }), Object.defineProperty(p, "StoreItemNotFoundError", { enumerable: !0, get: function() {
      return Ce.StoreItemNotFoundError;
    } }), Object.defineProperty(p, "StoreNotFoundError", { enumerable: !0, get: function() {
      return Ce.StoreNotFoundError;
    } }), Object.defineProperty(p, "UnknownError", { enumerable: !0, get: function() {
      return Ce.UnknownError;
    } }), h(enums, p);
    var _e = noopMomentoLogger;
    Object.defineProperty(p, "NoopMomentoLogger", { enumerable: !0, get: function() {
      return _e.NoopMomentoLogger;
    } }), Object.defineProperty(p, "NoopMomentoLoggerFactory", { enumerable: !0, get: function() {
      return _e.NoopMomentoLoggerFactory;
    } });
    var Ue = permissionScope;
    Object.defineProperty(p, "CacheRole", { enumerable: !0, get: function() {
      return Ue.CacheRole;
    } }), Object.defineProperty(p, "TopicRole", { enumerable: !0, get: function() {
      return Ue.TopicRole;
    } }), Object.defineProperty(p, "AllDataReadWrite", { enumerable: !0, get: function() {
      return Ue.AllDataReadWrite;
    } }), Object.defineProperty(p, "isCacheName", { enumerable: !0, get: function() {
      return Ue.isCacheName;
    } }), Object.defineProperty(p, "isTopicName", { enumerable: !0, get: function() {
      return Ue.isTopicName;
    } }), Object.defineProperty(p, "AllCaches", { enumerable: !0, get: function() {
      return Ue.AllCaches;
    } }), Object.defineProperty(p, "AllTopics", { enumerable: !0, get: function() {
      return Ue.AllTopics;
    } }), Object.defineProperty(p, "AllCacheItems", { enumerable: !0, get: function() {
      return Ue.AllCacheItems;
    } });
    var _t = disposableTokenScope;
    Object.defineProperty(p, "isCacheItemKey", { enumerable: !0, get: function() {
      return _t.isCacheItemKey;
    } }), Object.defineProperty(p, "isCacheItemKeyPrefix", { enumerable: !0, get: function() {
      return _t.isCacheItemKeyPrefix;
    } }), p.PermissionScopes = permissionScopes, p.TokenScopes = permissionScopes, p.DisposableTokenScopes = disposableTokenScopes;
    var ft = readConcern;
    Object.defineProperty(p, "ReadConcern", { enumerable: !0, get: function() {
      return ft.ReadConcern;
    } });
    var Ve = compressionLevel;
    Object.defineProperty(p, "CompressionLevel", { enumerable: !0, get: function() {
      return Ve.CompressionLevel;
    } });
  }(src)), src;
}
var hasRequiredCacheServiceErrorMapper;
function requireCacheServiceErrorMapper() {
  if (hasRequiredCacheServiceErrorMapper) return cacheServiceErrorMapper;
  hasRequiredCacheServiceErrorMapper = 1, Object.defineProperty(cacheServiceErrorMapper, "__esModule", { value: !0 }), cacheServiceErrorMapper.CacheServiceErrorMapper = void 0;
  const p = requireSrc(), s = grpcWeb$a, h = requireSrc$1();
  class c {
    constructor(g) {
      this.throwOnErrors = g;
    }
    returnOrThrowError(g, f) {
      const _ = d(g);
      if (this.throwOnErrors)
        throw _;
      return f(_);
    }
    resolveOrRejectError(g) {
      const f = this.convertError(g.err);
      this.throwOnErrors ? g.rejectFn(f) : g.resolveFn(g.errorResponseFactoryFn(f));
    }
    convertError(g) {
      var f, _, te, ae;
      const ie = [
        (g == null ? void 0 : g.message) || "Unable to process request",
        g == null ? void 0 : g.code,
        g == null ? void 0 : g.metadata,
        g == null ? void 0 : g.stack
      ];
      switch (g == null ? void 0 : g.code) {
        case s.StatusCode.PERMISSION_DENIED:
          return new p.PermissionError(...ie);
        case s.StatusCode.DATA_LOSS:
        case s.StatusCode.INTERNAL:
        case s.StatusCode.ABORTED:
          return new p.InternalServerError(...ie);
        case s.StatusCode.UNKNOWN:
          return new p.UnknownServiceError(...ie);
        case s.StatusCode.UNAVAILABLE:
          return new p.ServerUnavailableError(...ie);
        case s.StatusCode.NOT_FOUND: {
          let m = ((f = ie[2]) !== null && f !== void 0 ? f : {}).err;
          const w = (_ = ie[0]) === null || _ === void 0 ? void 0 : _.toString();
          switch ((w == null ? void 0 : w.includes("Store with name:")) && (w == null ? void 0 : w.includes("doesn't exist")) && (m = "store_not_found"), m) {
            case "item_not_found":
              return new h.StoreItemNotFoundError(...ie);
            case "store_not_found":
              return new h.StoreNotFoundError(...ie);
            default:
              return new h.CacheNotFoundError(...ie);
          }
        }
        case s.StatusCode.OUT_OF_RANGE:
        case s.StatusCode.UNIMPLEMENTED:
          return new p.BadRequestError(...ie);
        case s.StatusCode.FAILED_PRECONDITION:
          return new p.FailedPreconditionError(...ie);
        case s.StatusCode.INVALID_ARGUMENT:
          return new p.InvalidArgumentError(...ie);
        case s.StatusCode.CANCELLED:
          return new p.CancelledError(...ie);
        case s.StatusCode.DEADLINE_EXCEEDED:
          return new p.TimeoutError(...ie);
        case s.StatusCode.UNAUTHENTICATED:
          return new p.AuthenticationError(...ie);
        case s.StatusCode.RESOURCE_EXHAUSTED: {
          const m = ((te = ie[2]) !== null && te !== void 0 ? te : {}).err;
          return new p.LimitExceededError(...ie, m);
        }
        case s.StatusCode.ALREADY_EXISTS: {
          let se = "";
          const m = (ae = ie[0]) === null || ae === void 0 ? void 0 : ae.toString(), w = (m == null ? void 0 : m.includes("Store with name:")) && (m == null ? void 0 : m.includes("already exists"));
          switch (!se && w && (se = "store_already_exists"), se) {
            case "store_already_exists":
              return new h.StoreAlreadyExistsError(...ie);
            default:
              return new h.CacheAlreadyExistsError(...ie);
          }
        }
        default:
          return new p.UnknownError(...ie);
      }
    }
  }
  cacheServiceErrorMapper.CacheServiceErrorMapper = c;
  function d(l) {
    return l instanceof p.SdkError ? l : new p.UnknownError(l.message);
  }
  return cacheServiceErrorMapper;
}
var webClientUtils = {};
Object.defineProperty(webClientUtils, "__esModule", { value: !0 });
webClientUtils.getWebTokenEndpoint = webClientUtils.getWebStorageEndpoint = webClientUtils.getWebCacheEndpoint = webClientUtils.getWebControlEndpoint = webClientUtils.createStorageMetadata = webClientUtils.createCallMetadata = webClientUtils.convertToStringFromB64String = webClientUtils.convertToBytesFromB64String = webClientUtils.convertToB64String = void 0;
function convertToB64String(p) {
  if (typeof p == "string") {
    const s = new TextEncoder().encode(p), h = String.fromCharCode(...s);
    return btoa(h);
  } else {
    const s = String.fromCharCode(...p);
    return btoa(s);
  }
}
webClientUtils.convertToB64String = convertToB64String;
function convertToBytesFromB64String(p) {
  const s = atob(p), h = s.length, c = new Uint8Array(h);
  for (let d = 0; d < h; d++)
    c[d] = s.charCodeAt(d);
  return c;
}
webClientUtils.convertToBytesFromB64String = convertToBytesFromB64String;
function convertToStringFromB64String(p) {
  const s = convertToBytesFromB64String(p);
  return new TextDecoder().decode(s);
}
webClientUtils.convertToStringFromB64String = convertToStringFromB64String;
function createCallMetadata(p, s) {
  const h = Date.now() + s;
  return { cache: p, deadline: h.toString() };
}
webClientUtils.createCallMetadata = createCallMetadata;
function createStorageMetadata(p, s) {
  const h = Date.now() + s;
  return { store: p, deadline: h.toString() };
}
webClientUtils.createStorageMetadata = createStorageMetadata;
function getWebControlEndpoint(p) {
  return p.areEndpointsOverridden() ? withProtocolPrefix(p.getControlEndpoint()) : withProtocolPrefix(`web.${p.getControlEndpoint()}`);
}
webClientUtils.getWebControlEndpoint = getWebControlEndpoint;
function getWebCacheEndpoint(p) {
  return p.areEndpointsOverridden() ? withProtocolPrefix(p.getCacheEndpoint()) : withProtocolPrefix(`web.${p.getCacheEndpoint()}`);
}
webClientUtils.getWebCacheEndpoint = getWebCacheEndpoint;
function getWebStorageEndpoint(p) {
  return p.areEndpointsOverridden() ? withProtocolPrefix(p.getStorageEndpoint()) : withProtocolPrefix(`web.${p.getStorageEndpoint()}`);
}
webClientUtils.getWebStorageEndpoint = getWebStorageEndpoint;
function getWebTokenEndpoint(p) {
  return p.areEndpointsOverridden() ? withProtocolPrefix(p.getTokenEndpoint()) : withProtocolPrefix(`web.${p.getTokenEndpoint()}`);
}
webClientUtils.getWebTokenEndpoint = getWebTokenEndpoint;
function withProtocolPrefix(p) {
  return p.match(/^http(?:s)?:\/\//) ? p : `https://${p}`;
}
var clientMetadataProvider = {};
const name = "@gomomento/sdk-web", version = "1.99.1", description = "Client SDK for Momento services", main = "dist/src/index.js", files = [
  "dist/src",
  "dist/package.json"
], types = "dist/src/index.d.ts", repository = {
  type: "git",
  url: "https://github.com/momentohq/client-sdk-nodejs"
}, scripts = {
  prebuild: "eslint . --ext .ts",
  test: "jest --testPathIgnorePatterns auth-client.test.ts --maxWorkers 1",
  "unit-test": "jest unit",
  "integration-test-auth": "jest --env=jsdom auth/ --maxWorkers 1 -- useConsistentReads",
  "integration-test-cache": "jest --env=jsdom cache/ --maxWorkers 1 -- useConsistentReads",
  "integration-test-control-cache-topics": "npm run integration-test-cache && npm run integration-test-topics",
  "integration-test-leaderboard": "jest --env=jsdom leaderboard/ --maxWorkers 1 -- useConsistentReads",
  "integration-test-storage": "jest --env=jsdom storage/ --maxWorkers 1 -- useConsistentReads",
  "integration-test-store": "npm run integration-test-storage",
  "integration-test-topics": "jest --env=jsdom topics/ --maxWorkers 1 && jest --env=@happy-dom/jest-environment webhooks/ --maxWorkers 1 -- useConsistentReads",
  "integration-test-jsdom": 'jest integration --env=jsdom --testMatch "**/dictionary.test.ts|**/ping.test.ts|*/topic-client.test.ts|leaderboard.test.ts" --maxWorkers 1',
  "integration-test-jsdom-consistent-reads": 'jest integration --env=jsdom --testMatch "**/dictionary.test.ts|**/ping.test.ts|*/topic-client.test.ts|leaderboard.test.ts" --maxWorkers 1 -- useConsistentReads',
  "integration-test-happy-dom": 'jest integration --env=@happy-dom/jest-environment --testPathIgnorePatterns "dictionary.test.ts|ping.test.ts|topic-client.test.ts|auth-client.test.ts|leaderboard.test.ts|storage.test.ts" --maxWorkers 1',
  "integration-test-happy-dom-consistent-reads": 'jest integration --env=@happy-dom/jest-environment --testPathIgnorePatterns "dictionary.test.ts|ping.test.ts|topic-client.test.ts|auth-client.test.ts|leaderboard.test.ts|storage.test.ts" --maxWorkers 1 -- useConsistentReads',
  "integration-test": "npm run integration-test-happy-dom && npm run integration-test-jsdom",
  "integration-test-consistent-reads": "npm run integration-test-happy-dom-consistent-reads && npm run integration-test-jsdom-consistent-reads",
  "build-deps": "cd ../core && npm run build && cd - && cd ../common-integration-tests && npm run build && cd -",
  "build-and-run-tests": "npm run build-deps && jest --testPathIgnorePatterns auth-client.test.ts --maxWorkers 1",
  lint: "eslint . --ext .ts",
  format: "eslint . --ext .ts --fix",
  watch: "tsc -w",
  build: "cd ../core && npm run build && cd - && rm -rf dist && tsc"
}, author = "", license = "Apache-2.0", devDependencies = {
  "@gomomento/common-integration-tests": "file:../common-integration-tests/gomomento-common-integration-tests-1.99.1.tgz",
  "@happy-dom/jest-environment": "^12.10.3",
  "@types/jest": "27.5.2",
  "@types/node": "16.18.97",
  "@types/uuid": "^9.0.7",
  "@typescript-eslint/eslint-plugin": "5.62.0",
  "@typescript-eslint/parser": "5.62.0",
  eslint: "7.32.0",
  "eslint-config-prettier": "8.10.0",
  "eslint-plugin-import": "2.29.0",
  "eslint-plugin-node": "11.1.0",
  "eslint-plugin-prettier": "4.2.1",
  jest: "29.7.0",
  "jest-environment-jsdom": "^29.7.0",
  "jest-extended": "4.0.2",
  "jest-spec-reporter": "^1.0.19",
  prettier: "2.8.8",
  "ts-jest": "29.1.1",
  "ts-node": "10.9.1",
  typescript: "4.9.5",
  uuid: "^9.0.1",
  xhr2: "0.2.1"
}, dependencies = {
  "@gomomento/generated-types-webtext": "0.113.0",
  "@gomomento/sdk-core": "1.99.1",
  "@types/google-protobuf": "3.15.6",
  "google-protobuf": "3.21.2",
  "grpc-web": "1.4.2",
  "jwt-decode": "3.1.2"
}, engines = {
  node: ">= 16"
}, require$$1 = {
  name,
  version,
  description,
  main,
  files,
  types,
  repository,
  scripts,
  author,
  license,
  devDependencies,
  dependencies,
  engines
};
Object.defineProperty(clientMetadataProvider, "__esModule", { value: !0 });
clientMetadataProvider.ClientMetadataProvider = void 0;
const sdk_core_1$2 = requireSrc$1(), package_json_1 = require$$1;
class ClientMetadataProvider {
  constructor(s) {
    var h;
    this.areFirstTimeHeadersSent = !1, this.authToken = s.authToken, this.readConcern = s.readConcern, this.clientType = (h = s.clientType) !== null && h !== void 0 ? h : "unknown";
  }
  /**
   * Creates a client metadata header map. Provides an authorization header if an auth token is present. Provides an
   * agent string on the first call.
   */
  createClientMetadata() {
    const s = {};
    return this.authToken && (s.authorization = this.authToken), this.areFirstTimeHeadersSent || (this.areFirstTimeHeadersSent = !0, s.agent = `${ClientMetadataProvider.agentName}:${this.clientType}:${package_json_1.version}`, s["runtime-version"] = `${ClientMetadataProvider.agentName}:${getBrowserName(navigator.userAgent)}`), this.readConcern && this.readConcern !== sdk_core_1$2.ReadConcern.BALANCED && (s["read-concern"] = this.readConcern), s;
  }
}
clientMetadataProvider.ClientMetadataProvider = ClientMetadataProvider;
ClientMetadataProvider.agentName = "js-web";
function getBrowserName(p) {
  return p.includes("Firefox") ? "Mozilla-Firefox" : p.includes("SamsungBrowser") ? "Samsung-Internet" : p.includes("Opera") || p.includes("OPR") ? "Opera" : p.includes("Edge") ? "Microsoft-Edge-(Legacy)" : p.includes("Edg") ? "Microsoft-Edge-(Chromium)" : p.includes("Chrome") ? "Google-Chrome-or-Chromium" : p.includes("Safari") ? "Apple-Safari" : "unknown-browser";
}
var hasRequiredCacheControlClient;
function requireCacheControlClient() {
  if (hasRequiredCacheControlClient) return cacheControlClient;
  hasRequiredCacheControlClient = 1, Object.defineProperty(cacheControlClient, "__esModule", { value: !0 }), cacheControlClient.CacheControlClient = void 0;
  const p = dist, s = requireSrc(), h = controlclient_pb$1, c = requireCacheServiceErrorMapper(), d = utils$1, l = webClientUtils, g = clientMetadataProvider;
  class f {
    /**
     * @param {ControlClientProps} props
     */
    constructor(te) {
      this.logger = te.configuration.getLoggerFactory().getLogger(this), this.cacheServiceErrorMapper = new c.CacheServiceErrorMapper(te.configuration.getThrowOnErrors()), this.logger.debug(`Creating control client using endpoint: '${(0, l.getWebControlEndpoint)(te.credentialProvider)}`), this.clientMetadataProvider = new g.ClientMetadataProvider({
        authToken: te.credentialProvider.getAuthToken(),
        clientType: "cache"
      }), this.clientWrapper = new p.control.ScsControlClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, l.getWebControlEndpoint)(te.credentialProvider),
        null,
        {}
      );
    }
    close() {
      this.logger.debug("Closing cache control client");
    }
    async createCache(te) {
      try {
        (0, d.validateCacheName)(te);
      } catch (ie) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ie, (se) => new s.CreateCache.Error(se));
      }
      this.logger.debug(`Creating cache: ${te}`);
      const ae = new h._CreateCacheRequest();
      return ae.setCacheName(te), await new Promise((ie, se) => {
        this.clientWrapper.createCache(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          m ? this.cacheServiceErrorMapper.convertError(m).errorCode() === s.MomentoErrorCode.CACHE_ALREADY_EXISTS_ERROR ? ie(new s.CreateCache.AlreadyExists()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: m,
            errorResponseFactoryFn: (j) => new s.CreateCache.Error(j),
            resolveFn: ie,
            rejectFn: se
          }) : ie(new s.CreateCache.Success());
        });
      });
    }
    async deleteCache(te) {
      try {
        (0, d.validateCacheName)(te);
      } catch (ie) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ie, (se) => new s.DeleteCache.Error(se));
      }
      const ae = new h._DeleteCacheRequest();
      return ae.setCacheName(te), this.logger.debug(`Deleting cache: ${te}`), await new Promise((ie, se) => {
        this.clientWrapper.deleteCache(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          m ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: m,
            errorResponseFactoryFn: (q) => new s.DeleteCache.Error(q),
            resolveFn: ie,
            rejectFn: se
          }) : ie(new s.DeleteCache.Success());
        });
      });
    }
    async flushCache(te) {
      try {
        (0, d.validateCacheName)(te);
      } catch (ae) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ae, (ie) => new s.CacheFlush.Error(ie));
      }
      return this.logger.trace(`Flushing cache: ${te}`), await this.sendFlushCache(te);
    }
    async sendFlushCache(te) {
      const ae = new h._FlushCacheRequest();
      return ae.setCacheName(te), await new Promise((ie, se) => {
        this.clientWrapper.flushCache(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          w ? ie(new s.CacheFlush.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: m,
            errorResponseFactoryFn: (q) => new s.CacheFlush.Error(q),
            resolveFn: ie,
            rejectFn: se
          });
        });
      });
    }
    async listCaches() {
      const te = new h._ListCachesRequest();
      return te.setNextToken(""), this.logger.debug("Issuing 'listCaches' request"), await new Promise((ae, ie) => {
        this.clientWrapper.listCaches(te, this.clientMetadataProvider.createClientMetadata(), (se, m) => {
          if (se)
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: se,
              errorResponseFactoryFn: (w) => new s.ListCaches.Error(w),
              resolveFn: ae,
              rejectFn: ie
            });
          else {
            const w = m.getCacheList().map((q) => {
              var j, k, z, $, re, oe, le;
              const ue = q.getCacheName(), pe = {
                maxPublishMessageSizeKb: ((j = q.getTopicLimits()) === null || j === void 0 ? void 0 : j.getMaxPublishMessageSizeKb()) || 0,
                maxSubscriptionCount: ((k = q.getTopicLimits()) === null || k === void 0 ? void 0 : k.getMaxSubscriptionCount()) || 0,
                maxPublishRate: ((z = q.getTopicLimits()) === null || z === void 0 ? void 0 : z.getMaxPublishRate()) || 0
              }, he = {
                maxTtlSeconds: (($ = q.getCacheLimits()) === null || $ === void 0 ? void 0 : $.getMaxTtlSeconds()) || 0,
                maxItemSizeKb: ((re = q.getCacheLimits()) === null || re === void 0 ? void 0 : re.getMaxItemSizeKb()) || 0,
                maxThroughputKbps: ((oe = q.getCacheLimits()) === null || oe === void 0 ? void 0 : oe.getMaxThroughputKbps()) || 0,
                maxTrafficRate: ((le = q.getCacheLimits()) === null || le === void 0 ? void 0 : le.getMaxTrafficRate()) || 0
              };
              return new s.CacheInfo(ue, pe, he);
            });
            ae(new s.ListCaches.Success(w));
          }
        });
      });
    }
  }
  return cacheControlClient.CacheControlClient = f, cacheControlClient;
}
var cacheDataClient = {}, middlewaresInterceptor$1 = {}, middleware = {};
Object.defineProperty(middleware, "__esModule", { value: !0 });
middleware.MiddlewareRequest = middleware.MiddlewareMessage = middleware.MiddlewareStatus = middleware.MiddlewareMetadata = void 0;
class MiddlewareMetadata {
  constructor(s) {
    this._grpcMetadata = s;
  }
  toJsonString() {
    return JSON.stringify(this._grpcMetadata);
  }
}
middleware.MiddlewareMetadata = MiddlewareMetadata;
class MiddlewareStatus {
  constructor(s) {
    this._grpcStatus = s;
  }
  code() {
    return this._grpcStatus.code;
  }
}
middleware.MiddlewareStatus = MiddlewareStatus;
class MiddlewareMessage {
  constructor(s) {
    this._grpcMessage = s;
  }
  responseType() {
    return this._grpcMessage.constructor.name;
  }
  messageLength() {
    return this._grpcMessage !== null && this._grpcMessage !== void 0 ? this._grpcMessage.serializeBinary().length : 0;
  }
}
middleware.MiddlewareMessage = MiddlewareMessage;
class MiddlewareRequest {
  constructor(s) {
    this._grpcRequest = s;
  }
  getMetadata() {
    return this._grpcRequest.getMetadata();
  }
  getRequestType() {
    return this._grpcRequest.constructor.name;
  }
  getBodySize() {
    return this._grpcRequest.getRequestMessage().serializeBinary().length;
  }
}
middleware.MiddlewareRequest = MiddlewareRequest;
Object.defineProperty(middlewaresInterceptor$1, "__esModule", { value: !0 });
middlewaresInterceptor$1.middlewaresInterceptor = void 0;
const middleware_1 = middleware;
function middlewaresInterceptor(p, s, h) {
  return new MiddlewareStreamInterceptor(p, s, h);
}
middlewaresInterceptor$1.middlewaresInterceptor = middlewaresInterceptor;
class MiddlewareStreamInterceptor {
  constructor(s, h, c) {
    this.logger = s.getLogger(this.constructor.name), this.middlewares = h, this.middlewareRequestContext = c;
  }
  intercept(s, h) {
    const c = this.middlewares.map((g) => g.onNewRequest(this.middlewareRequestContext)), d = new middleware_1.MiddlewareRequest(s), l = c.reduce((g, f) => f.onRequest(g), d);
    return new MiddlewareInterceptedStream(this.logger, this.middlewareRequestContext, c, h(l._grpcRequest));
  }
}
class MiddlewareInterceptedStream {
  constructor(s, h, c, d) {
    this.logger = s, this.middlewareRequestContext = h, this.middlewareRequestHandlers = c, this.stream = d, this.reversedMiddlewareRequestHandlers = [
      ...this.middlewareRequestHandlers
    ].reverse();
  }
  on(s, h) {
    switch (s) {
      case "error":
        return this.onResponseError(s, h);
      case "status":
        return this.onResponseStatus(s, h);
      case "metadata":
        return this.onResponseMetadata(s, h);
      case "data":
        return this.onResponseData(s, h);
      case "end":
        return this.onResponseEnd(s, h);
      default:
        return this.stream.on(s, h);
    }
  }
  removeListener(s, h) {
  }
  cancel() {
    this.stream.cancel();
  }
  onResponseError(s, h) {
    return this.stream.on(s, h);
  }
  onResponseStatus(s, h) {
    const c = (d) => {
      const l = applyMiddlewareHandlers("onResponseStatus", this.reversedMiddlewareRequestHandlers, (g) => (f) => g.onResponseStatus(f), new middleware_1.MiddlewareStatus(d));
      h(l._grpcStatus);
    };
    return this.stream.on(s, c);
  }
  onResponseMetadata(s, h) {
    const c = (d) => {
      const l = applyMiddlewareHandlers("onResponseMetadata", this.reversedMiddlewareRequestHandlers, (g) => (f) => g.onResponseMetadata(f), new middleware_1.MiddlewareMetadata(d));
      h(l._grpcMetadata);
    };
    return this.stream.on(s, c);
  }
  onResponseData(s, h) {
    const c = (d) => {
      const l = applyMiddlewareHandlers("onResponseData", this.reversedMiddlewareRequestHandlers, (g) => (f) => g.onResponseData(f), new middleware_1.MiddlewareMessage(d));
      h(l._grpcMessage);
    };
    return this.stream.on(s, c);
  }
  onResponseEnd(s, h) {
    const c = () => {
      applyMiddlewareHandlers("onResponseEnd", this.reversedMiddlewareRequestHandlers, (d) => () => d.onResponseEnd(), void 0), h();
    };
    return this.stream.on(s, c);
  }
}
function applyMiddlewareHandlers(p, s, h, c) {
  let d = s, l = c;
  for (; d.length > 0; )
    l = h(d[0])(l), d = d.slice(1);
  return l;
}
var hasRequiredCacheDataClient;
function requireCacheDataClient() {
  if (hasRequiredCacheDataClient) return cacheDataClient;
  hasRequiredCacheDataClient = 1, Object.defineProperty(cacheDataClient, "__esModule", { value: !0 }), cacheDataClient.CacheDataClient = void 0;
  const p = dist, s = requireSrc(), h = requireCacheServiceErrorMapper(), c = grpcResponseTypes, d = cacheclient_pb$1, l = utils$1, g = webClientUtils, f = clientMetadataProvider, _ = middlewaresInterceptor$1, te = common_pb$2, ae = requireSrc$1();
  class ie {
    /**
     * @param {DataClientProps} props
     */
    constructor(m) {
      this.logger = m.configuration.getLoggerFactory().getLogger(this), this.cacheServiceErrorMapper = new h.CacheServiceErrorMapper(m.configuration.getThrowOnErrors()), this.logger.debug(`Creating data client using endpoint: '${(0, g.getWebCacheEndpoint)(m.credentialProvider)}`), this.deadlineMillis = m.configuration.getTransportStrategy().getGrpcConfig().getDeadlineMillis(), this.defaultTtlSeconds = m.defaultTtlSeconds, this.clientMetadataProvider = new f.ClientMetadataProvider({
        authToken: m.credentialProvider.getAuthToken(),
        readConcern: m.configuration.getReadConcern(),
        clientType: "cache"
      });
      const w = {};
      this.clientWrapper = new p.cache.ScsClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, g.getWebCacheEndpoint)(m.credentialProvider),
        null,
        {
          streamInterceptors: [
            (0, _.middlewaresInterceptor)(m.configuration.getLoggerFactory(), m.configuration.getMiddlewares(), w)
          ]
        }
      ), this.textEncoder = new TextEncoder();
    }
    close() {
      this.logger.debug("Closing cache control client");
    }
    async get(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheGet.Error(k));
      }
      this.logger.trace(`Issuing 'get' request; key: ${w.toString()}`);
      const q = await this.sendGet(m, (0, g.convertToB64String)(w));
      return this.logger.trace(`'get' request result: ${q.toString()}`), q;
    }
    async sendGet(m, w) {
      const q = new d._GetRequest();
      return q.setCacheKey(w), await new Promise((j, k) => {
        this.clientWrapper.get(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          if ($)
            switch ($.getResult()) {
              case d.ECacheResult.MISS:
                j(new s.CacheGet.Miss());
                break;
              case d.ECacheResult.HIT:
                j(new s.CacheGet.Hit($.getCacheBody_asU8()));
                break;
              case d.ECacheResult.INVALID:
              case d.ECacheResult.OK:
                j(new s.CacheGet.Error(new s.UnknownError($.getMessage())));
                break;
              default:
                j(new s.CacheGet.Error(new s.UnknownError("An unknown error occurred: " + $.getMessage())));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (re) => new s.CacheGet.Error(re),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async set(m, w, q, j) {
      try {
        (0, l.validateCacheName)(m), (j == null ? void 0 : j.ttl) !== void 0 && (0, l.validateTtlSeconds)(j == null ? void 0 : j.ttl);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheSet.Error($));
      }
      const k = (j == null ? void 0 : j.ttl) || this.defaultTtlSeconds;
      return this.logger.trace(`Issuing 'set' request; key: ${w.toString()}, value length: ${q.length}, ttl: ${k.toString()}`), await this.sendSet(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), k);
    }
    async sendSet(m, w, q, j) {
      const k = new d._SetRequest();
      return k.setCacheKey(w), k.setCacheBody(q), k.setTtlMilliseconds(this.convertSecondsToMilliseconds(j)), await new Promise((z, $) => {
        this.clientWrapper.set(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          oe ? z(new s.CacheSet.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: re,
            errorResponseFactoryFn: (le) => new s.CacheSet.Error(le),
            resolveFn: z,
            rejectFn: $
          });
        });
      });
    }
    // setIfNotExists is deprecated on the service. Here we call the new `SetIf` method with the absent field set
    // and return `CacheSetIfNotExists` responses.
    async setIfNotExists(m, w, q, j) {
      var k;
      try {
        (0, l.validateCacheName)(m), j !== void 0 && (0, l.validateTtlSeconds)(j);
      } catch ($) {
        return this.cacheServiceErrorMapper.returnOrThrowError($, (re) => new s.CacheSetIfNotExists.Error(re));
      }
      this.logger.trace(`Issuing 'setIfNotExists' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(k = j == null ? void 0 : j.toString()) !== null && k !== void 0 ? k : "null"}`);
      const z = await this.sendSetIfNotExists(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), j ? j * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfNotExists' request result: ${z.toString()}`), z;
    }
    async sendSetIfNotExists(m, w, q, j) {
      const k = new d._SetIfRequest();
      return k.setCacheKey(w), k.setCacheBody(q), k.setTtlMilliseconds(j), k.setAbsent(new te.Absent()), await new Promise((z, $) => {
        this.clientWrapper.setIf(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          if (oe)
            switch (oe.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                z(new s.CacheSetIfNotExists.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                z(new s.CacheSetIfNotExists.NotStored());
                break;
              default:
                z(new s.CacheSetIfNotExists.Error(new s.UnknownError("SetIfNotExists responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: re,
              errorResponseFactoryFn: (le) => new s.CacheSetIfNotExists.Error(le),
              resolveFn: z,
              rejectFn: $
            });
        });
      });
    }
    async setIfAbsent(m, w, q, j) {
      var k;
      const z = j == null ? void 0 : j.ttl;
      try {
        (0, l.validateCacheName)(m), z !== void 0 && (0, l.validateTtlSeconds)(z);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSetIfAbsent.Error(oe));
      }
      this.logger.trace(`Issuing 'setIfAbsent' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(k = z == null ? void 0 : z.toString()) !== null && k !== void 0 ? k : "null"}`);
      const $ = await this.sendSetIfAbsent(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), z ? z * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfAbsent' request result: ${$.toString()}`), $;
    }
    async sendSetIfAbsent(m, w, q, j) {
      const k = new d._SetIfRequest();
      return k.setCacheKey(w), k.setCacheBody(q), k.setTtlMilliseconds(j), k.setAbsent(new te.Absent()), await new Promise((z, $) => {
        this.clientWrapper.setIf(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          if (oe)
            switch (oe.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                z(new s.CacheSetIfAbsent.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                z(new s.CacheSetIfAbsent.NotStored());
                break;
              default:
                z(new s.CacheSetIfAbsent.Error(new s.UnknownError("SetIfAbsent responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: re,
              errorResponseFactoryFn: (le) => new s.CacheSetIfAbsent.Error(le),
              resolveFn: z,
              rejectFn: $
            });
        });
      });
    }
    async setIfPresent(m, w, q, j) {
      var k;
      try {
        (0, l.validateCacheName)(m), j !== void 0 && (0, l.validateTtlSeconds)(j);
      } catch ($) {
        return this.cacheServiceErrorMapper.returnOrThrowError($, (re) => new s.CacheSetIfPresent.Error(re));
      }
      this.logger.trace(`Issuing 'setIfPresent' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(k = j == null ? void 0 : j.toString()) !== null && k !== void 0 ? k : "null"}`);
      const z = await this.sendSetIfPresent(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), j ? j * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfPresent' request result: ${z.toString()}`), z;
    }
    async sendSetIfPresent(m, w, q, j) {
      const k = new d._SetIfRequest();
      return k.setCacheKey(w), k.setCacheBody(q), k.setTtlMilliseconds(j), k.setPresent(new te.Present()), await new Promise((z, $) => {
        this.clientWrapper.setIf(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          if (oe)
            switch (oe.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                z(new s.CacheSetIfPresent.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                z(new s.CacheSetIfPresent.NotStored());
                break;
              default:
                z(new s.CacheSetIfPresent.Error(new s.UnknownError("SetIfPresent responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: re,
              errorResponseFactoryFn: (le) => new s.CacheSetIfPresent.Error(le),
              resolveFn: z,
              rejectFn: $
            });
        });
      });
    }
    async setIfEqual(m, w, q, j, k) {
      var z;
      try {
        (0, l.validateCacheName)(m), k !== void 0 && (0, l.validateTtlSeconds)(k);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSetIfEqual.Error(oe));
      }
      this.logger.trace(`Issuing 'setIfEqual' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(z = k == null ? void 0 : k.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendSetIfEqual(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), (0, g.convertToB64String)(j), k ? k * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfEqual' request result: ${$.toString()}`), $;
    }
    async sendSetIfEqual(m, w, q, j, k) {
      const z = new d._SetIfRequest();
      return z.setCacheKey(w), z.setCacheBody(q), z.setTtlMilliseconds(k), z.setEqual(new te.Equal().setValueToCheck(j)), await new Promise(($, re) => {
        this.clientWrapper.setIf(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          if (le)
            switch (le.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                $(new s.CacheSetIfEqual.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                $(new s.CacheSetIfEqual.NotStored());
                break;
              default:
                $(new s.CacheSetIfEqual.Error(new s.UnknownError("SetIfEqual responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: oe,
              errorResponseFactoryFn: (ue) => new s.CacheSetIfEqual.Error(ue),
              resolveFn: $,
              rejectFn: re
            });
        });
      });
    }
    async setIfNotEqual(m, w, q, j, k) {
      var z;
      try {
        (0, l.validateCacheName)(m), k !== void 0 && (0, l.validateTtlSeconds)(k);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSetIfNotEqual.Error(oe));
      }
      this.logger.trace(`Issuing 'setIfNotEqual' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(z = k == null ? void 0 : k.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendSetIfNotEqual(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), (0, g.convertToB64String)(j), k ? k * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfNotEqual' request result: ${$.toString()}`), $;
    }
    async sendSetIfNotEqual(m, w, q, j, k) {
      const z = new d._SetIfRequest();
      return z.setCacheKey(w), z.setCacheBody(q), z.setTtlMilliseconds(k), z.setNotEqual(new te.NotEqual().setValueToCheck(j)), await new Promise(($, re) => {
        this.clientWrapper.setIf(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          if (le)
            switch (le.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                $(new s.CacheSetIfNotEqual.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                $(new s.CacheSetIfNotEqual.NotStored());
                break;
              default:
                $(new s.CacheSetIfNotEqual.Error(new s.UnknownError("SetIfNotEqual responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: oe,
              errorResponseFactoryFn: (ue) => new s.CacheSetIfNotEqual.Error(ue),
              resolveFn: $,
              rejectFn: re
            });
        });
      });
    }
    async setIfPresentAndNotEqual(m, w, q, j, k) {
      var z;
      try {
        (0, l.validateCacheName)(m), k !== void 0 && (0, l.validateTtlSeconds)(k);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSetIfPresentAndNotEqual.Error(oe));
      }
      this.logger.trace(`Issuing 'setIfPresentAndNotEqual' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(z = k == null ? void 0 : k.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendSetIfPresentAndNotEqual(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), (0, g.convertToB64String)(j), k ? k * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfPresentAndNotEqual' request result: ${$.toString()}`), $;
    }
    async sendSetIfPresentAndNotEqual(m, w, q, j, k) {
      const z = new d._SetIfRequest();
      return z.setCacheKey(w), z.setCacheBody(q), z.setTtlMilliseconds(k), z.setPresentAndNotEqual(new te.PresentAndNotEqual().setValueToCheck(j)), await new Promise(($, re) => {
        this.clientWrapper.setIf(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          if (le)
            switch (le.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                $(new s.CacheSetIfPresentAndNotEqual.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                $(new s.CacheSetIfPresentAndNotEqual.NotStored());
                break;
              default:
                $(new s.CacheSetIfPresentAndNotEqual.Error(new s.UnknownError("SetIfPresentAndNotEqual responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: oe,
              errorResponseFactoryFn: (ue) => new s.CacheSetIfPresentAndNotEqual.Error(ue),
              resolveFn: $,
              rejectFn: re
            });
        });
      });
    }
    async setIfAbsentOrEqual(m, w, q, j, k) {
      var z;
      try {
        (0, l.validateCacheName)(m), k !== void 0 && (0, l.validateTtlSeconds)(k);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSetIfAbsentOrEqual.Error(oe));
      }
      this.logger.trace(`Issuing 'setIfAbsentOrEqual' request; key: ${w.toString()}, field: ${q.toString()}, ttlSeconds: ${(z = k == null ? void 0 : k.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendSetIfAbsentOrEqual(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), (0, g.convertToB64String)(j), k ? k * 1e3 : this.defaultTtlSeconds * 1e3);
      return this.logger.trace(`'setIfAbsentOrEqual' request result: ${$.toString()}`), $;
    }
    async sendSetIfAbsentOrEqual(m, w, q, j, k) {
      const z = new d._SetIfRequest();
      return z.setCacheKey(w), z.setCacheBody(q), z.setTtlMilliseconds(k), z.setAbsentOrEqual(new te.AbsentOrEqual().setValueToCheck(j)), await new Promise(($, re) => {
        this.clientWrapper.setIf(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          if (le)
            switch (le.getResultCase()) {
              case d._SetIfResponse.ResultCase.STORED:
                $(new s.CacheSetIfAbsentOrEqual.Stored());
                break;
              case d._SetIfResponse.ResultCase.NOT_STORED:
                $(new s.CacheSetIfAbsentOrEqual.NotStored());
                break;
              default:
                $(new s.CacheSetIfAbsentOrEqual.Error(new s.UnknownError("SetIfAbsentOrEqual responded with an unknown result")));
                break;
            }
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: oe,
              errorResponseFactoryFn: (ue) => new s.CacheSetIfAbsentOrEqual.Error(ue),
              resolveFn: $,
              rejectFn: re
            });
        });
      });
    }
    async getBatch(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheGetBatch.Error(k));
      }
      this.logger.trace(`Issuing 'getBatch' request; keys: ${w.toString()}`);
      const q = await this.sendGetBatch(m, w);
      return this.logger.trace(`'getBatch' request result: ${q.toString()}`), q;
    }
    async sendGetBatch(m, w) {
      const q = [];
      for (const z of w) {
        const $ = new d._GetRequest();
        $.setCacheKey((0, g.convertToB64String)(z)), q.push($);
      }
      const j = new d._GetBatchRequest();
      j.setItemsList(q);
      const k = this.clientWrapper.getBatch(j, {
        ...this.clientMetadataProvider.createClientMetadata(),
        ...(0, g.createCallMetadata)(m, this.deadlineMillis)
      });
      return await new Promise((z, $) => {
        const re = [];
        k.on("data", (oe) => {
          switch (oe.getResult()) {
            case d.ECacheResult.HIT:
              re.push(new s.CacheGet.Hit(oe.getCacheBody_asU8()));
              break;
            case d.ECacheResult.MISS:
              re.push(new s.CacheGet.Miss());
              break;
            default:
              re.push(new s.CacheGet.Error(new s.UnknownError(oe.getMessage())));
          }
        }), k.on("end", () => {
          z(new s.CacheGetBatch.Success(re, w.map((oe) => this.convertToUint8Array(oe))));
        }), k.on("error", (oe) => {
          this.cacheServiceErrorMapper.resolveOrRejectError({
            err: oe,
            errorResponseFactoryFn: (le) => new s.CacheGetBatch.Error(le),
            resolveFn: z,
            rejectFn: $
          });
        });
      });
    }
    async setBatch(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (q == null ? void 0 : q.ttl) !== void 0 && (0, l.validateTtlSeconds)(q == null ? void 0 : q.ttl);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheSetBatch.Error($));
      }
      const j = (q == null ? void 0 : q.ttl) || this.defaultTtlSeconds, k = this.convertSetBatchElements(w, j);
      return this.logger.trace(`Issuing 'setBatch' request; items length: ${k.length}, ttl: ${j.toString()}`), await this.sendSetBatch(m, k);
    }
    async sendSetBatch(m, w) {
      const q = [];
      for (const z of w) {
        const [$, re, oe] = z, le = new d._SetRequest();
        le.setCacheKey($), le.setCacheBody(re), le.setTtlMilliseconds(this.convertSecondsToMilliseconds(oe)), q.push(le);
      }
      const j = new d._SetBatchRequest();
      j.setItemsList(q);
      const k = this.clientWrapper.setBatch(j, {
        ...this.clientMetadataProvider.createClientMetadata(),
        ...(0, g.createCallMetadata)(m, this.deadlineMillis)
      });
      return await new Promise((z, $) => {
        const re = [];
        k.on("data", (oe) => {
          switch (oe.getResult()) {
            case d.ECacheResult.OK:
              re.push(new s.CacheSet.Success());
              break;
            default:
              re.push(new s.CacheSet.Error(new s.UnknownError(oe.getMessage())));
          }
        }), k.on("end", () => {
          z(new s.CacheSetBatch.Success(re));
        }), k.on("error", (oe) => {
          this.cacheServiceErrorMapper.resolveOrRejectError({
            err: oe,
            errorResponseFactoryFn: (le) => new s.CacheSetBatch.Error(le),
            resolveFn: z,
            rejectFn: $
          });
        });
      });
    }
    async delete(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.CacheDelete.Error(j));
      }
      return this.logger.trace(`Issuing 'delete' request; key: ${w.toString()}`), await this.sendDelete(m, (0, g.convertToB64String)(w));
    }
    async sendDelete(m, w) {
      const q = new d._DeleteRequest();
      return q.setCacheKey(w), await new Promise((j, k) => {
        this.clientWrapper.delete(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          $ ? j(new s.CacheDelete.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (re) => new s.CacheDelete.Error(re),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async increment(m, w, q = 1, j) {
      var k;
      try {
        (0, l.validateCacheName)(m), j !== void 0 && (0, l.validateTtlSeconds)(j);
      } catch ($) {
        return this.cacheServiceErrorMapper.returnOrThrowError($, (re) => new s.CacheIncrement.Error(re));
      }
      this.logger.trace(`Issuing 'increment' request; field: ${w.toString()}, amount : ${q}, ttl: ${(k = j == null ? void 0 : j.toString()) !== null && k !== void 0 ? k : "null"}`);
      const z = await this.sendIncrement(m, (0, g.convertToB64String)(w), q, (j || this.defaultTtlSeconds) * 1e3);
      return this.logger.trace(`'increment' request result: ${z.toString()}`), z;
    }
    async sendIncrement(m, w, q = 1, j) {
      const k = new d._IncrementRequest();
      return k.setCacheKey(w), k.setAmount(q), k.setTtlMilliseconds(j), await new Promise((z, $) => {
        this.clientWrapper.increment(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          oe ? oe.getValue() ? z(new s.CacheIncrement.Success(oe.getValue())) : z(new s.CacheIncrement.Success(0)) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: re,
            errorResponseFactoryFn: (le) => new s.CacheIncrement.Error(le),
            resolveFn: z,
            rejectFn: $
          });
        });
      });
    }
    async setFetch(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.CacheSetFetch.Error(j));
      }
      return await this.sendSetFetch(m, (0, g.convertToB64String)(w));
    }
    async sendSetFetch(m, w) {
      const q = new d._SetFetchRequest();
      return q.setSetName(w), await new Promise((j, k) => {
        this.clientWrapper.setFetch(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          const re = $ == null ? void 0 : $.getFound();
          if (re && re.getElementsList()) {
            const oe = re.getElementsList();
            j(new s.CacheSetFetch.Hit(this.convertArrayToUint8(oe)));
          } else $ != null && $.getMissing() ? j(new s.CacheSetFetch.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (oe) => new s.CacheSetFetch.Error(oe),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async setAddElements(m, w, q, j = s.CollectionTtl.fromCacheTtl()) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheSetAddElements.Error(z));
      }
      return await this.sendSetAddElements(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q), j.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, j.refreshTtl());
    }
    async sendSetAddElements(m, w, q, j, k) {
      const z = new d._SetUnionRequest();
      return z.setSetName(w), z.setElementsList(q), z.setTtlMilliseconds(j), z.setRefreshTtl(k), await new Promise(($, re) => {
        this.clientWrapper.setUnion(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe) => {
          oe ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: oe,
            errorResponseFactoryFn: (le) => new s.CacheSetAddElements.Error(le),
            resolveFn: $,
            rejectFn: re
          }) : $(new s.CacheSetAddElements.Success());
        });
      });
    }
    async setContainsElement(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheSetContainsElement.Error(k));
      }
      return await this.sendSetContainsElement(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q));
    }
    async sendSetContainsElement(m, w, q) {
      const j = new d._SetContainsRequest();
      return j.setSetName(w), j.setElementsList([q]), await new Promise((k, z) => {
        this.clientWrapper.setContains(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          var oe;
          if (re)
            if (re.hasFound()) {
              const le = re.getFound();
              ((le == null ? void 0 : le.getContainsList()) === void 0 || (le == null ? void 0 : le.getContainsList().length) === 0) && k(new s.CacheSetContainsElement.Error(new s.UnknownError("SetContains responded with an empty list"))), k(new s.CacheSetContainsElement.Hit((oe = le == null ? void 0 : le.getContainsList().at(0)) !== null && oe !== void 0 ? oe : !1));
            } else
              k(new s.CacheSetContainsElement.Miss());
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: $,
              errorResponseFactoryFn: (le) => new s.CacheSetContainsElement.Error(le),
              resolveFn: k,
              rejectFn: z
            });
        });
      });
    }
    async setContainsElements(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheSetContainsElements.Error(k));
      }
      return await this.sendSetContainsElements(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q), this.convertArrayToUint8(q));
    }
    async sendSetContainsElements(m, w, q, j) {
      const k = new d._SetContainsRequest();
      return k.setSetName(w), k.setElementsList(q), await new Promise((z, $) => {
        this.clientWrapper.setContains(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          var le;
          if (oe)
            if (oe.hasFound()) {
              const ue = oe.getFound();
              ((ue == null ? void 0 : ue.getContainsList()) === void 0 || (ue == null ? void 0 : ue.getContainsList().length) === 0) && z(new s.CacheSetContainsElements.Error(new s.UnknownError("SetContains responded with an empty list"))), z(new s.CacheSetContainsElements.Hit(j, (le = ue == null ? void 0 : ue.getContainsList()) !== null && le !== void 0 ? le : []));
            } else
              z(new s.CacheSetContainsElements.Miss());
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: re,
              errorResponseFactoryFn: (ue) => new s.CacheSetContainsElements.Error(ue),
              resolveFn: z,
              rejectFn: $
            });
        });
      });
    }
    async setRemoveElements(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheSetRemoveElements.Error(k));
      }
      return await this.sendSetRemoveElements(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q));
    }
    async sendSetRemoveElements(m, w, q) {
      const j = new d._SetDifferenceRequest._Subtrahend(), k = new d._SetDifferenceRequest._Subtrahend._Set();
      k.setElementsList(q), j.setSet(k);
      const z = new d._SetDifferenceRequest();
      return z.setSetName(w), z.setSubtrahend(j), await new Promise(($, re) => {
        this.clientWrapper.setDifference(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe) => {
          oe ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: oe,
            errorResponseFactoryFn: (le) => new s.CacheSetRemoveElements.Error(le),
            resolveFn: $,
            rejectFn: re
          }) : $(new s.CacheSetRemoveElements.Success());
        });
      });
    }
    async setSample(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w), (0, l.validateSetSampleLimit)(q);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheSetSample.Error(k));
      }
      return await this.sendSetSample(m, (0, g.convertToB64String)(w), q);
    }
    async sendSetSample(m, w, q) {
      const j = new d._SetSampleRequest();
      return j.setSetName(w), j.setLimit(q), await new Promise((k, z) => {
        this.clientWrapper.setSample(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          const oe = re == null ? void 0 : re.getFound();
          if (oe && oe.getElementsList()) {
            const le = oe.getElementsList();
            k(new s.CacheSetSample.Hit(this.convertArrayToUint8(le)));
          } else re != null && re.getMissing() ? k(new s.CacheSetSample.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (le) => new s.CacheSetSample.Error(le),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async setPop(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w), (0, l.validateSetPopCount)(q);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new ae.CacheSetPop.Error(k));
      }
      return await this.sendSetPop(m, (0, g.convertToB64String)(w), q);
    }
    async sendSetPop(m, w, q) {
      const j = new d._SetPopRequest();
      return j.setSetName(w), j.setCount(q), await new Promise((k, z) => {
        this.clientWrapper.setPop(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          const oe = re == null ? void 0 : re.getFound();
          if (oe && oe.getElementsList()) {
            const le = oe.getElementsList();
            k(new ae.CacheSetPop.Hit(this.convertArrayToUint8(le)));
          } else re != null && re.getMissing() ? k(new ae.CacheSetPop.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (le) => new ae.CacheSetPop.Error(le),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async setLength(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSetName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new ae.CacheSetLength.Error(k));
      }
      this.logger.trace("Issuing 'setLength' request");
      const q = await this.sendSetLength(m, (0, g.convertToB64String)(w));
      return this.logger.trace("'setLength' request result: %s", (0, l.truncateString)(q.toString())), q;
    }
    async sendSetLength(m, w) {
      const q = new d._SetLengthRequest();
      return q.setSetName(w), await new Promise((j, k) => {
        this.clientWrapper.setLength(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          var re;
          if ($ != null && $.getMissing())
            j(new ae.CacheSetLength.Miss());
          else if ($ != null && $.getFound()) {
            const oe = (re = $.getFound()) === null || re === void 0 ? void 0 : re.getLength();
            j(oe ? new ae.CacheSetLength.Hit(oe) : new ae.CacheSetLength.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (oe) => new ae.CacheSetLength.Error(oe),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async listConcatenateBack(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheListConcatenateBack.Error(oe));
      }
      this.logger.trace(`Issuing 'listConcatenateBack' request; listName: ${w}, values length: ${q.length}, ${k.toString()}, truncateFrontToSize: ${(z = j == null ? void 0 : j.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendListConcatenateBack(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q), k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl(), j);
      return this.logger.trace(`'listConcatenateBack' request result: ${$.toString()}`), $;
    }
    async sendListConcatenateBack(m, w, q, j, k, z) {
      const $ = new d._ListConcatenateBackRequest();
      return $.setListName(w), $.setValuesList(q), $.setTtlMilliseconds(j), $.setRefreshTtl(k), $.setTruncateFrontToSize(z || 0), await new Promise((re, oe) => {
        this.clientWrapper.listConcatenateBack($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? re(new s.CacheListConcatenateBack.Success(ue.getListLength())) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheListConcatenateBack.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async listConcatenateFront(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheListConcatenateFront.Error(oe));
      }
      this.logger.trace(`Issuing 'listConcatenateFront' request; listName: ${w}, values length: ${q.length}, ${k.toString()}, truncateBackToSize: ${(z = j == null ? void 0 : j.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendListConcatenateFront(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q), k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl(), j);
      return this.logger.trace(`'listConcatenateFront' request result: ${$.toString()}`), $;
    }
    async sendListConcatenateFront(m, w, q, j, k, z) {
      const $ = new d._ListConcatenateFrontRequest();
      return $.setListName(w), $.setValuesList(q), $.setTtlMilliseconds(j), $.setRefreshTtl(k), $.setTruncateBackToSize(z || 0), await new Promise((re, oe) => {
        this.clientWrapper.listConcatenateFront($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? re(new s.CacheListConcatenateFront.Success(ue.getListLength())) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheListConcatenateFront.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async listFetch(m, w, q, j) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w), (0, l.validateListSliceStartEnd)(q, j);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheListFetch.Error($));
      }
      this.logger.trace("Issuing 'listFetch' request; listName: %s, startIndex: %s, endIndex: %s", w, q != null ? q : "null", j != null ? j : "null");
      const k = await this.sendListFetch(m, (0, g.convertToB64String)(w), q, j);
      return this.logger.trace("'listFetch' request result: %s", k.toString()), k;
    }
    async sendListFetch(m, w, q, j) {
      const k = new d._ListFetchRequest();
      return k.setListName(w), q ? k.setInclusiveStart(q) : k.setUnboundedStart(new te._Unbounded()), j ? k.setExclusiveEnd(j) : k.setUnboundedEnd(new te._Unbounded()), await new Promise((z, $) => {
        this.clientWrapper.listFetch(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          if (oe != null && oe.getMissing())
            z(new s.CacheListFetch.Miss());
          else if (oe != null && oe.getFound()) {
            const le = oe == null ? void 0 : oe.getFound();
            if (le !== void 0) {
              const ue = le.getValuesList();
              z(new s.CacheListFetch.Hit(this.convertArrayToUint8(ue)));
            } else
              z(new s.CacheListFetch.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: re,
              errorResponseFactoryFn: (le) => new s.CacheListFetch.Error(le),
              resolveFn: z,
              rejectFn: $
            });
        });
      });
    }
    async listRetain(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w), (0, l.validateListSliceStartEnd)(q, j);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheListRetain.Error(oe));
      }
      this.logger.trace("Issuing 'listRetain' request; listName: %s, startIndex: %s, endIndex: %s, ttl: %s", w, q != null ? q : "null", j != null ? j : "null", (z = k.ttlSeconds.toString()) !== null && z !== void 0 ? z : "null");
      const $ = await this.sendListRetain(
        m,
        (0, g.convertToB64String)(w),
        // passing ttl info before start/end because it's guaranteed to be defined so doesn't need
        // to be nullable
        k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3,
        k.refreshTtl(),
        q,
        j
      );
      return this.logger.trace("'listRetain' request result: %s", $.toString()), $;
    }
    async sendListRetain(m, w, q, j, k, z) {
      const $ = new d._ListRetainRequest();
      return $.setListName(w), $.setTtlMilliseconds(q), $.setRefreshTtl(j), k ? $.setInclusiveStart(k) : $.setUnboundedStart(new te._Unbounded()), z ? $.setExclusiveEnd(z) : $.setUnboundedEnd(new te._Unbounded()), await new Promise((re, oe) => {
        this.clientWrapper.listRetain($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? re(new s.CacheListRetain.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheListRetain.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async listLength(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheListLength.Error(k));
      }
      this.logger.trace(`Issuing 'listLength' request; listName: ${w}`);
      const q = await this.sendListLength(m, (0, g.convertToB64String)(w));
      return this.logger.trace(`'listLength' request result: ${q.toString()}`), q;
    }
    async sendListLength(m, w) {
      const q = new d._ListLengthRequest();
      return q.setListName(w), await new Promise((j, k) => {
        this.clientWrapper.listLength(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          var re;
          if ($ != null && $.getMissing())
            j(new s.CacheListLength.Miss());
          else if ($ != null && $.getFound()) {
            const oe = (re = $.getFound()) === null || re === void 0 ? void 0 : re.getLength();
            j(oe ? new s.CacheListLength.Hit(oe) : new s.CacheListLength.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (oe) => new s.CacheListLength.Error(oe),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async listPopBack(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheListPopBack.Error(k));
      }
      this.logger.trace("Issuing 'listPopBack' request");
      const q = await this.sendListPopBack(m, (0, g.convertToB64String)(w));
      return this.logger.trace(`'listPopBack' request result: ${q.toString()}`), q;
    }
    async sendListPopBack(m, w) {
      const q = new d._ListPopBackRequest();
      return q.setListName(w), await new Promise((j, k) => {
        this.clientWrapper.listPopBack(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          var re;
          if ($ != null && $.getMissing())
            j(new s.CacheListPopBack.Miss());
          else if ($ != null && $.getFound()) {
            const oe = (re = $.getFound()) === null || re === void 0 ? void 0 : re.getBack();
            j(oe ? new s.CacheListPopBack.Hit(this.convertToUint8Array(oe)) : new s.CacheListPopBack.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (oe) => new s.CacheListPopBack.Error(oe),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async listPopFront(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheListPopFront.Error(k));
      }
      this.logger.trace("Issuing 'listPopFront' request");
      const q = await this.sendListPopFront(m, (0, g.convertToB64String)(w));
      return this.logger.trace(`'listPopFront' request result: ${q.toString()}`), q;
    }
    async sendListPopFront(m, w) {
      const q = new d._ListPopFrontRequest();
      return q.setListName(w), await new Promise((j, k) => {
        this.clientWrapper.listPopFront(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          var re;
          if ($ != null && $.getMissing())
            j(new s.CacheListPopFront.Miss());
          else if ($ != null && $.getFound()) {
            const oe = (re = $.getFound()) === null || re === void 0 ? void 0 : re.getFront();
            j(oe ? new s.CacheListPopFront.Hit(this.convertToUint8Array(oe)) : new s.CacheListPopFront.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (oe) => new s.CacheListPopFront.Error(oe),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async listPushBack(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheListPushBack.Error(oe));
      }
      this.logger.trace(`Issuing 'listPushBack' request; listName: ${w}, value length: ${q.length}, ${k.toString()}, truncateFrontToSize: ${(z = j == null ? void 0 : j.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendListPushBack(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl(), j);
      return this.logger.trace(`'listPushBack' request result: ${$.toString()}`), $;
    }
    async sendListPushBack(m, w, q, j, k, z) {
      const $ = new d._ListPushBackRequest();
      return $.setListName(w), $.setValue(q), $.setTtlMilliseconds(j), $.setRefreshTtl(k), $.setTruncateFrontToSize(z || 0), await new Promise((re, oe) => {
        this.clientWrapper.listPushBack($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? re(new s.CacheListPushBack.Success(ue.getListLength())) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheListPushBack.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async listPushFront(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheListPushFront.Error(oe));
      }
      this.logger.trace(`Issuing 'listPushFront' request; listName: ${w}, value length: ${q.length}, ${k.toString()}, truncateBackToSize: ${(z = j == null ? void 0 : j.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendListPushFront(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl(), j);
      return this.logger.trace(`'listPushFront' request result: ${$.toString()}`), $;
    }
    async sendListPushFront(m, w, q, j, k, z) {
      const $ = new d._ListPushFrontRequest();
      return $.setListName(w), $.setValue(q), $.setTtlMilliseconds(j), $.setRefreshTtl(k), $.setTruncateBackToSize(z || 0), await new Promise((re, oe) => {
        this.clientWrapper.listPushFront($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? re(new s.CacheListPushFront.Success(ue.getListLength())) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheListPushFront.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async listRemoveValue(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateListName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheListRemoveValue.Error(z));
      }
      this.logger.trace(`Issuing 'listRemoveValue' request; listName: ${w}, value length: ${q.length}`);
      const j = await this.sendListRemoveValue(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q));
      return this.logger.trace(`'listRemoveValue' request result: ${j.toString()}`), j;
    }
    async sendListRemoveValue(m, w, q) {
      const j = new d._ListRemoveRequest();
      return j.setListName(w), j.setAllElementsWithValue(q), await new Promise((k, z) => {
        this.clientWrapper.listRemove(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          re ? k(new s.CacheListRemoveValue.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new s.CacheListRemoveValue.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async dictionarySetField(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheDictionarySetField.Error(oe));
      }
      this.logger.trace(`Issuing 'dictionarySetField' request; field: ${q.toString()}, value length: ${j.length}, ttl: ${(z = k.ttlSeconds.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendDictionarySetField(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), (0, g.convertToB64String)(j), k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl());
      return this.logger.trace(`'dictionarySetField' request result: ${$.toString()}`), $;
    }
    async sendDictionarySetField(m, w, q, j, k, z) {
      const $ = new d._DictionarySetRequest();
      $.setDictionaryName(w);
      const re = new d._DictionaryFieldValuePair();
      return re.setField(q), re.setValue(j), $.setItemsList([re]), $.setTtlMilliseconds(k), $.setRefreshTtl(z), await new Promise((oe, le) => {
        this.clientWrapper.dictionarySet($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (ue, pe) => {
          pe ? oe(new s.CacheDictionarySetField.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: ue,
            errorResponseFactoryFn: (he) => new s.CacheDictionarySetField.Error(he),
            resolveFn: oe,
            rejectFn: le
          });
        });
      });
    }
    async dictionarySetFields(m, w, q, j = s.CollectionTtl.fromCacheTtl()) {
      var k;
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheDictionarySetFields.Error(oe));
      }
      this.logger.trace(`Issuing 'dictionarySetFields' request; elements: ${q.toString()}, ttl: ${(k = j.ttlSeconds.toString()) !== null && k !== void 0 ? k : "null"}`);
      const z = this.convertElements(q), $ = await this.sendDictionarySetFields(m, (0, g.convertToB64String)(w), z, j.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, j.refreshTtl());
      return this.logger.trace(`'dictionarySetFields' request result: ${$.toString()}`), $;
    }
    async sendDictionarySetFields(m, w, q, j, k) {
      const z = new d._DictionarySetRequest();
      return z.setDictionaryName(w), z.setItemsList(q), z.setTtlMilliseconds(j), z.setRefreshTtl(k), await new Promise(($, re) => {
        this.clientWrapper.dictionarySet(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          le ? $(new s.CacheDictionarySetFields.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: oe,
            errorResponseFactoryFn: (ue) => new s.CacheDictionarySetFields.Error(ue),
            resolveFn: $,
            rejectFn: re
          });
        });
      });
    }
    async dictionaryGetField(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheDictionaryGetField.Error(z, this.convertToUint8Array(q)));
      }
      this.logger.trace(`Issuing 'dictionaryGetField' request; field: ${q.toString()}`);
      const j = await this.sendDictionaryGetField(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q));
      return this.logger.trace(`'dictionaryGetField' request result: ${j.toString()}`), j;
    }
    async sendDictionaryGetField(m, w, q) {
      const j = new d._DictionaryGetRequest();
      return j.setDictionaryName(w), j.setFieldsList([q]), await new Promise((k, z) => {
        this.clientWrapper.dictionaryGet(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          if (re != null && re.getMissing())
            k(new s.CacheDictionaryGetField.Miss(this.convertToUint8Array(q)));
          else if (re != null && re.getFound()) {
            const oe = re.getFound();
            oe && oe.getItemsList().length === 0 ? k(new s.CacheDictionaryGetField.Error(new s.UnknownError("_DictionaryGetResponseResponse contained no data but was found"), this.convertToUint8Array(q))) : oe && oe.getItemsList()[0].getResult() === d.ECacheResult.MISS ? k(new s.CacheDictionaryGetField.Miss(this.convertToUint8Array(q))) : oe && k(new s.CacheDictionaryGetField.Hit(oe.getItemsList()[0].getCacheBody_asU8(), this.convertToUint8Array(q)));
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: $,
              errorResponseFactoryFn: (oe) => new s.CacheDictionaryGetField.Error(oe, this.convertToUint8Array(q)),
              resolveFn: k,
              rejectFn: z
            });
        });
      });
    }
    async dictionaryGetFields(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheDictionaryGetFields.Error(z));
      }
      this.logger.trace(`Issuing 'dictionaryGetFields' request; fields: ${q.toString()}`);
      const j = await this.sendDictionaryGetFields(m, (0, g.convertToB64String)(w), q);
      return this.logger.trace(`'dictionaryGetFields' request result: ${j.toString()}`), j;
    }
    async sendDictionaryGetFields(m, w, q) {
      const j = new d._DictionaryGetRequest();
      return j.setDictionaryName(w), j.setFieldsList(this.convertArrayToB64Strings(q)), await new Promise((k, z) => {
        this.clientWrapper.dictionaryGet(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          const oe = re == null ? void 0 : re.getFound();
          if (oe) {
            const le = oe.getItemsList().map((ue) => {
              const pe = this.convertECacheResult(ue.getResult());
              return new c._DictionaryGetResponsePart(pe, ue.getCacheBody_asU8());
            });
            k(new s.CacheDictionaryGetFields.Hit(le, this.convertArrayToUint8(q)));
          } else re != null && re.getMissing() ? k(new s.CacheDictionaryGetFields.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (le) => new s.CacheDictionaryGetFields.Error(le),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async dictionaryFetch(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheDictionaryFetch.Error(k));
      }
      this.logger.trace(`Issuing 'dictionaryFetch' request; dictionaryName: ${w}`);
      const q = await this.sendDictionaryFetch(m, (0, g.convertToB64String)(w));
      return this.logger.trace(`'dictionaryFetch' request result: ${q.toString()}`), q;
    }
    async sendDictionaryFetch(m, w) {
      const q = new d._DictionaryFetchRequest();
      return q.setDictionaryName(w), await new Promise((j, k) => {
        this.clientWrapper.dictionaryFetch(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          const re = $ == null ? void 0 : $.getFound();
          if (re && re.getItemsList()) {
            const oe = [];
            re.getItemsList().forEach((ue) => {
              const pe = new c._DictionaryFieldValuePair({
                field: ue.getField_asU8(),
                value: ue.getValue_asU8()
              });
              oe.push(pe);
            }), j(new s.CacheDictionaryFetch.Hit(oe));
          } else $ != null && $.getMissing() ? j(new s.CacheDictionaryFetch.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (oe) => new s.CacheDictionaryFetch.Error(oe),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async dictionaryIncrement(m, w, q, j = 1, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheDictionaryIncrement.Error(oe));
      }
      this.logger.trace(`Issuing 'dictionaryIncrement' request; field: ${q.toString()}, amount : ${j}, ttl: ${(z = k.ttlSeconds.toString()) !== null && z !== void 0 ? z : "null"}`);
      const $ = await this.sendDictionaryIncrement(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), j, k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl());
      return this.logger.trace(`'dictionaryIncrement' request result: ${$.toString()}`), $;
    }
    async sendDictionaryIncrement(m, w, q, j, k, z) {
      const $ = new d._DictionaryIncrementRequest();
      return $.setDictionaryName(w), $.setField(q), $.setAmount(j), $.setTtlMilliseconds(k), $.setRefreshTtl(z), await new Promise((re, oe) => {
        this.clientWrapper.dictionaryIncrement($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? ue.getValue() ? re(new s.CacheDictionaryIncrement.Success(ue.getValue())) : re(new s.CacheDictionaryIncrement.Success(0)) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheDictionaryIncrement.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async dictionaryRemoveField(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheDictionaryRemoveField.Error(z));
      }
      this.logger.trace(`Issuing 'dictionaryRemoveField' request; field: ${q.toString()}`);
      const j = await this.sendDictionaryRemoveField(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q));
      return this.logger.trace(`'dictionaryRemoveField' request result: ${j.toString()}`), j;
    }
    async sendDictionaryRemoveField(m, w, q) {
      const j = new d._DictionaryDeleteRequest();
      return j.setDictionaryName(w), j.setSome(new d._DictionaryDeleteRequest.Some().addFields(q)), await new Promise((k, z) => {
        this.clientWrapper.dictionaryDelete(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          re ? k(new s.CacheDictionaryRemoveField.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new s.CacheDictionaryRemoveField.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async dictionaryRemoveFields(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheDictionaryRemoveFields.Error(z));
      }
      this.logger.trace(`Issuing 'dictionaryRemoveFields' request; fields: ${q.toString()}`);
      const j = await this.sendDictionaryRemoveFields(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q));
      return this.logger.trace(`'dictionaryRemoveFields' request result: ${j.toString()}`), j;
    }
    async sendDictionaryRemoveFields(m, w, q) {
      const j = new d._DictionaryDeleteRequest();
      return j.setDictionaryName(w), j.setSome(new d._DictionaryDeleteRequest.Some().setFieldsList(q)), await new Promise((k, z) => {
        this.clientWrapper.dictionaryDelete(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          re ? k(new s.CacheDictionaryRemoveFields.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new s.CacheDictionaryRemoveFields.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async dictionaryLength(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateDictionaryName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheDictionaryLength.Error(k));
      }
      this.logger.trace(`Issuing 'dictionaryLength' request; dictionaryName: ${w}`);
      const q = await this.sendDictionaryLength(m, (0, g.convertToB64String)(w));
      return this.logger.trace(`'dictionaryLength' request result: ${q.toString()}`), q;
    }
    async sendDictionaryLength(m, w) {
      const q = new d._DictionaryLengthRequest();
      return q.setDictionaryName(w), await new Promise((j, k) => {
        this.clientWrapper.dictionaryLength(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          var re;
          if ($ != null && $.getMissing())
            j(new s.CacheDictionaryLength.Miss());
          else if ($ != null && $.getFound()) {
            const oe = (re = $.getFound()) === null || re === void 0 ? void 0 : re.getLength();
            j(oe ? new s.CacheDictionaryLength.Hit(oe) : new s.CacheDictionaryLength.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (oe) => new s.CacheDictionaryLength.Error(oe),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async sortedSetFetchByRank(m, w, q, j, k) {
      var z, $;
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w), (0, l.validateSortedSetRanks)(j, k);
      } catch (oe) {
        return this.cacheServiceErrorMapper.returnOrThrowError(oe, (le) => new s.CacheSortedSetFetch.Error(le));
      }
      this.logger.trace("Issuing 'sortedSetFetchByRank' request; startRank: %s, endRank : %s, order: %s", (z = j.toString()) !== null && z !== void 0 ? z : "null", ($ = k == null ? void 0 : k.toString()) !== null && $ !== void 0 ? $ : "null", q.toString());
      const re = await this.sendSortedSetFetchByRank(m, (0, g.convertToB64String)(w), q, j, k);
      return this.logger.trace("'sortedSetFetchByRank' request result: %s", re.toString()), re;
    }
    async sendSortedSetFetchByRank(m, w, q, j, k) {
      const z = new d._SortedSetFetchRequest._ByIndex();
      j ? z.setInclusiveStartIndex(j) : z.setUnboundedStart(new te._Unbounded()), k ? z.setExclusiveEndIndex(k) : z.setUnboundedEnd(new te._Unbounded());
      const $ = q === s.SortedSetOrder.Descending ? d._SortedSetFetchRequest.Order.DESCENDING : d._SortedSetFetchRequest.Order.ASCENDING, re = new d._SortedSetFetchRequest();
      return re.setSetName(w), re.setOrder($), re.setWithScores(!0), re.setByIndex(z), await new Promise((oe, le) => {
        this.clientWrapper.sortedSetFetch(re, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (ue, pe) => {
          var he, fe;
          if (pe && pe.getFound()) {
            const ye = (fe = (he = pe.getFound()) === null || he === void 0 ? void 0 : he.getValuesWithScores()) === null || fe === void 0 ? void 0 : fe.getElementsList();
            if (ye) {
              const Re = ye.map((be) => new c._SortedSetElement(this.convertToUint8Array(be.getValue()), be.getScore()));
              oe(new s.CacheSortedSetFetch.Hit(Re));
            } else
              oe(new s.CacheSortedSetFetch.Error(new s.UnknownError("Unknown sorted set fetch hit response type")));
          } else pe != null && pe.getMissing() ? oe(new s.CacheSortedSetFetch.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: ue,
            errorResponseFactoryFn: (ye) => new s.CacheSortedSetFetch.Error(ye),
            resolveFn: oe,
            rejectFn: le
          });
        });
      });
    }
    async sortedSetFetchByScore(m, w, q, j, k, z, $) {
      var re, oe, le, ue;
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w), (0, l.validateSortedSetScores)(j, k), z !== void 0 && (0, l.validateSortedSetOffset)(z), $ !== void 0 && (0, l.validateSortedSetCount)($);
      } catch (he) {
        return this.cacheServiceErrorMapper.returnOrThrowError(he, (fe) => new s.CacheSortedSetFetch.Error(fe));
      }
      this.logger.trace("Issuing 'sortedSetFetchByScore' request; minScore: %s, maxScore : %s, order: %s, offset: %s, count: %s", (re = j == null ? void 0 : j.toString()) !== null && re !== void 0 ? re : "null", (oe = k == null ? void 0 : k.toString()) !== null && oe !== void 0 ? oe : "null", q.toString(), (le = z == null ? void 0 : z.toString()) !== null && le !== void 0 ? le : "null", (ue = $ == null ? void 0 : $.toString()) !== null && ue !== void 0 ? ue : "null");
      const pe = await this.sendSortedSetFetchByScore(m, (0, g.convertToB64String)(w), q, j, k, z, $);
      return this.logger.trace("'sortedSetFetchByScore' request result: %s", pe.toString()), pe;
    }
    async sendSortedSetFetchByScore(m, w, q, j, k, z, $) {
      const re = new d._SortedSetFetchRequest._ByScore();
      j !== void 0 ? re.setMinScore(new d._SortedSetFetchRequest._ByScore._Score().setScore(j).setExclusive(!1)) : re.setUnboundedMin(new te._Unbounded()), k !== void 0 ? re.setMaxScore(new d._SortedSetFetchRequest._ByScore._Score().setScore(k).setExclusive(!1)) : re.setUnboundedMax(new te._Unbounded()), re.setOffset(z != null ? z : 0), re.setCount($ != null ? $ : -1);
      const oe = q === s.SortedSetOrder.Descending ? d._SortedSetFetchRequest.Order.DESCENDING : d._SortedSetFetchRequest.Order.ASCENDING, le = new d._SortedSetFetchRequest();
      return le.setSetName(w), le.setOrder(oe), le.setWithScores(!0), le.setByScore(re), await new Promise((ue, pe) => {
        this.clientWrapper.sortedSetFetch(le, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (he, fe) => {
          var ye, Re, be;
          if (fe)
            if (!((ye = fe == null ? void 0 : fe.getFound()) === null || ye === void 0) && ye.getValuesWithScores()) {
              const Me = (be = (Re = fe.getFound()) === null || Re === void 0 ? void 0 : Re.getValuesWithScores()) === null || be === void 0 ? void 0 : be.getElementsList();
              if (Me) {
                const ve = Me.map((we) => new c._SortedSetElement(this.convertToUint8Array(we.getValue()), we.getScore()));
                ue(new s.CacheSortedSetFetch.Hit(ve));
              } else
                ue(new s.CacheSortedSetFetch.Error(new s.UnknownError("Unknown sorted set fetch hit response type")));
            } else fe != null && fe.getMissing() ? ue(new s.CacheSortedSetFetch.Miss()) : ue(new s.CacheSortedSetFetch.Error(new s.UnknownError("Unknown sorted set fetch response type")));
          else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: he,
              errorResponseFactoryFn: (Me) => new s.CacheSortedSetFetch.Error(Me),
              resolveFn: ue,
              rejectFn: pe
            });
        });
      });
    }
    async sortedSetPutElement(m, w, q, j, k = s.CollectionTtl.fromCacheTtl()) {
      var z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSortedSetPutElement.Error(oe));
      }
      this.logger.trace("Issuing 'sortedSetPutElement' request; value: %s, score : %s, ttl: %s", (0, l.truncateString)(q.toString()), j, (z = k.ttlSeconds.toString()) !== null && z !== void 0 ? z : "null");
      const $ = await this.sendSortedSetPutElement(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), j, k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl());
      return this.logger.trace("'sortedSetPutElement' request result: %s", $.toString()), $;
    }
    async sendSortedSetPutElement(m, w, q, j, k, z) {
      const $ = new d._SortedSetPutRequest(), re = new d._SortedSetElement();
      return re.setValue(q), re.setScore(j), $.setSetName(w), $.setElementsList([re]), $.setTtlMilliseconds(k), $.setRefreshTtl(z), await new Promise((oe, le) => {
        this.clientWrapper.sortedSetPut($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (ue, pe) => {
          pe ? oe(new s.CacheSortedSetPutElement.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: ue,
            errorResponseFactoryFn: (he) => new s.CacheSortedSetPutElement.Error(he),
            resolveFn: oe,
            rejectFn: le
          });
        });
      });
    }
    async sortedSetPutElements(m, w, q, j = s.CollectionTtl.fromCacheTtl()) {
      var k;
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSortedSetPutElements.Error(oe));
      }
      this.logger.trace("Issuing 'sortedSetPutElements' request; elements: %s, ttl: %s", q.toString(), (k = j.ttlSeconds.toString()) !== null && k !== void 0 ? k : "null");
      const z = this.convertSortedSetMapOrRecord(q), $ = await this.sendSortedSetPutElements(m, (0, g.convertToB64String)(w), z, j.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, j.refreshTtl());
      return this.logger.trace("'sortedSetPutElements' request result: %s", $.toString()), $;
    }
    async sendSortedSetPutElements(m, w, q, j, k) {
      const z = new d._SortedSetPutRequest();
      return z.setSetName(w), z.setElementsList(q), z.setTtlMilliseconds(j), z.setRefreshTtl(k), await new Promise(($, re) => {
        this.clientWrapper.sortedSetPut(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          le ? $(new s.CacheSortedSetPutElements.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: oe,
            errorResponseFactoryFn: (ue) => new s.CacheSortedSetPutElements.Error(ue),
            resolveFn: $,
            rejectFn: re
          });
        });
      });
    }
    async sortedSetGetScore(m, w, q) {
      const j = await this.sortedSetGetScores(m, w, [
        q
      ]);
      return j instanceof s.CacheSortedSetGetScores.Hit ? j.responses()[0] : j instanceof s.CacheSortedSetGetScores.Miss ? new s.CacheSortedSetGetScore.Miss(this.convertToUint8Array(q)) : j instanceof s.CacheSortedSetGetScores.Error ? this.cacheServiceErrorMapper.returnOrThrowError(j.innerException(), (k) => new s.CacheSortedSetGetScore.Error(k, this.convertToUint8Array(q))) : this.cacheServiceErrorMapper.returnOrThrowError(new s.UnknownError("Unknown response type"), (k) => new s.CacheSortedSetGetScore.Error(k, this.convertToUint8Array(q)));
    }
    async sortedSetGetScores(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheSortedSetGetScores.Error(z));
      }
      this.logger.trace("Issuing 'sortedSetGetScores' request; values: %s", (0, l.truncateString)(q.toString()));
      const j = await this.sendSortedSetGetScores(m, (0, g.convertToB64String)(w), q.map((k) => (0, g.convertToB64String)(k)));
      return this.logger.trace("'sortedSetGetScores' request result: %s", (0, l.truncateString)(j.toString())), j;
    }
    async sendSortedSetGetScores(m, w, q) {
      const j = new d._SortedSetGetScoreRequest();
      return j.setSetName(w), j.setValuesList(q), await new Promise((k, z) => {
        this.clientWrapper.sortedSetGetScore(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          var oe;
          if (re != null && re.getMissing())
            k(new s.CacheSortedSetGetScores.Miss());
          else if (re != null && re.getFound()) {
            const le = (oe = re.getFound()) === null || oe === void 0 ? void 0 : oe.getElementsList().map((ue) => {
              const pe = this.convertECacheResult(ue.getResult());
              return new c._SortedSetGetScoreResponsePart(pe, ue.getScore());
            });
            k(le ? new s.CacheSortedSetGetScores.Hit(le, this.convertArrayToUint8(q.map((ue) => atob(ue)))) : new s.CacheSortedSetGetScores.Error(new s.UnknownError("Unknown sorted set fetch hit response type")));
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: $,
              errorResponseFactoryFn: (le) => new s.CacheSortedSetGetScores.Error(le),
              resolveFn: k,
              rejectFn: z
            });
        });
      });
    }
    async sortedSetGetRank(m, w, q, j) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheSortedSetGetRank.Error($));
      }
      this.logger.trace("Issuing 'sortedSetGetRank' request; value: %s", (0, l.truncateString)(q.toString()));
      const k = await this.sendSortedSetGetRank(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), j);
      return this.logger.trace("'sortedSetGetRank' request result: %s", (0, l.truncateString)(k.toString())), k;
    }
    async sendSortedSetGetRank(m, w, q, j) {
      const k = j === s.SortedSetOrder.Descending ? d._SortedSetGetRankRequest.Order.DESCENDING : d._SortedSetGetRankRequest.Order.ASCENDING, z = new d._SortedSetGetRankRequest();
      return z.setSetName(w), z.setValue(q), z.setOrder(k), await new Promise(($, re) => {
        this.clientWrapper.sortedSetGetRank(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (oe, le) => {
          var ue, pe, he;
          if (le != null && le.getMissing() || ((ue = le == null ? void 0 : le.getElementRank()) === null || ue === void 0 ? void 0 : ue.getResult()) === d.ECacheResult.MISS)
            $(new s.CacheSortedSetGetRank.Miss());
          else if (((pe = le == null ? void 0 : le.getElementRank()) === null || pe === void 0 ? void 0 : pe.getResult()) === d.ECacheResult.HIT) {
            const fe = (he = le == null ? void 0 : le.getElementRank()) === null || he === void 0 ? void 0 : he.getRank();
            $(fe !== void 0 ? new s.CacheSortedSetGetRank.Hit(fe) : new s.CacheSortedSetGetRank.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: oe,
              errorResponseFactoryFn: (fe) => new s.CacheSortedSetGetRank.Error(fe),
              resolveFn: $,
              rejectFn: re
            });
        });
      });
    }
    async sortedSetIncrementScore(m, w, q, j = 1, k = s.CollectionTtl.fromCacheTtl()) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch ($) {
        return this.cacheServiceErrorMapper.returnOrThrowError($, (re) => new s.CacheSortedSetIncrementScore.Error(re));
      }
      this.logger.trace("Issuing 'sortedSetIncrementScore' request; value: %s", (0, l.truncateString)(q.toString()));
      const z = await this.sendSortedSetIncrementScore(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q), j, k.ttlMilliseconds() || this.defaultTtlSeconds * 1e3, k.refreshTtl());
      return this.logger.trace("'sortedSetIncrementScore' request result: %s", (0, l.truncateString)(z.toString())), z;
    }
    async sendSortedSetIncrementScore(m, w, q, j, k, z) {
      const $ = new d._SortedSetIncrementRequest();
      return $.setSetName(w), $.setValue(q), $.setAmount(j), $.setTtlMilliseconds(k), $.setRefreshTtl(z), await new Promise((re, oe) => {
        this.clientWrapper.sortedSetIncrement($, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (le, ue) => {
          ue ? ue.getScore() ? re(new s.CacheSortedSetIncrementScore.Success(ue.getScore())) : re(new s.CacheSortedSetIncrementScore.Success(0)) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: le,
            errorResponseFactoryFn: (pe) => new s.CacheSortedSetIncrementScore.Error(pe),
            resolveFn: re,
            rejectFn: oe
          });
        });
      });
    }
    async sortedSetRemoveElement(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheSortedSetRemoveElement.Error(z));
      }
      this.logger.trace("Issuing 'sortedSetRemoveElement' request");
      const j = await this.sendSortedSetRemoveElement(m, (0, g.convertToB64String)(w), (0, g.convertToB64String)(q));
      return this.logger.trace("'sortedSetRemoveElement' request result: %s", (0, l.truncateString)(j.toString())), j;
    }
    async sendSortedSetRemoveElement(m, w, q) {
      const j = new d._SortedSetRemoveRequest();
      return j.setSetName(w), j.setSome(new d._SortedSetRemoveRequest._Some().setValuesList([q])), await new Promise((k, z) => {
        this.clientWrapper.sortedSetRemove(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($) => {
          $ ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (re) => new s.CacheSortedSetRemoveElement.Error(re),
            resolveFn: k,
            rejectFn: z
          }) : k(new s.CacheSortedSetRemoveElement.Success());
        });
      });
    }
    async sortedSetRemoveElements(m, w, q) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new s.CacheSortedSetRemoveElements.Error(z));
      }
      this.logger.trace("Issuing 'sortedSetRemoveElements' request");
      const j = await this.sendSortedSetRemoveElements(m, (0, g.convertToB64String)(w), this.convertArrayToB64Strings(q));
      return this.logger.trace("'sortedSetRemoveElements' request result: %s", (0, l.truncateString)(j.toString())), j;
    }
    async sendSortedSetRemoveElements(m, w, q) {
      const j = new d._SortedSetRemoveRequest();
      return j.setSetName(w), j.setSome(new d._SortedSetRemoveRequest._Some().setValuesList(q)), await new Promise((k, z) => {
        this.clientWrapper.sortedSetRemove(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($) => {
          $ ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (re) => new s.CacheSortedSetRemoveElements.Error(re),
            resolveFn: k,
            rejectFn: z
          }) : k(new s.CacheSortedSetRemoveElements.Success());
        });
      });
    }
    async sortedSetLength(m, w) {
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheSortedSetLength.Error(k));
      }
      this.logger.trace("Issuing 'sortedSetLength' request");
      const q = await this.sendSortedSetLength(m, (0, g.convertToB64String)(w));
      return this.logger.trace("'sortedSetLength' request result: %s", (0, l.truncateString)(q.toString())), q;
    }
    async sendSortedSetLength(m, w) {
      const q = new d._SortedSetLengthRequest();
      return q.setSetName(w), await new Promise((j, k) => {
        this.clientWrapper.sortedSetLength(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          var re;
          if ($ != null && $.getMissing())
            j(new s.CacheSortedSetLength.Miss());
          else if ($ != null && $.getFound()) {
            const oe = (re = $.getFound()) === null || re === void 0 ? void 0 : re.getLength();
            j(oe ? new s.CacheSortedSetLength.Hit(oe) : new s.CacheSortedSetLength.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: z,
              errorResponseFactoryFn: (oe) => new s.CacheSortedSetLength.Error(oe),
              resolveFn: j,
              rejectFn: k
            });
        });
      });
    }
    async sortedSetLengthByScore(m, w, q, j) {
      var k, z;
      try {
        (0, l.validateCacheName)(m), (0, l.validateSortedSetName)(w), (0, l.validateSortedSetScores)(q, j);
      } catch (re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(re, (oe) => new s.CacheSortedSetLengthByScore.Error(oe));
      }
      this.logger.trace("Issuing 'sortedSetLengthByScore' request; minScore: %s, maxScore: %s", (k = q == null ? void 0 : q.toString()) !== null && k !== void 0 ? k : "null", (z = j == null ? void 0 : j.toString()) !== null && z !== void 0 ? z : "null");
      const $ = await this.sendSortedSetLengthByScore(m, (0, g.convertToB64String)(w), q, j);
      return this.logger.trace("'sortedSetLengthByScore' request result: %s", (0, l.truncateString)($.toString())), $;
    }
    async sendSortedSetLengthByScore(m, w, q, j) {
      const k = new d._SortedSetLengthByScoreRequest();
      return k.setSetName(w), q === void 0 ? k.setUnboundedMin(new te._Unbounded()) : k.setInclusiveMin(q), j === void 0 ? k.setUnboundedMax(new te._Unbounded()) : k.setInclusiveMax(j), await new Promise((z, $) => {
        this.clientWrapper.sortedSetLengthByScore(k, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (re, oe) => {
          var le;
          if (oe != null && oe.getMissing())
            z(new s.CacheSortedSetLengthByScore.Miss());
          else if (oe != null && oe.getFound()) {
            const ue = (le = oe.getFound()) === null || le === void 0 ? void 0 : le.getLength();
            z(ue ? new s.CacheSortedSetLengthByScore.Hit(ue) : new s.CacheSortedSetLengthByScore.Miss());
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: re,
              errorResponseFactoryFn: (ue) => new s.CacheSortedSetLengthByScore.Error(ue),
              resolveFn: z,
              rejectFn: $
            });
        });
      });
    }
    async itemGetType(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.CacheItemGetType.Error(j));
      }
      return await this.sendItemGetType(m, (0, g.convertToB64String)(w));
    }
    async sendItemGetType(m, w) {
      const q = new d._ItemGetTypeRequest();
      return q.setCacheKey(w), await new Promise((j, k) => {
        this.clientWrapper.itemGetType(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          const re = $.getFound();
          if (re) {
            const oe = re.getItemType();
            j(new s.CacheItemGetType.Hit(this.convertItemTypeResult(oe)));
          } else $ != null && $.getMissing() ? j(new s.CacheItemGetType.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (oe) => new s.CacheItemGetType.Error(oe),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async itemGetTtl(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.CacheItemGetTtl.Error(j));
      }
      return await this.sendItemGetTtl(m, (0, g.convertToB64String)(w));
    }
    async sendItemGetTtl(m, w) {
      const q = new d._ItemGetTtlRequest();
      return q.setCacheKey(w), await new Promise((j, k) => {
        this.clientWrapper.itemGetTtl(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          const re = $.getFound();
          re ? j(new s.CacheItemGetTtl.Hit(re.getRemainingTtlMillis())) : $ != null && $.getMissing() ? j(new s.CacheItemGetTtl.Miss()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (oe) => new s.CacheItemGetTtl.Error(oe),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async keyExists(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheKeyExists.Error(k));
      }
      this.logger.trace("Issuing 'keyExists' request");
      const q = await this.sendKeyExists(m, (0, g.convertToB64String)(w));
      return this.logger.trace("'keyExists' request result: %s", (0, l.truncateString)(q.toString())), q;
    }
    async sendKeyExists(m, w) {
      const q = new d._KeysExistRequest();
      return q.setCacheKeysList([w]), await new Promise((j, k) => {
        this.clientWrapper.keysExist(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          $ ? j(new s.CacheKeyExists.Success($.getExistsList())) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (re) => new s.CacheKeyExists.Error(re),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async keysExist(m, w) {
      try {
        (0, l.validateCacheName)(m);
      } catch (j) {
        return this.cacheServiceErrorMapper.returnOrThrowError(j, (k) => new s.CacheKeysExist.Error(k));
      }
      this.logger.trace("Issuing 'keysExist' request");
      const q = await this.sendKeysExist(m, w);
      return this.logger.trace("'keysExist' request result: %s", (0, l.truncateString)(q.toString())), q;
    }
    async sendKeysExist(m, w) {
      const q = new d._KeysExistRequest();
      return q.setCacheKeysList(this.convertArrayToB64Strings(w)), await new Promise((j, k) => {
        this.clientWrapper.keysExist(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, (z, $) => {
          $ ? j(new s.CacheKeysExist.Success(this.convertArrayToUint8(w), $.getExistsList())) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: z,
            errorResponseFactoryFn: (re) => new s.CacheKeysExist.Error(re),
            resolveFn: j,
            rejectFn: k
          });
        });
      });
    }
    async updateTtl(m, w, q) {
      var j;
      try {
        (0, l.validateCacheName)(m), (0, l.validateValidForSeconds)(q);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheUpdateTtl.Error($));
      }
      this.logger.trace("Issuing 'updateTtl' request; ttlMilliseconds: %s", (j = q == null ? void 0 : q.toString()) !== null && j !== void 0 ? j : "null");
      const k = await this.sendUpdateTtl(m, (0, g.convertToB64String)(w), q);
      return this.logger.trace("'updateTtl' request result: %s", (0, l.truncateString)(k.toString())), k;
    }
    async sendUpdateTtl(m, w, q) {
      const j = new d._UpdateTtlRequest();
      return j.setCacheKey(w), j.setOverwriteToMilliseconds(q), await new Promise((k, z) => {
        this.clientWrapper.updateTtl(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          re != null && re.getMissing() ? k(new s.CacheUpdateTtl.Miss()) : re != null && re.getSet() ? k(new s.CacheUpdateTtl.Set()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new s.CacheUpdateTtl.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async increaseTtl(m, w, q) {
      var j;
      try {
        (0, l.validateCacheName)(m), (0, l.validateValidForSeconds)(q);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheIncreaseTtl.Error($));
      }
      this.logger.trace("Issuing 'increaseTtl' request; ttlMilliseconds: %s", (j = q == null ? void 0 : q.toString()) !== null && j !== void 0 ? j : "null");
      const k = await this.sendIncreaseTtl(m, (0, g.convertToB64String)(w), q);
      return this.logger.trace("'increaseTtl' request result: %s", (0, l.truncateString)(k.toString())), k;
    }
    async sendIncreaseTtl(m, w, q) {
      const j = new d._UpdateTtlRequest();
      return j.setCacheKey(w), j.setIncreaseToMilliseconds(q), await new Promise((k, z) => {
        this.clientWrapper.updateTtl(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          re != null && re.getMissing() ? k(new s.CacheIncreaseTtl.Miss()) : re != null && re.getNotSet() ? k(new s.CacheIncreaseTtl.NotSet()) : re != null && re.getSet() ? k(new s.CacheIncreaseTtl.Set()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new s.CacheIncreaseTtl.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    async decreaseTtl(m, w, q) {
      var j;
      try {
        (0, l.validateCacheName)(m), (0, l.validateValidForSeconds)(q);
      } catch (z) {
        return this.cacheServiceErrorMapper.returnOrThrowError(z, ($) => new s.CacheDecreaseTtl.Error($));
      }
      this.logger.trace("Issuing 'decreaseTtl' request; ttlMilliseconds: %s", (j = q == null ? void 0 : q.toString()) !== null && j !== void 0 ? j : "null");
      const k = await this.sendDecreaseTtl(m, (0, g.convertToB64String)(w), q);
      return this.logger.trace("'decreaseTtl' request result: %s", (0, l.truncateString)(k.toString())), k;
    }
    async sendDecreaseTtl(m, w, q) {
      const j = new d._UpdateTtlRequest();
      return j.setCacheKey(w), j.setDecreaseToMilliseconds(q), await new Promise((k, z) => {
        this.clientWrapper.updateTtl(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, g.createCallMetadata)(m, this.deadlineMillis)
        }, ($, re) => {
          re != null && re.getMissing() ? k(new s.CacheDecreaseTtl.Miss()) : re != null && re.getNotSet() ? k(new s.CacheDecreaseTtl.NotSet()) : re != null && re.getSet() ? k(new s.CacheDecreaseTtl.Set()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new s.CacheDecreaseTtl.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    convertSecondsToMilliseconds(m) {
      return m * 1e3;
    }
    convertArrayToB64Strings(m) {
      return m.map((w) => (0, g.convertToB64String)(w));
    }
    convertToUint8Array(m) {
      return typeof m == "string" ? this.textEncoder.encode(m) : m;
    }
    convertArrayToUint8(m) {
      return m.map((w) => this.convertToUint8Array(w));
    }
    convertElements(m) {
      return m instanceof Array ? this.convertElements(new Map(m)) : m instanceof Map ? [...m.entries()].map((w) => new d._DictionaryFieldValuePair().setField((0, g.convertToB64String)(w[0])).setValue((0, g.convertToB64String)(w[1]))) : Object.entries(m).map((w) => new d._DictionaryFieldValuePair().setField((0, g.convertToB64String)(w[0])).setValue((0, g.convertToB64String)(w[1])));
    }
    convertSortedSetMapOrRecord(m) {
      return m instanceof Array ? this.convertSortedSetMapOrRecord(new Map(m)) : m instanceof Map ? [...m.entries()].map((w) => new d._SortedSetElement().setValue((0, g.convertToB64String)(w[0])).setScore(w[1])) : Object.entries(m).map((w) => new d._SortedSetElement().setValue((0, g.convertToB64String)(w[0])).setScore(w[1]));
    }
    convertSetBatchElements(m, w) {
      return m instanceof Array ? m.map((q) => {
        var j;
        return [
          (0, g.convertToB64String)(q.key),
          (0, g.convertToB64String)(q.value),
          (j = q.ttl) !== null && j !== void 0 ? j : w
        ];
      }) : m instanceof Map ? [...m.entries()].map((q) => [
        (0, g.convertToB64String)(q[0]),
        (0, g.convertToB64String)(q[1]),
        w
      ]) : Object.entries(m).map((q) => [
        (0, g.convertToB64String)(q[0]),
        (0, g.convertToB64String)(q[1]),
        w
      ]);
    }
    convertECacheResult(m) {
      switch (m) {
        case d.ECacheResult.HIT:
          return c._ECacheResult.Hit;
        case d.ECacheResult.INVALID:
          return c._ECacheResult.Invalid;
        case d.ECacheResult.MISS:
          return c._ECacheResult.Miss;
        case d.ECacheResult.OK:
          return c._ECacheResult.Ok;
      }
    }
    convertItemTypeResult(m) {
      switch (m) {
        case d._ItemGetTypeResponse.ItemType.SCALAR:
          return s.ItemType.SCALAR;
        case d._ItemGetTypeResponse.ItemType.LIST:
          return s.ItemType.LIST;
        case d._ItemGetTypeResponse.ItemType.DICTIONARY:
          return s.ItemType.DICTIONARY;
        case d._ItemGetTypeResponse.ItemType.SET:
          return s.ItemType.SET;
        case d._ItemGetTypeResponse.ItemType.SORTED_SET:
          return s.ItemType.SORTED_SET;
      }
    }
  }
  return cacheDataClient.CacheDataClient = ie, cacheDataClient;
}
var pingClient = {};
Object.defineProperty(pingClient, "__esModule", { value: !0 });
pingClient.PingClient = void 0;
const generated_types_webtext_1 = dist, cacheping_pb_1 = cacheping_pb$1, client_metadata_provider_1 = clientMetadataProvider;
class PingClient {
  /**
   * @param {PingClientProps} props
   */
  constructor(s) {
    this.logger = s.configuration.getLoggerFactory().getLogger(this), this.clientMetadataProvider = new client_metadata_provider_1.ClientMetadataProvider({
      clientType: "ping"
    }), this.clientWrapper = new generated_types_webtext_1.ping.PingClient(s.endpoint, null, {});
  }
  async ping() {
    this.logger.debug("pinging...");
    const s = new cacheping_pb_1._PingRequest();
    await this.clientWrapper.ping(s, this.clientMetadataProvider.createClientMetadata());
  }
}
pingClient.PingClient = PingClient;
var clients = {}, cache = {}, AbstractCacheClient$1 = {}, momentoCache = {};
Object.defineProperty(momentoCache, "__esModule", { value: !0 });
momentoCache.MomentoCache = void 0;
class MomentoCache {
  constructor(s, h) {
    this.cacheClient = s, this.cacheName = h;
  }
  get(s) {
    return this.cacheClient.get(this.cacheName, s);
  }
  set(s, h, c) {
    return this.cacheClient.set(this.cacheName, s, h, c);
  }
  delete(s) {
    return this.cacheClient.delete(this.cacheName, s);
  }
  increment(s, h, c) {
    return this.cacheClient.increment(this.cacheName, s, h, c);
  }
  setIfNotExists(s, h, c) {
    return this.cacheClient.setIfNotExists(this.cacheName, s, h, c);
  }
  setIfAbsent(s, h, c) {
    return this.cacheClient.setIfAbsent(this.cacheName, s, h, c);
  }
  setIfPresent(s, h, c) {
    return this.cacheClient.setIfPresent(this.cacheName, s, h, c);
  }
  setIfEqual(s, h, c, d) {
    return this.cacheClient.setIfEqual(this.cacheName, s, h, c, d);
  }
  setIfNotEqual(s, h, c, d) {
    return this.cacheClient.setIfNotEqual(this.cacheName, s, h, c, d);
  }
  setIfPresentAndNotEqual(s, h, c, d) {
    return this.cacheClient.setIfPresentAndNotEqual(this.cacheName, s, h, c, d);
  }
  setIfAbsentOrEqual(s, h, c, d) {
    return this.cacheClient.setIfAbsentOrEqual(this.cacheName, s, h, c, d);
  }
  getBatch(s) {
    return this.cacheClient.getBatch(this.cacheName, s);
  }
  setBatch(s, h) {
    return this.cacheClient.setBatch(this.cacheName, s, h);
  }
  setFetch(s) {
    return this.cacheClient.setFetch(this.cacheName, s);
  }
  setAddElement(s, h, c) {
    return this.cacheClient.setAddElement(this.cacheName, s, h, c);
  }
  setAddElements(s, h, c) {
    return this.cacheClient.setAddElements(this.cacheName, s, h, c);
  }
  setContainsElement(s, h) {
    return this.cacheClient.setContainsElement(this.cacheName, s, h);
  }
  setContainsElements(s, h) {
    return this.cacheClient.setContainsElements(this.cacheName, s, h);
  }
  setRemoveElement(s, h) {
    return this.cacheClient.setRemoveElement(this.cacheName, s, h);
  }
  setRemoveElements(s, h) {
    return this.cacheClient.setRemoveElements(this.cacheName, s, h);
  }
  setSample(s, h) {
    return this.cacheClient.setSample(this.cacheName, s, h);
  }
  setPop(s, h) {
    return this.cacheClient.setPop(this.cacheName, s, h);
  }
  setLength(s) {
    return this.cacheClient.setLength(this.cacheName, s);
  }
  listFetch(s, h) {
    return this.cacheClient.listFetch(this.cacheName, s, h);
  }
  listLength(s) {
    return this.cacheClient.listLength(this.cacheName, s);
  }
  listPushFront(s, h, c) {
    return this.cacheClient.listPushFront(this.cacheName, s, h, c);
  }
  listPushBack(s, h, c) {
    return this.cacheClient.listPushBack(this.cacheName, s, h, c);
  }
  listConcatenateBack(s, h, c) {
    return this.cacheClient.listConcatenateBack(this.cacheName, s, h, c);
  }
  listConcatenateFront(s, h, c) {
    return this.cacheClient.listConcatenateFront(this.cacheName, s, h, c);
  }
  listPopBack(s) {
    return this.cacheClient.listPopBack(this.cacheName, s);
  }
  listPopFront(s) {
    return this.cacheClient.listPopFront(this.cacheName, s);
  }
  listRemoveValue(s, h) {
    return this.cacheClient.listRemoveValue(this.cacheName, s, h);
  }
  listRetain(s, h) {
    return this.cacheClient.listRetain(this.cacheName, s, h);
  }
  dictionarySetField(s, h, c, d) {
    return this.cacheClient.dictionarySetField(this.cacheName, s, h, c, d);
  }
  dictionarySetFields(s, h, c) {
    return this.cacheClient.dictionarySetFields(this.cacheName, s, h, c);
  }
  dictionaryGetField(s, h) {
    return this.cacheClient.dictionaryGetField(this.cacheName, s, h);
  }
  dictionaryGetFields(s, h) {
    return this.cacheClient.dictionaryGetFields(this.cacheName, s, h);
  }
  dictionaryFetch(s) {
    return this.cacheClient.dictionaryFetch(this.cacheName, s);
  }
  dictionaryIncrement(s, h, c, d) {
    return this.cacheClient.dictionaryIncrement(this.cacheName, s, h, c, d);
  }
  dictionaryRemoveField(s, h) {
    return this.cacheClient.dictionaryRemoveField(this.cacheName, s, h);
  }
  dictionaryRemoveFields(s, h) {
    return this.cacheClient.dictionaryRemoveFields(this.cacheName, s, h);
  }
  dictionaryLength(s) {
    return this.cacheClient.dictionaryLength(this.cacheName, s);
  }
  sortedSetFetchByRank(s, h) {
    return this.cacheClient.sortedSetFetchByRank(this.cacheName, s, h);
  }
  sortedSetFetchByScore(s, h) {
    return this.cacheClient.sortedSetFetchByScore(this.cacheName, s, h);
  }
  sortedSetPutElement(s, h, c, d) {
    return this.cacheClient.sortedSetPutElement(this.cacheName, s, h, c, d);
  }
  sortedSetPutElements(s, h, c) {
    return this.cacheClient.sortedSetPutElements(this.cacheName, s, h, c);
  }
  sortedSetGetRank(s, h) {
    return this.cacheClient.sortedSetGetRank(this.cacheName, s, h);
  }
  sortedSetGetScore(s, h) {
    return this.cacheClient.sortedSetGetScore(this.cacheName, s, h);
  }
  sortedSetGetScores(s, h) {
    return this.cacheClient.sortedSetGetScores(this.cacheName, s, h);
  }
  sortedSetIncrementScore(s, h, c, d) {
    return this.cacheClient.sortedSetIncrementScore(this.cacheName, s, h, c, d);
  }
  sortedSetRemoveElement(s, h) {
    return this.cacheClient.sortedSetRemoveElement(this.cacheName, s, h);
  }
  sortedSetRemoveElements(s, h) {
    return this.cacheClient.sortedSetRemoveElements(this.cacheName, s, h);
  }
  sortedSetLength(s) {
    return this.cacheClient.sortedSetLength(this.cacheName, s);
  }
  sortedSetLengthByScore(s, h) {
    return this.cacheClient.sortedSetLengthByScore(this.cacheName, s, h);
  }
  itemGetType(s) {
    return this.cacheClient.itemGetType(this.cacheName, s);
  }
  itemGetTtl(s) {
    return this.cacheClient.itemGetTtl(this.cacheName, s);
  }
  keyExists(s) {
    return this.cacheClient.keyExists(this.cacheName, s);
  }
  keysExist(s) {
    return this.cacheClient.keysExist(this.cacheName, s);
  }
  updateTtl(s, h) {
    return this.cacheClient.updateTtl(this.cacheName, s, h);
  }
  increaseTtl(s, h) {
    return this.cacheClient.increaseTtl(this.cacheName, s, h);
  }
  decreaseTtl(s, h) {
    return this.cacheClient.decreaseTtl(this.cacheName, s, h);
  }
  close() {
    this.cacheClient.close();
  }
}
momentoCache.MomentoCache = MomentoCache;
Object.defineProperty(AbstractCacheClient$1, "__esModule", { value: !0 });
AbstractCacheClient$1.AbstractCacheClient = void 0;
const index_1$2 = requireSrc$1(), momento_cache_1 = momentoCache;
class AbstractCacheClient {
  constructor(s, h, c) {
    this.controlClient = s, this.dataClients = h, this.pingClient = c, this.nextDataClientIndex = 0;
  }
  cache(s) {
    return new momento_cache_1.MomentoCache(this, s);
  }
  /**
   * Ping the service to verify it is up and running
   */
  async ping() {
    var s;
    return await ((s = this.pingClient) === null || s === void 0 ? void 0 : s.ping());
  }
  /**
   * Creates a cache if it does not exist.
   *
   * @param {string} cacheName - The cache to be created.
   * @returns {Promise<CreateCache.Response>} -
   * {@link CreateCache.Success} on success.
   * {@link CreateCache.AlreadyExists} if the cache already exists.
   * {@link CreateCache.Error} on failure.
   */
  async createCache(s) {
    return await this.controlClient.createCache(s);
  }
  /**
   * Deletes a cache and all items stored in it.
   *
   * @param {string} cacheName - The cache to delete.
   * @returns {Promise<DeleteCache.Response>} -
   * {@link DeleteCache.Success} on success.
   * {@link DeleteCache.Error} on failure.
   */
  async deleteCache(s) {
    return await this.controlClient.deleteCache(s);
  }
  /**
   * Lists all caches.
   *
   * @returns {Promise<ListCaches.Response>} -
   * {@link ListCaches.Success} containing the list on success.
   * {@link ListCaches.Error} on failure.
   */
  async listCaches() {
    return await this.controlClient.listCaches();
  }
  /**
   * Gets the value stored for the given key.
   *
   * @param {string} cacheName - The cache to perform the lookup in.
   * @param {string | Uint8Array} key - The key to look up.
   * @param {GetOptions} [options]
   * @param {decompress} [options.decompress=false] - Whether to decompress the value. Overrides the client-wide
   * automatic decompression setting.
   * @returns {Promise<CacheGet.Response>} -
   * {@link CacheGet.Hit} containing the value if one is found.
   * {@link CacheGet.Miss} if the key does not exist.
   * {@link CacheGet.Error} on failure.
   */
  async get(s, h, c) {
    return await this.getNextDataClient().get(s, h, c);
  }
  /**
   * Associates the given key with the given value. If a value for the key is
   * already present it is replaced with the new value.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} value - The value to be stored.
   * @param {SetOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @param {boolean} [options.compress=false] - Whether to compress the value. Defaults to false.
   * @returns {Promise<CacheSet.Response>} -
   * {@link CacheSet.Success} on success.
   * {@link CacheSet.Error} on failure.
   */
  async set(s, h, c, d) {
    if (typeof d == "number")
      throw new index_1$2.InvalidArgumentError("Options must be an object with a ttl property.");
    return await this.getNextDataClient().set(s, h, c, d);
  }
  /**
   * Removes the given key from the cache. The key can represent a single value
   * or a collection.
   *
   * @param {string} cacheName - The cache to delete from.
   * @param {string | Uint8Array} key - The key to delete.
   * @returns {Promise<CacheDelete.Response>} -
   * {@link CacheDelete.Success} on success.
   * {@link CacheDelete.Error} on failure.
   */
  async delete(s, h) {
    return await this.getNextDataClient().delete(s, h);
  }
  /**
   * Gets the value stored for the given keys.
   *
   * @param {string} cacheName - The cache to perform the lookup in.
   * @param {string[] | Uint8Array[]} keys - The list of keys to look up.
   * @param {GetBatchOptions} [options]
   * @param {decompress} [options.decompress=false] - Whether to decompress the value. Overrides the client-wide
   * automatic decompression setting.
   * @returns {Promise<CacheGetBatch.Response>} -
   * {@link CacheGetBatch.Success} containing the values if they were found.
   * {@link CacheGetBatch.Error} on failure.
   */
  async getBatch(s, h, c) {
    return await this.getNextDataClient().getBatch(s, h, c);
  }
  /**
   * Associates the given keys with the given values. If a value for the key is
   * already present it is replaced with the new value.
   *
   * @param {string} cacheName - The cache to store the values in.
   * @param {Record<string, string | Uint8Array | SetBatchItem> | Map<string | Uint8Array, string | Uint8Array | SetBatchItem>} items - The key-value pairs to be stored, with the option to set a TTL per item.
   * @param {SetBatchOptions} [options]
   * @param {number} [options.ttl] - The time to live for the items in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @param {boolean} [options.compress=false] - Whether to compress the value. Defaults to false.
   * @returns {Promise<CacheSetBatch.Response>} -
   * {@link CacheSetBatch.Success} on success.
   * {@link CacheSetBatch.Error} on failure.
   */
  async setBatch(s, h, c) {
    return await this.getNextDataClient().setBatch(s, h, c);
  }
  /**
   * Adds multiple elements to the back of the given list. Creates the list if
   * it does not already exist.
   *
   * @param {string} cacheName - The cache to store the list in.
   * @param {string} listName - The list to add to.
   * @param {string[] | Uint8Array[]} values - The elements to add to the list.
   * @param {ListConcatenateBackOptions} [options]
   * @param {number} [options.truncateFrontToSize] - If the list exceeds this
   * length, remove excess from the front of the list. Must be positive.
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the list's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheListConcatenateBack.Response>} -
   * {@link CacheListConcatenateBack.Success} on success.
   * {@link CacheListConcatenateBack.Error} on failure.
   */
  async listConcatenateBack(s, h, c, d) {
    return await this.getNextDataClient().listConcatenateBack(s, h, c, d == null ? void 0 : d.truncateFrontToSize, d == null ? void 0 : d.ttl);
  }
  /**
   * Adds multiple elements to the front of the given list. Creates the list if
   * it does not already exist.
   *
   * @param {string} cacheName - The cache to store the list in.
   * @param {string} listName - The list to add to.
   * @param {string[] | Uint8Array[]} values - The elements to add to the list.
   * @param {ListConcatenateFrontOptions} [options]
   * @param {number} [options.truncateBackToSize] - If the list exceeds this
   * length, remove excess from the back of the list. Must be positive.
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the list's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheListConcatenateFront.Response>} -
   * {@link CacheListConcatenateFront.Success} on success.
   * {@link CacheListConcatenateFront.Error} on failure.
   */
  async listConcatenateFront(s, h, c, d) {
    return await this.getNextDataClient().listConcatenateFront(s, h, c, d == null ? void 0 : d.truncateBackToSize, d == null ? void 0 : d.ttl);
  }
  /**
   * Fetches all elements of the given list.
   *
   * @param {string} cacheName - The cache containing the list.
   * @param {string} listName - The list to fetch.
   * @param {ListFetchCallOptions} [options]
   * @param {number} [options.startIndex] - Start inclusive index for fetch operation.
   * @param {number} [options.endIndex] - End exclusive index for fetch operation.
   * @returns {Promise<CacheListFetch.Response>} -
   * {@link CacheListFetch.Hit} containing the list elements if the list exists.
   * {@link CacheListFetch.Miss} if the list does not exist.
   * {@link CacheListFetch.Error} on failure.
   */
  async listFetch(s, h, c) {
    return await this.getNextDataClient().listFetch(s, h, c == null ? void 0 : c.startIndex, c == null ? void 0 : c.endIndex);
  }
  /**
   * Gets the number of elements in the given list.
   *
   * @param {string} cacheName - The cache containing the list.
   * @param {string} listName - The list to get the length of.
   * @returns {Promise<CacheListLength.Response>} -
   * {@link CacheListLength.Hit} containing the length if the list exists.
   * {@link CacheListLength.Miss} if the list does not exist.
   * {@link CacheListLength.Error} on failure.
   */
  async listLength(s, h) {
    return await this.getNextDataClient().listLength(s, h);
  }
  /**
   * Gets and removes the last value from the given list.
   *
   * @param {string} cacheName - The cache containing the list.
   * @param {string} listName - The list to pop.
   * @returns {Promise<CacheListPopBack.Response>} -
   * {@link CacheListPopBack.Hit} containing the element if the list exists.
   * {@link CacheListPopBack.Miss} if the list does not exist.
   * {@link CacheListPopBack.Error} on failure.
   */
  async listPopBack(s, h) {
    return await this.getNextDataClient().listPopBack(s, h);
  }
  /**
   * Gets and removes the first value from the given list.
   *
   * @param {string} cacheName - The cache containing the list.
   * @param {string} listName - The list to pop.
   * @returns {Promise<CacheListPopFront.Response>} -
   * {@link CacheListPopFront.Hit} containing the element if the list exists.
   * {@link CacheListPopFront.Miss} if the list does not exist.
   * {@link CacheListPopFront.Error} on failure.
   */
  async listPopFront(s, h) {
    return await this.getNextDataClient().listPopFront(s, h);
  }
  /**
   * Adds an element to the back of the given list. Creates the list if
   * it does not already exist.
   *
   * @param {string} cacheName - The cache to store the list in.
   * @param {string} listName - The list to push to.
   * @param {string | Uint8Array} value - The value to push.
   * @param {ListPushBackOptions} [options]
   * @param {number} [options.truncateFrontToSize] - If the list exceeds this
   * length, remove excess from the front of the list. Must be positive.
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the list's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheListPushBack.Response>} -
   * {@link CacheListPushBack.Success} containing the list's new length on
   * success.
   * {@link CacheListPushBack.Error} on failure.
   */
  async listPushBack(s, h, c, d) {
    return await this.getNextDataClient().listPushBack(s, h, c, d == null ? void 0 : d.truncateFrontToSize, d == null ? void 0 : d.ttl);
  }
  /**
   * Adds an element to the front of the given list. Creates the list if
   * it does not already exist.
   *
   * @param {string} cacheName - The cache to store the list in.
   * @param {string} listName - The list to push to.
   * @param {string | Uint8Array} value - The value to push.
   * @param {ListPushFrontOptions} [options]
   * @param {number} [options.truncateBackToSize] - If the list exceeds this
   * length, remove excess from the end of the list. Must be positive.
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the list's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheListPushFront.Response>} -
   * {@link CacheListPushFront.Success} containing the list's new length on
   * success.
   * {@link CacheListPushFront.Error} on failure.
   */
  async listPushFront(s, h, c, d) {
    return await this.getNextDataClient().listPushFront(s, h, c, d == null ? void 0 : d.truncateBackToSize, d == null ? void 0 : d.ttl);
  }
  /**
   * Removes all elements from the given list equal to the given value.
   *
   * @param {string} cacheName - The cache containing the list.
   * @param {string} listName - The list to remove from.
   * @param {string | Uint8Array} value - The value to remove.
   * @returns {Promise<CacheListRemoveValue.Response>} -
   * {@link CacheListRemoveValue.Success} on success. Removing an element that
   * does not occur in the list or removing from a non-existent list counts as a
   * success.
   * {@link CacheListRemoveValue.Error} on failure.
   */
  async listRemoveValue(s, h, c) {
    return await this.getNextDataClient().listRemoveValue(s, h, c);
  }
  /**
   * Retains slice of elements of a given list, deletes the rest of the list
   * that isn't being retained. Returns a Success or Error.
   *
   * @param {string} cacheName - The cache containing the list.
   * @param {string} listName - The list to retain a slice of.
   * @param {ListRetainCallOptions} [options]
   * @param {number} [options.startIndex] - Start inclusive index for fetch
   * operation. Defaults to start of array if not given, 0.
   * @param {number} [options.endIndex] - End exclusive index for fetch
   * operation. Defaults to end of array if not given.
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the list's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheListRetain.Response>} -
   * {@link CacheListRetain.Success} on success.
   * {@link CacheListRetain.Error} on failure.
   */
  async listRetain(s, h, c) {
    return await this.getNextDataClient().listRetain(s, h, c == null ? void 0 : c.startIndex, c == null ? void 0 : c.endIndex, c == null ? void 0 : c.ttl);
  }
  /**
   * Fetches all elements of the given set
   *
   * @param {string} cacheName - The cache containing the set.
   * @param {string} setName - The set to fetch.
   * @returns {Promise<CacheSetFetch.Response>} -
   * {@link CacheSetFetch.Hit} containing the set elements if the set exists.
   * {@link CacheSetFetch.Miss} if the set does not exist.
   * {@link CacheSetFetch.Error} on failure.
   */
  async setFetch(s, h) {
    return await this.getNextDataClient().setFetch(s, h);
  }
  /**
   * Adds an element to the given set. Creates the set if it does not already
   * exist.
   *
   * @remarks
   * After this operation the set will contain the union of the element passed
   * in and the original elements of the set.
   *
   * @param {string} cacheName - The cache to store the set in.
   * @param {string} setName - The set to add to.
   * @param {string | Uint8Array} element - The element to add.
   * @param {SetAddElementOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the set's TTL using the client's default if this is not supplied.
   * @returns {Promise<CacheSetAddElement.Response>} -
   * {@link CacheSetAddElement.Success} on success.
   * {@link CacheSetAddElement.Error} on failure.
   */
  async setAddElement(s, h, c, d) {
    return (await this.setAddElements(s, h, [c], d)).toSingularResponse();
  }
  /**
   * Adds multiple elements to the given set. Creates the set if it does not
   * already exist.
   *
   * @remarks
   * After this operation, the set will contain the union of the elements passed
   * in and the original elements of the set.
   *
   * @param {string} cacheName - The cache to store the set in.
   * @param {string} setName - The set to add to.
   * @param {string[] | Uint8Array[]} elements - The elements to add.
   * @param {SetAddElementsOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the set's TTL using the client's default if this is not supplied.
   * @returns {Promise<CacheSetAddElements.Response>} -
   * {@link CacheSetAddElements.Success} on success.
   * {@link CacheSetAddElements.Error} on failure.
   */
  async setAddElements(s, h, c, d) {
    return await this.getNextDataClient().setAddElements(s, h, c, d == null ? void 0 : d.ttl);
  }
  /**
   * Tests if the given set contains the given element.
   * @param cacheName - The cache containing the set.
   * @param setName - The set to check.
   * @param element - The element to check for.
   * @returns {Promise<CacheSetContainsElement.Response>} -
   * {@link CacheSetContainsElement.Hit} if the set exists and contains the element.
   * {@link CacheSetContainsElement.Miss} if the set does not contain the element.
   * {@link CacheSetContainsElement.Error} on failure.
   */
  async setContainsElement(s, h, c) {
    return await this.getNextDataClient().setContainsElement(s, h, c);
  }
  /**
   * Tests if the given set contains the given elements.
   * @param cacheName - The cache containing the set.
   * @param setName - The set to check.
   * @param elements - The elements to check for.
   * @returns {Promise<CacheSetContainsElements.Response>} -
   * {@link CacheSetContainsElements.Hit} containing the elements to their presence in the cache.
   * {@link CacheSetContainsElements.Miss} if the set does not contain the elements.
   * {@link CacheSetContainsElements.Error} on failure.
   */
  async setContainsElements(s, h, c) {
    return await this.getNextDataClient().setContainsElements(s, h, c);
  }
  /**
   * Removes an element from the given set.
   *
   * @param {string} cacheName - The cache containing the set.
   * @param {string} setName - The set to remove from.
   * @param {string | Uint8Array} element - The element to remove.
   * @returns {Promise<CacheSetRemoveElement.Response>} -
   * {@link CacheSetRemoveElement.Success} on success. Removing an element that
   * does not occur in the set or removing from a non-existent set counts as a
   * success.
   * {@link CacheSetRemoveElement.Error} on failure.
   */
  async setRemoveElement(s, h, c) {
    return (await this.setRemoveElements(s, h, [c])).toSingularResponse();
  }
  /**
   * Removes multiple elements from the given set.
   *
   * @param {string} cacheName - The cache containing the set.
   * @param {string} setName - The set to remove from.
   * @param {string[] | Uint8Array[]} elements - The elements to remove.
   * @returns {Promise<CacheSetRemoveElements.Response>} -
   * {@link CacheSetRemoveElements.Success} on success. Removing elements that
   * do not occur in the set or removing from a non-existent set counts as a
   * success.
   * {@link CacheSetRemoveElements.Error} on failure.
   */
  async setRemoveElements(s, h, c) {
    return await this.getNextDataClient().setRemoveElements(s, h, c);
  }
  /**
   * Fetch a random sample of elements from the set.
   * Returns a different random sample for each call.
   *
   * @param {string} cacheName - The cache containing the set.
   * @param {string} setName - The set to remove from.
   * @param {number} limit - The maximum number of elements to return.
   * If the set contains fewer than 'limit' elements, the entire set will be returned.
   * @returns {Promise<CacheSetSample.Response>} -
   * {@link CacheSetSample.Hit} containing the set elements if the set exists.
   * {@link CacheSetSample.Miss} if the set does not exist.
   * {@link CacheSetSample.Error} on failure.
   */
  async setSample(s, h, c) {
    return await this.getNextDataClient().setSample(s, h, c);
  }
  /**
   * Pops a random sample of elements from the set.
   *
   * @param {string} cacheName - The cache containing the set.
   * @param {string} setName - The set to remove from.
   * @param {number} count - The maximum number of elements to return.
   * If the set contains fewer than 'limit' elements, the entire set will be returned.
   * @returns {Promise<CacheSetPop.Response>} -
   * {@link CacheSetPop.Hit} containing the set elements if the set exists.
   * {@link CacheSetPop.Miss} if the set does not exist.
   * {@link CacheSetPop.Error} on failure.
   */
  async setPop(s, h, c) {
    return await this.getNextDataClient().setPop(s, h, c);
  }
  /**
   * Get the number of elements in the set.
   *
   * @param {string} cacheName - The cache containing the set.
   * @param {string} setName - The set to remove from.
   * @returns {Promise<CacheSetLength.Response>} -
   * {@link CacheSetLength.Hit} containing the set elements if the set exists.
   * {@link CacheSetLength.Miss} if the set does not exist.
   * {@link CacheSetLength.Error} on failure.
   */
  async setLength(s, h) {
    return await this.getNextDataClient().setLength(s, h);
  }
  /**
   * Associates the given key with the given value if key is not already present in the cache.
   *
   * @deprecated Use setIfAbsent instead.
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {SetIfNotExistsOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @returns {Promise<CacheSetIfNotExists.Response>} -
   * {@link CacheSetIfNotExists.Stored} on storing the new value.
   * {@link CacheSetIfNotExists.NotStored} on not storing the new value.
   * {@link CacheSetIfNotExists.Error} on failure.
   */
  async setIfNotExists(s, h, c, d) {
    return await this.getNextDataClient().setIfNotExists(s, h, c, d == null ? void 0 : d.ttl);
  }
  /**
   * Associates the given key with the given value if key is not already present in the cache.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {SetIfAbsentOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @param {boolean} [options.compress=false] - Whether to compress the value. Defaults to false.
   * @returns {Promise<CacheSetIfAbsent.Response>} -
   * {@link CacheSetIfAbsent.Stored} on storing the new value.
   * {@link CacheSetIfAbsent.NotStored} on not storing the new value.
   * {@link CacheSetIfAbsent.Error} on failure.
   */
  async setIfAbsent(s, h, c, d) {
    return await this.getNextDataClient().setIfAbsent(s, h, c, d);
  }
  /**
   * Associates the given key with the given value if the key is present in the cache.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {SetIfPresentOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @returns {Promise<CacheSetIfPresent.Response>} -
   * {@link CacheSetIfPresent.Stored} on storing the new value.
   * {@link CacheSetIfPresent.NotStored} on not storing the new value.
   * {@link CacheSetIfPresent.Error} on failure.
   */
  async setIfPresent(s, h, c, d) {
    return await this.getNextDataClient().setIfPresent(s, h, c, d == null ? void 0 : d.ttl);
  }
  /**
   * Associates the given key with the given value if the key is present in the cache
   * and its value is equal to the supplied `equal` value.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {string | Uint8Array} equal - The value to compare to the cached value.
   * @param {SetIfEqualOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @returns {Promise<CacheSetIfEqual.Response>} -
   * {@link CacheSetIfEqual.Stored} on storing the new value.
   * {@link CacheSetIfEqual.NotStored} on not storing the new value.
   * {@link CacheSetIfEqual.Error} on failure.
   */
  async setIfEqual(s, h, c, d, l) {
    return await this.getNextDataClient().setIfEqual(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Associates the given key with the given value if the key does not exist in the cache or
   * if the value for the key is not equal to the supplied `notEqual` parameter.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {string | Uint8Array} notEqual - The value to compare to the cached value.
   * @param {SetIfNotEqualOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @returns {Promise<CacheSetIfNotEqual.Response>} -
   * {@link CacheSetIfNotEqual.Stored} on storing the new value.
   * {@link CacheSetIfNotEqual.NotStored} on not storing the new value.
   * {@link CacheSetIfNotEqual.Error} on failure.
   */
  async setIfNotEqual(s, h, c, d, l) {
    return await this.getNextDataClient().setIfNotEqual(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Associates the given key with the given value if key is present in the cache
   * and its value is not equal to the supplied `notEqual` value.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {string | Uint8Array} notEqual - The value to compare to the cached value.
   * @param {SetIfAbsentOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @returns {Promise<CacheSetIfPresentAndNotEqual.Response>} -
   * {@link CacheSetIfPresentAndNotEqual.Stored} on storing the new value.
   * {@link CacheSetIfPresentAndNotEqual.NotStored} on not storing the new value.
   * {@link CacheSetIfPresentAndNotEqual.Error} on failure.
   */
  async setIfPresentAndNotEqual(s, h, c, d, l) {
    return await this.getNextDataClient().setIfPresentAndNotEqual(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Associates the given key with the given value if key is absent or if the key is
   * present and its value is equal to the given value.
   *
   * @param {string} cacheName - The cache to store the value in.
   * @param {string | Uint8Array} key - The key to set.
   * @param {string | Uint8Array} field - The value to be stored.
   * @param {string | Uint8Array} equal - The value to compare to the cached value.
   * @param {SetIfAbsentOrEqualOptions} [options]
   * @param {number} [options.ttl] - The time to live for the item in the cache.
   * Uses the client's default TTL if this is not supplied.
   * @returns {Promise<CacheSetIfAbsentOrEqual.Response>} -
   * {@link CacheSetIfAbsentOrEqual.Stored} on storing the new value.
   * {@link CacheSetIfAbsentOrEqual.NotStored} on not storing the new value.
   * {@link CacheSetIfAbsentOrEqual.Error} on failure.
   */
  async setIfAbsentOrEqual(s, h, c, d, l) {
    return await this.getNextDataClient().setIfAbsentOrEqual(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Flushes / clears all the items of the given cache
   *
   * @param {string} cacheName - The cache to be flushed.
   * @returns {Promise<CacheFlush.Response>} -
   * {@link CacheFlush.Success} on success.
   * {@link CacheFlush.Error} on failure.
   */
  async flushCache(s) {
    return await this.controlClient.flushCache(s);
  }
  /**
   * Fetches all elements of the given dictionary.
   *
   * @param {string} cacheName - The cache to perform the lookup in.
   * @param {string} dictionaryName - The dictionary to fetch.
   * @returns {Promise<CacheDictionaryFetch.Response>} -
   * {@link CacheDictionaryFetch.Hit} containing the dictionary elements if the
   * dictionary exists.
   * {@link CacheDictionaryFetch.Miss} if the dictionary does not exist.
   * {@link CacheDictionaryFetch.Error} on failure.
   */
  async dictionaryFetch(s, h) {
    return await this.getNextDataClient().dictionaryFetch(s, h);
  }
  /**
   * Adds an integer quantity to a field value.
   *
   * @remarks
   * Incrementing the value of a missing field sets the value to amount.
   *
   * @param {string} cacheName - The cache containing the field.
   * @param {string | Uint8Array} field - The field to increment.
   * @param {number} amount - The quantity to add to the value. May be positive,
   * negative, or zero. Defaults to 1.
   * @param {IncrementOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * @returns {Promise<CacheIncrement>} -
   * {@link CacheIncrement.Success} containing the incremented value
   * on success.
   * {@link CacheIncrement.Error} on failure. Incrementing a value
   * that was not set using this method or is not the string representation of
   * an integer results in a failure with a FailedPreconditionException error.
   */
  async increment(s, h, c = 1, d) {
    return await this.getNextDataClient().increment(s, h, c, d == null ? void 0 : d.ttl);
  }
  /**
   * Adds an element to the given dictionary. Creates the dictionary if it does
   * not already exist.
   *
   * @param {string} cacheName - The cache to store the dictionary in.
   * @param {string} dictionaryName - The dictionary to add to.
   * @param {string | Uint8Array} field - The field to set.
   * @param {string | Uint8Array} value - The value to store.
   * @param {DictionarySetFieldOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the dictionary's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheDictionarySetField.Response>} -
   * {@link CacheDictionarySetField.Success} on success.
   * {@link CacheDictionarySetField.Error} on failure.
   */
  async dictionarySetField(s, h, c, d, l) {
    return await this.getNextDataClient().dictionarySetField(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Adds multiple elements to the given dictionary. Creates the dictionary if
   * it does not already exist.
   *
   * @param {string} cacheName - The cache to store the dictionary in.
   * @param {string} dictionaryName - The dictionary to add to.
   * @param {Map<string | Uint8Array, string | Uint8Array>} elements - The
   * elements to set.
   * @param {DictionarySetFieldsOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the dictionary's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheDictionarySetFields.Response>} -
   * {@link CacheDictionarySetFields.Success} on success.
   * {@link CacheDictionarySetFields.Error} on failure.
   */
  async dictionarySetFields(s, h, c, d) {
    return await this.getNextDataClient().dictionarySetFields(s, h, c, d == null ? void 0 : d.ttl);
  }
  /**
   * Gets the value stored for the given dictionary and field.
   *
   * @param {string} cacheName - The cache containing the dictionary.
   * @param {string} dictionaryName - The dictionary to look up.
   * @param {string | Uint8Array} field - The field to look up.
   * @returns {Promise<CacheDictionaryGetField.Response>} -
   * {@link CacheDictionaryGetField.Hit} containing the dictionary element if
   * one is found.
   * {@link CacheDictionaryGetField.Miss} if the dictionary does not exist.
   * {@link CacheDictionaryGetField.Error} on failure.
   */
  async dictionaryGetField(s, h, c) {
    return await this.getNextDataClient().dictionaryGetField(s, h, c);
  }
  /**
   * Gets multiple values from the given dictionary.
   *
   * @param {string} cacheName - The cache containing the dictionary.
   * @param {string} dictionaryName - The dictionary to look up.
   * @param {string[] | Uint8Array[]} fields - The fields to look up.
   * @returns {Promise<CacheDictionaryGetFields.Response>} -
   * {@link CacheDictionaryGetFields.Hit} containing the dictionary elements if
   * the dictionary exists.
   * {@link CacheDictionaryGetFields.Miss} if the dictionary does not exist.
   * {@link CacheDictionaryGetFields.Error} on failure.
   */
  async dictionaryGetFields(s, h, c) {
    return await this.getNextDataClient().dictionaryGetFields(s, h, c);
  }
  /**
   * Removes an element from the given dictionary.
   *
   * @remarks
   * Performs a no-op if the dictionary or field does not exist.
   *
   * @param {string} cacheName - The cache containing the dictionary.
   * @param {string} dictionaryName - The dictionary to remove from.
   * @param {string | Uint8Array} field - The field to remove.
   * @returns {Promise<CacheDictionaryRemoveField.Response>} -
   * {@link CacheDictionaryRemoveField.Success} on success.
   * {@link CacheDictionaryRemoveField.Error} on failure.
   */
  async dictionaryRemoveField(s, h, c) {
    return await this.getNextDataClient().dictionaryRemoveField(s, h, c);
  }
  /**
   * Removes multiple fields from the given dictionary.
   *
   * @remarks
   * Performs a no-op if the dictionary or fields do not exist.
   *
   * @param {string} cacheName - The cache containing the dictionary.
   * @param {string} dictionaryName - The dictionary to remove from.
   * @param {string[] | Uint8Array[]} fields - The fields to remove.
   * @returns {Promise<CacheDictionaryRemoveFields.Response>} -
   * {@link CacheDictionaryRemoveFields.Success} on success.
   * {@link CacheDictionaryRemoveFields.Error} on failure.
   */
  async dictionaryRemoveFields(s, h, c) {
    return await this.getNextDataClient().dictionaryRemoveFields(s, h, c);
  }
  /**
   * Adds an integer quantity to a dictionary value.
   *
   * @remarks
   * Incrementing the value of a missing field sets the value to amount.
   *
   * @param {string} cacheName - The cache containing the dictionary.
   * @param {string} dictionaryName - The dictionary to set.
   * @param {string | Uint8Array} field - The field to increment.
   * @param {number} amount - The quantity to add to the value. May be positive,
   * negative, or zero. Defaults to 1.
   * @param {DictionaryIncrementOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the dictionary's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheDictionaryIncrement.Response>} -
   * {@link CacheDictionaryIncrement.Success} containing the incremented value
   * on success.
   * {@link CacheDictionaryIncrement.Error} on failure. Incrementing a value
   * that was not set using this method or is not the string representation of
   * an integer results in a failure with a FailedPreconditionException error.
   */
  async dictionaryIncrement(s, h, c, d = 1, l) {
    return await this.getNextDataClient().dictionaryIncrement(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Gets the number of elements in the given dictionary.
   *
   * @param {string} cacheName - The cache containing the dictionary.
   * @param {string} dictionaryName - The dictionary to get the length of.
   * @returns {Promise<CacheDictionaryLength.Response>} -
   * {@link CacheDictionaryLength.Hit} containing the length if the dictionary exists.
   * {@link CacheDictionaryLength.Miss} if the dictionary does not exist.
   * {@link CacheDictionaryLength.Error} on failure.
   */
  async dictionaryLength(s, h) {
    return await this.getNextDataClient().dictionaryLength(s, h);
  }
  /**
   * Adds an element to the given sorted set. If the element already exists, its
   * score is updated. Creates the sorted set if it does not exist.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to add to.
   * @param {string | Uint8Array} value - The value to add.
   * @param {number} score - The score to assign to the value.
   * @param {SortedSetPutElementOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the sorted set's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheSortedSetPutElement.Response>} -
   * {@link CacheSortedSetPutElement.Success} on success.
   * {@link CacheSortedSetPutElement.Error} on failure.
   * @returns
   */
  async sortedSetPutElement(s, h, c, d, l) {
    return await this.getNextDataClient().sortedSetPutElement(s, h, c, d, l == null ? void 0 : l.ttl);
  }
  /**
   * Adds elements to the given sorted set. For any values that already exist, it
   * the score is updated. Creates the sorted set if it does not exist.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to add to.
   * @param {Map<string | Uint8Array, number>| Record<string, number>} elements - The value->score pairs to add to the sorted set.
   * @param {SortedSetPutElementOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the sorted set's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheSortedSetPutElements.Response>} -
   * {@link CacheSortedSetPutElements.Success} on success.
   * {@link CacheSortedSetPutElements.Error} on failure.
   * @returns
   */
  async sortedSetPutElements(s, h, c, d) {
    return await this.getNextDataClient().sortedSetPutElements(s, h, c, d == null ? void 0 : d.ttl);
  }
  /**
   * Fetch the elements in the given sorted set by index (rank).
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to fetch from.
   * @param {SortedSetFetchByRankOptions} options
   * @param {number} [options.startRank] - The rank of the first element to
   * fetch. Defaults to 0. This rank is inclusive, ie the element at this rank
   * will be fetched.
   * @param {number} [options.endRank] - The rank of the last element to fetch.
   * This rank is exclusive, ie the element at this rank will not be fetched.
   * Defaults to null, which fetches up until and including the last element.
   * @param {SortedSetOrder} [options.order] - The order to fetch the elements in.
   * Defaults to ascending.
   * @returns {Promise<CacheSortedSetFetch.Response>}
   * {@link CacheSortedSetFetch.Hit} containing the requested elements when found.
   * {@link CacheSortedSetFetch.Miss} when the sorted set does not exist.
   * {@link CacheSortedSetFetch.Error} on failure.
   */
  async sortedSetFetchByRank(s, h, c) {
    var d, l;
    return await this.getNextDataClient().sortedSetFetchByRank(s, h, (d = c == null ? void 0 : c.order) !== null && d !== void 0 ? d : index_1$2.SortedSetOrder.Ascending, (l = c == null ? void 0 : c.startRank) !== null && l !== void 0 ? l : 0, c == null ? void 0 : c.endRank);
  }
  /**
   * Fetch the elements in the given sorted set by score.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to fetch from.
   * @param {SortedSetFetchByScoreOptions} options
   * @param {number} [options.minScore] - The minimum score (inclusive) of the
   * elements to fetch. Defaults to negative infinity.
   * @param {number} [options.maxScore] - The maximum score (inclusive) of the
   * elements to fetch. Defaults to positive infinity.
   * @param {SortedSetOrder} [options.order] - The order to fetch the elements in.
   * Defaults to ascending.
   * @param {number} [options.offset] - The number of elements to skip before
   * returning the first element. Defaults to 0. Note: this is not the rank of
   * the first element to return, but the number of elements of the result set
   * to skip before returning the first element.
   * @param {number} [options.count] - The maximum number of elements to return.
   * Defaults to undefined, which returns all elements.
   * @returns {Promise<CacheSortedSetFetch.Response>} -
   * {@link CacheSortedSetFetch.Hit} containing the requested elements when found.
   * {@link CacheSortedSetFetch.Miss} when the sorted set does not exist.
   * {@link CacheSortedSetFetch.Error} on failure.
   */
  async sortedSetFetchByScore(s, h, c) {
    var d;
    return await this.getNextDataClient().sortedSetFetchByScore(s, h, (d = c == null ? void 0 : c.order) !== null && d !== void 0 ? d : index_1$2.SortedSetOrder.Ascending, c == null ? void 0 : c.minScore, c == null ? void 0 : c.maxScore, c == null ? void 0 : c.offset, c == null ? void 0 : c.count);
  }
  /**
   * Look up the rank of an element in the sorted set, by the value of the element.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to fetch from.
   * @param {string | Uint8Array} value - The value of the element whose rank we are retrieving.
   * @param {SortedSetGetRankOptions} options
   * @param {SortedSetOrder} [options.order] - The order in which sorted set will be sorted to determine the rank.
   * Defaults to ascending.
   * @returns {Promise<CacheSortedSetGetRank.Response>}
   * {@link CacheSortedSetGetRank.Hit} containing the rank of the requested elements when found.
   * {@link CacheSortedSetGetRank.Miss} when the element does not exist.
   * {@link CacheSortedSetGetRank.Error} on failure.
   */
  async sortedSetGetRank(s, h, c, d) {
    return await this.getNextDataClient().sortedSetGetRank(s, h, c, d == null ? void 0 : d.order);
  }
  /**
   * Look up the score of an element in the sorted set, by the value of the element.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to fetch from.
   * @param {string | Uint8Array} value - The value of the element whose score we are retrieving.
   * @returns {Promise<CacheSortedSetGetScore.Response>}
   * {@link CacheSortedSetGetScore.Hit} containing the score of the requested element when found.
   * {@link CacheSortedSetGetScore.Miss} when the element or collection does not exist.
   * {@link CacheSortedSetGetScore.Error} on failure.
   */
  async sortedSetGetScore(s, h, c) {
    return await this.getNextDataClient().sortedSetGetScore(s, h, c);
  }
  /**
   * Look up the scores of multiple elements in the sorted set, by the value of the elements.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to fetch from.
   * @param {string[] | Uint8Array[]} values - The values of the elements whose scores we are retrieving.
   * @returns {Promise<CacheSortedSetGetScores.Response>}
   * {@link CacheSortedSetGetScores.Hit} containing the scores of the requested elements when found.
   * {@link CacheSortedSetGetScores.Miss} when the element or collection does not exist.
   * {@link CacheSortedSetGetScores.Error} on failure.
   */
  async sortedSetGetScores(s, h, c) {
    return await this.getNextDataClient().sortedSetGetScores(s, h, c);
  }
  /**
   * Increment the score of an element in the sorted set.
   *
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to fetch from.
   * @param {string | Uint8Array} value - The value of the element whose score we are incrementing.
   * @param {number} amount - The quantity to add to the score. May be positive,
   * negative, or zero. Defaults to 1.
   * @param {SortedSetIncrementOptions} options
   * @param {CollectionTtl} [options.ttl] - How the TTL should be managed.
   * Refreshes the sorted set's TTL using the client's default if this is not
   * supplied.
   * @returns {Promise<CacheSortedSetIncrementScore.Response>} -
   * {@link CacheSortedSetIncrementScore.Success} containing the incremented score
   * on success.
   * {@link CacheSortedSetIncrementScore.Error} on failure. Incrementing a score
   * that was not set using this method or is not the string representation of
   * an integer results in a failure with a FailedPreconditionException error.
   */
  async sortedSetIncrementScore(s, h, c, d, l) {
    return await this.getNextDataClient().sortedSetIncrementScore(s, h, c, d || 1, l == null ? void 0 : l.ttl);
  }
  /**
   * Remove an element from the sorted set
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to remove from.
   * @param {string | Uint8Array} value - The value of the element to remove from the set.
   * @returns {Promise<CacheSortedSetRemoveElement.Response>}
   * {@link CacheSortedSetRemoveElement.Success} if the element was successfully removed
   * {@link CacheSortedSetIncrementScore.Error} on failure
   */
  async sortedSetRemoveElement(s, h, c) {
    return await this.getNextDataClient().sortedSetRemoveElement(s, h, c);
  }
  /**
   * Remove multiple elements from the sorted set
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set to remove from.
   * @param {string | Uint8Array} values - The values of the elements to remove from the set.
   * @returns {Promise<CacheSortedSetRemoveElement.Response>}
   * {@link CacheSortedSetRemoveElement.Success} if the elements were successfully removed
   * {@link CacheSortedSetIncrementScore.Error} on failure
   */
  async sortedSetRemoveElements(s, h, c) {
    return await this.getNextDataClient().sortedSetRemoveElements(s, h, c);
  }
  /**
   * Fetch length (number of items) of sorted set
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set name.
   * @returns {Promise<CacheSortedSetLength.Response>}
   * {@link CacheSortedSetLength.Hit} containing the length if the sorted set exists.
   * {@link CacheSortedSetLength.Miss} if the sorted set does not exist.
   * {@link CacheSortedSetLength.Error} on failure.
   */
  async sortedSetLength(s, h) {
    return await this.getNextDataClient().sortedSetLength(s, h);
  }
  /**
   * Fetch length (number of items) of sorted set within the provided score range
   * @param {string} cacheName - The cache containing the sorted set.
   * @param {string} sortedSetName - The sorted set name.
   * @param {SortedSetLengthByScoreOptions} options - Optional parameter for specifying the score range to search in.
   * @param {number} [options.minScore] - The lower bound on the score range to search in.
   * @param {number} [options.maxScore] - The upper bound on the score range to search in.
   * @returns {Promise<CacheSortedSetLengthByScore.Response>}
   * {@link CacheSortedSetLengthByScore.Hit} containing the length if the sorted set exists.
   * {@link CacheSortedSetLengthByScore.Miss} if the sorted set does not exist.
   * {@link CacheSortedSetLengthByScore.Error} on failure.
   */
  async sortedSetLengthByScore(s, h, c) {
    return await this.getNextDataClient().sortedSetLengthByScore(s, h, c == null ? void 0 : c.minScore, c == null ? void 0 : c.maxScore);
  }
  /**
   * Return the type of the key in the cache
   * @param {string} cacheName - The cache containing the key.
   * @param {string} key - The key for which type is requested.
   * @returns {Promise<CacheItemGetType.Response>}
   * {@link CacheItemGetType.Hit} containing type of key when found.
   * {@link CacheItemGetType.Miss} when the key does not exist.
   * {@link CacheItemGetType.Error} on failure.
   */
  async itemGetType(s, h) {
    return await this.getNextDataClient().itemGetType(s, h);
  }
  /**
   * Return the remaining ttl of the key in the cache in milliseconds.
   * @param {string} cacheName - The cache containing the key.
   * @param {string} key - The key for which the ttl remaining is requested.
   * @returns {Promise<CacheItemGetTtl.Response>}
   * {@link CacheItemGetTtl.Hit} containing ttl remaining of key when found.
   * {@link CacheItemGetTtl.Miss} when the key does not exist.
   * {@link CacheItemGetTtl.Error} on failure.
   */
  async itemGetTtl(s, h) {
    return await this.getNextDataClient().itemGetTtl(s, h);
  }
  /**
   * Check if the provided key exists in the cache
   * @param {string} cacheName - The cache to look in.
   * @param {string | Uint8Array} key - The key to look up.
   * @returns {Promise<CacheKeyExists.Response>}
   * {@link CacheKeyExists.Success} returns boolean indicating whether the key was found.
   * {@link CacheKeyExists.Error} on failure.
   */
  async keyExists(s, h) {
    return await this.getNextDataClient().keyExists(s, h);
  }
  /**
   * Check if the provided keys exist in the cache
   * @param {string} cacheName - The cache to look in.
   * @param {string[] | Uint8Array[]} keys - The keys to look up.
   * @returns {Promise<CacheKeysExist.Response>}
   * {@link CacheKeysExist.Success} returns list of booleans indicating whether each key was found.
   * {@link CacheKeysExist.Error} on failure.
   */
  async keysExist(s, h) {
    return await this.getNextDataClient().keysExist(s, h);
  }
  /**
   * Update the ttl of the key in the cache in milliseconds.
   * @param {string} cacheName - The cache containing the key.
   * @param {string} key - The key for which the ttl remaining is requested.
   * @param {number} ttlMilliseconds - The ttl in milliseconds that should overwrite the current ttl.
   * @returns {Promise<CacheUpdateTtl.Response>}
   * {@link CacheUpdateTtl.Set} when the ttl was successfully overwritten.
   * {@link CacheUpdateTtl.Miss} when the key does not exist.
   * {@link CacheUpdateTtl.Error} on failure.
   */
  async updateTtl(s, h, c) {
    return await this.getNextDataClient().updateTtl(s, h, c);
  }
  /**
   * Increase the ttl of the key in the cache in milliseconds.
   * @param {string} cacheName - The cache containing the key.
   * @param {string} key - The key for which the ttl remaining is requested.
   * @param {number} ttlMilliseconds - The ttl in milliseconds that should
   * overwrite the current ttl. Should be greater than the current ttl.
   * @returns {Promise<CacheIncreaseTtl.Response>}
   * {@link CacheIncreaseTtl.Set} when the ttl was successfully increased.
   * {@link CacheIncreaseTtl.Miss} when the key does not exist.
   * {@link CacheIncreaseTtl.Error} on failure.
   */
  async increaseTtl(s, h, c) {
    return await this.getNextDataClient().increaseTtl(s, h, c);
  }
  /**
   * Decrease the ttl of the key in the cache in milliseconds.
   * @param {string} cacheName - The cache containing the key.
   * @param {string} key - The key for which the ttl remaining is requested.
   * @param {number} ttlMilliseconds - The ttl in milliseconds that should
   * overwrite the current ttl. Should be less than the current ttl.
   * @returns {Promise<CacheDecreaseTtl.Response>}
   * {@link CacheDecreaseTtl.Set} when the ttl was successfully decreased.
   * {@link CacheDecreaseTtl.Miss} when the key does not exist.
   * {@link CacheDecreaseTtl.Error} on failure.
   */
  async decreaseTtl(s, h, c) {
    return await this.getNextDataClient().decreaseTtl(s, h, c);
  }
  getNextDataClient() {
    const s = this.dataClients[this.nextDataClientIndex];
    return this.nextDataClientIndex = (this.nextDataClientIndex + 1) % this.dataClients.length, s;
  }
}
AbstractCacheClient$1.AbstractCacheClient = AbstractCacheClient;
var ICacheClient = {};
Object.defineProperty(ICacheClient, "__esModule", { value: !0 });
var IControlClient = {};
Object.defineProperty(IControlClient, "__esModule", { value: !0 });
var IDataClient = {};
Object.defineProperty(IDataClient, "__esModule", { value: !0 });
var IPingClient = {};
Object.defineProperty(IPingClient, "__esModule", { value: !0 });
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(AbstractCacheClient$1, p), h(ICacheClient, p), h(IControlClient, p), h(IDataClient, p), h(IPingClient, p);
})(cache);
var auth = {}, AbstractAuthClient$1 = {};
Object.defineProperty(AbstractAuthClient$1, "__esModule", { value: !0 });
AbstractAuthClient$1.AbstractAuthClient = void 0;
class AbstractAuthClient {
  constructor(s) {
    this.authClient = s.createAuthClient();
  }
  /**
   * Generates a new API key, along with a refresh token to refresh the API key before expiry.
   *
   * @param {PermissionScope} scope - controls the permissions that the new key will have
   * @param {string} expiresIn - How long the API key should be valid for in epoch timestamp.
   * @returns {Promise<GenerateApiKey.Response>} -
   * {@link GenerateApiKey.Success} containing the API key, refresh token, origin and epoch timestamp when token expires.
   * If the API key never expires, then no refresh token will be returned and expires at timestamp will be infinite.
   * {@link GenerateApiKey.Error} on failure.
   */
  async generateApiKey(s, h) {
    return await this.authClient.generateApiKey(s, h);
  }
  /**
   * @deprecated please use `generateApiKey` instead
   */
  async generateAuthToken(s, h) {
    return await this.generateApiKey(s, h);
  }
  /**
   * Refreshes an API key.  Returns a new API key and refresh token, that will be able to be refreshed again in the future.
   * The new API key will be valid for the same length of time as the original key, starting from the time of refresh.
   * The original api key will still work until its expired.
   *
   * @param {string} refreshToken - Refresh token used to refresh the API key.
   * @returns {Promise<RefreshApiKey.Response>} -
   * {@link RefreshApiKey.Success} containing the new API key, refresh token, origin and epoch timestamp when the API key expires.
   * {@link RefreshApiKey.Error} on failure.
   */
  async refreshApiKey(s) {
    return await this.authClient.refreshApiKey(s);
  }
  /**
   * @deprecated please use `refreshApiKey` instead
   */
  async refreshAuthToken(s) {
    return await this.refreshApiKey(s);
  }
  /**
   * Generates a new disposable, fine-grained access token.
   *
   * @param {DisposableTokenScope} scope - controls the permissions that the new token will have
   * @param {string} expiresIn - How long the token is valid for in epoch timestamp.
   * @param {DisposableTokenProps} disposableTokenProps - Additional properties for the API
   * @returns {Promise<GenerateDisposableToken.Response>} -
   * {@link GenerateDisposableToken.Success} containing the api token, origin and epoch timestamp when token expires.
   * {@link GenerateDisposableToken.Error} on failure.
   */
  async generateDisposableToken(s, h, c) {
    return await this.authClient.generateDisposableToken(s, h, c);
  }
}
AbstractAuthClient$1.AbstractAuthClient = AbstractAuthClient;
var IAuthClient = {};
Object.defineProperty(IAuthClient, "__esModule", { value: !0 });
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(AbstractAuthClient$1, p), h(IAuthClient, p);
})(auth);
var pubsub = {}, ITopicClient = {};
Object.defineProperty(ITopicClient, "__esModule", { value: !0 });
var IPubsubClient = {};
Object.defineProperty(IPubsubClient, "__esModule", { value: !0 });
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(ITopicClient, p), h(IPubsubClient, p);
})(pubsub);
var leaderboard$1 = {}, ILeaderboard = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.LeaderboardOrder = void 0;
  const s = cacheCallOptions;
  Object.defineProperty(p, "LeaderboardOrder", { enumerable: !0, get: function() {
    return s.LeaderboardOrder;
  } });
})(ILeaderboard);
var ILeaderboardClient = {};
Object.defineProperty(ILeaderboardClient, "__esModule", { value: !0 });
var AbstractLeaderboard$1 = {};
Object.defineProperty(AbstractLeaderboard$1, "__esModule", { value: !0 });
AbstractLeaderboard$1.AbstractLeaderboard = void 0;
class AbstractLeaderboard {
  constructor(s, h, c) {
    this.cacheName = s, this.leaderboardName = h, this.dataClient = c;
  }
  /**
   * Updates elements in a leaderboard or inserts elements if they do not already exist.
   * The leaderboard is also created if it does not already exist.
   * Note: can upsert a maximum of 8192 elements at a time.
   *
   * @param {Map<number, number>} elements - The ID->score pairs to add to the leaderboard.
   * @returns {Promise<LeaderboardUpsert.Response>} -
   * {@link LeaderboardUpsert.Success} on success.
   * {@link LeaderboardUpsert.Error} on failure.
   */
  async upsert(s) {
    return await this.dataClient.upsert(this.cacheName, this.leaderboardName, s);
  }
  /**
   * Fetch the elements in the given leaderboard by score.
   * Note: can fetch a maximum of 8192 elements at a time.
   *
   * @param {LeaderboardFetchByScoreCallOptions} options
   * @param {number} [options.minScore] - The minimum score (inclusive) of the
   * elements to fetch. Defaults to negative infinity.
   * @param {number} [options.maxScore] - The maximum score (exclusive) of the
   * elements to fetch. Defaults to positive infinity.
   * @param {LeaderboardOrder} [options.order] - The order to fetch the elements in.
   * Defaults to ascending, meaning 0 is the lowest-scoring rank.
   * @param {number} [options.offset] - The number of elements to skip before
   * returning the first element. Defaults to 0. Note: this is not the score of
   * the first element to return, but the number of elements of the result set
   * to skip before returning the first element.
   * @param {number} [options.count] - The maximum number of elements to return.
   * Defaults to 8192, which is the maximum that can be fetched at a time.
   * @returns {Promise<LeaderboardFetch.Response>} -
   * {@link LeaderboardFetch.Success} containing the requested elements.
   * {@link LeaderboardFetch.Error} on failure.
   */
  async fetchByScore(s) {
    return await this.dataClient.fetchByScore(this.cacheName, this.leaderboardName, s == null ? void 0 : s.minScore, s == null ? void 0 : s.maxScore, s == null ? void 0 : s.order, s == null ? void 0 : s.offset, s == null ? void 0 : s.count);
  }
  /**
   * Fetch the elements in the given leaderboard by index (rank).
   * Note: can fetch a maximum of 8192 elements at a time and rank
   * is 0-based (index begins at 0).
   *
   * @param {number} [startRank] - The rank of the first element to
   * fetch. This rank is inclusive, ie the element at this rank
   * will be fetched. Ranks can be used to manually paginate through the leaderboard
   * in batches of 8192 elements (e.g. request 0-8192, then 8192-16384, etc).
   * @param {number} [endRank] - The rank of the last element to fetch.
   * This rank is exclusive, ie the element at this rank will not be fetched.
   * Ranks can be used to manually paginate through the leaderboard
   * in batches of 8192 elements (e.g. request 0-8192, then 8192-16384, etc).
   * @param {LeaderboardFetchByRankOptions} options
   * @param {LeaderboardOrder} [options.order] - The order to fetch the elements in.
   * Defaults to ascending, meaning 0 is the lowest-scoring rank.
   * @returns {Promise<LeaderboardFetch.Response>} -
   * {@link LeaderboardFetch.Success} containing the requested elements.
   * {@link LeaderboardFetch.Error} on failure.
   */
  async fetchByRank(s, h, c) {
    return await this.dataClient.fetchByRank(this.cacheName, this.leaderboardName, s, h, c == null ? void 0 : c.order);
  }
  /**
   * Look up the rank of an element in the leaderboard given the element id.
   * Note: rank is 0-based (index begins at 0).
   *
   * @param {number} ids - The ids of the elements whose rank we are retrieving.
   * @param {LeaderboardGetRankCallOptions} options
   * @param {LeaderboardOrder} [options.order] - The order to fetch the elements in.
   * Defaults to ascending, meaning 0 is the lowest-scoring rank.
   * @returns {Promise<LeaderboardFetch.Response>}
   * {@link LeaderboardFetch.Success} containing the requested elements.
   * {@link LeaderboardFetch.Error} on failure.
   */
  async getRank(s, h) {
    return await this.dataClient.getRank(this.cacheName, this.leaderboardName, s, h == null ? void 0 : h.order);
  }
  /**
   * Fetch length (number of items) of leaderboard
   *
   * @returns {Promise<LeaderboardLength.Response>}
   * {@link LeaderboardLength.Success} containing the length if the leaderboard exists.
   * {@link LeaderboardLength.Error} on failure.
   */
  async length() {
    return await this.dataClient.length(this.cacheName, this.leaderboardName);
  }
  /**
   * Remove multiple elements from the given leaderboard
   * Note: can remove a maximum of 8192 elements at a time.
   *
   * @param {Array<number>} ids - The IDs of the elements to remove from the leaderboard.
   * @returns {Promise<LeaderboardRemoveElements.Response>}
   * {@link LeaderboardRemoveElements.Success} if the elements were successfully removed.
   * {@link LeaderboardRemoveElements.Error} on failure.
   */
  async removeElements(s) {
    return await this.dataClient.removeElements(this.cacheName, this.leaderboardName, s);
  }
  /**
   * Delete the given leaderboard
   *
   * @returns {Promise<LeaderboardDelete.Response>}
   * {@link LeaderboardDelete.Success} on success.
   * {@link LeaderboardDelete.Error} on failure.
   */
  async delete() {
    return await this.dataClient.delete(this.cacheName, this.leaderboardName);
  }
}
AbstractLeaderboard$1.AbstractLeaderboard = AbstractLeaderboard;
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(ILeaderboard, p), h(ILeaderboardClient, p), h(AbstractLeaderboard$1, p);
})(leaderboard$1);
var storage = {}, AbstractStorageClient$1 = {};
Object.defineProperty(AbstractStorageClient$1, "__esModule", { value: !0 });
AbstractStorageClient$1.AbstractStorageClient = void 0;
class AbstractStorageClient {
  constructor(s, h) {
    this.dataClients = s, this.controlClient = h, this.nextDataClientIndex = 0;
  }
  createStore(s) {
    return this.controlClient.createStore(s);
  }
  listStores() {
    return this.controlClient.listStores();
  }
  deleteStore(s) {
    return this.controlClient.deleteStore(s);
  }
  get(s, h) {
    return this.getNextDataClient().get(s, h);
  }
  putInt(s, h, c) {
    return this.getNextDataClient().putInt(s, h, c);
  }
  putDouble(s, h, c) {
    return this.getNextDataClient().putDouble(s, h, c);
  }
  putString(s, h, c) {
    return this.getNextDataClient().putString(s, h, c);
  }
  putBytes(s, h, c) {
    return this.getNextDataClient().putBytes(s, h, c);
  }
  delete(s, h) {
    return this.getNextDataClient().delete(s, h);
  }
  getNextDataClient() {
    const s = this.dataClients[this.nextDataClientIndex];
    return this.nextDataClientIndex = (this.nextDataClientIndex + 1) % this.dataClients.length, s;
  }
}
AbstractStorageClient$1.AbstractStorageClient = AbstractStorageClient;
var IStorageControlClient = {};
Object.defineProperty(IStorageControlClient, "__esModule", { value: !0 });
var IStorageDataClient = {};
Object.defineProperty(IStorageDataClient, "__esModule", { value: !0 });
var IStorageClient = {};
Object.defineProperty(IStorageClient, "__esModule", { value: !0 });
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(AbstractStorageClient$1, p), h(IStorageControlClient, p), h(IStorageDataClient, p), h(IStorageClient, p);
})(storage);
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(cache, p), h(auth, p), h(pubsub, p), h(leaderboard$1, p), h(storage, p);
})(clients);
var hasRequiredCacheClient;
function requireCacheClient() {
  if (hasRequiredCacheClient) return cacheClient;
  hasRequiredCacheClient = 1, Object.defineProperty(cacheClient, "__esModule", { value: !0 }), cacheClient.CacheClient = void 0;
  const p = requireCacheControlClient(), s = requireCacheDataClient(), h = pingClient, c = clients, d = webClientUtils, l = requireSrc(), g = utils$1, f = requireSrc$1();
  class _ extends c.AbstractCacheClient {
    constructor(w) {
      var q, j;
      (0, g.validateTtlSeconds)(w.defaultTtlSeconds);
      const k = (q = w.configuration) !== null && q !== void 0 ? q : se(), z = (j = w.credentialProvider) !== null && j !== void 0 ? j : (0, f.getDefaultCredentialProvider)(), $ = {
        ...w,
        configuration: k,
        credentialProvider: z
      }, re = te($), oe = ae($), le = ie($);
      super(re, [oe], le);
    }
    close() {
      this.controlClient.close(), this.dataClients.map((w) => w.close());
    }
    /**
     * The configuration used by this client.
     *
     * @readonly
     * @type {Configuration} the configuration used by this client
     * @memberof CacheClient
     */
    get configuration() {
      return this._configuration;
    }
    /**
     * Creates a new instance of CacheClient.
     * @param cacheClientProps - The properties to use for creating the CacheClient.
     */
    // Disabling eslint rule because the example code that calls this function uses an await expression,
    // necessitating the function to be async.
    // eslint-disable-next-line require-await,@typescript-eslint/require-await
    static async create(w) {
      return new _(w);
    }
  }
  cacheClient.CacheClient = _;
  function te(m) {
    return new p.CacheControlClient({
      configuration: m.configuration,
      credentialProvider: m.credentialProvider
    });
  }
  function ae(m) {
    return new s.CacheDataClient({
      configuration: m.configuration,
      credentialProvider: m.credentialProvider,
      defaultTtlSeconds: m.defaultTtlSeconds
    });
  }
  function ie(m) {
    return new h.PingClient({
      endpoint: (0, d.getWebCacheEndpoint)(m.credentialProvider),
      configuration: m.configuration
    });
  }
  function se() {
    const m = l.Configurations.Browser.latest();
    return m.getLoggerFactory().getLogger("CacheClient").info("No configuration provided to CacheClient. Using default configuration. For production use, consider specifying an explicit configuration."), m;
  }
  return cacheClient;
}
var authClient$1 = {}, authClient = {}, hasRequiredAuthClient$1;
function requireAuthClient$1() {
  if (hasRequiredAuthClient$1) return authClient;
  hasRequiredAuthClient$1 = 1, Object.defineProperty(authClient, "__esModule", { value: !0 }), authClient.permissionsFromScope = authClient.InternalWebGrpcAuthClient = void 0;
  const p = dist, s = auth_pb$1, h = requireCacheServiceErrorMapper();
  var c = s._GenerateApiTokenRequest.Never, d = s._GenerateApiTokenRequest.Expires;
  const l = requireSrc$1(), g = utils$1, f = webClientUtils, _ = clientMetadataProvider, te = permissionScope, ae = disposableTokenScope, ie = token_pb$1, se = permissionmessages_pb;
  class m {
    constructor(pe) {
      var he;
      this.creds = pe.credentialProvider, this.cacheServiceErrorMapper = new h.CacheServiceErrorMapper((he = pe.throwOnErrors) !== null && he !== void 0 ? he : !1), this.clientMetadataProvider = new _.ClientMetadataProvider({
        clientType: "auth"
      }), this.authClient = new p.auth.AuthClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, f.getWebControlEndpoint)(this.creds),
        null,
        {}
      ), this.tokenClient = new p.token.TokenClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, f.getWebTokenEndpoint)(this.creds),
        null,
        {}
      );
    }
    async generateApiKey(pe, he) {
      const fe = new s._GenerateApiTokenRequest();
      fe.setAuthToken(this.creds.getAuthToken());
      let ye;
      try {
        ye = w(pe);
      } catch (Re) {
        return this.cacheServiceErrorMapper.returnOrThrowError(Re, (be) => new l.GenerateApiKey.Error(be));
      }
      if (fe.setPermissions(ye), he.doesExpire()) {
        try {
          (0, g.validateValidForSeconds)(he.seconds());
        } catch (be) {
          return this.cacheServiceErrorMapper.returnOrThrowError(be, (Me) => new l.GenerateApiKey.Error(Me));
        }
        const Re = new d();
        Re.setValidForSeconds(he.seconds()), fe.setExpires(Re);
      } else
        fe.setNever(new c());
      return await new Promise((Re, be) => {
        this.authClient.generateApiToken(fe, this.clientMetadataProvider.createClientMetadata(), (Me, ve) => {
          Me || !ve ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: Me,
            errorResponseFactoryFn: (we) => new l.GenerateApiKey.Error(we),
            resolveFn: Re,
            rejectFn: be
          }) : Re(new l.GenerateApiKey.Success(ve.getApiKey(), ve.getRefreshToken(), ve.getEndpoint(), l.ExpiresAt.fromEpoch(ve.getValidUntil())));
        });
      });
    }
    /**
     * @deprecated please use `generateApiKey` instead
     */
    generateAuthToken(pe, he) {
      return this.generateApiKey(pe, he);
    }
    async refreshApiKey(pe) {
      const he = new s._RefreshApiTokenRequest();
      return he.setApiKey(this.creds.getAuthToken()), he.setRefreshToken(pe), await new Promise((fe, ye) => {
        this.authClient.refreshApiToken(he, this.clientMetadataProvider.createClientMetadata(), (Re, be) => {
          Re || !be ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: Re,
            errorResponseFactoryFn: (Me) => new l.RefreshApiKey.Error(Me),
            resolveFn: fe,
            rejectFn: ye
          }) : fe(new l.RefreshApiKey.Success(be.getApiKey(), be.getRefreshToken(), be.getEndpoint(), l.ExpiresAt.fromEpoch(be.getValidUntil())));
        });
      });
    }
    /**
     * @deprecated please use `refreshApiKey` instead
     */
    refreshAuthToken(pe) {
      return this.refreshApiKey(pe);
    }
    async generateDisposableToken(pe, he, fe) {
      const ye = new ie._GenerateDisposableTokenRequest();
      ye.setAuthToken(this.creds.getAuthToken());
      let Re;
      try {
        Re = w(pe);
      } catch (ve) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ve, (we) => new l.GenerateDisposableToken.Error(we));
      }
      ye.setPermissions(Re);
      const be = fe == null ? void 0 : fe.tokenId;
      if (be !== void 0) {
        try {
          (0, g.validateDisposableTokenTokenID)(be);
        } catch (ve) {
          return this.cacheServiceErrorMapper.returnOrThrowError(ve, (we) => new l.GenerateDisposableToken.Error(we));
        }
        ye.setTokenId(be);
      }
      try {
        (0, g.validateDisposableTokenExpiry)(he);
      } catch (ve) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ve, (we) => new l.GenerateDisposableToken.Error(we));
      }
      const Me = new ie._GenerateDisposableTokenRequest.Expires();
      return Me.setValidForSeconds(he.seconds()), ye.setExpires(Me), await new Promise((ve, we) => {
        this.tokenClient.generateDisposableToken(ye, this.clientMetadataProvider.createClientMetadata(), (xe, We) => {
          xe || !We ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: xe,
            errorResponseFactoryFn: (He) => new l.GenerateDisposableToken.Error(He),
            resolveFn: ve,
            rejectFn: we
          }) : ve(new l.GenerateDisposableToken.Success(We.getApiKey(), We.getEndpoint(), l.ExpiresAt.fromEpoch(We.getValidUntil())));
        });
      });
    }
  }
  authClient.InternalWebGrpcAuthClient = m;
  function w(ue) {
    const pe = new se.Permissions();
    if (ue instanceof g.InternalSuperUserPermissions)
      return pe.setSuperUser(se.SuperUserPermissions.SUPERUSER), pe;
    if (!(ue instanceof te.PredefinedScope) && (0, ae.isDisposableTokenPermissionsObject)(ue)) {
      const he = (0, ae.asDisposableTokenPermissionsObject)(ue), fe = new se.ExplicitPermissions();
      return fe.setPermissionsList(he.permissions.map((ye) => oe(ye))), pe.setExplicit(fe), pe;
    } else if ((0, te.isPermissionsObject)(ue)) {
      const he = (0, te.asPermissionsObject)(ue), fe = new se.ExplicitPermissions();
      return fe.setPermissionsList(he.permissions.map((ye) => q(ye))), pe.setExplicit(fe), pe;
    }
    throw new Error(`Unrecognized token scope: ${JSON.stringify(ue)}`);
  }
  authClient.permissionsFromScope = w;
  function q(ue) {
    const pe = new se.PermissionsType();
    if ((0, te.isTopicPermission)(ue))
      return pe.setTopicPermissions(j((0, te.asTopicPermission)(ue))), pe;
    if ((0, te.isCachePermission)(ue))
      return pe.setCachePermissions(re((0, te.asCachePermission)(ue))), pe;
    throw new Error(`Unrecognized token permission: ${JSON.stringify(ue)}`);
  }
  function j(ue) {
    const pe = new se.PermissionsType.TopicPermissions();
    switch (ue.role) {
      case l.TopicRole.PublishSubscribe: {
        pe.setRole(se.TopicRole.TOPICREADWRITE);
        break;
      }
      case l.TopicRole.SubscribeOnly: {
        pe.setRole(se.TopicRole.TOPICREADONLY);
        break;
      }
      case l.TopicRole.PublishOnly: {
        pe.setRole(se.TopicRole.TOPICWRITEONLY);
        break;
      }
      default:
        throw new Error(`Unrecognized topic role: ${JSON.stringify(ue)}`);
    }
    const he = new se.PermissionsType.CacheSelector();
    if (ue.cache === l.AllCaches)
      pe.setAllCaches(new se.PermissionsType.All());
    else if (typeof ue.cache == "string")
      he.setCacheName(ue.cache), pe.setCacheSelector(he);
    else if ((0, l.isCacheName)(ue.cache))
      he.setCacheName(ue.cache.name), pe.setCacheSelector(he);
    else
      throw new Error(`Unrecognized cache specification in topic permission: ${JSON.stringify(ue)}`);
    const fe = new se.PermissionsType.TopicSelector();
    if (ue.topic === l.AllTopics)
      pe.setAllTopics(new se.PermissionsType.All());
    else if (typeof ue.topic == "string")
      fe.setTopicName(ue.topic), pe.setTopicSelector(fe);
    else if ((0, l.isTopicName)(ue.topic))
      fe.setTopicName(ue.topic.name), pe.setTopicSelector(fe);
    else
      throw new Error(`Unrecognized topic specification in topic permission: ${JSON.stringify(ue)}`);
    return pe;
  }
  function k(ue, pe) {
    switch (ue.role) {
      case l.CacheRole.ReadWrite: {
        pe.setRole(se.CacheRole.CACHEREADWRITE);
        break;
      }
      case l.CacheRole.ReadOnly: {
        pe.setRole(se.CacheRole.CACHEREADONLY);
        break;
      }
      case l.CacheRole.WriteOnly: {
        pe.setRole(se.CacheRole.CACHEWRITEONLY);
        break;
      }
      default:
        throw new Error(`Unrecognized cache role: ${JSON.stringify(ue)}`);
    }
    return pe;
  }
  function z(ue, pe) {
    const he = new se.PermissionsType.CacheSelector();
    if (ue.cache === l.AllCaches)
      pe.setAllCaches(new se.PermissionsType.All());
    else if (typeof ue.cache == "string")
      he.setCacheName(ue.cache), pe.setCacheSelector(he);
    else if ((0, l.isCacheName)(ue.cache))
      he.setCacheName(ue.cache.name), pe.setCacheSelector(he);
    else
      throw new Error(`Unrecognized cache specification in cache permission: ${JSON.stringify(ue)}`);
    return pe;
  }
  function $(ue, pe) {
    const he = new se.PermissionsType.CacheItemSelector();
    if (ue.item === l.AllCacheItems)
      pe.setAllItems(new se.PermissionsType.All());
    else if (typeof ue.item == "string")
      he.setKey((0, f.convertToB64String)(ue.item)), pe.setItemSelector(he);
    else if ((0, l.isCacheItemKey)(ue.item))
      (0, g.validateCacheKeyOrPrefix)(ue.item.key), he.setKey((0, f.convertToB64String)(ue.item.key)), pe.setItemSelector(he);
    else if ((0, l.isCacheItemKeyPrefix)(ue.item))
      (0, g.validateCacheKeyOrPrefix)(ue.item.keyPrefix), he.setKeyPrefix((0, f.convertToB64String)(ue.item.keyPrefix)), pe.setItemSelector(he);
    else
      throw new Error(`Unrecognized cache item specification in cache permission: ${JSON.stringify(ue)}`);
    return pe;
  }
  function re(ue) {
    let pe = new se.PermissionsType.CachePermissions();
    return pe = k(ue, pe), pe = z(ue, pe), pe;
  }
  function oe(ue) {
    const pe = new se.PermissionsType();
    if ((0, ae.isDisposableTokenCachePermission)(ue))
      return pe.setCachePermissions(le((0, ae.asDisposableTokenCachePermission)(ue))), pe;
    throw new Error(`Unrecognized token permission: ${JSON.stringify(ue)}`);
  }
  function le(ue) {
    let pe = new se.PermissionsType.CachePermissions();
    return pe = k(ue, pe), pe = z(ue, pe), pe = $(ue, pe), pe;
  }
  return authClient;
}
var hasRequiredAuthClient;
function requireAuthClient() {
  if (hasRequiredAuthClient) return authClient$1;
  hasRequiredAuthClient = 1, Object.defineProperty(authClient$1, "__esModule", { value: !0 }), authClient$1.AuthClient = void 0;
  const p = clients, s = requireAuthClient$1(), h = requireSrc$1();
  class c extends p.AbstractAuthClient {
    constructor(l) {
      const g = () => {
        var f;
        const _ = {
          ...l,
          credentialProvider: (f = l == null ? void 0 : l.credentialProvider) !== null && f !== void 0 ? f : (0, h.getDefaultCredentialProvider)()
        };
        return new s.InternalWebGrpcAuthClient(_);
      };
      super({ createAuthClient: g });
    }
  }
  return authClient$1.AuthClient = c, authClient$1;
}
var topicClient = {}, pubsubClient = {}, CachepubsubServiceClientPb = {}, cachepubsub_pb$1 = {}, extensions_pb = {}, descriptor_pb = {};
(function(p) {
  var s = googleProtobuf, h = s, c = typeof globalThis != "undefined" && globalThis || typeof window != "undefined" && window || typeof c != "undefined" && c || typeof self != "undefined" && self || function() {
    return this;
  }.call(null) || Function("return this")();
  h.exportSymbol("proto.google.protobuf.DescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.DescriptorProto.ExtensionRange", null, c), h.exportSymbol("proto.google.protobuf.DescriptorProto.ReservedRange", null, c), h.exportSymbol("proto.google.protobuf.EnumDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.EnumDescriptorProto.EnumReservedRange", null, c), h.exportSymbol("proto.google.protobuf.EnumOptions", null, c), h.exportSymbol("proto.google.protobuf.EnumValueDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.EnumValueOptions", null, c), h.exportSymbol("proto.google.protobuf.ExtensionRangeOptions", null, c), h.exportSymbol("proto.google.protobuf.FieldDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.FieldDescriptorProto.Label", null, c), h.exportSymbol("proto.google.protobuf.FieldDescriptorProto.Type", null, c), h.exportSymbol("proto.google.protobuf.FieldOptions", null, c), h.exportSymbol("proto.google.protobuf.FieldOptions.CType", null, c), h.exportSymbol("proto.google.protobuf.FieldOptions.JSType", null, c), h.exportSymbol("proto.google.protobuf.FileDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.FileDescriptorSet", null, c), h.exportSymbol("proto.google.protobuf.FileOptions", null, c), h.exportSymbol("proto.google.protobuf.FileOptions.OptimizeMode", null, c), h.exportSymbol("proto.google.protobuf.GeneratedCodeInfo", null, c), h.exportSymbol("proto.google.protobuf.GeneratedCodeInfo.Annotation", null, c), h.exportSymbol("proto.google.protobuf.MessageOptions", null, c), h.exportSymbol("proto.google.protobuf.MethodDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.MethodOptions", null, c), h.exportSymbol("proto.google.protobuf.MethodOptions.IdempotencyLevel", null, c), h.exportSymbol("proto.google.protobuf.OneofDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.OneofOptions", null, c), h.exportSymbol("proto.google.protobuf.ServiceDescriptorProto", null, c), h.exportSymbol("proto.google.protobuf.ServiceOptions", null, c), h.exportSymbol("proto.google.protobuf.SourceCodeInfo", null, c), h.exportSymbol("proto.google.protobuf.SourceCodeInfo.Location", null, c), h.exportSymbol("proto.google.protobuf.UninterpretedOption", null, c), h.exportSymbol("proto.google.protobuf.UninterpretedOption.NamePart", null, c), proto.google.protobuf.FileDescriptorSet = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.FileDescriptorSet.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.FileDescriptorSet, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.FileDescriptorSet.displayName = "proto.google.protobuf.FileDescriptorSet"), proto.google.protobuf.FileDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.FileDescriptorProto.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.FileDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.FileDescriptorProto.displayName = "proto.google.protobuf.FileDescriptorProto"), proto.google.protobuf.DescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.DescriptorProto.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.DescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.DescriptorProto.displayName = "proto.google.protobuf.DescriptorProto"), proto.google.protobuf.DescriptorProto.ExtensionRange = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.DescriptorProto.ExtensionRange, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.DescriptorProto.ExtensionRange.displayName = "proto.google.protobuf.DescriptorProto.ExtensionRange"), proto.google.protobuf.DescriptorProto.ReservedRange = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.DescriptorProto.ReservedRange, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.DescriptorProto.ReservedRange.displayName = "proto.google.protobuf.DescriptorProto.ReservedRange"), proto.google.protobuf.ExtensionRangeOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.ExtensionRangeOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.ExtensionRangeOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.ExtensionRangeOptions.displayName = "proto.google.protobuf.ExtensionRangeOptions"), proto.google.protobuf.ExtensionRangeOptions.extensions = {}, proto.google.protobuf.ExtensionRangeOptions.extensionsBinary = {}, proto.google.protobuf.FieldDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.FieldDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.FieldDescriptorProto.displayName = "proto.google.protobuf.FieldDescriptorProto"), proto.google.protobuf.OneofDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.OneofDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.OneofDescriptorProto.displayName = "proto.google.protobuf.OneofDescriptorProto"), proto.google.protobuf.EnumDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.EnumDescriptorProto.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.EnumDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.EnumDescriptorProto.displayName = "proto.google.protobuf.EnumDescriptorProto"), proto.google.protobuf.EnumDescriptorProto.EnumReservedRange = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.displayName = "proto.google.protobuf.EnumDescriptorProto.EnumReservedRange"), proto.google.protobuf.EnumValueDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.EnumValueDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.EnumValueDescriptorProto.displayName = "proto.google.protobuf.EnumValueDescriptorProto"), proto.google.protobuf.ServiceDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.ServiceDescriptorProto.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.ServiceDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.ServiceDescriptorProto.displayName = "proto.google.protobuf.ServiceDescriptorProto"), proto.google.protobuf.MethodDescriptorProto = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.MethodDescriptorProto, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.MethodDescriptorProto.displayName = "proto.google.protobuf.MethodDescriptorProto"), proto.google.protobuf.FileOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.FileOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.FileOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.FileOptions.displayName = "proto.google.protobuf.FileOptions"), proto.google.protobuf.FileOptions.extensions = {}, proto.google.protobuf.FileOptions.extensionsBinary = {}, proto.google.protobuf.MessageOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.MessageOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.MessageOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.MessageOptions.displayName = "proto.google.protobuf.MessageOptions"), proto.google.protobuf.MessageOptions.extensions = {}, proto.google.protobuf.MessageOptions.extensionsBinary = {}, proto.google.protobuf.FieldOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.FieldOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.FieldOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.FieldOptions.displayName = "proto.google.protobuf.FieldOptions"), proto.google.protobuf.FieldOptions.extensions = {}, proto.google.protobuf.FieldOptions.extensionsBinary = {}, proto.google.protobuf.OneofOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.OneofOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.OneofOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.OneofOptions.displayName = "proto.google.protobuf.OneofOptions"), proto.google.protobuf.OneofOptions.extensions = {}, proto.google.protobuf.OneofOptions.extensionsBinary = {}, proto.google.protobuf.EnumOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.EnumOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.EnumOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.EnumOptions.displayName = "proto.google.protobuf.EnumOptions"), proto.google.protobuf.EnumOptions.extensions = {}, proto.google.protobuf.EnumOptions.extensionsBinary = {}, proto.google.protobuf.EnumValueOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.EnumValueOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.EnumValueOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.EnumValueOptions.displayName = "proto.google.protobuf.EnumValueOptions"), proto.google.protobuf.EnumValueOptions.extensions = {}, proto.google.protobuf.EnumValueOptions.extensionsBinary = {}, proto.google.protobuf.ServiceOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.ServiceOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.ServiceOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.ServiceOptions.displayName = "proto.google.protobuf.ServiceOptions"), proto.google.protobuf.ServiceOptions.extensions = {}, proto.google.protobuf.ServiceOptions.extensionsBinary = {}, proto.google.protobuf.MethodOptions = function(d) {
    s.Message.initialize(this, d, 0, 500, proto.google.protobuf.MethodOptions.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.MethodOptions, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.MethodOptions.displayName = "proto.google.protobuf.MethodOptions"), proto.google.protobuf.MethodOptions.extensions = {}, proto.google.protobuf.MethodOptions.extensionsBinary = {}, proto.google.protobuf.UninterpretedOption = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.UninterpretedOption.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.UninterpretedOption, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.UninterpretedOption.displayName = "proto.google.protobuf.UninterpretedOption"), proto.google.protobuf.UninterpretedOption.NamePart = function(d) {
    s.Message.initialize(this, d, 0, -1, null, null);
  }, h.inherits(proto.google.protobuf.UninterpretedOption.NamePart, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.UninterpretedOption.NamePart.displayName = "proto.google.protobuf.UninterpretedOption.NamePart"), proto.google.protobuf.SourceCodeInfo = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.SourceCodeInfo.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.SourceCodeInfo, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.SourceCodeInfo.displayName = "proto.google.protobuf.SourceCodeInfo"), proto.google.protobuf.SourceCodeInfo.Location = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.SourceCodeInfo.Location, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.SourceCodeInfo.Location.displayName = "proto.google.protobuf.SourceCodeInfo.Location"), proto.google.protobuf.GeneratedCodeInfo = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.GeneratedCodeInfo.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.GeneratedCodeInfo, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.GeneratedCodeInfo.displayName = "proto.google.protobuf.GeneratedCodeInfo"), proto.google.protobuf.GeneratedCodeInfo.Annotation = function(d) {
    s.Message.initialize(this, d, 0, -1, proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_, null);
  }, h.inherits(proto.google.protobuf.GeneratedCodeInfo.Annotation, s.Message), h.DEBUG && !COMPILED && (proto.google.protobuf.GeneratedCodeInfo.Annotation.displayName = "proto.google.protobuf.GeneratedCodeInfo.Annotation"), proto.google.protobuf.FileDescriptorSet.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FileDescriptorSet.prototype.toObject = function(d) {
    return proto.google.protobuf.FileDescriptorSet.toObject(d, this);
  }, proto.google.protobuf.FileDescriptorSet.toObject = function(d, l) {
    var g = {
      fileList: s.Message.toObjectList(
        l.getFileList(),
        proto.google.protobuf.FileDescriptorProto.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.FileDescriptorSet.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.FileDescriptorSet();
    return proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new proto.google.protobuf.FileDescriptorProto();
          l.readMessage(f, proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader), d.addFile(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.FileDescriptorSet.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getFileList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter
    );
  }, proto.google.protobuf.FileDescriptorSet.prototype.getFileList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FileDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.FileDescriptorProto, 1)
    );
  }, proto.google.protobuf.FileDescriptorSet.prototype.setFileList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, proto.google.protobuf.FileDescriptorSet.prototype.addFile = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, proto.google.protobuf.FileDescriptorProto, l);
  }, proto.google.protobuf.FileDescriptorSet.prototype.clearFileList = function() {
    return this.setFileList([]);
  }, proto.google.protobuf.FileDescriptorProto.repeatedFields_ = [3, 10, 11, 4, 5, 6, 7], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FileDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.FileDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.FileDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      pb_package: (g = s.Message.getField(l, 2)) == null ? void 0 : g,
      dependencyList: (g = s.Message.getRepeatedField(l, 3)) == null ? void 0 : g,
      publicDependencyList: (g = s.Message.getRepeatedField(l, 10)) == null ? void 0 : g,
      weakDependencyList: (g = s.Message.getRepeatedField(l, 11)) == null ? void 0 : g,
      messageTypeList: s.Message.toObjectList(
        l.getMessageTypeList(),
        proto.google.protobuf.DescriptorProto.toObject,
        d
      ),
      enumTypeList: s.Message.toObjectList(
        l.getEnumTypeList(),
        proto.google.protobuf.EnumDescriptorProto.toObject,
        d
      ),
      serviceList: s.Message.toObjectList(
        l.getServiceList(),
        proto.google.protobuf.ServiceDescriptorProto.toObject,
        d
      ),
      extensionList: s.Message.toObjectList(
        l.getExtensionList(),
        proto.google.protobuf.FieldDescriptorProto.toObject,
        d
      ),
      options: (g = l.getOptions()) && proto.google.protobuf.FileOptions.toObject(d, g),
      sourceCodeInfo: (g = l.getSourceCodeInfo()) && proto.google.protobuf.SourceCodeInfo.toObject(d, g),
      syntax: (g = s.Message.getField(l, 12)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.FileDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.FileDescriptorProto();
    return proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.setName(te);
          break;
        case 2:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.setPackage(te);
          break;
        case 3:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.addDependency(te);
          break;
        case 10:
          for (var _ = (
            /** @type {!Array<number>} */
            l.isDelimited() ? l.readPackedInt32() : [l.readInt32()]
          ), f = 0; f < _.length; f++)
            d.addPublicDependency(_[f]);
          break;
        case 11:
          for (var _ = (
            /** @type {!Array<number>} */
            l.isDelimited() ? l.readPackedInt32() : [l.readInt32()]
          ), f = 0; f < _.length; f++)
            d.addWeakDependency(_[f]);
          break;
        case 4:
          var te = new proto.google.protobuf.DescriptorProto();
          l.readMessage(te, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader), d.addMessageType(te);
          break;
        case 5:
          var te = new proto.google.protobuf.EnumDescriptorProto();
          l.readMessage(te, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader), d.addEnumType(te);
          break;
        case 6:
          var te = new proto.google.protobuf.ServiceDescriptorProto();
          l.readMessage(te, proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader), d.addService(te);
          break;
        case 7:
          var te = new proto.google.protobuf.FieldDescriptorProto();
          l.readMessage(te, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader), d.addExtension$(te);
          break;
        case 8:
          var te = new proto.google.protobuf.FileOptions();
          l.readMessage(te, proto.google.protobuf.FileOptions.deserializeBinaryFromReader), d.setOptions(te);
          break;
        case 9:
          var te = new proto.google.protobuf.SourceCodeInfo();
          l.readMessage(te, proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader), d.setSourceCodeInfo(te);
          break;
        case 12:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.setSyntax(te);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.FileDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 2), g != null && l.writeString(
      2,
      g
    ), g = d.getDependencyList(), g.length > 0 && l.writeRepeatedString(
      3,
      g
    ), g = d.getPublicDependencyList(), g.length > 0 && l.writeRepeatedInt32(
      10,
      g
    ), g = d.getWeakDependencyList(), g.length > 0 && l.writeRepeatedInt32(
      11,
      g
    ), g = d.getMessageTypeList(), g.length > 0 && l.writeRepeatedMessage(
      4,
      g,
      proto.google.protobuf.DescriptorProto.serializeBinaryToWriter
    ), g = d.getEnumTypeList(), g.length > 0 && l.writeRepeatedMessage(
      5,
      g,
      proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter
    ), g = d.getServiceList(), g.length > 0 && l.writeRepeatedMessage(
      6,
      g,
      proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter
    ), g = d.getExtensionList(), g.length > 0 && l.writeRepeatedMessage(
      7,
      g,
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
    ), g = d.getOptions(), g != null && l.writeMessage(
      8,
      g,
      proto.google.protobuf.FileOptions.serializeBinaryToWriter
    ), g = d.getSourceCodeInfo(), g != null && l.writeMessage(
      9,
      g,
      proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter
    ), g = /** @type {string} */
    s.Message.getField(d, 12), g != null && l.writeString(
      12,
      g
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getPackage = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setPackage = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearPackage = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasPackage = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getDependencyList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 3)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setDependencyList = function(d) {
    return s.Message.setField(this, 3, d || []);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addDependency = function(d, l) {
    return s.Message.addToRepeatedField(this, 3, d, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearDependencyList = function() {
    return this.setDependencyList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getPublicDependencyList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 10)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setPublicDependencyList = function(d) {
    return s.Message.setField(this, 10, d || []);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addPublicDependency = function(d, l) {
    return s.Message.addToRepeatedField(this, 10, d, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearPublicDependencyList = function() {
    return this.setPublicDependencyList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getWeakDependencyList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 11)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setWeakDependencyList = function(d) {
    return s.Message.setField(this, 11, d || []);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addWeakDependency = function(d, l) {
    return s.Message.addToRepeatedField(this, 11, d, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearWeakDependencyList = function() {
    return this.setWeakDependencyList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getMessageTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 4)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setMessageTypeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 4, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addMessageType = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 4, d, proto.google.protobuf.DescriptorProto, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearMessageTypeList = function() {
    return this.setMessageTypeList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getEnumTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 5)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setEnumTypeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 5, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addEnumType = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 5, d, proto.google.protobuf.EnumDescriptorProto, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearEnumTypeList = function() {
    return this.setEnumTypeList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getServiceList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.ServiceDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.ServiceDescriptorProto, 6)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setServiceList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 6, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addService = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 6, d, proto.google.protobuf.ServiceDescriptorProto, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearServiceList = function() {
    return this.setServiceList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getExtensionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 7)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setExtensionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 7, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.addExtension$ = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 7, d, proto.google.protobuf.FieldDescriptorProto, l);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearExtensionList = function() {
    return this.setExtensionList([]);
  }, proto.google.protobuf.FileDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.FileOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.FileOptions, 8)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 8, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 8) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getSourceCodeInfo = function() {
    return (
      /** @type{?proto.google.protobuf.SourceCodeInfo} */
      s.Message.getWrapperField(this, proto.google.protobuf.SourceCodeInfo, 9)
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setSourceCodeInfo = function(d) {
    return s.Message.setWrapperField(this, 9, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearSourceCodeInfo = function() {
    return this.setSourceCodeInfo(void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasSourceCodeInfo = function() {
    return s.Message.getField(this, 9) != null;
  }, proto.google.protobuf.FileDescriptorProto.prototype.getSyntax = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 12, "")
    );
  }, proto.google.protobuf.FileDescriptorProto.prototype.setSyntax = function(d) {
    return s.Message.setField(this, 12, d);
  }, proto.google.protobuf.FileDescriptorProto.prototype.clearSyntax = function() {
    return s.Message.setField(this, 12, void 0);
  }, proto.google.protobuf.FileDescriptorProto.prototype.hasSyntax = function() {
    return s.Message.getField(this, 12) != null;
  }, proto.google.protobuf.DescriptorProto.repeatedFields_ = [2, 6, 3, 4, 5, 8, 9, 10], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.DescriptorProto.toObject(d, this);
  }, proto.google.protobuf.DescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      fieldList: s.Message.toObjectList(
        l.getFieldList(),
        proto.google.protobuf.FieldDescriptorProto.toObject,
        d
      ),
      extensionList: s.Message.toObjectList(
        l.getExtensionList(),
        proto.google.protobuf.FieldDescriptorProto.toObject,
        d
      ),
      nestedTypeList: s.Message.toObjectList(
        l.getNestedTypeList(),
        proto.google.protobuf.DescriptorProto.toObject,
        d
      ),
      enumTypeList: s.Message.toObjectList(
        l.getEnumTypeList(),
        proto.google.protobuf.EnumDescriptorProto.toObject,
        d
      ),
      extensionRangeList: s.Message.toObjectList(
        l.getExtensionRangeList(),
        proto.google.protobuf.DescriptorProto.ExtensionRange.toObject,
        d
      ),
      oneofDeclList: s.Message.toObjectList(
        l.getOneofDeclList(),
        proto.google.protobuf.OneofDescriptorProto.toObject,
        d
      ),
      options: (g = l.getOptions()) && proto.google.protobuf.MessageOptions.toObject(d, g),
      reservedRangeList: s.Message.toObjectList(
        l.getReservedRangeList(),
        proto.google.protobuf.DescriptorProto.ReservedRange.toObject,
        d
      ),
      reservedNameList: (g = s.Message.getRepeatedField(l, 10)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.DescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.DescriptorProto();
    return proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 2:
          var f = new proto.google.protobuf.FieldDescriptorProto();
          l.readMessage(f, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader), d.addField(f);
          break;
        case 6:
          var f = new proto.google.protobuf.FieldDescriptorProto();
          l.readMessage(f, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader), d.addExtension$(f);
          break;
        case 3:
          var f = new proto.google.protobuf.DescriptorProto();
          l.readMessage(f, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader), d.addNestedType(f);
          break;
        case 4:
          var f = new proto.google.protobuf.EnumDescriptorProto();
          l.readMessage(f, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader), d.addEnumType(f);
          break;
        case 5:
          var f = new proto.google.protobuf.DescriptorProto.ExtensionRange();
          l.readMessage(f, proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader), d.addExtensionRange(f);
          break;
        case 8:
          var f = new proto.google.protobuf.OneofDescriptorProto();
          l.readMessage(f, proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader), d.addOneofDecl(f);
          break;
        case 7:
          var f = new proto.google.protobuf.MessageOptions();
          l.readMessage(f, proto.google.protobuf.MessageOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        case 9:
          var f = new proto.google.protobuf.DescriptorProto.ReservedRange();
          l.readMessage(f, proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader), d.addReservedRange(f);
          break;
        case 10:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.addReservedName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.DescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.DescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.DescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = d.getFieldList(), g.length > 0 && l.writeRepeatedMessage(
      2,
      g,
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
    ), g = d.getExtensionList(), g.length > 0 && l.writeRepeatedMessage(
      6,
      g,
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
    ), g = d.getNestedTypeList(), g.length > 0 && l.writeRepeatedMessage(
      3,
      g,
      proto.google.protobuf.DescriptorProto.serializeBinaryToWriter
    ), g = d.getEnumTypeList(), g.length > 0 && l.writeRepeatedMessage(
      4,
      g,
      proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter
    ), g = d.getExtensionRangeList(), g.length > 0 && l.writeRepeatedMessage(
      5,
      g,
      proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter
    ), g = d.getOneofDeclList(), g.length > 0 && l.writeRepeatedMessage(
      8,
      g,
      proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter
    ), g = d.getOptions(), g != null && l.writeMessage(
      7,
      g,
      proto.google.protobuf.MessageOptions.serializeBinaryToWriter
    ), g = d.getReservedRangeList(), g.length > 0 && l.writeRepeatedMessage(
      9,
      g,
      proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter
    ), g = d.getReservedNameList(), g.length > 0 && l.writeRepeatedString(
      10,
      g
    );
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.toObject = function(d) {
    return proto.google.protobuf.DescriptorProto.ExtensionRange.toObject(d, this);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.toObject = function(d, l) {
    var g, f = {
      start: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      end: (g = s.Message.getField(l, 2)) == null ? void 0 : g,
      options: (g = l.getOptions()) && proto.google.protobuf.ExtensionRangeOptions.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.DescriptorProto.ExtensionRange();
    return proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setStart(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setEnd(f);
          break;
        case 3:
          var f = new proto.google.protobuf.ExtensionRangeOptions();
          l.readMessage(f, proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {number} */
    s.Message.getField(d, 1), g != null && l.writeInt32(
      1,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 2), g != null && l.writeInt32(
      2,
      g
    ), g = d.getOptions(), g != null && l.writeMessage(
      3,
      g,
      proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getStart = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setStart = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearStart = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasStart = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getEnd = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setEnd = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearEnd = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasEnd = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.ExtensionRangeOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.ExtensionRangeOptions, 3)
    );
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasOptions = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.DescriptorProto.ReservedRange.prototype.toObject = function(d) {
    return proto.google.protobuf.DescriptorProto.ReservedRange.toObject(d, this);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.toObject = function(d, l) {
    var g, f = {
      start: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      end: (g = s.Message.getField(l, 2)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.DescriptorProto.ReservedRange();
    return proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setStart(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setEnd(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {number} */
    s.Message.getField(d, 1), g != null && l.writeInt32(
      1,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 2), g != null && l.writeInt32(
      2,
      g
    );
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getStart = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setStart = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearStart = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasStart = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getEnd = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setEnd = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearEnd = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasEnd = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.DescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.DescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.DescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.DescriptorProto.prototype.getFieldList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 2)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setFieldList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 2, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addField = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 2, d, proto.google.protobuf.FieldDescriptorProto, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearFieldList = function() {
    return this.setFieldList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getExtensionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 6)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setExtensionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 6, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addExtension$ = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 6, d, proto.google.protobuf.FieldDescriptorProto, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearExtensionList = function() {
    return this.setExtensionList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getNestedTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 3)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setNestedTypeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 3, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addNestedType = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 3, d, proto.google.protobuf.DescriptorProto, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearNestedTypeList = function() {
    return this.setNestedTypeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getEnumTypeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 4)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setEnumTypeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 4, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addEnumType = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 4, d, proto.google.protobuf.EnumDescriptorProto, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearEnumTypeList = function() {
    return this.setEnumTypeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getExtensionRangeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ExtensionRange, 5)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setExtensionRangeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 5, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addExtensionRange = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 5, d, proto.google.protobuf.DescriptorProto.ExtensionRange, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearExtensionRangeList = function() {
    return this.setExtensionRangeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getOneofDeclList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.OneofDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.OneofDescriptorProto, 8)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setOneofDeclList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 8, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addOneofDecl = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 8, d, proto.google.protobuf.OneofDescriptorProto, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearOneofDeclList = function() {
    return this.setOneofDeclList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.MessageOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.MessageOptions, 7)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 7, d);
  }, proto.google.protobuf.DescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.DescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 7) != null;
  }, proto.google.protobuf.DescriptorProto.prototype.getReservedRangeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ReservedRange, 9)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setReservedRangeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 9, d);
  }, proto.google.protobuf.DescriptorProto.prototype.addReservedRange = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 9, d, proto.google.protobuf.DescriptorProto.ReservedRange, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearReservedRangeList = function() {
    return this.setReservedRangeList([]);
  }, proto.google.protobuf.DescriptorProto.prototype.getReservedNameList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 10)
    );
  }, proto.google.protobuf.DescriptorProto.prototype.setReservedNameList = function(d) {
    return s.Message.setField(this, 10, d || []);
  }, proto.google.protobuf.DescriptorProto.prototype.addReservedName = function(d, l) {
    return s.Message.addToRepeatedField(this, 10, d, l);
  }, proto.google.protobuf.DescriptorProto.prototype.clearReservedNameList = function() {
    return this.setReservedNameList([]);
  }, proto.google.protobuf.ExtensionRangeOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ExtensionRangeOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.ExtensionRangeOptions.toObject(d, this);
  }, proto.google.protobuf.ExtensionRangeOptions.toObject = function(d, l) {
    var g = {
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      g,
      proto.google.protobuf.ExtensionRangeOptions.extensions,
      proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension,
      d
    ), d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.ExtensionRangeOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.ExtensionRangeOptions();
    return proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.ExtensionRangeOptions.extensionsBinary,
            proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension,
            proto.google.protobuf.ExtensionRangeOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.ExtensionRangeOptions.extensionsBinary,
      proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension
    );
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.ExtensionRangeOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FieldDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.FieldDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.FieldDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      number: (g = s.Message.getField(l, 3)) == null ? void 0 : g,
      label: (g = s.Message.getField(l, 4)) == null ? void 0 : g,
      type: (g = s.Message.getField(l, 5)) == null ? void 0 : g,
      typeName: (g = s.Message.getField(l, 6)) == null ? void 0 : g,
      extendee: (g = s.Message.getField(l, 2)) == null ? void 0 : g,
      defaultValue: (g = s.Message.getField(l, 7)) == null ? void 0 : g,
      oneofIndex: (g = s.Message.getField(l, 9)) == null ? void 0 : g,
      jsonName: (g = s.Message.getField(l, 10)) == null ? void 0 : g,
      options: (g = l.getOptions()) && proto.google.protobuf.FieldOptions.toObject(d, g),
      proto3Optional: (g = s.Message.getBooleanField(l, 17)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.FieldDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.FieldDescriptorProto();
    return proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 3:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setNumber(f);
          break;
        case 4:
          var f = (
            /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */
            l.readEnum()
          );
          d.setLabel(f);
          break;
        case 5:
          var f = (
            /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */
            l.readEnum()
          );
          d.setType(f);
          break;
        case 6:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setTypeName(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setExtendee(f);
          break;
        case 7:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setDefaultValue(f);
          break;
        case 9:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setOneofIndex(f);
          break;
        case 10:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setJsonName(f);
          break;
        case 8:
          var f = new proto.google.protobuf.FieldOptions();
          l.readMessage(f, proto.google.protobuf.FieldOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        case 17:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setProto3Optional(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 3), g != null && l.writeInt32(
      3,
      g
    ), g = /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */
    s.Message.getField(d, 4), g != null && l.writeEnum(
      4,
      g
    ), g = /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */
    s.Message.getField(d, 5), g != null && l.writeEnum(
      5,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 6), g != null && l.writeString(
      6,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 2), g != null && l.writeString(
      2,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 7), g != null && l.writeString(
      7,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 9), g != null && l.writeInt32(
      9,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 10), g != null && l.writeString(
      10,
      g
    ), g = d.getOptions(), g != null && l.writeMessage(
      8,
      g,
      proto.google.protobuf.FieldOptions.serializeBinaryToWriter
    ), g = /** @type {boolean} */
    s.Message.getField(d, 17), g != null && l.writeBool(
      17,
      g
    );
  }, proto.google.protobuf.FieldDescriptorProto.Type = {
    TYPE_DOUBLE: 1,
    TYPE_FLOAT: 2,
    TYPE_INT64: 3,
    TYPE_UINT64: 4,
    TYPE_INT32: 5,
    TYPE_FIXED64: 6,
    TYPE_FIXED32: 7,
    TYPE_BOOL: 8,
    TYPE_STRING: 9,
    TYPE_GROUP: 10,
    TYPE_MESSAGE: 11,
    TYPE_BYTES: 12,
    TYPE_UINT32: 13,
    TYPE_ENUM: 14,
    TYPE_SFIXED32: 15,
    TYPE_SFIXED64: 16,
    TYPE_SINT32: 17,
    TYPE_SINT64: 18
  }, proto.google.protobuf.FieldDescriptorProto.Label = {
    LABEL_OPTIONAL: 1,
    LABEL_REQUIRED: 2,
    LABEL_REPEATED: 3
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getNumber = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setNumber = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearNumber = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasNumber = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getLabel = function() {
    return (
      /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */
      s.Message.getFieldWithDefault(this, 4, 1)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setLabel = function(d) {
    return s.Message.setField(this, 4, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearLabel = function() {
    return s.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasLabel = function() {
    return s.Message.getField(this, 4) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getType = function() {
    return (
      /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */
      s.Message.getFieldWithDefault(this, 5, 1)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setType = function(d) {
    return s.Message.setField(this, 5, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearType = function() {
    return s.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasType = function() {
    return s.Message.getField(this, 5) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getTypeName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 6, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setTypeName = function(d) {
    return s.Message.setField(this, 6, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearTypeName = function() {
    return s.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasTypeName = function() {
    return s.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getExtendee = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setExtendee = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearExtendee = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasExtendee = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getDefaultValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setDefaultValue = function(d) {
    return s.Message.setField(this, 7, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearDefaultValue = function() {
    return s.Message.setField(this, 7, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasDefaultValue = function() {
    return s.Message.getField(this, 7) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getOneofIndex = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 9, 0)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setOneofIndex = function(d) {
    return s.Message.setField(this, 9, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearOneofIndex = function() {
    return s.Message.setField(this, 9, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasOneofIndex = function() {
    return s.Message.getField(this, 9) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getJsonName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 10, "")
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setJsonName = function(d) {
    return s.Message.setField(this, 10, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearJsonName = function() {
    return s.Message.setField(this, 10, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasJsonName = function() {
    return s.Message.getField(this, 10) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.FieldOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.FieldOptions, 8)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 8, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 8) != null;
  }, proto.google.protobuf.FieldDescriptorProto.prototype.getProto3Optional = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 17, !1)
    );
  }, proto.google.protobuf.FieldDescriptorProto.prototype.setProto3Optional = function(d) {
    return s.Message.setField(this, 17, d);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.clearProto3Optional = function() {
    return s.Message.setField(this, 17, void 0);
  }, proto.google.protobuf.FieldDescriptorProto.prototype.hasProto3Optional = function() {
    return s.Message.getField(this, 17) != null;
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.OneofDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.OneofDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.OneofDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      options: (g = l.getOptions()) && proto.google.protobuf.OneofOptions.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.OneofDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.OneofDescriptorProto();
    return proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 2:
          var f = new proto.google.protobuf.OneofOptions();
          l.readMessage(f, proto.google.protobuf.OneofOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.OneofDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = d.getOptions(), g != null && l.writeMessage(
      2,
      g,
      proto.google.protobuf.OneofOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.OneofDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.OneofDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.OneofDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.OneofOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.OneofOptions, 2)
    );
  }, proto.google.protobuf.OneofDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 2, d);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.OneofDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumDescriptorProto.repeatedFields_ = [2, 4, 5], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.EnumDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.EnumDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      valueList: s.Message.toObjectList(
        l.getValueList(),
        proto.google.protobuf.EnumValueDescriptorProto.toObject,
        d
      ),
      options: (g = l.getOptions()) && proto.google.protobuf.EnumOptions.toObject(d, g),
      reservedRangeList: s.Message.toObjectList(
        l.getReservedRangeList(),
        proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject,
        d
      ),
      reservedNameList: (g = s.Message.getRepeatedField(l, 5)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.EnumDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.EnumDescriptorProto();
    return proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 2:
          var f = new proto.google.protobuf.EnumValueDescriptorProto();
          l.readMessage(f, proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader), d.addValue(f);
          break;
        case 3:
          var f = new proto.google.protobuf.EnumOptions();
          l.readMessage(f, proto.google.protobuf.EnumOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        case 4:
          var f = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange();
          l.readMessage(f, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader), d.addReservedRange(f);
          break;
        case 5:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.addReservedName(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = d.getValueList(), g.length > 0 && l.writeRepeatedMessage(
      2,
      g,
      proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter
    ), g = d.getOptions(), g != null && l.writeMessage(
      3,
      g,
      proto.google.protobuf.EnumOptions.serializeBinaryToWriter
    ), g = d.getReservedRangeList(), g.length > 0 && l.writeRepeatedMessage(
      4,
      g,
      proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter
    ), g = d.getReservedNameList(), g.length > 0 && l.writeRepeatedString(
      5,
      g
    );
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.toObject = function(d) {
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject(d, this);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject = function(d, l) {
    var g, f = {
      start: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      end: (g = s.Message.getField(l, 2)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange();
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setStart(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setEnd(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {number} */
    s.Message.getField(d, 1), g != null && l.writeInt32(
      1,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 2), g != null && l.writeInt32(
      2,
      g
    );
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getStart = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setStart = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearStart = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasStart = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getEnd = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setEnd = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearEnd = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasEnd = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getValueList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumValueDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumValueDescriptorProto, 2)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setValueList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 2, d);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.addValue = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 2, d, proto.google.protobuf.EnumValueDescriptorProto, l);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearValueList = function() {
    return this.setValueList([]);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.EnumOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.EnumOptions, 3)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getReservedRangeList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, 4)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setReservedRangeList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 4, d);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.addReservedRange = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 4, d, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, l);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedRangeList = function() {
    return this.setReservedRangeList([]);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.getReservedNameList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 5)
    );
  }, proto.google.protobuf.EnumDescriptorProto.prototype.setReservedNameList = function(d) {
    return s.Message.setField(this, 5, d || []);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.addReservedName = function(d, l) {
    return s.Message.addToRepeatedField(this, 5, d, l);
  }, proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedNameList = function() {
    return this.setReservedNameList([]);
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumValueDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.EnumValueDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.EnumValueDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      number: (g = s.Message.getField(l, 2)) == null ? void 0 : g,
      options: (g = l.getOptions()) && proto.google.protobuf.EnumValueOptions.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.EnumValueDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.EnumValueDescriptorProto();
    return proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 2:
          var f = (
            /** @type {number} */
            l.readInt32()
          );
          d.setNumber(f);
          break;
        case 3:
          var f = new proto.google.protobuf.EnumValueOptions();
          l.readMessage(f, proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 2), g != null && l.writeInt32(
      2,
      g
    ), g = d.getOptions(), g != null && l.writeMessage(
      3,
      g,
      proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.getNumber = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.setNumber = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.clearNumber = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.hasNumber = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.EnumValueOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.EnumValueOptions, 3)
    );
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.EnumValueDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.ServiceDescriptorProto.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ServiceDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.ServiceDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.ServiceDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      methodList: s.Message.toObjectList(
        l.getMethodList(),
        proto.google.protobuf.MethodDescriptorProto.toObject,
        d
      ),
      options: (g = l.getOptions()) && proto.google.protobuf.ServiceOptions.toObject(d, g)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.ServiceDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.ServiceDescriptorProto();
    return proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 2:
          var f = new proto.google.protobuf.MethodDescriptorProto();
          l.readMessage(f, proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader), d.addMethod(f);
          break;
        case 3:
          var f = new proto.google.protobuf.ServiceOptions();
          l.readMessage(f, proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = d.getMethodList(), g.length > 0 && l.writeRepeatedMessage(
      2,
      g,
      proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter
    ), g = d.getOptions(), g != null && l.writeMessage(
      3,
      g,
      proto.google.protobuf.ServiceOptions.serializeBinaryToWriter
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.getMethodList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.MethodDescriptorProto>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.MethodDescriptorProto, 2)
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.setMethodList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 2, d);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.addMethod = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 2, d, proto.google.protobuf.MethodDescriptorProto, l);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.clearMethodList = function() {
    return this.setMethodList([]);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.ServiceOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.ServiceOptions, 3)
    );
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 3, d);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.ServiceDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.MethodDescriptorProto.prototype.toObject = function(d) {
    return proto.google.protobuf.MethodDescriptorProto.toObject(d, this);
  }, proto.google.protobuf.MethodDescriptorProto.toObject = function(d, l) {
    var g, f = {
      name: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      inputType: (g = s.Message.getField(l, 2)) == null ? void 0 : g,
      outputType: (g = s.Message.getField(l, 3)) == null ? void 0 : g,
      options: (g = l.getOptions()) && proto.google.protobuf.MethodOptions.toObject(d, g),
      clientStreaming: s.Message.getBooleanFieldWithDefault(l, 5, !1),
      serverStreaming: s.Message.getBooleanFieldWithDefault(l, 6, !1)
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.MethodDescriptorProto.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.MethodDescriptorProto();
    return proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setName(f);
          break;
        case 2:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setInputType(f);
          break;
        case 3:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setOutputType(f);
          break;
        case 4:
          var f = new proto.google.protobuf.MethodOptions();
          l.readMessage(f, proto.google.protobuf.MethodOptions.deserializeBinaryFromReader), d.setOptions(f);
          break;
        case 5:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setClientStreaming(f);
          break;
        case 6:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setServerStreaming(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 2), g != null && l.writeString(
      2,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 3), g != null && l.writeString(
      3,
      g
    ), g = d.getOptions(), g != null && l.writeMessage(
      4,
      g,
      proto.google.protobuf.MethodOptions.serializeBinaryToWriter
    ), g = /** @type {boolean} */
    s.Message.getField(d, 5), g != null && l.writeBool(
      5,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 6), g != null && l.writeBool(
      6,
      g
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setName = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearName = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasName = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getInputType = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setInputType = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearInputType = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasInputType = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getOutputType = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setOutputType = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearOutputType = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasOutputType = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getOptions = function() {
    return (
      /** @type{?proto.google.protobuf.MethodOptions} */
      s.Message.getWrapperField(this, proto.google.protobuf.MethodOptions, 4)
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setOptions = function(d) {
    return s.Message.setWrapperField(this, 4, d);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasOptions = function() {
    return s.Message.getField(this, 4) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getClientStreaming = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setClientStreaming = function(d) {
    return s.Message.setField(this, 5, d);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearClientStreaming = function() {
    return s.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasClientStreaming = function() {
    return s.Message.getField(this, 5) != null;
  }, proto.google.protobuf.MethodDescriptorProto.prototype.getServerStreaming = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 6, !1)
    );
  }, proto.google.protobuf.MethodDescriptorProto.prototype.setServerStreaming = function(d) {
    return s.Message.setField(this, 6, d);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.clearServerStreaming = function() {
    return s.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.MethodDescriptorProto.prototype.hasServerStreaming = function() {
    return s.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FileOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FileOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.FileOptions.toObject(d, this);
  }, proto.google.protobuf.FileOptions.toObject = function(d, l) {
    var g, f = {
      javaPackage: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      javaOuterClassname: (g = s.Message.getField(l, 8)) == null ? void 0 : g,
      javaMultipleFiles: s.Message.getBooleanFieldWithDefault(l, 10, !1),
      javaGenerateEqualsAndHash: (g = s.Message.getBooleanField(l, 20)) == null ? void 0 : g,
      javaStringCheckUtf8: s.Message.getBooleanFieldWithDefault(l, 27, !1),
      optimizeFor: s.Message.getFieldWithDefault(l, 9, 1),
      goPackage: (g = s.Message.getField(l, 11)) == null ? void 0 : g,
      ccGenericServices: s.Message.getBooleanFieldWithDefault(l, 16, !1),
      javaGenericServices: s.Message.getBooleanFieldWithDefault(l, 17, !1),
      pyGenericServices: s.Message.getBooleanFieldWithDefault(l, 18, !1),
      phpGenericServices: s.Message.getBooleanFieldWithDefault(l, 42, !1),
      deprecated: s.Message.getBooleanFieldWithDefault(l, 23, !1),
      ccEnableArenas: s.Message.getBooleanFieldWithDefault(l, 31, !0),
      objcClassPrefix: (g = s.Message.getField(l, 36)) == null ? void 0 : g,
      csharpNamespace: (g = s.Message.getField(l, 37)) == null ? void 0 : g,
      swiftPrefix: (g = s.Message.getField(l, 39)) == null ? void 0 : g,
      phpClassPrefix: (g = s.Message.getField(l, 40)) == null ? void 0 : g,
      phpNamespace: (g = s.Message.getField(l, 41)) == null ? void 0 : g,
      phpMetadataNamespace: (g = s.Message.getField(l, 44)) == null ? void 0 : g,
      rubyPackage: (g = s.Message.getField(l, 45)) == null ? void 0 : g,
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      f,
      proto.google.protobuf.FileOptions.extensions,
      proto.google.protobuf.FileOptions.prototype.getExtension,
      d
    ), d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.FileOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.FileOptions();
    return proto.google.protobuf.FileOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.FileOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setJavaPackage(f);
          break;
        case 8:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setJavaOuterClassname(f);
          break;
        case 10:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setJavaMultipleFiles(f);
          break;
        case 20:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setJavaGenerateEqualsAndHash(f);
          break;
        case 27:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setJavaStringCheckUtf8(f);
          break;
        case 9:
          var f = (
            /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */
            l.readEnum()
          );
          d.setOptimizeFor(f);
          break;
        case 11:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setGoPackage(f);
          break;
        case 16:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setCcGenericServices(f);
          break;
        case 17:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setJavaGenericServices(f);
          break;
        case 18:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setPyGenericServices(f);
          break;
        case 42:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setPhpGenericServices(f);
          break;
        case 23:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 31:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setCcEnableArenas(f);
          break;
        case 36:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setObjcClassPrefix(f);
          break;
        case 37:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setCsharpNamespace(f);
          break;
        case 39:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setSwiftPrefix(f);
          break;
        case 40:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setPhpClassPrefix(f);
          break;
        case 41:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setPhpNamespace(f);
          break;
        case 44:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setPhpMetadataNamespace(f);
          break;
        case 45:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setRubyPackage(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.FileOptions.extensionsBinary,
            proto.google.protobuf.FileOptions.prototype.getExtension,
            proto.google.protobuf.FileOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.FileOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.FileOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.FileOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 8), g != null && l.writeString(
      8,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 10), g != null && l.writeBool(
      10,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 20), g != null && l.writeBool(
      20,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 27), g != null && l.writeBool(
      27,
      g
    ), g = /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */
    s.Message.getField(d, 9), g != null && l.writeEnum(
      9,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 11), g != null && l.writeString(
      11,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 16), g != null && l.writeBool(
      16,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 17), g != null && l.writeBool(
      17,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 18), g != null && l.writeBool(
      18,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 42), g != null && l.writeBool(
      42,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 23), g != null && l.writeBool(
      23,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 31), g != null && l.writeBool(
      31,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 36), g != null && l.writeString(
      36,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 37), g != null && l.writeString(
      37,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 39), g != null && l.writeString(
      39,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 40), g != null && l.writeString(
      40,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 41), g != null && l.writeString(
      41,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 44), g != null && l.writeString(
      44,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 45), g != null && l.writeString(
      45,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.FileOptions.extensionsBinary,
      proto.google.protobuf.FileOptions.prototype.getExtension
    );
  }, proto.google.protobuf.FileOptions.OptimizeMode = {
    SPEED: 1,
    CODE_SIZE: 2,
    LITE_RUNTIME: 3
  }, proto.google.protobuf.FileOptions.prototype.getJavaPackage = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaPackage = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaPackage = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaPackage = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaOuterClassname = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 8, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaOuterClassname = function(d) {
    return s.Message.setField(this, 8, d);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaOuterClassname = function() {
    return s.Message.setField(this, 8, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaOuterClassname = function() {
    return s.Message.getField(this, 8) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaMultipleFiles = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 10, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaMultipleFiles = function(d) {
    return s.Message.setField(this, 10, d);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaMultipleFiles = function() {
    return s.Message.setField(this, 10, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaMultipleFiles = function() {
    return s.Message.getField(this, 10) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaGenerateEqualsAndHash = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 20, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaGenerateEqualsAndHash = function(d) {
    return s.Message.setField(this, 20, d);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaGenerateEqualsAndHash = function() {
    return s.Message.setField(this, 20, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaGenerateEqualsAndHash = function() {
    return s.Message.getField(this, 20) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaStringCheckUtf8 = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 27, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaStringCheckUtf8 = function(d) {
    return s.Message.setField(this, 27, d);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaStringCheckUtf8 = function() {
    return s.Message.setField(this, 27, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaStringCheckUtf8 = function() {
    return s.Message.getField(this, 27) != null;
  }, proto.google.protobuf.FileOptions.prototype.getOptimizeFor = function() {
    return (
      /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */
      s.Message.getFieldWithDefault(this, 9, 1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setOptimizeFor = function(d) {
    return s.Message.setField(this, 9, d);
  }, proto.google.protobuf.FileOptions.prototype.clearOptimizeFor = function() {
    return s.Message.setField(this, 9, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasOptimizeFor = function() {
    return s.Message.getField(this, 9) != null;
  }, proto.google.protobuf.FileOptions.prototype.getGoPackage = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 11, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setGoPackage = function(d) {
    return s.Message.setField(this, 11, d);
  }, proto.google.protobuf.FileOptions.prototype.clearGoPackage = function() {
    return s.Message.setField(this, 11, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasGoPackage = function() {
    return s.Message.getField(this, 11) != null;
  }, proto.google.protobuf.FileOptions.prototype.getCcGenericServices = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 16, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setCcGenericServices = function(d) {
    return s.Message.setField(this, 16, d);
  }, proto.google.protobuf.FileOptions.prototype.clearCcGenericServices = function() {
    return s.Message.setField(this, 16, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasCcGenericServices = function() {
    return s.Message.getField(this, 16) != null;
  }, proto.google.protobuf.FileOptions.prototype.getJavaGenericServices = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 17, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setJavaGenericServices = function(d) {
    return s.Message.setField(this, 17, d);
  }, proto.google.protobuf.FileOptions.prototype.clearJavaGenericServices = function() {
    return s.Message.setField(this, 17, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasJavaGenericServices = function() {
    return s.Message.getField(this, 17) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPyGenericServices = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 18, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setPyGenericServices = function(d) {
    return s.Message.setField(this, 18, d);
  }, proto.google.protobuf.FileOptions.prototype.clearPyGenericServices = function() {
    return s.Message.setField(this, 18, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPyGenericServices = function() {
    return s.Message.getField(this, 18) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpGenericServices = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 42, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpGenericServices = function(d) {
    return s.Message.setField(this, 42, d);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpGenericServices = function() {
    return s.Message.setField(this, 42, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpGenericServices = function() {
    return s.Message.getField(this, 42) != null;
  }, proto.google.protobuf.FileOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 23, !1)
    );
  }, proto.google.protobuf.FileOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 23, d);
  }, proto.google.protobuf.FileOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 23, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 23) != null;
  }, proto.google.protobuf.FileOptions.prototype.getCcEnableArenas = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 31, !0)
    );
  }, proto.google.protobuf.FileOptions.prototype.setCcEnableArenas = function(d) {
    return s.Message.setField(this, 31, d);
  }, proto.google.protobuf.FileOptions.prototype.clearCcEnableArenas = function() {
    return s.Message.setField(this, 31, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasCcEnableArenas = function() {
    return s.Message.getField(this, 31) != null;
  }, proto.google.protobuf.FileOptions.prototype.getObjcClassPrefix = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 36, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setObjcClassPrefix = function(d) {
    return s.Message.setField(this, 36, d);
  }, proto.google.protobuf.FileOptions.prototype.clearObjcClassPrefix = function() {
    return s.Message.setField(this, 36, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasObjcClassPrefix = function() {
    return s.Message.getField(this, 36) != null;
  }, proto.google.protobuf.FileOptions.prototype.getCsharpNamespace = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 37, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setCsharpNamespace = function(d) {
    return s.Message.setField(this, 37, d);
  }, proto.google.protobuf.FileOptions.prototype.clearCsharpNamespace = function() {
    return s.Message.setField(this, 37, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasCsharpNamespace = function() {
    return s.Message.getField(this, 37) != null;
  }, proto.google.protobuf.FileOptions.prototype.getSwiftPrefix = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 39, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setSwiftPrefix = function(d) {
    return s.Message.setField(this, 39, d);
  }, proto.google.protobuf.FileOptions.prototype.clearSwiftPrefix = function() {
    return s.Message.setField(this, 39, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasSwiftPrefix = function() {
    return s.Message.getField(this, 39) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpClassPrefix = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 40, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpClassPrefix = function(d) {
    return s.Message.setField(this, 40, d);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpClassPrefix = function() {
    return s.Message.setField(this, 40, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpClassPrefix = function() {
    return s.Message.getField(this, 40) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpNamespace = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 41, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpNamespace = function(d) {
    return s.Message.setField(this, 41, d);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpNamespace = function() {
    return s.Message.setField(this, 41, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpNamespace = function() {
    return s.Message.getField(this, 41) != null;
  }, proto.google.protobuf.FileOptions.prototype.getPhpMetadataNamespace = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 44, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setPhpMetadataNamespace = function(d) {
    return s.Message.setField(this, 44, d);
  }, proto.google.protobuf.FileOptions.prototype.clearPhpMetadataNamespace = function() {
    return s.Message.setField(this, 44, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasPhpMetadataNamespace = function() {
    return s.Message.getField(this, 44) != null;
  }, proto.google.protobuf.FileOptions.prototype.getRubyPackage = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 45, "")
    );
  }, proto.google.protobuf.FileOptions.prototype.setRubyPackage = function(d) {
    return s.Message.setField(this, 45, d);
  }, proto.google.protobuf.FileOptions.prototype.clearRubyPackage = function() {
    return s.Message.setField(this, 45, void 0);
  }, proto.google.protobuf.FileOptions.prototype.hasRubyPackage = function() {
    return s.Message.getField(this, 45) != null;
  }, proto.google.protobuf.FileOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.FileOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.FileOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.FileOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.MessageOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.MessageOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.MessageOptions.toObject(d, this);
  }, proto.google.protobuf.MessageOptions.toObject = function(d, l) {
    var g, f = {
      messageSetWireFormat: s.Message.getBooleanFieldWithDefault(l, 1, !1),
      noStandardDescriptorAccessor: s.Message.getBooleanFieldWithDefault(l, 2, !1),
      deprecated: s.Message.getBooleanFieldWithDefault(l, 3, !1),
      mapEntry: (g = s.Message.getBooleanField(l, 7)) == null ? void 0 : g,
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      f,
      proto.google.protobuf.MessageOptions.extensions,
      proto.google.protobuf.MessageOptions.prototype.getExtension,
      d
    ), d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.MessageOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.MessageOptions();
    return proto.google.protobuf.MessageOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.MessageOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setMessageSetWireFormat(f);
          break;
        case 2:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setNoStandardDescriptorAccessor(f);
          break;
        case 3:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 7:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setMapEntry(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.MessageOptions.extensionsBinary,
            proto.google.protobuf.MessageOptions.prototype.getExtension,
            proto.google.protobuf.MessageOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.MessageOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.MessageOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.MessageOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {boolean} */
    s.Message.getField(d, 1), g != null && l.writeBool(
      1,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 2), g != null && l.writeBool(
      2,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 3), g != null && l.writeBool(
      3,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 7), g != null && l.writeBool(
      7,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.MessageOptions.extensionsBinary,
      proto.google.protobuf.MessageOptions.prototype.getExtension
    );
  }, proto.google.protobuf.MessageOptions.prototype.getMessageSetWireFormat = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setMessageSetWireFormat = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.MessageOptions.prototype.clearMessageSetWireFormat = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasMessageSetWireFormat = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getNoStandardDescriptorAccessor = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setNoStandardDescriptorAccessor = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.MessageOptions.prototype.clearNoStandardDescriptorAccessor = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasNoStandardDescriptorAccessor = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.MessageOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getMapEntry = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 7, !1)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setMapEntry = function(d) {
    return s.Message.setField(this, 7, d);
  }, proto.google.protobuf.MessageOptions.prototype.clearMapEntry = function() {
    return s.Message.setField(this, 7, void 0);
  }, proto.google.protobuf.MessageOptions.prototype.hasMapEntry = function() {
    return s.Message.getField(this, 7) != null;
  }, proto.google.protobuf.MessageOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.MessageOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.MessageOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.MessageOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.FieldOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.FieldOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.FieldOptions.toObject(d, this);
  }, proto.google.protobuf.FieldOptions.toObject = function(d, l) {
    var g, f = {
      ctype: s.Message.getFieldWithDefault(l, 1, 0),
      packed: (g = s.Message.getBooleanField(l, 2)) == null ? void 0 : g,
      jstype: s.Message.getFieldWithDefault(l, 6, 0),
      lazy: s.Message.getBooleanFieldWithDefault(l, 5, !1),
      unverifiedLazy: s.Message.getBooleanFieldWithDefault(l, 15, !1),
      deprecated: s.Message.getBooleanFieldWithDefault(l, 3, !1),
      weak: s.Message.getBooleanFieldWithDefault(l, 10, !1),
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      f,
      proto.google.protobuf.FieldOptions.extensions,
      proto.google.protobuf.FieldOptions.prototype.getExtension,
      d
    ), d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.FieldOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.FieldOptions();
    return proto.google.protobuf.FieldOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.FieldOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {!proto.google.protobuf.FieldOptions.CType} */
            l.readEnum()
          );
          d.setCtype(f);
          break;
        case 2:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setPacked(f);
          break;
        case 6:
          var f = (
            /** @type {!proto.google.protobuf.FieldOptions.JSType} */
            l.readEnum()
          );
          d.setJstype(f);
          break;
        case 5:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setLazy(f);
          break;
        case 15:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setUnverifiedLazy(f);
          break;
        case 3:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 10:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setWeak(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.FieldOptions.extensionsBinary,
            proto.google.protobuf.FieldOptions.prototype.getExtension,
            proto.google.protobuf.FieldOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.FieldOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.FieldOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.FieldOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {!proto.google.protobuf.FieldOptions.CType} */
    s.Message.getField(d, 1), g != null && l.writeEnum(
      1,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 2), g != null && l.writeBool(
      2,
      g
    ), g = /** @type {!proto.google.protobuf.FieldOptions.JSType} */
    s.Message.getField(d, 6), g != null && l.writeEnum(
      6,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 5), g != null && l.writeBool(
      5,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 15), g != null && l.writeBool(
      15,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 3), g != null && l.writeBool(
      3,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 10), g != null && l.writeBool(
      10,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.FieldOptions.extensionsBinary,
      proto.google.protobuf.FieldOptions.prototype.getExtension
    );
  }, proto.google.protobuf.FieldOptions.CType = {
    STRING: 0,
    CORD: 1,
    STRING_PIECE: 2
  }, proto.google.protobuf.FieldOptions.JSType = {
    JS_NORMAL: 0,
    JS_STRING: 1,
    JS_NUMBER: 2
  }, proto.google.protobuf.FieldOptions.prototype.getCtype = function() {
    return (
      /** @type {!proto.google.protobuf.FieldOptions.CType} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setCtype = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearCtype = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasCtype = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getPacked = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setPacked = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearPacked = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasPacked = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getJstype = function() {
    return (
      /** @type {!proto.google.protobuf.FieldOptions.JSType} */
      s.Message.getFieldWithDefault(this, 6, 0)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setJstype = function(d) {
    return s.Message.setField(this, 6, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearJstype = function() {
    return s.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasJstype = function() {
    return s.Message.getField(this, 6) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getLazy = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 5, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setLazy = function(d) {
    return s.Message.setField(this, 5, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearLazy = function() {
    return s.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasLazy = function() {
    return s.Message.getField(this, 5) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getUnverifiedLazy = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 15, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setUnverifiedLazy = function(d) {
    return s.Message.setField(this, 15, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearUnverifiedLazy = function() {
    return s.Message.setField(this, 15, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasUnverifiedLazy = function() {
    return s.Message.getField(this, 15) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getWeak = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 10, !1)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setWeak = function(d) {
    return s.Message.setField(this, 10, d);
  }, proto.google.protobuf.FieldOptions.prototype.clearWeak = function() {
    return s.Message.setField(this, 10, void 0);
  }, proto.google.protobuf.FieldOptions.prototype.hasWeak = function() {
    return s.Message.getField(this, 10) != null;
  }, proto.google.protobuf.FieldOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.FieldOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.FieldOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.FieldOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.OneofOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.OneofOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.OneofOptions.toObject(d, this);
  }, proto.google.protobuf.OneofOptions.toObject = function(d, l) {
    var g = {
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      g,
      proto.google.protobuf.OneofOptions.extensions,
      proto.google.protobuf.OneofOptions.prototype.getExtension,
      d
    ), d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.OneofOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.OneofOptions();
    return proto.google.protobuf.OneofOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.OneofOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.OneofOptions.extensionsBinary,
            proto.google.protobuf.OneofOptions.prototype.getExtension,
            proto.google.protobuf.OneofOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.OneofOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.OneofOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.OneofOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.OneofOptions.extensionsBinary,
      proto.google.protobuf.OneofOptions.prototype.getExtension
    );
  }, proto.google.protobuf.OneofOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.OneofOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.OneofOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.OneofOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.EnumOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.EnumOptions.toObject(d, this);
  }, proto.google.protobuf.EnumOptions.toObject = function(d, l) {
    var g, f = {
      allowAlias: (g = s.Message.getBooleanField(l, 2)) == null ? void 0 : g,
      deprecated: s.Message.getBooleanFieldWithDefault(l, 3, !1),
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      f,
      proto.google.protobuf.EnumOptions.extensions,
      proto.google.protobuf.EnumOptions.prototype.getExtension,
      d
    ), d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.EnumOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.EnumOptions();
    return proto.google.protobuf.EnumOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.EnumOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 2:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setAllowAlias(f);
          break;
        case 3:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.EnumOptions.extensionsBinary,
            proto.google.protobuf.EnumOptions.prototype.getExtension,
            proto.google.protobuf.EnumOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.EnumOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.EnumOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.EnumOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {boolean} */
    s.Message.getField(d, 2), g != null && l.writeBool(
      2,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 3), g != null && l.writeBool(
      3,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.EnumOptions.extensionsBinary,
      proto.google.protobuf.EnumOptions.prototype.getExtension
    );
  }, proto.google.protobuf.EnumOptions.prototype.getAllowAlias = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setAllowAlias = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.EnumOptions.prototype.clearAllowAlias = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.EnumOptions.prototype.hasAllowAlias = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.EnumOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 3, !1)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.EnumOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.EnumOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.EnumOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.EnumOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.EnumOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.EnumOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.EnumValueOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.EnumValueOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.EnumValueOptions.toObject(d, this);
  }, proto.google.protobuf.EnumValueOptions.toObject = function(d, l) {
    var g = {
      deprecated: s.Message.getBooleanFieldWithDefault(l, 1, !1),
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      g,
      proto.google.protobuf.EnumValueOptions.extensions,
      proto.google.protobuf.EnumValueOptions.prototype.getExtension,
      d
    ), d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.EnumValueOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.EnumValueOptions();
    return proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.EnumValueOptions.extensionsBinary,
            proto.google.protobuf.EnumValueOptions.prototype.getExtension,
            proto.google.protobuf.EnumValueOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.EnumValueOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {boolean} */
    s.Message.getField(d, 1), g != null && l.writeBool(
      1,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.EnumValueOptions.extensionsBinary,
      proto.google.protobuf.EnumValueOptions.prototype.getExtension
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 1, !1)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.EnumValueOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.EnumValueOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.EnumValueOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.EnumValueOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.EnumValueOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.ServiceOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.ServiceOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.ServiceOptions.toObject(d, this);
  }, proto.google.protobuf.ServiceOptions.toObject = function(d, l) {
    var g = {
      deprecated: s.Message.getBooleanFieldWithDefault(l, 33, !1),
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      g,
      proto.google.protobuf.ServiceOptions.extensions,
      proto.google.protobuf.ServiceOptions.prototype.getExtension,
      d
    ), d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.ServiceOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.ServiceOptions();
    return proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 33:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.ServiceOptions.extensionsBinary,
            proto.google.protobuf.ServiceOptions.prototype.getExtension,
            proto.google.protobuf.ServiceOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.ServiceOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.ServiceOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.ServiceOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {boolean} */
    s.Message.getField(d, 33), g != null && l.writeBool(
      33,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.ServiceOptions.extensionsBinary,
      proto.google.protobuf.ServiceOptions.prototype.getExtension
    );
  }, proto.google.protobuf.ServiceOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 33, !1)
    );
  }, proto.google.protobuf.ServiceOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 33, d);
  }, proto.google.protobuf.ServiceOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 33, void 0);
  }, proto.google.protobuf.ServiceOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 33) != null;
  }, proto.google.protobuf.ServiceOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.ServiceOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.ServiceOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.ServiceOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.MethodOptions.repeatedFields_ = [999], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.MethodOptions.prototype.toObject = function(d) {
    return proto.google.protobuf.MethodOptions.toObject(d, this);
  }, proto.google.protobuf.MethodOptions.toObject = function(d, l) {
    var g = {
      deprecated: s.Message.getBooleanFieldWithDefault(l, 33, !1),
      idempotencyLevel: s.Message.getFieldWithDefault(l, 34, 0),
      uninterpretedOptionList: s.Message.toObjectList(
        l.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject,
        d
      )
    };
    return s.Message.toObjectExtension(
      /** @type {!jspb.Message} */
      l,
      g,
      proto.google.protobuf.MethodOptions.extensions,
      proto.google.protobuf.MethodOptions.prototype.getExtension,
      d
    ), d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.MethodOptions.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.MethodOptions();
    return proto.google.protobuf.MethodOptions.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.MethodOptions.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 33:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setDeprecated(f);
          break;
        case 34:
          var f = (
            /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */
            l.readEnum()
          );
          d.setIdempotencyLevel(f);
          break;
        case 999:
          var f = new proto.google.protobuf.UninterpretedOption();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader), d.addUninterpretedOption(f);
          break;
        default:
          s.Message.readBinaryExtension(
            d,
            l,
            proto.google.protobuf.MethodOptions.extensionsBinary,
            proto.google.protobuf.MethodOptions.prototype.getExtension,
            proto.google.protobuf.MethodOptions.prototype.setExtension
          );
          break;
      }
    }
    return d;
  }, proto.google.protobuf.MethodOptions.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.MethodOptions.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.MethodOptions.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {boolean} */
    s.Message.getField(d, 33), g != null && l.writeBool(
      33,
      g
    ), g = /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */
    s.Message.getField(d, 34), g != null && l.writeEnum(
      34,
      g
    ), g = d.getUninterpretedOptionList(), g.length > 0 && l.writeRepeatedMessage(
      999,
      g,
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
    ), s.Message.serializeBinaryExtensions(
      d,
      l,
      proto.google.protobuf.MethodOptions.extensionsBinary,
      proto.google.protobuf.MethodOptions.prototype.getExtension
    );
  }, proto.google.protobuf.MethodOptions.IdempotencyLevel = {
    IDEMPOTENCY_UNKNOWN: 0,
    NO_SIDE_EFFECTS: 1,
    IDEMPOTENT: 2
  }, proto.google.protobuf.MethodOptions.prototype.getDeprecated = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 33, !1)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setDeprecated = function(d) {
    return s.Message.setField(this, 33, d);
  }, proto.google.protobuf.MethodOptions.prototype.clearDeprecated = function() {
    return s.Message.setField(this, 33, void 0);
  }, proto.google.protobuf.MethodOptions.prototype.hasDeprecated = function() {
    return s.Message.getField(this, 33) != null;
  }, proto.google.protobuf.MethodOptions.prototype.getIdempotencyLevel = function() {
    return (
      /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */
      s.Message.getFieldWithDefault(this, 34, 0)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setIdempotencyLevel = function(d) {
    return s.Message.setField(this, 34, d);
  }, proto.google.protobuf.MethodOptions.prototype.clearIdempotencyLevel = function() {
    return s.Message.setField(this, 34, void 0);
  }, proto.google.protobuf.MethodOptions.prototype.hasIdempotencyLevel = function() {
    return s.Message.getField(this, 34) != null;
  }, proto.google.protobuf.MethodOptions.prototype.getUninterpretedOptionList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999)
    );
  }, proto.google.protobuf.MethodOptions.prototype.setUninterpretedOptionList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 999, d);
  }, proto.google.protobuf.MethodOptions.prototype.addUninterpretedOption = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 999, d, proto.google.protobuf.UninterpretedOption, l);
  }, proto.google.protobuf.MethodOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
  }, proto.google.protobuf.UninterpretedOption.repeatedFields_ = [2], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UninterpretedOption.prototype.toObject = function(d) {
    return proto.google.protobuf.UninterpretedOption.toObject(d, this);
  }, proto.google.protobuf.UninterpretedOption.toObject = function(d, l) {
    var g, f = {
      nameList: s.Message.toObjectList(
        l.getNameList(),
        proto.google.protobuf.UninterpretedOption.NamePart.toObject,
        d
      ),
      identifierValue: (g = s.Message.getField(l, 3)) == null ? void 0 : g,
      positiveIntValue: (g = s.Message.getField(l, 4)) == null ? void 0 : g,
      negativeIntValue: (g = s.Message.getField(l, 5)) == null ? void 0 : g,
      doubleValue: (g = s.Message.getOptionalFloatingPointField(l, 6)) == null ? void 0 : g,
      stringValue: l.getStringValue_asB64(),
      aggregateValue: (g = s.Message.getField(l, 8)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.UninterpretedOption.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.UninterpretedOption();
    return proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 2:
          var f = new proto.google.protobuf.UninterpretedOption.NamePart();
          l.readMessage(f, proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader), d.addName(f);
          break;
        case 3:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setIdentifierValue(f);
          break;
        case 4:
          var f = (
            /** @type {number} */
            l.readUint64()
          );
          d.setPositiveIntValue(f);
          break;
        case 5:
          var f = (
            /** @type {number} */
            l.readInt64()
          );
          d.setNegativeIntValue(f);
          break;
        case 6:
          var f = (
            /** @type {number} */
            l.readDouble()
          );
          d.setDoubleValue(f);
          break;
        case 7:
          var f = (
            /** @type {!Uint8Array} */
            l.readBytes()
          );
          d.setStringValue(f);
          break;
        case 8:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setAggregateValue(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.UninterpretedOption.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getNameList(), g.length > 0 && l.writeRepeatedMessage(
      2,
      g,
      proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter
    ), g = /** @type {string} */
    s.Message.getField(d, 3), g != null && l.writeString(
      3,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 4), g != null && l.writeUint64(
      4,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 5), g != null && l.writeInt64(
      5,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 6), g != null && l.writeDouble(
      6,
      g
    ), g = /** @type {!(string|Uint8Array)} */
    s.Message.getField(d, 7), g != null && l.writeBytes(
      7,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 8), g != null && l.writeString(
      8,
      g
    );
  }, s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.UninterpretedOption.NamePart.prototype.toObject = function(d) {
    return proto.google.protobuf.UninterpretedOption.NamePart.toObject(d, this);
  }, proto.google.protobuf.UninterpretedOption.NamePart.toObject = function(d, l) {
    var g, f = {
      namePart: (g = s.Message.getField(l, 1)) == null ? void 0 : g,
      isExtension: (g = s.Message.getBooleanField(l, 2)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.UninterpretedOption.NamePart();
    return proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = (
            /** @type {string} */
            l.readString()
          );
          d.setNamePart(f);
          break;
        case 2:
          var f = (
            /** @type {boolean} */
            l.readBool()
          );
          d.setIsExtension(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = /** @type {string} */
    s.Message.getField(d, 1), g != null && l.writeString(
      1,
      g
    ), g = /** @type {boolean} */
    s.Message.getField(d, 2), g != null && l.writeBool(
      2,
      g
    );
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.getNamePart = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.setNamePart = function(d) {
    return s.Message.setField(this, 1, d);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearNamePart = function() {
    return s.Message.setField(this, 1, void 0);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasNamePart = function() {
    return s.Message.getField(this, 1) != null;
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.getIsExtension = function() {
    return (
      /** @type {boolean} */
      s.Message.getBooleanFieldWithDefault(this, 2, !1)
    );
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.setIsExtension = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearIsExtension = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasIsExtension = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getNameList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.UninterpretedOption.NamePart>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption.NamePart, 2)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setNameList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 2, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.addName = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 2, d, proto.google.protobuf.UninterpretedOption.NamePart, l);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearNameList = function() {
    return this.setNameList([]);
  }, proto.google.protobuf.UninterpretedOption.prototype.getIdentifierValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setIdentifierValue = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearIdentifierValue = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasIdentifierValue = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getPositiveIntValue = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setPositiveIntValue = function(d) {
    return s.Message.setField(this, 4, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearPositiveIntValue = function() {
    return s.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasPositiveIntValue = function() {
    return s.Message.getField(this, 4) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getNegativeIntValue = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 5, 0)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setNegativeIntValue = function(d) {
    return s.Message.setField(this, 5, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearNegativeIntValue = function() {
    return s.Message.setField(this, 5, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasNegativeIntValue = function() {
    return s.Message.getField(this, 5) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getDoubleValue = function() {
    return (
      /** @type {number} */
      s.Message.getFloatingPointFieldWithDefault(this, 6, 0)
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setDoubleValue = function(d) {
    return s.Message.setField(this, 6, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearDoubleValue = function() {
    return s.Message.setField(this, 6, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasDoubleValue = function() {
    return s.Message.getField(this, 6) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getStringValue = function() {
    return (
      /** @type {!(string|Uint8Array)} */
      s.Message.getFieldWithDefault(this, 7, "")
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getStringValue()
      )
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getStringValue()
      )
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setStringValue = function(d) {
    return s.Message.setField(this, 7, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearStringValue = function() {
    return s.Message.setField(this, 7, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasStringValue = function() {
    return s.Message.getField(this, 7) != null;
  }, proto.google.protobuf.UninterpretedOption.prototype.getAggregateValue = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 8, "")
    );
  }, proto.google.protobuf.UninterpretedOption.prototype.setAggregateValue = function(d) {
    return s.Message.setField(this, 8, d);
  }, proto.google.protobuf.UninterpretedOption.prototype.clearAggregateValue = function() {
    return s.Message.setField(this, 8, void 0);
  }, proto.google.protobuf.UninterpretedOption.prototype.hasAggregateValue = function() {
    return s.Message.getField(this, 8) != null;
  }, proto.google.protobuf.SourceCodeInfo.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.SourceCodeInfo.prototype.toObject = function(d) {
    return proto.google.protobuf.SourceCodeInfo.toObject(d, this);
  }, proto.google.protobuf.SourceCodeInfo.toObject = function(d, l) {
    var g = {
      locationList: s.Message.toObjectList(
        l.getLocationList(),
        proto.google.protobuf.SourceCodeInfo.Location.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.SourceCodeInfo.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.SourceCodeInfo();
    return proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new proto.google.protobuf.SourceCodeInfo.Location();
          l.readMessage(f, proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader), d.addLocation(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.SourceCodeInfo.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getLocationList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_ = [1, 2, 6], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.SourceCodeInfo.Location.prototype.toObject = function(d) {
    return proto.google.protobuf.SourceCodeInfo.Location.toObject(d, this);
  }, proto.google.protobuf.SourceCodeInfo.Location.toObject = function(d, l) {
    var g, f = {
      pathList: (g = s.Message.getRepeatedField(l, 1)) == null ? void 0 : g,
      spanList: (g = s.Message.getRepeatedField(l, 2)) == null ? void 0 : g,
      leadingComments: (g = s.Message.getField(l, 3)) == null ? void 0 : g,
      trailingComments: (g = s.Message.getField(l, 4)) == null ? void 0 : g,
      leadingDetachedCommentsList: (g = s.Message.getRepeatedField(l, 6)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.SourceCodeInfo.Location.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.SourceCodeInfo.Location();
    return proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          for (var _ = (
            /** @type {!Array<number>} */
            l.isDelimited() ? l.readPackedInt32() : [l.readInt32()]
          ), f = 0; f < _.length; f++)
            d.addPath(_[f]);
          break;
        case 2:
          for (var _ = (
            /** @type {!Array<number>} */
            l.isDelimited() ? l.readPackedInt32() : [l.readInt32()]
          ), f = 0; f < _.length; f++)
            d.addSpan(_[f]);
          break;
        case 3:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.setLeadingComments(te);
          break;
        case 4:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.setTrailingComments(te);
          break;
        case 6:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.addLeadingDetachedComments(te);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getPathList(), g.length > 0 && l.writePackedInt32(
      1,
      g
    ), g = d.getSpanList(), g.length > 0 && l.writePackedInt32(
      2,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 3), g != null && l.writeString(
      3,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 4), g != null && l.writeString(
      4,
      g
    ), g = d.getLeadingDetachedCommentsList(), g.length > 0 && l.writeRepeatedString(
      6,
      g
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getPathList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setPathList = function(d) {
    return s.Message.setField(this, 1, d || []);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.addPath = function(d, l) {
    return s.Message.addToRepeatedField(this, 1, d, l);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearPathList = function() {
    return this.setPathList([]);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getSpanList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 2)
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setSpanList = function(d) {
    return s.Message.setField(this, 2, d || []);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.addSpan = function(d, l) {
    return s.Message.addToRepeatedField(this, 2, d, l);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearSpanList = function() {
    return this.setSpanList([]);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingComments = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingComments = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingComments = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.hasLeadingComments = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getTrailingComments = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 4, "")
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setTrailingComments = function(d) {
    return s.Message.setField(this, 4, d);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearTrailingComments = function() {
    return s.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.hasTrailingComments = function() {
    return s.Message.getField(this, 4) != null;
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingDetachedCommentsList = function() {
    return (
      /** @type {!Array<string>} */
      s.Message.getRepeatedField(this, 6)
    );
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingDetachedCommentsList = function(d) {
    return s.Message.setField(this, 6, d || []);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.addLeadingDetachedComments = function(d, l) {
    return s.Message.addToRepeatedField(this, 6, d, l);
  }, proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingDetachedCommentsList = function() {
    return this.setLeadingDetachedCommentsList([]);
  }, proto.google.protobuf.SourceCodeInfo.prototype.getLocationList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.SourceCodeInfo.Location>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.SourceCodeInfo.Location, 1)
    );
  }, proto.google.protobuf.SourceCodeInfo.prototype.setLocationList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, proto.google.protobuf.SourceCodeInfo.prototype.addLocation = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, proto.google.protobuf.SourceCodeInfo.Location, l);
  }, proto.google.protobuf.SourceCodeInfo.prototype.clearLocationList = function() {
    return this.setLocationList([]);
  }, proto.google.protobuf.GeneratedCodeInfo.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.GeneratedCodeInfo.prototype.toObject = function(d) {
    return proto.google.protobuf.GeneratedCodeInfo.toObject(d, this);
  }, proto.google.protobuf.GeneratedCodeInfo.toObject = function(d, l) {
    var g = {
      annotationList: s.Message.toObjectList(
        l.getAnnotationList(),
        proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject,
        d
      )
    };
    return d && (g.$jspbMessageInstance = l), g;
  }), proto.google.protobuf.GeneratedCodeInfo.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.GeneratedCodeInfo();
    return proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          var f = new proto.google.protobuf.GeneratedCodeInfo.Annotation();
          l.readMessage(f, proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader), d.addAnnotation(f);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getAnnotationList(), g.length > 0 && l.writeRepeatedMessage(
      1,
      g,
      proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_ = [1], s.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.toObject = function(d) {
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject(d, this);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject = function(d, l) {
    var g, f = {
      pathList: (g = s.Message.getRepeatedField(l, 1)) == null ? void 0 : g,
      sourceFile: (g = s.Message.getField(l, 2)) == null ? void 0 : g,
      begin: (g = s.Message.getField(l, 3)) == null ? void 0 : g,
      end: (g = s.Message.getField(l, 4)) == null ? void 0 : g
    };
    return d && (f.$jspbMessageInstance = l), f;
  }), proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinary = function(d) {
    var l = new s.BinaryReader(d), g = new proto.google.protobuf.GeneratedCodeInfo.Annotation();
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader(g, l);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader = function(d, l) {
    for (; l.nextField() && !l.isEndGroup(); ) {
      var g = l.getFieldNumber();
      switch (g) {
        case 1:
          for (var f = (
            /** @type {!Array<number>} */
            l.isDelimited() ? l.readPackedInt32() : [l.readInt32()]
          ), _ = 0; _ < f.length; _++)
            d.addPath(f[_]);
          break;
        case 2:
          var te = (
            /** @type {string} */
            l.readString()
          );
          d.setSourceFile(te);
          break;
        case 3:
          var te = (
            /** @type {number} */
            l.readInt32()
          );
          d.setBegin(te);
          break;
        case 4:
          var te = (
            /** @type {number} */
            l.readInt32()
          );
          d.setEnd(te);
          break;
        default:
          l.skipField();
          break;
      }
    }
    return d;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.serializeBinary = function() {
    var d = new s.BinaryWriter();
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter(this, d), d.getResultBuffer();
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter = function(d, l) {
    var g = void 0;
    g = d.getPathList(), g.length > 0 && l.writePackedInt32(
      1,
      g
    ), g = /** @type {string} */
    s.Message.getField(d, 2), g != null && l.writeString(
      2,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 3), g != null && l.writeInt32(
      3,
      g
    ), g = /** @type {number} */
    s.Message.getField(d, 4), g != null && l.writeInt32(
      4,
      g
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getPathList = function() {
    return (
      /** @type {!Array<number>} */
      s.Message.getRepeatedField(this, 1)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setPathList = function(d) {
    return s.Message.setField(this, 1, d || []);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.addPath = function(d, l) {
    return s.Message.addToRepeatedField(this, 1, d, l);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearPathList = function() {
    return this.setPathList([]);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getSourceFile = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setSourceFile = function(d) {
    return s.Message.setField(this, 2, d);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearSourceFile = function() {
    return s.Message.setField(this, 2, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasSourceFile = function() {
    return s.Message.getField(this, 2) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getBegin = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setBegin = function(d) {
    return s.Message.setField(this, 3, d);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearBegin = function() {
    return s.Message.setField(this, 3, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasBegin = function() {
    return s.Message.getField(this, 3) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getEnd = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 4, 0)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setEnd = function(d) {
    return s.Message.setField(this, 4, d);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearEnd = function() {
    return s.Message.setField(this, 4, void 0);
  }, proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasEnd = function() {
    return s.Message.getField(this, 4) != null;
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.getAnnotationList = function() {
    return (
      /** @type{!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>} */
      s.Message.getRepeatedWrapperField(this, proto.google.protobuf.GeneratedCodeInfo.Annotation, 1)
    );
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.setAnnotationList = function(d) {
    return s.Message.setRepeatedWrapperField(this, 1, d);
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.addAnnotation = function(d, l) {
    return s.Message.addToRepeatedWrapperField(this, 1, d, proto.google.protobuf.GeneratedCodeInfo.Annotation, l);
  }, proto.google.protobuf.GeneratedCodeInfo.prototype.clearAnnotationList = function() {
    return this.setAnnotationList([]);
  }, h.object.extend(p, proto.google.protobuf);
})(descriptor_pb);
(function(p) {
  var s = googleProtobuf, h = s, c = {}, d = descriptor_pb;
  h.object.extend(c, d), h.exportSymbol("RetrySemantic", null, c), h.exportSymbol("retrySemantic", null, c), c.RetrySemantic = {
    NOTRETRYABLE: 0,
    RETRYABLE: 1
  }, c.retrySemantic = new s.ExtensionFieldInfo(
    5e4,
    { retrySemantic: 0 },
    null,
    /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */
    null,
    0
  ), d.MessageOptions.extensionsBinary[5e4] = new s.ExtensionFieldBinaryInfo(
    c.retrySemantic,
    s.BinaryReader.prototype.readEnum,
    s.BinaryWriter.prototype.writeEnum,
    void 0,
    void 0,
    !1
  ), d.MessageOptions.extensions[5e4] = c.retrySemantic, h.object.extend(p, c);
})(extensions_pb);
(function(p) {
  var s = googleProtobuf, h = s, c = {}, d = common_pb$2;
  h.object.extend(c, d);
  var l = extensions_pb;
  h.object.extend(c, l), h.exportSymbol("_Discontinuity", null, c), h.exportSymbol("_Heartbeat", null, c), h.exportSymbol("_PublishRequest", null, c), h.exportSymbol("_SubscriptionItem", null, c), h.exportSymbol("_SubscriptionItem.KindCase", null, c), h.exportSymbol("_SubscriptionRequest", null, c), h.exportSymbol("_TopicItem", null, c), h.exportSymbol("_TopicValue", null, c), h.exportSymbol("_TopicValue.KindCase", null, c), c._PublishRequest = function(g) {
    s.Message.initialize(this, g, 0, -1, null, null);
  }, h.inherits(c._PublishRequest, s.Message), h.DEBUG && !COMPILED && (c._PublishRequest.displayName = "proto._PublishRequest"), c._SubscriptionRequest = function(g) {
    s.Message.initialize(this, g, 0, -1, null, null);
  }, h.inherits(c._SubscriptionRequest, s.Message), h.DEBUG && !COMPILED && (c._SubscriptionRequest.displayName = "proto._SubscriptionRequest"), c._SubscriptionItem = function(g) {
    s.Message.initialize(this, g, 0, -1, null, c._SubscriptionItem.oneofGroups_);
  }, h.inherits(c._SubscriptionItem, s.Message), h.DEBUG && !COMPILED && (c._SubscriptionItem.displayName = "proto._SubscriptionItem"), c._TopicItem = function(g) {
    s.Message.initialize(this, g, 0, -1, null, null);
  }, h.inherits(c._TopicItem, s.Message), h.DEBUG && !COMPILED && (c._TopicItem.displayName = "proto._TopicItem"), c._TopicValue = function(g) {
    s.Message.initialize(this, g, 0, -1, null, c._TopicValue.oneofGroups_);
  }, h.inherits(c._TopicValue, s.Message), h.DEBUG && !COMPILED && (c._TopicValue.displayName = "proto._TopicValue"), c._Discontinuity = function(g) {
    s.Message.initialize(this, g, 0, -1, null, null);
  }, h.inherits(c._Discontinuity, s.Message), h.DEBUG && !COMPILED && (c._Discontinuity.displayName = "proto._Discontinuity"), c._Heartbeat = function(g) {
    s.Message.initialize(this, g, 0, -1, null, null);
  }, h.inherits(c._Heartbeat, s.Message), h.DEBUG && !COMPILED && (c._Heartbeat.displayName = "proto._Heartbeat"), s.Message.GENERATE_TO_OBJECT && (c._PublishRequest.prototype.toObject = function(g) {
    return c._PublishRequest.toObject(g, this);
  }, c._PublishRequest.toObject = function(g, f) {
    var _, te = {
      cacheName: s.Message.getFieldWithDefault(f, 1, ""),
      topic: s.Message.getFieldWithDefault(f, 2, ""),
      value: (_ = f.getValue()) && c._TopicValue.toObject(g, _)
    };
    return g && (te.$jspbMessageInstance = f), te;
  }), c._PublishRequest.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._PublishRequest();
    return c._PublishRequest.deserializeBinaryFromReader(_, f);
  }, c._PublishRequest.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        case 1:
          var te = (
            /** @type {string} */
            f.readString()
          );
          g.setCacheName(te);
          break;
        case 2:
          var te = (
            /** @type {string} */
            f.readString()
          );
          g.setTopic(te);
          break;
        case 3:
          var te = new c._TopicValue();
          f.readMessage(te, c._TopicValue.deserializeBinaryFromReader), g.setValue(te);
          break;
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._PublishRequest.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._PublishRequest.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._PublishRequest.serializeBinaryToWriter = function(g, f) {
    var _ = void 0;
    _ = g.getCacheName(), _.length > 0 && f.writeString(
      1,
      _
    ), _ = g.getTopic(), _.length > 0 && f.writeString(
      2,
      _
    ), _ = g.getValue(), _ != null && f.writeMessage(
      3,
      _,
      c._TopicValue.serializeBinaryToWriter
    );
  }, c._PublishRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._PublishRequest.prototype.setCacheName = function(g) {
    return s.Message.setProto3StringField(this, 1, g);
  }, c._PublishRequest.prototype.getTopic = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._PublishRequest.prototype.setTopic = function(g) {
    return s.Message.setProto3StringField(this, 2, g);
  }, c._PublishRequest.prototype.getValue = function() {
    return (
      /** @type{?proto._TopicValue} */
      s.Message.getWrapperField(this, c._TopicValue, 3)
    );
  }, c._PublishRequest.prototype.setValue = function(g) {
    return s.Message.setWrapperField(this, 3, g);
  }, c._PublishRequest.prototype.clearValue = function() {
    return this.setValue(void 0);
  }, c._PublishRequest.prototype.hasValue = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._SubscriptionRequest.prototype.toObject = function(g) {
    return c._SubscriptionRequest.toObject(g, this);
  }, c._SubscriptionRequest.toObject = function(g, f) {
    var _ = {
      cacheName: s.Message.getFieldWithDefault(f, 1, ""),
      topic: s.Message.getFieldWithDefault(f, 2, ""),
      resumeAtTopicSequenceNumber: s.Message.getFieldWithDefault(f, 3, 0)
    };
    return g && (_.$jspbMessageInstance = f), _;
  }), c._SubscriptionRequest.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._SubscriptionRequest();
    return c._SubscriptionRequest.deserializeBinaryFromReader(_, f);
  }, c._SubscriptionRequest.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        case 1:
          var te = (
            /** @type {string} */
            f.readString()
          );
          g.setCacheName(te);
          break;
        case 2:
          var te = (
            /** @type {string} */
            f.readString()
          );
          g.setTopic(te);
          break;
        case 3:
          var te = (
            /** @type {number} */
            f.readUint64()
          );
          g.setResumeAtTopicSequenceNumber(te);
          break;
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._SubscriptionRequest.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._SubscriptionRequest.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._SubscriptionRequest.serializeBinaryToWriter = function(g, f) {
    var _ = void 0;
    _ = g.getCacheName(), _.length > 0 && f.writeString(
      1,
      _
    ), _ = g.getTopic(), _.length > 0 && f.writeString(
      2,
      _
    ), _ = g.getResumeAtTopicSequenceNumber(), _ !== 0 && f.writeUint64(
      3,
      _
    );
  }, c._SubscriptionRequest.prototype.getCacheName = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._SubscriptionRequest.prototype.setCacheName = function(g) {
    return s.Message.setProto3StringField(this, 1, g);
  }, c._SubscriptionRequest.prototype.getTopic = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._SubscriptionRequest.prototype.setTopic = function(g) {
    return s.Message.setProto3StringField(this, 2, g);
  }, c._SubscriptionRequest.prototype.getResumeAtTopicSequenceNumber = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 3, 0)
    );
  }, c._SubscriptionRequest.prototype.setResumeAtTopicSequenceNumber = function(g) {
    return s.Message.setProto3IntField(this, 3, g);
  }, c._SubscriptionItem.oneofGroups_ = [[1, 2, 3]], c._SubscriptionItem.KindCase = {
    KIND_NOT_SET: 0,
    ITEM: 1,
    DISCONTINUITY: 2,
    HEARTBEAT: 3
  }, c._SubscriptionItem.prototype.getKindCase = function() {
    return (
      /** @type {proto._SubscriptionItem.KindCase} */
      s.Message.computeOneofCase(this, c._SubscriptionItem.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._SubscriptionItem.prototype.toObject = function(g) {
    return c._SubscriptionItem.toObject(g, this);
  }, c._SubscriptionItem.toObject = function(g, f) {
    var _, te = {
      item: (_ = f.getItem()) && c._TopicItem.toObject(g, _),
      discontinuity: (_ = f.getDiscontinuity()) && c._Discontinuity.toObject(g, _),
      heartbeat: (_ = f.getHeartbeat()) && c._Heartbeat.toObject(g, _)
    };
    return g && (te.$jspbMessageInstance = f), te;
  }), c._SubscriptionItem.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._SubscriptionItem();
    return c._SubscriptionItem.deserializeBinaryFromReader(_, f);
  }, c._SubscriptionItem.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        case 1:
          var te = new c._TopicItem();
          f.readMessage(te, c._TopicItem.deserializeBinaryFromReader), g.setItem(te);
          break;
        case 2:
          var te = new c._Discontinuity();
          f.readMessage(te, c._Discontinuity.deserializeBinaryFromReader), g.setDiscontinuity(te);
          break;
        case 3:
          var te = new c._Heartbeat();
          f.readMessage(te, c._Heartbeat.deserializeBinaryFromReader), g.setHeartbeat(te);
          break;
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._SubscriptionItem.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._SubscriptionItem.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._SubscriptionItem.serializeBinaryToWriter = function(g, f) {
    var _ = void 0;
    _ = g.getItem(), _ != null && f.writeMessage(
      1,
      _,
      c._TopicItem.serializeBinaryToWriter
    ), _ = g.getDiscontinuity(), _ != null && f.writeMessage(
      2,
      _,
      c._Discontinuity.serializeBinaryToWriter
    ), _ = g.getHeartbeat(), _ != null && f.writeMessage(
      3,
      _,
      c._Heartbeat.serializeBinaryToWriter
    );
  }, c._SubscriptionItem.prototype.getItem = function() {
    return (
      /** @type{?proto._TopicItem} */
      s.Message.getWrapperField(this, c._TopicItem, 1)
    );
  }, c._SubscriptionItem.prototype.setItem = function(g) {
    return s.Message.setOneofWrapperField(this, 1, c._SubscriptionItem.oneofGroups_[0], g);
  }, c._SubscriptionItem.prototype.clearItem = function() {
    return this.setItem(void 0);
  }, c._SubscriptionItem.prototype.hasItem = function() {
    return s.Message.getField(this, 1) != null;
  }, c._SubscriptionItem.prototype.getDiscontinuity = function() {
    return (
      /** @type{?proto._Discontinuity} */
      s.Message.getWrapperField(this, c._Discontinuity, 2)
    );
  }, c._SubscriptionItem.prototype.setDiscontinuity = function(g) {
    return s.Message.setOneofWrapperField(this, 2, c._SubscriptionItem.oneofGroups_[0], g);
  }, c._SubscriptionItem.prototype.clearDiscontinuity = function() {
    return this.setDiscontinuity(void 0);
  }, c._SubscriptionItem.prototype.hasDiscontinuity = function() {
    return s.Message.getField(this, 2) != null;
  }, c._SubscriptionItem.prototype.getHeartbeat = function() {
    return (
      /** @type{?proto._Heartbeat} */
      s.Message.getWrapperField(this, c._Heartbeat, 3)
    );
  }, c._SubscriptionItem.prototype.setHeartbeat = function(g) {
    return s.Message.setOneofWrapperField(this, 3, c._SubscriptionItem.oneofGroups_[0], g);
  }, c._SubscriptionItem.prototype.clearHeartbeat = function() {
    return this.setHeartbeat(void 0);
  }, c._SubscriptionItem.prototype.hasHeartbeat = function() {
    return s.Message.getField(this, 3) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._TopicItem.prototype.toObject = function(g) {
    return c._TopicItem.toObject(g, this);
  }, c._TopicItem.toObject = function(g, f) {
    var _, te = {
      topicSequenceNumber: s.Message.getFieldWithDefault(f, 1, 0),
      value: (_ = f.getValue()) && c._TopicValue.toObject(g, _),
      publisherId: s.Message.getFieldWithDefault(f, 3, "")
    };
    return g && (te.$jspbMessageInstance = f), te;
  }), c._TopicItem.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._TopicItem();
    return c._TopicItem.deserializeBinaryFromReader(_, f);
  }, c._TopicItem.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        case 1:
          var te = (
            /** @type {number} */
            f.readUint64()
          );
          g.setTopicSequenceNumber(te);
          break;
        case 2:
          var te = new c._TopicValue();
          f.readMessage(te, c._TopicValue.deserializeBinaryFromReader), g.setValue(te);
          break;
        case 3:
          var te = (
            /** @type {string} */
            f.readString()
          );
          g.setPublisherId(te);
          break;
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._TopicItem.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._TopicItem.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._TopicItem.serializeBinaryToWriter = function(g, f) {
    var _ = void 0;
    _ = g.getTopicSequenceNumber(), _ !== 0 && f.writeUint64(
      1,
      _
    ), _ = g.getValue(), _ != null && f.writeMessage(
      2,
      _,
      c._TopicValue.serializeBinaryToWriter
    ), _ = g.getPublisherId(), _.length > 0 && f.writeString(
      3,
      _
    );
  }, c._TopicItem.prototype.getTopicSequenceNumber = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._TopicItem.prototype.setTopicSequenceNumber = function(g) {
    return s.Message.setProto3IntField(this, 1, g);
  }, c._TopicItem.prototype.getValue = function() {
    return (
      /** @type{?proto._TopicValue} */
      s.Message.getWrapperField(this, c._TopicValue, 2)
    );
  }, c._TopicItem.prototype.setValue = function(g) {
    return s.Message.setWrapperField(this, 2, g);
  }, c._TopicItem.prototype.clearValue = function() {
    return this.setValue(void 0);
  }, c._TopicItem.prototype.hasValue = function() {
    return s.Message.getField(this, 2) != null;
  }, c._TopicItem.prototype.getPublisherId = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 3, "")
    );
  }, c._TopicItem.prototype.setPublisherId = function(g) {
    return s.Message.setProto3StringField(this, 3, g);
  }, c._TopicValue.oneofGroups_ = [[1, 2]], c._TopicValue.KindCase = {
    KIND_NOT_SET: 0,
    TEXT: 1,
    BINARY: 2
  }, c._TopicValue.prototype.getKindCase = function() {
    return (
      /** @type {proto._TopicValue.KindCase} */
      s.Message.computeOneofCase(this, c._TopicValue.oneofGroups_[0])
    );
  }, s.Message.GENERATE_TO_OBJECT && (c._TopicValue.prototype.toObject = function(g) {
    return c._TopicValue.toObject(g, this);
  }, c._TopicValue.toObject = function(g, f) {
    var _ = {
      text: s.Message.getFieldWithDefault(f, 1, ""),
      binary: f.getBinary_asB64()
    };
    return g && (_.$jspbMessageInstance = f), _;
  }), c._TopicValue.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._TopicValue();
    return c._TopicValue.deserializeBinaryFromReader(_, f);
  }, c._TopicValue.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        case 1:
          var te = (
            /** @type {string} */
            f.readString()
          );
          g.setText(te);
          break;
        case 2:
          var te = (
            /** @type {!Uint8Array} */
            f.readBytes()
          );
          g.setBinary(te);
          break;
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._TopicValue.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._TopicValue.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._TopicValue.serializeBinaryToWriter = function(g, f) {
    var _ = void 0;
    _ = /** @type {string} */
    s.Message.getField(g, 1), _ != null && f.writeString(
      1,
      _
    ), _ = /** @type {!(string|Uint8Array)} */
    s.Message.getField(g, 2), _ != null && f.writeBytes(
      2,
      _
    );
  }, c._TopicValue.prototype.getText = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 1, "")
    );
  }, c._TopicValue.prototype.setText = function(g) {
    return s.Message.setOneofField(this, 1, c._TopicValue.oneofGroups_[0], g);
  }, c._TopicValue.prototype.clearText = function() {
    return s.Message.setOneofField(this, 1, c._TopicValue.oneofGroups_[0], void 0);
  }, c._TopicValue.prototype.hasText = function() {
    return s.Message.getField(this, 1) != null;
  }, c._TopicValue.prototype.getBinary = function() {
    return (
      /** @type {string} */
      s.Message.getFieldWithDefault(this, 2, "")
    );
  }, c._TopicValue.prototype.getBinary_asB64 = function() {
    return (
      /** @type {string} */
      s.Message.bytesAsB64(
        this.getBinary()
      )
    );
  }, c._TopicValue.prototype.getBinary_asU8 = function() {
    return (
      /** @type {!Uint8Array} */
      s.Message.bytesAsU8(
        this.getBinary()
      )
    );
  }, c._TopicValue.prototype.setBinary = function(g) {
    return s.Message.setOneofField(this, 2, c._TopicValue.oneofGroups_[0], g);
  }, c._TopicValue.prototype.clearBinary = function() {
    return s.Message.setOneofField(this, 2, c._TopicValue.oneofGroups_[0], void 0);
  }, c._TopicValue.prototype.hasBinary = function() {
    return s.Message.getField(this, 2) != null;
  }, s.Message.GENERATE_TO_OBJECT && (c._Discontinuity.prototype.toObject = function(g) {
    return c._Discontinuity.toObject(g, this);
  }, c._Discontinuity.toObject = function(g, f) {
    var _ = {
      lastTopicSequence: s.Message.getFieldWithDefault(f, 1, 0),
      newTopicSequence: s.Message.getFieldWithDefault(f, 2, 0)
    };
    return g && (_.$jspbMessageInstance = f), _;
  }), c._Discontinuity.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._Discontinuity();
    return c._Discontinuity.deserializeBinaryFromReader(_, f);
  }, c._Discontinuity.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        case 1:
          var te = (
            /** @type {number} */
            f.readUint64()
          );
          g.setLastTopicSequence(te);
          break;
        case 2:
          var te = (
            /** @type {number} */
            f.readUint64()
          );
          g.setNewTopicSequence(te);
          break;
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._Discontinuity.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._Discontinuity.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._Discontinuity.serializeBinaryToWriter = function(g, f) {
    var _ = void 0;
    _ = g.getLastTopicSequence(), _ !== 0 && f.writeUint64(
      1,
      _
    ), _ = g.getNewTopicSequence(), _ !== 0 && f.writeUint64(
      2,
      _
    );
  }, c._Discontinuity.prototype.getLastTopicSequence = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 1, 0)
    );
  }, c._Discontinuity.prototype.setLastTopicSequence = function(g) {
    return s.Message.setProto3IntField(this, 1, g);
  }, c._Discontinuity.prototype.getNewTopicSequence = function() {
    return (
      /** @type {number} */
      s.Message.getFieldWithDefault(this, 2, 0)
    );
  }, c._Discontinuity.prototype.setNewTopicSequence = function(g) {
    return s.Message.setProto3IntField(this, 2, g);
  }, s.Message.GENERATE_TO_OBJECT && (c._Heartbeat.prototype.toObject = function(g) {
    return c._Heartbeat.toObject(g, this);
  }, c._Heartbeat.toObject = function(g, f) {
    var _ = {};
    return g && (_.$jspbMessageInstance = f), _;
  }), c._Heartbeat.deserializeBinary = function(g) {
    var f = new s.BinaryReader(g), _ = new c._Heartbeat();
    return c._Heartbeat.deserializeBinaryFromReader(_, f);
  }, c._Heartbeat.deserializeBinaryFromReader = function(g, f) {
    for (; f.nextField() && !f.isEndGroup(); ) {
      var _ = f.getFieldNumber();
      switch (_) {
        default:
          f.skipField();
          break;
      }
    }
    return g;
  }, c._Heartbeat.prototype.serializeBinary = function() {
    var g = new s.BinaryWriter();
    return c._Heartbeat.serializeBinaryToWriter(this, g), g.getResultBuffer();
  }, c._Heartbeat.serializeBinaryToWriter = function(g, f) {
  }, h.object.extend(p, c);
})(cachepubsub_pb$1);
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(p, s, h, c) {
  c === void 0 && (c = h);
  var d = Object.getOwnPropertyDescriptor(s, h);
  (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
    return s[h];
  } }), Object.defineProperty(p, c, d);
} : function(p, s, h, c) {
  c === void 0 && (c = h), p[c] = s[h];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(p, s) {
  Object.defineProperty(p, "default", { enumerable: !0, value: s });
} : function(p, s) {
  p.default = s;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(p) {
  if (p && p.__esModule) return p;
  var s = {};
  if (p != null) for (var h in p) h !== "default" && Object.prototype.hasOwnProperty.call(p, h) && __createBinding(s, p, h);
  return __setModuleDefault(s, p), s;
};
Object.defineProperty(CachepubsubServiceClientPb, "__esModule", { value: !0 });
CachepubsubServiceClientPb.PubsubClient = void 0;
const grpcWeb = __importStar(grpcWeb$a), cachepubsub_pb = __importStar(cachepubsub_pb$1), common_pb = __importStar(common_pb$2);
class PubsubClient {
  constructor(s, h, c) {
    this.methodDescriptorPublish = new grpcWeb.MethodDescriptor("/cache_client.pubsub.Pubsub/Publish", grpcWeb.MethodType.UNARY, cachepubsub_pb._PublishRequest, common_pb._Empty, (d) => d.serializeBinary(), common_pb._Empty.deserializeBinary), this.methodDescriptorSubscribe = new grpcWeb.MethodDescriptor("/cache_client.pubsub.Pubsub/Subscribe", grpcWeb.MethodType.SERVER_STREAMING, cachepubsub_pb._SubscriptionRequest, cachepubsub_pb._SubscriptionItem, (d) => d.serializeBinary(), cachepubsub_pb._SubscriptionItem.deserializeBinary), c || (c = {}), h || (h = {}), c.format = "text", this.client_ = new grpcWeb.GrpcWebClientBase(c), this.hostname_ = s, this.credentials_ = h, this.options_ = c;
  }
  publish(s, h, c) {
    return c !== void 0 ? this.client_.rpcCall(this.hostname_ + "/cache_client.pubsub.Pubsub/Publish", s, h || {}, this.methodDescriptorPublish, c) : this.client_.unaryCall(this.hostname_ + "/cache_client.pubsub.Pubsub/Publish", s, h || {}, this.methodDescriptorPublish);
  }
  subscribe(s, h) {
    return this.client_.serverStreaming(this.hostname_ + "/cache_client.pubsub.Pubsub/Subscribe", s, h || {}, this.methodDescriptorSubscribe);
  }
}
CachepubsubServiceClientPb.PubsubClient = PubsubClient;
var AbstractPubsubClient$1 = {}, subscriptionState = {};
Object.defineProperty(subscriptionState, "__esModule", { value: !0 });
subscriptionState.SubscriptionState = void 0;
class SubscriptionState {
  constructor() {
    this._unsubscribeFn = () => {
    }, this._isSubscribed = !1;
  }
  get resumeAtTopicSequenceNumber() {
    var s;
    return ((s = this.lastTopicSequenceNumber) !== null && s !== void 0 ? s : -1) + 1;
  }
  setSubscribed() {
    this._isSubscribed = !0;
  }
  setUnsubscribed() {
    this._isSubscribed = !1;
  }
  get isSubscribed() {
    return this._isSubscribed;
  }
  set unsubscribeFn(s) {
    this._unsubscribeFn = s;
  }
  unsubscribe() {
    this.isSubscribed && (this._unsubscribeFn(), this.setUnsubscribed());
  }
  toString() {
    return JSON.stringify({
      lastTopicSequenceNumber: this.lastTopicSequenceNumber,
      isSubscribed: this._isSubscribed
    }, null, 2);
  }
}
subscriptionState.SubscriptionState = SubscriptionState;
Object.defineProperty(AbstractPubsubClient$1, "__esModule", { value: !0 });
AbstractPubsubClient$1.AbstractPubsubClient = void 0;
const utils_1$1 = utils$1, errors_1 = errors$1, index_1$1 = requireSrc$1(), subscription_state_1 = subscriptionState;
class AbstractPubsubClient {
  constructor(s, h, c) {
    this.loggerFactory = s, this.logger = h, this.cacheServiceErrorMapper = c;
  }
  getLogger() {
    return this.logger;
  }
  getCacheServiceErrorMapper() {
    return this.cacheServiceErrorMapper;
  }
  async publish(s, h, c) {
    try {
      (0, utils_1$1.validateCacheName)(s), (0, utils_1$1.validateTopicName)(h);
    } catch (d) {
      return this.cacheServiceErrorMapper.returnOrThrowError(d, (l) => new index_1$1.TopicPublish.Error(l));
    }
    return this.logger.trace("Issuing publish request; topic: %s, message length: %s", (0, utils_1$1.truncateString)(h), c.length), await this.sendPublish(s, h, c);
  }
  async subscribe(s, h, c) {
    var d, l, g, f;
    try {
      (0, utils_1$1.validateCacheName)(s), (0, utils_1$1.validateTopicName)(h);
    } catch (w) {
      return this.cacheServiceErrorMapper.returnOrThrowError(w, (q) => new index_1$1.TopicSubscribe.Error(q));
    }
    this.logger.trace("Issuing subscribe request; topic: %s", (0, utils_1$1.truncateString)(h));
    const _ = (d = c.onItem) !== null && d !== void 0 ? d : () => {
    }, te = (l = c.onError) !== null && l !== void 0 ? l : () => {
    }, ae = (g = c.onDiscontinuity) !== null && g !== void 0 ? g : () => {
    }, ie = (f = c.onHeartbeat) !== null && f !== void 0 ? f : () => {
    }, se = new subscription_state_1.SubscriptionState(), m = new index_1$1.TopicSubscribe.Subscription(this.loggerFactory, se);
    return await this.sendSubscribe({
      cacheName: s,
      topicName: h,
      onItem: _,
      onError: te,
      onDiscontinuity: ae,
      onHeartbeat: ie,
      subscriptionState: se,
      subscription: m,
      restartedDueToError: !1,
      firstMessage: !0
    });
  }
  prepareEndCallback(s) {
    return () => {
      if (s.restartedDueToError) {
        this.logger.trace("Stream ended after error but was restarted on topic: %s", s.topicName);
        return;
      } else if (!s.subscriptionState.isSubscribed) {
        this.logger.trace("Stream ended after unsubscribe on topic: %s", s.topicName);
        return;
      }
      this.logger.trace("Stream ended on topic: %s; restarting.", s.topicName), this.sendSubscribe(s).then(() => {
      }).catch(() => {
      });
    };
  }
  handleSubscribeError(s, h, c) {
    if (this.logger.trace("Handling subscribe error"), s.firstMessage) {
      this.logger.trace("First message on subscription was an error; topic: %s, error: %s", (0, utils_1$1.truncateString)(s.topicName), h.toString()), s.resolve(h), s.subscription.unsubscribe();
      return;
    }
    if (this.logger.trace("Subscribe error was not the first message on the stream."), h.errorCode() === errors_1.MomentoErrorCode.CACHE_NOT_FOUND_ERROR) {
      this.logger.trace("Stream ended due to cache not found error on topic: %s", s.topicName), s.subscription.unsubscribe(), s.onError(h, s.subscription);
      return;
    }
    if (this.logger.trace("Checking to see if we should attempt to reconnect subscription."), c) {
      s.restartedDueToError = !0;
      const d = 500;
      this.logger.trace("Error occurred on subscription, possibly a network interruption. Will attempt to restart stream in %s ms.", d), (0, utils_1$1.sleep)(d).then(() => {
        this.sendSubscribe(s).then(() => {
        }).catch((l) => {
          this.logger.trace("Error when calling sendSubscribe to reconnect: %s", l);
        });
      }).catch((l) => {
        this.logger.trace("Error when sleeping prior to sendSubscribe to reconnect: %s", l);
      });
      return;
    }
    this.logger.trace("Subscribe error was not a re-connectable error."), this.logger.trace("Subscribe error was not one of the known error types; calling error handler."), s.onError(h, s.subscription);
  }
}
AbstractPubsubClient$1.AbstractPubsubClient = AbstractPubsubClient;
var hasRequiredPubsubClient;
function requirePubsubClient() {
  if (hasRequiredPubsubClient) return pubsubClient;
  hasRequiredPubsubClient = 1, Object.defineProperty(pubsubClient, "__esModule", { value: !0 }), pubsubClient.PubsubClient = void 0;
  const p = CachepubsubServiceClientPb, s = cachepubsub_pb$1, h = requireSrc$1(), c = grpcWeb$a, d = utils$1, l = requireSrc(), g = requireCacheServiceErrorMapper(), f = AbstractPubsubClient$1, _ = webClientUtils, te = clientMetadataProvider;
  class ae extends f.AbstractPubsubClient {
    constructor(se) {
      super(se.configuration.getLoggerFactory(), se.configuration.getLoggerFactory().getLogger(ae.name), new g.CacheServiceErrorMapper(se.configuration.getThrowOnErrors())), this.credentialProvider = se.credentialProvider, this.requestTimeoutMs = ae.DEFAULT_REQUEST_TIMEOUT_MS, this.getLogger().debug(`Creating topic client using endpoint: '${(0, _.getWebCacheEndpoint)(se.credentialProvider)}'`), this.client = new p.PubsubClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, _.getWebCacheEndpoint)(se.credentialProvider),
        null,
        {}
      ), this.clientMetadataProvider = new te.ClientMetadataProvider({
        authToken: se.credentialProvider.getAuthToken(),
        clientType: "topic"
      });
    }
    getEndpoint() {
      const se = (0, _.getWebCacheEndpoint)(this.credentialProvider);
      return this.getLogger().debug(`Using cache endpoint: ${se}`), se;
    }
    async sendPublish(se, m, w) {
      const q = new s._TopicValue();
      typeof w == "string" ? q.setText(w) : q.setBinary((0, _.convertToB64String)(w));
      const j = new s._PublishRequest();
      return j.setCacheName(se), j.setTopic(m), j.setValue(q), await new Promise((k, z) => {
        this.client.publish(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, _.createCallMetadata)(se, this.requestTimeoutMs)
        }, ($, re) => {
          re ? k(new l.TopicPublish.Success()) : this.getCacheServiceErrorMapper().resolveOrRejectError({
            err: $,
            errorResponseFactoryFn: (oe) => new l.TopicPublish.Error(oe),
            resolveFn: k,
            rejectFn: z
          });
        });
      });
    }
    /**
     * @remark This method is responsible for restarting the stream if it ends unexpectedly.
     * Since we return a single subscription object to the user, we need to update it with the
     * unsubscribe function should we restart the stream. This is why we pass the subscription
     * state and subscription object to this method.
     *
     * Handling a cache not exists requires special care as well. In the most likely case,
     * when the subscription starts and the cache does not exist, we receive an error immediately.
     * We return an error from the subscribe method and do immediately unsubscribe. In a distinct,
     * unlikely but possible case, the user deletes the cache while the stream is running. In this
     * case we already returned a subscription object to the user, so we instead cancel the stream and
     * propagate an error to the user via the error handler.
     */
    sendSubscribe(se) {
      const m = new s._SubscriptionRequest();
      m.setCacheName(se.cacheName), m.setTopic(se.topicName), m.setResumeAtTopicSequenceNumber(se.subscriptionState.resumeAtTopicSequenceNumber);
      const w = this.client.subscribe(m, {
        ...this.clientMetadataProvider.createClientMetadata()
      });
      return se.subscriptionState.setSubscribed(), se.subscriptionState.unsubscribeFn = () => {
        w.cancel();
      }, new Promise((q) => {
        const j = {
          ...se,
          restartedDueToError: !1,
          // We call subscribe send on retryable errors. All retry-able errors happen
          // after the first message. Here we can check if there has been a message that
          // has already been sent from this stream by checking to see if there is a resumable
          // sequence number. If there is one, we know that this isn't the first message.
          firstMessage: !se.subscriptionState.resumeAtTopicSequenceNumber,
          resolve: q
        };
        w.on("data", this.prepareDataCallback(j)), w.on("error", this.prepareErrorCallback(j)), w.on("end", this.prepareEndCallback(j));
      });
    }
    prepareDataCallback(se) {
      return (m) => {
        var w, q;
        se.firstMessage && se.resolve(se.subscription), se.firstMessage = !1;
        const j = m.getItem(), k = m.getDiscontinuity();
        if (j) {
          const z = j.getTopicSequenceNumber();
          se.subscriptionState.lastTopicSequenceNumber = z;
          const $ = j.getPublisherId(), re = (w = j.getValue()) === null || w === void 0 ? void 0 : w.getText(), oe = (q = j.getValue()) === null || q === void 0 ? void 0 : q.getBinary();
          re ? se.onItem(new h.TopicItem(re, z, { tokenId: $ })) : oe ? se.onItem(new h.TopicItem(oe, z, { tokenId: $ })) : (this.getLogger().error("Received subscription item with unknown type; topic: %s", (0, d.truncateString)(se.topicName)), se.onError(new l.TopicSubscribe.Error(new h.UnknownError("Unknown item value type")), se.subscription));
        } else m.getHeartbeat() ? (this.getLogger().trace("Received heartbeat from subscription stream; topic: %s", (0, d.truncateString)(se.topicName)), se.onHeartbeat(new h.TopicHeartbeat())) : k ? (this.getLogger().trace("Received discontinuity from subscription stream; topic: %s", (0, d.truncateString)(se.topicName)), se.onDiscontinuity(new h.TopicDiscontinuity(k.getLastTopicSequence(), k.getNewTopicSequence()))) : (this.getLogger().error("Received unknown subscription item; topic: %s", (0, d.truncateString)(se.topicName)), se.onError(new l.TopicSubscribe.Error(new h.UnknownError("Unknown item type")), se.subscription));
      };
    }
    prepareErrorCallback(se) {
      return (m) => {
        if (!se.subscriptionState.isSubscribed)
          return;
        const w = m, q = w.code === c.StatusCode.UNKNOWN && w.message === ae.BROWSER_DISCONNECT, j = w.code === c.StatusCode.INTERNAL && w.message === ae.RST_STREAM_NO_ERROR_MESSAGE, k = q || j, z = new l.TopicSubscribe.Error(this.getCacheServiceErrorMapper().convertError(w));
        this.handleSubscribeError(se, z, k);
      };
    }
  }
  return pubsubClient.PubsubClient = ae, ae.DEFAULT_REQUEST_TIMEOUT_MS = 5 * 1e3, ae.RST_STREAM_NO_ERROR_MESSAGE = "Received RST_STREAM with code 0", ae.BROWSER_DISCONNECT = "Http response at 400 or 500 level, http status code: 0", pubsubClient;
}
var AbstractTopicClient$1 = {};
Object.defineProperty(AbstractTopicClient$1, "__esModule", { value: !0 });
AbstractTopicClient$1.AbstractTopicClient = void 0;
const index_1 = requireSrc$1();
class AbstractTopicClient {
  constructor(s, h, c) {
    this.nextPubsubClientIndex = 0, this.logger = s, this.pubsubClients = h, this.webhookClient = c;
  }
  /**
   * Publishes a value to a topic.
   *
   * @param {string} cacheName - The name of the cache to containing the topic to publish to.
   * @param {string} topicName - The name of the topic to publish to.
   * @param {string | Uint8Array} value - The value to publish.
   * @returns {Promise<TopicPublish.Response>} -
   * {@link TopicPublish.Success} on success.
   * {@link TopicPublish.Error} on failure.
   */
  async publish(s, h, c) {
    return await this.getNextPubsubClient().publish(s, h, c);
  }
  /**
   * Subscribes to a topic.
   *
   * @param {string} cacheName - The name of the cache to containing the topic to subscribe to.
   * @param {string} topicName - The name of the topic to subscribe to.
   * @param {SubscribeCallOptions} options - The options for the subscription. Defaults to no-op handlers.
   * @param {function} options.onItem - The callback to invoke when data is received. Defaults to no-op.
   * @param {function} options.onError - The callback to invoke when an error is received. Defaults to no-op.
   * @returns {Promise<TopicSubscribe.Response>} -
   * {@link TopicSubscribe.Subscription} on success.
   * {@link TopicSubscribe.Error} on failure.
   */
  async subscribe(s, h, c) {
    return await this.getNextPubsubClient().subscribe(s, h, c);
  }
  /**
   * Deletes a webhook
   *
   * @param {string} cacheName - The name of the cache associated with the webhook
   * @param {string} webhookName - The name of the webhook
   * @returns {Promise<DeleteWebhook.Response>} -
   * {@link DeleteWebhook.Success} on success.
   * {@link DeleteWebhook.Error} on failure.
   */
  async deleteWebhook(s, h) {
    return await this.webhookClient.deleteWebhook({ cacheName: s, webhookName: h });
  }
  /**
   * Lists webhooks associated with a cache
   *
   * @param {string} cacheName - The cache to list webhooks associated with it
   * @returns {Promise<ListWebhooks.Response>} -
   * {@link ListWebhooks.Success} on success.
   * {@link ListWebhooks.Error} on failure.
   */
  async listWebhooks(s) {
    return await this.webhookClient.listWebhooks(s);
  }
  /**
   * Creates a new webhook, or updates an existing one
   *
   * @param {string} cacheName - The name of the cache to associate the webhook with
   * @param {string} webhookName - The name of the webhook
   * @param {PutWebhookCallOptions} options - The options for the webhook
   * @param {string} topicName - The name of the topic for the webhook to listen to
   * @param {WebhookDestination | string} webhookDestination - The url to associate the webhook with
   * @returns {Promise<PutWebhook.Response>} -
   * {@link PutWebhook.Success} on success.
   * {@link PutWebhook.Error} on failure.
   */
  async putWebhook(s, h, c) {
    let d = c.destination;
    return typeof d == "string" && (d = new index_1.PostUrlWebhookDestination(d)), await this.webhookClient.putWebhook({
      topicName: c.topicName,
      id: {
        cacheName: s,
        webhookName: h
      },
      destination: d
    });
  }
  /**
   * Gets the signing secret for a webhook
   *
   * @param {string} cacheName - The name of the cache associated with the webhook
   * @param {string} webhookName - The name of the webhook
   * @returns {Promise<GetWebhookSecret.Response>} -
   * {@link GetWebhookSecret.Success} on success.
   * {@link GetWebhookSecret.Error} on failure.
   */
  async getWebhookSecret(s, h) {
    return await this.webhookClient.getWebhookSecret({ cacheName: s, webhookName: h });
  }
  /**
   * Rotates the signing secret for a webhook
   *
   * @param {string} cacheName - The name of the cache associated with the webhook
   * @param {string} webhookName - The name of the webhook
   * @returns {Promise<RotateWebhookSecret.Response>} -
   * {@link RotateWebhookSecret.Success} on success.
   * {@link RotateWebhookSecret.Error} on failure.
   */
  async rotateWebhookSecret(s, h) {
    return await this.webhookClient.rotateWebhookSecret({
      cacheName: s,
      webhookName: h
    });
  }
  getNextPubsubClient() {
    const s = this.pubsubClients[this.nextPubsubClientIndex];
    return this.nextPubsubClientIndex = (this.nextPubsubClientIndex + 1) % this.pubsubClients.length, s;
  }
}
AbstractTopicClient$1.AbstractTopicClient = AbstractTopicClient;
var webhookClient = {}, hasRequiredWebhookClient;
function requireWebhookClient() {
  if (hasRequiredWebhookClient) return webhookClient;
  hasRequiredWebhookClient = 1, Object.defineProperty(webhookClient, "__esModule", { value: !0 }), webhookClient.WebhookClient = void 0;
  const p = WebhookServiceClientPb, s = requireSrc$1(), h = requireCacheServiceErrorMapper(), c = utils$1, d = webClientUtils, l = clientMetadataProvider, g = webhook_pb$1;
  class f {
    /**
     * @param {TopicClientProps} props
     */
    constructor(te) {
      this.configuration = te.configuration, this.credentialProvider = te.credentialProvider, this.logger = this.configuration.getLoggerFactory().getLogger(this), this.cacheServiceErrorMapper = new h.CacheServiceErrorMapper(te.configuration.getThrowOnErrors()), this.logger.debug(`Creating webhook client using endpoint: '${(0, d.getWebControlEndpoint)(this.credentialProvider)}'`), this.webhookClient = new p.WebhookClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, d.getWebControlEndpoint)(te.credentialProvider),
        null,
        {}
      ), this.clientMetadataProvider = new l.ClientMetadataProvider({
        authToken: te.credentialProvider.getAuthToken(),
        clientType: "webhook"
      });
    }
    async deleteWebhook(te) {
      try {
        (0, c.validateCacheName)(te.cacheName);
      } catch (se) {
        return this.cacheServiceErrorMapper.returnOrThrowError(se, (m) => new s.DeleteWebhook.Error(m));
      }
      const ae = new g._DeleteWebhookRequest(), ie = new g._WebhookId();
      return ie.setWebhookName(te.webhookName), ie.setCacheName(te.cacheName), ae.setWebhookId(ie), ae.setWebhookId(ie), this.logger.debug('issuing "DeleteWebhook" request'), await new Promise((se, m) => {
        this.webhookClient.deleteWebhook(ae, this.clientMetadataProvider.createClientMetadata(), (w, q) => {
          w ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: w,
            errorResponseFactoryFn: (j) => new s.DeleteWebhook.Error(j),
            resolveFn: se,
            rejectFn: m
          }) : se(new s.DeleteWebhook.Success());
        });
      });
    }
    async listWebhooks(te) {
      try {
        (0, c.validateCacheName)(te);
      } catch (ie) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ie, (se) => new s.ListWebhooks.Error(se));
      }
      const ae = new g._ListWebhookRequest();
      return ae.setCacheName(te), this.logger.debug('issuing "ListWebhooks" request'), await new Promise((ie, se) => {
        this.webhookClient.listWebhooks(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          if (m || !w)
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: m,
              errorResponseFactoryFn: (q) => new s.ListWebhooks.Error(q),
              resolveFn: ie,
              rejectFn: se
            });
          else {
            const q = w.getWebhookList().map((j) => {
              var k, z, $, re, oe, le, ue;
              return {
                id: {
                  cacheName: (z = (k = j.getWebhookId()) === null || k === void 0 ? void 0 : k.getCacheName()) !== null && z !== void 0 ? z : "",
                  webhookName: (re = ($ = j.getWebhookId()) === null || $ === void 0 ? void 0 : $.getWebhookName()) !== null && re !== void 0 ? re : ""
                },
                topicName: (oe = j.getTopicName()) !== null && oe !== void 0 ? oe : "",
                destination: new s.PostUrlWebhookDestination((ue = (le = j.getDestination()) === null || le === void 0 ? void 0 : le.getPostUrl()) !== null && ue !== void 0 ? ue : "")
              };
            });
            ie(new s.ListWebhooks.Success(q));
          }
        });
      });
    }
    async putWebhook(te) {
      try {
        (0, c.validateCacheName)(te.id.cacheName), (0, c.validateTopicName)(te.topicName), (0, c.validateWebhookName)(te.id.webhookName);
      } catch (w) {
        return this.cacheServiceErrorMapper.returnOrThrowError(w, (q) => new s.PutWebhook.Error(q));
      }
      const ae = new g._PutWebhookRequest(), ie = new g._Webhook(), se = new g._WebhookId();
      se.setWebhookName(te.id.webhookName), se.setCacheName(te.id.cacheName), ie.setWebhookId(se), ie.setTopicName(te.topicName);
      const m = new g._WebhookDestination();
      switch (te.destination.getType()) {
        case s.WebhookDestinationType.PostUrl:
          m.setPostUrl(te.destination.url());
          break;
      }
      return ie.setDestination(m), ae.setWebhook(ie), this.logger.debug('issuing "PutWebhook" request'), await new Promise((w, q) => {
        this.webhookClient.putWebhook(ae, this.clientMetadataProvider.createClientMetadata(), (j, k) => {
          j || !k ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: j,
            errorResponseFactoryFn: (z) => new s.PutWebhook.Error(z),
            resolveFn: w,
            rejectFn: q
          }) : w(new s.PutWebhook.Success(k.getSecretString()));
        });
      });
    }
    async getWebhookSecret(te) {
      try {
        (0, c.validateCacheName)(te.cacheName), (0, c.validateWebhookName)(te.webhookName);
      } catch (ie) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ie, (se) => new s.GetWebhookSecret.Error(se));
      }
      const ae = new g._GetWebhookSecretRequest();
      return ae.setCacheName(te.cacheName), ae.setWebhookName(te.webhookName), this.logger.debug('issuing "GetWebhookSecret" request'), await new Promise((ie, se) => {
        this.webhookClient.getWebhookSecret(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          m || !w ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: m,
            errorResponseFactoryFn: (q) => new s.GetWebhookSecret.Error(q),
            resolveFn: ie,
            rejectFn: se
          }) : ie(new s.GetWebhookSecret.Success({
            secret: w.getSecretString(),
            webhookName: w.getWebhookName(),
            cacheName: w.getCacheName()
          }));
        });
      });
    }
    async rotateWebhookSecret(te) {
      try {
        (0, c.validateCacheName)(te.cacheName), (0, c.validateWebhookName)(te.webhookName);
      } catch (se) {
        return this.cacheServiceErrorMapper.returnOrThrowError(se, (m) => new s.RotateWebhookSecret.Error(m));
      }
      const ae = new g._RotateWebhookSecretRequest(), ie = new g._WebhookId();
      return ie.setWebhookName(te.webhookName), ie.setCacheName(te.cacheName), ae.setWebhookId(ie), this.logger.debug('issuing "RotateWebhookSecret" request'), await new Promise((se, m) => {
        this.webhookClient.rotateWebhookSecret(ae, this.clientMetadataProvider.createClientMetadata(), (w, q) => {
          w || !q ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: w,
            errorResponseFactoryFn: (j) => new s.RotateWebhookSecret.Error(j),
            resolveFn: se,
            rejectFn: m
          }) : se(new s.RotateWebhookSecret.Success({
            secret: q.getSecretString(),
            webhookName: te.webhookName,
            cacheName: te.cacheName
          }));
        });
      });
    }
  }
  return webhookClient.WebhookClient = f, webhookClient;
}
var hasRequiredTopicClient;
function requireTopicClient() {
  if (hasRequiredTopicClient) return topicClient;
  hasRequiredTopicClient = 1, Object.defineProperty(topicClient, "__esModule", { value: !0 }), topicClient.TopicClient = void 0;
  const p = requireSrc(), s = requirePubsubClient(), h = AbstractTopicClient$1, c = requireWebhookClient(), d = requireSrc$1();
  class l extends h.AbstractTopicClient {
    /**
     * Creates an instance of TopicClient.
     */
    constructor(_) {
      var te, ae;
      const ie = (te = _ == null ? void 0 : _.configuration) !== null && te !== void 0 ? te : g(), se = {
        configuration: ie,
        credentialProvider: (ae = _ == null ? void 0 : _.credentialProvider) !== null && ae !== void 0 ? ae : (0, d.getDefaultCredentialProvider)()
      };
      super(ie.getLoggerFactory().getLogger(l.name), [new s.PubsubClient(se)], new c.WebhookClient(se)), this.logger.debug("Instantiated Momento TopicClient");
    }
  }
  topicClient.TopicClient = l;
  function g() {
    const f = p.TopicConfigurations.Default.latest();
    return f.getLoggerFactory().getLogger("TopicClient").info('No configuration provided to TopicClient. Using latest "Default" configuration, suitable for development. For production use, consider specifying an explicit configuration.'), f;
  }
  return topicClient;
}
var previewLeaderboardClient = {}, leaderboard = {};
Object.defineProperty(leaderboard, "__esModule", { value: !0 });
leaderboard.Leaderboard = void 0;
const sdk_core_1$1 = requireSrc$1(), leaderboard_1 = leaderboard$1, utils_1 = utils$1;
class Leaderboard extends leaderboard_1.AbstractLeaderboard {
  constructor(s, h, c) {
    try {
      (0, utils_1.validateCacheName)(h), (0, utils_1.validateLeaderboardName)(c);
    } catch (d) {
      throw new sdk_core_1$1.InvalidArgumentError("cache name and leaderboard name must not be empty strings");
    }
    super(h, c, s);
  }
}
leaderboard.Leaderboard = Leaderboard;
var leaderboardDataClient = {}, hasRequiredLeaderboardDataClient;
function requireLeaderboardDataClient() {
  if (hasRequiredLeaderboardDataClient) return leaderboardDataClient;
  hasRequiredLeaderboardDataClient = 1, Object.defineProperty(leaderboardDataClient, "__esModule", { value: !0 }), leaderboardDataClient.LeaderboardDataClient = void 0;
  const p = requireSrc$1(), s = utils$1, h = webClientUtils, c = dist, d = leaderboard_pb$1, l = clientMetadataProvider, g = requireCacheServiceErrorMapper(), f = grpcResponseTypes, _ = common_pb$2;
  class te {
    constructor(ie) {
      this.logger = ie.configuration.getLoggerFactory().getLogger(this), this.cacheServiceErrorMapper = new g.CacheServiceErrorMapper(ie.configuration.getThrowOnErrors()), this.logger.debug(`Creating data client using endpoint: '${(0, h.getWebCacheEndpoint)(ie.credentialProvider)}`), this.clientMetadataProvider = new l.ClientMetadataProvider({
        authToken: ie.credentialProvider.getAuthToken(),
        clientType: "leaderboard"
      }), this.deadlineMillis = ie.configuration.getTransportStrategy().getGrpcConfig().getDeadlineMillis(), this.client = new c.leaderboard.LeaderboardClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, h.getWebCacheEndpoint)(ie.credentialProvider),
        null,
        {}
      );
    }
    close() {
      this.logger.debug("Closing cache control client");
    }
    convertMapOrRecordToElementsList(ie) {
      const se = [];
      return ie instanceof Map ? ie.forEach((m, w) => {
        const q = new d._Element();
        q.setId(w), q.setScore(m), se.push(q);
      }) : Object.entries(ie).forEach((m) => {
        const w = new d._Element();
        w.setId(Number(m[0])), w.setScore(m[1]), se.push(w);
      }), se;
    }
    convertToRankedElementsList(ie) {
      return ie.map((se) => new f._RankedElement(se.getId(), se.getScore(), se.getRank()));
    }
    async upsert(ie, se, m) {
      const w = m instanceof Map ? m.size : Object.keys(m).length;
      try {
        (0, s.validateLeaderboardNumberOfElements)(w);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new p.LeaderboardUpsert.Error(j));
      }
      return this.logger.trace(`Issuing 'upsert' request; cache: ${ie}, leaderboard: ${se}, number of elements: ${w}`), await this.sendUpsert(ie, se, m);
    }
    async sendUpsert(ie, se, m) {
      const w = new d._UpsertElementsRequest();
      return w.setCacheName(ie), w.setLeaderboard(se), w.setElementsList(this.convertMapOrRecordToElementsList(m)), await new Promise((q, j) => {
        this.client.upsertElements(w, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, (k, z) => {
          z ? q(new p.LeaderboardUpsert.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: k,
            errorResponseFactoryFn: ($) => new p.LeaderboardUpsert.Error($),
            resolveFn: q,
            rejectFn: j
          });
        });
      });
    }
    async fetchByScore(ie, se, m, w, q, j, k) {
      var z;
      const $ = j === void 0 ? 0 : j, re = k === void 0 ? 8192 : k, oe = q != null ? q : p.LeaderboardOrder.Ascending;
      try {
        (0, s.validateSortedSetScores)(m, w), (0, s.validateLeaderboardOffset)($), (0, s.validateLeaderboardCount)(re);
      } catch (le) {
        return this.cacheServiceErrorMapper.returnOrThrowError(le, (ue) => new p.LeaderboardFetch.Error(ue));
      }
      return this.logger.trace(`Issuing 'fetchByScore' request; cache: ${ie}, leaderboard: ${se}, order: ${oe.toString()}, minScore: ${m != null ? m : "null"}, maxScore: ${(z = w == null ? void 0 : w.toString()) !== null && z !== void 0 ? z : "null"}, offset: ${$.toString()}, count: ${re.toString()}`), await this.sendFetchByScore(ie, se, oe, $, re, m, w);
    }
    async sendFetchByScore(ie, se, m, w, q, j, k) {
      const z = new d._GetByScoreRequest();
      z.setCacheName(ie), z.setLeaderboard(se), z.setOffset(w), z.setLimitElements(q);
      const $ = m === p.LeaderboardOrder.Descending ? d._Order.DESCENDING : d._Order.ASCENDING;
      z.setOrder($);
      const re = new d._ScoreRange();
      return j !== void 0 ? re.setMinInclusive(j) : re.setUnboundedMin(new _._Unbounded()), k !== void 0 ? re.setMaxExclusive(k) : re.setUnboundedMax(new _._Unbounded()), z.setScoreRange(re), await new Promise((oe, le) => {
        this.client.getByScore(z, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, (ue, pe) => {
          if (pe) {
            const he = pe.getElementsList();
            oe(new p.LeaderboardFetch.Success(this.convertToRankedElementsList(he)));
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: ue,
              errorResponseFactoryFn: (he) => new p.LeaderboardFetch.Error(he),
              resolveFn: oe,
              rejectFn: le
            });
        });
      });
    }
    async fetchByRank(ie, se, m, w, q) {
      const j = q != null ? q : p.LeaderboardOrder.Ascending;
      try {
        (0, s.validateLeaderboardRanks)(m, w);
      } catch (k) {
        return this.cacheServiceErrorMapper.returnOrThrowError(k, (z) => new p.LeaderboardFetch.Error(z));
      }
      return this.logger.trace(`Issuing 'fetchByRank' request; cache: ${ie}, leaderboard: ${se}, order: ${j.toString()}, startRank: ${m}, endRank: ${w}`), await this.sendFetchByRank(ie, se, m, w, j);
    }
    async sendFetchByRank(ie, se, m, w, q) {
      const j = new d._GetByRankRequest();
      j.setCacheName(ie), j.setLeaderboard(se);
      const k = q === p.LeaderboardOrder.Descending ? d._Order.DESCENDING : d._Order.ASCENDING;
      j.setOrder(k);
      const z = new d._RankRange();
      return z.setStartInclusive(m), z.setEndExclusive(w), j.setRankRange(z), await new Promise(($, re) => {
        this.client.getByRank(j, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, (oe, le) => {
          if (le) {
            const ue = le.getElementsList();
            $(new p.LeaderboardFetch.Success(this.convertToRankedElementsList(ue)));
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: oe,
              errorResponseFactoryFn: (ue) => new p.LeaderboardFetch.Error(ue),
              resolveFn: $,
              rejectFn: re
            });
        });
      });
    }
    async getRank(ie, se, m, w) {
      const q = w != null ? w : p.LeaderboardOrder.Ascending;
      return this.logger.trace(`Issuing 'getRank' request; cache: ${ie}, leaderboard: ${se}, order: ${q.toString()}, number of ids: ${m.length}`), await this.sendGetRank(ie, se, m, q);
    }
    async sendGetRank(ie, se, m, w) {
      const q = new d._GetRankRequest();
      q.setCacheName(ie), q.setLeaderboard(se), q.setIdsList(m);
      const j = w === p.LeaderboardOrder.Descending ? d._Order.DESCENDING : d._Order.ASCENDING;
      return q.setOrder(j), await new Promise((k, z) => {
        this.client.getRank(q, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, ($, re) => {
          if (re) {
            const oe = re.getElementsList();
            k(new p.LeaderboardFetch.Success(this.convertToRankedElementsList(oe)));
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: $,
              errorResponseFactoryFn: (oe) => new p.LeaderboardFetch.Error(oe),
              resolveFn: k,
              rejectFn: z
            });
        });
      });
    }
    async length(ie, se) {
      return this.logger.trace(`Issuing 'length' request; cache: ${ie}, leaderboard: ${se}`), await this.sendLength(ie, se);
    }
    async sendLength(ie, se) {
      const m = new d._GetLeaderboardLengthRequest();
      return m.setCacheName(ie), m.setLeaderboard(se), await new Promise((w, q) => {
        this.client.getLeaderboardLength(m, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, (j, k) => {
          if (k) {
            const z = k.getCount();
            w(new p.LeaderboardLength.Success(z));
          } else
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: j,
              errorResponseFactoryFn: (z) => new p.LeaderboardLength.Error(z),
              resolveFn: w,
              rejectFn: q
            });
        });
      });
    }
    async removeElements(ie, se, m) {
      try {
        (0, s.validateLeaderboardNumberOfElements)(m.length);
      } catch (w) {
        return this.cacheServiceErrorMapper.returnOrThrowError(w, (q) => new p.LeaderboardRemoveElements.Error(q));
      }
      return this.logger.trace(`Issuing 'removeElements' request; cache: ${ie}, leaderboard: ${se}, number of elements: ${m.length.toString()}`), await this.sendRemoveElements(ie, se, m);
    }
    async sendRemoveElements(ie, se, m) {
      const w = new d._RemoveElementsRequest();
      return w.setCacheName(ie), w.setLeaderboard(se), w.setIdsList(m), await new Promise((q, j) => {
        this.client.removeElements(w, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, (k, z) => {
          z ? q(new p.LeaderboardRemoveElements.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: k,
            errorResponseFactoryFn: ($) => new p.LeaderboardRemoveElements.Error($),
            resolveFn: q,
            rejectFn: j
          });
        });
      });
    }
    async delete(ie, se) {
      return this.logger.trace(`Issuing 'delete' request; cache: ${ie}, leaderboard: ${se}`), await this.sendDelete(ie, se);
    }
    async sendDelete(ie, se) {
      const m = new d._DeleteLeaderboardRequest();
      return m.setCacheName(ie), m.setLeaderboard(se), await new Promise((w, q) => {
        this.client.deleteLeaderboard(m, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, h.createCallMetadata)(ie, this.deadlineMillis)
        }, (j, k) => {
          k ? w(new p.LeaderboardDelete.Success()) : this.cacheServiceErrorMapper.resolveOrRejectError({
            err: j,
            errorResponseFactoryFn: (z) => new p.LeaderboardDelete.Error(z),
            resolveFn: w,
            rejectFn: q
          });
        });
      });
    }
  }
  return leaderboardDataClient.LeaderboardDataClient = te, leaderboardDataClient;
}
var hasRequiredPreviewLeaderboardClient;
function requirePreviewLeaderboardClient() {
  if (hasRequiredPreviewLeaderboardClient) return previewLeaderboardClient;
  hasRequiredPreviewLeaderboardClient = 1, Object.defineProperty(previewLeaderboardClient, "__esModule", { value: !0 }), previewLeaderboardClient.PreviewLeaderboardClient = void 0;
  const p = leaderboard, s = requireLeaderboardDataClient(), h = requireSrc$1(), c = requireSrc();
  class d {
    constructor(f) {
      var _, te;
      const ae = {
        configuration: (_ = f == null ? void 0 : f.configuration) !== null && _ !== void 0 ? _ : l(),
        credentialProvider: (te = f == null ? void 0 : f.credentialProvider) !== null && te !== void 0 ? te : (0, h.getDefaultCredentialProvider)()
      };
      this.dataClient = new s.LeaderboardDataClient(ae);
    }
    close() {
      this.dataClient.close();
    }
    /**
     * Creates an instance of LeaderboardClient with 32-bit float scores.
     */
    leaderboard(f, _) {
      return new p.Leaderboard(this.dataClient, f, _);
    }
  }
  previewLeaderboardClient.PreviewLeaderboardClient = d;
  function l() {
    const g = c.LeaderboardConfigurations.Laptop.latest();
    return g.getLoggerFactory().getLogger("LeaderboardClient").info('No configuration provided to LeaderboardClient. Using default "Laptop" configuration, suitable for development. For production use, consider specifying an explicit configuration.'), g;
  }
  return previewLeaderboardClient;
}
var previewStorageClient = {}, storageDataClient = {}, hasRequiredStorageDataClient;
function requireStorageDataClient() {
  if (hasRequiredStorageDataClient) return storageDataClient;
  hasRequiredStorageDataClient = 1, Object.defineProperty(storageDataClient, "__esModule", { value: !0 }), storageDataClient.StorageDataClient = void 0;
  const p = dist, s = requireSrc(), h = store_pb$1, c = utils$1, d = webClientUtils, l = clientMetadataProvider;
  var g = h._StoreValue.ValueCase;
  const f = requireCacheServiceErrorMapper();
  class _ {
    /**
     * @param {DataClientProps} props
     */
    constructor(ae) {
      this.deadlineMillis = 1e4, this.cacheServiceErrorMapper = new f.CacheServiceErrorMapper(!1), this.logger = ae.configuration.getLoggerFactory().getLogger(this), this.logger.debug(`Creating storage data client using endpoint: '${(0, d.getWebStorageEndpoint)(ae.credentialProvider)}`), this.clientMetadataProvider = new l.ClientMetadataProvider({
        authToken: ae.credentialProvider.getAuthToken(),
        clientType: "store"
      }), this.clientWrapper = new p.store.StoreClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, d.getWebStorageEndpoint)(ae.credentialProvider),
        null
      );
    }
    close() {
      this.logger.debug("Closing cache control client");
    }
    async get(ae, ie) {
      try {
        (0, c.validateStoreName)(ae);
      } catch (m) {
        return this.cacheServiceErrorMapper.returnOrThrowError(m, (w) => new s.StorageGet.Error(w));
      }
      this.logger.trace(`Issuing 'get' request; key: ${ie.toString()}`);
      const se = await this.sendGet(ae, (0, d.convertToB64String)(ie));
      return this.logger.trace(`'get' request result: ${se.toString()}`), se;
    }
    async sendGet(ae, ie) {
      const se = new h._StoreGetRequest();
      return se.setKey(ie), await new Promise((m, w) => {
        this.clientWrapper.get(se, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, d.createStorageMetadata)(ae, this.deadlineMillis)
        }, (q, j) => {
          const k = j == null ? void 0 : j.getValue();
          if (j)
            switch (k == null ? void 0 : k.getValueCase()) {
              case void 0:
              case g.VALUE_NOT_SET:
                return m(new s.StorageGet.Error(new s.UnknownError("StorageGet responded with an unknown result")));
              case g.BYTES_VALUE:
                return m(s.StorageGet.Found.ofBytes(k.getBytesValue_asU8()));
              case g.STRING_VALUE:
                return m(s.StorageGet.Found.ofString(k.getStringValue()));
              case g.INTEGER_VALUE:
                return m(s.StorageGet.Found.ofInt(k.getIntegerValue()));
              case g.DOUBLE_VALUE:
                return m(s.StorageGet.Found.ofDouble(k.getDoubleValue()));
            }
          else {
            if (this.cacheServiceErrorMapper.convertError(q).errorCode() === s.MomentoErrorCode.STORE_ITEM_NOT_FOUND_ERROR)
              return m(new s.StorageGet.NotFound());
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: q,
              errorResponseFactoryFn: ($) => new s.StorageGet.Error($),
              resolveFn: m,
              rejectFn: w
            });
          }
        });
      });
    }
    async putInt(ae, ie, se) {
      try {
        (0, c.validateStoreName)(ae);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.StoragePut.Error(j));
      }
      this.logger.trace(`Issuing 'put' request; key: ${ie.toString()}`);
      const m = new h._StoreValue();
      m.setIntegerValue(se);
      const w = await this.sendPut(ae, (0, d.convertToB64String)(ie), m);
      return this.logger.trace(`'put' request result: ${w.toString()}`), w;
    }
    async putDouble(ae, ie, se) {
      try {
        (0, c.validateStoreName)(ae);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.StoragePut.Error(j));
      }
      this.logger.trace(`Issuing 'put' request; key: ${ie.toString()}`);
      const m = new h._StoreValue();
      m.setDoubleValue(se);
      const w = await this.sendPut(ae, (0, d.convertToB64String)(ie), m);
      return this.logger.trace(`'put' request result: ${w.toString()}`), w;
    }
    async putBytes(ae, ie, se) {
      try {
        (0, c.validateStoreName)(ae);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.StoragePut.Error(j));
      }
      this.logger.trace(`Issuing 'put' request; key: ${ie.toString()}`);
      const m = new h._StoreValue();
      m.setBytesValue(se);
      const w = await this.sendPut(ae, (0, d.convertToB64String)(ie), m);
      return this.logger.trace(`'put' request result: ${w.toString()}`), w;
    }
    async putString(ae, ie, se) {
      try {
        (0, c.validateStoreName)(ae);
      } catch (q) {
        return this.cacheServiceErrorMapper.returnOrThrowError(q, (j) => new s.StoragePut.Error(j));
      }
      this.logger.trace(`Issuing 'put' request; key: ${ie.toString()}`);
      const m = new h._StoreValue();
      m.setStringValue(se);
      const w = await this.sendPut(ae, (0, d.convertToB64String)(ie), m);
      return this.logger.trace(`'put' request result: ${w.toString()}`), w;
    }
    async sendPut(ae, ie, se) {
      const m = new h._StorePutRequest();
      return m.setKey(ie), m.setValue(se), await new Promise((w, q) => {
        this.clientWrapper.put(m, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, d.createStorageMetadata)(ae, this.deadlineMillis)
        }, (j, k) => {
          j ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: j,
            errorResponseFactoryFn: (z) => new s.StoragePut.Error(z),
            resolveFn: w,
            rejectFn: q
          }) : w(new s.StoragePut.Success());
        });
      });
    }
    async delete(ae, ie) {
      try {
        (0, c.validateStoreName)(ae);
      } catch (m) {
        return this.cacheServiceErrorMapper.returnOrThrowError(m, (w) => new s.StorageDelete.Error(w));
      }
      this.logger.trace(`Issuing 'delete' request; key: ${ie.toString()}`);
      const se = await this.sendDelete(ae, (0, d.convertToB64String)(ie));
      return this.logger.trace(`'delete' request result: ${se.toString()}`), se;
    }
    async sendDelete(ae, ie) {
      const se = new h._StoreDeleteRequest();
      return se.setKey(ie), await new Promise((m, w) => {
        this.clientWrapper.delete(se, {
          ...this.clientMetadataProvider.createClientMetadata(),
          ...(0, d.createStorageMetadata)(ae, this.deadlineMillis)
        }, (q, j) => {
          q ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: q,
            errorResponseFactoryFn: (k) => new s.StorageDelete.Error(k),
            resolveFn: m,
            rejectFn: w
          }) : m(new s.StorageDelete.Success());
        });
      });
    }
  }
  return storageDataClient.StorageDataClient = _, storageDataClient;
}
var storageControlClient = {}, hasRequiredStorageControlClient;
function requireStorageControlClient() {
  if (hasRequiredStorageControlClient) return storageControlClient;
  hasRequiredStorageControlClient = 1, Object.defineProperty(storageControlClient, "__esModule", { value: !0 }), storageControlClient.StorageControlClient = void 0;
  const p = dist, s = requireSrc(), h = controlclient_pb$1, c = utils$1, d = webClientUtils, l = clientMetadataProvider, g = requireCacheServiceErrorMapper();
  class f {
    /**
     * @param {ControlClientProps} props
     */
    constructor(te) {
      this.logger = te.configuration.getLoggerFactory().getLogger(this), this.cacheServiceErrorMapper = new g.CacheServiceErrorMapper(!1), this.logger.debug(`Creating storage control client using endpoint: '${(0, d.getWebControlEndpoint)(te.credentialProvider)}`), this.clientMetadataProvider = new l.ClientMetadataProvider({
        authToken: te.credentialProvider.getAuthToken(),
        clientType: "store"
      }), this.clientWrapper = new p.control.ScsControlClient(
        // Note: all web SDK requests are routed to a `web.` subdomain to allow us flexibility on the server
        (0, d.getWebControlEndpoint)(te.credentialProvider),
        null,
        {}
      );
    }
    close() {
      this.logger.debug("Closing cache control client");
    }
    async createStore(te) {
      try {
        (0, c.validateStoreName)(te);
      } catch (ie) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ie, (se) => new s.CreateStore.Error(se));
      }
      this.logger.debug(`Creating store: ${te}`);
      const ae = new h._CreateStoreRequest();
      return ae.setStoreName(te), await new Promise((ie, se) => {
        this.clientWrapper.createStore(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          if (m) {
            if (this.cacheServiceErrorMapper.convertError(m).errorCode() === s.MomentoErrorCode.STORE_ALREADY_EXISTS_ERROR)
              return ie(new s.CreateStore.AlreadyExists());
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: m,
              errorResponseFactoryFn: (j) => new s.CreateStore.Error(j),
              resolveFn: ie,
              rejectFn: se
            });
          } else
            ie(new s.CreateStore.Success());
        });
      });
    }
    async deleteStore(te) {
      try {
        (0, c.validateStoreName)(te);
      } catch (ie) {
        return this.cacheServiceErrorMapper.returnOrThrowError(ie, (se) => new s.DeleteStore.Error(se));
      }
      const ae = new h._DeleteStoreRequest();
      return ae.setStoreName(te), this.logger.debug(`Deleting store: ${te}`), await new Promise((ie, se) => {
        this.clientWrapper.deleteStore(ae, this.clientMetadataProvider.createClientMetadata(), (m, w) => {
          m ? this.cacheServiceErrorMapper.resolveOrRejectError({
            err: m,
            errorResponseFactoryFn: (q) => new s.DeleteStore.Error(q),
            resolveFn: ie,
            rejectFn: se
          }) : ie(new s.DeleteStore.Success());
        });
      });
    }
    async listStores() {
      const te = new h._ListStoresRequest();
      return te.setNextToken(""), this.logger.debug("Issuing 'listStores' request"), await new Promise((ae, ie) => {
        this.clientWrapper.listStores(te, this.clientMetadataProvider.createClientMetadata(), (se, m) => {
          if (se)
            this.cacheServiceErrorMapper.resolveOrRejectError({
              err: se,
              errorResponseFactoryFn: (w) => new s.ListStores.Error(w),
              resolveFn: ae,
              rejectFn: ie
            });
          else {
            const w = m.getStoreList().map((q) => {
              const j = q.getStoreName();
              return new s.StoreInfo(j);
            });
            ae(new s.ListStores.Success(w));
          }
        });
      });
    }
  }
  return storageControlClient.StorageControlClient = f, storageControlClient;
}
var hasRequiredPreviewStorageClient;
function requirePreviewStorageClient() {
  if (hasRequiredPreviewStorageClient) return previewStorageClient;
  hasRequiredPreviewStorageClient = 1, Object.defineProperty(previewStorageClient, "__esModule", { value: !0 }), previewStorageClient.PreviewStorageClient = void 0;
  const p = clients, s = requireSrc(), h = requireSrc$1(), c = requireStorageDataClient(), d = requireStorageControlClient();
  class l extends p.AbstractStorageClient {
    constructor(ae) {
      var ie, se;
      const m = {
        configuration: (ie = ae == null ? void 0 : ae.configuration) !== null && ie !== void 0 ? ie : _(),
        credentialProvider: (se = ae == null ? void 0 : ae.credentialProvider) !== null && se !== void 0 ? se : (0, h.getDefaultCredentialProvider)()
      }, w = g(m), q = f(m);
      super([q], w);
    }
    close() {
      this.controlClient.close(), this.dataClients.forEach((ae) => ae.close());
    }
    /**
     * The configuration used by this client.
     *
     * @readonly
     * @type {StorageConfiguration} the configuration used by this client
     * @memberof PreviewStorageClient
     */
    get configuration() {
      return this._configuration;
    }
  }
  previewStorageClient.PreviewStorageClient = l;
  function g(te) {
    return new d.StorageControlClient(te);
  }
  function f(te) {
    return new c.StorageDataClient(te);
  }
  function _() {
    const te = s.StorageConfigurations.Default.latest();
    return te.getLoggerFactory().getLogger("StorageClient").info('No configuration provided to StorageClient. Using latest "Default" configuration, suitable for development. For production use, consider specifying an explicit configuration.'), te;
  }
  return previewStorageClient;
}
var configurations = {}, configuration = {};
Object.defineProperty(configuration, "__esModule", { value: !0 });
configuration.CacheConfiguration = void 0;
class CacheConfiguration {
  constructor(s) {
    this.middlewares = [], this.loggerFactory = s.loggerFactory, this.transportStrategy = s.transportStrategy, this.middlewares = s.middlewares, this.throwOnErrors = s.throwOnErrors, this.readConcern = s.readConcern;
  }
  getLoggerFactory() {
    return this.loggerFactory;
  }
  getTransportStrategy() {
    return this.transportStrategy;
  }
  withTransportStrategy(s) {
    return new CacheConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: s,
      middlewares: this.middlewares,
      throwOnErrors: this.throwOnErrors,
      readConcern: this.readConcern
    });
  }
  getMiddlewares() {
    return this.middlewares;
  }
  withMiddlewares(s) {
    return new CacheConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: this.transportStrategy,
      middlewares: s,
      throwOnErrors: this.throwOnErrors,
      readConcern: this.readConcern
    });
  }
  withClientTimeoutMillis(s) {
    return new CacheConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: this.transportStrategy.withClientTimeoutMillis(s),
      middlewares: this.middlewares,
      throwOnErrors: this.throwOnErrors,
      readConcern: this.readConcern
    });
  }
  getThrowOnErrors() {
    return this.throwOnErrors;
  }
  withThrowOnErrors(s) {
    return new CacheConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: this.transportStrategy,
      middlewares: this.middlewares,
      throwOnErrors: s,
      readConcern: this.readConcern
    });
  }
  getReadConcern() {
    return this.readConcern;
  }
  withReadConcern(s) {
    return new CacheConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: this.transportStrategy,
      middlewares: this.middlewares,
      throwOnErrors: this.throwOnErrors,
      readConcern: s
    });
  }
}
configuration.CacheConfiguration = CacheConfiguration;
var transport = {}, grpcConfiguration = {};
Object.defineProperty(grpcConfiguration, "__esModule", { value: !0 });
var transportStrategy = {};
Object.defineProperty(transportStrategy, "__esModule", { value: !0 });
transportStrategy.StaticTransportStrategy = transportStrategy.StaticGrpcConfiguration = void 0;
class StaticGrpcConfiguration {
  constructor(s) {
    this.deadlineMillis = s.deadlineMillis;
  }
  getDeadlineMillis() {
    return this.deadlineMillis;
  }
  withDeadlineMillis(s) {
    return new StaticGrpcConfiguration({
      deadlineMillis: s
    });
  }
}
transportStrategy.StaticGrpcConfiguration = StaticGrpcConfiguration;
class StaticTransportStrategy {
  constructor(s) {
    this.grpcConfig = s.grpcConfiguration;
  }
  getGrpcConfig() {
    return this.grpcConfig;
  }
  withGrpcConfig(s) {
    return new StaticTransportStrategy({
      grpcConfiguration: s
    });
  }
  withClientTimeoutMillis(s) {
    return new StaticTransportStrategy({
      grpcConfiguration: this.grpcConfig.withDeadlineMillis(s)
    });
  }
}
transportStrategy.StaticTransportStrategy = StaticTransportStrategy;
(function(p) {
  var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(c, d, l, g) {
    g === void 0 && (g = l);
    var f = Object.getOwnPropertyDescriptor(d, l);
    (!f || ("get" in f ? !d.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(c, g, f);
  } : function(c, d, l, g) {
    g === void 0 && (g = l), c[g] = d[l];
  }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(c, d) {
    for (var l in c) l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && s(d, c, l);
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), h(grpcConfiguration, p), h(transportStrategy, p);
})(transport);
var defaultMomentoLogger = {};
(function(p) {
  Object.defineProperty(p, "__esModule", { value: !0 }), p.DefaultMomentoLogger = p.DefaultMomentoLoggerFactory = p.DefaultMomentoLoggerLevel = void 0;
  var s;
  (function(d) {
    d[d.TRACE = 5] = "TRACE", d[d.DEBUG = 10] = "DEBUG", d[d.INFO = 20] = "INFO", d[d.WARN = 30] = "WARN", d[d.ERROR = 40] = "ERROR";
  })(s = p.DefaultMomentoLoggerLevel || (p.DefaultMomentoLoggerLevel = {}));
  class h {
    constructor(l = s.INFO) {
      this.level = l;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getLogger(l) {
      return new c(l, this.level);
    }
  }
  p.DefaultMomentoLoggerFactory = h;
  class c {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(l, g) {
      this.loggerName = typeof l == "string" || l instanceof String ? l : (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        l.constructor.name
      ), this.level = g;
    }
    trace(l, ...g) {
      this.level > s.TRACE || this.outputMessage(console.log, s.TRACE, l, g);
    }
    debug(l, ...g) {
      this.level > s.DEBUG || this.outputMessage(console.log, s.DEBUG, l, g);
    }
    info(l, ...g) {
      this.level > s.INFO || this.outputMessage(console.log, s.INFO, l, g);
    }
    warn(l, ...g) {
      this.level > s.WARN || this.outputMessage(console.warn, s.WARN, l, g);
    }
    error(l, ...g) {
      this.level > s.ERROR || this.outputMessage(console.error, s.ERROR, l, g);
    }
    outputMessage(l, g, f, _) {
      l(`[${(/* @__PURE__ */ new Date()).toISOString()}] ${s[g]} (Momento: ${this.loggerName}): ${f}${_.join(",")}`);
    }
  }
  p.DefaultMomentoLogger = c;
})(defaultMomentoLogger);
Object.defineProperty(configurations, "__esModule", { value: !0 });
configurations.Browser = configurations.Laptop = void 0;
const configuration_1 = configuration, sdk_core_1 = requireSrc$1(), transport_1$1 = transport, default_momento_logger_1$3 = defaultMomentoLogger, defaultLoggerFactory$3 = new default_momento_logger_1$3.DefaultMomentoLoggerFactory();
let Laptop$2 = class Rt extends configuration_1.CacheConfiguration {
  /**
   * Provides the latest recommended configuration for a laptop development environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {CacheConfiguration}
   */
  static latest(s = defaultLoggerFactory$3) {
    return Rt.v1(s);
  }
  /**
   * Provides v1 recommended configuration for a laptop development environment.  This configuration is guaranteed not
   * to change in future releases of the Momento web SDK.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {CacheConfiguration}
   */
  static v1(s = defaultLoggerFactory$3) {
    const c = new transport_1$1.StaticGrpcConfiguration({
      deadlineMillis: 5e3
    }), d = new transport_1$1.StaticTransportStrategy({
      grpcConfiguration: c
    });
    return new Rt({
      loggerFactory: s,
      transportStrategy: d,
      middlewares: [],
      throwOnErrors: !1,
      readConcern: sdk_core_1.ReadConcern.BALANCED
    });
  }
};
configurations.Laptop = Laptop$2;
let Browser$1 = class bt extends configuration_1.CacheConfiguration {
  /**
   * Provides the latest recommended configuration for an in-browser environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {CacheConfiguration}
   */
  static latest(s = defaultLoggerFactory$3) {
    return bt.v1(s);
  }
  /**
   * Provides v1 recommended configuration for an in-browser environment.  This configuration is guaranteed not
   * to change in future releases of the Momento web SDK.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {CacheConfiguration}
   */
  static v1(s = defaultLoggerFactory$3) {
    const c = new transport_1$1.StaticGrpcConfiguration({
      deadlineMillis: 5e3
    }), d = new transport_1$1.StaticTransportStrategy({
      grpcConfiguration: c
    });
    return new bt({
      loggerFactory: s,
      transportStrategy: d,
      middlewares: [],
      throwOnErrors: !1,
      readConcern: sdk_core_1.ReadConcern.BALANCED
    });
  }
};
configurations.Browser = Browser$1;
var topicConfigurations = {}, topicConfiguration = {};
Object.defineProperty(topicConfiguration, "__esModule", { value: !0 });
topicConfiguration.TopicClientConfiguration = void 0;
class TopicClientConfiguration {
  constructor(s) {
    this.loggerFactory = s.loggerFactory, this.throwOnErrors = s.throwOnErrors;
  }
  getLoggerFactory() {
    return this.loggerFactory;
  }
  getThrowOnErrors() {
    return this.throwOnErrors;
  }
  withThrowOnErrors(s) {
    return new TopicClientConfiguration({
      loggerFactory: this.loggerFactory,
      throwOnErrors: s
    });
  }
}
topicConfiguration.TopicClientConfiguration = TopicClientConfiguration;
Object.defineProperty(topicConfigurations, "__esModule", { value: !0 });
topicConfigurations.Browser = topicConfigurations.Laptop = topicConfigurations.Default = void 0;
const default_momento_logger_1$2 = defaultMomentoLogger, topic_configuration_1 = topicConfiguration, defaultLoggerFactory$2 = new default_momento_logger_1$2.DefaultMomentoLoggerFactory();
let Default$1 = class extends topic_configuration_1.TopicClientConfiguration {
  /**
   * Provides the latest recommended configuration for a default environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {TopicConfiguration}
   */
  static latest(s = defaultLoggerFactory$2) {
    return new topic_configuration_1.TopicClientConfiguration({
      loggerFactory: s,
      throwOnErrors: !1
    });
  }
};
topicConfigurations.Default = Default$1;
let Laptop$1 = class mt extends topic_configuration_1.TopicClientConfiguration {
  /**
   * Provides the latest recommended configuration for a laptop development environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {TopicConfiguration}
   */
  static latest(s = defaultLoggerFactory$2) {
    return mt.v1(s);
  }
  /**
   * Provides v1 recommended configuration for a laptop development environment.  This configuration is guaranteed not
   * to change in future releases of the Momento web SDK.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {TopicConfiguration}
   */
  static v1(s = defaultLoggerFactory$2) {
    return new mt({
      loggerFactory: s,
      throwOnErrors: !1
    });
  }
};
topicConfigurations.Laptop = Laptop$1;
class Browser extends topic_configuration_1.TopicClientConfiguration {
  /**
   * Provides the latest recommended configuration for an in-browser environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {TopicConfiguration}
   */
  static latest(s = defaultLoggerFactory$2) {
    return Browser.v1(s);
  }
  /**
   * Provides v1 recommended configuration for an in-browser environment.  This configuration is guaranteed not
   * to change in future releases of the Momento web SDK.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {TopicConfiguration}
   */
  static v1(s = defaultLoggerFactory$2) {
    return new Browser({
      loggerFactory: s,
      throwOnErrors: !1
    });
  }
}
topicConfigurations.Browser = Browser;
var leaderboardConfigurations = {}, leaderboardConfiguration = {};
Object.defineProperty(leaderboardConfiguration, "__esModule", { value: !0 });
leaderboardConfiguration.LeaderboardClientConfiguration = void 0;
class LeaderboardClientConfiguration {
  constructor(s) {
    this.loggerFactory = s.loggerFactory, this.transportStrategy = s.transportStrategy, this.throwOnErrors = s.throwOnErrors;
  }
  getLoggerFactory() {
    return this.loggerFactory;
  }
  getTransportStrategy() {
    return this.transportStrategy;
  }
  withClientTimeoutMillis(s) {
    return new LeaderboardClientConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: this.transportStrategy.withClientTimeoutMillis(s),
      throwOnErrors: this.throwOnErrors
    });
  }
  withTransportStrategy(s) {
    return new LeaderboardClientConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: s,
      throwOnErrors: this.throwOnErrors
    });
  }
  getThrowOnErrors() {
    return this.throwOnErrors;
  }
  withThrowOnErrors(s) {
    return new LeaderboardClientConfiguration({
      loggerFactory: this.loggerFactory,
      transportStrategy: this.transportStrategy,
      throwOnErrors: s
    });
  }
}
leaderboardConfiguration.LeaderboardClientConfiguration = LeaderboardClientConfiguration;
Object.defineProperty(leaderboardConfigurations, "__esModule", { value: !0 });
leaderboardConfigurations.Laptop = void 0;
const leaderboard_configuration_1 = leaderboardConfiguration, transport_1 = transport, default_momento_logger_1$1 = defaultMomentoLogger, defaultLoggerFactory$1 = new default_momento_logger_1$1.DefaultMomentoLoggerFactory();
class Laptop extends leaderboard_configuration_1.LeaderboardClientConfiguration {
  /**
   * Provides the latest recommended configuration for a laptop development environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {LeaderboardConfiguration}
   */
  static latest(s = defaultLoggerFactory$1) {
    return Laptop.v1(s);
  }
  /**
   * Provides v1 recommended configuration for a laptop development environment.  This configuration is guaranteed not
   * to change in future releases of the Momento web SDK.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {LeaderboardConfiguration}
   */
  static v1(s = defaultLoggerFactory$1) {
    const c = new transport_1.StaticGrpcConfiguration({
      deadlineMillis: 5e3
    }), d = new transport_1.StaticTransportStrategy({
      grpcConfiguration: c
    });
    return new Laptop({
      loggerFactory: s,
      transportStrategy: d,
      throwOnErrors: !1
    });
  }
}
leaderboardConfigurations.Laptop = Laptop;
var storageConfigurations = {}, storageConfiguration = {};
Object.defineProperty(storageConfiguration, "__esModule", { value: !0 });
storageConfiguration.StorageClientConfiguration = void 0;
class StorageClientConfiguration {
  constructor(s) {
    this.loggerFactory = s.loggerFactory;
  }
  getLoggerFactory() {
    return this.loggerFactory;
  }
}
storageConfiguration.StorageClientConfiguration = StorageClientConfiguration;
Object.defineProperty(storageConfigurations, "__esModule", { value: !0 });
storageConfigurations.Default = void 0;
const default_momento_logger_1 = defaultMomentoLogger, storage_configuration_1 = storageConfiguration, defaultLoggerFactory = new default_momento_logger_1.DefaultMomentoLoggerFactory();
class Default extends storage_configuration_1.StorageClientConfiguration {
  /**
   * Provides the latest recommended configuration for a default environment.  NOTE: this configuration may
   * change in future releases to take advantage of improvements we identify for default configurations.
   * @param {MomentoLoggerFactory} [loggerFactory=defaultLoggerFactory]
   * @returns {StorageConfiguration}
   */
  static latest(s = defaultLoggerFactory) {
    return new storage_configuration_1.StorageClientConfiguration({
      loggerFactory: s
    });
  }
}
storageConfigurations.Default = Default;
var hasRequiredSrc;
function requireSrc() {
  return hasRequiredSrc || (hasRequiredSrc = 1, function(p) {
    var s = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Ve, Ie, Oe, De) {
      De === void 0 && (De = Oe);
      var Ne = Object.getOwnPropertyDescriptor(Ie, Oe);
      (!Ne || ("get" in Ne ? !Ie.__esModule : Ne.writable || Ne.configurable)) && (Ne = { enumerable: !0, get: function() {
        return Ie[Oe];
      } }), Object.defineProperty(Ve, De, Ne);
    } : function(Ve, Ie, Oe, De) {
      De === void 0 && (De = Oe), Ve[De] = Ie[Oe];
    }), h = commonjsGlobal && commonjsGlobal.__exportStar || function(Ve, Ie) {
      for (var Oe in Ve) Oe !== "default" && !Object.prototype.hasOwnProperty.call(Ie, Oe) && s(Ie, Ve, Oe);
    };
    Object.defineProperty(p, "__esModule", { value: !0 }), p.CacheSetContainsElement = p.CacheSetFetch = p.CacheIncrement = p.ListCaches = p.DeleteCache = p.CreateCache = p.CacheFlush = p.CacheDelete = p.CacheGetBatch = p.CacheSetBatch = p.CacheSetIfAbsentOrEqual = p.CacheSetIfPresentAndNotEqual = p.CacheSetIfNotEqual = p.CacheSetIfEqual = p.CacheSetIfPresent = p.CacheSetIfAbsent = p.CacheSetIfNotExists = p.CacheSet = p.CacheListRetain = p.CacheListRemoveValue = p.CacheListPushFront = p.CacheListPushBack = p.CacheListPopFront = p.CacheListPopBack = p.CacheListLength = p.CacheListFetch = p.CacheListConcatenateFront = p.CacheListConcatenateBack = p.CacheGet = p.AllTopics = p.AllCaches = p.DisposableTokenScopes = p.TokenScopes = p.PermissionScopes = p.TopicRole = p.CacheRole = p.AllDataReadWrite = p.EnvMomentoTokenProvider = p.StringMomentoTokenProvider = p.CredentialProvider = p.CacheInfo = p.AuthClient = p.CacheClient = p.Configurations = p.SortedSetOrder = p.ItemType = p.CollectionTtl = p.DefaultMomentoLoggerLevel = p.DefaultMomentoLogger = p.DefaultMomentoLoggerFactory = void 0, p.ExpiresIn = p.ExpiresAt = p.GenerateDisposableToken = p.RefreshAuthToken = p.RefreshApiKey = p.GenerateAuthToken = p.GenerateApiKey = p.LeaderboardOrder = p.PreviewLeaderboardClient = p.LeaderboardClientConfiguration = p.LeaderboardConfigurations = p.TopicSubscribe = p.TopicPublish = p.TopicItem = p.TopicClient = p.TopicClientConfiguration = p.TopicConfigurations = p.CacheDecreaseTtl = p.CacheIncreaseTtl = p.CacheUpdateTtl = p.CacheKeysExist = p.CacheKeyExists = p.CacheItemGetTtl = p.CacheItemGetType = p.CacheSortedSetLengthByScore = p.CacheSortedSetLength = p.CacheSortedSetRemoveElements = p.CacheSortedSetRemoveElement = p.CacheSortedSetIncrementScore = p.CacheSortedSetGetScores = p.CacheSortedSetGetScore = p.CacheSortedSetGetRank = p.CacheSortedSetFetch = p.CacheSortedSetPutElements = p.CacheSortedSetPutElement = p.CacheSetSample = p.CacheSetRemoveElement = p.CacheSetRemoveElements = p.CacheSetAddElement = p.CacheSetAddElements = p.CacheDictionaryLength = p.CacheDictionaryIncrement = p.CacheDictionaryRemoveFields = p.CacheDictionaryRemoveField = p.CacheDictionaryGetFields = p.CacheDictionaryGetField = p.CacheDictionarySetFields = p.CacheDictionarySetField = p.CacheDictionaryFetch = p.CacheSetContainsElements = void 0, p.PreviewStorageClient = p.StorageConfigurations = p.StoreInfo = p.ReadConcern = p.WebhookDestinationType = p.RotateWebhookSecret = p.GetWebhookSecret = p.PutWebhook = p.ListWebhooks = p.DeleteWebhook = p.PostUrlWebhookDestination = p.NoopMomentoLoggerFactory = p.NoopMomentoLogger = p.UnknownError = p.StoreItemNotFoundError = p.StoreNotFoundError = p.CacheNotFoundError = p.PermissionError = p.BadRequestError = p.TimeoutError = p.ServerUnavailableError = p.UnknownServiceError = p.InvalidArgumentError = p.InternalServerError = p.LimitExceededError = p.FailedPreconditionError = p.CancelledError = p.AuthenticationError = p.StoreAlreadyExistsError = p.CacheAlreadyExistsError = p.SdkError = p.MomentoErrorCode = void 0;
    const c = requireCacheClient();
    Object.defineProperty(p, "CacheClient", { enumerable: !0, get: function() {
      return c.CacheClient;
    } });
    const d = requireAuthClient();
    Object.defineProperty(p, "AuthClient", { enumerable: !0, get: function() {
      return d.AuthClient;
    } });
    const l = requireTopicClient();
    Object.defineProperty(p, "TopicClient", { enumerable: !0, get: function() {
      return l.TopicClient;
    } });
    const g = requirePreviewLeaderboardClient();
    Object.defineProperty(p, "PreviewLeaderboardClient", { enumerable: !0, get: function() {
      return g.PreviewLeaderboardClient;
    } });
    const f = requirePreviewStorageClient();
    Object.defineProperty(p, "PreviewStorageClient", { enumerable: !0, get: function() {
      return f.PreviewStorageClient;
    } });
    const _ = configurations;
    p.Configurations = _;
    const te = topicConfigurations;
    p.TopicConfigurations = te;
    const ae = leaderboardConfigurations;
    p.LeaderboardConfigurations = ae;
    const ie = storageConfigurations;
    p.StorageConfigurations = ie;
    const se = cacheGet;
    p.CacheGet = se;
    const m = cacheListConcatenateBack;
    p.CacheListConcatenateBack = m;
    const w = cacheListConcatenateFront;
    p.CacheListConcatenateFront = w;
    const q = cacheListFetch;
    p.CacheListFetch = q;
    const j = cacheListLength;
    p.CacheListLength = j;
    const k = cacheListPopBack;
    p.CacheListPopBack = k;
    const z = cacheListPopFront;
    p.CacheListPopFront = z;
    const $ = cacheListPushBack;
    p.CacheListPushBack = $;
    const re = cacheListPushFront;
    p.CacheListPushFront = re;
    const oe = cacheListRemoveValue;
    p.CacheListRemoveValue = oe;
    const le = cacheListRetain;
    p.CacheListRetain = le;
    const ue = cacheSet;
    p.CacheSet = ue;
    const pe = cacheDelete;
    p.CacheDelete = pe;
    const he = cacheFlush;
    p.CacheFlush = he;
    const fe = createCache;
    p.CreateCache = fe;
    const ye = deleteCache;
    p.DeleteCache = ye;
    const Re = listCaches;
    p.ListCaches = Re;
    const be = cacheSetFetch;
    p.CacheSetFetch = be;
    const Me = cacheDictionaryFetch;
    p.CacheDictionaryFetch = Me;
    const ve = cacheDictionarySetField;
    p.CacheDictionarySetField = ve;
    const we = cacheDictionarySetFields;
    p.CacheDictionarySetFields = we;
    const xe = cacheDictionaryGetField;
    p.CacheDictionaryGetField = xe;
    const We = cacheDictionaryGetFields;
    p.CacheDictionaryGetFields = We;
    const He = cacheDictionaryRemoveField;
    p.CacheDictionaryRemoveField = He;
    const at = cacheDictionaryRemoveFields;
    p.CacheDictionaryRemoveFields = at;
    const Te = cacheDictionaryIncrement;
    p.CacheDictionaryIncrement = Te;
    const Le = cacheDictionaryLength;
    p.CacheDictionaryLength = Le;
    const Ze = cacheSetAddElements;
    p.CacheSetAddElements = Ze;
    const Qe = cacheSetAddElement;
    p.CacheSetAddElement = Qe;
    const et = cacheSetContainsElement;
    p.CacheSetContainsElement = et;
    const tt = cacheSetContainsElements;
    p.CacheSetContainsElements = tt;
    const rt = cacheSetRemoveElements;
    p.CacheSetRemoveElements = rt;
    const Ge = cacheSetRemoveElement;
    p.CacheSetRemoveElement = Ge;
    const Ke = cacheSetSample;
    p.CacheSetSample = Ke;
    const ot = cacheIncrement;
    p.CacheIncrement = ot;
    const ut = cacheSetIfNotExists;
    p.CacheSetIfNotExists = ut;
    const nt = cacheSetIfAbsent;
    p.CacheSetIfAbsent = nt;
    const qe = cacheSetIfPresent;
    p.CacheSetIfPresent = qe;
    const ze = cacheSetIfEqual;
    p.CacheSetIfEqual = ze;
    const ct = cacheSetIfNotEqual;
    p.CacheSetIfNotEqual = ct;
    const lt = cacheSetIfPresentAndNotEqual;
    p.CacheSetIfPresentAndNotEqual = lt;
    const Je = cacheSetIfAbsentOrEqual;
    p.CacheSetIfAbsentOrEqual = Je;
    const pt = cacheSortedSetPutElement;
    p.CacheSortedSetPutElement = pt;
    const gt = cacheSortedSetPutElements;
    p.CacheSortedSetPutElements = gt;
    const st = cacheSortedSetFetch;
    p.CacheSortedSetFetch = st;
    const $e = cacheSortedSetGetRank;
    p.CacheSortedSetGetRank = $e;
    const je = cacheSortedSetGetScore;
    p.CacheSortedSetGetScore = je;
    const Ye = requireCacheSortedSetGetScores();
    p.CacheSortedSetGetScores = Ye;
    const dt = cacheSortedSetIncrementScore;
    p.CacheSortedSetIncrementScore = dt;
    const ke = cacheSortedSetRemoveElement;
    p.CacheSortedSetRemoveElement = ke;
    const ht = cacheSortedSetRemoveElements;
    p.CacheSortedSetRemoveElements = ht;
    const ee = cacheSortedSetLength;
    p.CacheSortedSetLength = ee;
    const b = cacheSortedSetLengthByScore;
    p.CacheSortedSetLengthByScore = b;
    const M = cacheItemGetType;
    p.CacheItemGetType = M;
    const ne = cacheItemGetTtl;
    p.CacheItemGetTtl = ne;
    const ce = cacheKeyExists;
    p.CacheKeyExists = ce;
    const ge = cacheKeysExist;
    p.CacheKeysExist = ge;
    const de = cacheTtlUpdate;
    p.CacheUpdateTtl = de;
    const Se = cacheTtlIncrease;
    p.CacheIncreaseTtl = Se;
    const Be = cacheTtlDecrease;
    p.CacheDecreaseTtl = Be;
    const Ee = requireCacheBatchGet();
    p.CacheGetBatch = Ee;
    const Fe = cacheBatchSet;
    p.CacheSetBatch = Fe;
    const me = topicPublish;
    p.TopicPublish = me;
    const yt = topicSubscribe;
    p.TopicSubscribe = yt;
    const St = topicItem;
    Object.defineProperty(p, "TopicItem", { enumerable: !0, get: function() {
      return St.TopicItem;
    } });
    const Ae = generateApiKey;
    p.GenerateApiKey = Ae, p.GenerateAuthToken = Ae;
    const Xe = refreshApiKey;
    p.RefreshApiKey = Xe, p.RefreshAuthToken = Xe;
    const Ce = generateDisposableToken;
    p.GenerateDisposableToken = Ce;
    const _e = requireSrc$1();
    Object.defineProperty(p, "CacheInfo", { enumerable: !0, get: function() {
      return _e.CacheInfo;
    } }), Object.defineProperty(p, "CollectionTtl", { enumerable: !0, get: function() {
      return _e.CollectionTtl;
    } }), Object.defineProperty(p, "ItemType", { enumerable: !0, get: function() {
      return _e.ItemType;
    } }), Object.defineProperty(p, "SortedSetOrder", { enumerable: !0, get: function() {
      return _e.SortedSetOrder;
    } }), Object.defineProperty(p, "CredentialProvider", { enumerable: !0, get: function() {
      return _e.CredentialProvider;
    } }), Object.defineProperty(p, "StringMomentoTokenProvider", { enumerable: !0, get: function() {
      return _e.StringMomentoTokenProvider;
    } }), Object.defineProperty(p, "EnvMomentoTokenProvider", { enumerable: !0, get: function() {
      return _e.EnvMomentoTokenProvider;
    } }), Object.defineProperty(p, "MomentoErrorCode", { enumerable: !0, get: function() {
      return _e.MomentoErrorCode;
    } }), Object.defineProperty(p, "SdkError", { enumerable: !0, get: function() {
      return _e.SdkError;
    } }), Object.defineProperty(p, "CacheAlreadyExistsError", { enumerable: !0, get: function() {
      return _e.CacheAlreadyExistsError;
    } }), Object.defineProperty(p, "StoreAlreadyExistsError", { enumerable: !0, get: function() {
      return _e.StoreAlreadyExistsError;
    } }), Object.defineProperty(p, "AuthenticationError", { enumerable: !0, get: function() {
      return _e.AuthenticationError;
    } }), Object.defineProperty(p, "CancelledError", { enumerable: !0, get: function() {
      return _e.CancelledError;
    } }), Object.defineProperty(p, "FailedPreconditionError", { enumerable: !0, get: function() {
      return _e.FailedPreconditionError;
    } }), Object.defineProperty(p, "LimitExceededError", { enumerable: !0, get: function() {
      return _e.LimitExceededError;
    } }), Object.defineProperty(p, "InternalServerError", { enumerable: !0, get: function() {
      return _e.InternalServerError;
    } }), Object.defineProperty(p, "InvalidArgumentError", { enumerable: !0, get: function() {
      return _e.InvalidArgumentError;
    } }), Object.defineProperty(p, "UnknownServiceError", { enumerable: !0, get: function() {
      return _e.UnknownServiceError;
    } }), Object.defineProperty(p, "ServerUnavailableError", { enumerable: !0, get: function() {
      return _e.ServerUnavailableError;
    } }), Object.defineProperty(p, "TimeoutError", { enumerable: !0, get: function() {
      return _e.TimeoutError;
    } }), Object.defineProperty(p, "BadRequestError", { enumerable: !0, get: function() {
      return _e.BadRequestError;
    } }), Object.defineProperty(p, "PermissionError", { enumerable: !0, get: function() {
      return _e.PermissionError;
    } }), Object.defineProperty(p, "CacheNotFoundError", { enumerable: !0, get: function() {
      return _e.CacheNotFoundError;
    } }), Object.defineProperty(p, "StoreNotFoundError", { enumerable: !0, get: function() {
      return _e.StoreNotFoundError;
    } }), Object.defineProperty(p, "StoreItemNotFoundError", { enumerable: !0, get: function() {
      return _e.StoreItemNotFoundError;
    } }), Object.defineProperty(p, "UnknownError", { enumerable: !0, get: function() {
      return _e.UnknownError;
    } }), Object.defineProperty(p, "NoopMomentoLogger", { enumerable: !0, get: function() {
      return _e.NoopMomentoLogger;
    } }), Object.defineProperty(p, "NoopMomentoLoggerFactory", { enumerable: !0, get: function() {
      return _e.NoopMomentoLoggerFactory;
    } }), Object.defineProperty(p, "AllDataReadWrite", { enumerable: !0, get: function() {
      return _e.AllDataReadWrite;
    } }), Object.defineProperty(p, "PermissionScopes", { enumerable: !0, get: function() {
      return _e.PermissionScopes;
    } }), Object.defineProperty(p, "TokenScopes", { enumerable: !0, get: function() {
      return _e.PermissionScopes;
    } }), Object.defineProperty(p, "DisposableTokenScopes", { enumerable: !0, get: function() {
      return _e.DisposableTokenScopes;
    } }), Object.defineProperty(p, "ExpiresIn", { enumerable: !0, get: function() {
      return _e.ExpiresIn;
    } }), Object.defineProperty(p, "ExpiresAt", { enumerable: !0, get: function() {
      return _e.ExpiresAt;
    } }), Object.defineProperty(p, "AllCaches", { enumerable: !0, get: function() {
      return _e.AllCaches;
    } }), Object.defineProperty(p, "AllTopics", { enumerable: !0, get: function() {
      return _e.AllTopics;
    } }), Object.defineProperty(p, "CacheRole", { enumerable: !0, get: function() {
      return _e.CacheRole;
    } }), Object.defineProperty(p, "TopicRole", { enumerable: !0, get: function() {
      return _e.TopicRole;
    } }), Object.defineProperty(p, "LeaderboardOrder", { enumerable: !0, get: function() {
      return _e.LeaderboardOrder;
    } }), Object.defineProperty(p, "PostUrlWebhookDestination", { enumerable: !0, get: function() {
      return _e.PostUrlWebhookDestination;
    } }), Object.defineProperty(p, "DeleteWebhook", { enumerable: !0, get: function() {
      return _e.DeleteWebhook;
    } }), Object.defineProperty(p, "ListWebhooks", { enumerable: !0, get: function() {
      return _e.ListWebhooks;
    } }), Object.defineProperty(p, "PutWebhook", { enumerable: !0, get: function() {
      return _e.PutWebhook;
    } }), Object.defineProperty(p, "GetWebhookSecret", { enumerable: !0, get: function() {
      return _e.GetWebhookSecret;
    } }), Object.defineProperty(p, "RotateWebhookSecret", { enumerable: !0, get: function() {
      return _e.RotateWebhookSecret;
    } }), Object.defineProperty(p, "WebhookDestinationType", { enumerable: !0, get: function() {
      return _e.WebhookDestinationType;
    } }), Object.defineProperty(p, "ReadConcern", { enumerable: !0, get: function() {
      return _e.ReadConcern;
    } }), Object.defineProperty(p, "StoreInfo", { enumerable: !0, get: function() {
      return _e.StoreInfo;
    } });
    const Ue = topicConfiguration;
    Object.defineProperty(p, "TopicClientConfiguration", { enumerable: !0, get: function() {
      return Ue.TopicClientConfiguration;
    } });
    const _t = leaderboardConfiguration;
    Object.defineProperty(p, "LeaderboardClientConfiguration", { enumerable: !0, get: function() {
      return _t.LeaderboardClientConfiguration;
    } }), h(storage$1, p), h(enums, p);
    var ft = defaultMomentoLogger;
    Object.defineProperty(p, "DefaultMomentoLoggerFactory", { enumerable: !0, get: function() {
      return ft.DefaultMomentoLoggerFactory;
    } }), Object.defineProperty(p, "DefaultMomentoLogger", { enumerable: !0, get: function() {
      return ft.DefaultMomentoLogger;
    } }), Object.defineProperty(p, "DefaultMomentoLoggerLevel", { enumerable: !0, get: function() {
      return ft.DefaultMomentoLoggerLevel;
    } });
  }(src$1)), src$1;
}
var srcExports = requireSrc();
class EventEmitter {
  constructor() {
    Pe(this, "listeners", {});
  }
  on(s, h) {
    this.listeners[s] || (this.listeners[s] = []), this.listeners[s].push(h);
  }
  off(s, h) {
    const c = this.listeners[s];
    if (c) {
      const d = c.indexOf(h);
      d > -1 && c.splice(d, 1);
    }
  }
  emit(s, h) {
    const c = this.listeners[s];
    c && c.forEach((d) => d(h));
  }
}
const JSON_PARSING_ERROR = "JSON_PARSING_ERROR";
class MomentoError {
  constructor(s, h) {
    Pe(this, "code");
    Pe(this, "message");
    this.code = s, this.message = h;
  }
}
class EventFormatter {
  constructor(s) {
    this.namespace = s;
  }
  format(s) {
    return s.charAt(0) === "." || s.charAt(0) === "\\" ? s.slice(1) : (this.namespace && (s = this.namespace + "." + s), s.replace(/\./g, "\\"));
  }
  setNamespace(s) {
    this.namespace = s;
  }
}
class MomentoChannel extends Channel {
  constructor(h, c) {
    super(h);
    Pe(this, "options");
    Pe(this, "subscription");
    Pe(this, "isSubscribed", !1);
    Pe(this, "subscribing", !1);
    Pe(this, "healthCheckTimeout");
    Pe(this, "eventEmitter");
    Pe(this, "eventFormatter");
    this.options = c, this.eventEmitter = new EventEmitter(), this.eventFormatter = new EventFormatter(this.options.namespace), this.options.healthCheckDelay || (this.options.healthCheckDelay = 2500);
  }
  async authorize() {
    var h, c, d;
    (h = this.options.logger) == null || h.log({
      method: "authorize",
      name: this.name
    });
    try {
      return (await this.options.authorizer(this.name)).token;
    } catch (l) {
      (c = this.options.logger) == null || c.log({
        method: "authorize.catch",
        error: l,
        name: this.name
      });
      const g = (d = l == null ? void 0 : l.response) == null ? void 0 : d.status;
      throw new MomentoError(
        g === 401 || g === 403 ? "AUTHORIZATION_ERROR" : "UNCAUGHT_ERROR",
        l instanceof Error ? l.message : "Unable to authorize channel using authorizer."
      );
    }
  }
  async resolveClient() {
    var h;
    try {
      return new srcExports.TopicClient({
        configuration: srcExports.Configurations.Browser.v1(),
        credentialProvider: srcExports.CredentialProvider.fromString({
          authToken: await this.authorize()
        })
      });
    } catch (c) {
      throw (h = this.options.logger) == null || h.log({
        method: "resolveClient.catch",
        error: c,
        name: this.name
      }), c instanceof MomentoError ? c : new MomentoError(
        "TOPIC_CLIENT_CREATION_ERROR",
        c instanceof Error ? c.message : "Unable to create TopicClient client."
      );
    }
  }
  async resolveSubscription() {
    var h, c, d;
    (h = this.options.logger) == null || h.log({
      method: "resolveSubscription",
      name: this.name
    });
    try {
      const l = await this.resolveClient(), g = await l.subscribe(this.options.cache, this.name, {
        onItem: (f) => {
          var _;
          this.handleTopicItem(f), (_ = this.options.logger) == null || _.log({
            method: "resolveSubscription.onItem",
            topicItem: f,
            name: this.name
          });
        },
        onError: (f) => {
          var _;
          this.isSubscribed = !1, this.eventEmitter.emit(
            "error",
            new MomentoError(f.errorCode(), f.message())
          ), (_ = this.options.logger) == null || _.log({
            method: "resolveSubscription.onError",
            error: f,
            name: this.name
          });
        }
      });
      if (g instanceof srcExports.TopicSubscribe.Subscription)
        this.eventEmitter.emit("subscribed");
      else if (g instanceof srcExports.TopicSubscribe.Error)
        throw new MomentoError(g.errorCode(), g.message());
      return (c = this.options.logger) == null || c.log({
        method: "resolveSubscription",
        client: l,
        subscription: g,
        name: this.name
      }), g;
    } catch (l) {
      if ((d = this.options.logger) == null || d.log({
        method: "resolveSubscription.catch",
        error: l,
        name: this.name
      }), l instanceof MomentoError)
        throw l;
      {
        const g = l instanceof Error ? l.message : "Unable to subscribe due to unknown error during subscribe.";
        throw new MomentoError("SUBSCRIBE_ERROR", g);
      }
    }
  }
  registerHealthCheck() {
    this.healthCheckTimeout = setTimeout(() => {
      var h, c;
      if (this.isSubscribed || this.subscribing) {
        (h = this.options.logger) == null || h.log({
          method: "registerHealthCheck, already subscribed or subscribing",
          isSubscribed: this.isSubscribed,
          subscribing: this.subscribing,
          name: this.name
        }), this.registerHealthCheck();
        return;
      }
      (c = this.options.logger) == null || c.log({
        method: "registerHealthCheck, unsubscribe to subscribe again",
        isSubscribed: this.isSubscribed,
        subscribing: this.subscribing,
        name: this.name
      }), this.unsubscribe().finally(() => this.subscribe());
    }, this.options.healthCheckDelay);
  }
  subscribe() {
    var h, c;
    if (!this.options.cache) {
      (h = this.options.logger) == null || h.log({
        method: "subscribe() no cache provided.",
        name: this.name
      });
      return;
    }
    if (this.subscribing || this.isSubscribed) {
      (c = this.options.logger) == null || c.log({
        method: "subscribe() already subscribed",
        name: this.name
      });
      return;
    }
    this.registerHealthCheck(), this.subscribing = !0, this.subscription = this.resolveSubscription(), this.subscription.then((d) => {
      var l;
      (l = this.options.logger) == null || l.log({
        method: "subscribe.then",
        subscription: d,
        name: this.name
      }), d instanceof srcExports.TopicSubscribe.Subscription && (this.isSubscribed = !0);
    }).catch((d) => {
      var l;
      (l = this.options.logger) == null || l.log({
        method: "subscribe.catch",
        error: d,
        name: this.name
      }), this.isSubscribed = !1, this.eventEmitter.emit("error", d), d.code === "AUTHORIZATION_ERROR" && clearTimeout(this.healthCheckTimeout);
    }).finally(() => {
      var d;
      (d = this.options.logger) == null || d.log({
        method: "subscribe.finally",
        name: this.name
      }), this.subscribing = !1;
    });
  }
  subscribed(h) {
    return this.eventEmitter.on("subscribed", h), this;
  }
  async unsubscribe() {
    var h, c;
    clearTimeout(this.healthCheckTimeout), (h = this.options.logger) == null || h.log({
      method: "unsubscribe",
      name: this.name
    }), this.isSubscribed = !1, await ((c = this.subscription) == null ? void 0 : c.then((d) => {
      var l;
      (l = this.options.logger) == null || l.log({
        method: "unsubscribe.then",
        subscription: d,
        name: this.name
      }), d instanceof srcExports.TopicSubscribe.Subscription && d.unsubscribe();
    }).catch((d) => {
      var l;
      (l = this.options.logger) == null || l.log({
        method: "unsubscribe.catch",
        error: d,
        name: this.name
      }), this.eventEmitter.emit("error", d);
    })), this.subscription = void 0;
  }
  listen(h, c) {
    return this.eventEmitter.on(this.eventFormatter.format(h), c), this;
  }
  stopListening(h, c) {
    return this.eventEmitter.off(this.eventFormatter.format(h), c), this;
  }
  error(h) {
    return this.eventEmitter.on("error", h), this;
  }
  handleTopicItem(h) {
    var d, l;
    let c = h.value();
    c instanceof Uint8Array && (c = new TextDecoder().decode(c));
    try {
      const g = JSON.parse(c);
      (d = this.options.logger) == null || d.log({
        method: "handleTopicItem.try",
        event: g,
        name: this.name
      }), this.eventEmitter.emit(g.name, g.data);
    } catch (g) {
      (l = this.options.logger) == null || l.log({
        method: "handleTopicItem.catch",
        error: g,
        name: this.name
      }), this.eventEmitter.emit(
        "error",
        new MomentoError(
          JSON_PARSING_ERROR,
          g instanceof Error ? g.message : "Unable to parse a topic item value."
        )
      );
    }
  }
}
class MomentoConnector extends Connector {
  constructor(h) {
    super();
    Pe(this, "options");
    Pe(this, "channels", []);
    this.options = h;
  }
  connect() {
  }
  disconnect() {
    this.channels.forEach((h) => {
      h.unsubscribe();
    });
  }
  channel(h) {
    let c = this.channels.find((d) => d.name === h);
    return c || (c = new MomentoChannel(h, this.options), c.subscribe(), this.channels.push(c)), c;
  }
  leave(h) {
    this.channels.filter((c) => [`private-${h}`, h].includes(c.name)).forEach((c) => c.unsubscribe()), this.channels = this.channels.filter(
      (c) => ![`private-${h}`, h].includes(c.name)
    );
  }
  privateChannel(h) {
    return this.channel(`private-${h}`);
  }
}
export {
  Channel,
  Connector,
  Echo,
  MomentoChannel,
  MomentoConnector,
  NullConnector
};
